import * as React from 'react';
import React__default, { useState, useEffect, Component as Component$1, useRef, useMemo, forwardRef, Children, cloneElement, useCallback, Fragment } from 'react';
import styled, { ThemeProvider, css } from 'styled-components';
import { tint, shade, rgba, readableColor, darken, lighten, mix, transparentize, setLightness } from 'polished';
import PropTypes from 'prop-types';
import breakpoint from 'styled-components-breakpoint';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation, faCircleCheck, faCircleInfo, faChevronDown as faChevronDown$2, faCirclePlay, faCirclePause, faLock, faCircleXmark, faBadgeCheck, faPaperPlaneTop, faList, faSort, faSortDown, faSortUp, faHotel } from '@fortawesome/pro-solid-svg-icons';
import ReactMarkdown from 'react-markdown';
import { Link as Link$2 } from 'react-router-dom';
import gfm from 'remark-gfm';
import { faChevronDown as faChevronDown$1, faCheck, faLock as faLock$1, faCopy, faEnvelope as faEnvelope$1, faPhone, faCheckCircle, faDotCircle, faFilePdf, faLink, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { unstable_batchedUpdates, createPortal } from 'react-dom';
import { faEye, faPlus, faCircle, faCircleEllipsis, faCircleThreeQuartersStroke, faChevronRight, faBars, faStar, faEllipsis, faTrash, faCalendar, faUserGroup, faHouse, faUser, faPassport, faPlane, faFolderOpen, faShieldHalved, faMoneyBills, faBell as faBell$1, faMessage as faMessage$1, faCircleInfo as faCircleInfo$1, faGear, faRepeat, faArrowRightFromBracket, faCakeCandles, faCoins, faUserHelmetSafety, faUserGraduate, faStopwatch, faBriefcase, faCampground, faLink as faLink$1, faSearch, faNote, faClipboardUser, faCabin, faPlaneArrival, faPaperPlaneTop as faPaperPlaneTop$1, faMemoCircleInfo, faClipboardQuestion, faFileMagnifyingGlass, faFileInvoiceDollar, faGlobe, faComments, faExclamationCircle, faCheck as faCheck$1 } from '@fortawesome/pro-regular-svg-icons';
import { MultiSelect } from 'react-multi-select-component';
import { PlayerSdk } from '@api.video/player-sdk';
import ReactSelect from 'react-select';
import moment$1 from 'moment-timezone';
import { CSVLink } from 'react-csv';
import SignaturePad from 'react-signature-pad-wrapper';
import { useTable, useSortBy } from 'react-table';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';

var black = "#000000";
var grey = "#333333";
var white$7 = "#FFFFFF";
var yellow$5 = "#FFEB57";
var green$6 = "#87F9B5";
var blue$1 = "#7AECFC";
var red$2 = "red";
var lightGrey$7 = "#F8F8F8";
var midLightGrey$7 = "rgb(158, 158, 158)";
var midGrey$7 = "rgb(102, 102, 102)";
var darkGrey$6 = "#1F2B30";
var bookedGreen$6 = "#98cc00";
var inputFieldGrey$7 = "#F6F6F6";
var inputFieldBlack$7 = "#515151";
var inputFieldBorder$7 = "#CCCCCC";
var inputFieldHint$7 = "#999999";
var smallerearth = {
  name: "Smaller Earth",
  colors: {
    brand: black,
    brand2: white$7,
    body: white$7,
    background: white$7,
    primary: black,
    secondary: grey,
    success: yellow$5,
    warning: blue$1,
    danger: red$2,
    lightGrey: lightGrey$7,
    midLightGrey: midLightGrey$7,
    midGrey: midGrey$7,
    darkGrey: darkGrey$6,
    primaryContrasted: tint(0.3, black),
    primaryContrastedDarker: tint(0.4, black),
    notifications: {
      meta: white$7,
      badge: {
        background: yellow$5,
        text: black
      }
    },
    profile: {
      headerBg: black,
      avatarBackground: grey,
      buttons: {
        primary: {
          background: yellow$5,
          text: darkGrey$6
        },
        secondary: {
          background: white$7,
          text: white$7
        }
      },
      badge: {
        background: "#f2c400",
        text: "#004252"
      }
    },
    statuses: {
      locked: red$2,
      incomplete: white$7,
      complete: green$6,
      started: yellow$5,
      rejected: red$2
    },
    home: {
      headings: black
    },
    feature: {
      background: "#fab70040",
      text: "#004152"
    },
    banner: {
      background: "#02ADE51A",
      text: "#004152"
    },
    content: {
      background: lightGrey$7,
      text: darkGrey$6,
      url: darkGrey$6
    },
    contactInfo: {
      background: lightGrey$7,
      title: black,
      text: black
    },
    applicationProgress: {
      bar: "#DDD",
      value: black
    },
    tables: {
      headings: yellow$5
    },
    buttons: {
      lightColor: white$7,
      darkColor: black,
      special: {
        main: yellow$5,
        text: black
      },
      search: {
        textColor: white$7
      }
    },
    incompletion: {
      lightenAmount: 0.1,
      background: blue$1
    },
    availability: {
      booked: bookedGreen$6
    },
    fields: {
      text: inputFieldBlack$7,
      contentText: inputFieldBlack$7,
      contentHeading: "#666666",
      label: "#333333",
      border: inputFieldBorder$7,
      backgroundColor: inputFieldGrey$7,
      hint: inputFieldHint$7,
      fieldsetText: "#717171",
      backButton: "#CCCCCC",
      backButtonText: "#666666",
      invalid: {
        darkenAmount: 0
      },
      spacer: "#F2F2F2"
    },
    conversations: {
      activeChat: "rgba(128, 128, 128, 0.1)"
    },
    alerts: {
      info: "#004152",
      danger: "#FF2230",
      success: "#8FCB24"
    },
    headerGradient: {
      start: grey,
      end: lightGrey$7
    }
  },
  fonts: {
    body: {
      family: "Helvetica Neue",
      weight: "400"
    },
    headings: {
      family: "Helvetica Neue",
      weight: "700"
    }
  },
  breakpoints: {
    mobile: 0,
    tablet: 769,
    desktop: 1025,
    widescreen: 1216,
    fullhd: 1408,
    mahoosive: 1600
  }
};

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _assertThisInitialized$1(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf$1(o), _possibleConstructorReturn$1(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf$1(t).constructor) : o.apply(t, e));
}
function _classCallCheck$1(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass$1(e, r, t) {
  return r && _defineProperties$1(e.prototype, r), t && _defineProperties$1(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty$1(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _getPrototypeOf$1(t) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf$1(t);
}
function _inherits$1(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf$1(t, e);
}
function _isNativeReflectConstruct$1() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$1 = function () {
    return !!t;
  })();
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty$1(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties$1(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _possibleConstructorReturn$1(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(t);
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return r;
  };
  var t,
    r = {},
    e = Object.prototype,
    n = e.hasOwnProperty,
    o = "function" == typeof Symbol ? Symbol : {},
    i = o.iterator || "@@iterator",
    a = o.asyncIterator || "@@asyncIterator",
    u = o.toStringTag || "@@toStringTag";
  function c(t, r, e, n) {
    return Object.defineProperty(t, r, {
      value: e,
      enumerable: !n,
      configurable: !n,
      writable: !n
    });
  }
  try {
    c({}, "");
  } catch (t) {
    c = function (t, r, e) {
      return t[r] = e;
    };
  }
  function h(r, e, n, o) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype);
    return c(a, "_invoke", function (r, e, n) {
      var o = 1;
      return function (i, a) {
        if (3 === o) throw Error("Generator is already running");
        if (4 === o) {
          if ("throw" === i) throw a;
          return {
            value: t,
            done: !0
          };
        }
        for (n.method = i, n.arg = a;;) {
          var u = n.delegate;
          if (u) {
            var c = d(u, n);
            if (c) {
              if (c === f) continue;
              return c;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if (1 === o) throw o = 4, n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          o = 3;
          var h = s(r, e, n);
          if ("normal" === h.type) {
            if (o = n.done ? 4 : 2, h.arg === f) continue;
            return {
              value: h.arg,
              done: n.done
            };
          }
          "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg);
        }
      };
    }(r, n, new Context(o || [])), !0), a;
  }
  function s(t, r, e) {
    try {
      return {
        type: "normal",
        arg: t.call(r, e)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  r.wrap = h;
  var f = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var l = {};
  c(l, i, function () {
    return this;
  });
  var p = Object.getPrototypeOf,
    y = p && p(p(x([])));
  y && y !== e && n.call(y, i) && (l = y);
  var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l);
  function g(t) {
    ["next", "throw", "return"].forEach(function (r) {
      c(t, r, function (t) {
        return this._invoke(r, t);
      });
    });
  }
  function AsyncIterator(t, r) {
    function e(o, i, a, u) {
      var c = s(t[o], t, i);
      if ("throw" !== c.type) {
        var h = c.arg,
          f = h.value;
        return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) {
          e("next", t, a, u);
        }, function (t) {
          e("throw", t, a, u);
        }) : r.resolve(f).then(function (t) {
          h.value = t, a(h);
        }, function (t) {
          return e("throw", t, a, u);
        });
      }
      u(c.arg);
    }
    var o;
    c(this, "_invoke", function (t, n) {
      function i() {
        return new r(function (r, o) {
          e(t, n, r, o);
        });
      }
      return o = o ? o.then(i, i) : i();
    }, !0);
  }
  function d(r, e) {
    var n = e.method,
      o = r.i[n];
    if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f;
    var i = s(o, r.i, e.arg);
    if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f;
    var a = i.arg;
    return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
  }
  function w(t) {
    this.tryEntries.push(t);
  }
  function m(r) {
    var e = r[4] || {};
    e.type = "normal", e.arg = t, r[4] = e;
  }
  function Context(t) {
    this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0);
  }
  function x(r) {
    if (null != r) {
      var e = r[i];
      if (e) return e.call(r);
      if ("function" == typeof r.next) return r;
      if (!isNaN(r.length)) {
        var o = -1,
          a = function e() {
            for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e;
            return e.value = t, e.done = !0, e;
          };
        return a.next = a;
      }
    }
    throw new TypeError(typeof r + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) {
    var r = "function" == typeof t && t.constructor;
    return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name));
  }, r.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t;
  }, r.awrap = function (t) {
    return {
      __await: t
    };
  }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () {
    return this;
  }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(h(t, e, n, o), i);
    return r.isGeneratorFunction(e) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, g(v), c(v, u, "Generator"), c(v, i, function () {
    return this;
  }), c(v, "toString", function () {
    return "[object Generator]";
  }), r.keys = function (t) {
    var r = Object(t),
      e = [];
    for (var n in r) e.unshift(n);
    return function t() {
      for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t;
      return t.done = !0, t;
    };
  }, r.values = x, Context.prototype = {
    constructor: Context,
    reset: function (r) {
      if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0][4];
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (r) {
      if (this.done) throw r;
      var e = this;
      function n(t) {
        a.type = "throw", a.arg = r, e.next = t;
      }
      for (var o = e.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i[4],
          u = this.prev,
          c = i[1],
          h = i[2];
        if (-1 === i[0]) return n("end"), !1;
        if (!c && !h) throw Error("try statement without catch or finally");
        if (null != i[0] && i[0] <= u) {
          if (u < c) return this.method = "next", this.arg = t, n(c), !0;
          if (u < h) return n(h), !1;
        }
      }
    },
    abrupt: function (t, r) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var n = this.tryEntries[e];
        if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) {
          var o = n;
          break;
        }
      }
      o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null);
      var i = o ? o[4] : {};
      return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i);
    },
    complete: function (t, r) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f;
    },
    finish: function (t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var e = this.tryEntries[r];
        if (e[2] === t) return this.complete(e[4], e[3]), m(e), f;
      }
    },
    catch: function (t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var e = this.tryEntries[r];
        if (e[0] === t) {
          var n = e[4];
          if ("throw" === n.type) {
            var o = n.arg;
            m(e);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (r, e, n) {
      return this.delegate = {
        i: x(r),
        r: e,
        n: n
      }, "next" === this.method && (this.arg = t), f;
    }
  }, r;
}
function _setPrototypeOf$1(t, e) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf$1(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var _colors;
var campLeadersBlue = "#00ADE5";
var navy$2 = "#004152";
var yellow$4 = "#FAB700";
var green$5 = "#8FCB24";
var pink = "#ED2A53";
var lightGrey$6 = "#F8F8F8";
var midLightGrey$6 = "rgb(158, 158, 158)";
var midGrey$6 = "rgb(102, 102, 102)";
var darkGrey$5 = "#1F2B30";
var white$6 = "#FFFFFF";
var bookedGreen$5 = "#98cc00";
var inputFieldGrey$6 = "#F6F6F6";
var inputFieldBlack$6 = "#515151";
var inputFieldBorder$6 = "#CCCCCC";
var inputFieldHint$6 = "#999999";
var campleaders = {
  name: "Camp Leaders",
  colors: (_colors = {
    brand: campLeadersBlue,
    brand2: navy$2,
    body: white$6,
    background: white$6,
    primary: campLeadersBlue,
    primaryContrasted: shade(0.2, campLeadersBlue),
    primaryContrastedDarker: shade(0.3, campLeadersBlue),
    secondary: navy$2,
    success: green$5,
    warning: yellow$4,
    danger: pink,
    lightGrey: lightGrey$6,
    midLightGrey: midLightGrey$6,
    midGrey: midGrey$6,
    darkGrey: darkGrey$5
  }, _defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_colors, "primaryContrasted", rgba(readableColor(campLeadersBlue, darken(0.13, campLeadersBlue), lighten(0.13, campLeadersBlue), false), 0.8)), "notifications", {
    meta: campLeadersBlue,
    badge: {
      background: pink,
      text: white$6
    }
  }), "profile", {
    headerBg: campLeadersBlue,
    avatarBackground: navy$2,
    buttons: {
      primary: {
        background: green$5,
        text: white$6
      },
      secondary: {
        background: white$6,
        text: white$6
      }
    },
    badge: {
      background: "#f2c400",
      text: "#004252"
    }
  }), "statuses", {
    locked: darkGrey$5,
    incomplete: darkGrey$5,
    complete: green$5,
    started: yellow$4,
    rejected: pink
  }), "home", {
    headings: navy$2
  }), "feature", {
    background: "#fab70040",
    text: "#004152"
  }), "banner", {
    background: "#02ADE51A",
    text: "#004152"
  }), "content", {
    background: lightGrey$6,
    text: navy$2,
    url: campLeadersBlue
  }), "contactInfo", {
    background: lightGrey$6,
    title: navy$2,
    text: campLeadersBlue
  }), "applicationProgress", {
    value: campLeadersBlue,
    bar: "rgba(0, 65, 82, 0.5)"
  }), _defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_colors, "headerGradient", {
    start: campLeadersBlue,
    end: "#80D6F2"
  }), "tables", {
    headings: campLeadersBlue
  }), "buttons", {
    lightColor: white$6,
    darkColor: darkGrey$5,
    success: {
      text: white$6
    },
    special: {
      main: navy$2,
      text: white$6
    },
    search: {
      textColor: white$6
    }
  }), "incompletion", {
    lightenAmount: 0.3,
    background: yellow$4
  }), "availability", {
    booked: bookedGreen$5
  }), "fields", {
    text: inputFieldBlack$6,
    contentText: inputFieldBlack$6,
    contentHeading: "#666666",
    label: "#333333",
    border: inputFieldBorder$6,
    backgroundColor: inputFieldGrey$6,
    hint: inputFieldHint$6,
    fieldsetText: "#717171",
    backButton: "#CCCCCC",
    backButtonText: "#666666",
    invalid: {
      darkenAmount: 0.1
    },
    spacer: "#F2F2F2"
  }), "conversations", {
    activeChat: "rgba(2, 173, 229, 0.1)"
  }), "alerts", {
    info: "#004152",
    danger: "#FF2230",
    success: "#8FCB24"
  })),
  fonts: {
    body: {
      family: "Helvetica Neue",
      weight: "400"
    },
    headings: {
      family: "Helvetica Neue",
      weight: "700"
    }
  },
  breakpoints: {
    mobile: 0,
    tablet: 769,
    desktop: 1025,
    widescreen: 1216,
    fullhd: 1408,
    mahoosive: 1600
  }
};

var resortLeadersGreen = "#004737";
var kokomo = "#F4DF60";
var keyLimePie = "#8DD5AA";
var snowfall = "#E9ECDE";
var surfin = "#0085F0";
var heatwave = "#F96B23";
var lightGrey$5 = "#F8F8F8";
var midLightGrey$5 = "rgb(158, 158, 158)";
var midGrey$5 = "rgb(102, 102, 102)";
var nightsky = "#001E17";
var white$5 = "#FFFFFF";
var alert$3 = "#FF2230";
var inputFieldGrey$5 = "#F6F6F6";
var inputFieldBlack$5 = "#515151";
var inputFieldBorder$5 = "#CCCCCC";
var inputFieldHint$5 = "#999999";
var resortleaders = {
  name: "Resort Leaders",
  colors: {
    brand: resortLeadersGreen,
    brand2: snowfall,
    body: white$5,
    bodyAlternative: resortLeadersGreen,
    background: white$5,
    primary: resortLeadersGreen,
    secondary: snowfall,
    secondaryAlternative: nightsky,
    whiteAlternative: nightsky,
    success: keyLimePie,
    warning: kokomo,
    danger: heatwave,
    lightGrey: lightGrey$5,
    midLightGrey: midLightGrey$5,
    midGrey: midGrey$5,
    darkGrey: nightsky,
    primaryContrasted: tint(0.2, resortLeadersGreen),
    primaryContrastedDarker: tint(0.3, resortLeadersGreen),
    notifications: {
      meta: resortLeadersGreen,
      badge: {
        background: alert$3,
        text: white$5
      }
    },
    profile: {
      headerBg: resortLeadersGreen,
      avatarBackground: nightsky,
      buttons: {
        primary: {
          background: kokomo,
          text: nightsky
        },
        secondary: {
          background: white$5,
          text: white$5
        }
      },
      badge: {
        background: "#f2c400",
        text: "#004252"
      }
    },
    statuses: {
      locked: heatwave,
      incomplete: nightsky,
      complete: keyLimePie,
      started: kokomo,
      rejected: heatwave
    },
    home: {
      headings: resortLeadersGreen
    },
    feature: {
      background: "#fab70040",
      text: "#004152"
    },
    banner: {
      background: "#02ADE51A",
      text: "#004152"
    },
    content: {
      background: lightGrey$5,
      text: nightsky,
      url: surfin
    },
    contactInfo: {
      background: lightGrey$5,
      title: resortLeadersGreen,
      text: heatwave
    },
    applicationProgress: {
      bar: "#DDD",
      value: heatwave
    },
    headerGradient: {
      start: resortLeadersGreen,
      end: "#009271"
    },
    tables: {
      headings: resortLeadersGreen
    },
    buttons: {
      lightColor: white$5,
      darkColor: nightsky,
      special: {
        main: kokomo,
        text: resortLeadersGreen
      },
      search: {
        textColor: white$5
      }
    },
    incompletion: {
      lightenAmount: 0.3,
      background: heatwave
    },
    menu: {
      hover: keyLimePie
    },
    availability: {
      booked: keyLimePie
    },
    fields: {
      text: inputFieldBlack$5,
      contentText: inputFieldBlack$5,
      contentHeading: "#666666",
      label: "#333333",
      border: inputFieldBorder$5,
      backgroundColor: inputFieldGrey$5,
      hint: inputFieldHint$5,
      fieldsetText: "#717171",
      backButton: "#CCCCCC",
      backButtonText: "#666666",
      invalid: {
        darkenAmount: 0.2
      },
      spacer: "#F2F2F2"
    },
    conversations: {
      activeChat: "rgba(8, 41, 61, 0.1)"
    },
    alerts: {
      info: "#004152",
      danger: "#FF2230",
      success: "#8FCB24"
    },
    nav: {
      name: nightsky
    }
  },
  fonts: {
    body: {
      family: "Helvetica Neue",
      weight: "400"
    },
    headings: {
      family: "Helvetica Neue",
      weight: "700"
    }
  },
  breakpoints: {
    mobile: 0,
    tablet: 769,
    desktop: 1025,
    widescreen: 1216,
    fullhd: 1408,
    mahoosive: 1600
  }
};

var primary$1 = "#D73D3D";
var secondary$1 = "#221F20";
var yellow$3 = "#E89D3A";
var green$4 = "#285B55";
var primaryLight$1 = lighten(0.1, primary$1);
darken(0.2, primary$1);
var lightGrey$4 = "#F8F8F8";
var midLightGrey$4 = "rgb(158, 158, 158)";
var midGrey$4 = "rgb(102, 102, 102)";
var darkGrey$4 = "#221F20";
var white$4 = "#FFFFFF";
var alert$2 = primary$1;
var bookedGreen$4 = "#98cc00";
var inputFieldGrey$4 = "#F6F6F6";
var inputFieldBlack$4 = "#515151";
var inputFieldBorder$4 = "#CCCCCC";
var inputFieldHint$4 = "#999999";
var adventureasia = {
  colors: _defineProperty$1({
    brand: primary$1,
    brand2: secondary$1,
    body: white$4,
    background: white$4,
    primary: primary$1,
    primaryContrasted: shade(0.2, primary$1),
    primaryContrastedDarker: shade(0.3, primary$1),
    secondary: secondary$1,
    success: green$4,
    warning: yellow$3,
    danger: primaryLight$1,
    lightGrey: lightGrey$4,
    midLightGrey: midLightGrey$4,
    midGrey: midGrey$4,
    darkGrey: darkGrey$4,
    notifications: {
      meta: primary$1,
      badge: {
        background: alert$2,
        text: white$4
      }
    },
    profile: {
      headerBg: primary$1,
      avatarBackground: secondary$1,
      buttons: {
        primary: {
          background: green$4,
          text: white$4
        },
        secondary: {
          background: white$4,
          text: white$4
        }
      },
      badge: {
        background: "#f2c400",
        text: "#004252"
      }
    },
    logoutButton: {
      main: secondary$1,
      text: white$4
    },
    statuses: {
      locked: darkGrey$4,
      incomplete: darkGrey$4,
      complete: green$4,
      started: yellow$3,
      rejected: primaryLight$1
    },
    home: {
      headings: secondary$1
    },
    feature: {
      background: "#fab70040",
      text: "#004152"
    },
    banner: {
      background: "#02ADE51A",
      text: "#004152"
    },
    content: {
      background: lightGrey$4,
      text: secondary$1,
      url: primary$1
    },
    contactInfo: {
      background: lightGrey$4,
      title: secondary$1,
      text: primary$1
    },
    applicationProgress: {
      value: primary$1,
      bar: "#eeeeee"
    },
    headerGradient: {
      start: primary$1,
      end: "#e02229"
    },
    tables: {
      headings: primary$1
    },
    buttons: {
      lightColor: white$4,
      darkColor: darkGrey$4,
      special: {
        main: secondary$1,
        text: white$4
      },
      search: {
        textColor: white$4
      }
    },
    incompletion: {
      lightenAmount: 0.3,
      background: yellow$3
    },
    availability: {
      booked: bookedGreen$4
    },
    fields: {
      text: inputFieldBlack$4,
      contentText: inputFieldBlack$4,
      contentHeading: "#666666",
      label: "#333333",
      border: inputFieldBorder$4,
      backgroundColor: inputFieldGrey$4,
      hint: inputFieldHint$4,
      fieldsetText: "#717171",
      backButton: "#CCCCCC",
      backButtonText: "#666666",
      invalid: {
        darkenAmount: 0.125
      },
      spacer: "#F2F2F2"
    },
    conversations: {
      activeChat: "rgba(2, 173, 229, 0.1)"
    },
    alerts: {
      info: "#004152",
      danger: "#FF2230",
      success: "#8FCB24"
    }
  }, "headerGradient", {
    start: primary$1,
    end: "#eb3d44"
  }),
  fonts: {
    body: {
      family: "Helvetica Neue",
      weight: "400"
    },
    headings: {
      family: "Helvetica Neue",
      weight: "700"
    }
  },
  breakpoints: {
    mobile: 0,
    tablet: 769,
    desktop: 1025,
    widescreen: 1216,
    fullhd: 1408,
    mahoosive: 1600
  }
};

var adventureChinaRed = "#bd2126";
var deepRed = "#7D161A";
var brightGold = "#FBEDCA";
var gold = "#F7DA94";
var lightGrey$3 = "#F8F8F8";
var midLightGrey$3 = "rgb(158, 158, 158)";
var midGrey$3 = "rgb(102, 102, 102)";
var darkGrey$3 = "#221F20";
var white$3 = "#FFFFFF";
var green$3 = "#99CC00";
var bookedGreen$3 = "#98cc00";
var inputFieldGrey$3 = "#F6F6F6";
var inputFieldBlack$3 = "#515151";
var inputFieldBorder$3 = "#CCCCCC";
var inputFieldHint$3 = "#999999";
var adventurechina = {
  name: "Adventure China",
  colors: {
    brand: adventureChinaRed,
    brand2: deepRed,
    body: white$3,
    background: white$3,
    primary: adventureChinaRed,
    secondary: deepRed,
    success: gold,
    warning: gold,
    danger: adventureChinaRed,
    lightGrey: lightGrey$3,
    midLightGrey: midLightGrey$3,
    midGrey: midGrey$3,
    darkGrey: darkGrey$3,
    primaryContrasted: shade(0.2, adventureChinaRed),
    primaryContrastedDarker: shade(0.3, adventureChinaRed),
    notifications: {
      meta: gold,
      badge: {
        background: gold,
        text: white$3
      }
    },
    profile: {
      headerBg: adventureChinaRed,
      avatarBackground: deepRed,
      buttons: {
        primary: {
          background: gold,
          text: darkGrey$3
        },
        secondary: {
          background: white$3,
          text: white$3
        }
      },
      badge: {
        background: "#f2c400",
        text: "#004252"
      }
    },
    statuses: {
      locked: deepRed,
      incomplete: darkGrey$3,
      complete: green$3,
      started: brightGold,
      rejected: adventureChinaRed
    },
    home: {
      headings: deepRed
    },
    feature: {
      background: "#fab70040",
      text: "#004152"
    },
    banner: {
      background: "#02ADE51A",
      text: "#004152"
    },
    content: {
      background: lightGrey$3,
      text: darkGrey$3,
      url: adventureChinaRed
    },
    contactInfo: {
      background: lightGrey$3,
      title: deepRed,
      text: adventureChinaRed
    },
    applicationProgress: {
      bar: "#DDD",
      value: adventureChinaRed
    },
    tables: {
      headings: gold
    },
    buttons: {
      lightColor: white$3,
      darkColor: darkGrey$3,
      special: {
        main: brightGold,
        text: darkGrey$3
      },
      search: {
        textColor: darkGrey$3
      }
    },
    incompletion: {
      lightenAmount: 0.2,
      background: gold
    },
    availability: {
      booked: bookedGreen$3
    },
    fields: {
      text: inputFieldBlack$3,
      contentText: inputFieldBlack$3,
      contentHeading: "#666666",
      label: "#333333",
      border: inputFieldBorder$3,
      backgroundColor: inputFieldGrey$3,
      hint: inputFieldHint$3,
      fieldsetText: "#717171",
      backButton: "#CCCCCC",
      backButtonText: "#666666",
      invalid: {
        darkenAmount: 0.3
      },
      spacer: "#F2F2F2"
    },
    conversations: {
      activeChat: "rgba(2, 173, 229, 0.1)"
    },
    alerts: {
      info: "#004152",
      danger: "#FF2230",
      success: "#8FCB24"
    },
    headerGradient: {
      start: adventureChinaRed,
      end: "#eb3d44"
    }
  },
  fonts: {
    body: {
      family: "Helvetica Neue",
      weight: "400"
    },
    headings: {
      family: "Helvetica Neue",
      weight: "700"
    }
  },
  breakpoints: {
    mobile: 0,
    tablet: 769,
    desktop: 1025,
    widescreen: 1216,
    fullhd: 1408,
    mahoosive: 1600
  }
};

var campCanadaOrange = "#FF3D17";
var navy$1 = "#0B3854";
var blue = "#1D95E0";
var red$1 = "#BC1B13";
var yellow$2 = "#FAB700";
var lightGrey$2 = "#F8F8F8";
var midLightGrey$2 = "rgb(158, 158, 158)";
var midGrey$2 = "rgb(102, 102, 102)";
var darkGrey$2 = "#272E32";
var white$2 = "#FFFFFF";
var green$2 = "#99CC00";
var bookedGreen$2 = "#98cc00";
var inputFieldGrey$2 = "#F6F6F6";
var inputFieldBlack$2 = "#515151";
var inputFieldBorder$2 = "#CCCCCC";
var inputFieldHint$2 = "#999999";
var campcanada = {
  name: "Camp Canada",
  colors: {
    brand: campCanadaOrange,
    brand2: navy$1,
    body: white$2,
    background: white$2,
    primary: campCanadaOrange,
    secondary: navy$1,
    success: blue,
    warning: yellow$2,
    danger: red$1,
    lightGrey: lightGrey$2,
    midLightGrey: midLightGrey$2,
    midGrey: midGrey$2,
    darkGrey: darkGrey$2,
    primaryContrasted: shade(0.2, campCanadaOrange),
    primaryContrastedDarker: shade(0.3, campCanadaOrange),
    notifications: {
      meta: blue,
      badge: {
        background: blue,
        text: white$2
      }
    },
    profile: {
      headerBg: campCanadaOrange,
      avatarBackground: navy$1,
      buttons: {
        primary: {
          background: blue,
          text: white$2
        },
        secondary: {
          background: white$2,
          text: white$2
        }
      },
      badge: {
        background: "#f2c400",
        text: "#004252"
      }
    },
    statuses: {
      locked: red$1,
      incomplete: darkGrey$2,
      complete: green$2,
      started: yellow$2,
      rejected: red$1
    },
    home: {
      headings: navy$1
    },
    feature: {
      background: "#fab70040",
      text: "#004152"
    },
    banner: {
      background: "#02ADE51A",
      text: "#004152"
    },
    content: {
      background: lightGrey$2,
      text: darkGrey$2,
      url: campCanadaOrange
    },
    contactInfo: {
      background: lightGrey$2,
      title: navy$1,
      text: campCanadaOrange
    },
    applicationProgress: {
      bar: "#DDD",
      value: campCanadaOrange
    },
    tables: {
      headings: campCanadaOrange
    },
    buttons: {
      lightColor: white$2,
      darkColor: darkGrey$2,
      special: {
        main: white$2,
        text: darkGrey$2
      },
      search: {
        textColor: white$2
      }
    },
    incompletion: {
      lightenAmount: 0.3,
      background: yellow$2
    },
    availability: {
      booked: bookedGreen$2
    },
    fields: {
      text: inputFieldBlack$2,
      contentText: inputFieldBlack$2,
      contentHeading: "#666666",
      label: "#333333",
      border: inputFieldBorder$2,
      backgroundColor: inputFieldGrey$2,
      hint: inputFieldHint$2,
      fieldsetText: "#717171",
      backButton: "#CCCCCC",
      backButtonText: "#666666",
      invalid: {
        darkenAmount: 0.2
      },
      spacer: "#F2F2F2"
    },
    conversations: {
      activeChat: "rgba(255, 60, 23, 0.1)"
    },
    alerts: {
      info: "#004152",
      danger: "#FF2230",
      success: "#8FCB24"
    },
    headerGradient: {
      start: campCanadaOrange,
      end: "#ff8168"
    }
  },
  fonts: {
    body: {
      family: "Helvetica Neue",
      weight: "400"
    },
    headings: {
      family: "Helvetica Neue",
      weight: "700"
    }
  },
  breakpoints: {
    mobile: 0,
    tablet: 769,
    desktop: 1025,
    widescreen: 1216,
    fullhd: 1408,
    mahoosive: 1600
  }
};

var navy = "#062031";
var offWhite = "#EDE8DF";
var red = "#F03D07";
var brightBlue = "#9AE7ED";
var yellow$1 = "#FAB700";
var green$1 = "#99CC00";
var lightGrey$1 = "#F8F8F8";
var midLightGrey$1 = "rgb(158, 158, 158)";
var midGrey$1 = "rgb(102, 102, 102)";
var darkGrey$1 = "#1F2B30";
var white$1 = "#FFFFFF";
var lightNavy = "#034253";
var bookedGreen$1 = "#98cc00";
var inputFieldGrey$1 = "#F6F6F6";
var inputFieldBlack$1 = "#515151";
var inputFieldBorder$1 = "#CCCCCC";
var inputFieldHint$1 = "#999999";
var americancampco = {
  name: "American Camp Co",
  colors: {
    brand: navy,
    brand2: lightNavy,
    body: white$1,
    background: white$1,
    primary: navy,
    secondary: lightNavy,
    success: brightBlue,
    warning: yellow$1,
    danger: red,
    lightGrey: lightGrey$1,
    midLightGrey: midLightGrey$1,
    midGrey: midGrey$1,
    darkGrey: darkGrey$1,
    primaryContrasted: tint(0.2, navy),
    primaryContrastedDarker: tint(0.3, navy),
    notifications: {
      meta: brightBlue,
      badge: {
        background: brightBlue,
        text: darkGrey$1
      }
    },
    profile: {
      headerBg: navy,
      avatarBackground: lightNavy,
      buttons: {
        primary: {
          background: brightBlue,
          text: darkGrey$1
        },
        secondary: {
          background: white$1,
          text: white$1
        }
      },
      badge: {
        background: "#f2c400",
        text: "#004252"
      }
    },
    statuses: {
      locked: red,
      incomplete: darkGrey$1,
      complete: green$1,
      started: yellow$1,
      rejected: red
    },
    home: {
      headings: navy
    },
    feature: {
      background: "#fab70040",
      text: "#004152"
    },
    banner: {
      background: "#02ADE51A",
      text: "#004152"
    },
    content: {
      background: lightGrey$1,
      text: lightNavy,
      url: brightBlue
    },
    contactInfo: {
      background: lightGrey$1,
      title: navy,
      text: red
    },
    applicationProgress: {
      bar: "#DDD",
      value: red
    },
    tables: {
      headings: offWhite
    },
    buttons: {
      lightColor: white$1,
      darkColor: darkGrey$1,
      special: {
        main: brightBlue,
        text: darkGrey$1
      },
      search: {
        textColor: darkGrey$1
      }
    },
    incompletion: {
      lightenAmount: 0.3,
      background: yellow$1
    },
    menu: {
      hover: brightBlue
    },
    availability: {
      booked: bookedGreen$1
    },
    fields: {
      text: inputFieldBlack$1,
      contentText: inputFieldBlack$1,
      contentHeading: "#666666",
      label: "#333333",
      border: inputFieldBorder$1,
      backgroundColor: inputFieldGrey$1,
      hint: inputFieldHint$1,
      fieldsetText: "#717171",
      backButton: "#CCCCCC",
      backButtonText: "#666666",
      invalid: {
        darkenAmount: 0
      },
      spacer: "#F2F2F2"
    },
    conversations: {
      activeChat: "rgba(6, 31, 50, 0.1)"
    },
    alerts: {
      info: "#004152",
      danger: "#FF2230",
      success: "#8FCB24"
    },
    headerGradient: {
      start: navy,
      end: lightNavy
    }
  },
  fonts: {
    body: {
      family: "Helvetica Neue",
      weight: "400"
    },
    headings: {
      family: "Helvetica Neue",
      weight: "700"
    }
  },
  breakpoints: {
    mobile: 0,
    tablet: 769,
    desktop: 1025,
    widescreen: 1216,
    fullhd: 1408,
    mahoosive: 1600
  }
};

var primary = "#DA1F26";
var secondary = "#232323";
var yellow = "#FAB700";
var green = "#7DC95E";
var primaryLight = lighten(0.1, primary);
var lightGrey = "#F8F8F8";
var midLightGrey = "rgb(158, 158, 158)";
var midGrey = "rgb(102, 102, 102)";
var darkGrey = "#1F2B30";
var white = "#FFFFFF";
var alert$1 = primary;
var bookedGreen = "#98cc00";
var inputFieldGrey = "#F6F6F6";
var inputFieldBlack = "#515151";
var inputFieldBorder = "#CCCCCC";
var inputFieldHint = "#999999";
var canago = {
  colors: {
    brand: primary,
    brand2: secondary,
    body: white,
    background: white,
    primary: primary,
    primaryContrasted: shade(0.2, primary),
    primaryContrastedDarker: shade(0.3, primary),
    secondary: secondary,
    success: green,
    warning: yellow,
    danger: primaryLight,
    lightGrey: lightGrey,
    midLightGrey: midLightGrey,
    midGrey: midGrey,
    darkGrey: darkGrey,
    notifications: {
      meta: primary,
      badge: {
        background: alert$1,
        text: white
      }
    },
    profile: {
      headerBg: primary,
      avatarBackground: secondary,
      buttons: {
        primary: {
          background: green,
          text: darkGrey
        },
        secondary: {
          background: white,
          text: white
        }
      },
      badge: {
        background: "#f2c400",
        text: "#004252"
      }
    },
    logoutButton: {
      main: secondary,
      text: white
    },
    statuses: {
      locked: darkGrey,
      incomplete: darkGrey,
      complete: green,
      started: yellow,
      rejected: primaryLight
    },
    home: {
      headings: secondary
    },
    feature: {
      background: "#fab70040",
      text: "#004152"
    },
    banner: {
      background: "#02ADE51A",
      text: "#004152"
    },
    content: {
      background: lightGrey,
      text: secondary,
      url: primary
    },
    contactInfo: {
      background: lightGrey,
      title: secondary,
      text: primary
    },
    applicationProgress: {
      value: primary,
      bar: "#eeeeee"
    },
    headerGradient: {
      start: primary,
      end: "#e02229"
    },
    tables: {
      headings: primary
    },
    buttons: {
      lightColor: white,
      darkColor: darkGrey,
      special: {
        main: secondary,
        text: white
      },
      search: {
        textColor: white
      }
    },
    incompletion: {
      lightenAmount: 0.3,
      background: yellow
    },
    availability: {
      booked: bookedGreen
    },
    fields: {
      text: inputFieldBlack,
      contentText: inputFieldBlack,
      contentHeading: "#666666",
      label: "#333333",
      border: inputFieldBorder,
      backgroundColor: inputFieldGrey,
      hint: inputFieldHint,
      fieldsetText: "#717171",
      backButton: "#CCCCCC",
      backButtonText: "#666666",
      invalid: {
        darkenAmount: 0.125
      },
      spacer: "#F2F2F2"
    },
    conversations: {
      activeChat: "rgba(2, 173, 229, 0.1)"
    },
    alerts: {
      info: "#004152",
      danger: "#FF2230",
      success: "#8FCB24"
    }
  },
  fonts: {
    body: {
      family: "Helvetica Neue",
      weight: "400"
    },
    headings: {
      family: "Helvetica Neue",
      weight: "700"
    }
  },
  breakpoints: {
    mobile: 0,
    tablet: 769,
    desktop: 1025,
    widescreen: 1216,
    fullhd: 1408,
    mahoosive: 1600
  }
};

var themes = {
  campleaders: campleaders,
  campcanada: campcanada,
  resortleaders: resortleaders,
  adventureasia: adventureasia,
  adventurechina: adventurechina,
  smallerearth: smallerearth,
  americancampco: americancampco,
  canago: canago
};

var theme = {
  breakpoints: {
    mobile: 0,
    tablet: 769,
    desktop: 1025,
    widescreen: 1216,
    fullhd: 1408,
    mahoosive: 1600
  }
};
var PostcardThemeProvider = function PostcardThemeProvider(props) {
  var buildTheme = Object.assign(theme, themes["campleaders"], props.theme);
  return /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: buildTheme
  }, props.children);
};

var _templateObject$1O, _templateObject2$1y, _templateObject3$1h, _templateObject4$14, _templateObject5$O;
var getSize$2 = function getSize(size) {
  switch (size) {
    case "small":
      return "1rem";
    case "medium":
      return "2rem";
    case "large":
      return "2.5rem";
    case "extralarge":
      return "60px";
    default:
      return "1.5rem";
  }
};
var getColor$2 = function getColor(variant, theme, overrideWithBodyStyle) {
  switch (variant) {
    case "primary":
      return theme.colors.primary;
    case "secondary":
      return theme.colors.secondaryAlternative || theme.colors.secondary;
    case "content":
      return theme.colors.content.text;
    case "profile":
      return !!overrideWithBodyStyle ? theme.colors.body : theme.colors.content.text;
    case "secondaryReadable":
      return readableColor(theme.colors.secondary, theme.colors.buttons.darkColor, theme.colors.buttons.lightColor, false);
    default:
      return theme.colors.body;
  }
};
var Icon$5 = styled.svg(_templateObject$1O || (_templateObject$1O = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  fill: ", ";\n  cursor: pointer;\n\n  ", "\n"])), function (_ref) {
  var size = _ref.size;
  return getSize$2(size);
}, function (_ref2) {
  var size = _ref2.size;
  return getSize$2(size);
}, function (_ref3) {
  var variant = _ref3.variant,
    theme = _ref3.theme;
  return getColor$2(variant, theme, true);
}, breakpoint("tablet")(_templateObject2$1y || (_templateObject2$1y = _taggedTemplateLiteral(["\n    fill: ", ";\n  "])), function (_ref4) {
  var variant = _ref4.variant,
    theme = _ref4.theme,
    body = _ref4.body;
  return getColor$2(variant, theme, body);
}));
var Path = styled.path(_templateObject3$1h || (_templateObject3$1h = _taggedTemplateLiteral(["\n  fill: ", ";\n\n  ", "\n"])), function (_ref5) {
  var variant = _ref5.variant,
    theme = _ref5.theme;
  return getColor$2(variant, theme, true);
}, breakpoint("tablet")(_templateObject4$14 || (_templateObject4$14 = _taggedTemplateLiteral(["\n    fill: ", ";\n  "])), function (_ref6) {
  var variant = _ref6.variant,
    theme = _ref6.theme,
    body = _ref6.body;
  return getColor$2(variant, theme, body);
}));
styled.ellipse(_templateObject5$O || (_templateObject5$O = _taggedTemplateLiteral(["\n  stroke: ", ";\n"])), function (_ref7) {
  var variant = _ref7.variant,
    theme = _ref7.theme;
  return getColor$2(variant, theme, true);
});

var _excluded$B = ["onClick"];
var CloseIcon$1 = function CloseIcon(_ref) {
  var onClick = _ref.onClick,
    props = _objectWithoutProperties$1(_ref, _excluded$B);
  return /*#__PURE__*/React__default.createElement(Icon$5, _extends({
    viewBox: "0 0 35 36",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "close-icon",
    onClick: onClick
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "Postcard---Desktop",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Background---Dialog",
    transform: "translate(-1240.000000, -408.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Group-3",
    transform: "translate(398.000000, 384.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Close-Icon",
    transform: "translate(842.000000, 24.000000)"
  }, /*#__PURE__*/React__default.createElement(Path, _extends({
    d: "M10.5833333,16.9166667 L24.4028742,17.1113081 C24.9441371,17.1189315 25.3810685,17.5558629 25.3886919,18.0971258 L25.3888889,18.1111111 C25.3963464,18.6405971 24.9731588,19.0758758 24.4436728,19.0833333 C24.4346712,19.0834601 24.4256683,19.0834601 24.4166667,19.0833333 L10.5971258,18.8886919 C10.0558629,18.8810685 9.61893151,18.4441371 9.61130809,17.9028742 L9.61111111,17.8888889 C9.60365356,17.3594029 10.0268412,16.9241242 10.5563272,16.9166667 C10.5653288,16.9165399 10.5743317,16.9165399 10.5833333,16.9166667 Z",
    id: "Rectangle-Copy",
    transform: "translate(17.500000, 18.000000) rotate(-315.000000) translate(-17.500000, -18.000000) "
  }, props)), /*#__PURE__*/React__default.createElement(Path, _extends({
    d: "M10.5833333,16.9166667 L24.4028742,17.1113081 C24.9441371,17.1189315 25.3810685,17.5558629 25.3886919,18.0971258 L25.3888889,18.1111111 C25.3963464,18.6405971 24.9731588,19.0758758 24.4436728,19.0833333 C24.4346712,19.0834601 24.4256683,19.0834601 24.4166667,19.0833333 L10.5971258,18.8886919 C10.0558629,18.8810685 9.61893151,18.4441371 9.61130809,17.9028742 L9.61111111,17.8888889 C9.60365356,17.3594029 10.0268412,16.9241242 10.5563272,16.9166667 C10.5653288,16.9165399 10.5743317,16.9165399 10.5833333,16.9166667 Z",
    id: "Rectangle-Copy",
    transform: "translate(17.500000, 18.000000) scale(-1, 1) rotate(-315.000000) translate(-17.500000, -18.000000) "
  }, props)))))));
};
CloseIcon$1.propTypes = {
  variant: PropTypes.oneOf(["default", "primary", "secondary"]),
  size: PropTypes.oneOf(["small", "default", "medium", "large", "extralarge"]),
  body: PropTypes.bool
};
CloseIcon$1.defaultProps = {
  variant: "default",
  size: "default",
  body: false
};

function getColorFromVariant$1(variant) {
  switch (variant) {
    case "primary":
      return function (props) {
        return props.theme.colors.primary;
      };
    case "secondary":
      return function (props) {
        return props.theme.colors.secondaryAlternative || props.theme.colors.secondary;
      };
    case "home":
      return function (props) {
        return props.theme.colors.home.headings;
      };
    case "content":
      return function (props) {
        return props.theme.colors.content.text;
      };
    case "contentv2":
      return function (props) {
        return props.theme.colors.fields.contentText;
      };
    case "contentv2Heading":
      return function (props) {
        return props.theme.colors.primary;
      };
    case "contentv2PlainHeading":
      return function (props) {
        return props.theme.colors.fields.contentHeading;
      };
    case "simpleForm":
      return function (props) {
        return props.theme.colors.fields.fieldsetText;
      };
    case "body":
      return function (props) {
        return props.theme.colors.body;
      };
    case "neutral":
      return function (props) {
        return props.theme.colors.fields.label;
      };
    case "secondaryReadable":
      return function (props) {
        return readableColor(props.theme.colors.secondary, props.theme.colors.buttons.darkColor, props.theme.colors.buttons.lightColor, false);
      };
    default:
      return function (props) {
        return props.theme.colors.body;
      };
  }
}

var _templateObject$1N, _templateObject2$1x, _templateObject3$1g;
var fontSize$3 = function fontSize(size) {
  switch (size) {
    case "smallv2":
      return "2rem";
    case "small":
      return "1.5rem";
    case "medium":
      return "2.5rem";
    case "large":
      return "3rem";
    case "1xlarge":
      return "3.5rem";
    case "2xlarge":
      return "4rem";
    case "3xlarge":
      return "4.5rem";
    default:
      return "2rem";
  }
};
var styles$4 = css(_templateObject$1N || (_templateObject$1N = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n  letter-spacing: -1px;\n  line-height: 1.2;\n\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant;
  return getColorFromVariant$1(variant);
}, function (_ref2) {
  var size = _ref2.size;
  return fontSize$3(size);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.headings.family;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.headings.weight;
}, function (props) {
  return !!props.marginless && css(_templateObject2$1x || (_templateObject2$1x = _taggedTemplateLiteral(["\n      margin: 0;\n    "])));
});
var StyledH1 = styled.h1(_templateObject3$1g || (_templateObject3$1g = _taggedTemplateLiteral(["\n  ", "\n"])), styles$4);

var _excluded$A = ["children"];
var H1$1 = function H1(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$A);
  return /*#__PURE__*/React__default.createElement(StyledH1, rest, children);
};
H1$1.propTypes = {
  children: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["default", "small", "medium", "large", "1xlarge", "2xlarge", "3xlarge"]),
  variant: PropTypes.oneOf(["default", "primary", "secondary", "content", "contentv2"]),
  marginless: PropTypes.bool
};
H1$1.defaultProps = {
  size: "default",
  variant: "default",
  marginless: false
};

var _templateObject$1M, _templateObject2$1w, _templateObject3$1f, _templateObject4$13;
var fontSize$2 = function fontSize(size) {
  switch (size) {
    case "small":
      return "1.25rem";
    case "medium":
      return "1.75rem";
    case "large":
      return "2rem";
    case "profile":
      return "20px";
    default:
      return "1.5rem";
  }
};
var styles$3 = css(_templateObject$1M || (_templateObject$1M = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n  letter-spacing: -1px;\n  line-height: 1.2;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant;
  return getColorFromVariant$1(variant);
}, function (_ref2) {
  var size = _ref2.size;
  return fontSize$2(size);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.headings.family;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.headings.weight;
}, function (props) {
  return !!props.profile && css(_templateObject2$1w || (_templateObject2$1w = _taggedTemplateLiteral(["\n      margin: 0 0 24px;\n      font-size: 20px;\n    "])));
}, function (props) {
  return !!props.marginless && css(_templateObject3$1f || (_templateObject3$1f = _taggedTemplateLiteral(["\n      margin: 0;\n    "])));
});
var StyledH2 = styled.h2(_templateObject4$13 || (_templateObject4$13 = _taggedTemplateLiteral(["\n  ", "\n"])), styles$3);

var _excluded$z = ["children"];
var H2$1 = function H2(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$z);
  return /*#__PURE__*/React__default.createElement(StyledH2, rest, children);
};
H2$1.propTypes = {
  children: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["default", "small", "medium", "large"]),
  variant: PropTypes.oneOf(["default", "primary", "secondary", "content"]),
  marginless: PropTypes.bool
};
H2$1.defaultProps = {
  size: "default",
  variant: "default",
  marginless: false
};

var _templateObject$1L, _templateObject2$1v, _templateObject3$1e, _templateObject4$12;
var fontSize$1 = function fontSize(size) {
  switch (size) {
    case "small":
      return "1rem";
    case "medium":
      return "1.4rem";
    case "large":
      return "1.6rem";
    case "simpleForm":
      return "20px";
    default:
      return "1.2rem";
  }
};
var styles$2 = css(_templateObject$1L || (_templateObject$1L = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n  letter-spacing: -1px;\n  line-height: 1.2;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant;
  return getColorFromVariant$1(variant);
}, function (_ref2) {
  var size = _ref2.size;
  return fontSize$1(size);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.headings.family;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.headings.weight;
}, function (props) {
  return !!props.profile && css(_templateObject2$1v || (_templateObject2$1v = _taggedTemplateLiteral(["\n      margin: 0 0 24px;\n      font-size: 20px;\n    "])));
}, function (props) {
  return !!props.marginless && css(_templateObject3$1e || (_templateObject3$1e = _taggedTemplateLiteral(["\n      margin: 0;\n    "])));
});
var StyledH3$1 = styled.h3(_templateObject4$12 || (_templateObject4$12 = _taggedTemplateLiteral(["\n  ", "\n"])), styles$2);

var _excluded$y = ["children"];
var H3 = function H3(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$y);
  return /*#__PURE__*/React__default.createElement(StyledH3$1, rest, children);
};
H3.propTypes = {
  children: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["default", "small", "medium", "large"]),
  variant: PropTypes.oneOf(["default", "primary", "secondary", "content"]),
  marginless: PropTypes.bool
};
H3.defaultProps = {
  size: "default",
  variant: "default",
  marginless: false
};

var _templateObject$1K, _templateObject2$1u, _templateObject3$1d, _templateObject4$11, _templateObject5$N, _templateObject6$I, _templateObject7$E, _templateObject8$y, _templateObject9$w, _templateObject0$t;
var fontSize = function fontSize(size) {
  switch (size) {
    case "smallv2":
      return "16px";
    case "small":
      return "0.75rem";
    case "medium":
      return "1.25rem";
    case "large":
      return "1.5rem";
    case "extralarge":
      return "1.75rem";
    default:
      return "1rem";
  }
};
var StyledP$1 = styled.p(_templateObject$1K || (_templateObject$1K = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n  line-height: 1.4;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n    &:empty {\n    display: none;\n  }\n\n  ", "\n\n  ", "\n\n  text-align: ", ";\n"])), function (_ref) {
  var variant = _ref.variant;
  return getColorFromVariant$1(variant);
}, function (_ref2) {
  var size = _ref2.size;
  return fontSize(size);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.body.family;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.body.weight;
}, function (_ref5) {
  var marginless = _ref5.marginless;
  return marginless && css(_templateObject2$1u || (_templateObject2$1u = _taggedTemplateLiteral(["\n      margin: 0;\n    "])));
}, function (_ref6) {
  var bold = _ref6.bold;
  return bold && css(_templateObject3$1d || (_templateObject3$1d = _taggedTemplateLiteral(["\n      font-weight: bold;\n    "])));
}, function (_ref7) {
  var inline = _ref7.inline;
  return inline && css(_templateObject4$11 || (_templateObject4$11 = _taggedTemplateLiteral(["\n      display: inline;\n    "])));
}, function (_ref8) {
  var wrap = _ref8.wrap;
  return wrap && css(_templateObject5$N || (_templateObject5$N = _taggedTemplateLiteral(["\n      word-wrap: break-word;\n      word-break: break-word;\n    "])));
}, function (_ref9) {
  var nowrap = _ref9.nowrap;
  return nowrap && css(_templateObject6$I || (_templateObject6$I = _taggedTemplateLiteral(["\n      overflow: hidden;\n      white-space: nowrap;\n    "])));
}, function (_ref0) {
  var profileLabel = _ref0.profileLabel;
  return profileLabel && css(_templateObject7$E || (_templateObject7$E = _taggedTemplateLiteral(["\n      color: #555555;\n      font-weight: 600;\n      font-size: 16px;\n    "])));
}, function (_ref1) {
  var profileData = _ref1.profileData;
  return profileData && css(_templateObject8$y || (_templateObject8$y = _taggedTemplateLiteral(["\n      color: #333333;\n      font-weight: 400;\n      font-size: 16px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "])));
}, function (_ref10) {
  var multiline = _ref10.multiline;
  return multiline && css(_templateObject9$w || (_templateObject9$w = _taggedTemplateLiteral(["\n      white-space: pre-line;\n    "])));
}, function (_ref11) {
  var overflow = _ref11.overflow;
  return overflow && css(_templateObject0$t || (_templateObject0$t = _taggedTemplateLiteral(["\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "])));
}, function (_ref12) {
  var align = _ref12.align;
  return align;
});

var _excluded$x = ["children"];
var P$4 = function P(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$x);
  return /*#__PURE__*/React__default.createElement(StyledP$1, rest, children);
};
P$4.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["default", "small", "medium", "large", "extralarge"]),
  variant: PropTypes.oneOf(["default", "primary", "secondary", "content", "contentv2", "secondaryReadable", "neutral"]),
  marginless: PropTypes.bool,
  bold: PropTypes.bool,
  inline: PropTypes.bool,
  align: PropTypes.oneOf(["left", "center", "right"]),
  wrap: PropTypes.bool,
  multiline: PropTypes.bool
};
P$4.defaultProps = {
  size: "default",
  variant: "default",
  marginless: false,
  bold: false,
  inline: false,
  align: "left",
  wrap: false,
  multiline: false
};

var _templateObject$1J, _templateObject2$1t, _templateObject3$1c, _templateObject4$10, _templateObject5$M, _templateObject6$H, _templateObject7$D, _templateObject8$x, _templateObject9$v, _templateObject0$s, _templateObject1$p, _templateObject10$o;
var Container$D = styled.div(_templateObject$1J || (_templateObject$1J = _taggedTemplateLiteral(["\n  position: fixed;\n  right: 2rem;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  color: white;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var alertStyle = _ref.alertStyle;
  return alertStyle == "default" && css(_templateObject2$1t || (_templateObject2$1t = _taggedTemplateLiteral(["\n      bottom: 19.5rem;\n      padding: 2rem;\n      border-radius: 1rem;\n      justify-content: space-between;\n\n      ", "\n\n      & > :last-child {\n        margin-left: 1rem;\n      }\n\n      ", "\n\n      ", "\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject3$1c || (_templateObject3$1c = _taggedTemplateLiteral(["\n        bottom: 7rem;\n      "]))), function (_ref2) {
    var variant = _ref2.variant,
      theme = _ref2.theme;
    return variant === "success" && css(_templateObject4$10 || (_templateObject4$10 = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.colors.success);
  }, function (_ref3) {
    var variant = _ref3.variant,
      theme = _ref3.theme;
    return variant === "info" && css(_templateObject5$M || (_templateObject5$M = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.colors.secondary);
  }, function (_ref4) {
    var variant = _ref4.variant,
      theme = _ref4.theme;
    return variant === "error" && css(_templateObject6$H || (_templateObject6$H = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.colors.danger);
  });
}, function (_ref5) {
  var alertStyle = _ref5.alertStyle;
  return alertStyle == "simple" && css(_templateObject7$D || (_templateObject7$D = _taggedTemplateLiteral(["\n      padding: 10px 16px;\n      gap: 12px;\n      border-radius: 8px;\n      justify-content: start;\n      right: 1rem;\n      bottom: 1rem;\n      box-shadow: 1px 1px 5px #888;\n\n      ", "\n\n      ", "\n\n      p {\n        font-size: 16px;\n        font-weight: 400;\n        color: #ffffff;\n      }\n\n      ", "\n\n      ", "\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject8$x || (_templateObject8$x = _taggedTemplateLiteral(["\n        max-width: 50%;\n        max-width: 50vw;\n        bottom: 4.8rem;\n      "]))), breakpoint("desktop")(_templateObject9$v || (_templateObject9$v = _taggedTemplateLiteral(["\n        max-width: 23%;\n        max-width: 23vw;\n      "]))), function (_ref6) {
    var variant = _ref6.variant,
      theme = _ref6.theme;
    return variant === "success" && css(_templateObject0$s || (_templateObject0$s = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.colors.alerts.success);
  }, function (_ref7) {
    var variant = _ref7.variant,
      theme = _ref7.theme;
    return variant === "info" && css(_templateObject1$p || (_templateObject1$p = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.colors.alerts.info);
  }, function (_ref8) {
    var variant = _ref8.variant,
      theme = _ref8.theme;
    return variant === "error" && css(_templateObject10$o || (_templateObject10$o = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.colors.alerts.danger);
  });
});

var Alert = function Alert(_ref) {
  var options = _ref.options,
    message = _ref.message,
    close = _ref.close,
    _ref$simple = _ref.simple,
    simple = _ref$simple === void 0 ? false : _ref$simple;
  var closeAlert = function closeAlert(event) {
    event.preventDefault();
    if (close !== undefined) close();
  };
  var variant = options.type === "error" ? "" : "secondaryReadable";
  var alertStyle = simple ? "simple" : "default";
  return /*#__PURE__*/React__default.createElement(Container$D, {
    variant: options.type,
    alertStyle: alertStyle
  }, simple && options.type == "error" && /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleExclamation,
    size: "lg"
  }), simple && options.type == "success" && /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleCheck,
    size: "lg"
  }), simple && !["success", "error"].includes(options.type) && /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleInfo,
    size: "lg"
  }), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    variant: variant
  }, message), !simple && /*#__PURE__*/React__default.createElement(CloseIcon$1, {
    variant: variant,
    onClick: closeAlert
  }));
};
Alert.propTypes = {
  options: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired
};
Alert.defaultProps = {
  options: {},
  message: "",
  close: undefined
};

var SimpleAlert = function SimpleAlert(props) {
  return /*#__PURE__*/React__default.createElement(Alert, _extends({
    simple: true
  }, props));
};
SimpleAlert.propTypes = {
  style: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired
};
SimpleAlert.defaultProps = {
  style: "",
  options: {},
  message: "",
  close: undefined
};

var _templateObject$1I, _templateObject2$1s, _templateObject3$1b, _templateObject4$$, _templateObject5$L, _templateObject6$G;
var Container$C = styled.div(_templateObject$1I || (_templateObject$1I = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 8px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.banner.text;
});
var AccordionItem = styled.div(_templateObject2$1s || (_templateObject2$1s = _taggedTemplateLiteral(["\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n"])));
var AccordionHeading = styled.p(_templateObject3$1b || (_templateObject3$1b = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});
var AccordionHeadingOuter = styled.div(_templateObject4$$ || (_templateObject4$$ = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n\n  padding: 22px;\n"])));
var AccordionToggle = styled.button(_templateObject5$L || (_templateObject5$L = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 24px;\n  font-weight: 600;\n  background: none;\n  border: none;\n  padding: 0;\n  transition: transform 0.3s;\n\n  ", "\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
}, function (_ref5) {
  var rotated = _ref5.rotated;
  return rotated ? "transform: rotate(180deg);" : "";
});
var AccordionPanel = styled.div(_templateObject6$G || (_templateObject6$G = _taggedTemplateLiteral(["\n  ", "\n\n  font-size: 16px;\n  padding: 0 22px 20px;\n"])), function (_ref6) {
  var show = _ref6.show;
  return show ? "display: block;" : "display: none;";
});

var _templateObject$1H, _templateObject2$1r, _templateObject3$1a, _templateObject4$_, _templateObject5$K, _templateObject6$F, _templateObject7$C, _templateObject8$w, _templateObject9$u, _templateObject0$r, _templateObject1$o, _templateObject10$n, _templateObject11$m, _templateObject12$k, _templateObject13$i, _templateObject14$h, _templateObject15$h, _templateObject16$f, _templateObject17$c, _templateObject18$b, _templateObject19$a, _templateObject20$9, _templateObject21$7, _templateObject22$7;
var getButtonColorFromVariant = function getButtonColorFromVariant(variant, theme) {
  var useAlternative = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  switch (variant) {
    case "simpleForm":
      return theme.colors.primary;
    case "simpleFormDanger":
      return theme.colors.danger;
    case "simpleFormBack":
      return theme.colors.fields.backButton;
    case "primary":
      return theme.colors.primary;
    case "secondary":
      if (!!useAlternative) {
        return theme.colors.secondaryAlternative || theme.colors.secondary;
      } else {
        return theme.colors.secondary;
      }
    case "white":
      if (!!useAlternative) {
        return theme.colors.whiteAlternative || "white";
      } else {
        return "white";
      }
    case "success":
      return theme.colors.success;
    case "danger":
      return theme.colors.danger;
    case "special":
      return theme.colors.buttons.special.main;
    case "profilePrimary":
      return theme.colors.profile.buttons.primary.background;
    case "profileSecondary":
      return theme.colors.profile.buttons.secondary.background;
    default:
      return theme.colors.lightGrey;
  }
};
var getTextColorFromVariant$1 = function getTextColorFromVariant(variant, theme) {
  var simpleForm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  switch (variant) {
    case "simpleForm":
    case "simpleFormDanger":
      return theme.colors.buttons.lightColor;
    case "simpleFormBack":
      return theme.colors.fields.backButtonText;
    case "primary":
      return theme.colors.buttons.lightColor;
    case "secondary":
      return theme.colors.secondaryAlternative || theme.colors.buttons.lightColor;
    case "white":
      return theme.colors.buttons.darkColor;
    case "success":
      // special case for CL button
      if (simpleForm && theme.colors.buttons.success) {
        return theme.colors.buttons.success.text;
      } else {
        return readableColor(theme.colors.success, theme.colors.buttons.darkColor, theme.colors.buttons.lightColor, false);
      }
    case "danger":
      return theme.colors.buttons.lightColor;
    case "special":
      return theme.colors.buttons.special.text;
    case "profilePrimary":
      return theme.colors.profile.buttons.primary.text;
    case "profileSecondary":
      return theme.colors.profile.buttons.secondary.text;
    default:
      return theme.colors.buttons.darkColor;
  }
};
var getFontSizeFromSize$1 = function getFontSizeFromSize(size, theme, simpleForm) {
  if (simpleForm === true) return "16px";
  switch (size) {
    case "small":
      return "0.75rem";
    case "medium":
      return "1.25rem";
    case "large":
      return "1.5rem";
    default:
      return "1rem";
  }
};
var getPaddingFromSize$2 = function getPaddingFromSize(size, theme, variant, iconOnly) {
  if (variant == "simpleForm" === true) return "12px 24px";
  switch (size) {
    case "small":
      return "0.5rem 1rem";
    case "medium":
      return "1rem 2rem";
    case "large":
      return "1.25rem 2.5rem";
    case "profileHeader":
      return !!iconOnly ? "12px 15px" : "10px 18px";
    default:
      return "0.75rem 1.5rem";
  }
};
var styles$1 = css(_templateObject$1H || (_templateObject$1H = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-radius: 0.5rem;\n  margin: 0;\n  text-decoration: none;\n  text-align: center;\n  font-family: ", ", sans-serif;\n  font-weight: 500;\n  appearance: none;\n  cursor: pointer;\n  white-space: nowrap;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  padding: ", ";\n  box-sizing: border-box;\n\n  &:disabled,\n  &[disabled] {\n    color: #aaa;\n    background-color: #ddd;\n    border-color: #ddd;\n    pointer-events: none;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
    theme = _ref.theme;
  return getButtonColorFromVariant(variant, theme, true);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.body.family;
}, function (_ref3) {
  var variant = _ref3.variant,
    theme = _ref3.theme;
  return getButtonColorFromVariant(variant, theme);
}, function (_ref4) {
  var variant = _ref4.variant,
    theme = _ref4.theme,
    simpleForm = _ref4.simpleForm;
  return getTextColorFromVariant$1(variant, theme, !!simpleForm);
}, function (_ref5) {
  var size = _ref5.size,
    theme = _ref5.theme,
    variant = _ref5.variant;
  return getFontSizeFromSize$1(size, theme, variant == "simpleForm" || variant == "simpleFormDanger");
}, function (_ref6) {
  var size = _ref6.size,
    theme = _ref6.theme,
    variant = _ref6.variant,
    iconOnly = _ref6.iconOnly;
  return getPaddingFromSize$2(size, theme, variant, !!iconOnly);
}, function (_ref7) {
  var variant = _ref7.variant,
    outlined = _ref7.outlined;
  return variant !== "simpleFormBack" && !outlined && css(_templateObject2$1r || (_templateObject2$1r = _taggedTemplateLiteral(["\n      &:not([disabled]):hover,\n      &:not(:disabled):hover {\n        background-color: ", ";\n        border-color: ", ";\n      }\n    "])), function (_ref8) {
    var variant = _ref8.variant,
      theme = _ref8.theme;
    return lighten(0.05, getButtonColorFromVariant(variant, theme));
  }, function (_ref9) {
    var variant = _ref9.variant,
      theme = _ref9.theme;
    return getButtonColorFromVariant(variant, theme, true);
  });
}, function (_ref0) {
  var variant = _ref0.variant;
  return variant == "simpleFormBack" && css(_templateObject3$1a || (_templateObject3$1a = _taggedTemplateLiteral(["\n      &:not([disabled]):hover,\n      &:not(:disabled):hover {\n        background-color: white;\n        color: ", ";\n        border-color: ", ";\n      }\n    "])), function (_ref1) {
    var theme = _ref1.theme;
    return theme.colors.brand;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.brand;
  });
}, function (props) {
  return !!props.outlined && css(_templateObject4$_ || (_templateObject4$_ = _taggedTemplateLiteral(["\n      background-color: transparent;\n\n      &:disabled,\n      &[disabled] {\n        color: inherit;\n        background-color: transparent;\n        pointer-events: none;\n        opacity: 0.5;\n      }\n\n      ", "\n\n      ", "\n\n      ", "\n    "])), function (props) {
    return props.variant !== "simpleFormBack" && props.variant !== "profileSecondary" && css(_templateObject5$K || (_templateObject5$K = _taggedTemplateLiteral(["\n          color: ", ";\n\n          &:not([disabled]):hover,\n          &:not(:disabled):hover {\n            background-color: ", ";\n            color: ", ";\n          }\n        "])), getButtonColorFromVariant(props.variant, props.theme, true), getButtonColorFromVariant(props.variant, props.theme), getTextColorFromVariant$1(props.variant, props.theme));
  }, function (props) {
    return props.variant === "simpleFormBack" && css(_templateObject6$F || (_templateObject6$F = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), getTextColorFromVariant$1("simpleFormBack", props.theme));
  }, function (props) {
    return props.variant === "profileSecondary" && css(_templateObject7$C || (_templateObject7$C = _taggedTemplateLiteral(["\n          &:not([disabled]):hover,\n          &:not(:disabled):hover {\n            background-color: ", ";\n          }\n        "])), darken(0.05, props.theme.colors.profile.headerBg));
  });
}, function (props) {
  return !!props.fullwidth && css(_templateObject8$w || (_templateObject8$w = _taggedTemplateLiteral(["\n      display: block;\n      width: 100%;\n    "])));
}, function (props) {
  return !!props.fullHeight && css(_templateObject9$u || (_templateObject9$u = _taggedTemplateLiteral(["\n      height: 100%;\n    "])));
}, function (props) {
  return !!props.inlineBlock && css(_templateObject0$r || (_templateObject0$r = _taggedTemplateLiteral(["\n      display: inline-block;\n    "])));
}, function (props) {
  return !!props.fitContent && css(_templateObject1$o || (_templateObject1$o = _taggedTemplateLiteral(["\n      width: fit-content;\n    "])));
}, function (props) {
  return !!props.number && css(_templateObject10$n || (_templateObject10$n = _taggedTemplateLiteral(["\n      display: inline-flex;\n      align-items: center;\n    "])));
}, function (props) {
  return !!props.profileMoreButtonsFooter && css(_templateObject11$m || (_templateObject11$m = _taggedTemplateLiteral(["\n      border: none;\n      color: #333;\n      text-align: left;\n\n      &:not([disabled]):hover,\n      &:not(:disabled):hover {\n        background-color: transparent;\n        color: #434343;\n      }\n    "])));
}, function (props) {
  return !!props.withIcon && css(_templateObject12$k || (_templateObject12$k = _taggedTemplateLiteral(["\n      display: flex;\n      align-items: center;\n      justify-content: start;\n      gap: 0.55rem;\n    "])));
}, function (props) {
  return !!props.tableCellLink && css(_templateObject13$i || (_templateObject13$i = _taggedTemplateLiteral(["\n      background: transparent;\n      padding: 0;\n      text-decoration: underline;\n      border: none;\n      color: ", ";\n\n      display: flex;\n      align-items: center;\n      justify-content: start;\n      gap: 0.5rem;\n\n      &:not([disabled]):hover,\n      &:not(:disabled):hover {\n        background: transparent;\n        border: none;\n        text-decoration: none;\n      }\n    "])), function (_ref11) {
    var theme = _ref11.theme;
    return theme.colors.primary;
  });
});
var StyledLink$4 = styled(Link$2)(_templateObject14$h || (_templateObject14$h = _taggedTemplateLiteral(["\n  ", "\n"])), styles$1);
var StyledA = styled.a(_templateObject15$h || (_templateObject15$h = _taggedTemplateLiteral(["\n  ", "\n"])), styles$1);
var StyledButton$2 = styled.button(_templateObject16$f || (_templateObject16$f = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), styles$1, function (props) {
  return !!props.flexGrow && css(_templateObject17$c || (_templateObject17$c = _taggedTemplateLiteral(["\n      flex-grow: 1;\n    "])));
}, function (props) {
  return (props.variant === "simpleForm" || props.variant === "simpleFormDanger") && !!props.disabled && !!props.actionButton && css(_templateObject18$b || (_templateObject18$b = _taggedTemplateLiteral(["\n      opacity: 0.3;\n      background-color: ", " !important;\n      border-color: transparent !important;\n      color: ", " !important;\n    "])), function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.primary;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.colors.profile.buttons.secondary.text;
  });
}, function (props) {
  return (props.variant === "simpleForm" || props.variant === "simpleFormDanger") && !!props.actionButton && css(_templateObject19$a || (_templateObject19$a = _taggedTemplateLiteral(["\n      width: 100%;\n      ", "\n    "])), breakpoint("tablet")(_templateObject20$9 || (_templateObject20$9 = _taggedTemplateLiteral(["\n        width: initial;\n      "]))));
});
var Number$2 = styled.button(_templateObject21$7 || (_templateObject21$7 = _taggedTemplateLiteral(["\n  margin-left: 0.75rem;\n  text-decoration: none;\n  text-align: center;\n  font-family: ", ", sans-serif;\n  font-weight: bold;\n  font-size: 0.8rem;\n  white-space: nowrap;\n  background-color: ", ";\n  color: ", ";\n  border: none;\n  border-radius: 0.75rem;\n  min-height: 1.5rem;\n  min-width: 1.5rem;\n  margin-top: -0.5rem;\n  margin-bottom: -0.5rem;\n  padding: 4px 4px;\n\n  ", "\n"])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.fonts.body.family;
}, function (_ref15) {
  var variant = _ref15.variant,
    theme = _ref15.theme;
  return getTextColorFromVariant$1(variant, theme);
}, function (_ref16) {
  var variant = _ref16.variant,
    theme = _ref16.theme;
  return getButtonColorFromVariant(variant, theme);
}, function (props) {
  return !!props.outlined && css(_templateObject22$7 || (_templateObject22$7 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n\n      ", ":not([disabled]):hover, ", ":not(:disabled):hover & {\n        background-color: ", ";\n        color: ", ";\n      }\n    "])), getButtonColorFromVariant(props.variant, props.theme), getTextColorFromVariant$1(props.variant, props.theme), StyledButton$2, StyledButton$2, getTextColorFromVariant$1(props.variant, props.theme), getButtonColorFromVariant(props.variant, props.theme));
});

var _excluded$w = ["children", "number"];
var Button$5 = function Button(_ref) {
  var children = _ref.children,
    number = _ref.number,
    rest = _objectWithoutProperties$1(_ref, _excluded$w);
  if (!!number) return /*#__PURE__*/React__default.createElement(StyledButton$2, _extends({
    number: number
  }, rest), children, /*#__PURE__*/React__default.createElement(Number$2, rest, number));else if (rest.to) return /*#__PURE__*/React__default.createElement(StyledLink$4, rest, children);else if (rest.href || rest.tableCellLink) return /*#__PURE__*/React__default.createElement(StyledA, _extends({}, rest, {
    rel: "noopender noreferrer"
  }), children);else return /*#__PURE__*/React__default.createElement(StyledButton$2, rest, children);
};
Button$5.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
  href: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.oneOf(["default", "primary", "secondary", "white", "success", "danger", "special"]),
  size: PropTypes.oneOf(["small", "default", "medium", "large"]),
  outlined: PropTypes.bool,
  fullwidth: PropTypes.bool,
  onClick: PropTypes.func,
  number: PropTypes.string,
  iconOnly: PropTypes.bool,
  flexGrow: PropTypes.bool
};
Button$5.defaultProps = {
  to: null,
  href: null,
  variant: "default",
  size: "default",
  outlined: false,
  fullwidth: false,
  onClick: undefined,
  number: "",
  iconOnly: false,
  flexGrow: false
};

var _templateObject$1G, _templateObject2$1q, _templateObject3$19, _templateObject4$Z, _templateObject5$J, _templateObject6$E, _templateObject7$B, _templateObject8$v, _templateObject9$t;
var summaryFontSize = function summaryFontSize(size) {
  switch (size) {
    case "small":
      return "1.25rem";
    case "medium":
      return "1.75rem";
    case "large":
      return "2rem";
    default:
      return "1.5rem";
  }
};
var Container$B = styled.div(_templateObject$1G || (_templateObject$1G = _taggedTemplateLiteral(["\n  user-select: text;\n\n  &:empty {\n    display: none;\n  }\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n\n  ", ";\n"])), function (_ref) {
  var simpleForm = _ref.simpleForm;
  return simpleForm && css(_templateObject2$1q || (_templateObject2$1q = _taggedTemplateLiteral(["\n      border: 1px solid #e6e6e6;\n      padding: 24px;\n      border-radius: 8px;\n      color: #19434a;\n    "])));
});
var Img$8 = styled.img(_templateObject3$19 || (_templateObject3$19 = _taggedTemplateLiteral(["\n  max-width: 100%;\n"])));
var Table$2 = styled.table(_templateObject4$Z || (_templateObject4$Z = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n  border: 1px solid ", ";\n\n  td,\n  th {\n    border: 1px solid ", ";\n    padding: 0.25rem 0.5rem;\n  }\n\n  width: 100%;\n  border-collapse: collapse;\n"])), function (_ref2) {
  var variant = _ref2.variant;
  return getColorFromVariant$1(variant);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.body.family;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.body.weight;
}, function (_ref5) {
  var variant = _ref5.variant;
  return getColorFromVariant$1(variant);
}, function (_ref6) {
  var variant = _ref6.variant;
  return getColorFromVariant$1(variant);
});
var Details = styled.details(_templateObject5$J || (_templateObject5$J = _taggedTemplateLiteral(["\n  border: 1px solid #e6e6e6;\n  padding: 24px;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n\n  summary {\n    color: ", ";\n    font-size: ", ";\n    font-family: ", ", sans-serif;\n    font-weight: ", ";\n    letter-spacing: -1px;\n    line-height: 1.2;\n    cursor: pointer;\n  }\n\n  p > a.cta {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n"])), function (_ref7) {
  var variant = _ref7.variant;
  return getColorFromVariant$1(variant);
}, function (_ref8) {
  var size = _ref8.size;
  return summaryFontSize(size);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fonts.headings.family;
}, function (_ref0) {
  var theme = _ref0.theme;
  return theme.fonts.headings.weight;
});
var Li$2 = styled.li(_templateObject6$E || (_templateObject6$E = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n  margin-bottom: 0.5rem;\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n\n  ", "\n"])), function (_ref1) {
  var variant = _ref1.variant;
  return getColorFromVariant$1(variant);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fonts.body.family;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fonts.body.weight;
}, function (_ref12) {
  var variant = _ref12.variant;
  return variant === "profile" && css(_templateObject7$B || (_templateObject7$B = _taggedTemplateLiteral(["\n      margin-left: -20px;\n      color: #666666;\n      line-height: 1.55em;\n    "])));
});
var A$5 = styled.a(_templateObject8$v || (_templateObject8$v = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n"])), function (_ref13) {
  var variant = _ref13.variant;
  return getColorFromVariant$1(variant);
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fonts.body.family;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fonts.body.weight;
});
var ButtonA = styled(Button$5)(_templateObject9$t || (_templateObject9$t = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-right: 1rem;\n"])));

var VOID = -1;
var PRIMITIVE = 0;
var ARRAY = 1;
var OBJECT = 2;
var DATE = 3;
var REGEXP = 4;
var MAP = 5;
var SET = 6;
var ERROR = 7;
var BIGINT = 8;
// export const SYMBOL = 9;

var env = (typeof self === "undefined" ? "undefined" : _typeof$1(self)) === 'object' ? self : globalThis;
var deserializer = function deserializer($, _) {
  var as = function as(out, index) {
    $.set(index, out);
    return out;
  };
  var _unpair = function unpair(index) {
    if ($.has(index)) return $.get(index);
    var _$index = _slicedToArray(_[index], 2),
      type = _$index[0],
      value = _$index[1];
    switch (type) {
      case PRIMITIVE:
      case VOID:
        return as(value, index);
      case ARRAY:
        {
          var arr = as([], index);
          var _iterator = _createForOfIteratorHelper(value),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _index = _step.value;
              arr.push(_unpair(_index));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return arr;
        }
      case OBJECT:
        {
          var object = as({}, index);
          var _iterator2 = _createForOfIteratorHelper(value),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = _slicedToArray(_step2.value, 2),
                key = _step2$value[0],
                _index2 = _step2$value[1];
              object[_unpair(key)] = _unpair(_index2);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          return object;
        }
      case DATE:
        return as(new Date(value), index);
      case REGEXP:
        {
          var source = value.source,
            flags = value.flags;
          return as(new RegExp(source, flags), index);
        }
      case MAP:
        {
          var map = as(new Map(), index);
          var _iterator3 = _createForOfIteratorHelper(value),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _step3$value = _slicedToArray(_step3.value, 2),
                _key = _step3$value[0],
                _index3 = _step3$value[1];
              map.set(_unpair(_key), _unpair(_index3));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          return map;
        }
      case SET:
        {
          var set = as(new Set(), index);
          var _iterator4 = _createForOfIteratorHelper(value),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _index4 = _step4.value;
              set.add(_unpair(_index4));
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          return set;
        }
      case ERROR:
        {
          var name = value.name,
            message = value.message;
          return as(new env[name](message), index);
        }
      case BIGINT:
        return as(BigInt(value), index);
      case 'BigInt':
        return as(Object(BigInt(value)), index);
      case 'ArrayBuffer':
        return as(new Uint8Array(value).buffer, value);
      case 'DataView':
        {
          var _Uint8Array = new Uint8Array(value),
            buffer = _Uint8Array.buffer;
          return as(new DataView(buffer), value);
        }
    }
    return as(new env[type](value), index);
  };
  return _unpair;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns a deserialized value from a serialized array of Records.
 * @param {Record[]} serialized a previously serialized value.
 * @returns {any}
 */
var deserialize = function deserialize(serialized) {
  return deserializer(new Map(), serialized)(0);
};

var EMPTY = '';
var _ref = {},
  toString = _ref.toString;
var keys = Object.keys;
var typeOf = function typeOf(value) {
  var type = _typeof$1(value);
  if (type !== 'object' || !value) return [PRIMITIVE, type];
  var asString = toString.call(value).slice(8, -1);
  switch (asString) {
    case 'Array':
      return [ARRAY, EMPTY];
    case 'Object':
      return [OBJECT, EMPTY];
    case 'Date':
      return [DATE, EMPTY];
    case 'RegExp':
      return [REGEXP, EMPTY];
    case 'Map':
      return [MAP, EMPTY];
    case 'Set':
      return [SET, EMPTY];
    case 'DataView':
      return [ARRAY, asString];
  }
  if (asString.includes('Array')) return [ARRAY, asString];
  if (asString.includes('Error')) return [ERROR, asString];
  return [OBJECT, asString];
};
var shouldSkip = function shouldSkip(_ref2) {
  var _ref3 = _slicedToArray(_ref2, 2),
    TYPE = _ref3[0],
    type = _ref3[1];
  return TYPE === PRIMITIVE && (type === 'function' || type === 'symbol');
};
var serializer = function serializer(strict, json, $, _) {
  var as = function as(out, value) {
    var index = _.push(out) - 1;
    $.set(value, index);
    return index;
  };
  var _pair = function pair(value) {
    if ($.has(value)) return $.get(value);
    var _typeOf = typeOf(value),
      _typeOf2 = _slicedToArray(_typeOf, 2),
      TYPE = _typeOf2[0],
      type = _typeOf2[1];
    switch (TYPE) {
      case PRIMITIVE:
        {
          var entry = value;
          switch (type) {
            case 'bigint':
              TYPE = BIGINT;
              entry = value.toString();
              break;
            case 'function':
            case 'symbol':
              if (strict) throw new TypeError('unable to serialize ' + type);
              entry = null;
              break;
            case 'undefined':
              return as([VOID], value);
          }
          return as([TYPE, entry], value);
        }
      case ARRAY:
        {
          if (type) {
            var spread = value;
            if (type === 'DataView') {
              spread = new Uint8Array(value.buffer);
            } else if (type === 'ArrayBuffer') {
              spread = new Uint8Array(value);
            }
            return as([type, _toConsumableArray(spread)], value);
          }
          var arr = [];
          var index = as([TYPE, arr], value);
          var _iterator = _createForOfIteratorHelper(value),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _entry = _step.value;
              arr.push(_pair(_entry));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return index;
        }
      case OBJECT:
        {
          if (type) {
            switch (type) {
              case 'BigInt':
                return as([type, value.toString()], value);
              case 'Boolean':
              case 'Number':
              case 'String':
                return as([type, value.valueOf()], value);
            }
          }
          if (json && 'toJSON' in value) return _pair(value.toJSON());
          var entries = [];
          var _index = as([TYPE, entries], value);
          var _iterator2 = _createForOfIteratorHelper(keys(value)),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var key = _step2.value;
              if (strict || !shouldSkip(typeOf(value[key]))) entries.push([_pair(key), _pair(value[key])]);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          return _index;
        }
      case DATE:
        return as([TYPE, value.toISOString()], value);
      case REGEXP:
        {
          var source = value.source,
            flags = value.flags;
          return as([TYPE, {
            source: source,
            flags: flags
          }], value);
        }
      case MAP:
        {
          var _entries = [];
          var _index2 = as([TYPE, _entries], value);
          var _iterator3 = _createForOfIteratorHelper(value),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _step3$value = _slicedToArray(_step3.value, 2),
                _key = _step3$value[0],
                _entry2 = _step3$value[1];
              if (strict || !(shouldSkip(typeOf(_key)) || shouldSkip(typeOf(_entry2)))) _entries.push([_pair(_key), _pair(_entry2)]);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          return _index2;
        }
      case SET:
        {
          var _entries2 = [];
          var _index3 = as([TYPE, _entries2], value);
          var _iterator4 = _createForOfIteratorHelper(value),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _entry3 = _step4.value;
              if (strict || !shouldSkip(typeOf(_entry3))) _entries2.push(_pair(_entry3));
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          return _index3;
        }
    }
    var message = value.message;
    return as([TYPE, {
      name: type,
      message: message
    }], value);
  };
  return _pair;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns an array of serialized Records.
 * @param {any} value a serializable value.
 * @param {{json?: boolean, lossy?: boolean}?} options an object with a `lossy` or `json` property that,
 *  if `true`, will not throw errors on incompatible types, and behave more
 *  like JSON stringify would behave. Symbol and Function will be discarded.
 * @returns {Record[]}
 */
var serialize = function serialize(value) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    json = _ref4.json,
    lossy = _ref4.lossy;
  var _ = [];
  return serializer(!(json || lossy), !!json, new Map(), _)(value), _;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */
var structuredClone$1 = typeof structuredClone === "function" ? /* c8 ignore start */
function (any, options) {
  return options && ('json' in options || 'lossy' in options) ? deserialize(serialize(any, options)) : structuredClone(any);
} : function (any, options) {
  return deserialize(serialize(any, options));
};

function ok$1() {}

/**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */

/** @type {SchemaType} */
var Schema$2 = /*#__PURE__*/_createClass$1(
/**
 * @param {SchemaType['property']} property
 *   Property.
 * @param {SchemaType['normal']} normal
 *   Normal.
 * @param {Space | undefined} [space]
 *   Space.
 * @returns
 *   Schema.
 */
function Schema(property, normal, space) {
  _classCallCheck$1(this, Schema);
  this.normal = normal;
  this.property = property;
  if (space) {
    this.space = space;
  }
});
Schema$2.prototype.normal = {};
Schema$2.prototype.property = {};
Schema$2.prototype.space = undefined;

/**
 * @param {ReadonlyArray<Schema>} definitions
 *   Definitions.
 * @param {Space | undefined} [space]
 *   Space.
 * @returns {Schema}
 *   Schema.
 */
function merge$2(definitions, space) {
  /** @type {Record<string, Info>} */
  var property = {};
  /** @type {Record<string, string>} */
  var normal = {};
  var _iterator = _createForOfIteratorHelper(definitions),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var definition = _step.value;
      Object.assign(property, definition.property);
      Object.assign(normal, definition.normal);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return new Schema$2(property, normal, space);
}

/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */
function normalize$2(value) {
  return value.toLowerCase();
}

/**
 * @import {Info as InfoType} from 'property-information'
 */

/** @type {InfoType} */
var Info$3 = /*#__PURE__*/_createClass$1(
/**
 * @param {string} property
 *   Property.
 * @param {string} attribute
 *   Attribute.
 * @returns
 *   Info.
 */
function Info(property, attribute) {
  _classCallCheck$1(this, Info);
  this.attribute = attribute;
  this.property = property;
});
Info$3.prototype.attribute = '';
Info$3.prototype.booleanish = false;
Info$3.prototype["boolean"] = false;
Info$3.prototype.commaOrSpaceSeparated = false;
Info$3.prototype.commaSeparated = false;
Info$3.prototype.defined = false;
Info$3.prototype.mustUseProperty = false;
Info$3.prototype.number = false;
Info$3.prototype.overloadedBoolean = false;
Info$3.prototype.property = '';
Info$3.prototype.spaceSeparated = false;
Info$3.prototype.space = undefined;

var powers$2 = 0;
var _boolean$2 = increment$2();
var booleanish$2 = increment$2();
var overloadedBoolean$2 = increment$2();
var number$2 = increment$2();
var spaceSeparated$2 = increment$2();
var commaSeparated$2 = increment$2();
var commaOrSpaceSeparated$2 = increment$2();
function increment$2() {
  return Math.pow(2, ++powers$2);
}

var types$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  boolean: _boolean$2,
  booleanish: booleanish$2,
  commaOrSpaceSeparated: commaOrSpaceSeparated$2,
  commaSeparated: commaSeparated$2,
  number: number$2,
  overloadedBoolean: overloadedBoolean$2,
  spaceSeparated: spaceSeparated$2
});

var checks$2 = /** @type {ReadonlyArray<keyof typeof types>} */
Object.keys(types$2);
var DefinedInfo$2 = /*#__PURE__*/function (_Info) {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  function DefinedInfo(property, attribute, mask, space) {
    var _this;
    _classCallCheck$1(this, DefinedInfo);
    var index = -1;
    _this = _callSuper(this, DefinedInfo, [property, attribute]);
    mark$2(_this, 'space', space);
    if (typeof mask === 'number') {
      while (++index < checks$2.length) {
        var check = checks$2[index];
        mark$2(_this, checks$2[index], (mask & types$2[check]) === types$2[check]);
      }
    }
    return _this;
  }
  _inherits$1(DefinedInfo, _Info);
  return _createClass$1(DefinedInfo);
}(Info$3);
DefinedInfo$2.prototype.defined = true;

/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */
function mark$2(values, key, value) {
  if (value) {
    values[key] = value;
  }
}

/**
 * @param {Definition} definition
 *   Definition.
 * @returns {Schema}
 *   Schema.
 */
function create$2(definition) {
  /** @type {Record<string, Info>} */
  var properties = {};
  /** @type {Record<string, string>} */
  var normals = {};
  for (var _i = 0, _Object$entries = Object.entries(definition.properties); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      property = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    var info = new DefinedInfo$2(property, definition.transform(definition.attributes || {}, property), value, definition.space);
    if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) {
      info.mustUseProperty = true;
    }
    properties[property] = info;
    normals[normalize$2(property)] = property;
    normals[normalize$2(info.attribute)] = property;
  }
  return new Schema$2(properties, normals, definition.space);
}

var aria$2 = create$2({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish$2,
    ariaAutoComplete: null,
    ariaBusy: booleanish$2,
    ariaChecked: booleanish$2,
    ariaColCount: number$2,
    ariaColIndex: number$2,
    ariaColSpan: number$2,
    ariaControls: spaceSeparated$2,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated$2,
    ariaDetails: null,
    ariaDisabled: booleanish$2,
    ariaDropEffect: spaceSeparated$2,
    ariaErrorMessage: null,
    ariaExpanded: booleanish$2,
    ariaFlowTo: spaceSeparated$2,
    ariaGrabbed: booleanish$2,
    ariaHasPopup: null,
    ariaHidden: booleanish$2,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated$2,
    ariaLevel: number$2,
    ariaLive: null,
    ariaModal: booleanish$2,
    ariaMultiLine: booleanish$2,
    ariaMultiSelectable: booleanish$2,
    ariaOrientation: null,
    ariaOwns: spaceSeparated$2,
    ariaPlaceholder: null,
    ariaPosInSet: number$2,
    ariaPressed: booleanish$2,
    ariaReadOnly: booleanish$2,
    ariaRelevant: null,
    ariaRequired: booleanish$2,
    ariaRoleDescription: spaceSeparated$2,
    ariaRowCount: number$2,
    ariaRowIndex: number$2,
    ariaRowSpan: number$2,
    ariaSelected: booleanish$2,
    ariaSetSize: number$2,
    ariaSort: null,
    ariaValueMax: number$2,
    ariaValueMin: number$2,
    ariaValueNow: number$2,
    ariaValueText: null,
    role: null
  },
  transform: function transform(_, property) {
    return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
  }
});

/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */
function caseSensitiveTransform$2(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute;
}

/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Transformed property.
 */
function caseInsensitiveTransform$2(attributes, property) {
  return caseSensitiveTransform$2(attributes, property.toLowerCase());
}

var html$5 = create$2({
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated$2,
    acceptCharset: spaceSeparated$2,
    accessKey: spaceSeparated$2,
    action: null,
    allow: null,
    allowFullScreen: _boolean$2,
    allowPaymentRequest: _boolean$2,
    allowUserMedia: _boolean$2,
    alt: null,
    as: null,
    async: _boolean$2,
    autoCapitalize: null,
    autoComplete: spaceSeparated$2,
    autoFocus: _boolean$2,
    autoPlay: _boolean$2,
    blocking: spaceSeparated$2,
    capture: null,
    charSet: null,
    checked: _boolean$2,
    cite: null,
    className: spaceSeparated$2,
    cols: number$2,
    colSpan: null,
    content: null,
    contentEditable: booleanish$2,
    controls: _boolean$2,
    controlsList: spaceSeparated$2,
    coords: number$2 | commaSeparated$2,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    "default": _boolean$2,
    defer: _boolean$2,
    dir: null,
    dirName: null,
    disabled: _boolean$2,
    download: overloadedBoolean$2,
    draggable: booleanish$2,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: _boolean$2,
    formTarget: null,
    headers: spaceSeparated$2,
    height: number$2,
    hidden: overloadedBoolean$2,
    high: number$2,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated$2,
    httpEquiv: spaceSeparated$2,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: _boolean$2,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: _boolean$2,
    itemId: null,
    itemProp: spaceSeparated$2,
    itemRef: spaceSeparated$2,
    itemScope: _boolean$2,
    itemType: spaceSeparated$2,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: _boolean$2,
    low: number$2,
    manifest: null,
    max: null,
    maxLength: number$2,
    media: null,
    method: null,
    min: null,
    minLength: number$2,
    multiple: _boolean$2,
    muted: _boolean$2,
    name: null,
    nonce: null,
    noModule: _boolean$2,
    noValidate: _boolean$2,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: _boolean$2,
    optimum: number$2,
    pattern: null,
    ping: spaceSeparated$2,
    placeholder: null,
    playsInline: _boolean$2,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: _boolean$2,
    referrerPolicy: null,
    rel: spaceSeparated$2,
    required: _boolean$2,
    reversed: _boolean$2,
    rows: number$2,
    rowSpan: number$2,
    sandbox: spaceSeparated$2,
    scope: null,
    scoped: _boolean$2,
    seamless: _boolean$2,
    selected: _boolean$2,
    shadowRootClonable: _boolean$2,
    shadowRootDelegatesFocus: _boolean$2,
    shadowRootMode: null,
    shape: null,
    size: number$2,
    sizes: null,
    slot: null,
    span: number$2,
    spellCheck: booleanish$2,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number$2,
    step: null,
    style: null,
    tabIndex: number$2,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: _boolean$2,
    useMap: null,
    value: booleanish$2,
    width: number$2,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated$2,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number$2,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number$2,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    "char": null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: _boolean$2,
    // Lists. Use CSS to reduce space between items instead
    declare: _boolean$2,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number$2,
    // `<img>` and `<object>`
    leftMargin: number$2,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number$2,
    // `<body>`
    marginWidth: number$2,
    // `<body>`
    noResize: _boolean$2,
    // `<frame>`
    noHref: _boolean$2,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: _boolean$2,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: _boolean$2,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number$2,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish$2,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number$2,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number$2,
    // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: _boolean$2,
    disableRemotePlayback: _boolean$2,
    prefix: null,
    property: null,
    results: number$2,
    security: null,
    unselectable: null
  },
  space: 'html',
  transform: caseInsensitiveTransform$2
});

var svg$5 = create$2({
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    transformOrigin: 'transform-origin',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  properties: {
    about: commaOrSpaceSeparated$2,
    accentHeight: number$2,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number$2,
    amplitude: number$2,
    arabicForm: null,
    ascent: number$2,
    attributeName: null,
    attributeType: null,
    azimuth: number$2,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number$2,
    by: null,
    calcMode: null,
    capHeight: number$2,
    className: spaceSeparated$2,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number$2,
    diffuseConstant: number$2,
    direction: null,
    display: null,
    dur: null,
    divisor: number$2,
    dominantBaseline: null,
    download: _boolean$2,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number$2,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number$2,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number$2,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated$2,
    g2: commaSeparated$2,
    glyphName: commaSeparated$2,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number$2,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number$2,
    horizOriginX: number$2,
    horizOriginY: number$2,
    id: null,
    ideographic: number$2,
    imageRendering: null,
    initialVisibility: null,
    "in": null,
    in2: null,
    intercept: number$2,
    k: number$2,
    k1: number$2,
    k2: number$2,
    k3: number$2,
    k4: number$2,
    kernelMatrix: commaOrSpaceSeparated$2,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number$2,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number$2,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number$2,
    overlineThickness: number$2,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number$2,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated$2,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number$2,
    pointsAtY: number$2,
    pointsAtZ: number$2,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated$2,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated$2,
    rev: commaOrSpaceSeparated$2,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated$2,
    requiredFeatures: commaOrSpaceSeparated$2,
    requiredFonts: commaOrSpaceSeparated$2,
    requiredFormats: commaOrSpaceSeparated$2,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number$2,
    specularExponent: number$2,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number$2,
    strikethroughThickness: number$2,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated$2,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number$2,
    strokeOpacity: number$2,
    strokeWidth: null,
    style: null,
    surfaceScale: number$2,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated$2,
    tabIndex: number$2,
    tableValues: null,
    target: null,
    targetX: number$2,
    targetY: number$2,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated$2,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number$2,
    underlineThickness: number$2,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number$2,
    values: null,
    vAlphabetic: number$2,
    vMathematical: number$2,
    vectorEffect: null,
    vHanging: number$2,
    vIdeographic: number$2,
    version: null,
    vertAdvY: number$2,
    vertOriginX: number$2,
    vertOriginY: number$2,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number$2,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: 'svg',
  transform: caseSensitiveTransform$2
});

var xlink$2 = create$2({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: 'xlink',
  transform: function transform(_, property) {
    return 'xlink:' + property.slice(5).toLowerCase();
  }
});

var xmlns$2 = create$2({
  attributes: {
    xmlnsxlink: 'xmlns:xlink'
  },
  properties: {
    xmlnsXLink: null,
    xmlns: null
  },
  space: 'xmlns',
  transform: caseInsensitiveTransform$2
});

var xml$2 = create$2({
  properties: {
    xmlBase: null,
    xmlLang: null,
    xmlSpace: null
  },
  space: 'xml',
  transform: function transform(_, property) {
    return 'xml:' + property.slice(3).toLowerCase();
  }
});

/**
 * @import {Schema} from 'property-information'
 */

var cap$2 = /[A-Z]/g;
var dash$2 = /-[a-z]/g;
var valid$2 = /^data[-\w.:]+$/i;

/**
 * Look up info on a property.
 *
 * In most cases the given `schema` contains info on the property.
 * All standard,
 * most legacy,
 * and some non-standard properties are supported.
 * For these cases,
 * the returned `Info` has hints about the value of the property.
 *
 * `name` can also be a valid data attribute or property,
 * in which case an `Info` object with the correctly cased `attribute` and
 * `property` is returned.
 *
 * `name` can be an unknown attribute,
 * in which case an `Info` object with `attribute` and `property` set to the
 * given name is returned.
 * It is not recommended to provide unsupported legacy or recently specced
 * properties.
 *
 *
 * @param {Schema} schema
 *   Schema;
 *   either the `html` or `svg` export.
 * @param {string} value
 *   An attribute-like or property-like name;
 *   it will be passed through `normalize` to hopefully find the correct info.
 * @returns {Info}
 *   Info.
 */
function find$2(schema, value) {
  var normal = normalize$2(value);
  var property = value;
  var Type = Info$3;
  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]];
  }
  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid$2.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      var rest = value.slice(5).replace(dash$2, camelcase$2);
      property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      // Turn it into an attribute.
      var _rest = value.slice(4);
      if (!dash$2.test(_rest)) {
        var dashes = _rest.replace(cap$2, kebab$2);
        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes;
        }
        value = 'data' + dashes;
      }
    }
    Type = DefinedInfo$2;
  }
  return new Type(property, value);
}

/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */
function kebab$2($0) {
  return '-' + $0.toLowerCase();
}

/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */
function camelcase$2($0) {
  return $0.charAt(1).toUpperCase();
}

// Note: types exposed from `index.d.ts`.
var html$4 = merge$2([aria$2, html$5, xlink$2, xmlns$2, xml$2], 'html');
var svg$4 = merge$2([aria$2, svg$5, xlink$2, xmlns$2, xml$2], 'svg');

/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */

/**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */

/**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function parse$1(value) {
  /** @type {Array<string>} */
  var tokens = [];
  var input = String(value || '');
  var index = input.indexOf(',');
  var start = 0;
  /** @type {boolean} */
  var end = false;
  while (!end) {
    if (index === -1) {
      index = input.length;
      end = true;
    }
    var token = input.slice(start, index).trim();
    if (token || !end) {
      tokens.push(token);
    }
    start = index + 1;
    index = input.indexOf(',', start);
  }
  return tokens;
}

/**
 * Serialize an array of strings or numbers to comma-separated tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @param {Options} [options]
 *   Configuration for `stringify` (optional).
 * @returns {string}
 *   Comma-separated tokens.
 */
function stringify$1(values, options) {
  var settings = options || {};

  // Ensure the last empty entry is seen.
  var input = values[values.length - 1] === '' ? [].concat(_toConsumableArray(values), ['']) : values;
  return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 */

/**
 * @template {string} SimpleSelector
 *   Selector type.
 * @template {string} DefaultTagName
 *   Default tag name.
 * @typedef {(
 *   SimpleSelector extends ''
 *     ? DefaultTagName
 *     : SimpleSelector extends `${infer TagName}.${infer Rest}`
 *     ? ExtractTagName<TagName, DefaultTagName>
 *     : SimpleSelector extends `${infer TagName}#${infer Rest}`
 *     ? ExtractTagName<TagName, DefaultTagName>
 *     : SimpleSelector extends string
 *     ? SimpleSelector
 *     : DefaultTagName
 * )} ExtractTagName
 *   Extract tag name from a simple selector.
 */

var search = /[#.]/g;

/**
 * Create a hast element from a simple CSS selector.
 *
 * @template {string} Selector
 *   Type of selector.
 * @template {string} [DefaultTagName='div']
 *   Type of default tag name (default: `'div'`).
 * @param {Selector | null | undefined} [selector]
 *   Simple CSS selector (optional).
 *
 *   Can contain a tag name (`foo`), classes (`.bar`), and an ID (`#baz`).
 *   Multiple classes are allowed.
 *   Uses the last ID if multiple IDs are found.
 * @param {DefaultTagName | null | undefined} [defaultTagName='div']
 *   Tag name to use if `selector` does not specify one (default: `'div'`).
 * @returns {Element & {tagName: ExtractTagName<Selector, DefaultTagName>}}
 *   Built element.
 */
function parseSelector(selector, defaultTagName) {
  var value = selector || '';
  /** @type {Properties} */
  var props = {};
  var start = 0;
  /** @type {string | undefined} */
  var previous;
  /** @type {string | undefined} */
  var tagName;
  while (start < value.length) {
    search.lastIndex = start;
    var match = search.exec(value);
    var subvalue = value.slice(start, match ? match.index : value.length);
    if (subvalue) {
      if (!previous) {
        tagName = subvalue;
      } else if (previous === '#') {
        props.id = subvalue;
      } else if (Array.isArray(props.className)) {
        props.className.push(subvalue);
      } else {
        props.className = [subvalue];
      }
      start += subvalue.length;
    }
    if (match) {
      previous = match[0];
      start++;
    }
  }
  return {
    type: 'element',
    // @ts-expect-error: tag name is parsed.
    tagName: tagName || defaultTagName || 'div',
    properties: props,
    children: []
  };
}

/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function parse(value) {
  var input = String(value || '').trim();
  return input ? input.split(/[ \t\n\r\f]+/g) : [];
}

/**
 * Serialize an array of strings as space separated-tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @returns {string}
 *   Space-separated tokens.
 */
function stringify(values) {
  return values.join(' ').trim();
}

/**
 * @param {Schema} schema
 *   Schema to use.
 * @param {string} defaultTagName
 *   Default tag name.
 * @param {ReadonlyArray<string> | undefined} [caseSensitive]
 *   Case-sensitive tag names (default: `undefined`).
 * @returns
 *   `h`.
 */
function createH(schema, defaultTagName, caseSensitive) {
  var adjust = caseSensitive ? createAdjustMap(caseSensitive) : undefined;

  /**
   * Hyperscript compatible DSL for creating virtual hast trees.
   *
   * @overload
   * @param {null | undefined} [selector]
   * @param {...Child} children
   * @returns {Root}
   *
   * @overload
   * @param {string} selector
   * @param {Properties} properties
   * @param {...Child} children
   * @returns {Element}
   *
   * @overload
   * @param {string} selector
   * @param {...Child} children
   * @returns {Element}
   *
   * @param {string | null | undefined} [selector]
   *   Selector.
   * @param {Child | Properties | null | undefined} [properties]
   *   Properties (or first child) (default: `undefined`).
   * @param {...Child} children
   *   Children.
   * @returns {Result}
   *   Result.
   */
  function h(selector, properties) {
    /** @type {Result} */
    var node;
    for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      children[_key - 2] = arguments[_key];
    }
    if (selector === null || selector === undefined) {
      node = {
        type: 'root',
        children: []
      };
      // Properties are not supported for roots.
      var child = /** @type {Child} */properties;
      children.unshift(child);
    } else {
      node = parseSelector(selector, defaultTagName);
      // Normalize the name.
      var lower = node.tagName.toLowerCase();
      var adjusted = adjust ? adjust.get(lower) : undefined;
      node.tagName = adjusted || lower;

      // Handle properties.
      if (isChild(properties)) {
        children.unshift(properties);
      } else {
        for (var _i = 0, _Object$entries = Object.entries(properties); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          addProperty(schema, node.properties, key, value);
        }
      }
    }

    // Handle children.
    for (var _i2 = 0, _children = children; _i2 < _children.length; _i2++) {
      var _child = _children[_i2];
      addChild(node.children, _child);
    }
    if (node.type === 'element' && node.tagName === 'template') {
      node.content = {
        type: 'root',
        children: node.children
      };
      node.children = [];
    }
    return node;
  }
  return h;
}

/**
 * Check if something is properties or a child.
 *
 * @param {Child | Properties} value
 *   Value to check.
 * @returns {value is Child}
 *   Whether `value` is definitely a child.
 */
function isChild(value) {
  // Never properties if not an object.
  if (value === null || _typeof$1(value) !== 'object' || Array.isArray(value)) {
    return true;
  }

  // Never node without `type`; that’s the main discriminator.
  if (typeof value.type !== 'string') return false;

  // Slower check: never property value if object or array with
  // non-number/strings.
  var record = /** @type {Record<string, unknown>} */value;
  var keys = Object.keys(value);
  for (var _i3 = 0, _keys = keys; _i3 < _keys.length; _i3++) {
    var key = _keys[_i3];
    var _value = record[key];
    if (_value && _typeof$1(_value) === 'object') {
      if (!Array.isArray(_value)) return true;
      var list = /** @type {ReadonlyArray<unknown>} */_value;
      var _iterator = _createForOfIteratorHelper(list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (typeof item !== 'number' && typeof item !== 'string') {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }

  // Also see empty `children` as a node.
  if ('children' in value && Array.isArray(value.children)) {
    return true;
  }

  // Default to properties, someone can always pass an empty object,
  // put `data: {}` in a node,
  // or wrap it in an array.
  return false;
}

/**
 * @param {Schema} schema
 *   Schema.
 * @param {Properties} properties
 *   Properties object.
 * @param {string} key
 *   Property name.
 * @param {PropertyValue | Style} value
 *   Property value.
 * @returns {undefined}
 *   Nothing.
 */
function addProperty(schema, properties, key, value) {
  var info = find$2(schema, key);
  /** @type {PropertyValue} */
  var result;

  // Ignore nullish and NaN values.
  if (value === null || value === undefined) return;
  if (typeof value === 'number') {
    // Ignore NaN.
    if (Number.isNaN(value)) return;
    result = value;
  }
  // Booleans.
  else if (typeof value === 'boolean') {
    result = value;
  }
  // Handle list values.
  else if (typeof value === 'string') {
    if (info.spaceSeparated) {
      result = parse(value);
    } else if (info.commaSeparated) {
      result = parse$1(value);
    } else if (info.commaOrSpaceSeparated) {
      result = parse(parse$1(value).join(' '));
    } else {
      result = parsePrimitive(info, info.property, value);
    }
  } else if (Array.isArray(value)) {
    result = _toConsumableArray(value);
  } else {
    result = info.property === 'style' ? style(value) : String(value);
  }
  if (Array.isArray(result)) {
    /** @type {Array<number | string>} */
    var finalResult = [];
    var _iterator2 = _createForOfIteratorHelper(result),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        // Assume no booleans in array.
        finalResult.push(/** @type {number | string} */
        parsePrimitive(info, info.property, item));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    result = finalResult;
  }

  // Class names (which can be added both on the `selector` and here).
  if (info.property === 'className' && Array.isArray(properties.className)) {
    // Assume no booleans in `className`.
    result = properties.className.concat(/** @type {Array<number | string> | number | string} */result);
  }
  properties[info.property] = result;
}

/**
 * @param {Array<RootContent>} nodes
 *   Children.
 * @param {Child} value
 *   Child.
 * @returns {undefined}
 *   Nothing.
 */
function addChild(nodes, value) {
  if (value === null || value === undefined) ; else if (typeof value === 'number' || typeof value === 'string') {
    nodes.push({
      type: 'text',
      value: String(value)
    });
  } else if (Array.isArray(value)) {
    var _iterator3 = _createForOfIteratorHelper(value),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var child = _step3.value;
        addChild(nodes, child);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  } else if (_typeof$1(value) === 'object' && 'type' in value) {
    if (value.type === 'root') {
      addChild(nodes, value.children);
    } else {
      nodes.push(value);
    }
  } else {
    throw new Error('Expected node, nodes, or string, got `' + value + '`');
  }
}

/**
 * Parse a single primitives.
 *
 * @param {Info} info
 *   Property information.
 * @param {string} name
 *   Property name.
 * @param {PrimitiveValue} value
 *   Property value.
 * @returns {PrimitiveValue}
 *   Property value.
 */
function parsePrimitive(info, name, value) {
  if (typeof value === 'string') {
    if (info.number && value && !Number.isNaN(Number(value))) {
      return Number(value);
    }
    if ((info["boolean"] || info.overloadedBoolean) && (value === '' || normalize$2(value) === normalize$2(name))) {
      return true;
    }
  }
  return value;
}

/**
 * Serialize a `style` object as a string.
 *
 * @param {Style} styles
 *   Style object.
 * @returns {string}
 *   CSS string.
 */
function style(styles) {
  /** @type {Array<string>} */
  var result = [];
  for (var _i4 = 0, _Object$entries2 = Object.entries(styles); _i4 < _Object$entries2.length; _i4++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i4], 2),
      key = _Object$entries2$_i[0],
      value = _Object$entries2$_i[1];
    result.push([key, value].join(': '));
  }
  return result.join('; ');
}

/**
 * Create a map to adjust casing.
 *
 * @param {ReadonlyArray<string>} values
 *   List of properly cased keys.
 * @returns {Map<string, string>}
 *   Map of lowercase keys to uppercase keys.
 */
function createAdjustMap(values) {
  /** @type {Map<string, string>} */
  var result = new Map();
  var _iterator4 = _createForOfIteratorHelper(values),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var value = _step4.value;
      result.set(value.toLowerCase(), value);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return result;
}

/**
 * List of case-sensitive SVG tag names.
 *
 * @type {ReadonlyArray<string>}
 */
var svgCaseSensitiveTagNames = ['altGlyph', 'altGlyphDef', 'altGlyphItem', 'animateColor', 'animateMotion', 'animateTransform', 'clipPath', 'feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'foreignObject', 'glyphRef', 'linearGradient', 'radialGradient', 'solidColor', 'textArea', 'textPath'];

// Register the JSX namespace on `h`.
/**
 * @typedef {import('./jsx-classic.js').Element} h.JSX.Element
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} h.JSX.ElementChildrenAttribute
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} h.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} h.JSX.IntrinsicElements
 */


// Note: this explicit type is needed, otherwise TS creates broken types.
/** @type {ReturnType<createH>} */
var h = createH(html$4, 'div');

// Note: this explicit type is needed, otherwise TS creates broken types.
/** @type {ReturnType<createH>} */
var s$1 = createH(svg$4, 'g', svgCaseSensitiveTagNames);

/**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */

/** @type {SchemaType} */
var Schema$1 = /*#__PURE__*/_createClass$1(
/**
 * @param {SchemaType['property']} property
 *   Property.
 * @param {SchemaType['normal']} normal
 *   Normal.
 * @param {Space | undefined} [space]
 *   Space.
 * @returns
 *   Schema.
 */
function Schema(property, normal, space) {
  _classCallCheck$1(this, Schema);
  this.normal = normal;
  this.property = property;
  if (space) {
    this.space = space;
  }
});
Schema$1.prototype.normal = {};
Schema$1.prototype.property = {};
Schema$1.prototype.space = undefined;

/**
 * @param {ReadonlyArray<Schema>} definitions
 *   Definitions.
 * @param {Space | undefined} [space]
 *   Space.
 * @returns {Schema}
 *   Schema.
 */
function merge$1(definitions, space) {
  /** @type {Record<string, Info>} */
  var property = {};
  /** @type {Record<string, string>} */
  var normal = {};
  var _iterator = _createForOfIteratorHelper(definitions),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var definition = _step.value;
      Object.assign(property, definition.property);
      Object.assign(normal, definition.normal);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return new Schema$1(property, normal, space);
}

/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */
function normalize$1(value) {
  return value.toLowerCase();
}

/**
 * @import {Info as InfoType} from 'property-information'
 */

/** @type {InfoType} */
var Info$2 = /*#__PURE__*/_createClass$1(
/**
 * @param {string} property
 *   Property.
 * @param {string} attribute
 *   Attribute.
 * @returns
 *   Info.
 */
function Info(property, attribute) {
  _classCallCheck$1(this, Info);
  this.attribute = attribute;
  this.property = property;
});
Info$2.prototype.attribute = '';
Info$2.prototype.booleanish = false;
Info$2.prototype["boolean"] = false;
Info$2.prototype.commaOrSpaceSeparated = false;
Info$2.prototype.commaSeparated = false;
Info$2.prototype.defined = false;
Info$2.prototype.mustUseProperty = false;
Info$2.prototype.number = false;
Info$2.prototype.overloadedBoolean = false;
Info$2.prototype.property = '';
Info$2.prototype.spaceSeparated = false;
Info$2.prototype.space = undefined;

var powers$1 = 0;
var _boolean$1 = increment$1();
var booleanish$1 = increment$1();
var overloadedBoolean$1 = increment$1();
var number$1 = increment$1();
var spaceSeparated$1 = increment$1();
var commaSeparated$1 = increment$1();
var commaOrSpaceSeparated$1 = increment$1();
function increment$1() {
  return Math.pow(2, ++powers$1);
}

var types$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  boolean: _boolean$1,
  booleanish: booleanish$1,
  commaOrSpaceSeparated: commaOrSpaceSeparated$1,
  commaSeparated: commaSeparated$1,
  number: number$1,
  overloadedBoolean: overloadedBoolean$1,
  spaceSeparated: spaceSeparated$1
});

var checks$1 = /** @type {ReadonlyArray<keyof typeof types>} */
Object.keys(types$1);
var DefinedInfo$1 = /*#__PURE__*/function (_Info) {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  function DefinedInfo(property, attribute, mask, space) {
    var _this;
    _classCallCheck$1(this, DefinedInfo);
    var index = -1;
    _this = _callSuper(this, DefinedInfo, [property, attribute]);
    mark$1(_this, 'space', space);
    if (typeof mask === 'number') {
      while (++index < checks$1.length) {
        var check = checks$1[index];
        mark$1(_this, checks$1[index], (mask & types$1[check]) === types$1[check]);
      }
    }
    return _this;
  }
  _inherits$1(DefinedInfo, _Info);
  return _createClass$1(DefinedInfo);
}(Info$2);
DefinedInfo$1.prototype.defined = true;

/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */
function mark$1(values, key, value) {
  if (value) {
    values[key] = value;
  }
}

/**
 * @param {Definition} definition
 *   Definition.
 * @returns {Schema}
 *   Schema.
 */
function create$1(definition) {
  /** @type {Record<string, Info>} */
  var properties = {};
  /** @type {Record<string, string>} */
  var normals = {};
  for (var _i = 0, _Object$entries = Object.entries(definition.properties); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      property = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    var info = new DefinedInfo$1(property, definition.transform(definition.attributes || {}, property), value, definition.space);
    if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) {
      info.mustUseProperty = true;
    }
    properties[property] = info;
    normals[normalize$1(property)] = property;
    normals[normalize$1(info.attribute)] = property;
  }
  return new Schema$1(properties, normals, definition.space);
}

var aria$1 = create$1({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish$1,
    ariaAutoComplete: null,
    ariaBusy: booleanish$1,
    ariaChecked: booleanish$1,
    ariaColCount: number$1,
    ariaColIndex: number$1,
    ariaColSpan: number$1,
    ariaControls: spaceSeparated$1,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated$1,
    ariaDetails: null,
    ariaDisabled: booleanish$1,
    ariaDropEffect: spaceSeparated$1,
    ariaErrorMessage: null,
    ariaExpanded: booleanish$1,
    ariaFlowTo: spaceSeparated$1,
    ariaGrabbed: booleanish$1,
    ariaHasPopup: null,
    ariaHidden: booleanish$1,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated$1,
    ariaLevel: number$1,
    ariaLive: null,
    ariaModal: booleanish$1,
    ariaMultiLine: booleanish$1,
    ariaMultiSelectable: booleanish$1,
    ariaOrientation: null,
    ariaOwns: spaceSeparated$1,
    ariaPlaceholder: null,
    ariaPosInSet: number$1,
    ariaPressed: booleanish$1,
    ariaReadOnly: booleanish$1,
    ariaRelevant: null,
    ariaRequired: booleanish$1,
    ariaRoleDescription: spaceSeparated$1,
    ariaRowCount: number$1,
    ariaRowIndex: number$1,
    ariaRowSpan: number$1,
    ariaSelected: booleanish$1,
    ariaSetSize: number$1,
    ariaSort: null,
    ariaValueMax: number$1,
    ariaValueMin: number$1,
    ariaValueNow: number$1,
    ariaValueText: null,
    role: null
  },
  transform: function transform(_, property) {
    return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
  }
});

/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */
function caseSensitiveTransform$1(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute;
}

/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Transformed property.
 */
function caseInsensitiveTransform$1(attributes, property) {
  return caseSensitiveTransform$1(attributes, property.toLowerCase());
}

var html$3 = create$1({
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated$1,
    acceptCharset: spaceSeparated$1,
    accessKey: spaceSeparated$1,
    action: null,
    allow: null,
    allowFullScreen: _boolean$1,
    allowPaymentRequest: _boolean$1,
    allowUserMedia: _boolean$1,
    alt: null,
    as: null,
    async: _boolean$1,
    autoCapitalize: null,
    autoComplete: spaceSeparated$1,
    autoFocus: _boolean$1,
    autoPlay: _boolean$1,
    blocking: spaceSeparated$1,
    capture: null,
    charSet: null,
    checked: _boolean$1,
    cite: null,
    className: spaceSeparated$1,
    cols: number$1,
    colSpan: null,
    content: null,
    contentEditable: booleanish$1,
    controls: _boolean$1,
    controlsList: spaceSeparated$1,
    coords: number$1 | commaSeparated$1,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    "default": _boolean$1,
    defer: _boolean$1,
    dir: null,
    dirName: null,
    disabled: _boolean$1,
    download: overloadedBoolean$1,
    draggable: booleanish$1,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: _boolean$1,
    formTarget: null,
    headers: spaceSeparated$1,
    height: number$1,
    hidden: overloadedBoolean$1,
    high: number$1,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated$1,
    httpEquiv: spaceSeparated$1,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: _boolean$1,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: _boolean$1,
    itemId: null,
    itemProp: spaceSeparated$1,
    itemRef: spaceSeparated$1,
    itemScope: _boolean$1,
    itemType: spaceSeparated$1,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: _boolean$1,
    low: number$1,
    manifest: null,
    max: null,
    maxLength: number$1,
    media: null,
    method: null,
    min: null,
    minLength: number$1,
    multiple: _boolean$1,
    muted: _boolean$1,
    name: null,
    nonce: null,
    noModule: _boolean$1,
    noValidate: _boolean$1,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: _boolean$1,
    optimum: number$1,
    pattern: null,
    ping: spaceSeparated$1,
    placeholder: null,
    playsInline: _boolean$1,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: _boolean$1,
    referrerPolicy: null,
    rel: spaceSeparated$1,
    required: _boolean$1,
    reversed: _boolean$1,
    rows: number$1,
    rowSpan: number$1,
    sandbox: spaceSeparated$1,
    scope: null,
    scoped: _boolean$1,
    seamless: _boolean$1,
    selected: _boolean$1,
    shadowRootClonable: _boolean$1,
    shadowRootDelegatesFocus: _boolean$1,
    shadowRootMode: null,
    shape: null,
    size: number$1,
    sizes: null,
    slot: null,
    span: number$1,
    spellCheck: booleanish$1,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number$1,
    step: null,
    style: null,
    tabIndex: number$1,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: _boolean$1,
    useMap: null,
    value: booleanish$1,
    width: number$1,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated$1,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number$1,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number$1,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    "char": null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: _boolean$1,
    // Lists. Use CSS to reduce space between items instead
    declare: _boolean$1,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number$1,
    // `<img>` and `<object>`
    leftMargin: number$1,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number$1,
    // `<body>`
    marginWidth: number$1,
    // `<body>`
    noResize: _boolean$1,
    // `<frame>`
    noHref: _boolean$1,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: _boolean$1,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: _boolean$1,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number$1,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish$1,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number$1,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number$1,
    // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: _boolean$1,
    disableRemotePlayback: _boolean$1,
    prefix: null,
    property: null,
    results: number$1,
    security: null,
    unselectable: null
  },
  space: 'html',
  transform: caseInsensitiveTransform$1
});

var svg$3 = create$1({
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    transformOrigin: 'transform-origin',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  properties: {
    about: commaOrSpaceSeparated$1,
    accentHeight: number$1,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number$1,
    amplitude: number$1,
    arabicForm: null,
    ascent: number$1,
    attributeName: null,
    attributeType: null,
    azimuth: number$1,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number$1,
    by: null,
    calcMode: null,
    capHeight: number$1,
    className: spaceSeparated$1,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number$1,
    diffuseConstant: number$1,
    direction: null,
    display: null,
    dur: null,
    divisor: number$1,
    dominantBaseline: null,
    download: _boolean$1,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number$1,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number$1,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number$1,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated$1,
    g2: commaSeparated$1,
    glyphName: commaSeparated$1,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number$1,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number$1,
    horizOriginX: number$1,
    horizOriginY: number$1,
    id: null,
    ideographic: number$1,
    imageRendering: null,
    initialVisibility: null,
    "in": null,
    in2: null,
    intercept: number$1,
    k: number$1,
    k1: number$1,
    k2: number$1,
    k3: number$1,
    k4: number$1,
    kernelMatrix: commaOrSpaceSeparated$1,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number$1,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number$1,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number$1,
    overlineThickness: number$1,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number$1,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated$1,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number$1,
    pointsAtY: number$1,
    pointsAtZ: number$1,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated$1,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated$1,
    rev: commaOrSpaceSeparated$1,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated$1,
    requiredFeatures: commaOrSpaceSeparated$1,
    requiredFonts: commaOrSpaceSeparated$1,
    requiredFormats: commaOrSpaceSeparated$1,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number$1,
    specularExponent: number$1,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number$1,
    strikethroughThickness: number$1,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated$1,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number$1,
    strokeOpacity: number$1,
    strokeWidth: null,
    style: null,
    surfaceScale: number$1,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated$1,
    tabIndex: number$1,
    tableValues: null,
    target: null,
    targetX: number$1,
    targetY: number$1,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated$1,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number$1,
    underlineThickness: number$1,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number$1,
    values: null,
    vAlphabetic: number$1,
    vMathematical: number$1,
    vectorEffect: null,
    vHanging: number$1,
    vIdeographic: number$1,
    version: null,
    vertAdvY: number$1,
    vertOriginX: number$1,
    vertOriginY: number$1,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number$1,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: 'svg',
  transform: caseSensitiveTransform$1
});

var xlink$1 = create$1({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: 'xlink',
  transform: function transform(_, property) {
    return 'xlink:' + property.slice(5).toLowerCase();
  }
});

var xmlns$1 = create$1({
  attributes: {
    xmlnsxlink: 'xmlns:xlink'
  },
  properties: {
    xmlnsXLink: null,
    xmlns: null
  },
  space: 'xmlns',
  transform: caseInsensitiveTransform$1
});

var xml$1 = create$1({
  properties: {
    xmlBase: null,
    xmlLang: null,
    xmlSpace: null
  },
  space: 'xml',
  transform: function transform(_, property) {
    return 'xml:' + property.slice(3).toLowerCase();
  }
});

/**
 * @import {Schema} from 'property-information'
 */

var cap$1 = /[A-Z]/g;
var dash$1 = /-[a-z]/g;
var valid$1 = /^data[-\w.:]+$/i;

/**
 * Look up info on a property.
 *
 * In most cases the given `schema` contains info on the property.
 * All standard,
 * most legacy,
 * and some non-standard properties are supported.
 * For these cases,
 * the returned `Info` has hints about the value of the property.
 *
 * `name` can also be a valid data attribute or property,
 * in which case an `Info` object with the correctly cased `attribute` and
 * `property` is returned.
 *
 * `name` can be an unknown attribute,
 * in which case an `Info` object with `attribute` and `property` set to the
 * given name is returned.
 * It is not recommended to provide unsupported legacy or recently specced
 * properties.
 *
 *
 * @param {Schema} schema
 *   Schema;
 *   either the `html` or `svg` export.
 * @param {string} value
 *   An attribute-like or property-like name;
 *   it will be passed through `normalize` to hopefully find the correct info.
 * @returns {Info}
 *   Info.
 */
function find$1(schema, value) {
  var normal = normalize$1(value);
  var property = value;
  var Type = Info$2;
  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]];
  }
  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid$1.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      var rest = value.slice(5).replace(dash$1, camelcase$1);
      property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      // Turn it into an attribute.
      var _rest = value.slice(4);
      if (!dash$1.test(_rest)) {
        var dashes = _rest.replace(cap$1, kebab$1);
        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes;
        }
        value = 'data' + dashes;
      }
    }
    Type = DefinedInfo$1;
  }
  return new Type(property, value);
}

/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */
function kebab$1($0) {
  return '-' + $0.toLowerCase();
}

/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */
function camelcase$1($0) {
  return $0.charAt(1).toUpperCase();
}

// Note: types exposed from `index.d.ts`.
var html$2 = merge$1([aria$1, html$3, xlink$1, xmlns$1, xml$1], 'html');
var svg$2 = merge$1([aria$1, svg$3, xlink$1, xmlns$1, xml$1], 'svg');

/**
 * @import {VFile, Value} from 'vfile'
 * @import {Location} from 'vfile-location'
 */

/**
 * Create an index of the given document to translate between line/column and
 * offset based positional info.
 *
 * Also implemented in Rust in [`wooorm/markdown-rs`][markdown-rs].
 *
 * [markdown-rs]: https://github.com/wooorm/markdown-rs/blob/main/src/util/location.rs
 *
 * @param {VFile | Value} file
 *   File to index.
 * @returns {Location}
 *   Accessors for index.
 */
function location(file) {
  var value = String(file);
  /**
   * List, where each index is a line number (0-based), and each value is the
   * byte index *after* where the line ends.
   *
   * @type {Array<number>}
   */
  var indices = [];
  return {
    toOffset: toOffset,
    toPoint: toPoint
  };

  /** @type {Location['toPoint']} */
  function toPoint(offset) {
    if (typeof offset === 'number' && offset > -1 && offset <= value.length) {
      var index = 0;
      while (true) {
        var end = indices[index];
        if (end === undefined) {
          var eol = next(value, indices[index - 1]);
          end = eol === -1 ? value.length + 1 : eol + 1;
          indices[index] = end;
        }
        if (end > offset) {
          return {
            line: index + 1,
            column: offset - (index > 0 ? indices[index - 1] : 0) + 1,
            offset: offset
          };
        }
        index++;
      }
    }
  }

  /** @type {Location['toOffset']} */
  function toOffset(point) {
    if (point && typeof point.line === 'number' && typeof point.column === 'number' && !Number.isNaN(point.line) && !Number.isNaN(point.column)) {
      while (indices.length < point.line) {
        var from = indices[indices.length - 1];
        var eol = next(value, from);
        var end = eol === -1 ? value.length + 1 : eol + 1;
        if (from === end) break;
        indices.push(end);
      }
      var offset = (point.line > 1 ? indices[point.line - 2] : 0) + point.column - 1;
      // The given `column` could not exist on this line.
      if (offset < indices[point.line - 1]) return offset;
    }
  }
}

/**
 * @param {string} value
 * @param {number} from
 */
function next(value, from) {
  var cr = value.indexOf('\r', from);
  var lf = value.indexOf('\n', from);
  if (lf === -1) return cr;
  if (cr === -1 || cr + 1 === lf) return lf;
  return cr < lf ? cr : lf;
}

/**
 * Map of web namespaces.
 *
 * @type {Record<string, string>}
 */
var webNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg',
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace',
  xmlns: 'http://www.w3.org/2000/xmlns/'
};

/**
 * @import {ElementData, Element, Nodes, RootContent, Root} from 'hast'
 * @import {DefaultTreeAdapterMap, Token} from 'parse5'
 * @import {Schema} from 'property-information'
 * @import {Point, Position} from 'unist'
 * @import {VFile} from 'vfile'
 * @import {Options} from 'hast-util-from-parse5'
 */

var own$3 = {}.hasOwnProperty;
/** @type {unknown} */
// type-coverage:ignore-next-line
var proto = Object.prototype;

/**
 * Transform a `parse5` AST to hast.
 *
 * @param {DefaultTreeAdapterMap['node']} tree
 *   `parse5` tree to transform.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {Nodes}
 *   hast tree.
 */
function fromParse5(tree, options) {
  var settings = options || {};
  return one$1({
    file: settings.file || undefined,
    location: false,
    schema: settings.space === 'svg' ? svg$2 : html$2,
    verbose: settings.verbose || false
  }, tree);
}

/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['node']} node
 *   p5 node.
 * @returns {Nodes}
 *   hast node.
 */
function one$1(state, node) {
  /** @type {Nodes} */
  var result;
  switch (node.nodeName) {
    case '#comment':
      {
        var reference = /** @type {DefaultTreeAdapterMap['commentNode']} */
        node;
        result = {
          type: 'comment',
          value: reference.data
        };
        patch$1(state, reference, result);
        return result;
      }
    case '#document':
    case '#document-fragment':
      {
        var _reference = /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */
        node;
        var quirksMode = 'mode' in _reference ? _reference.mode === 'quirks' || _reference.mode === 'limited-quirks' : false;
        result = {
          type: 'root',
          children: all$2(state, node.childNodes),
          data: {
            quirksMode: quirksMode
          }
        };
        if (state.file && state.location) {
          var document = String(state.file);
          var loc = location(document);
          var start = loc.toPoint(0);
          var end = loc.toPoint(document.length);
          result.position = {
            start: start,
            end: end
          };
        }
        return result;
      }
    case '#documentType':
      {
        var _reference2 = /** @type {DefaultTreeAdapterMap['documentType']} */
        node;
        result = {
          type: 'doctype'
        };
        patch$1(state, _reference2, result);
        return result;
      }
    case '#text':
      {
        var _reference3 = /** @type {DefaultTreeAdapterMap['textNode']} */node;
        result = {
          type: 'text',
          value: _reference3.value
        };
        patch$1(state, _reference3, result);
        return result;
      }

    // Element.
    default:
      {
        var _reference4 = /** @type {DefaultTreeAdapterMap['element']} */node;
        result = element$2(state, _reference4);
        return result;
      }
  }
}

/**
 * Transform children.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Array<DefaultTreeAdapterMap['node']>} nodes
 *   Nodes.
 * @returns {Array<RootContent>}
 *   hast nodes.
 */
function all$2(state, nodes) {
  var index = -1;
  /** @type {Array<RootContent>} */
  var results = [];
  while (++index < nodes.length) {
    // Assume no roots in `nodes`.
    var result = /** @type {RootContent} */one$1(state, nodes[index]);
    results.push(result);
  }
  return results;
}

/**
 * Transform an element.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['element']} node
 *   `parse5` node to transform.
 * @returns {Element}
 *   hast node.
 */
function element$2(state, node) {
  var schema = state.schema;
  state.schema = node.namespaceURI === webNamespaces.svg ? svg$2 : html$2;

  // Props.
  var index = -1;
  /** @type {Record<string, string>} */
  var properties = {};
  while (++index < node.attrs.length) {
    var attribute = node.attrs[index];
    var name = (attribute.prefix ? attribute.prefix + ':' : '') + attribute.name;
    if (!own$3.call(proto, name)) {
      properties[name] = attribute.value;
    }
  }

  // Build.
  var x = state.schema.space === 'svg' ? s$1 : h;
  var result = x(node.tagName, properties, all$2(state, node.childNodes));
  patch$1(state, node, result);

  // Switch content.
  if (result.tagName === 'template') {
    var reference = /** @type {DefaultTreeAdapterMap['template']} */node;
    var pos = reference.sourceCodeLocation;
    var startTag = pos && pos.startTag && position(pos.startTag);
    var endTag = pos && pos.endTag && position(pos.endTag);

    // Root in, root out.
    var content = /** @type {Root} */one$1(state, reference.content);
    if (startTag && endTag && state.file) {
      content.position = {
        start: startTag.end,
        end: endTag.start
      };
    }
    result.content = content;
  }
  state.schema = schema;
  return result;
}

/**
 * Patch positional info from `from` onto `to`.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['node']} from
 *   p5 node.
 * @param {Nodes} to
 *   hast node.
 * @returns {undefined}
 *   Nothing.
 */
function patch$1(state, from, to) {
  if ('sourceCodeLocation' in from && from.sourceCodeLocation && state.file) {
    var _position = createLocation(state, to, from.sourceCodeLocation);
    if (_position) {
      state.location = true;
      to.position = _position;
    }
  }
}

/**
 * Create clean positional information.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Nodes} node
 *   hast node.
 * @param {Token.ElementLocation} location
 *   p5 location info.
 * @returns {Position | undefined}
 *   Position, or nothing.
 */
function createLocation(state, node, location) {
  var result = position(location);
  if (node.type === 'element') {
    var tail = node.children[node.children.length - 1];

    // Bug for unclosed with children.
    // See: <https://github.com/inikulin/parse5/issues/109>.
    if (result && !location.endTag && tail && tail.position && tail.position.end) {
      result.end = Object.assign({}, tail.position.end);
    }
    if (state.verbose) {
      /** @type {Record<string, Position | undefined>} */
      var properties = {};
      /** @type {string} */
      var key;
      if (location.attrs) {
        for (key in location.attrs) {
          if (own$3.call(location.attrs, key)) {
            properties[find$1(state.schema, key).property] = position(location.attrs[key]);
          }
        }
      }
      ok$1(location.startTag);
      var opening = position(location.startTag);
      var closing = location.endTag ? position(location.endTag) : undefined;
      /** @type {ElementData['position']} */
      var data = {
        opening: opening
      };
      if (closing) data.closing = closing;
      data.properties = properties;
      node.data = {
        position: data
      };
    }
  }
  return result;
}

/**
 * Turn a p5 location into a position.
 *
 * @param {Token.Location} loc
 *   Location.
 * @returns {Position | undefined}
 *   Position or nothing.
 */
function position(loc) {
  var start = point$1({
    line: loc.startLine,
    column: loc.startCol,
    offset: loc.startOffset
  });
  var end = point$1({
    line: loc.endLine,
    column: loc.endCol,
    offset: loc.endOffset
  });

  // @ts-expect-error: we do use `undefined` for points if one or the other
  // exists.
  return start || end ? {
    start: start,
    end: end
  } : undefined;
}

/**
 * Filter out invalid points.
 *
 * @param {Point} point
 *   Point with potentially `undefined` values.
 * @returns {Point | undefined}
 *   Point or nothing.
 */
function point$1(point) {
  return point.line && point.column ? point : undefined;
}

/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */

var Schema = /*#__PURE__*/_createClass$1(
/**
 * @constructor
 * @param {Properties} property
 * @param {Normal} normal
 * @param {string} [space]
 */
function Schema(property, normal, space) {
  _classCallCheck$1(this, Schema);
  this.property = property;
  this.normal = normal;
  if (space) {
    this.space = space;
  }
});

/** @type {Properties} */
Schema.prototype.property = {};
/** @type {Normal} */
Schema.prototype.normal = {};
/** @type {string|null} */
Schema.prototype.space = null;

/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */


/**
 * @param {Schema[]} definitions
 * @param {string} [space]
 * @returns {Schema}
 */
function merge(definitions, space) {
  /** @type {Properties} */
  var property = {};
  /** @type {Normal} */
  var normal = {};
  var index = -1;
  while (++index < definitions.length) {
    Object.assign(property, definitions[index].property);
    Object.assign(normal, definitions[index].normal);
  }
  return new Schema(property, normal, space);
}

/**
 * @param {string} value
 * @returns {string}
 */
function normalize(value) {
  return value.toLowerCase();
}

var Info$1 = /*#__PURE__*/_createClass$1(
/**
 * @constructor
 * @param {string} property
 * @param {string} attribute
 */
function Info(property, attribute) {
  _classCallCheck$1(this, Info);
  /** @type {string} */
  this.property = property;
  /** @type {string} */
  this.attribute = attribute;
});

/** @type {string|null} */
Info$1.prototype.space = null;
Info$1.prototype["boolean"] = false;
Info$1.prototype.booleanish = false;
Info$1.prototype.overloadedBoolean = false;
Info$1.prototype.number = false;
Info$1.prototype.commaSeparated = false;
Info$1.prototype.spaceSeparated = false;
Info$1.prototype.commaOrSpaceSeparated = false;
Info$1.prototype.mustUseProperty = false;
Info$1.prototype.defined = false;

var powers = 0;
var _boolean = increment();
var booleanish = increment();
var overloadedBoolean = increment();
var number = increment();
var spaceSeparated = increment();
var commaSeparated = increment();
var commaOrSpaceSeparated = increment();
function increment() {
  return Math.pow(2, ++powers);
}

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  boolean: _boolean,
  booleanish: booleanish,
  commaOrSpaceSeparated: commaOrSpaceSeparated,
  commaSeparated: commaSeparated,
  number: number,
  overloadedBoolean: overloadedBoolean,
  spaceSeparated: spaceSeparated
});

/** @type {Array<keyof types>} */
// @ts-expect-error: hush.
var checks = Object.keys(types);
var DefinedInfo = /*#__PURE__*/function (_Info) {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  function DefinedInfo(property, attribute, mask, space) {
    var _this;
    _classCallCheck$1(this, DefinedInfo);
    var index = -1;
    _this = _callSuper(this, DefinedInfo, [property, attribute]);
    mark(_this, 'space', space);
    if (typeof mask === 'number') {
      while (++index < checks.length) {
        var check = checks[index];
        mark(_this, checks[index], (mask & types[check]) === types[check]);
      }
    }
    return _this;
  }
  _inherits$1(DefinedInfo, _Info);
  return _createClass$1(DefinedInfo);
}(Info$1);
DefinedInfo.prototype.defined = true;

/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */
function mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
  }
}

/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */

var own$2 = {}.hasOwnProperty;

/**
 * @param {Definition} definition
 * @returns {Schema}
 */
function create(definition) {
  /** @type {Properties} */
  var property = {};
  /** @type {Normal} */
  var normal = {};
  /** @type {string} */
  var prop;
  for (prop in definition.properties) {
    if (own$2.call(definition.properties, prop)) {
      var value = definition.properties[prop];
      var info = new DefinedInfo(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
      if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) {
        info.mustUseProperty = true;
      }
      property[prop] = info;
      normal[normalize(prop)] = prop;
      normal[normalize(info.attribute)] = prop;
    }
  }
  return new Schema(property, normal, definition.space);
}

var xlink = create({
  space: 'xlink',
  transform: function transform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});

var xml = create({
  space: 'xml',
  transform: function transform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase();
  },
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
});

/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute;
}

/**
 * @param {Record<string, string>} attributes
 * @param {string} property
 * @returns {string}
 */
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase());
}

var xmlns = create({
  space: 'xmlns',
  attributes: {
    xmlnsxlink: 'xmlns:xlink'
  },
  transform: caseInsensitiveTransform,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
});

var aria = create({
  transform: function transform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
});

var html$1 = create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: _boolean,
    allowPaymentRequest: _boolean,
    allowUserMedia: _boolean,
    alt: null,
    as: null,
    async: _boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: _boolean,
    autoPlay: _boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: _boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: _boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    "default": _boolean,
    defer: _boolean,
    dir: null,
    dirName: null,
    disabled: _boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: _boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: _boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: _boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: _boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: _boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: _boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: _boolean,
    muted: _boolean,
    name: null,
    nonce: null,
    noModule: _boolean,
    noValidate: _boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: _boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: _boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: _boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: _boolean,
    reversed: _boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: _boolean,
    seamless: _boolean,
    selected: _boolean,
    shadowRootClonable: _boolean,
    shadowRootDelegatesFocus: _boolean,
    shadowRootMode: null,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: _boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    "char": null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: _boolean,
    // Lists. Use CSS to reduce space between items instead
    declare: _boolean,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number,
    // `<img>` and `<object>`
    leftMargin: number,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number,
    // `<body>`
    marginWidth: number,
    // `<body>`
    noResize: _boolean,
    // `<frame>`
    noHref: _boolean,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: _boolean,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: _boolean,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number,
    // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: _boolean,
    disableRemotePlayback: _boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
});

var svg$1 = create({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    transformOrigin: 'transform-origin',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: _boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    "in": null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
});

/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */

var valid = /^data[-\w.:]+$/i;
var dash = /-[a-z]/g;
var cap = /[A-Z]/g;

/**
 * @param {Schema} schema
 * @param {string} value
 * @returns {Info}
 */
function find(schema, value) {
  var normal = normalize(value);
  var prop = value;
  var Type = Info$1;
  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]];
  }
  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      var rest = value.slice(5).replace(dash, camelcase);
      prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      // Turn it into an attribute.
      var _rest = value.slice(4);
      if (!dash.test(_rest)) {
        var dashes = _rest.replace(cap, kebab);
        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes;
        }
        value = 'data' + dashes;
      }
    }
    Type = DefinedInfo;
  }
  return new Type(prop, value);
}

/**
 * @param {string} $0
 * @returns {string}
 */
function kebab($0) {
  return '-' + $0.toLowerCase();
}

/**
 * @param {string} $0
 * @returns {string}
 */
function camelcase($0) {
  return $0.charAt(1).toUpperCase();
}

/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */

var html = merge([xml, xlink, xmlns, aria, html$1], 'html');
var svg = merge([xml, xlink, xmlns, aria, svg$1], 'svg');

/**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */

/**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */

/**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */

/**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */

var own$1 = {}.hasOwnProperty;

/**
 * Handle values based on a field.
 *
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @param {string} key
 *   Field to switch on.
 * @param {Options<Invalid, Unknown, Handlers>} [options]
 *   Configuration (required).
 * @returns {{unknown: Unknown, invalid: Invalid, handlers: Handlers, (...parameters: Parameters<Handlers[keyof Handlers]>): ReturnType<Handlers[keyof Handlers]>, (...parameters: Parameters<Unknown>): ReturnType<Unknown>}}
 */
function zwitch(key, options) {
  var settings = options || {};

  /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */
  function one(value) {
    /** @type {Handler|undefined} */
    var fn = one.invalid;
    var handlers = one.handlers;
    if (value && own$1.call(value, key)) {
      // @ts-expect-error Indexable.
      var id = String(value[key]);
      // @ts-expect-error Indexable.
      fn = own$1.call(handlers, id) ? handlers[id] : one.unknown;
    }
    if (fn) {
      var _fn;
      for (var _len = arguments.length, parameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        parameters[_key - 1] = arguments[_key];
      }
      return (_fn = fn).call.apply(_fn, [this, value].concat(parameters));
    }
  }
  one.handlers = settings.handlers || {};
  one.invalid = settings.invalid;
  one.unknown = settings.unknown;

  // @ts-expect-error: matches!
  return one;
}

/**
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').Doctype} Doctype
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').RootContent} RootContent
 * @typedef {import('hast').Text} Text
 *
 * @typedef {import('parse5').DefaultTreeAdapterMap['document']} Parse5Document
 * @typedef {import('parse5').DefaultTreeAdapterMap['documentFragment']} Parse5Fragment
 * @typedef {import('parse5').DefaultTreeAdapterMap['element']} Parse5Element
 * @typedef {import('parse5').DefaultTreeAdapterMap['node']} Parse5Nodes
 * @typedef {import('parse5').DefaultTreeAdapterMap['documentType']} Parse5Doctype
 * @typedef {import('parse5').DefaultTreeAdapterMap['commentNode']} Parse5Comment
 * @typedef {import('parse5').DefaultTreeAdapterMap['textNode']} Parse5Text
 * @typedef {import('parse5').DefaultTreeAdapterMap['parentNode']} Parse5Parent
 * @typedef {import('parse5').Token.Attribute} Parse5Attribute
 *
 * @typedef {import('property-information').Schema} Schema
 */


/** @type {Options} */
var emptyOptions = {};
var own = {}.hasOwnProperty;
var one = zwitch('type', {
  handlers: {
    root: root$1,
    element: element$1,
    text: text$1,
    comment: comment$1,
    doctype: doctype$1
  }
});

/**
 * Transform a hast tree to a `parse5` AST.
 *
 * @param {Nodes} tree
 *   Tree to transform.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {Parse5Nodes}
 *   `parse5` node.
 */
function toParse5(tree, options) {
  var settings = options || emptyOptions;
  var space = settings.space;
  return one(tree, space === 'svg' ? svg : html);
}

/**
 * @param {Root} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Document}
 *   Parse5 node.
 */
function root$1(node, schema) {
  /** @type {Parse5Document} */
  var result = {
    nodeName: '#document',
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (node.data || {}).quirksMode ? 'quirks' : 'no-quirks',
    childNodes: []
  };
  result.childNodes = all$1(node.children, result, schema);
  patch(node, result);
  return result;
}

/**
 * @param {Root} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Fragment}
 *   Parse5 node.
 */
function fragment(node, schema) {
  /** @type {Parse5Fragment} */
  var result = {
    nodeName: '#document-fragment',
    childNodes: []
  };
  result.childNodes = all$1(node.children, result, schema);
  patch(node, result);
  return result;
}

/**
 * @param {Doctype} node
 *   Node (hast) to transform.
 * @returns {Parse5Doctype}
 *   Parse5 node.
 */
function doctype$1(node) {
  /** @type {Parse5Doctype} */
  var result = {
    nodeName: '#documentType',
    name: 'html',
    publicId: '',
    systemId: '',
    parentNode: null
  };
  patch(node, result);
  return result;
}

/**
 * @param {Text} node
 *   Node (hast) to transform.
 * @returns {Parse5Text}
 *   Parse5 node.
 */
function text$1(node) {
  /** @type {Parse5Text} */
  var result = {
    nodeName: '#text',
    value: node.value,
    parentNode: null
  };
  patch(node, result);
  return result;
}

/**
 * @param {Comment} node
 *   Node (hast) to transform.
 * @returns {Parse5Comment}
 *   Parse5 node.
 */
function comment$1(node) {
  /** @type {Parse5Comment} */
  var result = {
    nodeName: '#comment',
    data: node.value,
    parentNode: null
  };
  patch(node, result);
  return result;
}

/**
 * @param {Element} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Element}
 *   Parse5 node.
 */
function element$1(node, schema) {
  var parentSchema = schema;
  var currentSchema = parentSchema;
  if (node.type === 'element' && node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
    currentSchema = svg;
  }

  /** @type {Array<Parse5Attribute>} */
  var attrs = [];
  /** @type {string} */
  var prop;
  if (node.properties) {
    for (prop in node.properties) {
      if (prop !== 'children' && own.call(node.properties, prop)) {
        var _result = createProperty(currentSchema, prop, node.properties[prop]);
        if (_result) {
          attrs.push(_result);
        }
      }
    }
  }
  var space = currentSchema.space;

  /** @type {Parse5Element} */
  var result = {
    nodeName: node.tagName,
    tagName: node.tagName,
    attrs: attrs,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: webNamespaces[space],
    childNodes: [],
    parentNode: null
  };
  result.childNodes = all$1(node.children, result, currentSchema);
  patch(node, result);
  if (node.tagName === 'template' && node.content) {
    // @ts-expect-error: `parse5` types are wrong.
    result.content = fragment(node.content, currentSchema);
  }
  return result;
}

/**
 * Handle a property.
 *
 * @param {Schema} schema
 *   Current schema.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Parse5Attribute | undefined}
 *   Field for runtime, optional.
 */
function createProperty(schema, prop, value) {
  var info = find(schema, prop);

  // Ignore nullish and `NaN` values.
  if (value === false || value === null || value === undefined || typeof value === 'number' && Number.isNaN(value) || !value && info["boolean"]) {
    return;
  }
  if (Array.isArray(value)) {
    // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? stringify$1(value) : stringify(value);
  }

  /** @type {Parse5Attribute} */
  var attribute = {
    name: info.attribute,
    value: value === true ? '' : String(value)
  };
  if (info.space && info.space !== 'html' && info.space !== 'svg') {
    var index = attribute.name.indexOf(':');
    if (index < 0) {
      attribute.prefix = '';
    } else {
      attribute.name = attribute.name.slice(index + 1);
      attribute.prefix = info.attribute.slice(0, index);
    }
    attribute.namespace = webNamespaces[info.space];
  }
  return attribute;
}

/**
 * Transform all hast nodes.
 *
 * @param {Array<RootContent>} children
 *   List of children.
 * @param {Parse5Parent} parentNode
 *   `parse5` parent node.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Array<Parse5Content>}
 *   Transformed children.
 */
function all$1(children, parentNode, schema) {
  var index = -1;
  /** @type {Array<Parse5Content>} */
  var results = [];
  if (children) {
    while (++index < children.length) {
      /** @type {Parse5Content} */
      var child = one(children[index], schema);
      child.parentNode = parentNode;
      results.push(child);
    }
  }
  return results;
}

/**
 * Add position info from `from` to `to`.
 *
 * @param {Nodes} from
 *   hast node.
 * @param {Parse5Nodes} to
 *   `parse5` node.
 * @returns {undefined}
 *   Nothing.
 */
function patch(from, to) {
  var position = from.position;
  if (position && position.start && position.end) {
    ok$1(typeof position.start.offset === 'number');
    ok$1(typeof position.end.offset === 'number');
    to.sourceCodeLocation = {
      startLine: position.start.line,
      startCol: position.start.column,
      startOffset: position.start.offset,
      endLine: position.end.line,
      endCol: position.end.column,
      endOffset: position.end.offset
    };
  }
}

/**
 * List of HTML void tag names.
 *
 * @type {Array<string>}
 */
var htmlVoidElements = ['area', 'base', 'basefont', 'bgsound', 'br', 'col', 'command', 'embed', 'frame', 'hr', 'image', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

var UNDEFINED_CODE_POINTS = new Set([65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111]);
var REPLACEMENT_CHARACTER = "\uFFFD";
var CODE_POINTS;
(function (CODE_POINTS) {
  CODE_POINTS[CODE_POINTS["EOF"] = -1] = "EOF";
  CODE_POINTS[CODE_POINTS["NULL"] = 0] = "NULL";
  CODE_POINTS[CODE_POINTS["TABULATION"] = 9] = "TABULATION";
  CODE_POINTS[CODE_POINTS["CARRIAGE_RETURN"] = 13] = "CARRIAGE_RETURN";
  CODE_POINTS[CODE_POINTS["LINE_FEED"] = 10] = "LINE_FEED";
  CODE_POINTS[CODE_POINTS["FORM_FEED"] = 12] = "FORM_FEED";
  CODE_POINTS[CODE_POINTS["SPACE"] = 32] = "SPACE";
  CODE_POINTS[CODE_POINTS["EXCLAMATION_MARK"] = 33] = "EXCLAMATION_MARK";
  CODE_POINTS[CODE_POINTS["QUOTATION_MARK"] = 34] = "QUOTATION_MARK";
  CODE_POINTS[CODE_POINTS["AMPERSAND"] = 38] = "AMPERSAND";
  CODE_POINTS[CODE_POINTS["APOSTROPHE"] = 39] = "APOSTROPHE";
  CODE_POINTS[CODE_POINTS["HYPHEN_MINUS"] = 45] = "HYPHEN_MINUS";
  CODE_POINTS[CODE_POINTS["SOLIDUS"] = 47] = "SOLIDUS";
  CODE_POINTS[CODE_POINTS["DIGIT_0"] = 48] = "DIGIT_0";
  CODE_POINTS[CODE_POINTS["DIGIT_9"] = 57] = "DIGIT_9";
  CODE_POINTS[CODE_POINTS["SEMICOLON"] = 59] = "SEMICOLON";
  CODE_POINTS[CODE_POINTS["LESS_THAN_SIGN"] = 60] = "LESS_THAN_SIGN";
  CODE_POINTS[CODE_POINTS["EQUALS_SIGN"] = 61] = "EQUALS_SIGN";
  CODE_POINTS[CODE_POINTS["GREATER_THAN_SIGN"] = 62] = "GREATER_THAN_SIGN";
  CODE_POINTS[CODE_POINTS["QUESTION_MARK"] = 63] = "QUESTION_MARK";
  CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_A"] = 65] = "LATIN_CAPITAL_A";
  CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_Z"] = 90] = "LATIN_CAPITAL_Z";
  CODE_POINTS[CODE_POINTS["RIGHT_SQUARE_BRACKET"] = 93] = "RIGHT_SQUARE_BRACKET";
  CODE_POINTS[CODE_POINTS["GRAVE_ACCENT"] = 96] = "GRAVE_ACCENT";
  CODE_POINTS[CODE_POINTS["LATIN_SMALL_A"] = 97] = "LATIN_SMALL_A";
  CODE_POINTS[CODE_POINTS["LATIN_SMALL_Z"] = 122] = "LATIN_SMALL_Z";
})(CODE_POINTS || (CODE_POINTS = {}));
var SEQUENCES = {
  DASH_DASH: '--',
  CDATA_START: '[CDATA[',
  DOCTYPE: 'doctype',
  SCRIPT: 'script',
  PUBLIC: 'public',
  SYSTEM: 'system'
};
//Surrogates
function isSurrogate(cp) {
  return cp >= 55296 && cp <= 57343;
}
function isSurrogatePair(cp) {
  return cp >= 56320 && cp <= 57343;
}
function getSurrogatePairCodePoint(cp1, cp2) {
  return (cp1 - 55296) * 1024 + 9216 + cp2;
}
//NOTE: excluding NULL and ASCII whitespace
function isControlCodePoint(cp) {
  return cp !== 0x20 && cp !== 0x0a && cp !== 0x0d && cp !== 0x09 && cp !== 0x0c && cp >= 0x01 && cp <= 0x1f || cp >= 0x7f && cp <= 0x9f;
}
function isUndefinedCodePoint(cp) {
  return cp >= 64976 && cp <= 65007 || UNDEFINED_CODE_POINTS.has(cp);
}

var ERR;
(function (ERR) {
  ERR["controlCharacterInInputStream"] = "control-character-in-input-stream";
  ERR["noncharacterInInputStream"] = "noncharacter-in-input-stream";
  ERR["surrogateInInputStream"] = "surrogate-in-input-stream";
  ERR["nonVoidHtmlElementStartTagWithTrailingSolidus"] = "non-void-html-element-start-tag-with-trailing-solidus";
  ERR["endTagWithAttributes"] = "end-tag-with-attributes";
  ERR["endTagWithTrailingSolidus"] = "end-tag-with-trailing-solidus";
  ERR["unexpectedSolidusInTag"] = "unexpected-solidus-in-tag";
  ERR["unexpectedNullCharacter"] = "unexpected-null-character";
  ERR["unexpectedQuestionMarkInsteadOfTagName"] = "unexpected-question-mark-instead-of-tag-name";
  ERR["invalidFirstCharacterOfTagName"] = "invalid-first-character-of-tag-name";
  ERR["unexpectedEqualsSignBeforeAttributeName"] = "unexpected-equals-sign-before-attribute-name";
  ERR["missingEndTagName"] = "missing-end-tag-name";
  ERR["unexpectedCharacterInAttributeName"] = "unexpected-character-in-attribute-name";
  ERR["unknownNamedCharacterReference"] = "unknown-named-character-reference";
  ERR["missingSemicolonAfterCharacterReference"] = "missing-semicolon-after-character-reference";
  ERR["unexpectedCharacterAfterDoctypeSystemIdentifier"] = "unexpected-character-after-doctype-system-identifier";
  ERR["unexpectedCharacterInUnquotedAttributeValue"] = "unexpected-character-in-unquoted-attribute-value";
  ERR["eofBeforeTagName"] = "eof-before-tag-name";
  ERR["eofInTag"] = "eof-in-tag";
  ERR["missingAttributeValue"] = "missing-attribute-value";
  ERR["missingWhitespaceBetweenAttributes"] = "missing-whitespace-between-attributes";
  ERR["missingWhitespaceAfterDoctypePublicKeyword"] = "missing-whitespace-after-doctype-public-keyword";
  ERR["missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers"] = "missing-whitespace-between-doctype-public-and-system-identifiers";
  ERR["missingWhitespaceAfterDoctypeSystemKeyword"] = "missing-whitespace-after-doctype-system-keyword";
  ERR["missingQuoteBeforeDoctypePublicIdentifier"] = "missing-quote-before-doctype-public-identifier";
  ERR["missingQuoteBeforeDoctypeSystemIdentifier"] = "missing-quote-before-doctype-system-identifier";
  ERR["missingDoctypePublicIdentifier"] = "missing-doctype-public-identifier";
  ERR["missingDoctypeSystemIdentifier"] = "missing-doctype-system-identifier";
  ERR["abruptDoctypePublicIdentifier"] = "abrupt-doctype-public-identifier";
  ERR["abruptDoctypeSystemIdentifier"] = "abrupt-doctype-system-identifier";
  ERR["cdataInHtmlContent"] = "cdata-in-html-content";
  ERR["incorrectlyOpenedComment"] = "incorrectly-opened-comment";
  ERR["eofInScriptHtmlCommentLikeText"] = "eof-in-script-html-comment-like-text";
  ERR["eofInDoctype"] = "eof-in-doctype";
  ERR["nestedComment"] = "nested-comment";
  ERR["abruptClosingOfEmptyComment"] = "abrupt-closing-of-empty-comment";
  ERR["eofInComment"] = "eof-in-comment";
  ERR["incorrectlyClosedComment"] = "incorrectly-closed-comment";
  ERR["eofInCdata"] = "eof-in-cdata";
  ERR["absenceOfDigitsInNumericCharacterReference"] = "absence-of-digits-in-numeric-character-reference";
  ERR["nullCharacterReference"] = "null-character-reference";
  ERR["surrogateCharacterReference"] = "surrogate-character-reference";
  ERR["characterReferenceOutsideUnicodeRange"] = "character-reference-outside-unicode-range";
  ERR["controlCharacterReference"] = "control-character-reference";
  ERR["noncharacterCharacterReference"] = "noncharacter-character-reference";
  ERR["missingWhitespaceBeforeDoctypeName"] = "missing-whitespace-before-doctype-name";
  ERR["missingDoctypeName"] = "missing-doctype-name";
  ERR["invalidCharacterSequenceAfterDoctypeName"] = "invalid-character-sequence-after-doctype-name";
  ERR["duplicateAttribute"] = "duplicate-attribute";
  ERR["nonConformingDoctype"] = "non-conforming-doctype";
  ERR["missingDoctype"] = "missing-doctype";
  ERR["misplacedDoctype"] = "misplaced-doctype";
  ERR["endTagWithoutMatchingOpenElement"] = "end-tag-without-matching-open-element";
  ERR["closingOfElementWithOpenChildElements"] = "closing-of-element-with-open-child-elements";
  ERR["disallowedContentInNoscriptInHead"] = "disallowed-content-in-noscript-in-head";
  ERR["openElementsLeftAfterEof"] = "open-elements-left-after-eof";
  ERR["abandonedHeadElementChild"] = "abandoned-head-element-child";
  ERR["misplacedStartTagForHeadElement"] = "misplaced-start-tag-for-head-element";
  ERR["nestedNoscriptInHead"] = "nested-noscript-in-head";
  ERR["eofInElementThatCanContainOnlyText"] = "eof-in-element-that-can-contain-only-text";
})(ERR || (ERR = {}));

//Const
var DEFAULT_BUFFER_WATERLINE = 1 << 16;
//Preprocessor
//NOTE: HTML input preprocessing
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html#preprocessing-the-input-stream)
var Preprocessor = /*#__PURE__*/function () {
  function Preprocessor(handler) {
    _classCallCheck$1(this, Preprocessor);
    this.handler = handler;
    this.html = '';
    this.pos = -1;
    // NOTE: Initial `lastGapPos` is -2, to ensure `col` on initialisation is 0
    this.lastGapPos = -2;
    this.gapStack = [];
    this.skipNextNewLine = false;
    this.lastChunkWritten = false;
    this.endOfChunkHit = false;
    this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
    this.isEol = false;
    this.lineStartPos = 0;
    this.droppedBufferSize = 0;
    this.line = 1;
    //NOTE: avoid reporting errors twice on advance/retreat
    this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  return _createClass$1(Preprocessor, [{
    key: "col",
    get: function get() {
      return this.pos - this.lineStartPos + Number(this.lastGapPos !== this.pos);
    }
  }, {
    key: "offset",
    get: function get() {
      return this.droppedBufferSize + this.pos;
    }
  }, {
    key: "getError",
    value: function getError(code, cpOffset) {
      var line = this.line,
        col = this.col,
        offset = this.offset;
      var startCol = col + cpOffset;
      var startOffset = offset + cpOffset;
      return {
        code: code,
        startLine: line,
        endLine: line,
        startCol: startCol,
        endCol: startCol,
        startOffset: startOffset,
        endOffset: startOffset
      };
    }
  }, {
    key: "_err",
    value: function _err(code) {
      if (this.handler.onParseError && this.lastErrOffset !== this.offset) {
        this.lastErrOffset = this.offset;
        this.handler.onParseError(this.getError(code, 0));
      }
    }
  }, {
    key: "_addGap",
    value: function _addGap() {
      this.gapStack.push(this.lastGapPos);
      this.lastGapPos = this.pos;
    }
  }, {
    key: "_processSurrogate",
    value: function _processSurrogate(cp) {
      //NOTE: try to peek a surrogate pair
      if (this.pos !== this.html.length - 1) {
        var nextCp = this.html.charCodeAt(this.pos + 1);
        if (isSurrogatePair(nextCp)) {
          //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
          this.pos++;
          //NOTE: add a gap that should be avoided during retreat
          this._addGap();
          return getSurrogatePairCodePoint(cp, nextCp);
        }
      }
      //NOTE: we are at the end of a chunk, therefore we can't infer the surrogate pair yet.
      else if (!this.lastChunkWritten) {
        this.endOfChunkHit = true;
        return CODE_POINTS.EOF;
      }
      //NOTE: isolated surrogate
      this._err(ERR.surrogateInInputStream);
      return cp;
    }
  }, {
    key: "willDropParsedChunk",
    value: function willDropParsedChunk() {
      return this.pos > this.bufferWaterline;
    }
  }, {
    key: "dropParsedChunk",
    value: function dropParsedChunk() {
      if (this.willDropParsedChunk()) {
        this.html = this.html.substring(this.pos);
        this.lineStartPos -= this.pos;
        this.droppedBufferSize += this.pos;
        this.pos = 0;
        this.lastGapPos = -2;
        this.gapStack.length = 0;
      }
    }
  }, {
    key: "write",
    value: function write(chunk, isLastChunk) {
      if (this.html.length > 0) {
        this.html += chunk;
      } else {
        this.html = chunk;
      }
      this.endOfChunkHit = false;
      this.lastChunkWritten = isLastChunk;
    }
  }, {
    key: "insertHtmlAtCurrentPos",
    value: function insertHtmlAtCurrentPos(chunk) {
      this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1);
      this.endOfChunkHit = false;
    }
  }, {
    key: "startsWith",
    value: function startsWith(pattern, caseSensitive) {
      // Check if our buffer has enough characters
      if (this.pos + pattern.length > this.html.length) {
        this.endOfChunkHit = !this.lastChunkWritten;
        return false;
      }
      if (caseSensitive) {
        return this.html.startsWith(pattern, this.pos);
      }
      for (var i = 0; i < pattern.length; i++) {
        var cp = this.html.charCodeAt(this.pos + i) | 0x20;
        if (cp !== pattern.charCodeAt(i)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "peek",
    value: function peek(offset) {
      var pos = this.pos + offset;
      if (pos >= this.html.length) {
        this.endOfChunkHit = !this.lastChunkWritten;
        return CODE_POINTS.EOF;
      }
      var code = this.html.charCodeAt(pos);
      return code === CODE_POINTS.CARRIAGE_RETURN ? CODE_POINTS.LINE_FEED : code;
    }
  }, {
    key: "advance",
    value: function advance() {
      this.pos++;
      //NOTE: LF should be in the last column of the line
      if (this.isEol) {
        this.isEol = false;
        this.line++;
        this.lineStartPos = this.pos;
      }
      if (this.pos >= this.html.length) {
        this.endOfChunkHit = !this.lastChunkWritten;
        return CODE_POINTS.EOF;
      }
      var cp = this.html.charCodeAt(this.pos);
      //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
      if (cp === CODE_POINTS.CARRIAGE_RETURN) {
        this.isEol = true;
        this.skipNextNewLine = true;
        return CODE_POINTS.LINE_FEED;
      }
      //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
      //must be ignored.
      if (cp === CODE_POINTS.LINE_FEED) {
        this.isEol = true;
        if (this.skipNextNewLine) {
          // `line` will be bumped again in the recursive call.
          this.line--;
          this.skipNextNewLine = false;
          this._addGap();
          return this.advance();
        }
      }
      this.skipNextNewLine = false;
      if (isSurrogate(cp)) {
        cp = this._processSurrogate(cp);
      }
      //OPTIMIZATION: first check if code point is in the common allowed
      //range (ASCII alphanumeric, whitespaces, big chunk of BMP)
      //before going into detailed performance cost validation.
      var isCommonValidRange = this.handler.onParseError === null || cp > 0x1f && cp < 0x7f || cp === CODE_POINTS.LINE_FEED || cp === CODE_POINTS.CARRIAGE_RETURN || cp > 0x9f && cp < 64976;
      if (!isCommonValidRange) {
        this._checkForProblematicCharacters(cp);
      }
      return cp;
    }
  }, {
    key: "_checkForProblematicCharacters",
    value: function _checkForProblematicCharacters(cp) {
      if (isControlCodePoint(cp)) {
        this._err(ERR.controlCharacterInInputStream);
      } else if (isUndefinedCodePoint(cp)) {
        this._err(ERR.noncharacterInInputStream);
      }
    }
  }, {
    key: "retreat",
    value: function retreat(count) {
      this.pos -= count;
      while (this.pos < this.lastGapPos) {
        this.lastGapPos = this.gapStack.pop();
        this.pos--;
      }
      this.isEol = false;
    }
  }]);
}();

var TokenType;
(function (TokenType) {
  TokenType[TokenType["CHARACTER"] = 0] = "CHARACTER";
  TokenType[TokenType["NULL_CHARACTER"] = 1] = "NULL_CHARACTER";
  TokenType[TokenType["WHITESPACE_CHARACTER"] = 2] = "WHITESPACE_CHARACTER";
  TokenType[TokenType["START_TAG"] = 3] = "START_TAG";
  TokenType[TokenType["END_TAG"] = 4] = "END_TAG";
  TokenType[TokenType["COMMENT"] = 5] = "COMMENT";
  TokenType[TokenType["DOCTYPE"] = 6] = "DOCTYPE";
  TokenType[TokenType["EOF"] = 7] = "EOF";
  TokenType[TokenType["HIBERNATION"] = 8] = "HIBERNATION";
})(TokenType || (TokenType = {}));
function getTokenAttr(token, attrName) {
  for (var i = token.attrs.length - 1; i >= 0; i--) {
    if (token.attrs[i].name === attrName) {
      return token.attrs[i].value;
    }
  }
  return null;
}

// Generated using scripts/write-decode-map.ts
var htmlDecodeTree = /* #__PURE__ */new Uint16Array(
// prettier-ignore
/* #__PURE__ */
"\u1D41<\xD5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7F\x84\x8B\x90\x95\x98\xA6\xB3\xB9\xC8\xCFlig\u803B\xC6\u40C6P\u803B&\u4026cute\u803B\xC1\u40C1reve;\u4102\u0100iyx}rc\u803B\xC2\u40C2;\u4410r;\uC000\uD835\uDD04rave\u803B\xC0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9D\xA1on;\u4104f;\uC000\uD835\uDD38plyFunction;\u6061ing\u803B\xC5\u40C5\u0100cs\xBE\xC3r;\uC000\uD835\uDC9Cign;\u6254ilde\u803B\xC3\u40C3ml\u803B\xC4\u40C4\u0400aceforsu\xE5\xFB\xFE\u0117\u011C\u0122\u0127\u012A\u0100cr\xEA\xF2kslash;\u6216\u0176\xF6\xF8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\uD835\uDD05pf;\uC000\uD835\uDD39eve;\u42D8c\xF2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xA9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xC7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xF2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\uD835\uDC9Ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\uD835\uDD07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\uD835\uDD3B\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xEC\u0239o\u0274\u0379\0\0\u037B\xBB\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xE5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\uD835\uDC9Frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xD0\u40D0cute\u803B\xC9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xCA\u40CA;\u442Dot;\u4116r;\uC000\uD835\uDD08rave\u803B\xC8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\uD835\uDD3Csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xCB\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\uD835\uDD09lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\uD835\uDD3DAll;\u6200riertrf;\u6131c\xF2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\uD835\uDD0A;\u62D9pf;\uC000\uD835\uDD3Eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\uD835\uDCA2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xF2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xF0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xCD\u40CD\u0100iy\u0713\u0718rc\u803B\xCE\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xCC\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xF3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\uD835\uDD40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xCF\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\uD835\uDD0Dpf;\uC000\uD835\uDD41\u01E3\u07C7\0\u07CCr;\uC000\uD835\uDCA5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\uD835\uDD0Epf;\uC000\uD835\uDD42cr;\uC000\uD835\uDCA6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xE1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\uD835\uDD0F\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xE1\u03BFight\xE1\u03CAf;\uC000\uD835\uDD43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xF2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\uD835\uDD10nusPlus;\u6213pf;\uC000\uD835\uDD44c\xF2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xEB\u0AD9eryThi\xEE\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xF2\u0673essLes\xF3\u0A48Line;\u400Ar;\uC000\uD835\uDD11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\uD835\uDCA9ilde\u803B\xD1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xD3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xD4\u40D4;\u441Eblac;\u4150r;\uC000\uD835\uDD12rave\u803B\xD2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\uD835\uDD46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\uD835\uDCAAash\u803B\xD8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xD5\u40D5es;\u6A37ml\u803B\xD6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\uD835\uDD13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xE5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\uD835\uDCAB;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B\"\u4022r;\uC000\uD835\uDD14pf;\u611Acr;\uC000\uD835\uDCAC\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xAE\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xBB\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\uD835\uDD16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xBB\u041EeftArrow\xBB\u089AightArrow\xBB\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\uD835\uDD4A\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\uD835\uDCAEar;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xE1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xBB\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xDE\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\uD835\uDD17\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\uD835\uDD4BipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\uD835\uDCAFrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xDA\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xDB\u40DB;\u4423blac;\u4170r;\uC000\uD835\uDD18rave\u803B\xD9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\uD835\uDD4C\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xE1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\uD835\uDCB0ilde;\u4168ml\u803B\xDC\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\uD835\uDD19pf;\uC000\uD835\uDD4Dcr;\uC000\uD835\uDCB1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\uD835\uDD1Apf;\uC000\uD835\uDD4Ecr;\uC000\uD835\uDCB2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\uD835\uDD1B;\u439Epf;\uC000\uD835\uDD4Fcr;\uC000\uD835\uDCB3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xDD\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\uD835\uDD1Cpf;\uC000\uD835\uDD50cr;\uC000\uD835\uDCB4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xE8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\uD835\uDCB5\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xE1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xE2\u40E2te\u80BB\xB4\u0306;\u4430lig\u803B\xE6\u40E6\u0100;r\xB2\u15BA;\uC000\uD835\uDD1Erave\u803B\xE0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xE8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xBB\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xBB\xB9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\uD835\uDD52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xF1\u1683ing\u803B\xE5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\uD835\uDCB6;\u402Amp\u0100;e\u12C1\u16AF\xF1\u0288ilde\u803B\xE3\u40E3ml\u803B\xE4\u40E4\u0100ci\u16C2\u16C8onin\xF4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xBB\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xE9\u170Cno\xF5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\uD835\uDD1Fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xF0\u0760rc;\u65EFp\xBB\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xE5\u1444\xE5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\uD835\uDD53\u0100;t\u13CB\u1863om\xBB\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xA6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\uD835\uDCB7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xBB\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xEE\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xE7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xB8\u01ADptyv;\u69B2t\u8100\xA2;e\u1A2D\u1A2E\u40A2r\xE4\u01B2r;\uC000\uD835\uDD20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xBB\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xBB\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xBB\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xC7\xC6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xEE\u1160e\u0100mx\u1AF1\u1AF6ent\xBB\u1AE9e\xF3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xF4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\uD835\uDD54o\xE4\u0254\u8100\xA9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\uD835\uDCB8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xE3\u1B73u\xE3\u1B75ee;\u62CEedge;\u62CFen\u803B\xA4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xBB\u1B80ight\xBB\u1BBDe\xE4\u1BDD\u0100ci\u1C01\u1C07onin\xF4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xF2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xF2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xBB\u090A\u016B\u1C61\u1C67arow;\u690Fa\xE3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xB0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\uD835\uDD21ar\u0100lr\u1CB3\u1CB5\xBB\u08DC\xBB\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xF7;o\u1CE7\u1CF0ntimes;\u62C7n\xF8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\uD835\uDD55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xE5\xFAn\u0180adh\u112E\u1D5D\u1D67ownarrow\xF3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xF4\u1CB4igh\xF4\u1CB6\u0162\u1D7F\u1D85karo\xF7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\uD835\uDCB9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xF2\u0429a\xF2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xF4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xE9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xEA\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\uD835\uDD22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xE8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xBB\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\uD835\uDD56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xBB\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xBB\u1E2E\u0269\u1EF9\0\0\u1EFB\xED\u0548ant\u0100gl\u1F02\u1F06tr\xBB\u1E5Dess\xBB\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xF4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xF0\u40F0\u0100mr\u1F53\u1F57l\u803B\xEB\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xF4\u056E\u0100eo\u1F6C\u1F74ctatio\xEE\u0559nential\xE5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xF1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\uD835\uDD23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\uD835\uDD57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xBD\u40BD;\u6153\u803B\xBC\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xBE\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\uD835\uDCBB\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xF4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\uD835\uDD24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xBB\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\uD835\uDD58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xF8\u209Er;\u6978q\u0100lq\u063F\u2196les\xF3\u2088i\xED\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xC5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xF2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xF0\u1484f\xBB\u2024il\xF4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xBB\u220Alip;\u6026con;\u62B9r;\uC000\uD835\uDD25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\uD835\uDD59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\uD835\uDCBDas\xE8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xBB\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xED\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xEE\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xA1\u40A1\u0100fr\u039F\u22C9;\uC000\uD835\uDD26rave\u803B\xEC\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xE5\u078Ear\xF4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xF4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xF3\u1563\xE3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\uD835\uDD5Aa;\u43B9uest\u803B\xBF\u40BF\u0100ci\u238A\u238Fr;\uC000\uD835\uDCBEn\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xEF\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\uD835\uDD27ath;\u4237pf;\uC000\uD835\uDD5B\u01E3\u23EC\0\u23F1r;\uC000\uD835\uDCBFrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\uD835\uDD28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\uD835\uDD5Ccr;\uC000\uD835\uDCC0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xF2\u09C6\xF2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xEE\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xE5\u088E;\u6A85uo\u803B\xAB\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xEB\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xEC\u08B0\xE2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xE9\u24F6arpoon\u0100du\u25AF\u25B4own\xBB\u045Ap\xBB\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xF3\u0F98quigarro\xF7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xF4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xF8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xF4\u0989gt\xF2\u248C\xF4\u099Bi\xED\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\uD835\uDD29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xF2\u25C1orne\xF2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xBB\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xBB\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xEB\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xE1\u09F2apsto;\u67FCight\xE1\u09FDparrow\u0100lr\u2725\u2729ef\xF4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\uD835\uDD5Dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xE1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xBB\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xF2\u08A8orne\xF2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\uD835\uDCC1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xE5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xC5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xAF\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xBB\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xEE\u048Cef\xF4\u090F\xF0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xBB\u1626r;\uC000\uD835\uDD2Ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xB5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xF4\u16A7ir;\u6AF0ot\u80BB\xB7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xF2\u2212\xF0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\uD835\uDD5E\u0100ct\u28F8\u28FDr;\uC000\uD835\uDCC2pos\xBB\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xBB\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xF8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xA0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xF6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xED\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\uD835\uDD2B\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xF4\u0BE2i\xED\u0BEA\u0100;r\u0BB6\u2A81\xBB\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xF2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xF2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xF7\u2AC1ightarro\xF7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xF4\u0C55\u0100;s\u0C55\u2AF4\xBB\u0C36i\xED\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xE4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\uD835\uDD5F\u8180\xAC;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xEC\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xE5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xF1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xF2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xBB\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xE5\u0D45;\uC000\uD835\uDCC3ort\u026D\u2B05\0\0\u2BD6ar\xE1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xE5\u0CF8\xE5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xF1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xEC\u0BD7lde\u803B\xF1\u40F1\xE7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xF1\u0C26ight\u0100;e\u0CCB\u2C65\xF1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xF3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xF4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\uD835\uDD2C\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xF2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xF2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xE5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\uD835\uDD60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xF2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xBB\u2DFF\u803B\xAA\u40AA\u803B\xBA\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xF2\u2E01ash\u803B\xF8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xF5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xF6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xB6;l\u2E6D\u2E6E\u40B6le\xEC\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\uD835\uDD2D\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xF4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xBB\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xF6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xB1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\uD835\uDD61nd\u803B\xA3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xE5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xF8\u2F43urlye\xF1\u0ED9\xF1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xED\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xF0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xEF\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\uD835\uDCC5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\uD835\uDD2Epf;\uC000\uD835\uDD62rime;\u6057cr;\uC000\uD835\uDCC6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xF3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xF1\u1F19\xF4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xF2\u10B3\xF2\u03DDail;\u691Car\xF2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xE3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xE5\u0FD1uo\u803B\xBB\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xEB\u225D\xF0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xF3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xF2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xEC\u0FF2\xE2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xE5\u10BBar\xF4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\uD835\uDD2F\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xBB\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xE9\u30C8arpoon\u0100du\u31BB\u31BFow\xEE\u317Ep\xBB\u1092eft\u0100ah\u31CA\u31D0rrow\xF3\u0FEAarpoon\xF3\u0551ightarrows;\u61C9quigarro\xF7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xF1\u1F32\u0180ahm\u320D\u3210\u3213r\xF2\u0FEAa\xF2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xBB\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xEB\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\uD835\uDD63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xF2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\uD835\uDCC7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xE5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xEF\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xE5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xED\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xEB\u2228\u0100;o\u0A36\u0A34t\u803B\xA7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xF0nu\xF3\xF1t;\u6736r\u0100;o\u3376\u2055\uC000\uD835\uDD30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xE4\u1464ara\xEC\u2E6F\u803B\xAD\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xF2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xE9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\uD835\uDD64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xBB\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xF1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xF1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xBB\u117Car\xF2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\uD835\uDCC8tm\xEE\xF1i\xEC\u3415ar\xE6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xEE\u1EE0h\xE9\u2EAFs\xBB\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xF8\u32FAurlye\xF1\u11FE\xF1\u11F3\u0180aes\u3582\u3588\u331Bppro\xF8\u331Aq\xF1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xB9\u40B9\u803B\xB2\u40B2\u803B\xB3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xEB\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xDF\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xEB\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\uD835\uDD31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xF8\u12C1im\xBB\u12ACs\xF0\u129E\u0100as\u36BA\u36AE\xF0\u12C1rn\u803B\xFE\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xD7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xE1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\uD835\uDD65rk;\u6ADA\xE1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xE5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xBB\u1DBBeft\u0100;e\u2800\u373E\xF1\u092E;\u625Cight\u0100;e\u32AA\u374B\xF1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\uD835\uDCC9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xF4\u1777head\u0100lr\u3797\u37A0eftarro\xF7\u084Fightarrow\xBB\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xF2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xFA\u40FA\xF2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xFB\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xF2\u13ADlac;\u4171a\xF2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\uD835\uDD32rave\u803B\xF9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xBB\u0957\xBB\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xBB\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xA8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\uD835\uDD66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xE1\u13B3arpoon\u0100lr\u3888\u388Cef\xF4\u382Digh\xF4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xBB\u13FAon\xBB\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xBB\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\uD835\uDCCA\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xBB\u1813\u0100am\u38EF\u38F2r\xF2\u38A8l\u803B\xFC\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xF2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xE8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xE1\u2415othin\xE7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xF4\u2FB5\u0100;h\u13B7\u3962\xEF\u318D\u0100iu\u3969\u396Dgm\xE1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xE1\u369Ciangle\u0100lr\u39AA\u39AFeft\xBB\u0925ight\xBB\u1051y;\u4432ash\xBB\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xF2\u1469r;\uC000\uD835\uDD33tr\xE9\u39AEsu\u0100bp\u39EF\u39F1\xBB\u0D1C\xBB\u0D59pf;\uC000\uD835\uDD67ro\xF0\u0EFBtr\xE9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\uD835\uDCCB\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xBB\u397En\u0100Ee\u3992\u3A1E\xBB\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\uD835\uDD34pf;\uC000\uD835\uDD68\u0100;e\u1479\u3A66at\xE8\u1479cr;\uC000\uD835\uDCCC\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xE9\u17D1r;\uC000\uD835\uDD35\u0100Aa\u3A94\u3A97r\xF2\u03C3r\xF2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xF2\u03B8r\xF2\u09EBa\xF0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\uD835\uDD69im\xE5\u17B2\u0100Aa\u3AC7\u3ACAr\xF2\u03CEr\xF2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\uD835\uDCCD\u0100pt\u17D6\u3ADCr\xE9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xFD\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xA5\u40A5r;\uC000\uD835\uDD36cy;\u4457pf;\uC000\uD835\uDD6Acr;\uC000\uD835\uDCCE\u0100cm\u3B26\u3B29y;\u444El\u803B\xFF\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xE6\u155Fa;\u43B6r;\uC000\uD835\uDD37cy;\u4436grarr;\u61DDpf;\uC000\uD835\uDD6Bcr;\uC000\uD835\uDCCF\u0100jn\u3B85\u3B87;\u600Dj;\u600C".split("").map(function (c) {
  return c.charCodeAt(0);
}));

// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var decodeMap = new Map([[0, 65533],
// C1 Unicode control character reference replacements
[128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */
function replaceCodePoint(codePoint) {
  var _a;
  if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
    return 65533;
  }
  return (_a = decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}

var CharCodes;
(function (CharCodes) {
  CharCodes[CharCodes["NUM"] = 35] = "NUM";
  CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
  CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
  CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
  CharCodes[CharCodes["NINE"] = 57] = "NINE";
  CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
  CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
  CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
  CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
  CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
  CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
  CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})(CharCodes || (CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */
var TO_LOWER_BIT = 32;
var BinTrieFlags;
(function (BinTrieFlags) {
  BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
  BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
  BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags || (BinTrieFlags = {}));
function isNumber(code) {
  return code >= CharCodes.ZERO && code <= CharCodes.NINE;
}
function isHexadecimalCharacter(code) {
  return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F;
}
function isAsciiAlphaNumeric$1(code) {
  return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z || isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */
function isEntityInAttributeInvalidEnd(code) {
  return code === CharCodes.EQUALS || isAsciiAlphaNumeric$1(code);
}
var EntityDecoderState;
(function (EntityDecoderState) {
  EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
  EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
  EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
  EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
  EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})(EntityDecoderState || (EntityDecoderState = {}));
var DecodingMode;
(function (DecodingMode) {
  /** Entities in text nodes that can end with any character. */
  DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
  /** Only allow entities terminated with a semicolon. */
  DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
  /** Entities in attributes have limitations on ending characters. */
  DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})(DecodingMode || (DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */
var EntityDecoder = /*#__PURE__*/function () {
  function EntityDecoder(/** The tree used to decode entities. */
  decodeTree,
  /**
   * The function that is called when a codepoint is decoded.
   *
   * For multi-byte named entities, this will be called multiple times,
   * with the second codepoint, and the same `consumed` value.
   *
   * @param codepoint The decoded codepoint.
   * @param consumed The number of bytes consumed by the decoder.
   */
  emitCodePoint, /** An object that is used to produce errors. */
  errors) {
    _classCallCheck$1(this, EntityDecoder);
    this.decodeTree = decodeTree;
    this.emitCodePoint = emitCodePoint;
    this.errors = errors;
    /** The current state of the decoder. */
    this.state = EntityDecoderState.EntityStart;
    /** Characters that were consumed while parsing an entity. */
    this.consumed = 1;
    /**
     * The result of the entity.
     *
     * Either the result index of a numeric entity, or the codepoint of a
     * numeric entity.
     */
    this.result = 0;
    /** The current index in the decode tree. */
    this.treeIndex = 0;
    /** The number of characters that were consumed in excess. */
    this.excess = 1;
    /** The mode in which the decoder is operating. */
    this.decodeMode = DecodingMode.Strict;
  }
  /** Resets the instance to make it reusable. */
  return _createClass$1(EntityDecoder, [{
    key: "startEntity",
    value: function startEntity(decodeMode) {
      this.decodeMode = decodeMode;
      this.state = EntityDecoderState.EntityStart;
      this.result = 0;
      this.treeIndex = 0;
      this.excess = 1;
      this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
  }, {
    key: "write",
    value: function write(input, offset) {
      switch (this.state) {
        case EntityDecoderState.EntityStart:
          {
            if (input.charCodeAt(offset) === CharCodes.NUM) {
              this.state = EntityDecoderState.NumericStart;
              this.consumed += 1;
              return this.stateNumericStart(input, offset + 1);
            }
            this.state = EntityDecoderState.NamedEntity;
            return this.stateNamedEntity(input, offset);
          }
        case EntityDecoderState.NumericStart:
          {
            return this.stateNumericStart(input, offset);
          }
        case EntityDecoderState.NumericDecimal:
          {
            return this.stateNumericDecimal(input, offset);
          }
        case EntityDecoderState.NumericHex:
          {
            return this.stateNumericHex(input, offset);
          }
        case EntityDecoderState.NamedEntity:
          {
            return this.stateNamedEntity(input, offset);
          }
      }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
  }, {
    key: "stateNumericStart",
    value: function stateNumericStart(input, offset) {
      if (offset >= input.length) {
        return -1;
      }
      if ((input.charCodeAt(offset) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
        this.state = EntityDecoderState.NumericHex;
        this.consumed += 1;
        return this.stateNumericHex(input, offset + 1);
      }
      this.state = EntityDecoderState.NumericDecimal;
      return this.stateNumericDecimal(input, offset);
    }
  }, {
    key: "addToNumericResult",
    value: function addToNumericResult(input, start, end, base) {
      if (start !== end) {
        var digitCount = end - start;
        this.result = this.result * Math.pow(base, digitCount) + Number.parseInt(input.substr(start, digitCount), base);
        this.consumed += digitCount;
      }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
  }, {
    key: "stateNumericHex",
    value: function stateNumericHex(input, offset) {
      var startIndex = offset;
      while (offset < input.length) {
        var _char = input.charCodeAt(offset);
        if (isNumber(_char) || isHexadecimalCharacter(_char)) {
          offset += 1;
        } else {
          this.addToNumericResult(input, startIndex, offset, 16);
          return this.emitNumericEntity(_char, 3);
        }
      }
      this.addToNumericResult(input, startIndex, offset, 16);
      return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
  }, {
    key: "stateNumericDecimal",
    value: function stateNumericDecimal(input, offset) {
      var startIndex = offset;
      while (offset < input.length) {
        var _char2 = input.charCodeAt(offset);
        if (isNumber(_char2)) {
          offset += 1;
        } else {
          this.addToNumericResult(input, startIndex, offset, 10);
          return this.emitNumericEntity(_char2, 2);
        }
      }
      this.addToNumericResult(input, startIndex, offset, 10);
      return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */
  }, {
    key: "emitNumericEntity",
    value: function emitNumericEntity(lastCp, expectedLength) {
      var _a;
      // Ensure we consumed at least one digit.
      if (this.consumed <= expectedLength) {
        (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
        return 0;
      }
      // Figure out if this is a legit end of the entity
      if (lastCp === CharCodes.SEMI) {
        this.consumed += 1;
      } else if (this.decodeMode === DecodingMode.Strict) {
        return 0;
      }
      this.emitCodePoint(replaceCodePoint(this.result), this.consumed);
      if (this.errors) {
        if (lastCp !== CharCodes.SEMI) {
          this.errors.missingSemicolonAfterCharacterReference();
        }
        this.errors.validateNumericCharacterReference(this.result);
      }
      return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
  }, {
    key: "stateNamedEntity",
    value: function stateNamedEntity(input, offset) {
      var decodeTree = this.decodeTree;
      var current = decodeTree[this.treeIndex];
      // The mask is the number of bytes of the value, including the current byte.
      var valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
      for (; offset < input.length; offset++, this.excess++) {
        var _char3 = input.charCodeAt(offset);
        this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), _char3);
        if (this.treeIndex < 0) {
          return this.result === 0 ||
          // If we are parsing an attribute
          this.decodeMode === DecodingMode.Attribute && (
          // We shouldn't have consumed any characters after the entity,
          valueLength === 0 ||
          // And there should be no invalid characters.
          isEntityInAttributeInvalidEnd(_char3)) ? 0 : this.emitNotTerminatedNamedEntity();
        }
        current = decodeTree[this.treeIndex];
        valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
        // If the branch is a value, store it and continue
        if (valueLength !== 0) {
          // If the entity is terminated by a semicolon, we are done.
          if (_char3 === CharCodes.SEMI) {
            return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
          }
          // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
          if (this.decodeMode !== DecodingMode.Strict) {
            this.result = this.treeIndex;
            this.consumed += this.excess;
            this.excess = 0;
          }
        }
      }
      return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */
  }, {
    key: "emitNotTerminatedNamedEntity",
    value: function emitNotTerminatedNamedEntity() {
      var _a;
      var result = this.result,
        decodeTree = this.decodeTree;
      var valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
      this.emitNamedEntityData(result, valueLength, this.consumed);
      (_a = this.errors) === null || _a === void 0 ? void 0 : _a.missingSemicolonAfterCharacterReference();
      return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */
  }, {
    key: "emitNamedEntityData",
    value: function emitNamedEntityData(result, valueLength, consumed) {
      var decodeTree = this.decodeTree;
      this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
      if (valueLength === 3) {
        // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
      }
      return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */
  }, {
    key: "end",
    value: function end() {
      var _a;
      switch (this.state) {
        case EntityDecoderState.NamedEntity:
          {
            // Emit a named entity if we have one.
            return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          }
        // Otherwise, emit a numeric entity if we have one.
        case EntityDecoderState.NumericDecimal:
          {
            return this.emitNumericEntity(0, 2);
          }
        case EntityDecoderState.NumericHex:
          {
            return this.emitNumericEntity(0, 3);
          }
        case EntityDecoderState.NumericStart:
          {
            (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
          }
        case EntityDecoderState.EntityStart:
          {
            // Return 0 if we have no entity.
            return 0;
          }
      }
    }
  }]);
}();
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */
function determineBranch(decodeTree, current, nodeIndex, _char4) {
  var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
  var jumpOffset = current & BinTrieFlags.JUMP_TABLE;
  // Case 1: Single branch encoded in jump offset
  if (branchCount === 0) {
    return jumpOffset !== 0 && _char4 === jumpOffset ? nodeIndex : -1;
  }
  // Case 2: Multiple branches encoded in jump table
  if (jumpOffset) {
    var value = _char4 - jumpOffset;
    return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIndex + value] - 1;
  }
  // Case 3: Multiple branches encoded in dictionary
  // Binary search for the character.
  var lo = nodeIndex;
  var hi = lo + branchCount - 1;
  while (lo <= hi) {
    var mid = lo + hi >>> 1;
    var midValue = decodeTree[mid];
    if (midValue < _char4) {
      lo = mid + 1;
    } else if (midValue > _char4) {
      hi = mid - 1;
    } else {
      return decodeTree[mid + branchCount];
    }
  }
  return -1;
}

/** All valid namespaces in HTML. */
var NS;
(function (NS) {
  NS["HTML"] = "http://www.w3.org/1999/xhtml";
  NS["MATHML"] = "http://www.w3.org/1998/Math/MathML";
  NS["SVG"] = "http://www.w3.org/2000/svg";
  NS["XLINK"] = "http://www.w3.org/1999/xlink";
  NS["XML"] = "http://www.w3.org/XML/1998/namespace";
  NS["XMLNS"] = "http://www.w3.org/2000/xmlns/";
})(NS || (NS = {}));
var ATTRS;
(function (ATTRS) {
  ATTRS["TYPE"] = "type";
  ATTRS["ACTION"] = "action";
  ATTRS["ENCODING"] = "encoding";
  ATTRS["PROMPT"] = "prompt";
  ATTRS["NAME"] = "name";
  ATTRS["COLOR"] = "color";
  ATTRS["FACE"] = "face";
  ATTRS["SIZE"] = "size";
})(ATTRS || (ATTRS = {}));
/**
 * The mode of the document.
 *
 * @see {@link https://dom.spec.whatwg.org/#concept-document-limited-quirks}
 */
var DOCUMENT_MODE;
(function (DOCUMENT_MODE) {
  DOCUMENT_MODE["NO_QUIRKS"] = "no-quirks";
  DOCUMENT_MODE["QUIRKS"] = "quirks";
  DOCUMENT_MODE["LIMITED_QUIRKS"] = "limited-quirks";
})(DOCUMENT_MODE || (DOCUMENT_MODE = {}));
var TAG_NAMES;
(function (TAG_NAMES) {
  TAG_NAMES["A"] = "a";
  TAG_NAMES["ADDRESS"] = "address";
  TAG_NAMES["ANNOTATION_XML"] = "annotation-xml";
  TAG_NAMES["APPLET"] = "applet";
  TAG_NAMES["AREA"] = "area";
  TAG_NAMES["ARTICLE"] = "article";
  TAG_NAMES["ASIDE"] = "aside";
  TAG_NAMES["B"] = "b";
  TAG_NAMES["BASE"] = "base";
  TAG_NAMES["BASEFONT"] = "basefont";
  TAG_NAMES["BGSOUND"] = "bgsound";
  TAG_NAMES["BIG"] = "big";
  TAG_NAMES["BLOCKQUOTE"] = "blockquote";
  TAG_NAMES["BODY"] = "body";
  TAG_NAMES["BR"] = "br";
  TAG_NAMES["BUTTON"] = "button";
  TAG_NAMES["CAPTION"] = "caption";
  TAG_NAMES["CENTER"] = "center";
  TAG_NAMES["CODE"] = "code";
  TAG_NAMES["COL"] = "col";
  TAG_NAMES["COLGROUP"] = "colgroup";
  TAG_NAMES["DD"] = "dd";
  TAG_NAMES["DESC"] = "desc";
  TAG_NAMES["DETAILS"] = "details";
  TAG_NAMES["DIALOG"] = "dialog";
  TAG_NAMES["DIR"] = "dir";
  TAG_NAMES["DIV"] = "div";
  TAG_NAMES["DL"] = "dl";
  TAG_NAMES["DT"] = "dt";
  TAG_NAMES["EM"] = "em";
  TAG_NAMES["EMBED"] = "embed";
  TAG_NAMES["FIELDSET"] = "fieldset";
  TAG_NAMES["FIGCAPTION"] = "figcaption";
  TAG_NAMES["FIGURE"] = "figure";
  TAG_NAMES["FONT"] = "font";
  TAG_NAMES["FOOTER"] = "footer";
  TAG_NAMES["FOREIGN_OBJECT"] = "foreignObject";
  TAG_NAMES["FORM"] = "form";
  TAG_NAMES["FRAME"] = "frame";
  TAG_NAMES["FRAMESET"] = "frameset";
  TAG_NAMES["H1"] = "h1";
  TAG_NAMES["H2"] = "h2";
  TAG_NAMES["H3"] = "h3";
  TAG_NAMES["H4"] = "h4";
  TAG_NAMES["H5"] = "h5";
  TAG_NAMES["H6"] = "h6";
  TAG_NAMES["HEAD"] = "head";
  TAG_NAMES["HEADER"] = "header";
  TAG_NAMES["HGROUP"] = "hgroup";
  TAG_NAMES["HR"] = "hr";
  TAG_NAMES["HTML"] = "html";
  TAG_NAMES["I"] = "i";
  TAG_NAMES["IMG"] = "img";
  TAG_NAMES["IMAGE"] = "image";
  TAG_NAMES["INPUT"] = "input";
  TAG_NAMES["IFRAME"] = "iframe";
  TAG_NAMES["KEYGEN"] = "keygen";
  TAG_NAMES["LABEL"] = "label";
  TAG_NAMES["LI"] = "li";
  TAG_NAMES["LINK"] = "link";
  TAG_NAMES["LISTING"] = "listing";
  TAG_NAMES["MAIN"] = "main";
  TAG_NAMES["MALIGNMARK"] = "malignmark";
  TAG_NAMES["MARQUEE"] = "marquee";
  TAG_NAMES["MATH"] = "math";
  TAG_NAMES["MENU"] = "menu";
  TAG_NAMES["META"] = "meta";
  TAG_NAMES["MGLYPH"] = "mglyph";
  TAG_NAMES["MI"] = "mi";
  TAG_NAMES["MO"] = "mo";
  TAG_NAMES["MN"] = "mn";
  TAG_NAMES["MS"] = "ms";
  TAG_NAMES["MTEXT"] = "mtext";
  TAG_NAMES["NAV"] = "nav";
  TAG_NAMES["NOBR"] = "nobr";
  TAG_NAMES["NOFRAMES"] = "noframes";
  TAG_NAMES["NOEMBED"] = "noembed";
  TAG_NAMES["NOSCRIPT"] = "noscript";
  TAG_NAMES["OBJECT"] = "object";
  TAG_NAMES["OL"] = "ol";
  TAG_NAMES["OPTGROUP"] = "optgroup";
  TAG_NAMES["OPTION"] = "option";
  TAG_NAMES["P"] = "p";
  TAG_NAMES["PARAM"] = "param";
  TAG_NAMES["PLAINTEXT"] = "plaintext";
  TAG_NAMES["PRE"] = "pre";
  TAG_NAMES["RB"] = "rb";
  TAG_NAMES["RP"] = "rp";
  TAG_NAMES["RT"] = "rt";
  TAG_NAMES["RTC"] = "rtc";
  TAG_NAMES["RUBY"] = "ruby";
  TAG_NAMES["S"] = "s";
  TAG_NAMES["SCRIPT"] = "script";
  TAG_NAMES["SEARCH"] = "search";
  TAG_NAMES["SECTION"] = "section";
  TAG_NAMES["SELECT"] = "select";
  TAG_NAMES["SOURCE"] = "source";
  TAG_NAMES["SMALL"] = "small";
  TAG_NAMES["SPAN"] = "span";
  TAG_NAMES["STRIKE"] = "strike";
  TAG_NAMES["STRONG"] = "strong";
  TAG_NAMES["STYLE"] = "style";
  TAG_NAMES["SUB"] = "sub";
  TAG_NAMES["SUMMARY"] = "summary";
  TAG_NAMES["SUP"] = "sup";
  TAG_NAMES["TABLE"] = "table";
  TAG_NAMES["TBODY"] = "tbody";
  TAG_NAMES["TEMPLATE"] = "template";
  TAG_NAMES["TEXTAREA"] = "textarea";
  TAG_NAMES["TFOOT"] = "tfoot";
  TAG_NAMES["TD"] = "td";
  TAG_NAMES["TH"] = "th";
  TAG_NAMES["THEAD"] = "thead";
  TAG_NAMES["TITLE"] = "title";
  TAG_NAMES["TR"] = "tr";
  TAG_NAMES["TRACK"] = "track";
  TAG_NAMES["TT"] = "tt";
  TAG_NAMES["U"] = "u";
  TAG_NAMES["UL"] = "ul";
  TAG_NAMES["SVG"] = "svg";
  TAG_NAMES["VAR"] = "var";
  TAG_NAMES["WBR"] = "wbr";
  TAG_NAMES["XMP"] = "xmp";
})(TAG_NAMES || (TAG_NAMES = {}));
/**
 * Tag IDs are numeric IDs for known tag names.
 *
 * We use tag IDs to improve the performance of tag name comparisons.
 */
var TAG_ID;
(function (TAG_ID) {
  TAG_ID[TAG_ID["UNKNOWN"] = 0] = "UNKNOWN";
  TAG_ID[TAG_ID["A"] = 1] = "A";
  TAG_ID[TAG_ID["ADDRESS"] = 2] = "ADDRESS";
  TAG_ID[TAG_ID["ANNOTATION_XML"] = 3] = "ANNOTATION_XML";
  TAG_ID[TAG_ID["APPLET"] = 4] = "APPLET";
  TAG_ID[TAG_ID["AREA"] = 5] = "AREA";
  TAG_ID[TAG_ID["ARTICLE"] = 6] = "ARTICLE";
  TAG_ID[TAG_ID["ASIDE"] = 7] = "ASIDE";
  TAG_ID[TAG_ID["B"] = 8] = "B";
  TAG_ID[TAG_ID["BASE"] = 9] = "BASE";
  TAG_ID[TAG_ID["BASEFONT"] = 10] = "BASEFONT";
  TAG_ID[TAG_ID["BGSOUND"] = 11] = "BGSOUND";
  TAG_ID[TAG_ID["BIG"] = 12] = "BIG";
  TAG_ID[TAG_ID["BLOCKQUOTE"] = 13] = "BLOCKQUOTE";
  TAG_ID[TAG_ID["BODY"] = 14] = "BODY";
  TAG_ID[TAG_ID["BR"] = 15] = "BR";
  TAG_ID[TAG_ID["BUTTON"] = 16] = "BUTTON";
  TAG_ID[TAG_ID["CAPTION"] = 17] = "CAPTION";
  TAG_ID[TAG_ID["CENTER"] = 18] = "CENTER";
  TAG_ID[TAG_ID["CODE"] = 19] = "CODE";
  TAG_ID[TAG_ID["COL"] = 20] = "COL";
  TAG_ID[TAG_ID["COLGROUP"] = 21] = "COLGROUP";
  TAG_ID[TAG_ID["DD"] = 22] = "DD";
  TAG_ID[TAG_ID["DESC"] = 23] = "DESC";
  TAG_ID[TAG_ID["DETAILS"] = 24] = "DETAILS";
  TAG_ID[TAG_ID["DIALOG"] = 25] = "DIALOG";
  TAG_ID[TAG_ID["DIR"] = 26] = "DIR";
  TAG_ID[TAG_ID["DIV"] = 27] = "DIV";
  TAG_ID[TAG_ID["DL"] = 28] = "DL";
  TAG_ID[TAG_ID["DT"] = 29] = "DT";
  TAG_ID[TAG_ID["EM"] = 30] = "EM";
  TAG_ID[TAG_ID["EMBED"] = 31] = "EMBED";
  TAG_ID[TAG_ID["FIELDSET"] = 32] = "FIELDSET";
  TAG_ID[TAG_ID["FIGCAPTION"] = 33] = "FIGCAPTION";
  TAG_ID[TAG_ID["FIGURE"] = 34] = "FIGURE";
  TAG_ID[TAG_ID["FONT"] = 35] = "FONT";
  TAG_ID[TAG_ID["FOOTER"] = 36] = "FOOTER";
  TAG_ID[TAG_ID["FOREIGN_OBJECT"] = 37] = "FOREIGN_OBJECT";
  TAG_ID[TAG_ID["FORM"] = 38] = "FORM";
  TAG_ID[TAG_ID["FRAME"] = 39] = "FRAME";
  TAG_ID[TAG_ID["FRAMESET"] = 40] = "FRAMESET";
  TAG_ID[TAG_ID["H1"] = 41] = "H1";
  TAG_ID[TAG_ID["H2"] = 42] = "H2";
  TAG_ID[TAG_ID["H3"] = 43] = "H3";
  TAG_ID[TAG_ID["H4"] = 44] = "H4";
  TAG_ID[TAG_ID["H5"] = 45] = "H5";
  TAG_ID[TAG_ID["H6"] = 46] = "H6";
  TAG_ID[TAG_ID["HEAD"] = 47] = "HEAD";
  TAG_ID[TAG_ID["HEADER"] = 48] = "HEADER";
  TAG_ID[TAG_ID["HGROUP"] = 49] = "HGROUP";
  TAG_ID[TAG_ID["HR"] = 50] = "HR";
  TAG_ID[TAG_ID["HTML"] = 51] = "HTML";
  TAG_ID[TAG_ID["I"] = 52] = "I";
  TAG_ID[TAG_ID["IMG"] = 53] = "IMG";
  TAG_ID[TAG_ID["IMAGE"] = 54] = "IMAGE";
  TAG_ID[TAG_ID["INPUT"] = 55] = "INPUT";
  TAG_ID[TAG_ID["IFRAME"] = 56] = "IFRAME";
  TAG_ID[TAG_ID["KEYGEN"] = 57] = "KEYGEN";
  TAG_ID[TAG_ID["LABEL"] = 58] = "LABEL";
  TAG_ID[TAG_ID["LI"] = 59] = "LI";
  TAG_ID[TAG_ID["LINK"] = 60] = "LINK";
  TAG_ID[TAG_ID["LISTING"] = 61] = "LISTING";
  TAG_ID[TAG_ID["MAIN"] = 62] = "MAIN";
  TAG_ID[TAG_ID["MALIGNMARK"] = 63] = "MALIGNMARK";
  TAG_ID[TAG_ID["MARQUEE"] = 64] = "MARQUEE";
  TAG_ID[TAG_ID["MATH"] = 65] = "MATH";
  TAG_ID[TAG_ID["MENU"] = 66] = "MENU";
  TAG_ID[TAG_ID["META"] = 67] = "META";
  TAG_ID[TAG_ID["MGLYPH"] = 68] = "MGLYPH";
  TAG_ID[TAG_ID["MI"] = 69] = "MI";
  TAG_ID[TAG_ID["MO"] = 70] = "MO";
  TAG_ID[TAG_ID["MN"] = 71] = "MN";
  TAG_ID[TAG_ID["MS"] = 72] = "MS";
  TAG_ID[TAG_ID["MTEXT"] = 73] = "MTEXT";
  TAG_ID[TAG_ID["NAV"] = 74] = "NAV";
  TAG_ID[TAG_ID["NOBR"] = 75] = "NOBR";
  TAG_ID[TAG_ID["NOFRAMES"] = 76] = "NOFRAMES";
  TAG_ID[TAG_ID["NOEMBED"] = 77] = "NOEMBED";
  TAG_ID[TAG_ID["NOSCRIPT"] = 78] = "NOSCRIPT";
  TAG_ID[TAG_ID["OBJECT"] = 79] = "OBJECT";
  TAG_ID[TAG_ID["OL"] = 80] = "OL";
  TAG_ID[TAG_ID["OPTGROUP"] = 81] = "OPTGROUP";
  TAG_ID[TAG_ID["OPTION"] = 82] = "OPTION";
  TAG_ID[TAG_ID["P"] = 83] = "P";
  TAG_ID[TAG_ID["PARAM"] = 84] = "PARAM";
  TAG_ID[TAG_ID["PLAINTEXT"] = 85] = "PLAINTEXT";
  TAG_ID[TAG_ID["PRE"] = 86] = "PRE";
  TAG_ID[TAG_ID["RB"] = 87] = "RB";
  TAG_ID[TAG_ID["RP"] = 88] = "RP";
  TAG_ID[TAG_ID["RT"] = 89] = "RT";
  TAG_ID[TAG_ID["RTC"] = 90] = "RTC";
  TAG_ID[TAG_ID["RUBY"] = 91] = "RUBY";
  TAG_ID[TAG_ID["S"] = 92] = "S";
  TAG_ID[TAG_ID["SCRIPT"] = 93] = "SCRIPT";
  TAG_ID[TAG_ID["SEARCH"] = 94] = "SEARCH";
  TAG_ID[TAG_ID["SECTION"] = 95] = "SECTION";
  TAG_ID[TAG_ID["SELECT"] = 96] = "SELECT";
  TAG_ID[TAG_ID["SOURCE"] = 97] = "SOURCE";
  TAG_ID[TAG_ID["SMALL"] = 98] = "SMALL";
  TAG_ID[TAG_ID["SPAN"] = 99] = "SPAN";
  TAG_ID[TAG_ID["STRIKE"] = 100] = "STRIKE";
  TAG_ID[TAG_ID["STRONG"] = 101] = "STRONG";
  TAG_ID[TAG_ID["STYLE"] = 102] = "STYLE";
  TAG_ID[TAG_ID["SUB"] = 103] = "SUB";
  TAG_ID[TAG_ID["SUMMARY"] = 104] = "SUMMARY";
  TAG_ID[TAG_ID["SUP"] = 105] = "SUP";
  TAG_ID[TAG_ID["TABLE"] = 106] = "TABLE";
  TAG_ID[TAG_ID["TBODY"] = 107] = "TBODY";
  TAG_ID[TAG_ID["TEMPLATE"] = 108] = "TEMPLATE";
  TAG_ID[TAG_ID["TEXTAREA"] = 109] = "TEXTAREA";
  TAG_ID[TAG_ID["TFOOT"] = 110] = "TFOOT";
  TAG_ID[TAG_ID["TD"] = 111] = "TD";
  TAG_ID[TAG_ID["TH"] = 112] = "TH";
  TAG_ID[TAG_ID["THEAD"] = 113] = "THEAD";
  TAG_ID[TAG_ID["TITLE"] = 114] = "TITLE";
  TAG_ID[TAG_ID["TR"] = 115] = "TR";
  TAG_ID[TAG_ID["TRACK"] = 116] = "TRACK";
  TAG_ID[TAG_ID["TT"] = 117] = "TT";
  TAG_ID[TAG_ID["U"] = 118] = "U";
  TAG_ID[TAG_ID["UL"] = 119] = "UL";
  TAG_ID[TAG_ID["SVG"] = 120] = "SVG";
  TAG_ID[TAG_ID["VAR"] = 121] = "VAR";
  TAG_ID[TAG_ID["WBR"] = 122] = "WBR";
  TAG_ID[TAG_ID["XMP"] = 123] = "XMP";
})(TAG_ID || (TAG_ID = {}));
var TAG_NAME_TO_ID = new Map([[TAG_NAMES.A, TAG_ID.A], [TAG_NAMES.ADDRESS, TAG_ID.ADDRESS], [TAG_NAMES.ANNOTATION_XML, TAG_ID.ANNOTATION_XML], [TAG_NAMES.APPLET, TAG_ID.APPLET], [TAG_NAMES.AREA, TAG_ID.AREA], [TAG_NAMES.ARTICLE, TAG_ID.ARTICLE], [TAG_NAMES.ASIDE, TAG_ID.ASIDE], [TAG_NAMES.B, TAG_ID.B], [TAG_NAMES.BASE, TAG_ID.BASE], [TAG_NAMES.BASEFONT, TAG_ID.BASEFONT], [TAG_NAMES.BGSOUND, TAG_ID.BGSOUND], [TAG_NAMES.BIG, TAG_ID.BIG], [TAG_NAMES.BLOCKQUOTE, TAG_ID.BLOCKQUOTE], [TAG_NAMES.BODY, TAG_ID.BODY], [TAG_NAMES.BR, TAG_ID.BR], [TAG_NAMES.BUTTON, TAG_ID.BUTTON], [TAG_NAMES.CAPTION, TAG_ID.CAPTION], [TAG_NAMES.CENTER, TAG_ID.CENTER], [TAG_NAMES.CODE, TAG_ID.CODE], [TAG_NAMES.COL, TAG_ID.COL], [TAG_NAMES.COLGROUP, TAG_ID.COLGROUP], [TAG_NAMES.DD, TAG_ID.DD], [TAG_NAMES.DESC, TAG_ID.DESC], [TAG_NAMES.DETAILS, TAG_ID.DETAILS], [TAG_NAMES.DIALOG, TAG_ID.DIALOG], [TAG_NAMES.DIR, TAG_ID.DIR], [TAG_NAMES.DIV, TAG_ID.DIV], [TAG_NAMES.DL, TAG_ID.DL], [TAG_NAMES.DT, TAG_ID.DT], [TAG_NAMES.EM, TAG_ID.EM], [TAG_NAMES.EMBED, TAG_ID.EMBED], [TAG_NAMES.FIELDSET, TAG_ID.FIELDSET], [TAG_NAMES.FIGCAPTION, TAG_ID.FIGCAPTION], [TAG_NAMES.FIGURE, TAG_ID.FIGURE], [TAG_NAMES.FONT, TAG_ID.FONT], [TAG_NAMES.FOOTER, TAG_ID.FOOTER], [TAG_NAMES.FOREIGN_OBJECT, TAG_ID.FOREIGN_OBJECT], [TAG_NAMES.FORM, TAG_ID.FORM], [TAG_NAMES.FRAME, TAG_ID.FRAME], [TAG_NAMES.FRAMESET, TAG_ID.FRAMESET], [TAG_NAMES.H1, TAG_ID.H1], [TAG_NAMES.H2, TAG_ID.H2], [TAG_NAMES.H3, TAG_ID.H3], [TAG_NAMES.H4, TAG_ID.H4], [TAG_NAMES.H5, TAG_ID.H5], [TAG_NAMES.H6, TAG_ID.H6], [TAG_NAMES.HEAD, TAG_ID.HEAD], [TAG_NAMES.HEADER, TAG_ID.HEADER], [TAG_NAMES.HGROUP, TAG_ID.HGROUP], [TAG_NAMES.HR, TAG_ID.HR], [TAG_NAMES.HTML, TAG_ID.HTML], [TAG_NAMES.I, TAG_ID.I], [TAG_NAMES.IMG, TAG_ID.IMG], [TAG_NAMES.IMAGE, TAG_ID.IMAGE], [TAG_NAMES.INPUT, TAG_ID.INPUT], [TAG_NAMES.IFRAME, TAG_ID.IFRAME], [TAG_NAMES.KEYGEN, TAG_ID.KEYGEN], [TAG_NAMES.LABEL, TAG_ID.LABEL], [TAG_NAMES.LI, TAG_ID.LI], [TAG_NAMES.LINK, TAG_ID.LINK], [TAG_NAMES.LISTING, TAG_ID.LISTING], [TAG_NAMES.MAIN, TAG_ID.MAIN], [TAG_NAMES.MALIGNMARK, TAG_ID.MALIGNMARK], [TAG_NAMES.MARQUEE, TAG_ID.MARQUEE], [TAG_NAMES.MATH, TAG_ID.MATH], [TAG_NAMES.MENU, TAG_ID.MENU], [TAG_NAMES.META, TAG_ID.META], [TAG_NAMES.MGLYPH, TAG_ID.MGLYPH], [TAG_NAMES.MI, TAG_ID.MI], [TAG_NAMES.MO, TAG_ID.MO], [TAG_NAMES.MN, TAG_ID.MN], [TAG_NAMES.MS, TAG_ID.MS], [TAG_NAMES.MTEXT, TAG_ID.MTEXT], [TAG_NAMES.NAV, TAG_ID.NAV], [TAG_NAMES.NOBR, TAG_ID.NOBR], [TAG_NAMES.NOFRAMES, TAG_ID.NOFRAMES], [TAG_NAMES.NOEMBED, TAG_ID.NOEMBED], [TAG_NAMES.NOSCRIPT, TAG_ID.NOSCRIPT], [TAG_NAMES.OBJECT, TAG_ID.OBJECT], [TAG_NAMES.OL, TAG_ID.OL], [TAG_NAMES.OPTGROUP, TAG_ID.OPTGROUP], [TAG_NAMES.OPTION, TAG_ID.OPTION], [TAG_NAMES.P, TAG_ID.P], [TAG_NAMES.PARAM, TAG_ID.PARAM], [TAG_NAMES.PLAINTEXT, TAG_ID.PLAINTEXT], [TAG_NAMES.PRE, TAG_ID.PRE], [TAG_NAMES.RB, TAG_ID.RB], [TAG_NAMES.RP, TAG_ID.RP], [TAG_NAMES.RT, TAG_ID.RT], [TAG_NAMES.RTC, TAG_ID.RTC], [TAG_NAMES.RUBY, TAG_ID.RUBY], [TAG_NAMES.S, TAG_ID.S], [TAG_NAMES.SCRIPT, TAG_ID.SCRIPT], [TAG_NAMES.SEARCH, TAG_ID.SEARCH], [TAG_NAMES.SECTION, TAG_ID.SECTION], [TAG_NAMES.SELECT, TAG_ID.SELECT], [TAG_NAMES.SOURCE, TAG_ID.SOURCE], [TAG_NAMES.SMALL, TAG_ID.SMALL], [TAG_NAMES.SPAN, TAG_ID.SPAN], [TAG_NAMES.STRIKE, TAG_ID.STRIKE], [TAG_NAMES.STRONG, TAG_ID.STRONG], [TAG_NAMES.STYLE, TAG_ID.STYLE], [TAG_NAMES.SUB, TAG_ID.SUB], [TAG_NAMES.SUMMARY, TAG_ID.SUMMARY], [TAG_NAMES.SUP, TAG_ID.SUP], [TAG_NAMES.TABLE, TAG_ID.TABLE], [TAG_NAMES.TBODY, TAG_ID.TBODY], [TAG_NAMES.TEMPLATE, TAG_ID.TEMPLATE], [TAG_NAMES.TEXTAREA, TAG_ID.TEXTAREA], [TAG_NAMES.TFOOT, TAG_ID.TFOOT], [TAG_NAMES.TD, TAG_ID.TD], [TAG_NAMES.TH, TAG_ID.TH], [TAG_NAMES.THEAD, TAG_ID.THEAD], [TAG_NAMES.TITLE, TAG_ID.TITLE], [TAG_NAMES.TR, TAG_ID.TR], [TAG_NAMES.TRACK, TAG_ID.TRACK], [TAG_NAMES.TT, TAG_ID.TT], [TAG_NAMES.U, TAG_ID.U], [TAG_NAMES.UL, TAG_ID.UL], [TAG_NAMES.SVG, TAG_ID.SVG], [TAG_NAMES.VAR, TAG_ID.VAR], [TAG_NAMES.WBR, TAG_ID.WBR], [TAG_NAMES.XMP, TAG_ID.XMP]]);
function getTagID(tagName) {
  var _a;
  return (_a = TAG_NAME_TO_ID.get(tagName)) !== null && _a !== void 0 ? _a : TAG_ID.UNKNOWN;
}
var $ = TAG_ID;
var SPECIAL_ELEMENTS = _defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1({}, NS.HTML, new Set([$.ADDRESS, $.APPLET, $.AREA, $.ARTICLE, $.ASIDE, $.BASE, $.BASEFONT, $.BGSOUND, $.BLOCKQUOTE, $.BODY, $.BR, $.BUTTON, $.CAPTION, $.CENTER, $.COL, $.COLGROUP, $.DD, $.DETAILS, $.DIR, $.DIV, $.DL, $.DT, $.EMBED, $.FIELDSET, $.FIGCAPTION, $.FIGURE, $.FOOTER, $.FORM, $.FRAME, $.FRAMESET, $.H1, $.H2, $.H3, $.H4, $.H5, $.H6, $.HEAD, $.HEADER, $.HGROUP, $.HR, $.HTML, $.IFRAME, $.IMG, $.INPUT, $.LI, $.LINK, $.LISTING, $.MAIN, $.MARQUEE, $.MENU, $.META, $.NAV, $.NOEMBED, $.NOFRAMES, $.NOSCRIPT, $.OBJECT, $.OL, $.P, $.PARAM, $.PLAINTEXT, $.PRE, $.SCRIPT, $.SECTION, $.SELECT, $.SOURCE, $.STYLE, $.SUMMARY, $.TABLE, $.TBODY, $.TD, $.TEMPLATE, $.TEXTAREA, $.TFOOT, $.TH, $.THEAD, $.TITLE, $.TR, $.TRACK, $.UL, $.WBR, $.XMP])), NS.MATHML, new Set([$.MI, $.MO, $.MN, $.MS, $.MTEXT, $.ANNOTATION_XML])), NS.SVG, new Set([$.TITLE, $.FOREIGN_OBJECT, $.DESC])), NS.XLINK, new Set()), NS.XML, new Set()), NS.XMLNS, new Set());
var NUMBERED_HEADERS = new Set([$.H1, $.H2, $.H3, $.H4, $.H5, $.H6]);
new Set([TAG_NAMES.STYLE, TAG_NAMES.SCRIPT, TAG_NAMES.XMP, TAG_NAMES.IFRAME, TAG_NAMES.NOEMBED, TAG_NAMES.NOFRAMES, TAG_NAMES.PLAINTEXT]);

//States
var State$1;
(function (State) {
  State[State["DATA"] = 0] = "DATA";
  State[State["RCDATA"] = 1] = "RCDATA";
  State[State["RAWTEXT"] = 2] = "RAWTEXT";
  State[State["SCRIPT_DATA"] = 3] = "SCRIPT_DATA";
  State[State["PLAINTEXT"] = 4] = "PLAINTEXT";
  State[State["TAG_OPEN"] = 5] = "TAG_OPEN";
  State[State["END_TAG_OPEN"] = 6] = "END_TAG_OPEN";
  State[State["TAG_NAME"] = 7] = "TAG_NAME";
  State[State["RCDATA_LESS_THAN_SIGN"] = 8] = "RCDATA_LESS_THAN_SIGN";
  State[State["RCDATA_END_TAG_OPEN"] = 9] = "RCDATA_END_TAG_OPEN";
  State[State["RCDATA_END_TAG_NAME"] = 10] = "RCDATA_END_TAG_NAME";
  State[State["RAWTEXT_LESS_THAN_SIGN"] = 11] = "RAWTEXT_LESS_THAN_SIGN";
  State[State["RAWTEXT_END_TAG_OPEN"] = 12] = "RAWTEXT_END_TAG_OPEN";
  State[State["RAWTEXT_END_TAG_NAME"] = 13] = "RAWTEXT_END_TAG_NAME";
  State[State["SCRIPT_DATA_LESS_THAN_SIGN"] = 14] = "SCRIPT_DATA_LESS_THAN_SIGN";
  State[State["SCRIPT_DATA_END_TAG_OPEN"] = 15] = "SCRIPT_DATA_END_TAG_OPEN";
  State[State["SCRIPT_DATA_END_TAG_NAME"] = 16] = "SCRIPT_DATA_END_TAG_NAME";
  State[State["SCRIPT_DATA_ESCAPE_START"] = 17] = "SCRIPT_DATA_ESCAPE_START";
  State[State["SCRIPT_DATA_ESCAPE_START_DASH"] = 18] = "SCRIPT_DATA_ESCAPE_START_DASH";
  State[State["SCRIPT_DATA_ESCAPED"] = 19] = "SCRIPT_DATA_ESCAPED";
  State[State["SCRIPT_DATA_ESCAPED_DASH"] = 20] = "SCRIPT_DATA_ESCAPED_DASH";
  State[State["SCRIPT_DATA_ESCAPED_DASH_DASH"] = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH";
  State[State["SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN"] = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN";
  State[State["SCRIPT_DATA_ESCAPED_END_TAG_OPEN"] = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN";
  State[State["SCRIPT_DATA_ESCAPED_END_TAG_NAME"] = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME";
  State[State["SCRIPT_DATA_DOUBLE_ESCAPE_START"] = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START";
  State[State["SCRIPT_DATA_DOUBLE_ESCAPED"] = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED";
  State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH"] = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH";
  State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH"] = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH";
  State[State["SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN"] = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN";
  State[State["SCRIPT_DATA_DOUBLE_ESCAPE_END"] = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END";
  State[State["BEFORE_ATTRIBUTE_NAME"] = 31] = "BEFORE_ATTRIBUTE_NAME";
  State[State["ATTRIBUTE_NAME"] = 32] = "ATTRIBUTE_NAME";
  State[State["AFTER_ATTRIBUTE_NAME"] = 33] = "AFTER_ATTRIBUTE_NAME";
  State[State["BEFORE_ATTRIBUTE_VALUE"] = 34] = "BEFORE_ATTRIBUTE_VALUE";
  State[State["ATTRIBUTE_VALUE_DOUBLE_QUOTED"] = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED";
  State[State["ATTRIBUTE_VALUE_SINGLE_QUOTED"] = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED";
  State[State["ATTRIBUTE_VALUE_UNQUOTED"] = 37] = "ATTRIBUTE_VALUE_UNQUOTED";
  State[State["AFTER_ATTRIBUTE_VALUE_QUOTED"] = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED";
  State[State["SELF_CLOSING_START_TAG"] = 39] = "SELF_CLOSING_START_TAG";
  State[State["BOGUS_COMMENT"] = 40] = "BOGUS_COMMENT";
  State[State["MARKUP_DECLARATION_OPEN"] = 41] = "MARKUP_DECLARATION_OPEN";
  State[State["COMMENT_START"] = 42] = "COMMENT_START";
  State[State["COMMENT_START_DASH"] = 43] = "COMMENT_START_DASH";
  State[State["COMMENT"] = 44] = "COMMENT";
  State[State["COMMENT_LESS_THAN_SIGN"] = 45] = "COMMENT_LESS_THAN_SIGN";
  State[State["COMMENT_LESS_THAN_SIGN_BANG"] = 46] = "COMMENT_LESS_THAN_SIGN_BANG";
  State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH"] = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH";
  State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH"] = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH";
  State[State["COMMENT_END_DASH"] = 49] = "COMMENT_END_DASH";
  State[State["COMMENT_END"] = 50] = "COMMENT_END";
  State[State["COMMENT_END_BANG"] = 51] = "COMMENT_END_BANG";
  State[State["DOCTYPE"] = 52] = "DOCTYPE";
  State[State["BEFORE_DOCTYPE_NAME"] = 53] = "BEFORE_DOCTYPE_NAME";
  State[State["DOCTYPE_NAME"] = 54] = "DOCTYPE_NAME";
  State[State["AFTER_DOCTYPE_NAME"] = 55] = "AFTER_DOCTYPE_NAME";
  State[State["AFTER_DOCTYPE_PUBLIC_KEYWORD"] = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD";
  State[State["BEFORE_DOCTYPE_PUBLIC_IDENTIFIER"] = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER";
  State[State["DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED"] = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED";
  State[State["DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED"] = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED";
  State[State["AFTER_DOCTYPE_PUBLIC_IDENTIFIER"] = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER";
  State[State["BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS"] = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS";
  State[State["AFTER_DOCTYPE_SYSTEM_KEYWORD"] = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD";
  State[State["BEFORE_DOCTYPE_SYSTEM_IDENTIFIER"] = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER";
  State[State["DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED"] = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED";
  State[State["DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED"] = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED";
  State[State["AFTER_DOCTYPE_SYSTEM_IDENTIFIER"] = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER";
  State[State["BOGUS_DOCTYPE"] = 67] = "BOGUS_DOCTYPE";
  State[State["CDATA_SECTION"] = 68] = "CDATA_SECTION";
  State[State["CDATA_SECTION_BRACKET"] = 69] = "CDATA_SECTION_BRACKET";
  State[State["CDATA_SECTION_END"] = 70] = "CDATA_SECTION_END";
  State[State["CHARACTER_REFERENCE"] = 71] = "CHARACTER_REFERENCE";
  State[State["AMBIGUOUS_AMPERSAND"] = 72] = "AMBIGUOUS_AMPERSAND";
})(State$1 || (State$1 = {}));
//Tokenizer initial states for different modes
var TokenizerMode = {
  DATA: State$1.DATA,
  RCDATA: State$1.RCDATA,
  RAWTEXT: State$1.RAWTEXT,
  SCRIPT_DATA: State$1.SCRIPT_DATA,
  PLAINTEXT: State$1.PLAINTEXT,
  CDATA_SECTION: State$1.CDATA_SECTION
};
//Utils
//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isAsciiDigit(cp) {
  return cp >= CODE_POINTS.DIGIT_0 && cp <= CODE_POINTS.DIGIT_9;
}
function isAsciiUpper(cp) {
  return cp >= CODE_POINTS.LATIN_CAPITAL_A && cp <= CODE_POINTS.LATIN_CAPITAL_Z;
}
function isAsciiLower(cp) {
  return cp >= CODE_POINTS.LATIN_SMALL_A && cp <= CODE_POINTS.LATIN_SMALL_Z;
}
function isAsciiLetter(cp) {
  return isAsciiLower(cp) || isAsciiUpper(cp);
}
function isAsciiAlphaNumeric(cp) {
  return isAsciiLetter(cp) || isAsciiDigit(cp);
}
function toAsciiLower(cp) {
  return cp + 32;
}
function isWhitespace(cp) {
  return cp === CODE_POINTS.SPACE || cp === CODE_POINTS.LINE_FEED || cp === CODE_POINTS.TABULATION || cp === CODE_POINTS.FORM_FEED;
}
function isScriptDataDoubleEscapeSequenceEnd(cp) {
  return isWhitespace(cp) || cp === CODE_POINTS.SOLIDUS || cp === CODE_POINTS.GREATER_THAN_SIGN;
}
function getErrorForNumericCharacterReference(code) {
  if (code === CODE_POINTS.NULL) {
    return ERR.nullCharacterReference;
  } else if (code > 1114111) {
    return ERR.characterReferenceOutsideUnicodeRange;
  } else if (isSurrogate(code)) {
    return ERR.surrogateCharacterReference;
  } else if (isUndefinedCodePoint(code)) {
    return ERR.noncharacterCharacterReference;
  } else if (isControlCodePoint(code) || code === CODE_POINTS.CARRIAGE_RETURN) {
    return ERR.controlCharacterReference;
  }
  return null;
}
//Tokenizer
var Tokenizer = /*#__PURE__*/function () {
  function Tokenizer(options, handler) {
    var _this = this;
    _classCallCheck$1(this, Tokenizer);
    this.options = options;
    this.handler = handler;
    this.paused = false;
    /** Ensures that the parsing loop isn't run multiple times at once. */
    this.inLoop = false;
    /**
     * Indicates that the current adjusted node exists, is not an element in the HTML namespace,
     * and that it is not an integration point for either MathML or HTML.
     *
     * @see {@link https://html.spec.whatwg.org/multipage/parsing.html#tree-construction}
     */
    this.inForeignNode = false;
    this.lastStartTagName = '';
    this.active = false;
    this.state = State$1.DATA;
    this.returnState = State$1.DATA;
    this.entityStartPos = 0;
    this.consumedAfterSnapshot = -1;
    this.currentCharacterToken = null;
    this.currentToken = null;
    this.currentAttr = {
      name: '',
      value: ''
    };
    this.preprocessor = new Preprocessor(handler);
    this.currentLocation = this.getCurrentLocation(-1);
    this.entityDecoder = new EntityDecoder(htmlDecodeTree, function (cp, consumed) {
      // Note: Set `pos` _before_ flushing, as flushing might drop
      // the current chunk and invalidate `entityStartPos`.
      _this.preprocessor.pos = _this.entityStartPos + consumed - 1;
      _this._flushCodePointConsumedAsCharacterReference(cp);
    }, handler.onParseError ? {
      missingSemicolonAfterCharacterReference: function missingSemicolonAfterCharacterReference() {
        _this._err(ERR.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: function absenceOfDigitsInNumericCharacterReference(consumed) {
        _this._err(ERR.absenceOfDigitsInNumericCharacterReference, _this.entityStartPos - _this.preprocessor.pos + consumed);
      },
      validateNumericCharacterReference: function validateNumericCharacterReference(code) {
        var error = getErrorForNumericCharacterReference(code);
        if (error) _this._err(error, 1);
      }
    } : undefined);
  }
  //Errors
  return _createClass$1(Tokenizer, [{
    key: "_err",
    value: function _err(code) {
      var cpOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _a, _b;
      (_b = (_a = this.handler).onParseError) === null || _b === void 0 ? void 0 : _b.call(_a, this.preprocessor.getError(code, cpOffset));
    }
    // NOTE: `offset` may never run across line boundaries.
  }, {
    key: "getCurrentLocation",
    value: function getCurrentLocation(offset) {
      if (!this.options.sourceCodeLocationInfo) {
        return null;
      }
      return {
        startLine: this.preprocessor.line,
        startCol: this.preprocessor.col - offset,
        startOffset: this.preprocessor.offset - offset,
        endLine: -1,
        endCol: -1,
        endOffset: -1
      };
    }
  }, {
    key: "_runParsingLoop",
    value: function _runParsingLoop() {
      if (this.inLoop) return;
      this.inLoop = true;
      while (this.active && !this.paused) {
        this.consumedAfterSnapshot = 0;
        var cp = this._consume();
        if (!this._ensureHibernation()) {
          this._callState(cp);
        }
      }
      this.inLoop = false;
    }
    //API
  }, {
    key: "pause",
    value: function pause() {
      this.paused = true;
    }
  }, {
    key: "resume",
    value: function resume(writeCallback) {
      if (!this.paused) {
        throw new Error('Parser was already resumed');
      }
      this.paused = false;
      // Necessary for synchronous resume.
      if (this.inLoop) return;
      this._runParsingLoop();
      if (!this.paused) {
        writeCallback === null || writeCallback === void 0 ? void 0 : writeCallback();
      }
    }
  }, {
    key: "write",
    value: function write(chunk, isLastChunk, writeCallback) {
      this.active = true;
      this.preprocessor.write(chunk, isLastChunk);
      this._runParsingLoop();
      if (!this.paused) {
        writeCallback === null || writeCallback === void 0 ? void 0 : writeCallback();
      }
    }
  }, {
    key: "insertHtmlAtCurrentPos",
    value: function insertHtmlAtCurrentPos(chunk) {
      this.active = true;
      this.preprocessor.insertHtmlAtCurrentPos(chunk);
      this._runParsingLoop();
    }
    //Hibernation
  }, {
    key: "_ensureHibernation",
    value: function _ensureHibernation() {
      if (this.preprocessor.endOfChunkHit) {
        this.preprocessor.retreat(this.consumedAfterSnapshot);
        this.consumedAfterSnapshot = 0;
        this.active = false;
        return true;
      }
      return false;
    }
    //Consumption
  }, {
    key: "_consume",
    value: function _consume() {
      this.consumedAfterSnapshot++;
      return this.preprocessor.advance();
    }
  }, {
    key: "_advanceBy",
    value: function _advanceBy(count) {
      this.consumedAfterSnapshot += count;
      for (var i = 0; i < count; i++) {
        this.preprocessor.advance();
      }
    }
  }, {
    key: "_consumeSequenceIfMatch",
    value: function _consumeSequenceIfMatch(pattern, caseSensitive) {
      if (this.preprocessor.startsWith(pattern, caseSensitive)) {
        // We will already have consumed one character before calling this method.
        this._advanceBy(pattern.length - 1);
        return true;
      }
      return false;
    }
    //Token creation
  }, {
    key: "_createStartTagToken",
    value: function _createStartTagToken() {
      this.currentToken = {
        type: TokenType.START_TAG,
        tagName: '',
        tagID: TAG_ID.UNKNOWN,
        selfClosing: false,
        ackSelfClosing: false,
        attrs: [],
        location: this.getCurrentLocation(1)
      };
    }
  }, {
    key: "_createEndTagToken",
    value: function _createEndTagToken() {
      this.currentToken = {
        type: TokenType.END_TAG,
        tagName: '',
        tagID: TAG_ID.UNKNOWN,
        selfClosing: false,
        ackSelfClosing: false,
        attrs: [],
        location: this.getCurrentLocation(2)
      };
    }
  }, {
    key: "_createCommentToken",
    value: function _createCommentToken(offset) {
      this.currentToken = {
        type: TokenType.COMMENT,
        data: '',
        location: this.getCurrentLocation(offset)
      };
    }
  }, {
    key: "_createDoctypeToken",
    value: function _createDoctypeToken(initialName) {
      this.currentToken = {
        type: TokenType.DOCTYPE,
        name: initialName,
        forceQuirks: false,
        publicId: null,
        systemId: null,
        location: this.currentLocation
      };
    }
  }, {
    key: "_createCharacterToken",
    value: function _createCharacterToken(type, chars) {
      this.currentCharacterToken = {
        type: type,
        chars: chars,
        location: this.currentLocation
      };
    }
    //Tag attributes
  }, {
    key: "_createAttr",
    value: function _createAttr(attrNameFirstCh) {
      this.currentAttr = {
        name: attrNameFirstCh,
        value: ''
      };
      this.currentLocation = this.getCurrentLocation(0);
    }
  }, {
    key: "_leaveAttrName",
    value: function _leaveAttrName() {
      var _a;
      var _b;
      var token = this.currentToken;
      if (getTokenAttr(token, this.currentAttr.name) === null) {
        token.attrs.push(this.currentAttr);
        if (token.location && this.currentLocation) {
          var attrLocations = (_a = (_b = token.location).attrs) !== null && _a !== void 0 ? _a : _b.attrs = Object.create(null);
          attrLocations[this.currentAttr.name] = this.currentLocation;
          // Set end location
          this._leaveAttrValue();
        }
      } else {
        this._err(ERR.duplicateAttribute);
      }
    }
  }, {
    key: "_leaveAttrValue",
    value: function _leaveAttrValue() {
      if (this.currentLocation) {
        this.currentLocation.endLine = this.preprocessor.line;
        this.currentLocation.endCol = this.preprocessor.col;
        this.currentLocation.endOffset = this.preprocessor.offset;
      }
    }
    //Token emission
  }, {
    key: "prepareToken",
    value: function prepareToken(ct) {
      this._emitCurrentCharacterToken(ct.location);
      this.currentToken = null;
      if (ct.location) {
        ct.location.endLine = this.preprocessor.line;
        ct.location.endCol = this.preprocessor.col + 1;
        ct.location.endOffset = this.preprocessor.offset + 1;
      }
      this.currentLocation = this.getCurrentLocation(-1);
    }
  }, {
    key: "emitCurrentTagToken",
    value: function emitCurrentTagToken() {
      var ct = this.currentToken;
      this.prepareToken(ct);
      ct.tagID = getTagID(ct.tagName);
      if (ct.type === TokenType.START_TAG) {
        this.lastStartTagName = ct.tagName;
        this.handler.onStartTag(ct);
      } else {
        if (ct.attrs.length > 0) {
          this._err(ERR.endTagWithAttributes);
        }
        if (ct.selfClosing) {
          this._err(ERR.endTagWithTrailingSolidus);
        }
        this.handler.onEndTag(ct);
      }
      this.preprocessor.dropParsedChunk();
    }
  }, {
    key: "emitCurrentComment",
    value: function emitCurrentComment(ct) {
      this.prepareToken(ct);
      this.handler.onComment(ct);
      this.preprocessor.dropParsedChunk();
    }
  }, {
    key: "emitCurrentDoctype",
    value: function emitCurrentDoctype(ct) {
      this.prepareToken(ct);
      this.handler.onDoctype(ct);
      this.preprocessor.dropParsedChunk();
    }
  }, {
    key: "_emitCurrentCharacterToken",
    value: function _emitCurrentCharacterToken(nextLocation) {
      if (this.currentCharacterToken) {
        //NOTE: if we have a pending character token, make it's end location equal to the
        //current token's start location.
        if (nextLocation && this.currentCharacterToken.location) {
          this.currentCharacterToken.location.endLine = nextLocation.startLine;
          this.currentCharacterToken.location.endCol = nextLocation.startCol;
          this.currentCharacterToken.location.endOffset = nextLocation.startOffset;
        }
        switch (this.currentCharacterToken.type) {
          case TokenType.CHARACTER:
            {
              this.handler.onCharacter(this.currentCharacterToken);
              break;
            }
          case TokenType.NULL_CHARACTER:
            {
              this.handler.onNullCharacter(this.currentCharacterToken);
              break;
            }
          case TokenType.WHITESPACE_CHARACTER:
            {
              this.handler.onWhitespaceCharacter(this.currentCharacterToken);
              break;
            }
        }
        this.currentCharacterToken = null;
      }
    }
  }, {
    key: "_emitEOFToken",
    value: function _emitEOFToken() {
      var location = this.getCurrentLocation(0);
      if (location) {
        location.endLine = location.startLine;
        location.endCol = location.startCol;
        location.endOffset = location.startOffset;
      }
      this._emitCurrentCharacterToken(location);
      this.handler.onEof({
        type: TokenType.EOF,
        location: location
      });
      this.active = false;
    }
    //Characters emission
    //OPTIMIZATION: The specification uses only one type of character token (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, the parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  }, {
    key: "_appendCharToCurrentCharacterToken",
    value: function _appendCharToCurrentCharacterToken(type, ch) {
      if (this.currentCharacterToken) {
        if (this.currentCharacterToken.type === type) {
          this.currentCharacterToken.chars += ch;
          return;
        } else {
          this.currentLocation = this.getCurrentLocation(0);
          this._emitCurrentCharacterToken(this.currentLocation);
          this.preprocessor.dropParsedChunk();
        }
      }
      this._createCharacterToken(type, ch);
    }
  }, {
    key: "_emitCodePoint",
    value: function _emitCodePoint(cp) {
      var type = isWhitespace(cp) ? TokenType.WHITESPACE_CHARACTER : cp === CODE_POINTS.NULL ? TokenType.NULL_CHARACTER : TokenType.CHARACTER;
      this._appendCharToCurrentCharacterToken(type, String.fromCodePoint(cp));
    }
    //NOTE: used when we emit characters explicitly.
    //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  }, {
    key: "_emitChars",
    value: function _emitChars(ch) {
      this._appendCharToCurrentCharacterToken(TokenType.CHARACTER, ch);
    }
    // Character reference helpers
  }, {
    key: "_startCharacterReference",
    value: function _startCharacterReference() {
      this.returnState = this.state;
      this.state = State$1.CHARACTER_REFERENCE;
      this.entityStartPos = this.preprocessor.pos;
      this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? DecodingMode.Attribute : DecodingMode.Legacy);
    }
  }, {
    key: "_isCharacterReferenceInAttribute",
    value: function _isCharacterReferenceInAttribute() {
      return this.returnState === State$1.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === State$1.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === State$1.ATTRIBUTE_VALUE_UNQUOTED;
    }
  }, {
    key: "_flushCodePointConsumedAsCharacterReference",
    value: function _flushCodePointConsumedAsCharacterReference(cp) {
      if (this._isCharacterReferenceInAttribute()) {
        this.currentAttr.value += String.fromCodePoint(cp);
      } else {
        this._emitCodePoint(cp);
      }
    }
    // Calling states this way turns out to be much faster than any other approach.
  }, {
    key: "_callState",
    value: function _callState(cp) {
      switch (this.state) {
        case State$1.DATA:
          {
            this._stateData(cp);
            break;
          }
        case State$1.RCDATA:
          {
            this._stateRcdata(cp);
            break;
          }
        case State$1.RAWTEXT:
          {
            this._stateRawtext(cp);
            break;
          }
        case State$1.SCRIPT_DATA:
          {
            this._stateScriptData(cp);
            break;
          }
        case State$1.PLAINTEXT:
          {
            this._statePlaintext(cp);
            break;
          }
        case State$1.TAG_OPEN:
          {
            this._stateTagOpen(cp);
            break;
          }
        case State$1.END_TAG_OPEN:
          {
            this._stateEndTagOpen(cp);
            break;
          }
        case State$1.TAG_NAME:
          {
            this._stateTagName(cp);
            break;
          }
        case State$1.RCDATA_LESS_THAN_SIGN:
          {
            this._stateRcdataLessThanSign(cp);
            break;
          }
        case State$1.RCDATA_END_TAG_OPEN:
          {
            this._stateRcdataEndTagOpen(cp);
            break;
          }
        case State$1.RCDATA_END_TAG_NAME:
          {
            this._stateRcdataEndTagName(cp);
            break;
          }
        case State$1.RAWTEXT_LESS_THAN_SIGN:
          {
            this._stateRawtextLessThanSign(cp);
            break;
          }
        case State$1.RAWTEXT_END_TAG_OPEN:
          {
            this._stateRawtextEndTagOpen(cp);
            break;
          }
        case State$1.RAWTEXT_END_TAG_NAME:
          {
            this._stateRawtextEndTagName(cp);
            break;
          }
        case State$1.SCRIPT_DATA_LESS_THAN_SIGN:
          {
            this._stateScriptDataLessThanSign(cp);
            break;
          }
        case State$1.SCRIPT_DATA_END_TAG_OPEN:
          {
            this._stateScriptDataEndTagOpen(cp);
            break;
          }
        case State$1.SCRIPT_DATA_END_TAG_NAME:
          {
            this._stateScriptDataEndTagName(cp);
            break;
          }
        case State$1.SCRIPT_DATA_ESCAPE_START:
          {
            this._stateScriptDataEscapeStart(cp);
            break;
          }
        case State$1.SCRIPT_DATA_ESCAPE_START_DASH:
          {
            this._stateScriptDataEscapeStartDash(cp);
            break;
          }
        case State$1.SCRIPT_DATA_ESCAPED:
          {
            this._stateScriptDataEscaped(cp);
            break;
          }
        case State$1.SCRIPT_DATA_ESCAPED_DASH:
          {
            this._stateScriptDataEscapedDash(cp);
            break;
          }
        case State$1.SCRIPT_DATA_ESCAPED_DASH_DASH:
          {
            this._stateScriptDataEscapedDashDash(cp);
            break;
          }
        case State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN:
          {
            this._stateScriptDataEscapedLessThanSign(cp);
            break;
          }
        case State$1.SCRIPT_DATA_ESCAPED_END_TAG_OPEN:
          {
            this._stateScriptDataEscapedEndTagOpen(cp);
            break;
          }
        case State$1.SCRIPT_DATA_ESCAPED_END_TAG_NAME:
          {
            this._stateScriptDataEscapedEndTagName(cp);
            break;
          }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPE_START:
          {
            this._stateScriptDataDoubleEscapeStart(cp);
            break;
          }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPED:
          {
            this._stateScriptDataDoubleEscaped(cp);
            break;
          }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH:
          {
            this._stateScriptDataDoubleEscapedDash(cp);
            break;
          }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH:
          {
            this._stateScriptDataDoubleEscapedDashDash(cp);
            break;
          }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN:
          {
            this._stateScriptDataDoubleEscapedLessThanSign(cp);
            break;
          }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPE_END:
          {
            this._stateScriptDataDoubleEscapeEnd(cp);
            break;
          }
        case State$1.BEFORE_ATTRIBUTE_NAME:
          {
            this._stateBeforeAttributeName(cp);
            break;
          }
        case State$1.ATTRIBUTE_NAME:
          {
            this._stateAttributeName(cp);
            break;
          }
        case State$1.AFTER_ATTRIBUTE_NAME:
          {
            this._stateAfterAttributeName(cp);
            break;
          }
        case State$1.BEFORE_ATTRIBUTE_VALUE:
          {
            this._stateBeforeAttributeValue(cp);
            break;
          }
        case State$1.ATTRIBUTE_VALUE_DOUBLE_QUOTED:
          {
            this._stateAttributeValueDoubleQuoted(cp);
            break;
          }
        case State$1.ATTRIBUTE_VALUE_SINGLE_QUOTED:
          {
            this._stateAttributeValueSingleQuoted(cp);
            break;
          }
        case State$1.ATTRIBUTE_VALUE_UNQUOTED:
          {
            this._stateAttributeValueUnquoted(cp);
            break;
          }
        case State$1.AFTER_ATTRIBUTE_VALUE_QUOTED:
          {
            this._stateAfterAttributeValueQuoted(cp);
            break;
          }
        case State$1.SELF_CLOSING_START_TAG:
          {
            this._stateSelfClosingStartTag(cp);
            break;
          }
        case State$1.BOGUS_COMMENT:
          {
            this._stateBogusComment(cp);
            break;
          }
        case State$1.MARKUP_DECLARATION_OPEN:
          {
            this._stateMarkupDeclarationOpen(cp);
            break;
          }
        case State$1.COMMENT_START:
          {
            this._stateCommentStart(cp);
            break;
          }
        case State$1.COMMENT_START_DASH:
          {
            this._stateCommentStartDash(cp);
            break;
          }
        case State$1.COMMENT:
          {
            this._stateComment(cp);
            break;
          }
        case State$1.COMMENT_LESS_THAN_SIGN:
          {
            this._stateCommentLessThanSign(cp);
            break;
          }
        case State$1.COMMENT_LESS_THAN_SIGN_BANG:
          {
            this._stateCommentLessThanSignBang(cp);
            break;
          }
        case State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH:
          {
            this._stateCommentLessThanSignBangDash(cp);
            break;
          }
        case State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH:
          {
            this._stateCommentLessThanSignBangDashDash(cp);
            break;
          }
        case State$1.COMMENT_END_DASH:
          {
            this._stateCommentEndDash(cp);
            break;
          }
        case State$1.COMMENT_END:
          {
            this._stateCommentEnd(cp);
            break;
          }
        case State$1.COMMENT_END_BANG:
          {
            this._stateCommentEndBang(cp);
            break;
          }
        case State$1.DOCTYPE:
          {
            this._stateDoctype(cp);
            break;
          }
        case State$1.BEFORE_DOCTYPE_NAME:
          {
            this._stateBeforeDoctypeName(cp);
            break;
          }
        case State$1.DOCTYPE_NAME:
          {
            this._stateDoctypeName(cp);
            break;
          }
        case State$1.AFTER_DOCTYPE_NAME:
          {
            this._stateAfterDoctypeName(cp);
            break;
          }
        case State$1.AFTER_DOCTYPE_PUBLIC_KEYWORD:
          {
            this._stateAfterDoctypePublicKeyword(cp);
            break;
          }
        case State$1.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER:
          {
            this._stateBeforeDoctypePublicIdentifier(cp);
            break;
          }
        case State$1.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED:
          {
            this._stateDoctypePublicIdentifierDoubleQuoted(cp);
            break;
          }
        case State$1.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED:
          {
            this._stateDoctypePublicIdentifierSingleQuoted(cp);
            break;
          }
        case State$1.AFTER_DOCTYPE_PUBLIC_IDENTIFIER:
          {
            this._stateAfterDoctypePublicIdentifier(cp);
            break;
          }
        case State$1.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS:
          {
            this._stateBetweenDoctypePublicAndSystemIdentifiers(cp);
            break;
          }
        case State$1.AFTER_DOCTYPE_SYSTEM_KEYWORD:
          {
            this._stateAfterDoctypeSystemKeyword(cp);
            break;
          }
        case State$1.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER:
          {
            this._stateBeforeDoctypeSystemIdentifier(cp);
            break;
          }
        case State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED:
          {
            this._stateDoctypeSystemIdentifierDoubleQuoted(cp);
            break;
          }
        case State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED:
          {
            this._stateDoctypeSystemIdentifierSingleQuoted(cp);
            break;
          }
        case State$1.AFTER_DOCTYPE_SYSTEM_IDENTIFIER:
          {
            this._stateAfterDoctypeSystemIdentifier(cp);
            break;
          }
        case State$1.BOGUS_DOCTYPE:
          {
            this._stateBogusDoctype(cp);
            break;
          }
        case State$1.CDATA_SECTION:
          {
            this._stateCdataSection(cp);
            break;
          }
        case State$1.CDATA_SECTION_BRACKET:
          {
            this._stateCdataSectionBracket(cp);
            break;
          }
        case State$1.CDATA_SECTION_END:
          {
            this._stateCdataSectionEnd(cp);
            break;
          }
        case State$1.CHARACTER_REFERENCE:
          {
            this._stateCharacterReference();
            break;
          }
        case State$1.AMBIGUOUS_AMPERSAND:
          {
            this._stateAmbiguousAmpersand(cp);
            break;
          }
        default:
          {
            throw new Error('Unknown state');
          }
      }
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
  }, {
    key: "_stateData",
    value: function _stateData(cp) {
      switch (cp) {
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            this.state = State$1.TAG_OPEN;
            break;
          }
        case CODE_POINTS.AMPERSAND:
          {
            this._startCharacterReference();
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this._emitCodePoint(cp);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._emitCodePoint(cp);
          }
      }
    }
    //  RCDATA state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdata",
    value: function _stateRcdata(cp) {
      switch (cp) {
        case CODE_POINTS.AMPERSAND:
          {
            this._startCharacterReference();
            break;
          }
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            this.state = State$1.RCDATA_LESS_THAN_SIGN;
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(REPLACEMENT_CHARACTER);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._emitCodePoint(cp);
          }
      }
    }
    // RAWTEXT state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtext",
    value: function _stateRawtext(cp) {
      switch (cp) {
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            this.state = State$1.RAWTEXT_LESS_THAN_SIGN;
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(REPLACEMENT_CHARACTER);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._emitCodePoint(cp);
          }
      }
    }
    // Script data state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptData",
    value: function _stateScriptData(cp) {
      switch (cp) {
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            this.state = State$1.SCRIPT_DATA_LESS_THAN_SIGN;
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(REPLACEMENT_CHARACTER);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._emitCodePoint(cp);
          }
      }
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
  }, {
    key: "_statePlaintext",
    value: function _statePlaintext(cp) {
      switch (cp) {
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(REPLACEMENT_CHARACTER);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._emitCodePoint(cp);
          }
      }
    }
    // Tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateTagOpen",
    value: function _stateTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this._createStartTagToken();
        this.state = State$1.TAG_NAME;
        this._stateTagName(cp);
      } else switch (cp) {
        case CODE_POINTS.EXCLAMATION_MARK:
          {
            this.state = State$1.MARKUP_DECLARATION_OPEN;
            break;
          }
        case CODE_POINTS.SOLIDUS:
          {
            this.state = State$1.END_TAG_OPEN;
            break;
          }
        case CODE_POINTS.QUESTION_MARK:
          {
            this._err(ERR.unexpectedQuestionMarkInsteadOfTagName);
            this._createCommentToken(1);
            this.state = State$1.BOGUS_COMMENT;
            this._stateBogusComment(cp);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofBeforeTagName);
            this._emitChars('<');
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.invalidFirstCharacterOfTagName);
            this._emitChars('<');
            this.state = State$1.DATA;
            this._stateData(cp);
          }
      }
    }
    // End tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateEndTagOpen",
    value: function _stateEndTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this.state = State$1.TAG_NAME;
        this._stateTagName(cp);
      } else switch (cp) {
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.missingEndTagName);
            this.state = State$1.DATA;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofBeforeTagName);
            this._emitChars('</');
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.invalidFirstCharacterOfTagName);
            this._createCommentToken(2);
            this.state = State$1.BOGUS_COMMENT;
            this._stateBogusComment(cp);
          }
      }
    }
    // Tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateTagName",
    value: function _stateTagName(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            this.state = State$1.BEFORE_ATTRIBUTE_NAME;
            break;
          }
        case CODE_POINTS.SOLIDUS:
          {
            this.state = State$1.SELF_CLOSING_START_TAG;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.state = State$1.DATA;
            this.emitCurrentTagToken();
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            token.tagName += REPLACEMENT_CHARACTER;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
            break;
          }
        default:
          {
            token.tagName += String.fromCodePoint(isAsciiUpper(cp) ? toAsciiLower(cp) : cp);
          }
      }
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdataLessThanSign",
    value: function _stateRcdataLessThanSign(cp) {
      if (cp === CODE_POINTS.SOLIDUS) {
        this.state = State$1.RCDATA_END_TAG_OPEN;
      } else {
        this._emitChars('<');
        this.state = State$1.RCDATA;
        this._stateRcdata(cp);
      }
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdataEndTagOpen",
    value: function _stateRcdataEndTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this.state = State$1.RCDATA_END_TAG_NAME;
        this._stateRcdataEndTagName(cp);
      } else {
        this._emitChars('</');
        this.state = State$1.RCDATA;
        this._stateRcdata(cp);
      }
    }
  }, {
    key: "handleSpecialEndTag",
    value: function handleSpecialEndTag(_cp) {
      if (!this.preprocessor.startsWith(this.lastStartTagName, false)) {
        return !this._ensureHibernation();
      }
      this._createEndTagToken();
      var token = this.currentToken;
      token.tagName = this.lastStartTagName;
      var cp = this.preprocessor.peek(this.lastStartTagName.length);
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            this._advanceBy(this.lastStartTagName.length);
            this.state = State$1.BEFORE_ATTRIBUTE_NAME;
            return false;
          }
        case CODE_POINTS.SOLIDUS:
          {
            this._advanceBy(this.lastStartTagName.length);
            this.state = State$1.SELF_CLOSING_START_TAG;
            return false;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._advanceBy(this.lastStartTagName.length);
            this.emitCurrentTagToken();
            this.state = State$1.DATA;
            return false;
          }
        default:
          {
            return !this._ensureHibernation();
          }
      }
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdataEndTagName",
    value: function _stateRcdataEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars('</');
        this.state = State$1.RCDATA;
        this._stateRcdata(cp);
      }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtextLessThanSign",
    value: function _stateRawtextLessThanSign(cp) {
      if (cp === CODE_POINTS.SOLIDUS) {
        this.state = State$1.RAWTEXT_END_TAG_OPEN;
      } else {
        this._emitChars('<');
        this.state = State$1.RAWTEXT;
        this._stateRawtext(cp);
      }
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtextEndTagOpen",
    value: function _stateRawtextEndTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this.state = State$1.RAWTEXT_END_TAG_NAME;
        this._stateRawtextEndTagName(cp);
      } else {
        this._emitChars('</');
        this.state = State$1.RAWTEXT;
        this._stateRawtext(cp);
      }
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtextEndTagName",
    value: function _stateRawtextEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars('</');
        this.state = State$1.RAWTEXT;
        this._stateRawtext(cp);
      }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataLessThanSign",
    value: function _stateScriptDataLessThanSign(cp) {
      switch (cp) {
        case CODE_POINTS.SOLIDUS:
          {
            this.state = State$1.SCRIPT_DATA_END_TAG_OPEN;
            break;
          }
        case CODE_POINTS.EXCLAMATION_MARK:
          {
            this.state = State$1.SCRIPT_DATA_ESCAPE_START;
            this._emitChars('<!');
            break;
          }
        default:
          {
            this._emitChars('<');
            this.state = State$1.SCRIPT_DATA;
            this._stateScriptData(cp);
          }
      }
    }
    // Script data end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEndTagOpen",
    value: function _stateScriptDataEndTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this.state = State$1.SCRIPT_DATA_END_TAG_NAME;
        this._stateScriptDataEndTagName(cp);
      } else {
        this._emitChars('</');
        this.state = State$1.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEndTagName",
    value: function _stateScriptDataEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars('</');
        this.state = State$1.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data escape start state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapeStart",
    value: function _stateScriptDataEscapeStart(cp) {
      if (cp === CODE_POINTS.HYPHEN_MINUS) {
        this.state = State$1.SCRIPT_DATA_ESCAPE_START_DASH;
        this._emitChars('-');
      } else {
        this.state = State$1.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapeStartDash",
    value: function _stateScriptDataEscapeStartDash(cp) {
      if (cp === CODE_POINTS.HYPHEN_MINUS) {
        this.state = State$1.SCRIPT_DATA_ESCAPED_DASH_DASH;
        this._emitChars('-');
      } else {
        this.state = State$1.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data escaped state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscaped",
    value: function _stateScriptDataEscaped(cp) {
      switch (cp) {
        case CODE_POINTS.HYPHEN_MINUS:
          {
            this.state = State$1.SCRIPT_DATA_ESCAPED_DASH;
            this._emitChars('-');
            break;
          }
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            this.state = State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(REPLACEMENT_CHARACTER);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._emitCodePoint(cp);
          }
      }
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedDash",
    value: function _stateScriptDataEscapedDash(cp) {
      switch (cp) {
        case CODE_POINTS.HYPHEN_MINUS:
          {
            this.state = State$1.SCRIPT_DATA_ESCAPED_DASH_DASH;
            this._emitChars('-');
            break;
          }
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            this.state = State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this.state = State$1.SCRIPT_DATA_ESCAPED;
            this._emitChars(REPLACEMENT_CHARACTER);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this.state = State$1.SCRIPT_DATA_ESCAPED;
            this._emitCodePoint(cp);
          }
      }
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedDashDash",
    value: function _stateScriptDataEscapedDashDash(cp) {
      switch (cp) {
        case CODE_POINTS.HYPHEN_MINUS:
          {
            this._emitChars('-');
            break;
          }
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            this.state = State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.state = State$1.SCRIPT_DATA;
            this._emitChars('>');
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this.state = State$1.SCRIPT_DATA_ESCAPED;
            this._emitChars(REPLACEMENT_CHARACTER);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this.state = State$1.SCRIPT_DATA_ESCAPED;
            this._emitCodePoint(cp);
          }
      }
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedLessThanSign",
    value: function _stateScriptDataEscapedLessThanSign(cp) {
      if (cp === CODE_POINTS.SOLIDUS) {
        this.state = State$1.SCRIPT_DATA_ESCAPED_END_TAG_OPEN;
      } else if (isAsciiLetter(cp)) {
        this._emitChars('<');
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPE_START;
        this._stateScriptDataDoubleEscapeStart(cp);
      } else {
        this._emitChars('<');
        this.state = State$1.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedEndTagOpen",
    value: function _stateScriptDataEscapedEndTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this.state = State$1.SCRIPT_DATA_ESCAPED_END_TAG_NAME;
        this._stateScriptDataEscapedEndTagName(cp);
      } else {
        this._emitChars('</');
        this.state = State$1.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedEndTagName",
    value: function _stateScriptDataEscapedEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars('</');
        this.state = State$1.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapeStart",
    value: function _stateScriptDataDoubleEscapeStart(cp) {
      if (this.preprocessor.startsWith(SEQUENCES.SCRIPT, false) && isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek(SEQUENCES.SCRIPT.length))) {
        this._emitCodePoint(cp);
        for (var i = 0; i < SEQUENCES.SCRIPT.length; i++) {
          this._emitCodePoint(this._consume());
        }
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
      } else if (!this._ensureHibernation()) {
        this.state = State$1.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data double escaped state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscaped",
    value: function _stateScriptDataDoubleEscaped(cp) {
      switch (cp) {
        case CODE_POINTS.HYPHEN_MINUS:
          {
            this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH;
            this._emitChars('-');
            break;
          }
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
            this._emitChars('<');
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(REPLACEMENT_CHARACTER);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._emitCodePoint(cp);
          }
      }
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapedDash",
    value: function _stateScriptDataDoubleEscapedDash(cp) {
      switch (cp) {
        case CODE_POINTS.HYPHEN_MINUS:
          {
            this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH;
            this._emitChars('-');
            break;
          }
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
            this._emitChars('<');
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._emitChars(REPLACEMENT_CHARACTER);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._emitCodePoint(cp);
          }
      }
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapedDashDash",
    value: function _stateScriptDataDoubleEscapedDashDash(cp) {
      switch (cp) {
        case CODE_POINTS.HYPHEN_MINUS:
          {
            this._emitChars('-');
            break;
          }
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
            this._emitChars('<');
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.state = State$1.SCRIPT_DATA;
            this._emitChars('>');
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._emitChars(REPLACEMENT_CHARACTER);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._emitCodePoint(cp);
          }
      }
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapedLessThanSign",
    value: function _stateScriptDataDoubleEscapedLessThanSign(cp) {
      if (cp === CODE_POINTS.SOLIDUS) {
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPE_END;
        this._emitChars('/');
      } else {
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
        this._stateScriptDataDoubleEscaped(cp);
      }
    }
    // Script data double escape end state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapeEnd",
    value: function _stateScriptDataDoubleEscapeEnd(cp) {
      if (this.preprocessor.startsWith(SEQUENCES.SCRIPT, false) && isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek(SEQUENCES.SCRIPT.length))) {
        this._emitCodePoint(cp);
        for (var i = 0; i < SEQUENCES.SCRIPT.length; i++) {
          this._emitCodePoint(this._consume());
        }
        this.state = State$1.SCRIPT_DATA_ESCAPED;
      } else if (!this._ensureHibernation()) {
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
        this._stateScriptDataDoubleEscaped(cp);
      }
    }
    // Before attribute name state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeAttributeName",
    value: function _stateBeforeAttributeName(cp) {
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            // Ignore whitespace
            break;
          }
        case CODE_POINTS.SOLIDUS:
        case CODE_POINTS.GREATER_THAN_SIGN:
        case CODE_POINTS.EOF:
          {
            this.state = State$1.AFTER_ATTRIBUTE_NAME;
            this._stateAfterAttributeName(cp);
            break;
          }
        case CODE_POINTS.EQUALS_SIGN:
          {
            this._err(ERR.unexpectedEqualsSignBeforeAttributeName);
            this._createAttr('=');
            this.state = State$1.ATTRIBUTE_NAME;
            break;
          }
        default:
          {
            this._createAttr('');
            this.state = State$1.ATTRIBUTE_NAME;
            this._stateAttributeName(cp);
          }
      }
    }
    // Attribute name state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeName",
    value: function _stateAttributeName(cp) {
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
        case CODE_POINTS.SOLIDUS:
        case CODE_POINTS.GREATER_THAN_SIGN:
        case CODE_POINTS.EOF:
          {
            this._leaveAttrName();
            this.state = State$1.AFTER_ATTRIBUTE_NAME;
            this._stateAfterAttributeName(cp);
            break;
          }
        case CODE_POINTS.EQUALS_SIGN:
          {
            this._leaveAttrName();
            this.state = State$1.BEFORE_ATTRIBUTE_VALUE;
            break;
          }
        case CODE_POINTS.QUOTATION_MARK:
        case CODE_POINTS.APOSTROPHE:
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            this._err(ERR.unexpectedCharacterInAttributeName);
            this.currentAttr.name += String.fromCodePoint(cp);
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.name += REPLACEMENT_CHARACTER;
            break;
          }
        default:
          {
            this.currentAttr.name += String.fromCodePoint(isAsciiUpper(cp) ? toAsciiLower(cp) : cp);
          }
      }
    }
    // After attribute name state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterAttributeName",
    value: function _stateAfterAttributeName(cp) {
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            // Ignore whitespace
            break;
          }
        case CODE_POINTS.SOLIDUS:
          {
            this.state = State$1.SELF_CLOSING_START_TAG;
            break;
          }
        case CODE_POINTS.EQUALS_SIGN:
          {
            this.state = State$1.BEFORE_ATTRIBUTE_VALUE;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.state = State$1.DATA;
            this.emitCurrentTagToken();
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._createAttr('');
            this.state = State$1.ATTRIBUTE_NAME;
            this._stateAttributeName(cp);
          }
      }
    }
    // Before attribute value state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeAttributeValue",
    value: function _stateBeforeAttributeValue(cp) {
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            // Ignore whitespace
            break;
          }
        case CODE_POINTS.QUOTATION_MARK:
          {
            this.state = State$1.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
            break;
          }
        case CODE_POINTS.APOSTROPHE:
          {
            this.state = State$1.ATTRIBUTE_VALUE_SINGLE_QUOTED;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.missingAttributeValue);
            this.state = State$1.DATA;
            this.emitCurrentTagToken();
            break;
          }
        default:
          {
            this.state = State$1.ATTRIBUTE_VALUE_UNQUOTED;
            this._stateAttributeValueUnquoted(cp);
          }
      }
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeValueDoubleQuoted",
    value: function _stateAttributeValueDoubleQuoted(cp) {
      switch (cp) {
        case CODE_POINTS.QUOTATION_MARK:
          {
            this.state = State$1.AFTER_ATTRIBUTE_VALUE_QUOTED;
            break;
          }
        case CODE_POINTS.AMPERSAND:
          {
            this._startCharacterReference();
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.value += REPLACEMENT_CHARACTER;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this.currentAttr.value += String.fromCodePoint(cp);
          }
      }
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeValueSingleQuoted",
    value: function _stateAttributeValueSingleQuoted(cp) {
      switch (cp) {
        case CODE_POINTS.APOSTROPHE:
          {
            this.state = State$1.AFTER_ATTRIBUTE_VALUE_QUOTED;
            break;
          }
        case CODE_POINTS.AMPERSAND:
          {
            this._startCharacterReference();
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.value += REPLACEMENT_CHARACTER;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this.currentAttr.value += String.fromCodePoint(cp);
          }
      }
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeValueUnquoted",
    value: function _stateAttributeValueUnquoted(cp) {
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            this._leaveAttrValue();
            this.state = State$1.BEFORE_ATTRIBUTE_NAME;
            break;
          }
        case CODE_POINTS.AMPERSAND:
          {
            this._startCharacterReference();
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._leaveAttrValue();
            this.state = State$1.DATA;
            this.emitCurrentTagToken();
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.value += REPLACEMENT_CHARACTER;
            break;
          }
        case CODE_POINTS.QUOTATION_MARK:
        case CODE_POINTS.APOSTROPHE:
        case CODE_POINTS.LESS_THAN_SIGN:
        case CODE_POINTS.EQUALS_SIGN:
        case CODE_POINTS.GRAVE_ACCENT:
          {
            this._err(ERR.unexpectedCharacterInUnquotedAttributeValue);
            this.currentAttr.value += String.fromCodePoint(cp);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this.currentAttr.value += String.fromCodePoint(cp);
          }
      }
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterAttributeValueQuoted",
    value: function _stateAfterAttributeValueQuoted(cp) {
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            this._leaveAttrValue();
            this.state = State$1.BEFORE_ATTRIBUTE_NAME;
            break;
          }
        case CODE_POINTS.SOLIDUS:
          {
            this._leaveAttrValue();
            this.state = State$1.SELF_CLOSING_START_TAG;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._leaveAttrValue();
            this.state = State$1.DATA;
            this.emitCurrentTagToken();
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.missingWhitespaceBetweenAttributes);
            this.state = State$1.BEFORE_ATTRIBUTE_NAME;
            this._stateBeforeAttributeName(cp);
          }
      }
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
  }, {
    key: "_stateSelfClosingStartTag",
    value: function _stateSelfClosingStartTag(cp) {
      switch (cp) {
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            var token = this.currentToken;
            token.selfClosing = true;
            this.state = State$1.DATA;
            this.emitCurrentTagToken();
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.unexpectedSolidusInTag);
            this.state = State$1.BEFORE_ATTRIBUTE_NAME;
            this._stateBeforeAttributeName(cp);
          }
      }
    }
    // Bogus comment state
    //------------------------------------------------------------------
  }, {
    key: "_stateBogusComment",
    value: function _stateBogusComment(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.state = State$1.DATA;
            this.emitCurrentComment(token);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this.emitCurrentComment(token);
            this._emitEOFToken();
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            token.data += REPLACEMENT_CHARACTER;
            break;
          }
        default:
          {
            token.data += String.fromCodePoint(cp);
          }
      }
    }
    // Markup declaration open state
    //------------------------------------------------------------------
  }, {
    key: "_stateMarkupDeclarationOpen",
    value: function _stateMarkupDeclarationOpen(cp) {
      if (this._consumeSequenceIfMatch(SEQUENCES.DASH_DASH, true)) {
        this._createCommentToken(SEQUENCES.DASH_DASH.length + 1);
        this.state = State$1.COMMENT_START;
      } else if (this._consumeSequenceIfMatch(SEQUENCES.DOCTYPE, false)) {
        // NOTE: Doctypes tokens are created without fixed offsets. We keep track of the moment a doctype *might* start here.
        this.currentLocation = this.getCurrentLocation(SEQUENCES.DOCTYPE.length + 1);
        this.state = State$1.DOCTYPE;
      } else if (this._consumeSequenceIfMatch(SEQUENCES.CDATA_START, true)) {
        if (this.inForeignNode) {
          this.state = State$1.CDATA_SECTION;
        } else {
          this._err(ERR.cdataInHtmlContent);
          this._createCommentToken(SEQUENCES.CDATA_START.length + 1);
          this.currentToken.data = '[CDATA[';
          this.state = State$1.BOGUS_COMMENT;
        }
      }
      //NOTE: Sequence lookups can be abrupted by hibernation. In that case, lookup
      //results are no longer valid and we will need to start over.
      else if (!this._ensureHibernation()) {
        this._err(ERR.incorrectlyOpenedComment);
        this._createCommentToken(2);
        this.state = State$1.BOGUS_COMMENT;
        this._stateBogusComment(cp);
      }
    }
    // Comment start state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentStart",
    value: function _stateCommentStart(cp) {
      switch (cp) {
        case CODE_POINTS.HYPHEN_MINUS:
          {
            this.state = State$1.COMMENT_START_DASH;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.abruptClosingOfEmptyComment);
            this.state = State$1.DATA;
            var token = this.currentToken;
            this.emitCurrentComment(token);
            break;
          }
        default:
          {
            this.state = State$1.COMMENT;
            this._stateComment(cp);
          }
      }
    }
    // Comment start dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentStartDash",
    value: function _stateCommentStartDash(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.HYPHEN_MINUS:
          {
            this.state = State$1.COMMENT_END;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.abruptClosingOfEmptyComment);
            this.state = State$1.DATA;
            this.emitCurrentComment(token);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInComment);
            this.emitCurrentComment(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            token.data += '-';
            this.state = State$1.COMMENT;
            this._stateComment(cp);
          }
      }
    }
    // Comment state
    //------------------------------------------------------------------
  }, {
    key: "_stateComment",
    value: function _stateComment(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.HYPHEN_MINUS:
          {
            this.state = State$1.COMMENT_END_DASH;
            break;
          }
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            token.data += '<';
            this.state = State$1.COMMENT_LESS_THAN_SIGN;
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            token.data += REPLACEMENT_CHARACTER;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInComment);
            this.emitCurrentComment(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            token.data += String.fromCodePoint(cp);
          }
      }
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSign",
    value: function _stateCommentLessThanSign(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.EXCLAMATION_MARK:
          {
            token.data += '!';
            this.state = State$1.COMMENT_LESS_THAN_SIGN_BANG;
            break;
          }
        case CODE_POINTS.LESS_THAN_SIGN:
          {
            token.data += '<';
            break;
          }
        default:
          {
            this.state = State$1.COMMENT;
            this._stateComment(cp);
          }
      }
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSignBang",
    value: function _stateCommentLessThanSignBang(cp) {
      if (cp === CODE_POINTS.HYPHEN_MINUS) {
        this.state = State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH;
      } else {
        this.state = State$1.COMMENT;
        this._stateComment(cp);
      }
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSignBangDash",
    value: function _stateCommentLessThanSignBangDash(cp) {
      if (cp === CODE_POINTS.HYPHEN_MINUS) {
        this.state = State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH;
      } else {
        this.state = State$1.COMMENT_END_DASH;
        this._stateCommentEndDash(cp);
      }
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSignBangDashDash",
    value: function _stateCommentLessThanSignBangDashDash(cp) {
      if (cp !== CODE_POINTS.GREATER_THAN_SIGN && cp !== CODE_POINTS.EOF) {
        this._err(ERR.nestedComment);
      }
      this.state = State$1.COMMENT_END;
      this._stateCommentEnd(cp);
    }
    // Comment end dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentEndDash",
    value: function _stateCommentEndDash(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.HYPHEN_MINUS:
          {
            this.state = State$1.COMMENT_END;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInComment);
            this.emitCurrentComment(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            token.data += '-';
            this.state = State$1.COMMENT;
            this._stateComment(cp);
          }
      }
    }
    // Comment end state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentEnd",
    value: function _stateCommentEnd(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.state = State$1.DATA;
            this.emitCurrentComment(token);
            break;
          }
        case CODE_POINTS.EXCLAMATION_MARK:
          {
            this.state = State$1.COMMENT_END_BANG;
            break;
          }
        case CODE_POINTS.HYPHEN_MINUS:
          {
            token.data += '-';
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInComment);
            this.emitCurrentComment(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            token.data += '--';
            this.state = State$1.COMMENT;
            this._stateComment(cp);
          }
      }
    }
    // Comment end bang state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentEndBang",
    value: function _stateCommentEndBang(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.HYPHEN_MINUS:
          {
            token.data += '--!';
            this.state = State$1.COMMENT_END_DASH;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.incorrectlyClosedComment);
            this.state = State$1.DATA;
            this.emitCurrentComment(token);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInComment);
            this.emitCurrentComment(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            token.data += '--!';
            this.state = State$1.COMMENT;
            this._stateComment(cp);
          }
      }
    }
    // DOCTYPE state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctype",
    value: function _stateDoctype(cp) {
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            this.state = State$1.BEFORE_DOCTYPE_NAME;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.state = State$1.BEFORE_DOCTYPE_NAME;
            this._stateBeforeDoctypeName(cp);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            this._createDoctypeToken(null);
            var token = this.currentToken;
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.missingWhitespaceBeforeDoctypeName);
            this.state = State$1.BEFORE_DOCTYPE_NAME;
            this._stateBeforeDoctypeName(cp);
          }
      }
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeDoctypeName",
    value: function _stateBeforeDoctypeName(cp) {
      if (isAsciiUpper(cp)) {
        this._createDoctypeToken(String.fromCharCode(toAsciiLower(cp)));
        this.state = State$1.DOCTYPE_NAME;
      } else switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            // Ignore whitespace
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            this._createDoctypeToken(REPLACEMENT_CHARACTER);
            this.state = State$1.DOCTYPE_NAME;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.missingDoctypeName);
            this._createDoctypeToken(null);
            var token = this.currentToken;
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this.state = State$1.DATA;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            this._createDoctypeToken(null);
            var _token = this.currentToken;
            _token.forceQuirks = true;
            this.emitCurrentDoctype(_token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._createDoctypeToken(String.fromCodePoint(cp));
            this.state = State$1.DOCTYPE_NAME;
          }
      }
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypeName",
    value: function _stateDoctypeName(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            this.state = State$1.AFTER_DOCTYPE_NAME;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.state = State$1.DATA;
            this.emitCurrentDoctype(token);
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            token.name += REPLACEMENT_CHARACTER;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            token.name += String.fromCodePoint(isAsciiUpper(cp) ? toAsciiLower(cp) : cp);
          }
      }
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypeName",
    value: function _stateAfterDoctypeName(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            // Ignore whitespace
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.state = State$1.DATA;
            this.emitCurrentDoctype(token);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            if (this._consumeSequenceIfMatch(SEQUENCES.PUBLIC, false)) {
              this.state = State$1.AFTER_DOCTYPE_PUBLIC_KEYWORD;
            } else if (this._consumeSequenceIfMatch(SEQUENCES.SYSTEM, false)) {
              this.state = State$1.AFTER_DOCTYPE_SYSTEM_KEYWORD;
            }
            //NOTE: sequence lookup can be abrupted by hibernation. In that case lookup
            //results are no longer valid and we will need to start over.
            else if (!this._ensureHibernation()) {
              this._err(ERR.invalidCharacterSequenceAfterDoctypeName);
              token.forceQuirks = true;
              this.state = State$1.BOGUS_DOCTYPE;
              this._stateBogusDoctype(cp);
            }
          }
      }
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypePublicKeyword",
    value: function _stateAfterDoctypePublicKeyword(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            this.state = State$1.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
            break;
          }
        case CODE_POINTS.QUOTATION_MARK:
          {
            this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
            token.publicId = '';
            this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
            break;
          }
        case CODE_POINTS.APOSTROPHE:
          {
            this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
            token.publicId = '';
            this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.missingDoctypePublicIdentifier);
            token.forceQuirks = true;
            this.state = State$1.DATA;
            this.emitCurrentDoctype(token);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
            token.forceQuirks = true;
            this.state = State$1.BOGUS_DOCTYPE;
            this._stateBogusDoctype(cp);
          }
      }
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeDoctypePublicIdentifier",
    value: function _stateBeforeDoctypePublicIdentifier(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            // Ignore whitespace
            break;
          }
        case CODE_POINTS.QUOTATION_MARK:
          {
            token.publicId = '';
            this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
            break;
          }
        case CODE_POINTS.APOSTROPHE:
          {
            token.publicId = '';
            this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.missingDoctypePublicIdentifier);
            token.forceQuirks = true;
            this.state = State$1.DATA;
            this.emitCurrentDoctype(token);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
            token.forceQuirks = true;
            this.state = State$1.BOGUS_DOCTYPE;
            this._stateBogusDoctype(cp);
          }
      }
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypePublicIdentifierDoubleQuoted",
    value: function _stateDoctypePublicIdentifierDoubleQuoted(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.QUOTATION_MARK:
          {
            this.state = State$1.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            token.publicId += REPLACEMENT_CHARACTER;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.abruptDoctypePublicIdentifier);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this.state = State$1.DATA;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            token.publicId += String.fromCodePoint(cp);
          }
      }
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypePublicIdentifierSingleQuoted",
    value: function _stateDoctypePublicIdentifierSingleQuoted(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.APOSTROPHE:
          {
            this.state = State$1.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            token.publicId += REPLACEMENT_CHARACTER;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.abruptDoctypePublicIdentifier);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this.state = State$1.DATA;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            token.publicId += String.fromCodePoint(cp);
          }
      }
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypePublicIdentifier",
    value: function _stateAfterDoctypePublicIdentifier(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            this.state = State$1.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.state = State$1.DATA;
            this.emitCurrentDoctype(token);
            break;
          }
        case CODE_POINTS.QUOTATION_MARK:
          {
            this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
            token.systemId = '';
            this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
            break;
          }
        case CODE_POINTS.APOSTROPHE:
          {
            this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
            token.systemId = '';
            this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            token.forceQuirks = true;
            this.state = State$1.BOGUS_DOCTYPE;
            this._stateBogusDoctype(cp);
          }
      }
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
  }, {
    key: "_stateBetweenDoctypePublicAndSystemIdentifiers",
    value: function _stateBetweenDoctypePublicAndSystemIdentifiers(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            // Ignore whitespace
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.emitCurrentDoctype(token);
            this.state = State$1.DATA;
            break;
          }
        case CODE_POINTS.QUOTATION_MARK:
          {
            token.systemId = '';
            this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
            break;
          }
        case CODE_POINTS.APOSTROPHE:
          {
            token.systemId = '';
            this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            token.forceQuirks = true;
            this.state = State$1.BOGUS_DOCTYPE;
            this._stateBogusDoctype(cp);
          }
      }
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypeSystemKeyword",
    value: function _stateAfterDoctypeSystemKeyword(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            this.state = State$1.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
            break;
          }
        case CODE_POINTS.QUOTATION_MARK:
          {
            this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
            token.systemId = '';
            this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
            break;
          }
        case CODE_POINTS.APOSTROPHE:
          {
            this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
            token.systemId = '';
            this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.missingDoctypeSystemIdentifier);
            token.forceQuirks = true;
            this.state = State$1.DATA;
            this.emitCurrentDoctype(token);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            token.forceQuirks = true;
            this.state = State$1.BOGUS_DOCTYPE;
            this._stateBogusDoctype(cp);
          }
      }
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeDoctypeSystemIdentifier",
    value: function _stateBeforeDoctypeSystemIdentifier(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            // Ignore whitespace
            break;
          }
        case CODE_POINTS.QUOTATION_MARK:
          {
            token.systemId = '';
            this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
            break;
          }
        case CODE_POINTS.APOSTROPHE:
          {
            token.systemId = '';
            this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.missingDoctypeSystemIdentifier);
            token.forceQuirks = true;
            this.state = State$1.DATA;
            this.emitCurrentDoctype(token);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            token.forceQuirks = true;
            this.state = State$1.BOGUS_DOCTYPE;
            this._stateBogusDoctype(cp);
          }
      }
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypeSystemIdentifierDoubleQuoted",
    value: function _stateDoctypeSystemIdentifierDoubleQuoted(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.QUOTATION_MARK:
          {
            this.state = State$1.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            token.systemId += REPLACEMENT_CHARACTER;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.abruptDoctypeSystemIdentifier);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this.state = State$1.DATA;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            token.systemId += String.fromCodePoint(cp);
          }
      }
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypeSystemIdentifierSingleQuoted",
    value: function _stateDoctypeSystemIdentifierSingleQuoted(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.APOSTROPHE:
          {
            this.state = State$1.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            token.systemId += REPLACEMENT_CHARACTER;
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this._err(ERR.abruptDoctypeSystemIdentifier);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this.state = State$1.DATA;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            token.systemId += String.fromCodePoint(cp);
          }
      }
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypeSystemIdentifier",
    value: function _stateAfterDoctypeSystemIdentifier(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          {
            // Ignore whitespace
            break;
          }
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.emitCurrentDoctype(token);
            this.state = State$1.DATA;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInDoctype);
            token.forceQuirks = true;
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._err(ERR.unexpectedCharacterAfterDoctypeSystemIdentifier);
            this.state = State$1.BOGUS_DOCTYPE;
            this._stateBogusDoctype(cp);
          }
      }
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
  }, {
    key: "_stateBogusDoctype",
    value: function _stateBogusDoctype(cp) {
      var token = this.currentToken;
      switch (cp) {
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.emitCurrentDoctype(token);
            this.state = State$1.DATA;
            break;
          }
        case CODE_POINTS.NULL:
          {
            this._err(ERR.unexpectedNullCharacter);
            break;
          }
        case CODE_POINTS.EOF:
          {
            this.emitCurrentDoctype(token);
            this._emitEOFToken();
            break;
          }
        // Do nothing
      }
    }
    // CDATA section state
    //------------------------------------------------------------------
  }, {
    key: "_stateCdataSection",
    value: function _stateCdataSection(cp) {
      switch (cp) {
        case CODE_POINTS.RIGHT_SQUARE_BRACKET:
          {
            this.state = State$1.CDATA_SECTION_BRACKET;
            break;
          }
        case CODE_POINTS.EOF:
          {
            this._err(ERR.eofInCdata);
            this._emitEOFToken();
            break;
          }
        default:
          {
            this._emitCodePoint(cp);
          }
      }
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
  }, {
    key: "_stateCdataSectionBracket",
    value: function _stateCdataSectionBracket(cp) {
      if (cp === CODE_POINTS.RIGHT_SQUARE_BRACKET) {
        this.state = State$1.CDATA_SECTION_END;
      } else {
        this._emitChars(']');
        this.state = State$1.CDATA_SECTION;
        this._stateCdataSection(cp);
      }
    }
    // CDATA section end state
    //------------------------------------------------------------------
  }, {
    key: "_stateCdataSectionEnd",
    value: function _stateCdataSectionEnd(cp) {
      switch (cp) {
        case CODE_POINTS.GREATER_THAN_SIGN:
          {
            this.state = State$1.DATA;
            break;
          }
        case CODE_POINTS.RIGHT_SQUARE_BRACKET:
          {
            this._emitChars(']');
            break;
          }
        default:
          {
            this._emitChars(']]');
            this.state = State$1.CDATA_SECTION;
            this._stateCdataSection(cp);
          }
      }
    }
    // Character reference state
    //------------------------------------------------------------------
  }, {
    key: "_stateCharacterReference",
    value: function _stateCharacterReference() {
      var length = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
      if (length < 0) {
        if (this.preprocessor.lastChunkWritten) {
          length = this.entityDecoder.end();
        } else {
          // Wait for the rest of the entity.
          this.active = false;
          // Mark the entire buffer as read.
          this.preprocessor.pos = this.preprocessor.html.length - 1;
          this.consumedAfterSnapshot = 0;
          this.preprocessor.endOfChunkHit = true;
          return;
        }
      }
      if (length === 0) {
        // This was not a valid entity. Go back to the beginning, and
        // figure out what to do.
        this.preprocessor.pos = this.entityStartPos;
        this._flushCodePointConsumedAsCharacterReference(CODE_POINTS.AMPERSAND);
        this.state = !this._isCharacterReferenceInAttribute() && isAsciiAlphaNumeric(this.preprocessor.peek(1)) ? State$1.AMBIGUOUS_AMPERSAND : this.returnState;
      } else {
        // We successfully parsed an entity. Switch to the return state.
        this.state = this.returnState;
      }
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
  }, {
    key: "_stateAmbiguousAmpersand",
    value: function _stateAmbiguousAmpersand(cp) {
      if (isAsciiAlphaNumeric(cp)) {
        this._flushCodePointConsumedAsCharacterReference(cp);
      } else {
        if (cp === CODE_POINTS.SEMICOLON) {
          this._err(ERR.unknownNamedCharacterReference);
        }
        this.state = this.returnState;
        this._callState(cp);
      }
    }
  }]);
}();

//Element utils
var IMPLICIT_END_TAG_REQUIRED = new Set([TAG_ID.DD, TAG_ID.DT, TAG_ID.LI, TAG_ID.OPTGROUP, TAG_ID.OPTION, TAG_ID.P, TAG_ID.RB, TAG_ID.RP, TAG_ID.RT, TAG_ID.RTC]);
var IMPLICIT_END_TAG_REQUIRED_THOROUGHLY = new Set([].concat(_toConsumableArray(IMPLICIT_END_TAG_REQUIRED), [TAG_ID.CAPTION, TAG_ID.COLGROUP, TAG_ID.TBODY, TAG_ID.TD, TAG_ID.TFOOT, TAG_ID.TH, TAG_ID.THEAD, TAG_ID.TR]));
var SCOPING_ELEMENTS_HTML = new Set([TAG_ID.APPLET, TAG_ID.CAPTION, TAG_ID.HTML, TAG_ID.MARQUEE, TAG_ID.OBJECT, TAG_ID.TABLE, TAG_ID.TD, TAG_ID.TEMPLATE, TAG_ID.TH]);
var SCOPING_ELEMENTS_HTML_LIST = new Set([].concat(_toConsumableArray(SCOPING_ELEMENTS_HTML), [TAG_ID.OL, TAG_ID.UL]));
var SCOPING_ELEMENTS_HTML_BUTTON = new Set([].concat(_toConsumableArray(SCOPING_ELEMENTS_HTML), [TAG_ID.BUTTON]));
var SCOPING_ELEMENTS_MATHML = new Set([TAG_ID.ANNOTATION_XML, TAG_ID.MI, TAG_ID.MN, TAG_ID.MO, TAG_ID.MS, TAG_ID.MTEXT]);
var SCOPING_ELEMENTS_SVG = new Set([TAG_ID.DESC, TAG_ID.FOREIGN_OBJECT, TAG_ID.TITLE]);
var TABLE_ROW_CONTEXT = new Set([TAG_ID.TR, TAG_ID.TEMPLATE, TAG_ID.HTML]);
var TABLE_BODY_CONTEXT = new Set([TAG_ID.TBODY, TAG_ID.TFOOT, TAG_ID.THEAD, TAG_ID.TEMPLATE, TAG_ID.HTML]);
var TABLE_CONTEXT = new Set([TAG_ID.TABLE, TAG_ID.TEMPLATE, TAG_ID.HTML]);
var TABLE_CELLS = new Set([TAG_ID.TD, TAG_ID.TH]);
//Stack of open elements
var OpenElementStack = /*#__PURE__*/function () {
  function OpenElementStack(document, treeAdapter, handler) {
    _classCallCheck$1(this, OpenElementStack);
    this.treeAdapter = treeAdapter;
    this.handler = handler;
    this.items = [];
    this.tagIDs = [];
    this.stackTop = -1;
    this.tmplCount = 0;
    this.currentTagId = TAG_ID.UNKNOWN;
    this.current = document;
  }
  //Index of element
  return _createClass$1(OpenElementStack, [{
    key: "currentTmplContentOrNode",
    get: function get() {
      return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
    }
  }, {
    key: "_indexOf",
    value: function _indexOf(element) {
      return this.items.lastIndexOf(element, this.stackTop);
    }
    //Update current element
  }, {
    key: "_isInTemplate",
    value: function _isInTemplate() {
      return this.currentTagId === TAG_ID.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
    }
  }, {
    key: "_updateCurrentElement",
    value: function _updateCurrentElement() {
      this.current = this.items[this.stackTop];
      this.currentTagId = this.tagIDs[this.stackTop];
    }
    //Mutations
  }, {
    key: "push",
    value: function push(element, tagID) {
      this.stackTop++;
      this.items[this.stackTop] = element;
      this.current = element;
      this.tagIDs[this.stackTop] = tagID;
      this.currentTagId = tagID;
      if (this._isInTemplate()) {
        this.tmplCount++;
      }
      this.handler.onItemPush(element, tagID, true);
    }
  }, {
    key: "pop",
    value: function pop() {
      var popped = this.current;
      if (this.tmplCount > 0 && this._isInTemplate()) {
        this.tmplCount--;
      }
      this.stackTop--;
      this._updateCurrentElement();
      this.handler.onItemPop(popped, true);
    }
  }, {
    key: "replace",
    value: function replace(oldElement, newElement) {
      var idx = this._indexOf(oldElement);
      this.items[idx] = newElement;
      if (idx === this.stackTop) {
        this.current = newElement;
      }
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(referenceElement, newElement, newElementID) {
      var insertionIdx = this._indexOf(referenceElement) + 1;
      this.items.splice(insertionIdx, 0, newElement);
      this.tagIDs.splice(insertionIdx, 0, newElementID);
      this.stackTop++;
      if (insertionIdx === this.stackTop) {
        this._updateCurrentElement();
      }
      if (this.current && this.currentTagId !== undefined) {
        this.handler.onItemPush(this.current, this.currentTagId, insertionIdx === this.stackTop);
      }
    }
  }, {
    key: "popUntilTagNamePopped",
    value: function popUntilTagNamePopped(tagName) {
      var targetIdx = this.stackTop + 1;
      do {
        targetIdx = this.tagIDs.lastIndexOf(tagName, targetIdx - 1);
      } while (targetIdx > 0 && this.treeAdapter.getNamespaceURI(this.items[targetIdx]) !== NS.HTML);
      this.shortenToLength(Math.max(targetIdx, 0));
    }
  }, {
    key: "shortenToLength",
    value: function shortenToLength(idx) {
      while (this.stackTop >= idx) {
        var popped = this.current;
        if (this.tmplCount > 0 && this._isInTemplate()) {
          this.tmplCount -= 1;
        }
        this.stackTop--;
        this._updateCurrentElement();
        this.handler.onItemPop(popped, this.stackTop < idx);
      }
    }
  }, {
    key: "popUntilElementPopped",
    value: function popUntilElementPopped(element) {
      var idx = this._indexOf(element);
      this.shortenToLength(Math.max(idx, 0));
    }
  }, {
    key: "popUntilPopped",
    value: function popUntilPopped(tagNames, targetNS) {
      var idx = this._indexOfTagNames(tagNames, targetNS);
      this.shortenToLength(Math.max(idx, 0));
    }
  }, {
    key: "popUntilNumberedHeaderPopped",
    value: function popUntilNumberedHeaderPopped() {
      this.popUntilPopped(NUMBERED_HEADERS, NS.HTML);
    }
  }, {
    key: "popUntilTableCellPopped",
    value: function popUntilTableCellPopped() {
      this.popUntilPopped(TABLE_CELLS, NS.HTML);
    }
  }, {
    key: "popAllUpToHtmlElement",
    value: function popAllUpToHtmlElement() {
      //NOTE: here we assume that the root <html> element is always first in the open element stack, so
      //we perform this fast stack clean up.
      this.tmplCount = 0;
      this.shortenToLength(1);
    }
  }, {
    key: "_indexOfTagNames",
    value: function _indexOfTagNames(tagNames, namespace) {
      for (var i = this.stackTop; i >= 0; i--) {
        if (tagNames.has(this.tagIDs[i]) && this.treeAdapter.getNamespaceURI(this.items[i]) === namespace) {
          return i;
        }
      }
      return -1;
    }
  }, {
    key: "clearBackTo",
    value: function clearBackTo(tagNames, targetNS) {
      var idx = this._indexOfTagNames(tagNames, targetNS);
      this.shortenToLength(idx + 1);
    }
  }, {
    key: "clearBackToTableContext",
    value: function clearBackToTableContext() {
      this.clearBackTo(TABLE_CONTEXT, NS.HTML);
    }
  }, {
    key: "clearBackToTableBodyContext",
    value: function clearBackToTableBodyContext() {
      this.clearBackTo(TABLE_BODY_CONTEXT, NS.HTML);
    }
  }, {
    key: "clearBackToTableRowContext",
    value: function clearBackToTableRowContext() {
      this.clearBackTo(TABLE_ROW_CONTEXT, NS.HTML);
    }
  }, {
    key: "remove",
    value: function remove(element) {
      var idx = this._indexOf(element);
      if (idx >= 0) {
        if (idx === this.stackTop) {
          this.pop();
        } else {
          this.items.splice(idx, 1);
          this.tagIDs.splice(idx, 1);
          this.stackTop--;
          this._updateCurrentElement();
          this.handler.onItemPop(element, false);
        }
      }
    }
    //Search
  }, {
    key: "tryPeekProperlyNestedBodyElement",
    value: function tryPeekProperlyNestedBodyElement() {
      //Properly nested <body> element (should be second element in stack).
      return this.stackTop >= 1 && this.tagIDs[1] === TAG_ID.BODY ? this.items[1] : null;
    }
  }, {
    key: "contains",
    value: function contains(element) {
      return this._indexOf(element) > -1;
    }
  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor(element) {
      var elementIdx = this._indexOf(element) - 1;
      return elementIdx >= 0 ? this.items[elementIdx] : null;
    }
  }, {
    key: "isRootHtmlElementCurrent",
    value: function isRootHtmlElementCurrent() {
      return this.stackTop === 0 && this.tagIDs[0] === TAG_ID.HTML;
    }
    //Element in scope
  }, {
    key: "hasInDynamicScope",
    value: function hasInDynamicScope(tagName, htmlScope) {
      for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.tagIDs[i];
        switch (this.treeAdapter.getNamespaceURI(this.items[i])) {
          case NS.HTML:
            {
              if (tn === tagName) return true;
              if (htmlScope.has(tn)) return false;
              break;
            }
          case NS.SVG:
            {
              if (SCOPING_ELEMENTS_SVG.has(tn)) return false;
              break;
            }
          case NS.MATHML:
            {
              if (SCOPING_ELEMENTS_MATHML.has(tn)) return false;
              break;
            }
        }
      }
      return true;
    }
  }, {
    key: "hasInScope",
    value: function hasInScope(tagName) {
      return this.hasInDynamicScope(tagName, SCOPING_ELEMENTS_HTML);
    }
  }, {
    key: "hasInListItemScope",
    value: function hasInListItemScope(tagName) {
      return this.hasInDynamicScope(tagName, SCOPING_ELEMENTS_HTML_LIST);
    }
  }, {
    key: "hasInButtonScope",
    value: function hasInButtonScope(tagName) {
      return this.hasInDynamicScope(tagName, SCOPING_ELEMENTS_HTML_BUTTON);
    }
  }, {
    key: "hasNumberedHeaderInScope",
    value: function hasNumberedHeaderInScope() {
      for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.tagIDs[i];
        switch (this.treeAdapter.getNamespaceURI(this.items[i])) {
          case NS.HTML:
            {
              if (NUMBERED_HEADERS.has(tn)) return true;
              if (SCOPING_ELEMENTS_HTML.has(tn)) return false;
              break;
            }
          case NS.SVG:
            {
              if (SCOPING_ELEMENTS_SVG.has(tn)) return false;
              break;
            }
          case NS.MATHML:
            {
              if (SCOPING_ELEMENTS_MATHML.has(tn)) return false;
              break;
            }
        }
      }
      return true;
    }
  }, {
    key: "hasInTableScope",
    value: function hasInTableScope(tagName) {
      for (var i = this.stackTop; i >= 0; i--) {
        if (this.treeAdapter.getNamespaceURI(this.items[i]) !== NS.HTML) {
          continue;
        }
        switch (this.tagIDs[i]) {
          case tagName:
            {
              return true;
            }
          case TAG_ID.TABLE:
          case TAG_ID.HTML:
            {
              return false;
            }
        }
      }
      return true;
    }
  }, {
    key: "hasTableBodyContextInTableScope",
    value: function hasTableBodyContextInTableScope() {
      for (var i = this.stackTop; i >= 0; i--) {
        if (this.treeAdapter.getNamespaceURI(this.items[i]) !== NS.HTML) {
          continue;
        }
        switch (this.tagIDs[i]) {
          case TAG_ID.TBODY:
          case TAG_ID.THEAD:
          case TAG_ID.TFOOT:
            {
              return true;
            }
          case TAG_ID.TABLE:
          case TAG_ID.HTML:
            {
              return false;
            }
        }
      }
      return true;
    }
  }, {
    key: "hasInSelectScope",
    value: function hasInSelectScope(tagName) {
      for (var i = this.stackTop; i >= 0; i--) {
        if (this.treeAdapter.getNamespaceURI(this.items[i]) !== NS.HTML) {
          continue;
        }
        switch (this.tagIDs[i]) {
          case tagName:
            {
              return true;
            }
          case TAG_ID.OPTION:
          case TAG_ID.OPTGROUP:
            {
              break;
            }
          default:
            {
              return false;
            }
        }
      }
      return true;
    }
    //Implied end tags
  }, {
    key: "generateImpliedEndTags",
    value: function generateImpliedEndTags() {
      while (this.currentTagId !== undefined && IMPLICIT_END_TAG_REQUIRED.has(this.currentTagId)) {
        this.pop();
      }
    }
  }, {
    key: "generateImpliedEndTagsThoroughly",
    value: function generateImpliedEndTagsThoroughly() {
      while (this.currentTagId !== undefined && IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId)) {
        this.pop();
      }
    }
  }, {
    key: "generateImpliedEndTagsWithExclusion",
    value: function generateImpliedEndTagsWithExclusion(exclusionId) {
      while (this.currentTagId !== undefined && this.currentTagId !== exclusionId && IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId)) {
        this.pop();
      }
    }
  }]);
}();

//Const
var NOAH_ARK_CAPACITY = 3;
var EntryType;
(function (EntryType) {
  EntryType[EntryType["Marker"] = 0] = "Marker";
  EntryType[EntryType["Element"] = 1] = "Element";
})(EntryType || (EntryType = {}));
var MARKER = {
  type: EntryType.Marker
};
//List of formatting elements
var FormattingElementList = /*#__PURE__*/function () {
  function FormattingElementList(treeAdapter) {
    _classCallCheck$1(this, FormattingElementList);
    this.treeAdapter = treeAdapter;
    this.entries = [];
    this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  return _createClass$1(FormattingElementList, [{
    key: "_getNoahArkConditionCandidates",
    value: function _getNoahArkConditionCandidates(newElement, neAttrs) {
      var candidates = [];
      var neAttrsLength = neAttrs.length;
      var neTagName = this.treeAdapter.getTagName(newElement);
      var neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
      for (var i = 0; i < this.entries.length; i++) {
        var entry = this.entries[i];
        if (entry.type === EntryType.Marker) {
          break;
        }
        var element = entry.element;
        if (this.treeAdapter.getTagName(element) === neTagName && this.treeAdapter.getNamespaceURI(element) === neNamespaceURI) {
          var elementAttrs = this.treeAdapter.getAttrList(element);
          if (elementAttrs.length === neAttrsLength) {
            candidates.push({
              idx: i,
              attrs: elementAttrs
            });
          }
        }
      }
      return candidates;
    }
  }, {
    key: "_ensureNoahArkCondition",
    value: function _ensureNoahArkCondition(newElement) {
      if (this.entries.length < NOAH_ARK_CAPACITY) return;
      var neAttrs = this.treeAdapter.getAttrList(newElement);
      var candidates = this._getNoahArkConditionCandidates(newElement, neAttrs);
      if (candidates.length < NOAH_ARK_CAPACITY) return;
      //NOTE: build attrs map for the new element, so we can perform fast lookups
      var neAttrsMap = new Map(neAttrs.map(function (neAttr) {
        return [neAttr.name, neAttr.value];
      }));
      var validCandidates = 0;
      //NOTE: remove bottommost candidates, until Noah's Ark condition will not be met
      for (var i = 0; i < candidates.length; i++) {
        var candidate = candidates[i];
        // We know that `candidate.attrs.length === neAttrs.length`
        if (candidate.attrs.every(function (cAttr) {
          return neAttrsMap.get(cAttr.name) === cAttr.value;
        })) {
          validCandidates += 1;
          if (validCandidates >= NOAH_ARK_CAPACITY) {
            this.entries.splice(candidate.idx, 1);
          }
        }
      }
    }
    //Mutations
  }, {
    key: "insertMarker",
    value: function insertMarker() {
      this.entries.unshift(MARKER);
    }
  }, {
    key: "pushElement",
    value: function pushElement(element, token) {
      this._ensureNoahArkCondition(element);
      this.entries.unshift({
        type: EntryType.Element,
        element: element,
        token: token
      });
    }
  }, {
    key: "insertElementAfterBookmark",
    value: function insertElementAfterBookmark(element, token) {
      var bookmarkIdx = this.entries.indexOf(this.bookmark);
      this.entries.splice(bookmarkIdx, 0, {
        type: EntryType.Element,
        element: element,
        token: token
      });
    }
  }, {
    key: "removeEntry",
    value: function removeEntry(entry) {
      var entryIndex = this.entries.indexOf(entry);
      if (entryIndex !== -1) {
        this.entries.splice(entryIndex, 1);
      }
    }
    /**
     * Clears the list of formatting elements up to the last marker.
     *
     * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
     */
  }, {
    key: "clearToLastMarker",
    value: function clearToLastMarker() {
      var markerIdx = this.entries.indexOf(MARKER);
      if (markerIdx === -1) {
        this.entries.length = 0;
      } else {
        this.entries.splice(0, markerIdx + 1);
      }
    }
    //Search
  }, {
    key: "getElementEntryInScopeWithTagName",
    value: function getElementEntryInScopeWithTagName(tagName) {
      var _this = this;
      var entry = this.entries.find(function (entry) {
        return entry.type === EntryType.Marker || _this.treeAdapter.getTagName(entry.element) === tagName;
      });
      return entry && entry.type === EntryType.Element ? entry : null;
    }
  }, {
    key: "getElementEntry",
    value: function getElementEntry(element) {
      return this.entries.find(function (entry) {
        return entry.type === EntryType.Element && entry.element === element;
      });
    }
  }]);
}();

var defaultTreeAdapter = {
  //Node construction
  createDocument: function createDocument() {
    return {
      nodeName: '#document',
      mode: DOCUMENT_MODE.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment: function createDocumentFragment() {
    return {
      nodeName: '#document-fragment',
      childNodes: []
    };
  },
  createElement: function createElement(tagName, namespaceURI, attrs) {
    return {
      nodeName: tagName,
      tagName: tagName,
      attrs: attrs,
      namespaceURI: namespaceURI,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode: function createCommentNode(data) {
    return {
      nodeName: '#comment',
      data: data,
      parentNode: null
    };
  },
  createTextNode: function createTextNode(value) {
    return {
      nodeName: '#text',
      value: value,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild: function appendChild(parentNode, newNode) {
    parentNode.childNodes.push(newNode);
    newNode.parentNode = parentNode;
  },
  insertBefore: function insertBefore(parentNode, newNode, referenceNode) {
    var insertionIdx = parentNode.childNodes.indexOf(referenceNode);
    parentNode.childNodes.splice(insertionIdx, 0, newNode);
    newNode.parentNode = parentNode;
  },
  setTemplateContent: function setTemplateContent(templateElement, contentElement) {
    templateElement.content = contentElement;
  },
  getTemplateContent: function getTemplateContent(templateElement) {
    return templateElement.content;
  },
  setDocumentType: function setDocumentType(document, name, publicId, systemId) {
    var doctypeNode = document.childNodes.find(function (node) {
      return node.nodeName === '#documentType';
    });
    if (doctypeNode) {
      doctypeNode.name = name;
      doctypeNode.publicId = publicId;
      doctypeNode.systemId = systemId;
    } else {
      var node = {
        nodeName: '#documentType',
        name: name,
        publicId: publicId,
        systemId: systemId,
        parentNode: null
      };
      defaultTreeAdapter.appendChild(document, node);
    }
  },
  setDocumentMode: function setDocumentMode(document, mode) {
    document.mode = mode;
  },
  getDocumentMode: function getDocumentMode(document) {
    return document.mode;
  },
  detachNode: function detachNode(node) {
    if (node.parentNode) {
      var idx = node.parentNode.childNodes.indexOf(node);
      node.parentNode.childNodes.splice(idx, 1);
      node.parentNode = null;
    }
  },
  insertText: function insertText(parentNode, text) {
    if (parentNode.childNodes.length > 0) {
      var prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
      if (defaultTreeAdapter.isTextNode(prevNode)) {
        prevNode.value += text;
        return;
      }
    }
    defaultTreeAdapter.appendChild(parentNode, defaultTreeAdapter.createTextNode(text));
  },
  insertTextBefore: function insertTextBefore(parentNode, text, referenceNode) {
    var prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
    if (prevNode && defaultTreeAdapter.isTextNode(prevNode)) {
      prevNode.value += text;
    } else {
      defaultTreeAdapter.insertBefore(parentNode, defaultTreeAdapter.createTextNode(text), referenceNode);
    }
  },
  adoptAttributes: function adoptAttributes(recipient, attrs) {
    var recipientAttrsMap = new Set(recipient.attrs.map(function (attr) {
      return attr.name;
    }));
    for (var j = 0; j < attrs.length; j++) {
      if (!recipientAttrsMap.has(attrs[j].name)) {
        recipient.attrs.push(attrs[j]);
      }
    }
  },
  //Tree traversing
  getFirstChild: function getFirstChild(node) {
    return node.childNodes[0];
  },
  getChildNodes: function getChildNodes(node) {
    return node.childNodes;
  },
  getParentNode: function getParentNode(node) {
    return node.parentNode;
  },
  getAttrList: function getAttrList(element) {
    return element.attrs;
  },
  //Node data
  getTagName: function getTagName(element) {
    return element.tagName;
  },
  getNamespaceURI: function getNamespaceURI(element) {
    return element.namespaceURI;
  },
  getTextNodeContent: function getTextNodeContent(textNode) {
    return textNode.value;
  },
  getCommentNodeContent: function getCommentNodeContent(commentNode) {
    return commentNode.data;
  },
  getDocumentTypeNodeName: function getDocumentTypeNodeName(doctypeNode) {
    return doctypeNode.name;
  },
  getDocumentTypeNodePublicId: function getDocumentTypeNodePublicId(doctypeNode) {
    return doctypeNode.publicId;
  },
  getDocumentTypeNodeSystemId: function getDocumentTypeNodeSystemId(doctypeNode) {
    return doctypeNode.systemId;
  },
  //Node types
  isTextNode: function isTextNode(node) {
    return node.nodeName === '#text';
  },
  isCommentNode: function isCommentNode(node) {
    return node.nodeName === '#comment';
  },
  isDocumentTypeNode: function isDocumentTypeNode(node) {
    return node.nodeName === '#documentType';
  },
  isElementNode: function isElementNode(node) {
    return Object.prototype.hasOwnProperty.call(node, 'tagName');
  },
  // Source code location
  setNodeSourceCodeLocation: function setNodeSourceCodeLocation(node, location) {
    node.sourceCodeLocation = location;
  },
  getNodeSourceCodeLocation: function getNodeSourceCodeLocation(node) {
    return node.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation: function updateNodeSourceCodeLocation(node, endLocation) {
    node.sourceCodeLocation = _objectSpread2(_objectSpread2({}, node.sourceCodeLocation), endLocation);
  }
};

//Const
var VALID_DOCTYPE_NAME = 'html';
var VALID_SYSTEM_ID = 'about:legacy-compat';
var QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd';
var QUIRKS_MODE_PUBLIC_ID_PREFIXES = ['+//silmaril//dtd html pro v0r11 19970101//', '-//as//dtd html 3.0 aswedit + extensions//', '-//advasoft ltd//dtd html 3.0 aswedit + extensions//', '-//ietf//dtd html 2.0 level 1//', '-//ietf//dtd html 2.0 level 2//', '-//ietf//dtd html 2.0 strict level 1//', '-//ietf//dtd html 2.0 strict level 2//', '-//ietf//dtd html 2.0 strict//', '-//ietf//dtd html 2.0//', '-//ietf//dtd html 2.1e//', '-//ietf//dtd html 3.0//', '-//ietf//dtd html 3.2 final//', '-//ietf//dtd html 3.2//', '-//ietf//dtd html 3//', '-//ietf//dtd html level 0//', '-//ietf//dtd html level 1//', '-//ietf//dtd html level 2//', '-//ietf//dtd html level 3//', '-//ietf//dtd html strict level 0//', '-//ietf//dtd html strict level 1//', '-//ietf//dtd html strict level 2//', '-//ietf//dtd html strict level 3//', '-//ietf//dtd html strict//', '-//ietf//dtd html//', '-//metrius//dtd metrius presentational//', '-//microsoft//dtd internet explorer 2.0 html strict//', '-//microsoft//dtd internet explorer 2.0 html//', '-//microsoft//dtd internet explorer 2.0 tables//', '-//microsoft//dtd internet explorer 3.0 html strict//', '-//microsoft//dtd internet explorer 3.0 html//', '-//microsoft//dtd internet explorer 3.0 tables//', '-//netscape comm. corp.//dtd html//', '-//netscape comm. corp.//dtd strict html//', "-//o'reilly and associates//dtd html 2.0//", "-//o'reilly and associates//dtd html extended 1.0//", "-//o'reilly and associates//dtd html extended relaxed 1.0//", '-//sq//dtd html 2.0 hotmetal + extensions//', '-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//', '-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//', '-//spyglass//dtd html 2.0 extended//', '-//sun microsystems corp.//dtd hotjava html//', '-//sun microsystems corp.//dtd hotjava strict html//', '-//w3c//dtd html 3 1995-03-24//', '-//w3c//dtd html 3.2 draft//', '-//w3c//dtd html 3.2 final//', '-//w3c//dtd html 3.2//', '-//w3c//dtd html 3.2s draft//', '-//w3c//dtd html 4.0 frameset//', '-//w3c//dtd html 4.0 transitional//', '-//w3c//dtd html experimental 19960712//', '-//w3c//dtd html experimental 970421//', '-//w3c//dtd w3 html//', '-//w3o//dtd w3 html 3.0//', '-//webtechs//dtd mozilla html 2.0//', '-//webtechs//dtd mozilla html//'];
var QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = [].concat(QUIRKS_MODE_PUBLIC_ID_PREFIXES, ['-//w3c//dtd html 4.01 frameset//', '-//w3c//dtd html 4.01 transitional//']);
var QUIRKS_MODE_PUBLIC_IDS = new Set(['-//w3o//dtd w3 html strict 3.0//en//', '-/w3c/dtd html 4.0 transitional/en', 'html']);
var LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = ['-//w3c//dtd xhtml 1.0 frameset//', '-//w3c//dtd xhtml 1.0 transitional//'];
var LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = [].concat(LIMITED_QUIRKS_PUBLIC_ID_PREFIXES, ['-//w3c//dtd html 4.01 frameset//', '-//w3c//dtd html 4.01 transitional//']);
//Utils
function hasPrefix(publicId, prefixes) {
  return prefixes.some(function (prefix) {
    return publicId.startsWith(prefix);
  });
}
//API
function isConforming(token) {
  return token.name === VALID_DOCTYPE_NAME && token.publicId === null && (token.systemId === null || token.systemId === VALID_SYSTEM_ID);
}
function getDocumentMode(token) {
  if (token.name !== VALID_DOCTYPE_NAME) {
    return DOCUMENT_MODE.QUIRKS;
  }
  var systemId = token.systemId;
  if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID) {
    return DOCUMENT_MODE.QUIRKS;
  }
  var publicId = token.publicId;
  if (publicId !== null) {
    publicId = publicId.toLowerCase();
    if (QUIRKS_MODE_PUBLIC_IDS.has(publicId)) {
      return DOCUMENT_MODE.QUIRKS;
    }
    var prefixes = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;
    if (hasPrefix(publicId, prefixes)) {
      return DOCUMENT_MODE.QUIRKS;
    }
    prefixes = systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;
    if (hasPrefix(publicId, prefixes)) {
      return DOCUMENT_MODE.LIMITED_QUIRKS;
    }
  }
  return DOCUMENT_MODE.NO_QUIRKS;
}

//MIME types
var MIME_TYPES = {
  TEXT_HTML: 'text/html',
  APPLICATION_XML: 'application/xhtml+xml'
};
//Attributes
var DEFINITION_URL_ATTR = 'definitionurl';
var ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL';
var SVG_ATTRS_ADJUSTMENT_MAP = new Map(['attributeName', 'attributeType', 'baseFrequency', 'baseProfile', 'calcMode', 'clipPathUnits', 'diffuseConstant', 'edgeMode', 'filterUnits', 'glyphRef', 'gradientTransform', 'gradientUnits', 'kernelMatrix', 'kernelUnitLength', 'keyPoints', 'keySplines', 'keyTimes', 'lengthAdjust', 'limitingConeAngle', 'markerHeight', 'markerUnits', 'markerWidth', 'maskContentUnits', 'maskUnits', 'numOctaves', 'pathLength', 'patternContentUnits', 'patternTransform', 'patternUnits', 'pointsAtX', 'pointsAtY', 'pointsAtZ', 'preserveAlpha', 'preserveAspectRatio', 'primitiveUnits', 'refX', 'refY', 'repeatCount', 'repeatDur', 'requiredExtensions', 'requiredFeatures', 'specularConstant', 'specularExponent', 'spreadMethod', 'startOffset', 'stdDeviation', 'stitchTiles', 'surfaceScale', 'systemLanguage', 'tableValues', 'targetX', 'targetY', 'textLength', 'viewBox', 'viewTarget', 'xChannelSelector', 'yChannelSelector', 'zoomAndPan'].map(function (attr) {
  return [attr.toLowerCase(), attr];
}));
var XML_ATTRS_ADJUSTMENT_MAP = new Map([['xlink:actuate', {
  prefix: 'xlink',
  name: 'actuate',
  namespace: NS.XLINK
}], ['xlink:arcrole', {
  prefix: 'xlink',
  name: 'arcrole',
  namespace: NS.XLINK
}], ['xlink:href', {
  prefix: 'xlink',
  name: 'href',
  namespace: NS.XLINK
}], ['xlink:role', {
  prefix: 'xlink',
  name: 'role',
  namespace: NS.XLINK
}], ['xlink:show', {
  prefix: 'xlink',
  name: 'show',
  namespace: NS.XLINK
}], ['xlink:title', {
  prefix: 'xlink',
  name: 'title',
  namespace: NS.XLINK
}], ['xlink:type', {
  prefix: 'xlink',
  name: 'type',
  namespace: NS.XLINK
}], ['xml:lang', {
  prefix: 'xml',
  name: 'lang',
  namespace: NS.XML
}], ['xml:space', {
  prefix: 'xml',
  name: 'space',
  namespace: NS.XML
}], ['xmlns', {
  prefix: '',
  name: 'xmlns',
  namespace: NS.XMLNS
}], ['xmlns:xlink', {
  prefix: 'xmlns',
  name: 'xlink',
  namespace: NS.XMLNS
}]]);
//SVG tag names adjustment map
var SVG_TAG_NAMES_ADJUSTMENT_MAP = new Map(['altGlyph', 'altGlyphDef', 'altGlyphItem', 'animateColor', 'animateMotion', 'animateTransform', 'clipPath', 'feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'foreignObject', 'glyphRef', 'linearGradient', 'radialGradient', 'textPath'].map(function (tn) {
  return [tn.toLowerCase(), tn];
}));
//Tags that causes exit from foreign content
var EXITS_FOREIGN_CONTENT = new Set([TAG_ID.B, TAG_ID.BIG, TAG_ID.BLOCKQUOTE, TAG_ID.BODY, TAG_ID.BR, TAG_ID.CENTER, TAG_ID.CODE, TAG_ID.DD, TAG_ID.DIV, TAG_ID.DL, TAG_ID.DT, TAG_ID.EM, TAG_ID.EMBED, TAG_ID.H1, TAG_ID.H2, TAG_ID.H3, TAG_ID.H4, TAG_ID.H5, TAG_ID.H6, TAG_ID.HEAD, TAG_ID.HR, TAG_ID.I, TAG_ID.IMG, TAG_ID.LI, TAG_ID.LISTING, TAG_ID.MENU, TAG_ID.META, TAG_ID.NOBR, TAG_ID.OL, TAG_ID.P, TAG_ID.PRE, TAG_ID.RUBY, TAG_ID.S, TAG_ID.SMALL, TAG_ID.SPAN, TAG_ID.STRONG, TAG_ID.STRIKE, TAG_ID.SUB, TAG_ID.SUP, TAG_ID.TABLE, TAG_ID.TT, TAG_ID.U, TAG_ID.UL, TAG_ID.VAR]);
//Check exit from foreign content
function causesExit(startTagToken) {
  var tn = startTagToken.tagID;
  var isFontWithAttrs = tn === TAG_ID.FONT && startTagToken.attrs.some(function (_ref) {
    var name = _ref.name;
    return name === ATTRS.COLOR || name === ATTRS.SIZE || name === ATTRS.FACE;
  });
  return isFontWithAttrs || EXITS_FOREIGN_CONTENT.has(tn);
}
//Token adjustments
function adjustTokenMathMLAttrs(token) {
  for (var i = 0; i < token.attrs.length; i++) {
    if (token.attrs[i].name === DEFINITION_URL_ATTR) {
      token.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
      break;
    }
  }
}
function adjustTokenSVGAttrs(token) {
  for (var i = 0; i < token.attrs.length; i++) {
    var adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
    if (adjustedAttrName != null) {
      token.attrs[i].name = adjustedAttrName;
    }
  }
}
function adjustTokenXMLAttrs(token) {
  for (var i = 0; i < token.attrs.length; i++) {
    var adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
    if (adjustedAttrEntry) {
      token.attrs[i].prefix = adjustedAttrEntry.prefix;
      token.attrs[i].name = adjustedAttrEntry.name;
      token.attrs[i].namespace = adjustedAttrEntry.namespace;
    }
  }
}
function adjustTokenSVGTagName(token) {
  var adjustedTagName = SVG_TAG_NAMES_ADJUSTMENT_MAP.get(token.tagName);
  if (adjustedTagName != null) {
    token.tagName = adjustedTagName;
    token.tagID = getTagID(token.tagName);
  }
}
//Integration points
function isMathMLTextIntegrationPoint(tn, ns) {
  return ns === NS.MATHML && (tn === TAG_ID.MI || tn === TAG_ID.MO || tn === TAG_ID.MN || tn === TAG_ID.MS || tn === TAG_ID.MTEXT);
}
function isHtmlIntegrationPoint(tn, ns, attrs) {
  if (ns === NS.MATHML && tn === TAG_ID.ANNOTATION_XML) {
    for (var i = 0; i < attrs.length; i++) {
      if (attrs[i].name === ATTRS.ENCODING) {
        var value = attrs[i].value.toLowerCase();
        return value === MIME_TYPES.TEXT_HTML || value === MIME_TYPES.APPLICATION_XML;
      }
    }
  }
  return ns === NS.SVG && (tn === TAG_ID.FOREIGN_OBJECT || tn === TAG_ID.DESC || tn === TAG_ID.TITLE);
}
function isIntegrationPoint(tn, ns, attrs, foreignNS) {
  return (!foreignNS || foreignNS === NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs) || (!foreignNS || foreignNS === NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns);
}

//Misc constants
var HIDDEN_INPUT_TYPE = 'hidden';
//Adoption agency loops iteration count
var AA_OUTER_LOOP_ITER = 8;
var AA_INNER_LOOP_ITER = 3;
//Insertion modes
var InsertionMode;
(function (InsertionMode) {
  InsertionMode[InsertionMode["INITIAL"] = 0] = "INITIAL";
  InsertionMode[InsertionMode["BEFORE_HTML"] = 1] = "BEFORE_HTML";
  InsertionMode[InsertionMode["BEFORE_HEAD"] = 2] = "BEFORE_HEAD";
  InsertionMode[InsertionMode["IN_HEAD"] = 3] = "IN_HEAD";
  InsertionMode[InsertionMode["IN_HEAD_NO_SCRIPT"] = 4] = "IN_HEAD_NO_SCRIPT";
  InsertionMode[InsertionMode["AFTER_HEAD"] = 5] = "AFTER_HEAD";
  InsertionMode[InsertionMode["IN_BODY"] = 6] = "IN_BODY";
  InsertionMode[InsertionMode["TEXT"] = 7] = "TEXT";
  InsertionMode[InsertionMode["IN_TABLE"] = 8] = "IN_TABLE";
  InsertionMode[InsertionMode["IN_TABLE_TEXT"] = 9] = "IN_TABLE_TEXT";
  InsertionMode[InsertionMode["IN_CAPTION"] = 10] = "IN_CAPTION";
  InsertionMode[InsertionMode["IN_COLUMN_GROUP"] = 11] = "IN_COLUMN_GROUP";
  InsertionMode[InsertionMode["IN_TABLE_BODY"] = 12] = "IN_TABLE_BODY";
  InsertionMode[InsertionMode["IN_ROW"] = 13] = "IN_ROW";
  InsertionMode[InsertionMode["IN_CELL"] = 14] = "IN_CELL";
  InsertionMode[InsertionMode["IN_SELECT"] = 15] = "IN_SELECT";
  InsertionMode[InsertionMode["IN_SELECT_IN_TABLE"] = 16] = "IN_SELECT_IN_TABLE";
  InsertionMode[InsertionMode["IN_TEMPLATE"] = 17] = "IN_TEMPLATE";
  InsertionMode[InsertionMode["AFTER_BODY"] = 18] = "AFTER_BODY";
  InsertionMode[InsertionMode["IN_FRAMESET"] = 19] = "IN_FRAMESET";
  InsertionMode[InsertionMode["AFTER_FRAMESET"] = 20] = "AFTER_FRAMESET";
  InsertionMode[InsertionMode["AFTER_AFTER_BODY"] = 21] = "AFTER_AFTER_BODY";
  InsertionMode[InsertionMode["AFTER_AFTER_FRAMESET"] = 22] = "AFTER_AFTER_FRAMESET";
})(InsertionMode || (InsertionMode = {}));
var BASE_LOC = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
};
var TABLE_STRUCTURE_TAGS = new Set([TAG_ID.TABLE, TAG_ID.TBODY, TAG_ID.TFOOT, TAG_ID.THEAD, TAG_ID.TR]);
var defaultParserOptions = {
  scriptingEnabled: true,
  sourceCodeLocationInfo: false,
  treeAdapter: defaultTreeAdapter,
  onParseError: null
};
//Parser
var Parser = /*#__PURE__*/function () {
  function Parser(options, document) {
    var fragmentContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var scriptHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck$1(this, Parser);
    this.fragmentContext = fragmentContext;
    this.scriptHandler = scriptHandler;
    this.currentToken = null;
    this.stopped = false;
    /** @internal */
    this.insertionMode = InsertionMode.INITIAL;
    /** @internal */
    this.originalInsertionMode = InsertionMode.INITIAL;
    /** @internal */
    this.headElement = null;
    /** @internal */
    this.formElement = null;
    /** Indicates that the current node is not an element in the HTML namespace */
    this.currentNotInHTML = false;
    /**
     * The template insertion mode stack is maintained from the left.
     * Ie. the topmost element will always have index 0.
     *
     * @internal
     */
    this.tmplInsertionModeStack = [];
    /** @internal */
    this.pendingCharacterTokens = [];
    /** @internal */
    this.hasNonWhitespacePendingCharacterToken = false;
    /** @internal */
    this.framesetOk = true;
    /** @internal */
    this.skipNextNewLine = false;
    /** @internal */
    this.fosterParentingEnabled = false;
    this.options = _objectSpread2(_objectSpread2({}, defaultParserOptions), options);
    this.treeAdapter = this.options.treeAdapter;
    this.onParseError = this.options.onParseError;
    // Always enable location info if we report parse errors.
    if (this.onParseError) {
      this.options.sourceCodeLocationInfo = true;
    }
    this.document = document !== null && document !== void 0 ? document : this.treeAdapter.createDocument();
    this.tokenizer = new Tokenizer(this.options, this);
    this.activeFormattingElements = new FormattingElementList(this.treeAdapter);
    this.fragmentContextID = fragmentContext ? getTagID(this.treeAdapter.getTagName(fragmentContext)) : TAG_ID.UNKNOWN;
    this._setContextModes(fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : this.document, this.fragmentContextID);
    this.openElements = new OpenElementStack(this.document, this.treeAdapter, this);
  }
  // API
  return _createClass$1(Parser, [{
    key: "getFragment",
    value: function getFragment() {
      var rootElement = this.treeAdapter.getFirstChild(this.document);
      var fragment = this.treeAdapter.createDocumentFragment();
      this._adoptNodes(rootElement, fragment);
      return fragment;
    }
    //Errors
    /** @internal */
  }, {
    key: "_err",
    value: function _err(token, code, beforeToken) {
      var _a;
      if (!this.onParseError) return;
      var loc = (_a = token.location) !== null && _a !== void 0 ? _a : BASE_LOC;
      var err = {
        code: code,
        startLine: loc.startLine,
        startCol: loc.startCol,
        startOffset: loc.startOffset,
        endLine: beforeToken ? loc.startLine : loc.endLine,
        endCol: beforeToken ? loc.startCol : loc.endCol,
        endOffset: beforeToken ? loc.startOffset : loc.endOffset
      };
      this.onParseError(err);
    }
    //Stack events
    /** @internal */
  }, {
    key: "onItemPush",
    value: function onItemPush(node, tid, isTop) {
      var _a, _b;
      (_b = (_a = this.treeAdapter).onItemPush) === null || _b === void 0 ? void 0 : _b.call(_a, node);
      if (isTop && this.openElements.stackTop > 0) this._setContextModes(node, tid);
    }
    /** @internal */
  }, {
    key: "onItemPop",
    value: function onItemPop(node, isTop) {
      var _a, _b;
      if (this.options.sourceCodeLocationInfo) {
        this._setEndLocation(node, this.currentToken);
      }
      (_b = (_a = this.treeAdapter).onItemPop) === null || _b === void 0 ? void 0 : _b.call(_a, node, this.openElements.current);
      if (isTop) {
        var current;
        var currentTagId;
        if (this.openElements.stackTop === 0 && this.fragmentContext) {
          current = this.fragmentContext;
          currentTagId = this.fragmentContextID;
        } else {
          var _this$openElements = this.openElements;
          current = _this$openElements.current;
          currentTagId = _this$openElements.currentTagId;
        }
        this._setContextModes(current, currentTagId);
      }
    }
  }, {
    key: "_setContextModes",
    value: function _setContextModes(current, tid) {
      var isHTML = current === this.document || current && this.treeAdapter.getNamespaceURI(current) === NS.HTML;
      this.currentNotInHTML = !isHTML;
      this.tokenizer.inForeignNode = !isHTML && current !== undefined && tid !== undefined && !this._isIntegrationPoint(tid, current);
    }
    /** @protected */
  }, {
    key: "_switchToTextParsing",
    value: function _switchToTextParsing(currentToken, nextTokenizerState) {
      this._insertElement(currentToken, NS.HTML);
      this.tokenizer.state = nextTokenizerState;
      this.originalInsertionMode = this.insertionMode;
      this.insertionMode = InsertionMode.TEXT;
    }
  }, {
    key: "switchToPlaintextParsing",
    value: function switchToPlaintextParsing() {
      this.insertionMode = InsertionMode.TEXT;
      this.originalInsertionMode = InsertionMode.IN_BODY;
      this.tokenizer.state = TokenizerMode.PLAINTEXT;
    }
    //Fragment parsing
    /** @protected */
  }, {
    key: "_getAdjustedCurrentElement",
    value: function _getAdjustedCurrentElement() {
      return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
    /** @protected */
  }, {
    key: "_findFormInFragmentContext",
    value: function _findFormInFragmentContext() {
      var node = this.fragmentContext;
      while (node) {
        if (this.treeAdapter.getTagName(node) === TAG_NAMES.FORM) {
          this.formElement = node;
          break;
        }
        node = this.treeAdapter.getParentNode(node);
      }
    }
  }, {
    key: "_initTokenizerForFragmentParsing",
    value: function _initTokenizerForFragmentParsing() {
      if (!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== NS.HTML) {
        return;
      }
      switch (this.fragmentContextID) {
        case TAG_ID.TITLE:
        case TAG_ID.TEXTAREA:
          {
            this.tokenizer.state = TokenizerMode.RCDATA;
            break;
          }
        case TAG_ID.STYLE:
        case TAG_ID.XMP:
        case TAG_ID.IFRAME:
        case TAG_ID.NOEMBED:
        case TAG_ID.NOFRAMES:
        case TAG_ID.NOSCRIPT:
          {
            this.tokenizer.state = TokenizerMode.RAWTEXT;
            break;
          }
        case TAG_ID.SCRIPT:
          {
            this.tokenizer.state = TokenizerMode.SCRIPT_DATA;
            break;
          }
        case TAG_ID.PLAINTEXT:
          {
            this.tokenizer.state = TokenizerMode.PLAINTEXT;
            break;
          }
        // Do nothing
      }
    }
    //Tree mutation
    /** @protected */
  }, {
    key: "_setDocumentType",
    value: function _setDocumentType(token) {
      var _this = this;
      var name = token.name || '';
      var publicId = token.publicId || '';
      var systemId = token.systemId || '';
      this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
      if (token.location) {
        var documentChildren = this.treeAdapter.getChildNodes(this.document);
        var docTypeNode = documentChildren.find(function (node) {
          return _this.treeAdapter.isDocumentTypeNode(node);
        });
        if (docTypeNode) {
          this.treeAdapter.setNodeSourceCodeLocation(docTypeNode, token.location);
        }
      }
    }
    /** @protected */
  }, {
    key: "_attachElementToTree",
    value: function _attachElementToTree(element, location) {
      if (this.options.sourceCodeLocationInfo) {
        var loc = location && _objectSpread2(_objectSpread2({}, location), {}, {
          startTag: location
        });
        this.treeAdapter.setNodeSourceCodeLocation(element, loc);
      }
      if (this._shouldFosterParentOnInsertion()) {
        this._fosterParentElement(element);
      } else {
        var parent = this.openElements.currentTmplContentOrNode;
        this.treeAdapter.appendChild(parent !== null && parent !== void 0 ? parent : this.document, element);
      }
    }
    /**
     * For self-closing tags. Add an element to the tree, but skip adding it
     * to the stack.
     */
    /** @protected */
  }, {
    key: "_appendElement",
    value: function _appendElement(token, namespaceURI) {
      var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
      this._attachElementToTree(element, token.location);
    }
    /** @protected */
  }, {
    key: "_insertElement",
    value: function _insertElement(token, namespaceURI) {
      var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
      this._attachElementToTree(element, token.location);
      this.openElements.push(element, token.tagID);
    }
    /** @protected */
  }, {
    key: "_insertFakeElement",
    value: function _insertFakeElement(tagName, tagID) {
      var element = this.treeAdapter.createElement(tagName, NS.HTML, []);
      this._attachElementToTree(element, null);
      this.openElements.push(element, tagID);
    }
    /** @protected */
  }, {
    key: "_insertTemplate",
    value: function _insertTemplate(token) {
      var tmpl = this.treeAdapter.createElement(token.tagName, NS.HTML, token.attrs);
      var content = this.treeAdapter.createDocumentFragment();
      this.treeAdapter.setTemplateContent(tmpl, content);
      this._attachElementToTree(tmpl, token.location);
      this.openElements.push(tmpl, token.tagID);
      if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(content, null);
    }
    /** @protected */
  }, {
    key: "_insertFakeRootElement",
    value: function _insertFakeRootElement() {
      var element = this.treeAdapter.createElement(TAG_NAMES.HTML, NS.HTML, []);
      if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(element, null);
      this.treeAdapter.appendChild(this.openElements.current, element);
      this.openElements.push(element, TAG_ID.HTML);
    }
    /** @protected */
  }, {
    key: "_appendCommentNode",
    value: function _appendCommentNode(token, parent) {
      var commentNode = this.treeAdapter.createCommentNode(token.data);
      this.treeAdapter.appendChild(parent, commentNode);
      if (this.options.sourceCodeLocationInfo) {
        this.treeAdapter.setNodeSourceCodeLocation(commentNode, token.location);
      }
    }
    /** @protected */
  }, {
    key: "_insertCharacters",
    value: function _insertCharacters(token) {
      var parent;
      var beforeElement;
      if (this._shouldFosterParentOnInsertion()) {
        var _this$_findFosterPare = this._findFosterParentingLocation();
        parent = _this$_findFosterPare.parent;
        beforeElement = _this$_findFosterPare.beforeElement;
        if (beforeElement) {
          this.treeAdapter.insertTextBefore(parent, token.chars, beforeElement);
        } else {
          this.treeAdapter.insertText(parent, token.chars);
        }
      } else {
        parent = this.openElements.currentTmplContentOrNode;
        this.treeAdapter.insertText(parent, token.chars);
      }
      if (!token.location) return;
      var siblings = this.treeAdapter.getChildNodes(parent);
      var textNodeIdx = beforeElement ? siblings.lastIndexOf(beforeElement) : siblings.length;
      var textNode = siblings[textNodeIdx - 1];
      //NOTE: if we have a location assigned by another token, then just update the end position
      var tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);
      if (tnLoc) {
        var _token$location = token.location,
          endLine = _token$location.endLine,
          endCol = _token$location.endCol,
          endOffset = _token$location.endOffset;
        this.treeAdapter.updateNodeSourceCodeLocation(textNode, {
          endLine: endLine,
          endCol: endCol,
          endOffset: endOffset
        });
      } else if (this.options.sourceCodeLocationInfo) {
        this.treeAdapter.setNodeSourceCodeLocation(textNode, token.location);
      }
    }
    /** @protected */
  }, {
    key: "_adoptNodes",
    value: function _adoptNodes(donor, recipient) {
      for (var child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)) {
        this.treeAdapter.detachNode(child);
        this.treeAdapter.appendChild(recipient, child);
      }
    }
    /** @protected */
  }, {
    key: "_setEndLocation",
    value: function _setEndLocation(element, closingToken) {
      if (this.treeAdapter.getNodeSourceCodeLocation(element) && closingToken.location) {
        var ctLoc = closingToken.location;
        var tn = this.treeAdapter.getTagName(element);
        var endLoc =
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        closingToken.type === TokenType.END_TAG && tn === closingToken.tagName ? {
          endTag: _objectSpread2({}, ctLoc),
          endLine: ctLoc.endLine,
          endCol: ctLoc.endCol,
          endOffset: ctLoc.endOffset
        } : {
          endLine: ctLoc.startLine,
          endCol: ctLoc.startCol,
          endOffset: ctLoc.startOffset
        };
        this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
      }
    }
    //Token processing
  }, {
    key: "shouldProcessStartTagTokenInForeignContent",
    value: function shouldProcessStartTagTokenInForeignContent(token) {
      // Check that neither current === document, or ns === NS.HTML
      if (!this.currentNotInHTML) return false;
      var current;
      var currentTagId;
      if (this.openElements.stackTop === 0 && this.fragmentContext) {
        current = this.fragmentContext;
        currentTagId = this.fragmentContextID;
      } else {
        var _this$openElements2 = this.openElements;
        current = _this$openElements2.current;
        currentTagId = _this$openElements2.currentTagId;
      }
      if (token.tagID === TAG_ID.SVG && this.treeAdapter.getTagName(current) === TAG_NAMES.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(current) === NS.MATHML) {
        return false;
      }
      return (
        // Check that `current` is not an integration point for HTML or MathML elements.
        this.tokenizer.inForeignNode ||
        // If it _is_ an integration point, then we might have to check that it is not an HTML
        // integration point.
        (token.tagID === TAG_ID.MGLYPH || token.tagID === TAG_ID.MALIGNMARK) && currentTagId !== undefined && !this._isIntegrationPoint(currentTagId, current, NS.HTML)
      );
    }
    /** @protected */
  }, {
    key: "_processToken",
    value: function _processToken(token) {
      switch (token.type) {
        case TokenType.CHARACTER:
          {
            this.onCharacter(token);
            break;
          }
        case TokenType.NULL_CHARACTER:
          {
            this.onNullCharacter(token);
            break;
          }
        case TokenType.COMMENT:
          {
            this.onComment(token);
            break;
          }
        case TokenType.DOCTYPE:
          {
            this.onDoctype(token);
            break;
          }
        case TokenType.START_TAG:
          {
            this._processStartTag(token);
            break;
          }
        case TokenType.END_TAG:
          {
            this.onEndTag(token);
            break;
          }
        case TokenType.EOF:
          {
            this.onEof(token);
            break;
          }
        case TokenType.WHITESPACE_CHARACTER:
          {
            this.onWhitespaceCharacter(token);
            break;
          }
      }
    }
    //Integration points
    /** @protected */
  }, {
    key: "_isIntegrationPoint",
    value: function _isIntegrationPoint(tid, element, foreignNS) {
      var ns = this.treeAdapter.getNamespaceURI(element);
      var attrs = this.treeAdapter.getAttrList(element);
      return isIntegrationPoint(tid, ns, attrs, foreignNS);
    }
    //Active formatting elements reconstruction
    /** @protected */
  }, {
    key: "_reconstructActiveFormattingElements",
    value: function _reconstructActiveFormattingElements() {
      var _this2 = this;
      var listLength = this.activeFormattingElements.entries.length;
      if (listLength) {
        var endIndex = this.activeFormattingElements.entries.findIndex(function (entry) {
          return entry.type === EntryType.Marker || _this2.openElements.contains(entry.element);
        });
        var unopenIdx = endIndex === -1 ? listLength - 1 : endIndex - 1;
        for (var i = unopenIdx; i >= 0; i--) {
          var entry = this.activeFormattingElements.entries[i];
          this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
          entry.element = this.openElements.current;
        }
      }
    }
    //Close elements
    /** @protected */
  }, {
    key: "_closeTableCell",
    value: function _closeTableCell() {
      this.openElements.generateImpliedEndTags();
      this.openElements.popUntilTableCellPopped();
      this.activeFormattingElements.clearToLastMarker();
      this.insertionMode = InsertionMode.IN_ROW;
    }
    /** @protected */
  }, {
    key: "_closePElement",
    value: function _closePElement() {
      this.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.P);
      this.openElements.popUntilTagNamePopped(TAG_ID.P);
    }
    //Insertion modes
    /** @protected */
  }, {
    key: "_resetInsertionMode",
    value: function _resetInsertionMode() {
      for (var i = this.openElements.stackTop; i >= 0; i--) {
        //Insertion mode reset map
        switch (i === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[i]) {
          case TAG_ID.TR:
            {
              this.insertionMode = InsertionMode.IN_ROW;
              return;
            }
          case TAG_ID.TBODY:
          case TAG_ID.THEAD:
          case TAG_ID.TFOOT:
            {
              this.insertionMode = InsertionMode.IN_TABLE_BODY;
              return;
            }
          case TAG_ID.CAPTION:
            {
              this.insertionMode = InsertionMode.IN_CAPTION;
              return;
            }
          case TAG_ID.COLGROUP:
            {
              this.insertionMode = InsertionMode.IN_COLUMN_GROUP;
              return;
            }
          case TAG_ID.TABLE:
            {
              this.insertionMode = InsertionMode.IN_TABLE;
              return;
            }
          case TAG_ID.BODY:
            {
              this.insertionMode = InsertionMode.IN_BODY;
              return;
            }
          case TAG_ID.FRAMESET:
            {
              this.insertionMode = InsertionMode.IN_FRAMESET;
              return;
            }
          case TAG_ID.SELECT:
            {
              this._resetInsertionModeForSelect(i);
              return;
            }
          case TAG_ID.TEMPLATE:
            {
              this.insertionMode = this.tmplInsertionModeStack[0];
              return;
            }
          case TAG_ID.HTML:
            {
              this.insertionMode = this.headElement ? InsertionMode.AFTER_HEAD : InsertionMode.BEFORE_HEAD;
              return;
            }
          case TAG_ID.TD:
          case TAG_ID.TH:
            {
              if (i > 0) {
                this.insertionMode = InsertionMode.IN_CELL;
                return;
              }
              break;
            }
          case TAG_ID.HEAD:
            {
              if (i > 0) {
                this.insertionMode = InsertionMode.IN_HEAD;
                return;
              }
              break;
            }
        }
      }
      this.insertionMode = InsertionMode.IN_BODY;
    }
    /** @protected */
  }, {
    key: "_resetInsertionModeForSelect",
    value: function _resetInsertionModeForSelect(selectIdx) {
      if (selectIdx > 0) {
        for (var i = selectIdx - 1; i > 0; i--) {
          var tn = this.openElements.tagIDs[i];
          if (tn === TAG_ID.TEMPLATE) {
            break;
          } else if (tn === TAG_ID.TABLE) {
            this.insertionMode = InsertionMode.IN_SELECT_IN_TABLE;
            return;
          }
        }
      }
      this.insertionMode = InsertionMode.IN_SELECT;
    }
    //Foster parenting
    /** @protected */
  }, {
    key: "_isElementCausesFosterParenting",
    value: function _isElementCausesFosterParenting(tn) {
      return TABLE_STRUCTURE_TAGS.has(tn);
    }
    /** @protected */
  }, {
    key: "_shouldFosterParentOnInsertion",
    value: function _shouldFosterParentOnInsertion() {
      return this.fosterParentingEnabled && this.openElements.currentTagId !== undefined && this._isElementCausesFosterParenting(this.openElements.currentTagId);
    }
    /** @protected */
  }, {
    key: "_findFosterParentingLocation",
    value: function _findFosterParentingLocation() {
      for (var i = this.openElements.stackTop; i >= 0; i--) {
        var openElement = this.openElements.items[i];
        switch (this.openElements.tagIDs[i]) {
          case TAG_ID.TEMPLATE:
            {
              if (this.treeAdapter.getNamespaceURI(openElement) === NS.HTML) {
                return {
                  parent: this.treeAdapter.getTemplateContent(openElement),
                  beforeElement: null
                };
              }
              break;
            }
          case TAG_ID.TABLE:
            {
              var parent = this.treeAdapter.getParentNode(openElement);
              if (parent) {
                return {
                  parent: parent,
                  beforeElement: openElement
                };
              }
              return {
                parent: this.openElements.items[i - 1],
                beforeElement: null
              };
            }
          // Do nothing
        }
      }
      return {
        parent: this.openElements.items[0],
        beforeElement: null
      };
    }
    /** @protected */
  }, {
    key: "_fosterParentElement",
    value: function _fosterParentElement(element) {
      var location = this._findFosterParentingLocation();
      if (location.beforeElement) {
        this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
      } else {
        this.treeAdapter.appendChild(location.parent, element);
      }
    }
    //Special elements
    /** @protected */
  }, {
    key: "_isSpecialElement",
    value: function _isSpecialElement(element, id) {
      var ns = this.treeAdapter.getNamespaceURI(element);
      return SPECIAL_ELEMENTS[ns].has(id);
    }
    /** @internal */
  }, {
    key: "onCharacter",
    value: function onCharacter(token) {
      this.skipNextNewLine = false;
      if (this.tokenizer.inForeignNode) {
        characterInForeignContent(this, token);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode.INITIAL:
          {
            tokenInInitialMode(this, token);
            break;
          }
        case InsertionMode.BEFORE_HTML:
          {
            tokenBeforeHtml(this, token);
            break;
          }
        case InsertionMode.BEFORE_HEAD:
          {
            tokenBeforeHead(this, token);
            break;
          }
        case InsertionMode.IN_HEAD:
          {
            tokenInHead(this, token);
            break;
          }
        case InsertionMode.IN_HEAD_NO_SCRIPT:
          {
            tokenInHeadNoScript(this, token);
            break;
          }
        case InsertionMode.AFTER_HEAD:
          {
            tokenAfterHead(this, token);
            break;
          }
        case InsertionMode.IN_BODY:
        case InsertionMode.IN_CAPTION:
        case InsertionMode.IN_CELL:
        case InsertionMode.IN_TEMPLATE:
          {
            characterInBody(this, token);
            break;
          }
        case InsertionMode.TEXT:
        case InsertionMode.IN_SELECT:
        case InsertionMode.IN_SELECT_IN_TABLE:
          {
            this._insertCharacters(token);
            break;
          }
        case InsertionMode.IN_TABLE:
        case InsertionMode.IN_TABLE_BODY:
        case InsertionMode.IN_ROW:
          {
            characterInTable(this, token);
            break;
          }
        case InsertionMode.IN_TABLE_TEXT:
          {
            characterInTableText(this, token);
            break;
          }
        case InsertionMode.IN_COLUMN_GROUP:
          {
            tokenInColumnGroup(this, token);
            break;
          }
        case InsertionMode.AFTER_BODY:
          {
            tokenAfterBody(this, token);
            break;
          }
        case InsertionMode.AFTER_AFTER_BODY:
          {
            tokenAfterAfterBody(this, token);
            break;
          }
        // Do nothing
      }
    }
    /** @internal */
  }, {
    key: "onNullCharacter",
    value: function onNullCharacter(token) {
      this.skipNextNewLine = false;
      if (this.tokenizer.inForeignNode) {
        nullCharacterInForeignContent(this, token);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode.INITIAL:
          {
            tokenInInitialMode(this, token);
            break;
          }
        case InsertionMode.BEFORE_HTML:
          {
            tokenBeforeHtml(this, token);
            break;
          }
        case InsertionMode.BEFORE_HEAD:
          {
            tokenBeforeHead(this, token);
            break;
          }
        case InsertionMode.IN_HEAD:
          {
            tokenInHead(this, token);
            break;
          }
        case InsertionMode.IN_HEAD_NO_SCRIPT:
          {
            tokenInHeadNoScript(this, token);
            break;
          }
        case InsertionMode.AFTER_HEAD:
          {
            tokenAfterHead(this, token);
            break;
          }
        case InsertionMode.TEXT:
          {
            this._insertCharacters(token);
            break;
          }
        case InsertionMode.IN_TABLE:
        case InsertionMode.IN_TABLE_BODY:
        case InsertionMode.IN_ROW:
          {
            characterInTable(this, token);
            break;
          }
        case InsertionMode.IN_COLUMN_GROUP:
          {
            tokenInColumnGroup(this, token);
            break;
          }
        case InsertionMode.AFTER_BODY:
          {
            tokenAfterBody(this, token);
            break;
          }
        case InsertionMode.AFTER_AFTER_BODY:
          {
            tokenAfterAfterBody(this, token);
            break;
          }
        // Do nothing
      }
    }
    /** @internal */
  }, {
    key: "onComment",
    value: function onComment(token) {
      this.skipNextNewLine = false;
      if (this.currentNotInHTML) {
        appendComment(this, token);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode.INITIAL:
        case InsertionMode.BEFORE_HTML:
        case InsertionMode.BEFORE_HEAD:
        case InsertionMode.IN_HEAD:
        case InsertionMode.IN_HEAD_NO_SCRIPT:
        case InsertionMode.AFTER_HEAD:
        case InsertionMode.IN_BODY:
        case InsertionMode.IN_TABLE:
        case InsertionMode.IN_CAPTION:
        case InsertionMode.IN_COLUMN_GROUP:
        case InsertionMode.IN_TABLE_BODY:
        case InsertionMode.IN_ROW:
        case InsertionMode.IN_CELL:
        case InsertionMode.IN_SELECT:
        case InsertionMode.IN_SELECT_IN_TABLE:
        case InsertionMode.IN_TEMPLATE:
        case InsertionMode.IN_FRAMESET:
        case InsertionMode.AFTER_FRAMESET:
          {
            appendComment(this, token);
            break;
          }
        case InsertionMode.IN_TABLE_TEXT:
          {
            tokenInTableText(this, token);
            break;
          }
        case InsertionMode.AFTER_BODY:
          {
            appendCommentToRootHtmlElement(this, token);
            break;
          }
        case InsertionMode.AFTER_AFTER_BODY:
        case InsertionMode.AFTER_AFTER_FRAMESET:
          {
            appendCommentToDocument(this, token);
            break;
          }
        // Do nothing
      }
    }
    /** @internal */
  }, {
    key: "onDoctype",
    value: function onDoctype(token) {
      this.skipNextNewLine = false;
      switch (this.insertionMode) {
        case InsertionMode.INITIAL:
          {
            doctypeInInitialMode(this, token);
            break;
          }
        case InsertionMode.BEFORE_HEAD:
        case InsertionMode.IN_HEAD:
        case InsertionMode.IN_HEAD_NO_SCRIPT:
        case InsertionMode.AFTER_HEAD:
          {
            this._err(token, ERR.misplacedDoctype);
            break;
          }
        case InsertionMode.IN_TABLE_TEXT:
          {
            tokenInTableText(this, token);
            break;
          }
        // Do nothing
      }
    }
    /** @internal */
  }, {
    key: "onStartTag",
    value: function onStartTag(token) {
      this.skipNextNewLine = false;
      this.currentToken = token;
      this._processStartTag(token);
      if (token.selfClosing && !token.ackSelfClosing) {
        this._err(token, ERR.nonVoidHtmlElementStartTagWithTrailingSolidus);
      }
    }
    /**
     * Processes a given start tag.
     *
     * `onStartTag` checks if a self-closing tag was recognized. When a token
     * is moved inbetween multiple insertion modes, this check for self-closing
     * could lead to false positives. To avoid this, `_processStartTag` is used
     * for nested calls.
     *
     * @param token The token to process.
     * @protected
     */
  }, {
    key: "_processStartTag",
    value: function _processStartTag(token) {
      if (this.shouldProcessStartTagTokenInForeignContent(token)) {
        startTagInForeignContent(this, token);
      } else {
        this._startTagOutsideForeignContent(token);
      }
    }
    /** @protected */
  }, {
    key: "_startTagOutsideForeignContent",
    value: function _startTagOutsideForeignContent(token) {
      switch (this.insertionMode) {
        case InsertionMode.INITIAL:
          {
            tokenInInitialMode(this, token);
            break;
          }
        case InsertionMode.BEFORE_HTML:
          {
            startTagBeforeHtml(this, token);
            break;
          }
        case InsertionMode.BEFORE_HEAD:
          {
            startTagBeforeHead(this, token);
            break;
          }
        case InsertionMode.IN_HEAD:
          {
            startTagInHead(this, token);
            break;
          }
        case InsertionMode.IN_HEAD_NO_SCRIPT:
          {
            startTagInHeadNoScript(this, token);
            break;
          }
        case InsertionMode.AFTER_HEAD:
          {
            startTagAfterHead(this, token);
            break;
          }
        case InsertionMode.IN_BODY:
          {
            startTagInBody(this, token);
            break;
          }
        case InsertionMode.IN_TABLE:
          {
            startTagInTable(this, token);
            break;
          }
        case InsertionMode.IN_TABLE_TEXT:
          {
            tokenInTableText(this, token);
            break;
          }
        case InsertionMode.IN_CAPTION:
          {
            startTagInCaption(this, token);
            break;
          }
        case InsertionMode.IN_COLUMN_GROUP:
          {
            startTagInColumnGroup(this, token);
            break;
          }
        case InsertionMode.IN_TABLE_BODY:
          {
            startTagInTableBody(this, token);
            break;
          }
        case InsertionMode.IN_ROW:
          {
            startTagInRow(this, token);
            break;
          }
        case InsertionMode.IN_CELL:
          {
            startTagInCell(this, token);
            break;
          }
        case InsertionMode.IN_SELECT:
          {
            startTagInSelect(this, token);
            break;
          }
        case InsertionMode.IN_SELECT_IN_TABLE:
          {
            startTagInSelectInTable(this, token);
            break;
          }
        case InsertionMode.IN_TEMPLATE:
          {
            startTagInTemplate(this, token);
            break;
          }
        case InsertionMode.AFTER_BODY:
          {
            startTagAfterBody(this, token);
            break;
          }
        case InsertionMode.IN_FRAMESET:
          {
            startTagInFrameset(this, token);
            break;
          }
        case InsertionMode.AFTER_FRAMESET:
          {
            startTagAfterFrameset(this, token);
            break;
          }
        case InsertionMode.AFTER_AFTER_BODY:
          {
            startTagAfterAfterBody(this, token);
            break;
          }
        case InsertionMode.AFTER_AFTER_FRAMESET:
          {
            startTagAfterAfterFrameset(this, token);
            break;
          }
        // Do nothing
      }
    }
    /** @internal */
  }, {
    key: "onEndTag",
    value: function onEndTag(token) {
      this.skipNextNewLine = false;
      this.currentToken = token;
      if (this.currentNotInHTML) {
        endTagInForeignContent(this, token);
      } else {
        this._endTagOutsideForeignContent(token);
      }
    }
    /** @protected */
  }, {
    key: "_endTagOutsideForeignContent",
    value: function _endTagOutsideForeignContent(token) {
      switch (this.insertionMode) {
        case InsertionMode.INITIAL:
          {
            tokenInInitialMode(this, token);
            break;
          }
        case InsertionMode.BEFORE_HTML:
          {
            endTagBeforeHtml(this, token);
            break;
          }
        case InsertionMode.BEFORE_HEAD:
          {
            endTagBeforeHead(this, token);
            break;
          }
        case InsertionMode.IN_HEAD:
          {
            endTagInHead(this, token);
            break;
          }
        case InsertionMode.IN_HEAD_NO_SCRIPT:
          {
            endTagInHeadNoScript(this, token);
            break;
          }
        case InsertionMode.AFTER_HEAD:
          {
            endTagAfterHead(this, token);
            break;
          }
        case InsertionMode.IN_BODY:
          {
            endTagInBody(this, token);
            break;
          }
        case InsertionMode.TEXT:
          {
            endTagInText(this, token);
            break;
          }
        case InsertionMode.IN_TABLE:
          {
            endTagInTable(this, token);
            break;
          }
        case InsertionMode.IN_TABLE_TEXT:
          {
            tokenInTableText(this, token);
            break;
          }
        case InsertionMode.IN_CAPTION:
          {
            endTagInCaption(this, token);
            break;
          }
        case InsertionMode.IN_COLUMN_GROUP:
          {
            endTagInColumnGroup(this, token);
            break;
          }
        case InsertionMode.IN_TABLE_BODY:
          {
            endTagInTableBody(this, token);
            break;
          }
        case InsertionMode.IN_ROW:
          {
            endTagInRow(this, token);
            break;
          }
        case InsertionMode.IN_CELL:
          {
            endTagInCell(this, token);
            break;
          }
        case InsertionMode.IN_SELECT:
          {
            endTagInSelect(this, token);
            break;
          }
        case InsertionMode.IN_SELECT_IN_TABLE:
          {
            endTagInSelectInTable(this, token);
            break;
          }
        case InsertionMode.IN_TEMPLATE:
          {
            endTagInTemplate(this, token);
            break;
          }
        case InsertionMode.AFTER_BODY:
          {
            endTagAfterBody(this, token);
            break;
          }
        case InsertionMode.IN_FRAMESET:
          {
            endTagInFrameset(this, token);
            break;
          }
        case InsertionMode.AFTER_FRAMESET:
          {
            endTagAfterFrameset(this, token);
            break;
          }
        case InsertionMode.AFTER_AFTER_BODY:
          {
            tokenAfterAfterBody(this, token);
            break;
          }
        // Do nothing
      }
    }
    /** @internal */
  }, {
    key: "onEof",
    value: function onEof(token) {
      switch (this.insertionMode) {
        case InsertionMode.INITIAL:
          {
            tokenInInitialMode(this, token);
            break;
          }
        case InsertionMode.BEFORE_HTML:
          {
            tokenBeforeHtml(this, token);
            break;
          }
        case InsertionMode.BEFORE_HEAD:
          {
            tokenBeforeHead(this, token);
            break;
          }
        case InsertionMode.IN_HEAD:
          {
            tokenInHead(this, token);
            break;
          }
        case InsertionMode.IN_HEAD_NO_SCRIPT:
          {
            tokenInHeadNoScript(this, token);
            break;
          }
        case InsertionMode.AFTER_HEAD:
          {
            tokenAfterHead(this, token);
            break;
          }
        case InsertionMode.IN_BODY:
        case InsertionMode.IN_TABLE:
        case InsertionMode.IN_CAPTION:
        case InsertionMode.IN_COLUMN_GROUP:
        case InsertionMode.IN_TABLE_BODY:
        case InsertionMode.IN_ROW:
        case InsertionMode.IN_CELL:
        case InsertionMode.IN_SELECT:
        case InsertionMode.IN_SELECT_IN_TABLE:
          {
            eofInBody(this, token);
            break;
          }
        case InsertionMode.TEXT:
          {
            eofInText(this, token);
            break;
          }
        case InsertionMode.IN_TABLE_TEXT:
          {
            tokenInTableText(this, token);
            break;
          }
        case InsertionMode.IN_TEMPLATE:
          {
            eofInTemplate(this, token);
            break;
          }
        case InsertionMode.AFTER_BODY:
        case InsertionMode.IN_FRAMESET:
        case InsertionMode.AFTER_FRAMESET:
        case InsertionMode.AFTER_AFTER_BODY:
        case InsertionMode.AFTER_AFTER_FRAMESET:
          {
            stopParsing(this, token);
            break;
          }
        // Do nothing
      }
    }
    /** @internal */
  }, {
    key: "onWhitespaceCharacter",
    value: function onWhitespaceCharacter(token) {
      if (this.skipNextNewLine) {
        this.skipNextNewLine = false;
        if (token.chars.charCodeAt(0) === CODE_POINTS.LINE_FEED) {
          if (token.chars.length === 1) {
            return;
          }
          token.chars = token.chars.substr(1);
        }
      }
      if (this.tokenizer.inForeignNode) {
        this._insertCharacters(token);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode.IN_HEAD:
        case InsertionMode.IN_HEAD_NO_SCRIPT:
        case InsertionMode.AFTER_HEAD:
        case InsertionMode.TEXT:
        case InsertionMode.IN_COLUMN_GROUP:
        case InsertionMode.IN_SELECT:
        case InsertionMode.IN_SELECT_IN_TABLE:
        case InsertionMode.IN_FRAMESET:
        case InsertionMode.AFTER_FRAMESET:
          {
            this._insertCharacters(token);
            break;
          }
        case InsertionMode.IN_BODY:
        case InsertionMode.IN_CAPTION:
        case InsertionMode.IN_CELL:
        case InsertionMode.IN_TEMPLATE:
        case InsertionMode.AFTER_BODY:
        case InsertionMode.AFTER_AFTER_BODY:
        case InsertionMode.AFTER_AFTER_FRAMESET:
          {
            whitespaceCharacterInBody(this, token);
            break;
          }
        case InsertionMode.IN_TABLE:
        case InsertionMode.IN_TABLE_BODY:
        case InsertionMode.IN_ROW:
          {
            characterInTable(this, token);
            break;
          }
        case InsertionMode.IN_TABLE_TEXT:
          {
            whitespaceCharacterInTableText(this, token);
            break;
          }
        // Do nothing
      }
    }
  }], [{
    key: "parse",
    value: function parse(html, options) {
      var parser = new this(options);
      parser.tokenizer.write(html, true);
      return parser.document;
    }
  }, {
    key: "getFragmentParser",
    value: function getFragmentParser(fragmentContext, options) {
      var opts = _objectSpread2(_objectSpread2({}, defaultParserOptions), options);
      //NOTE: use a <template> element as the fragment context if no context element was provided,
      //so we will parse in a "forgiving" manner
      fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : fragmentContext = opts.treeAdapter.createElement(TAG_NAMES.TEMPLATE, NS.HTML, []);
      //NOTE: create a fake element which will be used as the `document` for fragment parsing.
      //This is important for jsdom, where a new `document` cannot be created. This led to
      //fragment parsing messing with the main `document`.
      var documentMock = opts.treeAdapter.createElement('documentmock', NS.HTML, []);
      var parser = new this(opts, documentMock, fragmentContext);
      if (parser.fragmentContextID === TAG_ID.TEMPLATE) {
        parser.tmplInsertionModeStack.unshift(InsertionMode.IN_TEMPLATE);
      }
      parser._initTokenizerForFragmentParsing();
      parser._insertFakeRootElement();
      parser._resetInsertionMode();
      parser._findFormInFragmentContext();
      return parser;
    }
  }]);
}();
//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------
//Steps 5-8 of the algorithm
function aaObtainFormattingElementEntry(p, token) {
  var formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);
  if (formattingElementEntry) {
    if (!p.openElements.contains(formattingElementEntry.element)) {
      p.activeFormattingElements.removeEntry(formattingElementEntry);
      formattingElementEntry = null;
    } else if (!p.openElements.hasInScope(token.tagID)) {
      formattingElementEntry = null;
    }
  } else {
    genericEndTagInBody(p, token);
  }
  return formattingElementEntry;
}
//Steps 9 and 10 of the algorithm
function aaObtainFurthestBlock(p, formattingElementEntry) {
  var furthestBlock = null;
  var idx = p.openElements.stackTop;
  for (; idx >= 0; idx--) {
    var element = p.openElements.items[idx];
    if (element === formattingElementEntry.element) {
      break;
    }
    if (p._isSpecialElement(element, p.openElements.tagIDs[idx])) {
      furthestBlock = element;
    }
  }
  if (!furthestBlock) {
    p.openElements.shortenToLength(Math.max(idx, 0));
    p.activeFormattingElements.removeEntry(formattingElementEntry);
  }
  return furthestBlock;
}
//Step 13 of the algorithm
function aaInnerLoop(p, furthestBlock, formattingElement) {
  var lastElement = furthestBlock;
  var nextElement = p.openElements.getCommonAncestor(furthestBlock);
  for (var i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
    //NOTE: store the next element for the next loop iteration (it may be deleted from the stack by step 9.5)
    nextElement = p.openElements.getCommonAncestor(element);
    var elementEntry = p.activeFormattingElements.getElementEntry(element);
    var counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER;
    var shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
    if (shouldRemoveFromOpenElements) {
      if (counterOverflow) {
        p.activeFormattingElements.removeEntry(elementEntry);
      }
      p.openElements.remove(element);
    } else {
      element = aaRecreateElementFromEntry(p, elementEntry);
      if (lastElement === furthestBlock) {
        p.activeFormattingElements.bookmark = elementEntry;
      }
      p.treeAdapter.detachNode(lastElement);
      p.treeAdapter.appendChild(element, lastElement);
      lastElement = element;
    }
  }
  return lastElement;
}
//Step 13.7 of the algorithm
function aaRecreateElementFromEntry(p, elementEntry) {
  var ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
  var newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
  p.openElements.replace(elementEntry.element, newElement);
  elementEntry.element = newElement;
  return newElement;
}
//Step 14 of the algorithm
function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
  var tn = p.treeAdapter.getTagName(commonAncestor);
  var tid = getTagID(tn);
  if (p._isElementCausesFosterParenting(tid)) {
    p._fosterParentElement(lastElement);
  } else {
    var ns = p.treeAdapter.getNamespaceURI(commonAncestor);
    if (tid === TAG_ID.TEMPLATE && ns === NS.HTML) {
      commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
    }
    p.treeAdapter.appendChild(commonAncestor, lastElement);
  }
}
//Steps 15-19 of the algorithm
function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
  var ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
  var token = formattingElementEntry.token;
  var newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);
  p._adoptNodes(furthestBlock, newElement);
  p.treeAdapter.appendChild(furthestBlock, newElement);
  p.activeFormattingElements.insertElementAfterBookmark(newElement, token);
  p.activeFormattingElements.removeEntry(formattingElementEntry);
  p.openElements.remove(formattingElementEntry.element);
  p.openElements.insertAfter(furthestBlock, newElement, token.tagID);
}
//Algorithm entry point
function callAdoptionAgency(p, token) {
  for (var i = 0; i < AA_OUTER_LOOP_ITER; i++) {
    var formattingElementEntry = aaObtainFormattingElementEntry(p, token);
    if (!formattingElementEntry) {
      break;
    }
    var furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);
    if (!furthestBlock) {
      break;
    }
    p.activeFormattingElements.bookmark = formattingElementEntry;
    var lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
    var commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
    p.treeAdapter.detachNode(lastElement);
    if (commonAncestor) aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
    aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
  }
}
//Generic token handlers
//------------------------------------------------------------------
function appendComment(p, token) {
  p._appendCommentNode(token, p.openElements.currentTmplContentOrNode);
}
function appendCommentToRootHtmlElement(p, token) {
  p._appendCommentNode(token, p.openElements.items[0]);
}
function appendCommentToDocument(p, token) {
  p._appendCommentNode(token, p.document);
}
function stopParsing(p, token) {
  p.stopped = true;
  // NOTE: Set end locations for elements that remain on the open element stack.
  if (token.location) {
    // NOTE: If we are not in a fragment, `html` and `body` will stay on the stack.
    // This is a problem, as we might overwrite their end position here.
    var target = p.fragmentContext ? 0 : 2;
    for (var i = p.openElements.stackTop; i >= target; i--) {
      p._setEndLocation(p.openElements.items[i], token);
    }
    // Handle `html` and `body`
    if (!p.fragmentContext && p.openElements.stackTop >= 0) {
      var htmlElement = p.openElements.items[0];
      var htmlLocation = p.treeAdapter.getNodeSourceCodeLocation(htmlElement);
      if (htmlLocation && !htmlLocation.endTag) {
        p._setEndLocation(htmlElement, token);
        if (p.openElements.stackTop >= 1) {
          var bodyElement = p.openElements.items[1];
          var bodyLocation = p.treeAdapter.getNodeSourceCodeLocation(bodyElement);
          if (bodyLocation && !bodyLocation.endTag) {
            p._setEndLocation(bodyElement, token);
          }
        }
      }
    }
  }
}
// The "initial" insertion mode
//------------------------------------------------------------------
function doctypeInInitialMode(p, token) {
  p._setDocumentType(token);
  var mode = token.forceQuirks ? DOCUMENT_MODE.QUIRKS : getDocumentMode(token);
  if (!isConforming(token)) {
    p._err(token, ERR.nonConformingDoctype);
  }
  p.treeAdapter.setDocumentMode(p.document, mode);
  p.insertionMode = InsertionMode.BEFORE_HTML;
}
function tokenInInitialMode(p, token) {
  p._err(token, ERR.missingDoctype, true);
  p.treeAdapter.setDocumentMode(p.document, DOCUMENT_MODE.QUIRKS);
  p.insertionMode = InsertionMode.BEFORE_HTML;
  p._processToken(token);
}
// The "before html" insertion mode
//------------------------------------------------------------------
function startTagBeforeHtml(p, token) {
  if (token.tagID === TAG_ID.HTML) {
    p._insertElement(token, NS.HTML);
    p.insertionMode = InsertionMode.BEFORE_HEAD;
  } else {
    tokenBeforeHtml(p, token);
  }
}
function endTagBeforeHtml(p, token) {
  var tn = token.tagID;
  if (tn === TAG_ID.HTML || tn === TAG_ID.HEAD || tn === TAG_ID.BODY || tn === TAG_ID.BR) {
    tokenBeforeHtml(p, token);
  }
}
function tokenBeforeHtml(p, token) {
  p._insertFakeRootElement();
  p.insertionMode = InsertionMode.BEFORE_HEAD;
  p._processToken(token);
}
// The "before head" insertion mode
//------------------------------------------------------------------
function startTagBeforeHead(p, token) {
  switch (token.tagID) {
    case TAG_ID.HTML:
      {
        startTagInBody(p, token);
        break;
      }
    case TAG_ID.HEAD:
      {
        p._insertElement(token, NS.HTML);
        p.headElement = p.openElements.current;
        p.insertionMode = InsertionMode.IN_HEAD;
        break;
      }
    default:
      {
        tokenBeforeHead(p, token);
      }
  }
}
function endTagBeforeHead(p, token) {
  var tn = token.tagID;
  if (tn === TAG_ID.HEAD || tn === TAG_ID.BODY || tn === TAG_ID.HTML || tn === TAG_ID.BR) {
    tokenBeforeHead(p, token);
  } else {
    p._err(token, ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenBeforeHead(p, token) {
  p._insertFakeElement(TAG_NAMES.HEAD, TAG_ID.HEAD);
  p.headElement = p.openElements.current;
  p.insertionMode = InsertionMode.IN_HEAD;
  p._processToken(token);
}
// The "in head" insertion mode
//------------------------------------------------------------------
function startTagInHead(p, token) {
  switch (token.tagID) {
    case TAG_ID.HTML:
      {
        startTagInBody(p, token);
        break;
      }
    case TAG_ID.BASE:
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.LINK:
    case TAG_ID.META:
      {
        p._appendElement(token, NS.HTML);
        token.ackSelfClosing = true;
        break;
      }
    case TAG_ID.TITLE:
      {
        p._switchToTextParsing(token, TokenizerMode.RCDATA);
        break;
      }
    case TAG_ID.NOSCRIPT:
      {
        if (p.options.scriptingEnabled) {
          p._switchToTextParsing(token, TokenizerMode.RAWTEXT);
        } else {
          p._insertElement(token, NS.HTML);
          p.insertionMode = InsertionMode.IN_HEAD_NO_SCRIPT;
        }
        break;
      }
    case TAG_ID.NOFRAMES:
    case TAG_ID.STYLE:
      {
        p._switchToTextParsing(token, TokenizerMode.RAWTEXT);
        break;
      }
    case TAG_ID.SCRIPT:
      {
        p._switchToTextParsing(token, TokenizerMode.SCRIPT_DATA);
        break;
      }
    case TAG_ID.TEMPLATE:
      {
        p._insertTemplate(token);
        p.activeFormattingElements.insertMarker();
        p.framesetOk = false;
        p.insertionMode = InsertionMode.IN_TEMPLATE;
        p.tmplInsertionModeStack.unshift(InsertionMode.IN_TEMPLATE);
        break;
      }
    case TAG_ID.HEAD:
      {
        p._err(token, ERR.misplacedStartTagForHeadElement);
        break;
      }
    default:
      {
        tokenInHead(p, token);
      }
  }
}
function endTagInHead(p, token) {
  switch (token.tagID) {
    case TAG_ID.HEAD:
      {
        p.openElements.pop();
        p.insertionMode = InsertionMode.AFTER_HEAD;
        break;
      }
    case TAG_ID.BODY:
    case TAG_ID.BR:
    case TAG_ID.HTML:
      {
        tokenInHead(p, token);
        break;
      }
    case TAG_ID.TEMPLATE:
      {
        templateEndTagInHead(p, token);
        break;
      }
    default:
      {
        p._err(token, ERR.endTagWithoutMatchingOpenElement);
      }
  }
}
function templateEndTagInHead(p, token) {
  if (p.openElements.tmplCount > 0) {
    p.openElements.generateImpliedEndTagsThoroughly();
    if (p.openElements.currentTagId !== TAG_ID.TEMPLATE) {
      p._err(token, ERR.closingOfElementWithOpenChildElements);
    }
    p.openElements.popUntilTagNamePopped(TAG_ID.TEMPLATE);
    p.activeFormattingElements.clearToLastMarker();
    p.tmplInsertionModeStack.shift();
    p._resetInsertionMode();
  } else {
    p._err(token, ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenInHead(p, token) {
  p.openElements.pop();
  p.insertionMode = InsertionMode.AFTER_HEAD;
  p._processToken(token);
}
// The "in head no script" insertion mode
//------------------------------------------------------------------
function startTagInHeadNoScript(p, token) {
  switch (token.tagID) {
    case TAG_ID.HTML:
      {
        startTagInBody(p, token);
        break;
      }
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.HEAD:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.NOFRAMES:
    case TAG_ID.STYLE:
      {
        startTagInHead(p, token);
        break;
      }
    case TAG_ID.NOSCRIPT:
      {
        p._err(token, ERR.nestedNoscriptInHead);
        break;
      }
    default:
      {
        tokenInHeadNoScript(p, token);
      }
  }
}
function endTagInHeadNoScript(p, token) {
  switch (token.tagID) {
    case TAG_ID.NOSCRIPT:
      {
        p.openElements.pop();
        p.insertionMode = InsertionMode.IN_HEAD;
        break;
      }
    case TAG_ID.BR:
      {
        tokenInHeadNoScript(p, token);
        break;
      }
    default:
      {
        p._err(token, ERR.endTagWithoutMatchingOpenElement);
      }
  }
}
function tokenInHeadNoScript(p, token) {
  var errCode = token.type === TokenType.EOF ? ERR.openElementsLeftAfterEof : ERR.disallowedContentInNoscriptInHead;
  p._err(token, errCode);
  p.openElements.pop();
  p.insertionMode = InsertionMode.IN_HEAD;
  p._processToken(token);
}
// The "after head" insertion mode
//------------------------------------------------------------------
function startTagAfterHead(p, token) {
  switch (token.tagID) {
    case TAG_ID.HTML:
      {
        startTagInBody(p, token);
        break;
      }
    case TAG_ID.BODY:
      {
        p._insertElement(token, NS.HTML);
        p.framesetOk = false;
        p.insertionMode = InsertionMode.IN_BODY;
        break;
      }
    case TAG_ID.FRAMESET:
      {
        p._insertElement(token, NS.HTML);
        p.insertionMode = InsertionMode.IN_FRAMESET;
        break;
      }
    case TAG_ID.BASE:
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.NOFRAMES:
    case TAG_ID.SCRIPT:
    case TAG_ID.STYLE:
    case TAG_ID.TEMPLATE:
    case TAG_ID.TITLE:
      {
        p._err(token, ERR.abandonedHeadElementChild);
        p.openElements.push(p.headElement, TAG_ID.HEAD);
        startTagInHead(p, token);
        p.openElements.remove(p.headElement);
        break;
      }
    case TAG_ID.HEAD:
      {
        p._err(token, ERR.misplacedStartTagForHeadElement);
        break;
      }
    default:
      {
        tokenAfterHead(p, token);
      }
  }
}
function endTagAfterHead(p, token) {
  switch (token.tagID) {
    case TAG_ID.BODY:
    case TAG_ID.HTML:
    case TAG_ID.BR:
      {
        tokenAfterHead(p, token);
        break;
      }
    case TAG_ID.TEMPLATE:
      {
        templateEndTagInHead(p, token);
        break;
      }
    default:
      {
        p._err(token, ERR.endTagWithoutMatchingOpenElement);
      }
  }
}
function tokenAfterHead(p, token) {
  p._insertFakeElement(TAG_NAMES.BODY, TAG_ID.BODY);
  p.insertionMode = InsertionMode.IN_BODY;
  modeInBody(p, token);
}
// The "in body" insertion mode
//------------------------------------------------------------------
function modeInBody(p, token) {
  switch (token.type) {
    case TokenType.CHARACTER:
      {
        characterInBody(p, token);
        break;
      }
    case TokenType.WHITESPACE_CHARACTER:
      {
        whitespaceCharacterInBody(p, token);
        break;
      }
    case TokenType.COMMENT:
      {
        appendComment(p, token);
        break;
      }
    case TokenType.START_TAG:
      {
        startTagInBody(p, token);
        break;
      }
    case TokenType.END_TAG:
      {
        endTagInBody(p, token);
        break;
      }
    case TokenType.EOF:
      {
        eofInBody(p, token);
        break;
      }
    // Do nothing
  }
}
function whitespaceCharacterInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertCharacters(token);
}
function characterInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertCharacters(token);
  p.framesetOk = false;
}
function htmlStartTagInBody(p, token) {
  if (p.openElements.tmplCount === 0) {
    p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
  }
}
function bodyStartTagInBody(p, token) {
  var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
  if (bodyElement && p.openElements.tmplCount === 0) {
    p.framesetOk = false;
    p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
  }
}
function framesetStartTagInBody(p, token) {
  var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
  if (p.framesetOk && bodyElement) {
    p.treeAdapter.detachNode(bodyElement);
    p.openElements.popAllUpToHtmlElement();
    p._insertElement(token, NS.HTML);
    p.insertionMode = InsertionMode.IN_FRAMESET;
  }
}
function addressStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope(TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token, NS.HTML);
}
function numberedHeaderStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope(TAG_ID.P)) {
    p._closePElement();
  }
  if (p.openElements.currentTagId !== undefined && NUMBERED_HEADERS.has(p.openElements.currentTagId)) {
    p.openElements.pop();
  }
  p._insertElement(token, NS.HTML);
}
function preStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope(TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token, NS.HTML);
  //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
  //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
  p.skipNextNewLine = true;
  p.framesetOk = false;
}
function formStartTagInBody(p, token) {
  var inTemplate = p.openElements.tmplCount > 0;
  if (!p.formElement || inTemplate) {
    if (p.openElements.hasInButtonScope(TAG_ID.P)) {
      p._closePElement();
    }
    p._insertElement(token, NS.HTML);
    if (!inTemplate) {
      p.formElement = p.openElements.current;
    }
  }
}
function listItemStartTagInBody(p, token) {
  p.framesetOk = false;
  var tn = token.tagID;
  for (var i = p.openElements.stackTop; i >= 0; i--) {
    var elementId = p.openElements.tagIDs[i];
    if (tn === TAG_ID.LI && elementId === TAG_ID.LI || (tn === TAG_ID.DD || tn === TAG_ID.DT) && (elementId === TAG_ID.DD || elementId === TAG_ID.DT)) {
      p.openElements.generateImpliedEndTagsWithExclusion(elementId);
      p.openElements.popUntilTagNamePopped(elementId);
      break;
    }
    if (elementId !== TAG_ID.ADDRESS && elementId !== TAG_ID.DIV && elementId !== TAG_ID.P && p._isSpecialElement(p.openElements.items[i], elementId)) {
      break;
    }
  }
  if (p.openElements.hasInButtonScope(TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token, NS.HTML);
}
function plaintextStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope(TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token, NS.HTML);
  p.tokenizer.state = TokenizerMode.PLAINTEXT;
}
function buttonStartTagInBody(p, token) {
  if (p.openElements.hasInScope(TAG_ID.BUTTON)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped(TAG_ID.BUTTON);
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
  p.framesetOk = false;
}
function aStartTagInBody(p, token) {
  var activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(TAG_NAMES.A);
  if (activeElementEntry) {
    callAdoptionAgency(p, token);
    p.openElements.remove(activeElementEntry.element);
    p.activeFormattingElements.removeEntry(activeElementEntry);
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function bStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function nobrStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  if (p.openElements.hasInScope(TAG_ID.NOBR)) {
    callAdoptionAgency(p, token);
    p._reconstructActiveFormattingElements();
  }
  p._insertElement(token, NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function appletStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
  p.activeFormattingElements.insertMarker();
  p.framesetOk = false;
}
function tableStartTagInBody(p, token) {
  if (p.treeAdapter.getDocumentMode(p.document) !== DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope(TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token, NS.HTML);
  p.framesetOk = false;
  p.insertionMode = InsertionMode.IN_TABLE;
}
function areaStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._appendElement(token, NS.HTML);
  p.framesetOk = false;
  token.ackSelfClosing = true;
}
function isHiddenInput(token) {
  var inputType = getTokenAttr(token, ATTRS.TYPE);
  return inputType != null && inputType.toLowerCase() === HIDDEN_INPUT_TYPE;
}
function inputStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._appendElement(token, NS.HTML);
  if (!isHiddenInput(token)) {
    p.framesetOk = false;
  }
  token.ackSelfClosing = true;
}
function paramStartTagInBody(p, token) {
  p._appendElement(token, NS.HTML);
  token.ackSelfClosing = true;
}
function hrStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope(TAG_ID.P)) {
    p._closePElement();
  }
  p._appendElement(token, NS.HTML);
  p.framesetOk = false;
  token.ackSelfClosing = true;
}
function imageStartTagInBody(p, token) {
  token.tagName = TAG_NAMES.IMG;
  token.tagID = TAG_ID.IMG;
  areaStartTagInBody(p, token);
}
function textareaStartTagInBody(p, token) {
  p._insertElement(token, NS.HTML);
  //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
  //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
  p.skipNextNewLine = true;
  p.tokenizer.state = TokenizerMode.RCDATA;
  p.originalInsertionMode = p.insertionMode;
  p.framesetOk = false;
  p.insertionMode = InsertionMode.TEXT;
}
function xmpStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope(TAG_ID.P)) {
    p._closePElement();
  }
  p._reconstructActiveFormattingElements();
  p.framesetOk = false;
  p._switchToTextParsing(token, TokenizerMode.RAWTEXT);
}
function iframeStartTagInBody(p, token) {
  p.framesetOk = false;
  p._switchToTextParsing(token, TokenizerMode.RAWTEXT);
}
//NOTE: here we assume that we always act as a user agent with enabled plugins/frames, so we parse
//<noembed>/<noframes> as rawtext.
function rawTextStartTagInBody(p, token) {
  p._switchToTextParsing(token, TokenizerMode.RAWTEXT);
}
function selectStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
  p.framesetOk = false;
  p.insertionMode = p.insertionMode === InsertionMode.IN_TABLE || p.insertionMode === InsertionMode.IN_CAPTION || p.insertionMode === InsertionMode.IN_TABLE_BODY || p.insertionMode === InsertionMode.IN_ROW || p.insertionMode === InsertionMode.IN_CELL ? InsertionMode.IN_SELECT_IN_TABLE : InsertionMode.IN_SELECT;
}
function optgroupStartTagInBody(p, token) {
  if (p.openElements.currentTagId === TAG_ID.OPTION) {
    p.openElements.pop();
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
}
function rbStartTagInBody(p, token) {
  if (p.openElements.hasInScope(TAG_ID.RUBY)) {
    p.openElements.generateImpliedEndTags();
  }
  p._insertElement(token, NS.HTML);
}
function rtStartTagInBody(p, token) {
  if (p.openElements.hasInScope(TAG_ID.RUBY)) {
    p.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.RTC);
  }
  p._insertElement(token, NS.HTML);
}
function mathStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  adjustTokenMathMLAttrs(token);
  adjustTokenXMLAttrs(token);
  if (token.selfClosing) {
    p._appendElement(token, NS.MATHML);
  } else {
    p._insertElement(token, NS.MATHML);
  }
  token.ackSelfClosing = true;
}
function svgStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  adjustTokenSVGAttrs(token);
  adjustTokenXMLAttrs(token);
  if (token.selfClosing) {
    p._appendElement(token, NS.SVG);
  } else {
    p._insertElement(token, NS.SVG);
  }
  token.ackSelfClosing = true;
}
function genericStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
}
function startTagInBody(p, token) {
  switch (token.tagID) {
    case TAG_ID.I:
    case TAG_ID.S:
    case TAG_ID.B:
    case TAG_ID.U:
    case TAG_ID.EM:
    case TAG_ID.TT:
    case TAG_ID.BIG:
    case TAG_ID.CODE:
    case TAG_ID.FONT:
    case TAG_ID.SMALL:
    case TAG_ID.STRIKE:
    case TAG_ID.STRONG:
      {
        bStartTagInBody(p, token);
        break;
      }
    case TAG_ID.A:
      {
        aStartTagInBody(p, token);
        break;
      }
    case TAG_ID.H1:
    case TAG_ID.H2:
    case TAG_ID.H3:
    case TAG_ID.H4:
    case TAG_ID.H5:
    case TAG_ID.H6:
      {
        numberedHeaderStartTagInBody(p, token);
        break;
      }
    case TAG_ID.P:
    case TAG_ID.DL:
    case TAG_ID.OL:
    case TAG_ID.UL:
    case TAG_ID.DIV:
    case TAG_ID.DIR:
    case TAG_ID.NAV:
    case TAG_ID.MAIN:
    case TAG_ID.MENU:
    case TAG_ID.ASIDE:
    case TAG_ID.CENTER:
    case TAG_ID.FIGURE:
    case TAG_ID.FOOTER:
    case TAG_ID.HEADER:
    case TAG_ID.HGROUP:
    case TAG_ID.DIALOG:
    case TAG_ID.DETAILS:
    case TAG_ID.ADDRESS:
    case TAG_ID.ARTICLE:
    case TAG_ID.SEARCH:
    case TAG_ID.SECTION:
    case TAG_ID.SUMMARY:
    case TAG_ID.FIELDSET:
    case TAG_ID.BLOCKQUOTE:
    case TAG_ID.FIGCAPTION:
      {
        addressStartTagInBody(p, token);
        break;
      }
    case TAG_ID.LI:
    case TAG_ID.DD:
    case TAG_ID.DT:
      {
        listItemStartTagInBody(p, token);
        break;
      }
    case TAG_ID.BR:
    case TAG_ID.IMG:
    case TAG_ID.WBR:
    case TAG_ID.AREA:
    case TAG_ID.EMBED:
    case TAG_ID.KEYGEN:
      {
        areaStartTagInBody(p, token);
        break;
      }
    case TAG_ID.HR:
      {
        hrStartTagInBody(p, token);
        break;
      }
    case TAG_ID.RB:
    case TAG_ID.RTC:
      {
        rbStartTagInBody(p, token);
        break;
      }
    case TAG_ID.RT:
    case TAG_ID.RP:
      {
        rtStartTagInBody(p, token);
        break;
      }
    case TAG_ID.PRE:
    case TAG_ID.LISTING:
      {
        preStartTagInBody(p, token);
        break;
      }
    case TAG_ID.XMP:
      {
        xmpStartTagInBody(p, token);
        break;
      }
    case TAG_ID.SVG:
      {
        svgStartTagInBody(p, token);
        break;
      }
    case TAG_ID.HTML:
      {
        htmlStartTagInBody(p, token);
        break;
      }
    case TAG_ID.BASE:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.STYLE:
    case TAG_ID.TITLE:
    case TAG_ID.SCRIPT:
    case TAG_ID.BGSOUND:
    case TAG_ID.BASEFONT:
    case TAG_ID.TEMPLATE:
      {
        startTagInHead(p, token);
        break;
      }
    case TAG_ID.BODY:
      {
        bodyStartTagInBody(p, token);
        break;
      }
    case TAG_ID.FORM:
      {
        formStartTagInBody(p, token);
        break;
      }
    case TAG_ID.NOBR:
      {
        nobrStartTagInBody(p, token);
        break;
      }
    case TAG_ID.MATH:
      {
        mathStartTagInBody(p, token);
        break;
      }
    case TAG_ID.TABLE:
      {
        tableStartTagInBody(p, token);
        break;
      }
    case TAG_ID.INPUT:
      {
        inputStartTagInBody(p, token);
        break;
      }
    case TAG_ID.PARAM:
    case TAG_ID.TRACK:
    case TAG_ID.SOURCE:
      {
        paramStartTagInBody(p, token);
        break;
      }
    case TAG_ID.IMAGE:
      {
        imageStartTagInBody(p, token);
        break;
      }
    case TAG_ID.BUTTON:
      {
        buttonStartTagInBody(p, token);
        break;
      }
    case TAG_ID.APPLET:
    case TAG_ID.OBJECT:
    case TAG_ID.MARQUEE:
      {
        appletStartTagInBody(p, token);
        break;
      }
    case TAG_ID.IFRAME:
      {
        iframeStartTagInBody(p, token);
        break;
      }
    case TAG_ID.SELECT:
      {
        selectStartTagInBody(p, token);
        break;
      }
    case TAG_ID.OPTION:
    case TAG_ID.OPTGROUP:
      {
        optgroupStartTagInBody(p, token);
        break;
      }
    case TAG_ID.NOEMBED:
    case TAG_ID.NOFRAMES:
      {
        rawTextStartTagInBody(p, token);
        break;
      }
    case TAG_ID.FRAMESET:
      {
        framesetStartTagInBody(p, token);
        break;
      }
    case TAG_ID.TEXTAREA:
      {
        textareaStartTagInBody(p, token);
        break;
      }
    case TAG_ID.NOSCRIPT:
      {
        if (p.options.scriptingEnabled) {
          rawTextStartTagInBody(p, token);
        } else {
          genericStartTagInBody(p, token);
        }
        break;
      }
    case TAG_ID.PLAINTEXT:
      {
        plaintextStartTagInBody(p, token);
        break;
      }
    case TAG_ID.COL:
    case TAG_ID.TH:
    case TAG_ID.TD:
    case TAG_ID.TR:
    case TAG_ID.HEAD:
    case TAG_ID.FRAME:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
    case TAG_ID.CAPTION:
    case TAG_ID.COLGROUP:
      {
        // Ignore token
        break;
      }
    default:
      {
        genericStartTagInBody(p, token);
      }
  }
}
function bodyEndTagInBody(p, token) {
  if (p.openElements.hasInScope(TAG_ID.BODY)) {
    p.insertionMode = InsertionMode.AFTER_BODY;
    //NOTE: <body> is never popped from the stack, so we need to updated
    //the end location explicitly.
    if (p.options.sourceCodeLocationInfo) {
      var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
      if (bodyElement) {
        p._setEndLocation(bodyElement, token);
      }
    }
  }
}
function htmlEndTagInBody(p, token) {
  if (p.openElements.hasInScope(TAG_ID.BODY)) {
    p.insertionMode = InsertionMode.AFTER_BODY;
    endTagAfterBody(p, token);
  }
}
function addressEndTagInBody(p, token) {
  var tn = token.tagID;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped(tn);
  }
}
function formEndTagInBody(p) {
  var inTemplate = p.openElements.tmplCount > 0;
  var formElement = p.formElement;
  if (!inTemplate) {
    p.formElement = null;
  }
  if ((formElement || inTemplate) && p.openElements.hasInScope(TAG_ID.FORM)) {
    p.openElements.generateImpliedEndTags();
    if (inTemplate) {
      p.openElements.popUntilTagNamePopped(TAG_ID.FORM);
    } else if (formElement) {
      p.openElements.remove(formElement);
    }
  }
}
function pEndTagInBody(p) {
  if (!p.openElements.hasInButtonScope(TAG_ID.P)) {
    p._insertFakeElement(TAG_NAMES.P, TAG_ID.P);
  }
  p._closePElement();
}
function liEndTagInBody(p) {
  if (p.openElements.hasInListItemScope(TAG_ID.LI)) {
    p.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.LI);
    p.openElements.popUntilTagNamePopped(TAG_ID.LI);
  }
}
function ddEndTagInBody(p, token) {
  var tn = token.tagID;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTagsWithExclusion(tn);
    p.openElements.popUntilTagNamePopped(tn);
  }
}
function numberedHeaderEndTagInBody(p) {
  if (p.openElements.hasNumberedHeaderInScope()) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilNumberedHeaderPopped();
  }
}
function appletEndTagInBody(p, token) {
  var tn = token.tagID;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped(tn);
    p.activeFormattingElements.clearToLastMarker();
  }
}
function brEndTagInBody(p) {
  p._reconstructActiveFormattingElements();
  p._insertFakeElement(TAG_NAMES.BR, TAG_ID.BR);
  p.openElements.pop();
  p.framesetOk = false;
}
function genericEndTagInBody(p, token) {
  var tn = token.tagName;
  var tid = token.tagID;
  for (var i = p.openElements.stackTop; i > 0; i--) {
    var element = p.openElements.items[i];
    var elementId = p.openElements.tagIDs[i];
    // Compare the tag name here, as the tag might not be a known tag with an ID.
    if (tid === elementId && (tid !== TAG_ID.UNKNOWN || p.treeAdapter.getTagName(element) === tn)) {
      p.openElements.generateImpliedEndTagsWithExclusion(tid);
      if (p.openElements.stackTop >= i) p.openElements.shortenToLength(i);
      break;
    }
    if (p._isSpecialElement(element, elementId)) {
      break;
    }
  }
}
function endTagInBody(p, token) {
  switch (token.tagID) {
    case TAG_ID.A:
    case TAG_ID.B:
    case TAG_ID.I:
    case TAG_ID.S:
    case TAG_ID.U:
    case TAG_ID.EM:
    case TAG_ID.TT:
    case TAG_ID.BIG:
    case TAG_ID.CODE:
    case TAG_ID.FONT:
    case TAG_ID.NOBR:
    case TAG_ID.SMALL:
    case TAG_ID.STRIKE:
    case TAG_ID.STRONG:
      {
        callAdoptionAgency(p, token);
        break;
      }
    case TAG_ID.P:
      {
        pEndTagInBody(p);
        break;
      }
    case TAG_ID.DL:
    case TAG_ID.UL:
    case TAG_ID.OL:
    case TAG_ID.DIR:
    case TAG_ID.DIV:
    case TAG_ID.NAV:
    case TAG_ID.PRE:
    case TAG_ID.MAIN:
    case TAG_ID.MENU:
    case TAG_ID.ASIDE:
    case TAG_ID.BUTTON:
    case TAG_ID.CENTER:
    case TAG_ID.FIGURE:
    case TAG_ID.FOOTER:
    case TAG_ID.HEADER:
    case TAG_ID.HGROUP:
    case TAG_ID.DIALOG:
    case TAG_ID.ADDRESS:
    case TAG_ID.ARTICLE:
    case TAG_ID.DETAILS:
    case TAG_ID.SEARCH:
    case TAG_ID.SECTION:
    case TAG_ID.SUMMARY:
    case TAG_ID.LISTING:
    case TAG_ID.FIELDSET:
    case TAG_ID.BLOCKQUOTE:
    case TAG_ID.FIGCAPTION:
      {
        addressEndTagInBody(p, token);
        break;
      }
    case TAG_ID.LI:
      {
        liEndTagInBody(p);
        break;
      }
    case TAG_ID.DD:
    case TAG_ID.DT:
      {
        ddEndTagInBody(p, token);
        break;
      }
    case TAG_ID.H1:
    case TAG_ID.H2:
    case TAG_ID.H3:
    case TAG_ID.H4:
    case TAG_ID.H5:
    case TAG_ID.H6:
      {
        numberedHeaderEndTagInBody(p);
        break;
      }
    case TAG_ID.BR:
      {
        brEndTagInBody(p);
        break;
      }
    case TAG_ID.BODY:
      {
        bodyEndTagInBody(p, token);
        break;
      }
    case TAG_ID.HTML:
      {
        htmlEndTagInBody(p, token);
        break;
      }
    case TAG_ID.FORM:
      {
        formEndTagInBody(p);
        break;
      }
    case TAG_ID.APPLET:
    case TAG_ID.OBJECT:
    case TAG_ID.MARQUEE:
      {
        appletEndTagInBody(p, token);
        break;
      }
    case TAG_ID.TEMPLATE:
      {
        templateEndTagInHead(p, token);
        break;
      }
    default:
      {
        genericEndTagInBody(p, token);
      }
  }
}
function eofInBody(p, token) {
  if (p.tmplInsertionModeStack.length > 0) {
    eofInTemplate(p, token);
  } else {
    stopParsing(p, token);
  }
}
// The "text" insertion mode
//------------------------------------------------------------------
function endTagInText(p, token) {
  var _a;
  if (token.tagID === TAG_ID.SCRIPT) {
    (_a = p.scriptHandler) === null || _a === void 0 ? void 0 : _a.call(p, p.openElements.current);
  }
  p.openElements.pop();
  p.insertionMode = p.originalInsertionMode;
}
function eofInText(p, token) {
  p._err(token, ERR.eofInElementThatCanContainOnlyText);
  p.openElements.pop();
  p.insertionMode = p.originalInsertionMode;
  p.onEof(token);
}
// The "in table" insertion mode
//------------------------------------------------------------------
function characterInTable(p, token) {
  if (p.openElements.currentTagId !== undefined && TABLE_STRUCTURE_TAGS.has(p.openElements.currentTagId)) {
    p.pendingCharacterTokens.length = 0;
    p.hasNonWhitespacePendingCharacterToken = false;
    p.originalInsertionMode = p.insertionMode;
    p.insertionMode = InsertionMode.IN_TABLE_TEXT;
    switch (token.type) {
      case TokenType.CHARACTER:
        {
          characterInTableText(p, token);
          break;
        }
      case TokenType.WHITESPACE_CHARACTER:
        {
          whitespaceCharacterInTableText(p, token);
          break;
        }
      // Ignore null
    }
  } else {
    tokenInTable(p, token);
  }
}
function captionStartTagInTable(p, token) {
  p.openElements.clearBackToTableContext();
  p.activeFormattingElements.insertMarker();
  p._insertElement(token, NS.HTML);
  p.insertionMode = InsertionMode.IN_CAPTION;
}
function colgroupStartTagInTable(p, token) {
  p.openElements.clearBackToTableContext();
  p._insertElement(token, NS.HTML);
  p.insertionMode = InsertionMode.IN_COLUMN_GROUP;
}
function colStartTagInTable(p, token) {
  p.openElements.clearBackToTableContext();
  p._insertFakeElement(TAG_NAMES.COLGROUP, TAG_ID.COLGROUP);
  p.insertionMode = InsertionMode.IN_COLUMN_GROUP;
  startTagInColumnGroup(p, token);
}
function tbodyStartTagInTable(p, token) {
  p.openElements.clearBackToTableContext();
  p._insertElement(token, NS.HTML);
  p.insertionMode = InsertionMode.IN_TABLE_BODY;
}
function tdStartTagInTable(p, token) {
  p.openElements.clearBackToTableContext();
  p._insertFakeElement(TAG_NAMES.TBODY, TAG_ID.TBODY);
  p.insertionMode = InsertionMode.IN_TABLE_BODY;
  startTagInTableBody(p, token);
}
function tableStartTagInTable(p, token) {
  if (p.openElements.hasInTableScope(TAG_ID.TABLE)) {
    p.openElements.popUntilTagNamePopped(TAG_ID.TABLE);
    p._resetInsertionMode();
    p._processStartTag(token);
  }
}
function inputStartTagInTable(p, token) {
  if (isHiddenInput(token)) {
    p._appendElement(token, NS.HTML);
  } else {
    tokenInTable(p, token);
  }
  token.ackSelfClosing = true;
}
function formStartTagInTable(p, token) {
  if (!p.formElement && p.openElements.tmplCount === 0) {
    p._insertElement(token, NS.HTML);
    p.formElement = p.openElements.current;
    p.openElements.pop();
  }
}
function startTagInTable(p, token) {
  switch (token.tagID) {
    case TAG_ID.TD:
    case TAG_ID.TH:
    case TAG_ID.TR:
      {
        tdStartTagInTable(p, token);
        break;
      }
    case TAG_ID.STYLE:
    case TAG_ID.SCRIPT:
    case TAG_ID.TEMPLATE:
      {
        startTagInHead(p, token);
        break;
      }
    case TAG_ID.COL:
      {
        colStartTagInTable(p, token);
        break;
      }
    case TAG_ID.FORM:
      {
        formStartTagInTable(p, token);
        break;
      }
    case TAG_ID.TABLE:
      {
        tableStartTagInTable(p, token);
        break;
      }
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
      {
        tbodyStartTagInTable(p, token);
        break;
      }
    case TAG_ID.INPUT:
      {
        inputStartTagInTable(p, token);
        break;
      }
    case TAG_ID.CAPTION:
      {
        captionStartTagInTable(p, token);
        break;
      }
    case TAG_ID.COLGROUP:
      {
        colgroupStartTagInTable(p, token);
        break;
      }
    default:
      {
        tokenInTable(p, token);
      }
  }
}
function endTagInTable(p, token) {
  switch (token.tagID) {
    case TAG_ID.TABLE:
      {
        if (p.openElements.hasInTableScope(TAG_ID.TABLE)) {
          p.openElements.popUntilTagNamePopped(TAG_ID.TABLE);
          p._resetInsertionMode();
        }
        break;
      }
    case TAG_ID.TEMPLATE:
      {
        templateEndTagInHead(p, token);
        break;
      }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TBODY:
    case TAG_ID.TD:
    case TAG_ID.TFOOT:
    case TAG_ID.TH:
    case TAG_ID.THEAD:
    case TAG_ID.TR:
      {
        // Ignore token
        break;
      }
    default:
      {
        tokenInTable(p, token);
      }
  }
}
function tokenInTable(p, token) {
  var savedFosterParentingState = p.fosterParentingEnabled;
  p.fosterParentingEnabled = true;
  // Process token in `In Body` mode
  modeInBody(p, token);
  p.fosterParentingEnabled = savedFosterParentingState;
}
// The "in table text" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInTableText(p, token) {
  p.pendingCharacterTokens.push(token);
}
function characterInTableText(p, token) {
  p.pendingCharacterTokens.push(token);
  p.hasNonWhitespacePendingCharacterToken = true;
}
function tokenInTableText(p, token) {
  var i = 0;
  if (p.hasNonWhitespacePendingCharacterToken) {
    for (; i < p.pendingCharacterTokens.length; i++) {
      tokenInTable(p, p.pendingCharacterTokens[i]);
    }
  } else {
    for (; i < p.pendingCharacterTokens.length; i++) {
      p._insertCharacters(p.pendingCharacterTokens[i]);
    }
  }
  p.insertionMode = p.originalInsertionMode;
  p._processToken(token);
}
// The "in caption" insertion mode
//------------------------------------------------------------------
var TABLE_VOID_ELEMENTS = new Set([TAG_ID.CAPTION, TAG_ID.COL, TAG_ID.COLGROUP, TAG_ID.TBODY, TAG_ID.TD, TAG_ID.TFOOT, TAG_ID.TH, TAG_ID.THEAD, TAG_ID.TR]);
function startTagInCaption(p, token) {
  var tn = token.tagID;
  if (TABLE_VOID_ELEMENTS.has(tn)) {
    if (p.openElements.hasInTableScope(TAG_ID.CAPTION)) {
      p.openElements.generateImpliedEndTags();
      p.openElements.popUntilTagNamePopped(TAG_ID.CAPTION);
      p.activeFormattingElements.clearToLastMarker();
      p.insertionMode = InsertionMode.IN_TABLE;
      startTagInTable(p, token);
    }
  } else {
    startTagInBody(p, token);
  }
}
function endTagInCaption(p, token) {
  var tn = token.tagID;
  switch (tn) {
    case TAG_ID.CAPTION:
    case TAG_ID.TABLE:
      {
        if (p.openElements.hasInTableScope(TAG_ID.CAPTION)) {
          p.openElements.generateImpliedEndTags();
          p.openElements.popUntilTagNamePopped(TAG_ID.CAPTION);
          p.activeFormattingElements.clearToLastMarker();
          p.insertionMode = InsertionMode.IN_TABLE;
          if (tn === TAG_ID.TABLE) {
            endTagInTable(p, token);
          }
        }
        break;
      }
    case TAG_ID.BODY:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TBODY:
    case TAG_ID.TD:
    case TAG_ID.TFOOT:
    case TAG_ID.TH:
    case TAG_ID.THEAD:
    case TAG_ID.TR:
      {
        // Ignore token
        break;
      }
    default:
      {
        endTagInBody(p, token);
      }
  }
}
// The "in column group" insertion mode
//------------------------------------------------------------------
function startTagInColumnGroup(p, token) {
  switch (token.tagID) {
    case TAG_ID.HTML:
      {
        startTagInBody(p, token);
        break;
      }
    case TAG_ID.COL:
      {
        p._appendElement(token, NS.HTML);
        token.ackSelfClosing = true;
        break;
      }
    case TAG_ID.TEMPLATE:
      {
        startTagInHead(p, token);
        break;
      }
    default:
      {
        tokenInColumnGroup(p, token);
      }
  }
}
function endTagInColumnGroup(p, token) {
  switch (token.tagID) {
    case TAG_ID.COLGROUP:
      {
        if (p.openElements.currentTagId === TAG_ID.COLGROUP) {
          p.openElements.pop();
          p.insertionMode = InsertionMode.IN_TABLE;
        }
        break;
      }
    case TAG_ID.TEMPLATE:
      {
        templateEndTagInHead(p, token);
        break;
      }
    case TAG_ID.COL:
      {
        // Ignore token
        break;
      }
    default:
      {
        tokenInColumnGroup(p, token);
      }
  }
}
function tokenInColumnGroup(p, token) {
  if (p.openElements.currentTagId === TAG_ID.COLGROUP) {
    p.openElements.pop();
    p.insertionMode = InsertionMode.IN_TABLE;
    p._processToken(token);
  }
}
// The "in table body" insertion mode
//------------------------------------------------------------------
function startTagInTableBody(p, token) {
  switch (token.tagID) {
    case TAG_ID.TR:
      {
        p.openElements.clearBackToTableBodyContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = InsertionMode.IN_ROW;
        break;
      }
    case TAG_ID.TH:
    case TAG_ID.TD:
      {
        p.openElements.clearBackToTableBodyContext();
        p._insertFakeElement(TAG_NAMES.TR, TAG_ID.TR);
        p.insertionMode = InsertionMode.IN_ROW;
        startTagInRow(p, token);
        break;
      }
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
      {
        if (p.openElements.hasTableBodyContextInTableScope()) {
          p.openElements.clearBackToTableBodyContext();
          p.openElements.pop();
          p.insertionMode = InsertionMode.IN_TABLE;
          startTagInTable(p, token);
        }
        break;
      }
    default:
      {
        startTagInTable(p, token);
      }
  }
}
function endTagInTableBody(p, token) {
  var tn = token.tagID;
  switch (token.tagID) {
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
      {
        if (p.openElements.hasInTableScope(tn)) {
          p.openElements.clearBackToTableBodyContext();
          p.openElements.pop();
          p.insertionMode = InsertionMode.IN_TABLE;
        }
        break;
      }
    case TAG_ID.TABLE:
      {
        if (p.openElements.hasTableBodyContextInTableScope()) {
          p.openElements.clearBackToTableBodyContext();
          p.openElements.pop();
          p.insertionMode = InsertionMode.IN_TABLE;
          endTagInTable(p, token);
        }
        break;
      }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TD:
    case TAG_ID.TH:
    case TAG_ID.TR:
      {
        // Ignore token
        break;
      }
    default:
      {
        endTagInTable(p, token);
      }
  }
}
// The "in row" insertion mode
//------------------------------------------------------------------
function startTagInRow(p, token) {
  switch (token.tagID) {
    case TAG_ID.TH:
    case TAG_ID.TD:
      {
        p.openElements.clearBackToTableRowContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = InsertionMode.IN_CELL;
        p.activeFormattingElements.insertMarker();
        break;
      }
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
    case TAG_ID.TR:
      {
        if (p.openElements.hasInTableScope(TAG_ID.TR)) {
          p.openElements.clearBackToTableRowContext();
          p.openElements.pop();
          p.insertionMode = InsertionMode.IN_TABLE_BODY;
          startTagInTableBody(p, token);
        }
        break;
      }
    default:
      {
        startTagInTable(p, token);
      }
  }
}
function endTagInRow(p, token) {
  switch (token.tagID) {
    case TAG_ID.TR:
      {
        if (p.openElements.hasInTableScope(TAG_ID.TR)) {
          p.openElements.clearBackToTableRowContext();
          p.openElements.pop();
          p.insertionMode = InsertionMode.IN_TABLE_BODY;
        }
        break;
      }
    case TAG_ID.TABLE:
      {
        if (p.openElements.hasInTableScope(TAG_ID.TR)) {
          p.openElements.clearBackToTableRowContext();
          p.openElements.pop();
          p.insertionMode = InsertionMode.IN_TABLE_BODY;
          endTagInTableBody(p, token);
        }
        break;
      }
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
      {
        if (p.openElements.hasInTableScope(token.tagID) || p.openElements.hasInTableScope(TAG_ID.TR)) {
          p.openElements.clearBackToTableRowContext();
          p.openElements.pop();
          p.insertionMode = InsertionMode.IN_TABLE_BODY;
          endTagInTableBody(p, token);
        }
        break;
      }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TD:
    case TAG_ID.TH:
      {
        // Ignore end tag
        break;
      }
    default:
      {
        endTagInTable(p, token);
      }
  }
}
// The "in cell" insertion mode
//------------------------------------------------------------------
function startTagInCell(p, token) {
  var tn = token.tagID;
  if (TABLE_VOID_ELEMENTS.has(tn)) {
    if (p.openElements.hasInTableScope(TAG_ID.TD) || p.openElements.hasInTableScope(TAG_ID.TH)) {
      p._closeTableCell();
      startTagInRow(p, token);
    }
  } else {
    startTagInBody(p, token);
  }
}
function endTagInCell(p, token) {
  var tn = token.tagID;
  switch (tn) {
    case TAG_ID.TD:
    case TAG_ID.TH:
      {
        if (p.openElements.hasInTableScope(tn)) {
          p.openElements.generateImpliedEndTags();
          p.openElements.popUntilTagNamePopped(tn);
          p.activeFormattingElements.clearToLastMarker();
          p.insertionMode = InsertionMode.IN_ROW;
        }
        break;
      }
    case TAG_ID.TABLE:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
    case TAG_ID.TR:
      {
        if (p.openElements.hasInTableScope(tn)) {
          p._closeTableCell();
          endTagInRow(p, token);
        }
        break;
      }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
      {
        // Ignore token
        break;
      }
    default:
      {
        endTagInBody(p, token);
      }
  }
}
// The "in select" insertion mode
//------------------------------------------------------------------
function startTagInSelect(p, token) {
  switch (token.tagID) {
    case TAG_ID.HTML:
      {
        startTagInBody(p, token);
        break;
      }
    case TAG_ID.OPTION:
      {
        if (p.openElements.currentTagId === TAG_ID.OPTION) {
          p.openElements.pop();
        }
        p._insertElement(token, NS.HTML);
        break;
      }
    case TAG_ID.OPTGROUP:
      {
        if (p.openElements.currentTagId === TAG_ID.OPTION) {
          p.openElements.pop();
        }
        if (p.openElements.currentTagId === TAG_ID.OPTGROUP) {
          p.openElements.pop();
        }
        p._insertElement(token, NS.HTML);
        break;
      }
    case TAG_ID.HR:
      {
        if (p.openElements.currentTagId === TAG_ID.OPTION) {
          p.openElements.pop();
        }
        if (p.openElements.currentTagId === TAG_ID.OPTGROUP) {
          p.openElements.pop();
        }
        p._appendElement(token, NS.HTML);
        token.ackSelfClosing = true;
        break;
      }
    case TAG_ID.INPUT:
    case TAG_ID.KEYGEN:
    case TAG_ID.TEXTAREA:
    case TAG_ID.SELECT:
      {
        if (p.openElements.hasInSelectScope(TAG_ID.SELECT)) {
          p.openElements.popUntilTagNamePopped(TAG_ID.SELECT);
          p._resetInsertionMode();
          if (token.tagID !== TAG_ID.SELECT) {
            p._processStartTag(token);
          }
        }
        break;
      }
    case TAG_ID.SCRIPT:
    case TAG_ID.TEMPLATE:
      {
        startTagInHead(p, token);
        break;
      }
    // Do nothing
  }
}
function endTagInSelect(p, token) {
  switch (token.tagID) {
    case TAG_ID.OPTGROUP:
      {
        if (p.openElements.stackTop > 0 && p.openElements.currentTagId === TAG_ID.OPTION && p.openElements.tagIDs[p.openElements.stackTop - 1] === TAG_ID.OPTGROUP) {
          p.openElements.pop();
        }
        if (p.openElements.currentTagId === TAG_ID.OPTGROUP) {
          p.openElements.pop();
        }
        break;
      }
    case TAG_ID.OPTION:
      {
        if (p.openElements.currentTagId === TAG_ID.OPTION) {
          p.openElements.pop();
        }
        break;
      }
    case TAG_ID.SELECT:
      {
        if (p.openElements.hasInSelectScope(TAG_ID.SELECT)) {
          p.openElements.popUntilTagNamePopped(TAG_ID.SELECT);
          p._resetInsertionMode();
        }
        break;
      }
    case TAG_ID.TEMPLATE:
      {
        templateEndTagInHead(p, token);
        break;
      }
    // Do nothing
  }
}
// The "in select in table" insertion mode
//------------------------------------------------------------------
function startTagInSelectInTable(p, token) {
  var tn = token.tagID;
  if (tn === TAG_ID.CAPTION || tn === TAG_ID.TABLE || tn === TAG_ID.TBODY || tn === TAG_ID.TFOOT || tn === TAG_ID.THEAD || tn === TAG_ID.TR || tn === TAG_ID.TD || tn === TAG_ID.TH) {
    p.openElements.popUntilTagNamePopped(TAG_ID.SELECT);
    p._resetInsertionMode();
    p._processStartTag(token);
  } else {
    startTagInSelect(p, token);
  }
}
function endTagInSelectInTable(p, token) {
  var tn = token.tagID;
  if (tn === TAG_ID.CAPTION || tn === TAG_ID.TABLE || tn === TAG_ID.TBODY || tn === TAG_ID.TFOOT || tn === TAG_ID.THEAD || tn === TAG_ID.TR || tn === TAG_ID.TD || tn === TAG_ID.TH) {
    if (p.openElements.hasInTableScope(tn)) {
      p.openElements.popUntilTagNamePopped(TAG_ID.SELECT);
      p._resetInsertionMode();
      p.onEndTag(token);
    }
  } else {
    endTagInSelect(p, token);
  }
}
// The "in template" insertion mode
//------------------------------------------------------------------
function startTagInTemplate(p, token) {
  switch (token.tagID) {
    // First, handle tags that can start without a mode change
    case TAG_ID.BASE:
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.NOFRAMES:
    case TAG_ID.SCRIPT:
    case TAG_ID.STYLE:
    case TAG_ID.TEMPLATE:
    case TAG_ID.TITLE:
      {
        startTagInHead(p, token);
        break;
      }
    // Re-process the token in the appropriate mode
    case TAG_ID.CAPTION:
    case TAG_ID.COLGROUP:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
      {
        p.tmplInsertionModeStack[0] = InsertionMode.IN_TABLE;
        p.insertionMode = InsertionMode.IN_TABLE;
        startTagInTable(p, token);
        break;
      }
    case TAG_ID.COL:
      {
        p.tmplInsertionModeStack[0] = InsertionMode.IN_COLUMN_GROUP;
        p.insertionMode = InsertionMode.IN_COLUMN_GROUP;
        startTagInColumnGroup(p, token);
        break;
      }
    case TAG_ID.TR:
      {
        p.tmplInsertionModeStack[0] = InsertionMode.IN_TABLE_BODY;
        p.insertionMode = InsertionMode.IN_TABLE_BODY;
        startTagInTableBody(p, token);
        break;
      }
    case TAG_ID.TD:
    case TAG_ID.TH:
      {
        p.tmplInsertionModeStack[0] = InsertionMode.IN_ROW;
        p.insertionMode = InsertionMode.IN_ROW;
        startTagInRow(p, token);
        break;
      }
    default:
      {
        p.tmplInsertionModeStack[0] = InsertionMode.IN_BODY;
        p.insertionMode = InsertionMode.IN_BODY;
        startTagInBody(p, token);
      }
  }
}
function endTagInTemplate(p, token) {
  if (token.tagID === TAG_ID.TEMPLATE) {
    templateEndTagInHead(p, token);
  }
}
function eofInTemplate(p, token) {
  if (p.openElements.tmplCount > 0) {
    p.openElements.popUntilTagNamePopped(TAG_ID.TEMPLATE);
    p.activeFormattingElements.clearToLastMarker();
    p.tmplInsertionModeStack.shift();
    p._resetInsertionMode();
    p.onEof(token);
  } else {
    stopParsing(p, token);
  }
}
// The "after body" insertion mode
//------------------------------------------------------------------
function startTagAfterBody(p, token) {
  if (token.tagID === TAG_ID.HTML) {
    startTagInBody(p, token);
  } else {
    tokenAfterBody(p, token);
  }
}
function endTagAfterBody(p, token) {
  var _a;
  if (token.tagID === TAG_ID.HTML) {
    if (!p.fragmentContext) {
      p.insertionMode = InsertionMode.AFTER_AFTER_BODY;
    }
    //NOTE: <html> is never popped from the stack, so we need to updated
    //the end location explicitly.
    if (p.options.sourceCodeLocationInfo && p.openElements.tagIDs[0] === TAG_ID.HTML) {
      p._setEndLocation(p.openElements.items[0], token);
      // Update the body element, if it doesn't have an end tag
      var bodyElement = p.openElements.items[1];
      if (bodyElement && !((_a = p.treeAdapter.getNodeSourceCodeLocation(bodyElement)) === null || _a === void 0 ? void 0 : _a.endTag)) {
        p._setEndLocation(bodyElement, token);
      }
    }
  } else {
    tokenAfterBody(p, token);
  }
}
function tokenAfterBody(p, token) {
  p.insertionMode = InsertionMode.IN_BODY;
  modeInBody(p, token);
}
// The "in frameset" insertion mode
//------------------------------------------------------------------
function startTagInFrameset(p, token) {
  switch (token.tagID) {
    case TAG_ID.HTML:
      {
        startTagInBody(p, token);
        break;
      }
    case TAG_ID.FRAMESET:
      {
        p._insertElement(token, NS.HTML);
        break;
      }
    case TAG_ID.FRAME:
      {
        p._appendElement(token, NS.HTML);
        token.ackSelfClosing = true;
        break;
      }
    case TAG_ID.NOFRAMES:
      {
        startTagInHead(p, token);
        break;
      }
    // Do nothing
  }
}
function endTagInFrameset(p, token) {
  if (token.tagID === TAG_ID.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
    p.openElements.pop();
    if (!p.fragmentContext && p.openElements.currentTagId !== TAG_ID.FRAMESET) {
      p.insertionMode = InsertionMode.AFTER_FRAMESET;
    }
  }
}
// The "after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterFrameset(p, token) {
  switch (token.tagID) {
    case TAG_ID.HTML:
      {
        startTagInBody(p, token);
        break;
      }
    case TAG_ID.NOFRAMES:
      {
        startTagInHead(p, token);
        break;
      }
    // Do nothing
  }
}
function endTagAfterFrameset(p, token) {
  if (token.tagID === TAG_ID.HTML) {
    p.insertionMode = InsertionMode.AFTER_AFTER_FRAMESET;
  }
}
// The "after after body" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterBody(p, token) {
  if (token.tagID === TAG_ID.HTML) {
    startTagInBody(p, token);
  } else {
    tokenAfterAfterBody(p, token);
  }
}
function tokenAfterAfterBody(p, token) {
  p.insertionMode = InsertionMode.IN_BODY;
  modeInBody(p, token);
}
// The "after after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterFrameset(p, token) {
  switch (token.tagID) {
    case TAG_ID.HTML:
      {
        startTagInBody(p, token);
        break;
      }
    case TAG_ID.NOFRAMES:
      {
        startTagInHead(p, token);
        break;
      }
    // Do nothing
  }
}
// The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function nullCharacterInForeignContent(p, token) {
  token.chars = REPLACEMENT_CHARACTER;
  p._insertCharacters(token);
}
function characterInForeignContent(p, token) {
  p._insertCharacters(token);
  p.framesetOk = false;
}
function popUntilHtmlOrIntegrationPoint(p) {
  while (p.treeAdapter.getNamespaceURI(p.openElements.current) !== NS.HTML && p.openElements.currentTagId !== undefined && !p._isIntegrationPoint(p.openElements.currentTagId, p.openElements.current)) {
    p.openElements.pop();
  }
}
function startTagInForeignContent(p, token) {
  if (causesExit(token)) {
    popUntilHtmlOrIntegrationPoint(p);
    p._startTagOutsideForeignContent(token);
  } else {
    var current = p._getAdjustedCurrentElement();
    var currentNs = p.treeAdapter.getNamespaceURI(current);
    if (currentNs === NS.MATHML) {
      adjustTokenMathMLAttrs(token);
    } else if (currentNs === NS.SVG) {
      adjustTokenSVGTagName(token);
      adjustTokenSVGAttrs(token);
    }
    adjustTokenXMLAttrs(token);
    if (token.selfClosing) {
      p._appendElement(token, currentNs);
    } else {
      p._insertElement(token, currentNs);
    }
    token.ackSelfClosing = true;
  }
}
function endTagInForeignContent(p, token) {
  if (token.tagID === TAG_ID.P || token.tagID === TAG_ID.BR) {
    popUntilHtmlOrIntegrationPoint(p);
    p._endTagOutsideForeignContent(token);
    return;
  }
  for (var i = p.openElements.stackTop; i > 0; i--) {
    var element = p.openElements.items[i];
    if (p.treeAdapter.getNamespaceURI(element) === NS.HTML) {
      p._endTagOutsideForeignContent(token);
      break;
    }
    var tagName = p.treeAdapter.getTagName(element);
    if (tagName.toLowerCase() === token.tagName) {
      //NOTE: update the token tag name for `_setEndLocation`.
      token.tagName = tagName;
      p.openElements.shortenToLength(i);
      break;
    }
  }
}

// Sets
new Set([TAG_NAMES.AREA, TAG_NAMES.BASE, TAG_NAMES.BASEFONT, TAG_NAMES.BGSOUND, TAG_NAMES.BR, TAG_NAMES.COL, TAG_NAMES.EMBED, TAG_NAMES.FRAME, TAG_NAMES.HR, TAG_NAMES.IMG, TAG_NAMES.INPUT, TAG_NAMES.KEYGEN, TAG_NAMES.LINK, TAG_NAMES.META, TAG_NAMES.PARAM, TAG_NAMES.SOURCE, TAG_NAMES.TRACK, TAG_NAMES.WBR]);

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */

/**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
var pointEnd = point('end');

/**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
var pointStart = point('start');

/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */
function point(type) {
  return point;

  /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */
  function point(node) {
    var point = node && node.position && node.position[type] || {};
    if (typeof point.line === 'number' && point.line > 0 && typeof point.column === 'number' && point.column > 0) {
      return {
        line: point.line,
        column: point.column,
        offset: typeof point.offset === 'number' && point.offset > -1 ? point.offset : undefined
      };
    }
  }
}

var convert =
// Note: overloads in JSDoc can’t yet use different `@template`s.
/**
 * @type {(
 *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
 *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
 *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
 *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
 *   ((test?: Test) => Check)
 * )}
 */

/**
 * @param {Test} [test]
 * @returns {Check}
 */
function convert(test) {
  if (test === null || test === undefined) {
    return ok;
  }
  if (typeof test === 'function') {
    return castFactory(test);
  }
  if (_typeof$1(test) === 'object') {
    return Array.isArray(test) ? anyFactory(test) : propsFactory(test);
  }
  if (typeof test === 'string') {
    return typeFactory(test);
  }
  throw new Error('Expected function, string, or object as test');
};

/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */
function anyFactory(tests) {
  /** @type {Array<Check>} */
  var checks = [];
  var index = -1;
  while (++index < tests.length) {
    checks[index] = convert(tests[index]);
  }
  return castFactory(any);

  /**
   * @this {unknown}
   * @type {TestFunction}
   */
  function any() {
    var index = -1;
    for (var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++) {
      parameters[_key] = arguments[_key];
    }
    while (++index < checks.length) {
      if (checks[index].apply(this, parameters)) return true;
    }
    return false;
  }
}

/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */
function propsFactory(check) {
  var checkAsRecord = /** @type {Record<string, unknown>} */check;
  return castFactory(all);

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    var nodeAsRecord = /** @type {Record<string, unknown>} */
    /** @type {unknown} */node;

    /** @type {string} */
    var key;
    for (key in check) {
      if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
    }
    return true;
  }
}

/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */
function typeFactory(check) {
  return castFactory(type);

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check;
  }
}

/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */
function castFactory(testFunction) {
  return check;

  /**
   * @this {unknown}
   * @type {Check}
   */
  function check(value, index, parent) {
    return Boolean(looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
  }
}
function ok() {
  return true;
}

/**
 * @param {unknown} value
 * @returns {value is Node}
 */
function looksLikeANode(value) {
  return value !== null && _typeof$1(value) === 'object' && 'type' in value;
}

/**
 * @param {string} d
 * @returns {string}
 */
function color(d) {
  return d;
}

/** @type {Readonly<ActionTuple>} */
var empty = [];

/**
 * Continue traversing as normal.
 */
var CONTINUE = true;

/**
 * Stop traversing immediately.
 */
var EXIT = false;

/**
 * Do not traverse this node’s children.
 */
var SKIP = 'skip';

/**
 * Visit nodes, with ancestral information.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @overload
 * @param {Tree} tree
 * @param {Check} check
 * @param {BuildVisitor<Tree, Check>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @overload
 * @param {Tree} tree
 * @param {BuildVisitor<Tree>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @param {UnistNode} tree
 *   Tree to traverse.
 * @param {Visitor | Test} test
 *   `unist-util-is`-compatible test
 * @param {Visitor | boolean | null | undefined} [visitor]
 *   Handle each node.
 * @param {boolean | null | undefined} [reverse]
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns {undefined}
 *   Nothing.
 *
 * @template {UnistNode} Tree
 *   Node type.
 * @template {Test} Check
 *   `unist-util-is`-compatible test.
 */
function visitParents(tree, test, visitor, reverse) {
  /** @type {Test} */
  var check;
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor;
    // @ts-expect-error no visitor given, so `visitor` is test.
    visitor = test;
  } else {
    // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
  }
  var is = convert(check);
  var step = reverse ? -1 : 1;
  factory(tree, undefined, [])();

  /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */
  function factory(node, index, parents) {
    var value = /** @type {Record<string, unknown>} */
    node && _typeof$1(node) === 'object' ? node : {};
    if (typeof value.type === 'string') {
      var name =
      // `hast`
      typeof value.tagName === 'string' ? value.tagName :
      // `xast`
      typeof value.name === 'string' ? value.name : undefined;
      Object.defineProperty(visit, 'name', {
        value: 'node (' + color(node.type + (name ? '<' + name + '>' : '')) + ')'
      });
    }
    return visit;
    function visit() {
      /** @type {Readonly<ActionTuple>} */
      var result = empty;
      /** @type {Readonly<ActionTuple>} */
      var subresult;
      /** @type {number} */
      var offset;
      /** @type {Array<UnistParent>} */
      var grandparents;
      if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
        // @ts-expect-error: `visitor` is now a visitor.
        result = toResult(visitor(node, parents));
        if (result[0] === EXIT) {
          return result;
        }
      }
      if ('children' in node && node.children) {
        var nodeAsParent = /** @type {UnistParent} */node;
        if (nodeAsParent.children && result[0] !== SKIP) {
          offset = (reverse ? nodeAsParent.children.length : -1) + step;
          grandparents = parents.concat(nodeAsParent);
          while (offset > -1 && offset < nodeAsParent.children.length) {
            var child = nodeAsParent.children[offset];
            subresult = factory(child, offset, grandparents)();
            if (subresult[0] === EXIT) {
              return subresult;
            }
            offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
          }
        }
      }
      return result;
    }
  }
}

/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */
function toResult(value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'number') {
    return [CONTINUE, value];
  }
  return value === null || value === undefined ? empty : [value];
}

/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */


/**
 * Visit nodes.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @overload
 * @param {Tree} tree
 * @param {Check} check
 * @param {BuildVisitor<Tree, Check>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @overload
 * @param {Tree} tree
 * @param {BuildVisitor<Tree>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @param {UnistNode} tree
 *   Tree to traverse.
 * @param {Visitor | Test} testOrVisitor
 *   `unist-util-is`-compatible test (optional, omit to pass a visitor).
 * @param {Visitor | boolean | null | undefined} [visitorOrReverse]
 *   Handle each node (when test is omitted, pass `reverse`).
 * @param {boolean | null | undefined} [maybeReverse=false]
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns {undefined}
 *   Nothing.
 *
 * @template {UnistNode} Tree
 *   Node type.
 * @template {Test} Check
 *   `unist-util-is`-compatible test.
 */
function visit(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
  /** @type {boolean | null | undefined} */
  var reverse;
  /** @type {Test} */
  var test;
  /** @type {Visitor} */
  var visitor;
  if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
    test = undefined;
    visitor = testOrVisitor;
    reverse = visitorOrReverse;
  } else {
    // @ts-expect-error: assume the overload with test was given.
    test = testOrVisitor;
    // @ts-expect-error: assume the overload with test was given.
    visitor = visitorOrReverse;
    reverse = maybeReverse;
  }
  visitParents(tree, test, overload, reverse);

  /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */
  function overload(node, parents) {
    var parent = parents[parents.length - 1];
    var index = parent ? parent.children.indexOf(node) : undefined;
    return visitor(node, index, parent);
  }
}

var gfmTagfilterExpression = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi;

// Node types associated with MDX.
// <https://github.com/mdx-js/mdx/blob/8a56312/packages/mdx/lib/node-types.js>
var knownMdxNames = new Set(['mdxFlowExpression', 'mdxJsxFlowElement', 'mdxJsxTextElement', 'mdxTextExpression', 'mdxjsEsm']);

/** @type {ParserOptions<DefaultTreeAdapterMap>} */
var parseOptions = {
  sourceCodeLocationInfo: true,
  scriptingEnabled: false
};

/**
 * Pass a hast tree through an HTML parser, which will fix nesting, and turn
 * raw nodes into actual nodes.
 *
 * @param {Nodes} tree
 *   Original hast tree to transform.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {Nodes}
 *   Parsed again tree.
 */
function raw(tree, options) {
  var document = documentMode(tree);
  /** @type {(node: Nodes, state: State) => undefined} */
  var one = zwitch('type', {
    handlers: {
      root: root,
      element: element,
      text: text,
      comment: comment,
      doctype: doctype,
      raw: handleRaw
    },
    unknown: unknown
  });

  /** @type {State} */
  var state = {
    parser: document ? new Parser(parseOptions) : Parser.getFragmentParser(undefined, parseOptions),
    handle: function handle(node) {
      one(node, state);
    },
    stitches: false,
    options: options || {}
  };
  one(tree, state);
  resetTokenizer(state, pointStart());
  var p5 = document ? state.parser.document : state.parser.getFragment();
  var result = fromParse5(p5, {
    // To do: support `space`?
    file: state.options.file
  });
  if (state.stitches) {
    visit(result, 'comment', function (node, index, parent) {
      var stitch = /** @type {Stitch} */ /** @type {unknown} */node;
      if (stitch.value.stitch && parent && index !== undefined) {
        /** @type {Array<RootContent>} */
        var siblings = parent.children;
        // @ts-expect-error: assume the stitch is allowed.
        siblings[index] = stitch.value.stitch;
        return index;
      }
    });
  }

  // Unpack if possible and when not given a `root`.
  if (result.type === 'root' && result.children.length === 1 && result.children[0].type === tree.type) {
    return result.children[0];
  }
  return result;
}

/**
 * Transform all nodes
 *
 * @param {Array<RootContent>} nodes
 *   hast content.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function all(nodes, state) {
  var index = -1;

  /* istanbul ignore else - invalid nodes, see rehypejs/rehype-raw#7. */
  if (nodes) {
    while (++index < nodes.length) {
      state.handle(nodes[index]);
    }
  }
}

/**
 * Transform a root.
 *
 * @param {Root} node
 *   hast root node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function root(node, state) {
  all(node.children, state);
}

/**
 * Transform an element.
 *
 * @param {Element} node
 *   hast element node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function element(node, state) {
  startTag(node, state);
  all(node.children, state);
  endTag(node, state);
}

/**
 * Transform a text.
 *
 * @param {Text} node
 *   hast text node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function text(node, state) {
  // Allow `DATA` through `PLAINTEXT`,
  // but when hanging in a tag for example,
  // switch back to `DATA`.
  // Note: `State` is not exposed by `parse5`, so these numbers are fragile.
  // See: <https://github.com/inikulin/parse5/blob/46cba43/packages/parse5/lib/tokenizer/index.ts#L58>
  if (state.parser.tokenizer.state > 4) {
    state.parser.tokenizer.state = 0;
  }

  /** @type {Token.CharacterToken} */
  var token = {
    type: TokenType.CHARACTER,
    chars: node.value,
    location: createParse5Location(node)
  };
  resetTokenizer(state, pointStart(node));
  // @ts-expect-error: private.
  state.parser.currentToken = token;
  // @ts-expect-error: private.
  state.parser._processToken(state.parser.currentToken);
}

/**
 * Transform a doctype.
 *
 * @param {Doctype} node
 *   hast doctype node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function doctype(node, state) {
  /** @type {Token.DoctypeToken} */
  var token = {
    type: TokenType.DOCTYPE,
    name: 'html',
    forceQuirks: false,
    publicId: '',
    systemId: '',
    location: createParse5Location(node)
  };
  resetTokenizer(state, pointStart(node));
  // @ts-expect-error: private.
  state.parser.currentToken = token;
  // @ts-expect-error: private.
  state.parser._processToken(state.parser.currentToken);
}

/**
 * Transform a stitch.
 *
 * @param {Nodes} node
 *   unknown node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function stitch(node, state) {
  // Mark that there are stitches, so we need to walk the tree and revert them.
  state.stitches = true;

  /** @type {Nodes} */
  var clone = cloneWithoutChildren(node);

  // Recurse, because to somewhat handle `[<x>]</x>` (where `[]` denotes the
  // passed through node).
  if ('children' in node && 'children' in clone) {
    // Root in root out.
    var fakeRoot = /** @type {Root} */
    raw({
      type: 'root',
      children: node.children
    }, state.options);
    clone.children = fakeRoot.children;
  }

  // Hack: `value` is supposed to be a string, but as none of the tools
  // (`parse5` or `hast-util-from-parse5`) looks at it, we can pass nodes
  // through.
  comment({
    type: 'comment',
    value: {
      stitch: clone
    }
  }, state);
}

/**
 * Transform a comment (or stitch).
 *
 * @param {Comment | Stitch} node
 *   hast comment node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function comment(node, state) {
  /** @type {string} */
  // @ts-expect-error: we pass stitches through.
  var data = node.value;

  /** @type {Token.CommentToken} */
  var token = {
    type: TokenType.COMMENT,
    data: data,
    location: createParse5Location(node)
  };
  resetTokenizer(state, pointStart(node));
  // @ts-expect-error: private.
  state.parser.currentToken = token;
  // @ts-expect-error: private.
  state.parser._processToken(state.parser.currentToken);
}

/**
 * Transform a raw node.
 *
 * @param {Raw} node
 *   hast raw node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function handleRaw(node, state) {
  // Reset preprocessor:
  // See: <https://github.com/inikulin/parse5/blob/6f7ca60/packages/parse5/lib/tokenizer/preprocessor.ts#L18-L31>.
  state.parser.tokenizer.preprocessor.html = '';
  state.parser.tokenizer.preprocessor.pos = -1;
  // @ts-expect-error: private.
  // type-coverage:ignore-next-line
  state.parser.tokenizer.preprocessor.lastGapPos = -2;
  // @ts-expect-error: private.
  // type-coverage:ignore-next-line
  state.parser.tokenizer.preprocessor.gapStack = [];
  // @ts-expect-error: private.
  // type-coverage:ignore-next-line
  state.parser.tokenizer.preprocessor.skipNextNewLine = false;
  state.parser.tokenizer.preprocessor.lastChunkWritten = false;
  state.parser.tokenizer.preprocessor.endOfChunkHit = false;
  // @ts-expect-error: private.
  // type-coverage:ignore-next-line
  state.parser.tokenizer.preprocessor.isEol = false;

  // Now pass `node.value`.
  setPoint(state, pointStart(node));
  state.parser.tokenizer.write(state.options.tagfilter ? node.value.replace(gfmTagfilterExpression, '&lt;$1$2') : node.value, false);
  // @ts-expect-error: private.
  state.parser.tokenizer._runParsingLoop();

  // Character references hang, so if we ended there, we need to flush
  // those too.
  // We reset the preprocessor as if the document ends here.
  // Then one single call to the relevant state does the trick, parse5
  // consumes the whole token.

  // Note: `State` is not exposed by `parse5`, so these numbers are fragile.
  // See: <https://github.com/inikulin/parse5/blob/46cba43/packages/parse5/lib/tokenizer/index.ts#L58>
  // Note: a change to `parse5`, which breaks this, was merged but not released.
  // Investigate when it is.
  // To do: remove next major.
  /* c8 ignore next 12 -- removed in <https://github.com/inikulin/parse5/pull/897> */
  if (state.parser.tokenizer.state === 72 /* NAMED_CHARACTER_REFERENCE */ ||
  // @ts-expect-error: removed.
  state.parser.tokenizer.state === 78 /* NUMERIC_CHARACTER_REFERENCE_END */) {
    state.parser.tokenizer.preprocessor.lastChunkWritten = true;
    /** @type {number} */
    // @ts-expect-error: private.
    var cp = state.parser.tokenizer._consume();
    // @ts-expect-error: private.
    state.parser.tokenizer._callState(cp);
  }
}

/**
 * Crash on an unknown node.
 *
 * @param {unknown} node_
 *   unknown node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Never.
 */
function unknown(node_, state) {
  var node = /** @type {Nodes} */node_;
  if (state.options.passThrough && state.options.passThrough.includes(node.type)) {
    stitch(node, state);
  } else {
    var extra = '';
    if (knownMdxNames.has(node.type)) {
      extra = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax";
    }
    throw new Error('Cannot compile `' + node.type + '` node' + extra);
  }
}

/**
 * Reset the tokenizer of a parser.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Point | undefined} point
 *   Point.
 * @returns {undefined}
 *   Nothing.
 */
function resetTokenizer(state, point) {
  setPoint(state, point);

  // Process final characters if they’re still there after hibernating.
  /** @type {Token.CharacterToken} */
  // @ts-expect-error: private.
  var token = state.parser.tokenizer.currentCharacterToken;
  if (token && token.location) {
    token.location.endLine = state.parser.tokenizer.preprocessor.line;
    token.location.endCol = state.parser.tokenizer.preprocessor.col + 1;
    token.location.endOffset = state.parser.tokenizer.preprocessor.offset + 1;
    // @ts-expect-error: private.
    state.parser.currentToken = token;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
  }

  // Reset tokenizer:
  // See: <https://github.com/inikulin/parse5/blob/6f7ca60/packages/parse5/lib/tokenizer/index.ts#L187-L223>.
  // Especially putting it back in the `data` state is useful: some elements,
  // like textareas and iframes, change the state.
  // See GH-7.
  // But also if broken HTML is in `raw`, and then a correct element is given.
  // See GH-11.
  // @ts-expect-error: private.
  state.parser.tokenizer.paused = false;
  // @ts-expect-error: private.
  state.parser.tokenizer.inLoop = false;

  // Note: don’t reset `state`, `inForeignNode`, or `lastStartTagName`, we
  // manually update those when needed.
  state.parser.tokenizer.active = false;
  // @ts-expect-error: private.
  state.parser.tokenizer.returnState = TokenizerMode.DATA;
  // @ts-expect-error: private.
  state.parser.tokenizer.charRefCode = -1;
  // @ts-expect-error: private.
  state.parser.tokenizer.consumedAfterSnapshot = -1;
  // @ts-expect-error: private.
  state.parser.tokenizer.currentLocation = null;
  // @ts-expect-error: private.
  state.parser.tokenizer.currentCharacterToken = null;
  // @ts-expect-error: private.
  state.parser.tokenizer.currentToken = null;
  // @ts-expect-error: private.
  state.parser.tokenizer.currentAttr = {
    name: '',
    value: ''
  };
}

/**
 * Set current location.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Point | undefined} point
 *   Point.
 * @returns {undefined}
 *   Nothing.
 */
function setPoint(state, point) {
  if (point && point.offset !== undefined) {
    /** @type {Token.Location} */
    var location = {
      startLine: point.line,
      startCol: point.column,
      startOffset: point.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };

    // @ts-expect-error: private.
    // type-coverage:ignore-next-line
    state.parser.tokenizer.preprocessor.lineStartPos = -point.column + 1; // Looks weird, but ensures we get correct positional info.
    state.parser.tokenizer.preprocessor.droppedBufferSize = point.offset;
    state.parser.tokenizer.preprocessor.line = point.line;
    // @ts-expect-error: private.
    state.parser.tokenizer.currentLocation = location;
  }
}

/**
 * Emit a start tag.
 *
 * @param {Element} node
 *   Element.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function startTag(node, state) {
  var tagName = node.tagName.toLowerCase();

  // Ignore tags if we’re in plain text.
  if (state.parser.tokenizer.state === TokenizerMode.PLAINTEXT) return;
  resetTokenizer(state, pointStart(node));
  var current = state.parser.openElements.current;
  var ns = 'namespaceURI' in current ? current.namespaceURI : webNamespaces.html;
  if (ns === webNamespaces.html && tagName === 'svg') {
    ns = webNamespaces.svg;
  }
  var result = toParse5(// Shallow clone to not delve into `children`: we only need the attributes.
  _objectSpread2(_objectSpread2({}, node), {}, {
    children: []
  }), {
    space: ns === webNamespaces.svg ? 'svg' : 'html'
  });

  /** @type {Token.TagToken} */
  var tag = {
    type: TokenType.START_TAG,
    tagName: tagName,
    tagID: getTagID(tagName),
    // We always send start and end tags.
    selfClosing: false,
    ackSelfClosing: false,
    // Always element.
    /* c8 ignore next */
    attrs: 'attrs' in result ? result.attrs : [],
    location: createParse5Location(node)
  };

  // The HTML parsing algorithm works by doing half of the state management in
  // the tokenizer and half in the parser.
  // We can’t use the tokenizer here, as we don’t have strings.
  // So we act *as if* the tokenizer emits tokens:

  // @ts-expect-error: private.
  state.parser.currentToken = tag;
  // @ts-expect-error: private.
  state.parser._processToken(state.parser.currentToken);

  // …but then we still need a bunch of work that the tokenizer would normally
  // do, such as:

  // Set a tag name, similar to how the tokenizer would do it.
  state.parser.tokenizer.lastStartTagName = tagName;

  // `inForeignNode` is correctly set by the parser.
}

/**
 * Emit an end tag.
 *
 * @param {Element} node
 *   Element.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function endTag(node, state) {
  var tagName = node.tagName.toLowerCase();
  // Do not emit closing tags for HTML void elements.
  if (!state.parser.tokenizer.inForeignNode && htmlVoidElements.includes(tagName)) {
    return;
  }

  // Ignore tags if we’re in plain text.
  if (state.parser.tokenizer.state === TokenizerMode.PLAINTEXT) return;
  resetTokenizer(state, pointEnd(node));

  /** @type {Token.TagToken} */
  var tag = {
    type: TokenType.END_TAG,
    tagName: tagName,
    tagID: getTagID(tagName),
    selfClosing: false,
    ackSelfClosing: false,
    attrs: [],
    location: createParse5Location(node)
  };

  // The HTML parsing algorithm works by doing half of the state management in
  // the tokenizer and half in the parser.
  // We can’t use the tokenizer here, as we don’t have strings.
  // So we act *as if* the tokenizer emits tokens:

  // @ts-expect-error: private.
  state.parser.currentToken = tag;
  // @ts-expect-error: private.
  state.parser._processToken(state.parser.currentToken);

  // …but then we still need a bunch of work that the tokenizer would normally
  // do, such as:

  // Switch back to the data state after alternative states that don’t accept
  // tags:
  if (
  // Current element is closed.
  tagName === state.parser.tokenizer.lastStartTagName && (
  // `<textarea>` and `<title>`
  state.parser.tokenizer.state === TokenizerMode.RCDATA ||
  // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
  state.parser.tokenizer.state === TokenizerMode.RAWTEXT ||
  // `<script>`
  state.parser.tokenizer.state === TokenizerMode.SCRIPT_DATA)
  // Note: `<plaintext>` not needed, as it’s the last element.
  ) {
    state.parser.tokenizer.state = TokenizerMode.DATA;
  }
}

/**
 * Check if `node` represents a whole document or a fragment.
 *
 * @param {Nodes} node
 *   hast node.
 * @returns {boolean}
 *   Whether this represents a whole document or a fragment.
 */
function documentMode(node) {
  var head = node.type === 'root' ? node.children[0] : node;
  return Boolean(head && (head.type === 'doctype' || head.type === 'element' && head.tagName.toLowerCase() === 'html'));
}

/**
 * Get a `parse5` location from a node.
 *
 * @param {Nodes | Stitch} node
 *   hast node.
 * @returns {Token.Location}
 *   `parse5` location.
 */
function createParse5Location(node) {
  var start = pointStart(node) || {
    line: undefined,
    column: undefined,
    offset: undefined
  };
  var end = pointEnd(node) || {
    line: undefined,
    column: undefined,
    offset: undefined
  };

  /** @type {Record<keyof Token.Location, number | undefined>} */
  var location = {
    startLine: start.line,
    startCol: start.column,
    startOffset: start.offset,
    endLine: end.line,
    endCol: end.column,
    endOffset: end.offset
  };

  // @ts-expect-error: unist point values can be `undefined` in hast, which
  // `parse5` types don’t want.
  return location;
}

/**
 * @template {Nodes} NodeType
 *   Node type.
 * @param {NodeType} node
 *   Node to clone.
 * @returns {NodeType}
 *   Cloned node, without children.
 */
function cloneWithoutChildren(node) {
  return 'children' in node ? structuredClone$1(_objectSpread2(_objectSpread2({}, node), {}, {
    children: []
  })) : structuredClone$1(node);
}

/**
 * Parse the tree (and raw nodes) again, keeping positional info okay.
 *
 * @param {Options | null | undefined}  [options]
 *   Configuration (optional).
 * @returns
 *   Transform.
 */
function rehypeRaw(options) {
  /**
   * @param {Root} tree
   *   Tree.
   * @param {VFile} file
   *   File.
   * @returns {Root}
   *   New tree.
   */
  return function (tree, file) {
    // Assume root in -> root out.
    var result = /** @type {Root} */raw(tree, _objectSpread2(_objectSpread2({}, options), {}, {
      file: file
    }));
    return result;
  };
}

var _excluded$v = ["children", "componentStyles"],
  _excluded2$3 = ["children"],
  _excluded3$2 = ["children"],
  _excluded4$1 = ["children"],
  _excluded5$1 = ["children"],
  _excluded6$1 = ["children"],
  _excluded7$1 = ["children"],
  _excluded8$1 = ["children"],
  _excluded9$1 = ["children"],
  _excluded0$1 = ["children"];
var defaultComponentStyles = {
  p: {
    variant: "content"
  },
  h1: {
    variant: "content"
  },
  h2: {
    variant: "content"
  },
  h3: {
    variant: "content"
  },
  img: {
    variant: "content"
  },
  table: {
    variant: "content"
  },
  details: {
    variant: "content"
  },
  li: {
    variant: "content"
  },
  a: {
    variant: "content"
  }
};
var Markdown = function Markdown(_ref) {
  var children = _ref.children,
    componentStyles = _ref.componentStyles,
    rest = _objectWithoutProperties$1(_ref, _excluded$v);
  var mergedComponentStyles = {
    p: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultComponentStyles.p), componentStyles.generic), componentStyles.p),
    h1: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultComponentStyles.h1), componentStyles.generic), componentStyles.h1),
    h2: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultComponentStyles.h2), componentStyles.generic), componentStyles.h2),
    h3: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultComponentStyles.h3), componentStyles.generic), componentStyles.h3),
    img: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultComponentStyles.img), componentStyles.generic), componentStyles.img),
    table: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultComponentStyles.table), componentStyles.generic), componentStyles.table),
    details: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultComponentStyles.details), componentStyles.generic), componentStyles.details),
    li: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultComponentStyles.li), componentStyles.generic), componentStyles.li),
    a: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultComponentStyles.a), componentStyles.generic), componentStyles.a)
  };
  var components = {
    p: function p(_ref2) {
      var children = _ref2.children,
        other = _objectWithoutProperties$1(_ref2, _excluded2$3);
      return /*#__PURE__*/React__default.createElement(P$4, _extends({}, other, mergedComponentStyles.p), children);
    },
    pre: function pre(_ref3) {
      var children = _ref3.children,
        other = _objectWithoutProperties$1(_ref3, _excluded3$2);
      return /*#__PURE__*/React__default.createElement(P$4, _extends({}, other, mergedComponentStyles.p), children);
    },
    h1: function h1(_ref4) {
      var children = _ref4.children,
        other = _objectWithoutProperties$1(_ref4, _excluded4$1);
      return /*#__PURE__*/React__default.createElement(H1$1, _extends({}, other, mergedComponentStyles.h1), children);
    },
    h2: function h2(_ref5) {
      var children = _ref5.children,
        other = _objectWithoutProperties$1(_ref5, _excluded5$1);
      return /*#__PURE__*/React__default.createElement(H2$1, _extends({}, other, mergedComponentStyles.h2), children);
    },
    h3: function h3(_ref6) {
      var children = _ref6.children,
        other = _objectWithoutProperties$1(_ref6, _excluded6$1);
      return /*#__PURE__*/React__default.createElement(H3, _extends({}, other, mergedComponentStyles.h3), children);
    },
    img: function img(_ref7) {
      var other = _extends({}, (_objectDestructuringEmpty(_ref7), _ref7));
      return /*#__PURE__*/React__default.createElement(Img$8, _extends({}, other, mergedComponentStyles.img));
    },
    table: function table(_ref8) {
      var children = _ref8.children,
        other = _objectWithoutProperties$1(_ref8, _excluded7$1);
      return /*#__PURE__*/React__default.createElement(Table$2, _extends({}, other, mergedComponentStyles.table), children);
    },
    details: function details(_ref9) {
      var children = _ref9.children,
        other = _objectWithoutProperties$1(_ref9, _excluded8$1);
      return /*#__PURE__*/React__default.createElement(Details, _extends({}, other, mergedComponentStyles.details), children);
    },
    li: function li(_ref0) {
      var children = _ref0.children,
        other = _objectWithoutProperties$1(_ref0, _excluded9$1);
      return /*#__PURE__*/React__default.createElement(Li$2, _extends({}, other, mergedComponentStyles.li), children);
    },
    a: function a(_ref1) {
      var children = _ref1.children,
        other = _objectWithoutProperties$1(_ref1, _excluded0$1);
      return other.className === "cta" ? /*#__PURE__*/React__default.createElement(ButtonA, _extends({
        variant: "primary"
      }, other), children) : /*#__PURE__*/React__default.createElement(A$5, _extends({}, other, mergedComponentStyles.a), children);
    }
  };
  return /*#__PURE__*/React__default.createElement(Container$B, rest, /*#__PURE__*/React__default.createElement(ReactMarkdown, {
    remarkPlugins: [gfm],
    rehypePlugins: [rehypeRaw],
    linkTarget: "_blank",
    components: components,
    children: children
  }));
};
Markdown.propTypes = {
  children: PropTypes.node,
  componentStyles: PropTypes.object
};
Markdown.defaultProps = {
  componentStyles: {}
};

var _excluded$u = ["items", "inlineOnMobile", "contentsAreComponents"];
var AccordionContent = function AccordionContent(_ref) {
  var items = _ref.items,
    inlineOnMobile = _ref.inlineOnMobile,
    contentsAreComponents = _ref.contentsAreComponents,
    rest = _objectWithoutProperties$1(_ref, _excluded$u);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    showItems = _useState2[0],
    setShowItems = _useState2[1];
  var toggleItem = function toggleItem(index) {
    if (showItems.includes(index)) {
      setShowItems(showItems.filter(function (item) {
        return item !== index;
      }));
    } else {
      setShowItems([].concat(_toConsumableArray(showItems), [index]));
    }
  };
  useEffect(function () {
    items.map(function (item, index) {
      if (!!item.defaultOpen) {
        setShowItems([].concat(_toConsumableArray(showItems), [index]));
      }
    });
  }, [items, setShowItems]);
  var accordionKey = Math.random().toString(36).substring(7);
  return /*#__PURE__*/React__default.createElement(Container$C, _extends({
    inlineOnMobile: inlineOnMobile,
    className: "ho-accordion"
  }, rest), items.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(AccordionItem, {
      key: "accordion_".concat(accordionKey, "_").concat(index),
      inlineOnMobile: inlineOnMobile
    }, /*#__PURE__*/React__default.createElement(AccordionHeadingOuter, {
      onClick: function onClick() {
        return toggleItem(index);
      }
    }, /*#__PURE__*/React__default.createElement(H2$1, {
      marginless: true
    }, /*#__PURE__*/React__default.createElement(AccordionHeading, null, item.heading)), /*#__PURE__*/React__default.createElement(AccordionToggle, {
      rotated: showItems.includes(index)
    }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faChevronDown$1
    }))), /*#__PURE__*/React__default.createElement(AccordionPanel, {
      show: showItems.includes(index)
    }, !contentsAreComponents && item.content && /*#__PURE__*/React__default.createElement(Markdown, null, item.content), contentsAreComponents && item.content));
  }));
};
AccordionContent.propTypes = {
  items: PropTypes.array.isRequired,
  inlineOnMobile: PropTypes.bool,
  contentsAreComponents: PropTypes["boolean"]
};
AccordionContent.defaultProps = {
  inlineOnMobile: false,
  contentsAreComponents: false
};

var _templateObject$1F, _templateObject2$1p;
var Container$A = styled.div(_templateObject$1F || (_templateObject$1F = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  flex-direction: column;\n  margin-bottom: 1rem;\n  box-sizing: border-box;\n\n  > * {\n    margin-bottom: 1rem;\n  }\n\n  ", "\n"])), function (_ref) {
  var justify = _ref.justify;
  return justify;
}, breakpoint("tablet")(_templateObject2$1p || (_templateObject2$1p = _taggedTemplateLiteral(["\n    flex-direction: row;\n\n    & > :not(:last-child) {\n      margin-right: 1rem;\n    }\n\n    > * {\n      margin-bottom: 0;\n    }\n  "]))));

var _excluded$t = ["children", "justify"];
var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
    justify = _ref.justify,
    rest = _objectWithoutProperties$1(_ref, _excluded$t);
  return /*#__PURE__*/React__default.createElement(Container$A, _extends({
    justify: justify
  }, rest), children);
};
ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  justify: PropTypes.string
};
ButtonGroup.defaultProps = {
  justify: "space-between"
};

var _templateObject$1E, _templateObject2$1o, _templateObject3$18, _templateObject4$Y, _templateObject5$I, _templateObject6$D, _templateObject7$A, _templateObject8$u, _templateObject9$s, _templateObject0$q, _templateObject1$n, _templateObject10$m, _templateObject11$l, _templateObject12$j, _templateObject13$h, _templateObject14$g, _templateObject15$g, _templateObject16$e;
var Container$z = styled.div(_templateObject$1E || (_templateObject$1E = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  > * {\n    display: flex;\n    align-items: center;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var invalid = _ref.invalid,
    theme = _ref.theme;
  return !!invalid && css(_templateObject2$1o || (_templateObject2$1o = _taggedTemplateLiteral(["\n      border-radius: 1rem;\n      padding: 1rem 1.25rem;\n      border: 2px solid ", ";\n      background-color: ", ";\n    "])), theme.colors.danger, mix(0.8, "#fff", theme.colors.danger));
}, function (_ref2) {
  var invalid = _ref2.invalid,
    simpleForm = _ref2.simpleForm,
    theme = _ref2.theme;
  return !!invalid && !simpleForm && css(_templateObject3$18 || (_templateObject3$18 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), mix(0.95, "#fff", theme.colors.danger));
}, function (_ref3) {
  var stacked = _ref3.stacked;
  return !stacked && css(_templateObject4$Y || (_templateObject4$Y = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject5$I || (_templateObject5$I = _taggedTemplateLiteral(["\n      flex-direction: row;\n\n      & > :not(:last-child) {\n        margin-right: 1.5rem;\n      }\n    "]))));
}, function (_ref4) {
  var stacked = _ref4.stacked;
  return !!stacked && css(_templateObject6$D || (_templateObject6$D = _taggedTemplateLiteral(["\n      & > :not(:last-child) {\n        margin-bottom: 0.5rem;\n      }\n    "])));
});
var Label$2 = styled.label(_templateObject7$A || (_templateObject7$A = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ", sans-serif;\n  font-weight: bold;\n  cursor: pointer;\n  margin: 0;\n  line-height: 1.5;\n  display: inline-block;\n\n  ", "\n\n  ", "\n\n    ", "\n\n  ", "\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.body;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fonts.body.family;
}, function (_ref7) {
  var invalid = _ref7.invalid,
    simpleForm = _ref7.simpleForm,
    theme = _ref7.theme;
  return !!invalid && !simpleForm && css(_templateObject8$u || (_templateObject8$u = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger));
}, function (_ref8) {
  var simpleForm = _ref8.simpleForm,
    theme = _ref8.theme;
  return !!simpleForm && css(_templateObject9$s || (_templateObject9$s = _taggedTemplateLiteral(["\n      color: ", ";\n      margin-left: 14px;\n      font-size: 16px;\n      font-weight: 400;\n      position: relative;\n      top: -2px;\n    "])), theme.colors.fields.text);
}, function (_ref9) {
  var large = _ref9.large;
  return !!large && css(_templateObject0$q || (_templateObject0$q = _taggedTemplateLiteral(["\n      font-weight: normal;\n      font-size: 1.1rem;\n    "])));
}, function (_ref0) {
  var bold = _ref0.bold;
  return !!bold && css(_templateObject1$n || (_templateObject1$n = _taggedTemplateLiteral(["\n      font-weight: bold;\n    "])));
});
var CheckboxContainer = styled.label(_templateObject10$m || (_templateObject10$m = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref1) {
  var simpleForm = _ref1.simpleForm;
  return !!simpleForm && css(_templateObject11$l || (_templateObject11$l = _taggedTemplateLiteral(["\n      display: block;\n      position: relative;\n      padding-left: 24px;\n      cursor: pointer;\n      font-size: 22px;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n\n      & > input {\n        position: absolute;\n        cursor: pointer;\n        opacity: 0;\n        height: 0;\n        width: 0;\n      }\n\n      &:hover input + span {\n        border-color: ", ";\n      }\n\n      & > input:checked + span {\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      & > input:checked + span:after {\n        display: block;\n      }\n\n      & > span:after {\n        left: 8px;\n        top: 4px;\n        width: 5px;\n        height: 10px;\n        border: solid white;\n        border-width: 0 3px 3px 0;\n        -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n        transform: rotate(45deg);\n      }\n\n      ", "\n    "])), function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.primary;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.colors.primary;
  }, function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.primary;
  }, function (_ref13) {
    var marginless = _ref13.marginless;
    return !marginless && css(_templateObject12$j || (_templateObject12$j = _taggedTemplateLiteral(["\n          margin-bottom: 12px;\n        "])));
  });
});
var Checkbox$1 = styled.input(_templateObject13$h || (_templateObject13$h = _taggedTemplateLiteral(["\n  cursor: pointer;\n  margin: 0;\n  margin-right: 0.5rem;\n\n  ", "\n"])), function (_ref14) {
  var large = _ref14.large;
  return !!large && css(_templateObject14$g || (_templateObject14$g = _taggedTemplateLiteral(["\n      min-width: 24px;\n      min-height: 24px;\n      margin-right: 1rem;\n    "])));
});
var Checkmark$1 = styled.span(_templateObject15$g || (_templateObject15$g = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 24px;\n  width: 24px;\n  background-color: transparent;\n  border: 1px solid ", ";\n  border-radius: 4px;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n  }\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.fields.border;
});
var Hint$1 = styled.p(_templateObject16$e || (_templateObject16$e = _taggedTemplateLiteral(["\n  font-size: 0.8rem;\n  margin-left: 14px;\n  color: ", ";\n  margin-top: 0;\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.midLightGrey;
});

var Checkboxes = /*#__PURE__*/function (_Component) {
  function Checkboxes(props) {
    var _this;
    _classCallCheck$1(this, Checkboxes);
    _this = _callSuper(this, Checkboxes, [props]);
    _defineProperty$1(_this, "onChange", function (event) {
      var _event$target = event.target,
        name = _event$target.name,
        checked = _event$target.checked;
      var handleInputChange = _this.props.handleInputChange;
      _this.setState(function (prevState) {
        var filters = _objectSpread2(_objectSpread2({}, prevState.filters), {}, _defineProperty$1({}, name, checked));
        var activeFilterNames = Object.keys(filters).filter(function (filterName) {
          return filters[filterName];
        });
        if (handleInputChange !== undefined) handleInputChange(_this.props.name, activeFilterNames);
        var filteredItems = prevState.items.filter(function (item) {
          return activeFilterNames.some(function (activeFilterName) {
            return activeFilterName === item.name;
          });
        });
        return {
          filters: filters,
          filteredItems: filteredItems
        };
      });
    });
    var values = Array.isArray(props.value) ? props.value : props.value.toString().split(",");
    var _filters = {};
    props.options.forEach(function (option) {
      _filters[option[0]] = values.includes(option[0]);
    });
    _this.state = {
      items: props.options,
      filters: _filters,
      filteredItems: []
    };
    return _this;
  }
  _inherits$1(Checkboxes, _Component);
  return _createClass$1(Checkboxes, [{
    key: "renderCheckboxes",
    value: function renderCheckboxes() {
      var _this$state = this.state,
        filters = _this$state.filters,
        items = _this$state.items;
      var onChange = this.onChange;
      var _this$props = this.props,
        multiple = _this$props.multiple,
        invalid = _this$props.invalid,
        simpleForm = _this$props.simpleForm,
        marginless = _this$props.marginless,
        large = _this$props.large,
        boldLabel = _this$props.boldLabel,
        hints = _this$props.hints;
      var toRender = items.sort(function (a, b) {
        if (a[1] < b[1]) return -1;
        if (a[1] > b[1]) return 1;
        return 0;
      }).map(function (item, index) {
        return /*#__PURE__*/React__default.createElement(CheckboxContainer, {
          simpleForm: simpleForm,
          marginless: marginless,
          key: "".concat(item[0], "_").concat(index)
        }, /*#__PURE__*/React__default.createElement(Checkbox$1, {
          type: "checkbox",
          id: "".concat(item[0], "_").concat(index),
          name: item[0],
          onChange: onChange,
          value: item[0],
          checked: filters[item[0]],
          multiple: multiple,
          large: large
        }), simpleForm && /*#__PURE__*/React__default.createElement(Checkmark$1, null), /*#__PURE__*/React__default.createElement(Label$2, {
          invalid: invalid,
          large: large,
          htmlFor: "".concat(item[0], "_").concat(index),
          simpleForm: simpleForm,
          bold: !!boldLabel
        }, item[1]), hints && hints[index] && /*#__PURE__*/React__default.createElement(Hint$1, null, hints[index]));
      });
      return toRender;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        stacked = _this$props2.stacked,
        simpleForm = _this$props2.simpleForm;
      return /*#__PURE__*/React__default.createElement(Container$z, {
        stacked: stacked,
        simpleForm: simpleForm
      }, this.renderCheckboxes());
    }
  }]);
}(Component$1);
Checkboxes.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  required: PropTypes.bool,
  stacked: PropTypes.bool,
  multiple: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  handleInputChange: PropTypes.func.isRequired,
  simpleForm: PropTypes.bool,
  large: PropTypes.bool
};
Checkboxes.defaultProps = {
  options: [],
  required: false,
  stacked: true,
  multiple: true,
  value: [],
  handleInputChange: undefined,
  simpleForm: false,
  large: false
};

var _templateObject$1D, _templateObject2$1n, _templateObject3$17, _templateObject4$X, _templateObject5$H;
var fieldStyles = css(_templateObject$1D || (_templateObject$1D = _taggedTemplateLiteral(["\n  border: 2px solid white;\n  border-radius: 0.5rem;\n  padding: 0.75rem 1.25rem;\n  font-size: 1rem;\n  width: 100%;\n  box-sizing: border-box;\n  display: block;\n  appearance: none;\n  background-image: none;\n  background-color: ", ";\n  box-shadow: none;\n  outline: none;\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n\n  &::-webkit-datetime-edit {\n    line-height: 1;\n    padding: 0;\n    margin-bottom: -2px;\n  }\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.body.family;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.body.weight;
}, function (_ref4) {
  var invalid = _ref4.invalid,
    theme = _ref4.theme;
  return !!invalid && css(_templateObject2$1n || (_templateObject2$1n = _taggedTemplateLiteral(["\n      border-color: ", ";\n      background-color: ", ";\n      color: ", ";\n    "])), darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger), mix(0.8, "#fff", theme.colors.danger), darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger));
}, function (_ref5) {
  var simpleForm = _ref5.simpleForm;
  return !!simpleForm && css(_templateObject3$17 || (_templateObject3$17 = _taggedTemplateLiteral(["\n      background-color: #fff;\n      border: 1px solid #e6e6e6;\n      border-radius: 8px;\n      height: 3rem;\n      padding: 0 1rem;\n\n      ", "\n\n      ", "\n\n      &:disabled, &[disabled] {\n        background-color: #f2f2f2;\n        border-color: #e6e6e6;\n        color: #999999;\n      }\n\n      &:focus {\n        border-color: ", ";\n      }\n\n      &[readonly] {\n        background-color: rgba(221, 221, 221, 1);\n        border-color: rgba(221, 221, 221, 1);\n        color: #000;\n      }\n    "])), function (props) {
    return props.showValidation && css(_templateObject4$X || (_templateObject4$X = _taggedTemplateLiteral(["\n          &:focus {\n            border-color: ", ";\n          }\n        "])), function (_ref6) {
      var theme = _ref6.theme;
      return theme.colors.brand;
    });
  }, function (_ref7) {
    var invalid = _ref7.invalid,
      theme = _ref7.theme;
    return !!invalid && css(_templateObject5$H || (_templateObject5$H = _taggedTemplateLiteral(["\n          border-color: ", ";\n          background-color: ", ";\n        "])), theme.colors.danger, mix(0.95, "#fff", theme.colors.danger));
  }, function (props) {
    return props.theme.colors.primary;
  });
});

var _templateObject$1C;
var StyledField$8 = styled(DatePicker)(_templateObject$1C || (_templateObject$1C = _taggedTemplateLiteral(["\n  ", "\n"])), fieldStyles);

var _excluded$s = ["handleInputChange"];
var DateField = function DateField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    rest = _objectWithoutProperties$1(_ref, _excluded$s);
  var name = rest.name,
    value = rest.value,
    min = rest.min,
    max = rest.max,
    placeholder = rest.placeholder;
  var _onChange = function onChange(value) {
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  var selected = value ? new Date(value) : "";
  var minDate = min ? new Date(min) : "";
  var maxDate = max ? new Date(max) : "";
  return /*#__PURE__*/React__default.createElement(StyledField$8, _extends({
    onChange: function onChange(date) {
      return _onChange(date);
    },
    selected: selected,
    dateFormat: "dd MMMM yyyy",
    minDate: minDate,
    maxDate: maxDate,
    showYearDropdown: true,
    scrollableYearDropdown: true,
    showMonthDropdown: true,
    useShortMonthInDropdown: true,
    withPortal: true,
    placeholder: placeholder
  }, rest));
};
DateField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  invalid: PropTypes.bool
};
DateField.defaultProps = {
  handleInputChange: undefined,
  placeholder: "",
  invalid: false
};

var _templateObject$1B, _templateObject2$1m, _templateObject3$16;
var StyledDateField$1 = styled.input(_templateObject$1B || (_templateObject$1B = _taggedTemplateLiteral(["\n  ", "\n  padding: calc(0.75rem - 1px) 1.25rem;\n\n  @supports (-webkit-touch-callout: none) {\n    min-height: 3rem;\n  }\n\n  ", "\n\n  ", "\n"])), fieldStyles, function (props) {
  return (props === null || props === void 0 ? void 0 : props.homepage) && css(_templateObject2$1m || (_templateObject2$1m = _taggedTemplateLiteral(["\n      padding: 12px 16px 10px 16px;\n    "])));
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.simpleForm) && css(_templateObject3$16 || (_templateObject3$16 = _taggedTemplateLiteral(["\n      padding: 12px 16px 10px 16px;\n    "])));
});

var _excluded$r = ["handleInputChange"];
var DefaultDateField = function DefaultDateField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    rest = _objectWithoutProperties$1(_ref, _excluded$r);
  var name = rest.name,
    value = rest.value,
    min = rest.min,
    max = rest.max,
    placeholder = rest.placeholder,
    homepage = rest.homepage,
    simpleForm = rest.simpleForm;
  var onChange = function onChange(value) {
    if (handleInputChange !== undefined) {
      var date = new Date(value);
      handleInputChange(name, date);
    }
  };
  var selected = value ? moment(value).format("YYYY-MM-DD") : "";
  var minDate = min ? moment(min).format("YYYY-MM-DD") : "";
  var maxDate = max ? moment(max).format("YYYY-MM-DD") : "";
  var isDateSupported = function isDateSupported() {
    var i = document.createElement("input");
    i.setAttribute("type", "date");
    return i.type !== "text";
  };
  return isDateSupported() ? /*#__PURE__*/React__default.createElement(StyledDateField$1, {
    type: "date",
    defaultValue: selected,
    placeholder: placeholder,
    min: minDate,
    max: maxDate,
    onInput: function onInput(date) {
      return onChange(date.target.value);
    },
    homepage: homepage,
    simpleForm: simpleForm
  }) : /*#__PURE__*/React__default.createElement(DateField, _extends({
    handleInputChange: handleInputChange
  }, rest));
};
DefaultDateField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
};
DefaultDateField.defaultProps = {
  handleInputChange: undefined,
  placeholder: ""
};

var _templateObject$1A, _templateObject2$1l, _templateObject3$15;
var StyledDateField = styled.input(_templateObject$1A || (_templateObject$1A = _taggedTemplateLiteral(["\n  ", "\n  padding: calc(0.75rem - 1px) 1.25rem;\n\n  @supports (-webkit-touch-callout: none) {\n    min-height: 3rem;\n  }\n\n  ", "\n\n  ", "\n"])), fieldStyles, function (props) {
  return (props === null || props === void 0 ? void 0 : props.homepage) && css(_templateObject2$1l || (_templateObject2$1l = _taggedTemplateLiteral(["\n      padding: 12px 16px 10px 16px;\n    "])));
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.simpleForm) && css(_templateObject3$15 || (_templateObject3$15 = _taggedTemplateLiteral(["\n      padding: 12px 16px 10px 16px;\n    "])));
});

var _excluded$q = ["handleInputChange", "handleInputBlur"];
var DefaultDateTimeField = function DefaultDateTimeField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    handleInputBlur = _ref.handleInputBlur,
    rest = _objectWithoutProperties$1(_ref, _excluded$q);
  var name = rest.name,
    value = rest.value,
    min = rest.min,
    max = rest.max,
    placeholder = rest.placeholder,
    homepage = rest.homepage,
    simpleForm = rest.simpleForm;
  var handleBlur = function handleBlur(event) {
    if (handleInputBlur !== undefined) {
      handleInputBlur(name, event.target.value);
    }
  };
  var handleChange = function handleChange(event) {
    if (handleInputChange !== undefined) {
      handleInputChange(name, event.target.value);
    }
  };
  var defaultValue = value ? moment(value).format("YYYY-MM-DD HH:mm") : "";
  var minDate = min ? moment(min).format("YYYY-MM-DD HH:mm") : "";
  var maxDate = max ? moment(max).format("YYYY-MM-DD HH:mm") : "";
  return /*#__PURE__*/React__default.createElement(StyledDateField, {
    type: "datetime-local",
    value: defaultValue,
    placeholder: placeholder,
    min: minDate,
    max: maxDate,
    step: 300,
    onChange: handleChange,
    onBlur: handleBlur,
    homepage: homepage,
    simpleForm: simpleForm
  });
};
DefaultDateTimeField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
};
DefaultDateTimeField.defaultProps = {
  handleInputChange: undefined,
  placeholder: ""
};

var _templateObject$1z;
var StyledField$7 = styled.input(_templateObject$1z || (_templateObject$1z = _taggedTemplateLiteral(["\n  ", "\n\n  padding: calc(0.75rem - 1px) 1.25rem;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  font-size: 1rem;\n\n  @supports (-webkit-touch-callout: none) {\n    min-height: 3rem;\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"])), fieldStyles, function (props) {
  return props.theme.colors.primary;
});

function e$2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function r$1(r) {
  for (var t = 1; t < arguments.length; t++) {
    var a = null != arguments[t] ? arguments[t] : {};
    t % 2 ? e$2(Object(a), !0).forEach(function (e) {
      n$1(r, e, a[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(a)) : e$2(Object(a)).forEach(function (e) {
      Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(a, e));
    });
  }
  return r;
}
function t$1(e) {
  var r = function (e, r) {
    if ("object" != _typeof$1(e) || !e) return e;
    var t = e[Symbol.toPrimitive];
    if (void 0 !== t) {
      var n = t.call(e, r || "default");
      if ("object" != _typeof$1(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(e);
  }(e, "string");
  return "symbol" == _typeof$1(r) ? r : r + "";
}
function n$1(e, r, n) {
  return (r = t$1(r)) in e ? Object.defineProperty(e, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = n, e;
}
function c$2(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];
  return n;
}
function i$2(e, r) {
  var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!t) {
    if (Array.isArray(e) || (t = function (e, r) {
      if (e) {
        if ("string" == typeof e) return c$2(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? c$2(e, r) : void 0;
      }
    }(e)) || r) {
      t && (e = t);
      var _n = 0,
        a = function a() {};
      return {
        s: a,
        n: function n() {
          return _n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[_n++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: a
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    i = !0,
    l = !1;
  return {
    s: function s() {
      t = t.call(e);
    },
    n: function n() {
      var e = t.next();
      return i = e.done, e;
    },
    e: function e(_e2) {
      l = !0, o = _e2;
    },
    f: function f() {
      try {
        i || null == t["return"] || t["return"]();
      } finally {
        if (l) throw o;
      }
    }
  };
}
function l(e, r) {
  var t,
    n = r.replacementChars,
    a = r.replacement,
    o = r.separate,
    c = n,
    l = "",
    s = i$2(e);
  try {
    for (s.s(); !(t = s.n()).done;) {
      var u,
        p = t.value,
        f = !Object.prototype.hasOwnProperty.call(a, p) && (null === (u = a[c[0]]) || void 0 === u ? void 0 : u.test(p));
      (o && p === c[0] || f) && (c = c.slice(1), l += p);
    }
  } catch (e) {
    s.e(e);
  } finally {
    s.f();
  }
  return l;
}
function s(e) {
  return e.length > 0 ? n$1({}, e, /./) : {};
}
function u$3(e, r) {
  var t,
    n = r.mask,
    a = r.replacement,
    o = r.separate,
    c = r.showMask,
    l = 0,
    s = "",
    u = i$2(n);
  try {
    for (u.s(); !(t = u.n()).done;) {
      var p = t.value;
      if (!c && void 0 === e[l]) break;
      Object.prototype.hasOwnProperty.call(a, p) && void 0 !== e[l] ? s += e[l++] : s += p;
    }
  } catch (e) {
    u.e(e);
  } finally {
    u.f();
  }
  if (o && !c) {
    for (var f = n.length - 1; f >= 0 && s[f] === n[f]; f--);
    s = s.slice(0, f + 1);
  }
  return s;
}
function p(e, r) {
  for (var t = r.mask, n = r.replacement, a = [], o = 0; o < t.length; o++) {
    var c,
      i = null !== (c = e[o]) && void 0 !== c ? c : t[o],
      l = Object.prototype.hasOwnProperty.call(n, i) ? "replacement" : void 0 !== e[o] && e[o] !== t[o] ? "input" : "mask";
    a.push({
      type: l,
      value: i,
      index: o
    });
  }
  return a;
}
function f$1(e, r) {
  for (var t = r.start, n = void 0 === t ? 0 : t, a = r.end, o = r.mask, c = r.replacement, i = r.separate, l = e.slice(n, a), s = o.slice(n, a), u = "", p = 0; p < s.length; p++) {
    var f = Object.prototype.hasOwnProperty.call(c, s[p]);
    f && void 0 !== l[p] && l[p] !== s[p] ? u += l[p] : f && i && (u += s[p]);
  }
  return u;
}
var b = ["[", "]", "\\", "/", "^", "$", ".", "|", "?", "*", "+", "(", ")", "{", "}"];
function O(e) {
  return b.includes(e) ? "\\".concat(e) : e;
}
function g(e) {
  for (var r = e.mask, t = e.replacement, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], a = "string" == typeof t ? s(t) : t, o = "", c = 0; c < r.length; c++) {
    var i = r[c],
      l = Object.prototype.hasOwnProperty.call(a, i),
      u = n ? "(?!".concat(O(i), ")") : "";
    0 === c && (o += "^"), o += l ? "".concat(u, "(").concat(a[i].source, ")") : O(i), c === r.length - 1 && (o += "$");
  }
  return o;
}

function t(t, n, r) {
  return n = c$1(n), function (t, e) {
    if (e && ("object" == _typeof$1(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t);
  }(t, e$1() ? Reflect.construct(n, r || [], c$1(t).constructor) : n.apply(t, r));
}
function e$1() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (e$1 = function e() {
    return !!t;
  })();
}
function r(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function o(t, e, n) {
  return Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function u$2(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && i$1(t, e);
}
function c$1(t) {
  return c$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, c$1(t);
}
function i$1(t, e) {
  return i$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, i$1(t, e);
}
function f(t) {
  var n = "function" == typeof Map ? new Map() : void 0;
  return f = function f(t) {
    if (null === t || !function (t) {
      try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
      } catch (e) {
        return "function" == typeof t;
      }
    }(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== n) {
      if (n.has(t)) return n.get(t);
      n.set(t, r);
    }
    function r() {
      return function (t, n, r) {
        if (e$1()) return Reflect.construct.apply(null, arguments);
        var o = [null];
        o.push.apply(o, n);
        var u = new (t.bind.apply(t, o))();
        return r && i$1(u, r.prototype), u;
      }(t, arguments, c$1(this).constructor);
    }
    return r.prototype = Object.create(t.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), i$1(r, t);
  }, f(t);
}

var n = function (e) {
  function n(r$1, a) {
    var e;
    return r(this, n), (e = t(this, n, [r$1])).name = "SyntheticChangeError", e.cause = a, e;
  }
  return u$2(n, e), o(n);
}(f(Error));

function e(e, t) {
  var o = t.value,
    a = t.selectionStart,
    i = t.selectionEnd;
  void 0 !== o && (e.value = o), void 0 !== a && void 0 !== i && e.setSelectionRange(a, i);
}

var u$1 = ["text", "email", "tel", "search", "url"];
function i(i) {
  var o = i.init,
    a = i.tracking,
    c = i.eventType,
    d = i.eventHandler,
    v = useRef({
      timeoutId: -1,
      fallbackTimeoutId: -1,
      cachedTimeoutId: -1,
      start: 0,
      end: 0
    }),
    s = useRef(!0),
    m = useRef(null),
    p = useRef({
      init: o,
      tracking: a,
      eventType: c,
      eventHandler: d
    });
  return p.current.init = o, p.current.tracking = a, p.current.eventType = c, p.current.eventHandler = d, useMemo(function () {
    return function (e$1, t, n) {
      var r = n.onFocus,
        i = n.onBlur,
        o = n.onInput;
      return new Proxy(e$1, {
        set: function set(n, a, c) {
          if ("current" !== a) return !1;
          var d = null !== c && u$1.includes(c.type);
          if ("production" === process.env.NODE_ENV || null === c || d || console.warn("Warn: The input element type does not match one of the types: ".concat(u$1.join(", "), ".")), c !== e$1.current && (null !== e$1.current && (e$1.current.removeEventListener("focus", r), e$1.current.removeEventListener("blur", i), e$1.current.removeEventListener("input", o)), null !== c && d)) {
            var v,
              s = null !== (v = c._wrapperState) && void 0 !== v ? v : {},
              m = s.controlled,
              p = void 0 !== m && m,
              h = s.initialValue,
              f = void 0 === h ? "" : h,
              E = t({
                controlled: p,
                initialValue: c.value || f
              });
            e(c, {
              value: E.value
            }), document.activeElement === c && r(), c.addEventListener("focus", r), c.addEventListener("blur", i), c.addEventListener("input", o);
          }
          return n[a] = c, !0;
        }
      });
    }(m, p.current.init, {
      onFocus: function onFocus() {
        v.current.timeoutId = window.setTimeout(function e() {
          var t, n, r, l;
          s.current ? (v.current.start = null !== (t = null === (n = m.current) || void 0 === n ? void 0 : n.selectionStart) && void 0 !== t ? t : 0, v.current.end = null !== (r = null === (l = m.current) || void 0 === l ? void 0 : l.selectionEnd) && void 0 !== r ? r : 0, v.current.timeoutId = window.setTimeout(e)) : v.current.fallbackTimeoutId = window.setTimeout(e);
        });
      },
      onBlur: function onBlur() {
        window.clearTimeout(v.current.timeoutId), window.clearTimeout(v.current.fallbackTimeoutId), v.current.timeoutId = -1, v.current.fallbackTimeoutId = -1, v.current.cachedTimeoutId = -1;
      },
      onInput: function onInput(e$1) {
        var t = m.current;
        if (null !== t) try {
          var u, i, o, a, c;
          if (v.current.cachedTimeoutId === v.current.timeoutId) throw new n("The input selection has not been updated.");
          v.current.cachedTimeoutId = v.current.timeoutId;
          var d = t.value,
            h = t.selectionStart,
            f = t.selectionEnd;
          if (null === h || null === f) throw new n("The selection attributes have not been initialized.");
          var E,
            w = null !== (u = null === (i = t._valueTracker) || void 0 === i || null === (o = i.getValue) || void 0 === o ? void 0 : o.call(i)) && void 0 !== u ? u : "";
          if (void 0 === e$1.inputType && (v.current.start = 0, v.current.end = w.length), h > v.current.start ? E = "insert" : h <= v.current.start && h < v.current.end ? E = "deleteBackward" : h === v.current.end && d.length < w.length && (E = "deleteForward"), void 0 === E || ("deleteBackward" === E || "deleteForward" === E) && d.length > w.length) throw new n("Input type detection error.");
          var T = "",
            b = "",
            g = v.current.start,
            _ = v.current.end;
          if ("insert" === E) T = d.slice(v.current.start, h);else {
            var I = w.length - d.length;
            g = h, _ = h + I, b = w.slice(g, _);
          }
          var S = p.current.tracking({
            inputType: E,
            previousValue: w,
            value: d,
            addedValue: T,
            deletedValue: b,
            changeStart: g,
            changeEnd: _,
            selectionStart: h,
            selectionEnd: f
          });
          e(t, {
            value: S.value,
            selectionStart: S.selectionStart,
            selectionEnd: S.selectionEnd
          });
          var y = p.current.eventType,
            k = p.current.eventHandler;
          if ("string" == typeof y && k) {
            var V = t.value,
              L = t.selectionStart,
              F = t.selectionEnd;
            s.current = !1, requestAnimationFrame(function () {
              e(t, {
                value: V,
                selectionStart: null != L ? L : V.length,
                selectionEnd: null != F ? F : V.length
              });
              var e$1 = new CustomEvent(y, {
                bubbles: !0,
                cancelable: !1,
                composed: !0,
                detail: S.__detail
              });
              t.dispatchEvent(e$1), unstable_batchedUpdates ? unstable_batchedUpdates(k, e$1) : k(e$1), s.current = !0;
            });
          }
          null === (a = t._valueTracker) || void 0 === a || null === (c = a.setValue) || void 0 === c || c.call(a, w), v.current.start = S.selectionStart, v.current.end = S.selectionEnd;
        } catch (n) {
          var B,
            H,
            j,
            x,
            C,
            A,
            D,
            N,
            P,
            q,
            z,
            O = n,
            W = O.name,
            G = O.cause;
          if (e(t, {
            value: null !== (B = null !== (H = null == G || null === (j = G.__attributes) || void 0 === j ? void 0 : j.value) && void 0 !== H ? H : null === (x = t._valueTracker) || void 0 === x || null === (C = x.getValue) || void 0 === C ? void 0 : C.call(x)) && void 0 !== B ? B : "",
            selectionStart: null !== (A = null == G || null === (D = G.__attributes) || void 0 === D ? void 0 : D.selectionStart) && void 0 !== A ? A : v.current.start,
            selectionEnd: null !== (N = null == G || null === (P = G.__attributes) || void 0 === P ? void 0 : P.selectionEnd) && void 0 !== N ? N : v.current.end
          }), void 0 !== (null == G || null === (q = G.__attributes) || void 0 === q ? void 0 : q.selectionStart) && (v.current.start = G.__attributes.selectionStart), void 0 !== (null == G || null === (z = G.__attributes) || void 0 === z ? void 0 : z.selectionEnd) && (v.current.end = G.__attributes.selectionEnd), e$1.preventDefault(), e$1.stopPropagation(), "SyntheticChangeError" !== W) throw n;
        }
      }
    });
  }, []);
}

var c = function c(e) {
  return function () {
    for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++) r[a] = arguments[a];
    return new e("".concat(r.join("\n\n"), "\n"));
  };
};
function u() {
  var u = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    d = u.mask,
    h = void 0 === d ? "" : d,
    v = u.replacement,
    m = void 0 === v ? {} : v,
    f = u.showMask,
    k = void 0 !== f && f,
    g$1 = u.separate,
    y = void 0 !== g$1 && g$1,
    w = u.track,
    b = u.modify,
    V = u.onMask,
    T = "string" == typeof m ? s(m) : m,
    j = useRef(null);
  return i({
    init: function init(e) {
      var t = e.controlled,
        r = e.initialValue;
      r = t || r ? r : k ? h : "", "production" !== process.env.NODE_ENV && function (e) {
        var t = e.initialValue,
          r = e.mask,
          a = e.replacement;
        t.length > r.length && console.error(c(Error)("The initialized value of the `value` or `defaultValue` property is longer than the value specified in the `mask` property. Check the correctness of the initialized value in the specified property.", 'Invalid value: "'.concat(t, '".'), "To initialize an unmasked value, use the `format` utility. More details https://github.com/GoncharukOrg/react-input/tree/main/packages/mask#initializing-the-value."));
        var n = Object.keys(a).filter(function (e) {
          return e.length > 1;
        });
        n.length > 0 && console.error(c(Error)("Object keys in the `replacement` property are longer than one character. Replacement keys must be one character long. Check the correctness of the value in the specified property.", "Invalid keys: ".concat(n.join(", "), "."), "To initialize an unmasked value, use the `format` utility. More details https://github.com/GoncharukOrg/react-input/tree/main/packages/mask#initializing-the-value."));
        for (var i = r.slice(0, t.length), l = -1, o = 0; o < i.length; o++) {
          var p = Object.prototype.hasOwnProperty.call(a, i[o]);
          if (!(i[o] === t[o] || p && a[i[o]].test(t[o]))) {
            l = o;
            break;
          }
        }
        -1 !== l && console.error(c(Error)("An invalid character was found in the initialized property value `value` or `defaultValue` (index: ".concat(l, "). Check the correctness of the initialized value in the specified property."), 'Invalid value: "'.concat(t, '".'), "To initialize an unmasked value, use the `format` utility. More details https://github.com/GoncharukOrg/react-input/tree/main/packages/mask#initializing-the-value."));
      }({
        initialValue: r,
        mask: h,
        replacement: T
      });
      var a = {
        mask: h,
        replacement: T,
        separate: y
      };
      return j.current = {
        value: r,
        props: a,
        fallbackProps: a
      }, {
        value: r
      };
    },
    tracking: function tracking(o) {
      var p$1,
        c = o.inputType,
        u = o.previousValue,
        d = o.addedValue,
        v = o.changeStart,
        m = o.changeEnd;
      if (null === j.current) throw new n("The state has not been initialized.");
      j.current.value !== u ? j.current.props = j.current.fallbackProps : j.current.fallbackProps = j.current.props;
      var f = null == w ? void 0 : w(r$1(r$1({}, "insert" === c ? {
        inputType: c,
        data: d
      } : {
        inputType: c,
        data: null
      }), {}, {
        value: u,
        selectionStart: v,
        selectionEnd: m
      }));
      if (!1 === f) throw new n("Custom tracking stop.");
      null === f ? d = "" : !0 !== f && void 0 !== f && (d = f);
      var g$1 = f$1(u, r$1({
          end: v
        }, j.current.props)),
        V = f$1(u, r$1({
          start: m
        }, j.current.props)),
        z = RegExp("[^".concat(Object.keys(j.current.props.replacement).join(""), "]"), "g"),
        O = j.current.props.mask.replace(z, "");
      if (g$1 && (g$1 = l(g$1, {
        replacementChars: O,
        replacement: j.current.props.replacement,
        separate: j.current.props.separate
      }), O = O.slice(g$1.length)), d && (d = l(d, {
        replacementChars: O,
        replacement: j.current.props.replacement,
        separate: !1
      }), O = O.slice(d.length)), "insert" === c && "" === d) throw new n("The character does not match the key value of the `replacement` object.");
      if (j.current.props.separate) {
        var E = j.current.props.mask.slice(v, m).replace(z, ""),
          C = E.length - d.length;
        C < 0 ? V = V.slice(-C) : C > 0 && (V = E.slice(-C) + V);
      }
      V && (V = l(V, {
        replacementChars: O,
        replacement: j.current.props.replacement,
        separate: j.current.props.separate
      }));
      var M = g$1 + d + V,
        x = null !== (p$1 = null == b ? void 0 : b(M)) && void 0 !== p$1 ? p$1 : {},
        P = x.mask,
        I = void 0 === P ? h : P,
        G = x.replacement,
        R = void 0 === G ? T : G,
        S = x.showMask,
        _ = void 0 === S ? k : S,
        A = x.separate,
        N = void 0 === A ? y : A;
      "string" == typeof R && (R = s(R));
      var B = function (a, n) {
          var i = n.mask,
            l = n.replacement,
            o = n.separate,
            p$1 = n.showMask,
            s = u$3(a, {
              mask: i,
              replacement: l,
              separate: o,
              showMask: p$1
            }),
            c = p(s, {
              mask: i,
              replacement: l
            }),
            u = g({
              mask: i,
              replacement: l
            }),
            d = g({
              mask: i,
              replacement: l
            }, !0);
          return {
            value: s,
            input: a,
            parts: c,
            pattern: u,
            isValid: RegExp(d).test(s)
          };
        }(M, {
          mask: I,
          replacement: R,
          separate: N,
          showMask: _
        }),
        D = function (e) {
          var t,
            r,
            a,
            n = e.inputType,
            i = e.value,
            l = e.addedValue,
            o = e.beforeChangeValue,
            p = e.parts,
            s = e.replacement,
            c = e.separate,
            u = p.filter(function (e) {
              var t = e.type;
              return "input" === t || c && "replacement" === t;
            }),
            d = null === (t = u[o.length + l.length - 1]) || void 0 === t ? void 0 : t.index,
            h = null === (r = u[o.length - 1]) || void 0 === r ? void 0 : r.index,
            v = null === (a = u[o.length + l.length]) || void 0 === a ? void 0 : a.index;
          if ("insert" === n) {
            if (void 0 !== d) return d + 1;
            if (void 0 !== v) return v;
            if (void 0 !== h) return h + 1;
          }
          if ("deleteForward" === n) {
            if (void 0 !== v) return v;
            if (void 0 !== h) return h + 1;
          }
          if ("deleteBackward" === n) {
            if (void 0 !== h) return h + 1;
            if (void 0 !== v) return v;
          }
          var m = i.split("").findIndex(function (e) {
            return Object.prototype.hasOwnProperty.call(s, e);
          });
          return -1 !== m ? m : i.length;
        }({
          inputType: c,
          value: B.value,
          addedValue: d,
          beforeChangeValue: g$1,
          parts: B.parts,
          replacement: R,
          separate: N
        });
      return j.current.value = B.value, j.current.props = {
        mask: I,
        replacement: R,
        separate: N
      }, {
        value: B.value,
        selectionStart: D,
        selectionEnd: D,
        __detail: B
      };
    },
    eventType: "input-mask",
    eventHandler: V
  });
}

var _excluded$p = ["handleInputChange"];
var PlainDateField = function PlainDateField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    rest = _objectWithoutProperties$1(_ref, _excluded$p);
  var date_format = navigator.language === "en-US" ? "MM/DD/YYYY" : "DD/MM/YYYY";
  var name = rest.name;
  var dateMask = u({
    mask: date_format,
    replacement: {
      D: /\d/,
      M: /\d/,
      Y: /\d/
    },
    showMask: true,
    separate: true
  });
  var _onChange = function onChange(value) {
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  return /*#__PURE__*/React__default.createElement(StyledField$7, _extends({
    ref: dateMask,
    type: "text",
    onChange: function onChange(input) {
      return _onChange(input.target.value);
    }
  }, rest, {
    placeholder: date_format,
    pattern: "[0-9]{2}/[0-9]{2}/[0-9]{4}",
    value: rest.value
  }));
};
PlainDateField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
};
PlainDateField.defaultProps = {
  handleInputChange: undefined,
  placeholder: "DD/MM/YYYY"
};

var _templateObject$1y;
var Container$y = styled.div(_templateObject$1y || (_templateObject$1y = _taggedTemplateLiteral(["\n  display: ", ";\n"])), function (_ref) {
  var show = _ref.show;
  return !!show ? "grid" : "none";
});

var _excluded$o = ["children"];
var FieldGroup = function FieldGroup(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$o);
  return /*#__PURE__*/React__default.createElement(Container$y, rest, children);
};
FieldGroup.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool
};
FieldGroup.defaultProps = {
  show: true
};

var _templateObject$1x, _templateObject2$1k, _templateObject3$14, _templateObject4$W, _templateObject5$G, _templateObject6$C, _templateObject7$z, _templateObject8$t, _templateObject9$r;
var StyledFieldset = styled.fieldset(_templateObject$1x || (_templateObject$1x = _taggedTemplateLiteral(["\n  border: none;\n  margin: 0;\n  padding: 0;\n\n  ", "\n"])), function (_ref) {
  var last = _ref.last,
    simpleForm = _ref.simpleForm;
  return !!last && !!simpleForm && css(_templateObject2$1k || (_templateObject2$1k = _taggedTemplateLiteral(["\n      margin-bottom: 32px;\n    "])));
});
var Legend = styled.legend(_templateObject3$14 || (_templateObject3$14 = _taggedTemplateLiteral(["\n  ", "\n\n  margin: 0 0 1rem;\n  padding: 0;\n"])), styles$2);
var VideoHintList = styled.div(_templateObject4$W || (_templateObject4$W = _taggedTemplateLiteral(["\n  line-height: 1.5em;\n  padding: 0 0 0 20px;\n  text-decoration: underline;\n\n  ", "\n"])), function (_ref2) {
  var simpleForm = _ref2.simpleForm;
  return !!simpleForm && css(_templateObject5$G || (_templateObject5$G = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.fields.text;
  });
});
var VideoHintP = styled.p(_templateObject6$C || (_templateObject6$C = _taggedTemplateLiteral(["\n  margin: -5px 0 0;\n\n  ", "\n"])), function (_ref4) {
  var simpleForm = _ref4.simpleForm;
  return !!simpleForm && css(_templateObject7$z || (_templateObject7$z = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.fields.text;
  });
});
var VideoHintHeading = styled.div(_templateObject8$t || (_templateObject8$t = _taggedTemplateLiteral(["\n  margin: 1rem 0 -3px;\n  font-weight: bold;\n\n  ", "\n"])), function (_ref6) {
  var simpleForm = _ref6.simpleForm;
  return !!simpleForm && css(_templateObject9$r || (_templateObject9$r = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.primary;
  });
});

var _templateObject$1w, _templateObject2$1j, _templateObject3$13, _templateObject4$V, _templateObject5$F, _templateObject6$B, _templateObject7$y, _templateObject8$s, _templateObject9$q, _templateObject0$p, _templateObject1$m, _templateObject10$l, _templateObject11$k, _templateObject12$i, _templateObject13$g, _templateObject14$f, _templateObject15$f;
var getBackgroundColor$1 = function getBackgroundColor(variant) {
  var useAlternativeVariant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  switch (variant) {
    case "primary":
      return function (props) {
        return props.theme.colors.primary;
      };
    case "secondary":
      if (useAlternativeVariant) {
        return function (props) {
          return props.theme.colors.secondaryAlternative || props.theme.colors.secondary;
        };
      } else {
        return function (props) {
          return props.theme.colors.secondary;
        };
      }
    case "white":
      return "white";
    case "danger":
      return function (props) {
        return lighten(0.3, props.theme.colors.danger);
      };
    case "transparent":
      return "transparent";
    case "warning":
      return function (props) {
        return lighten(0.3, props.theme.colors.warning);
      };
    case "incompletion":
      return function (props) {
        return lighten(0.3, props.theme.colors.warning);
      };
    default:
      return function (props) {
        return props.theme.colors.lightGrey;
      };
  }
};
var getHeightFromProps = function getHeightFromProps(props) {
  if (!!props.fixed && !!props.paddingless) {
    return "9rem";
  } else if (!!props.fixed) {
    return "7rem";
  } else {
    return "auto";
  }
};
var StyledCard$1 = styled.div(_templateObject$1w || (_templateObject$1w = _taggedTemplateLiteral(["\n  position: relative;\n  background-color: ", ";\n  ", "\n  ", "\n  ", "\n  height: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n    ", "\n\n    ", "\n\n      ", "\n"])), function (_ref) {
  var variant = _ref.variant,
    useAlternativeVariant = _ref.useAlternativeVariant;
  return getBackgroundColor$1(variant, useAlternativeVariant);
}, function (_ref2) {
  var simpleForm = _ref2.simpleForm;
  return !simpleForm && css(_templateObject2$1j || (_templateObject2$1j = _taggedTemplateLiteral(["\n      margin-bottom: 2rem;\n    "])));
}, function (_ref3) {
  var roundedOnMobile = _ref3.roundedOnMobile;
  return !!roundedOnMobile && css(_templateObject3$13 || (_templateObject3$13 = _taggedTemplateLiteral(["\n      border-radius: 1rem;\n    "])));
}, breakpoint("tablet")(_templateObject4$V || (_templateObject4$V = _taggedTemplateLiteral(["\n    border-radius: 1rem;\n  "]))), function (props) {
  return getHeightFromProps(props);
}, function (_ref4) {
  var image = _ref4.image,
    theme = _ref4.theme;
  return image !== undefined && css(_templateObject5$F || (_templateObject5$F = _taggedTemplateLiteral(["\n      background-size: cover;\n      background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ", " 100%),\n        url(\"", "\");\n    "])), theme.colors.primary, image);
}, function (_ref5) {
  var paddingless = _ref5.paddingless;
  return !paddingless && css(_templateObject6$B || (_templateObject6$B = _taggedTemplateLiteral(["\n      padding: 2rem;\n    "])));
}, function (_ref6) {
  var paddingless = _ref6.paddingless;
  return !!paddingless && css(_templateObject7$y || (_templateObject7$y = _taggedTemplateLiteral(["\n      padding: 0;\n    "])));
}, function (_ref7) {
  var marginless = _ref7.marginless;
  return !!marginless && css(_templateObject8$s || (_templateObject8$s = _taggedTemplateLiteral(["\n      margin: 0rem;\n    "])));
}, function (_ref8) {
  var paddinglessOnMobile = _ref8.paddinglessOnMobile;
  return !!paddinglessOnMobile && breakpoint("mobile", "tablet")(_templateObject9$q || (_templateObject9$q = _taggedTemplateLiteral(["\n    padding: 0;\n  "])));
}, function (_ref9) {
  var pageMargin = _ref9.pageMargin;
  return !!pageMargin && css(_templateObject0$p || (_templateObject0$p = _taggedTemplateLiteral(["\n      margin: 0 1rem;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject1$m || (_templateObject1$m = _taggedTemplateLiteral(["\n      margin: 0;\n    "]))));
}, function (_ref0) {
  var gridArea = _ref0.gridArea;
  return gridArea !== undefined && css(_templateObject10$l || (_templateObject10$l = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject11$k || (_templateObject11$k = _taggedTemplateLiteral(["\n      grid-area: ", ";\n    "])), gridArea));
}, function (props) {
  return props.desktopOnly && css(_templateObject12$i || (_templateObject12$i = _taggedTemplateLiteral(["\n      display: none;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject13$g || (_templateObject13$g = _taggedTemplateLiteral(["\n      display: block;\n    "]))));
}, function (_ref1) {
  var simpleFormContent = _ref1.simpleFormContent,
    theme = _ref1.theme;
  return !!simpleFormContent && css(_templateObject14$f || (_templateObject14$f = _taggedTemplateLiteral(["\n      width: 100%;\n      padding: 24px 20px;\n      border: 1px solid ", ";\n      border-radius: 16px;\n    "])), theme.colors.fields.border);
}, function (_ref10) {
  var variant = _ref10.variant;
  return variant === "incompletion" && css(_templateObject15$f || (_templateObject15$f = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n      border-radius: 8px !important;\n      padding: 16px 18px;\n    "])), function (_ref11) {
    var theme = _ref11.theme;
    return darken(0.25, theme.colors.warning);
  });
});

var _templateObject$1v, _templateObject2$1i, _templateObject3$12, _templateObject4$U, _templateObject5$E, _templateObject6$A, _templateObject7$x, _templateObject8$r, _templateObject9$p, _templateObject0$o, _templateObject1$l, _templateObject10$k;
var styles = css(_templateObject$1v || (_templateObject$1v = _taggedTemplateLiteral(["\n  ", "\n  grid-template: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var autoCols = _ref.autoCols,
    overview = _ref.overview;
  return !autoCols && !overview && css(_templateObject2$1i || (_templateObject2$1i = _taggedTemplateLiteral(["\n      grid: ", ";\n    "])), function (_ref2) {
    var grid = _ref2.grid;
    return grid;
  });
}, function (_ref3) {
  var template = _ref3.template;
  return template;
}, function (_ref4) {
  var placeItems = _ref4.placeItems;
  return placeItems !== undefined && css(_templateObject3$12 || (_templateObject3$12 = _taggedTemplateLiteral(["\n      place-items: ", ";\n    "])), placeItems);
}, function (_ref5) {
  var placeContent = _ref5.placeContent;
  return placeContent !== undefined && css(_templateObject4$U || (_templateObject4$U = _taggedTemplateLiteral(["\n      place-content: ", ";\n    "])), placeContent);
}, function (_ref6) {
  var gridArea = _ref6.gridArea;
  return gridArea !== undefined && css(_templateObject5$E || (_templateObject5$E = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject6$A || (_templateObject6$A = _taggedTemplateLiteral(["\n      grid-area: ", ";\n    "])), gridArea));
});
var StyledGrid = styled.div(_templateObject7$x || (_templateObject7$x = _taggedTemplateLiteral(["\n  display: grid;\n  gap: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n\n    ", "\n\n    ", "\n"])), function (_ref7) {
  var gap = _ref7.gap;
  return gap;
}, function (_ref8) {
  var simpleForm = _ref8.simpleForm;
  return !!simpleForm && css(_templateObject8$r || (_templateObject8$r = _taggedTemplateLiteral(["\n      gap: 16px;\n    "])));
}, breakpoint("tablet")(_templateObject9$p || (_templateObject9$p = _taggedTemplateLiteral(["\n    ", "\n  "])), styles), function (_ref9) {
  var mobile = _ref9.mobile;
  return !!mobile && styles;
}, function (_ref0) {
  var autoCols = _ref0.autoCols;
  return !!autoCols && css(_templateObject0$o || (_templateObject0$o = _taggedTemplateLiteral(["\n      grid-auto-flow: column;\n    "])));
}, function (_ref1) {
  var fill = _ref1.fill;
  return !!fill && css(_templateObject1$l || (_templateObject1$l = _taggedTemplateLiteral(["\n      flex: 1;\n    "])));
}, function (_ref10) {
  var overview = _ref10.overview,
    videoGrid = _ref10.videoGrid;
  return !!overview && css(_templateObject10$k || (_templateObject10$k = _taggedTemplateLiteral(["\n      display: grid;\n      grid-template-columns: ", " !important;\n      gap: 24px;\n      align-self: stretch;\n    "])), videoGrid ? "1fr" : "repeat(2, 1fr)");
});

var _excluded$n = ["children", "gap", "grid", "template", "placeItems", "placeContent", "gridArea", "mobile"];
var Grid$1 = function Grid(_ref) {
  var children = _ref.children,
    gap = _ref.gap,
    grid = _ref.grid,
    template = _ref.template,
    placeItems = _ref.placeItems,
    placeContent = _ref.placeContent,
    gridArea = _ref.gridArea,
    mobile = _ref.mobile,
    rest = _objectWithoutProperties$1(_ref, _excluded$n);
  return /*#__PURE__*/React__default.createElement(StyledGrid, _extends({
    gap: gap,
    grid: grid,
    template: template,
    placeItems: placeItems,
    placeContent: placeContent,
    gridArea: gridArea,
    mobile: mobile
  }, rest), children);
};
Grid$1.propTypes = {
  children: PropTypes.node,
  gap: PropTypes.string,
  grid: PropTypes.string,
  template: PropTypes.string,
  placeItems: PropTypes.string,
  placeContent: PropTypes.string,
  gridArea: PropTypes.string,
  mobile: PropTypes.bool
};
Grid$1.defaultProps = {
  children: null,
  gap: "2rem",
  grid: "none",
  template: "none",
  placeItems: undefined,
  placeContent: undefined,
  gridArea: undefined,
  mobile: false
};

var _excluded$m = ["children"];
var Card$1 = function Card(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties$1(_ref, _excluded$m);
  var dismissalPersisted = function dismissalPersisted() {
    return localStorage.getItem(rest.dismissableKey) === "true";
  };
  var _useState = useState(dismissalPersisted()),
    _useState2 = _slicedToArray(_useState, 2),
    cardHidden = _useState2[0],
    setCardHidden = _useState2[1];
  var persistDismissal = function persistDismissal() {
    localStorage.setItem(rest.dismissableKey, "true");
  };
  var dismissCard = function dismissCard() {
    setCardHidden(true);
    if (rest.dismissableKey) persistDismissal();
  };
  var renderCloseIcon = function renderCloseIcon() {
    return /*#__PURE__*/React__default.createElement(CloseIcon$1, {
      size: "large",
      onClick: dismissCard,
      variant: "secondary",
      style: {
        position: "absolute",
        right: "1rem",
        top: "1rem"
      }
    });
  };
  return /*#__PURE__*/React__default.createElement(StyledCard$1, _extends({}, rest, {
    hidden: cardHidden
  }), rest.dismissable && renderCloseIcon(), children);
};
Card$1.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["default", "primary", "secondary", "white", "danger", "transparent", "warning"]),
  paddingless: PropTypes.bool,
  fixed: PropTypes.bool,
  gridArea: PropTypes.string,
  image: PropTypes.string,
  roundedOnMobile: PropTypes.bool,
  paddinglessOnMobile: PropTypes.bool,
  dismissable: PropTypes.bool,
  dismissableKey: PropTypes.string,
  useAlternativeVariant: PropTypes.bool
};
Card$1.defaultProps = {
  variant: "default",
  paddingless: false,
  fixed: false,
  gridArea: undefined,
  image: undefined,
  roundedOnMobile: true,
  paddinglessOnMobile: false,
  dismissable: false,
  dismissableKey: undefined,
  useAlternativeVariant: false
};

var _templateObject$1u, _templateObject2$1h, _templateObject3$11, _templateObject4$T, _templateObject5$D, _templateObject6$z, _templateObject7$w, _templateObject8$q, _templateObject9$o, _templateObject0$n, _templateObject1$k, _templateObject10$j, _templateObject11$j, _templateObject12$h, _templateObject13$f, _templateObject14$e, _templateObject15$e, _templateObject16$d, _templateObject17$b, _templateObject18$a, _templateObject19$9, _templateObject20$8, _templateObject21$6, _templateObject22$6, _templateObject23$6, _templateObject24$5, _templateObject25$5, _templateObject26$5, _templateObject27$5;
var SeeMoreLink = styled.button(_templateObject$1u || (_templateObject$1u = _taggedTemplateLiteral(["\n  color: ", ";\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-weight: 400;\n  padding: 0;\n  font-size: 16px;\n  margin-top: 0.8rem;\n  width: 100%;\n\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  > svg {\n    font-size: 0.875rem;\n  }\n"])), function (props) {
  return props.theme.colors.brand;
});
var Container$x = styled.div(_templateObject2$1h || (_templateObject2$1h = _taggedTemplateLiteral(["\n  display: grid;\n  gap: 1rem;\n\n  ", "\n\n  &:empty {\n    display: none;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), breakpoint("desktop")(_templateObject3$11 || (_templateObject3$11 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: flex-start;\n    gap: 2rem;\n  "]))), function (_ref) {
  var gridArea = _ref.gridArea;
  return gridArea !== undefined && css(_templateObject4$T || (_templateObject4$T = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject5$D || (_templateObject5$D = _taggedTemplateLiteral(["\n      grid-area: ", ";\n    "])), gridArea));
}, function (_ref2) {
  var simpleForm = _ref2.simpleForm;
  return !!simpleForm && css(_templateObject6$z || (_templateObject6$z = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("desktop")(_templateObject7$w || (_templateObject7$w = _taggedTemplateLiteral(["\n        flex-direction: column;\n        align-items: stretch;\n        gap: 1rem;\n      "]))));
}, function (_ref3) {
  var fullWidthVideo = _ref3.fullWidthVideo;
  return !!fullWidthVideo && css(_templateObject8$q || (_templateObject8$q = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("desktop")(_templateObject9$o || (_templateObject9$o = _taggedTemplateLiteral(["\n        flex-direction: column;\n        align-items: stretch;\n        gap: 0;\n      "]))));
});
var ContentContainer = styled(Card$1)(_templateObject0$n || (_templateObject0$n = _taggedTemplateLiteral(["\n  user-select: text;\n\n  &:empty {\n    display: none;\n  }\n\n  ", "\n"])), function (_ref4) {
  var inlineOnMobile = _ref4.inlineOnMobile;
  return !!inlineOnMobile && breakpoint("mobile", "tablet")(_templateObject1$k || (_templateObject1$k = _taggedTemplateLiteral(["\n    display: none;\n  "])));
});
var SimpleFormContentContainer = styled(Card$1).attrs({
  variant: "white",
  simpleFormContent: true
})(_templateObject10$j || (_templateObject10$j = _taggedTemplateLiteral(["\n  user-select: text;\n  width: unset;\n  margin-bottom: 16px;\n  border: 1px solid #e6e6e6;\n  overflow: auto;\n\n  ", "\n\n  ", "\n\n  ", "\n  &:empty {\n    display: none;\n  }\n"])), breakpoint("tablet")(_templateObject11$j || (_templateObject11$j = _taggedTemplateLiteral(["\n    width: auto;\n  "]))), function (props) {
  return !!props.marginless && css(_templateObject12$h || (_templateObject12$h = _taggedTemplateLiteral(["\n      margin-bottom: 0;\n    "])));
}, function (props) {
  return !!props.fullWidthVideo && !!props.simpleForm && css(_templateObject13$f || (_templateObject13$f = _taggedTemplateLiteral(["\n      display: flex;\n      flex-direction: column;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject14$e || (_templateObject14$e = _taggedTemplateLiteral(["\n        padding: 24px;\n        align-items: flex-start;\n        gap: 24px;\n        align-self: stretch;\n        flex-direction: row;\n        flex-wrap: wrap;\n\n        ", "\n      "])), !!props.splitContainer && css(_templateObject15$e || (_templateObject15$e = _taggedTemplateLiteral(["\n            > div {\n              flex: 1;\n            }\n          "])))));
});
var ProfileContentContainer = styled.div(_templateObject16$d || (_templateObject16$d = _taggedTemplateLiteral(["\n  user-select: text;\n  width: unset;\n  margin-bottom: 16px;\n\n  ", "\n\n  &:empty {\n    display: none;\n  }\n"])), breakpoint("tablet")(_templateObject17$b || (_templateObject17$b = _taggedTemplateLiteral(["\n    width: auto;\n  "]))));
var MobileContentContainer = styled(Card$1).attrs({
  paddingless: true,
  variant: "transparent"
})(_templateObject18$a || (_templateObject18$a = _taggedTemplateLiteral(["\n  user-select: text;\n\n  &:empty {\n    display: none;\n  }\n\n  ", "\n"])), breakpoint("tablet")(_templateObject19$9 || (_templateObject19$9 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var VideoContainer$2 = styled(Card$1).attrs({
  paddingless: true
})(_templateObject20$8 || (_templateObject20$8 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref5) {
  var simpleForm = _ref5.simpleForm;
  return !simpleForm && css(_templateObject21$6 || (_templateObject21$6 = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("desktop")(_templateObject22$6 || (_templateObject22$6 = _taggedTemplateLiteral(["\n        flex: 0 0 45%;\n      "]))));
}, function (_ref6) {
  var simpleForm = _ref6.simpleForm;
  return !!simpleForm && css(_templateObject23$6 || (_templateObject23$6 = _taggedTemplateLiteral(["\n      max-width: 672px;\n      margin-top: 0.5rem;\n      background: transparent;\n    "])));
}, function (_ref7) {
  var fullWidthVideo = _ref7.fullWidthVideo,
    simpleForm = _ref7.simpleForm;
  return !!fullWidthVideo && css(_templateObject24$5 || (_templateObject24$5 = _taggedTemplateLiteral(["\n      width: 100%;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject25$5 || (_templateObject25$5 = _taggedTemplateLiteral(["\n        ", "\n      "])), !!simpleForm && "width: 66%;"));
});
var VideoWrapper$2 = styled.div(_templateObject26$5 || (_templateObject26$5 = _taggedTemplateLiteral(["\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 0%;\n  border-radius: inherit;\n"])));
var Video$1 = styled.iframe(_templateObject27$5 || (_templateObject27$5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n"])));

function parameterize() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
  return str.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, "").replace(/\s/g, separator);
}
function toBool() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return ["true", "yes", "1"].includes(value.toString().trim().toLowerCase());
}
function capitalize(str) {
  if (typeof str !== "string") return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}
function validVideoUrl(videoUrl) {
  var youtubePattern = /youtube\.com\/embed\/(.{11})(\?.{0,})?/;
  var vimeoPattern = /player\.vimeo\.com.*(\?v=|\/video\/)(.{8,})/;
  return youtubePattern.test(videoUrl) || vimeoPattern.test(videoUrl);
}
function truncateNearestWord(str, maxLength) {
  try {
    var output = "";
    var currentLength = 0;
    var insideTag = false;
    var insideMarkdownLink = false;
    var insideBold = false;
    var tagBuffer = "";
    var markdownBuffer = "";
    var boldBuffer = "";
    for (var i = 0; i < str.length; i++) {
      var _char = str[i];

      // Check if we're inside an HTML tag
      if (_char === "<") {
        insideTag = true;
        tagBuffer = "<";
        continue;
      }
      if (insideTag) {
        tagBuffer += _char;
        if (_char === ">") {
          insideTag = false;
          output += tagBuffer;
          tagBuffer = "";
        }
        continue;
      }

      // Check if we're inside a Markdown link
      if (_char === "[") {
        insideMarkdownLink = true;
        markdownBuffer = "[";
        continue;
      }
      if (insideMarkdownLink) {
        markdownBuffer += _char;
        if (_char === "]") {
          var linkPart = "";
          var j = i + 1;
          if (str[j] === "(") {
            while (j < str.length && str[j] !== ")") {
              linkPart += str[j];
              j++;
            }
            if (str[j] === ")") {
              markdownBuffer += linkPart + ")";
              output += markdownBuffer;
              i = j;
              insideMarkdownLink = false;
              continue;
            }
          }
        }
        continue;
      }

      // Check if we're inside a bold tag
      if (_char === "*" && str[i + 1] === "*") {
        if (!insideBold) {
          insideBold = true;
          boldBuffer = "**";
          i++; // Skip the second asterisk
          continue;
        } else {
          insideBold = false;
          output += boldBuffer + "**";
          boldBuffer = "";
          i++; // Skip the second asterisk
          continue;
        }
      }
      if (insideBold) {
        boldBuffer += _char;
        continue;
      }

      // Add characters to the output while under the limit
      if (currentLength < maxLength) {
        output += _char;
        currentLength++;
      } else {
        // Check if we are in the middle of a link, tag, or bold text
        if (insideTag || insideMarkdownLink || insideBold) {
          continue; // Skip truncating in the middle of a tag, link, or bold text
        }
        // If we were in the middle of bold text, close it
        if (boldBuffer) {
          output += boldBuffer + "**";
        }
        break;
      }
    }

    // If we end with an unclosed bold tag, close it
    if (insideBold) {
      output += boldBuffer + "**";
    }
    return output;
  } catch (error) {
    console.error("truncateNearestWord error", error);
    var trimmedString = str.substr(0, maxLength);
    return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
  }
}

var faMessage={prefix:'fal',iconName:'message',icon:[512,512,["comment-alt"],"f27a","M160 384c17.7 0 32 14.3 32 32l0 48 98.1-73.6c5.5-4.2 12.3-6.4 19.2-6.4L448 384c17.7 0 32-14.3 32-32l0-288c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 288c0 17.7 14.3 32 32 32l96 0zM0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-48 0-32-32 0-64 0c-35.3 0-64-28.7-64-64L0 64z"]};var faChevronUp={prefix:'fal',iconName:'chevron-up',icon:[512,512,[],"f077","M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z"]};var faPhoneFlip={prefix:'fal',iconName:'phone-flip',icon:[512,512,[128381,"phone-alt"],"f879","M136.2 275.2c16.4-7 35.4-2.4 46.7 11.4l33.2 40.6c46-26.7 84.4-65.1 111.1-111.1L286.7 183c-13.8-11.3-18.5-30.3-11.4-46.7l48-112C330.8 6.7 349.7-3.1 368.4 .9l112 24C498.8 28.8 512 45.1 512 64c0 0 0 0 0 0c0 236.7-183.5 430.5-416 446.9c-4.5 .3-9.1 .6-13.7 .8c0 0 0 0 0 0c0 0-.1 0-.1 0c-6.1 .2-12.1 .4-18.3 .4c0 0 0 0 0 0c-18.9 0-35.2-13.2-39.1-31.6l-24-112c-4-18.7 5.8-37.6 23.4-45.1l112-48zM64.3 480C293.9 479.8 480 293.7 480 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0-3.8-2.6-7-6.3-7.8l-112-24c-3.7-.8-7.5 1.2-9 4.7l-48 112c-1.4 3.3-.5 7.1 2.3 9.3l40.6 33.2c12.2 9.9 15.3 27.2 7.4 40.8c-29.5 50.9-71.9 93.3-122.7 122.7c-13.6 7.9-30.9 4.7-40.8-7.4l-33.2-40.6c-2.3-2.8-6.1-3.7-9.3-2.3l-112 48c-3.5 1.5-5.5 5.3-4.7 9l24 112c.8 3.7 4.1 6.3 7.8 6.3c.1 0 .2 0 .3 0z"]};var faPhoneAlt=faPhoneFlip;var faEnvelope={prefix:'fal',iconName:'envelope',icon:[512,512,[128386,9993,61443],"f0e0","M64 96c-17.7 0-32 14.3-32 32l0 39.9L227.6 311.3c16.9 12.4 39.9 12.4 56.8 0L480 167.9l0-39.9c0-17.7-14.3-32-32-32L64 96zM32 207.6L32 384c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-176.4L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"]};var faBell={prefix:'fal',iconName:'bell',icon:[448,512,[128276,61602],"f0f3","M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.8c80.9 8 144 76.2 144 159.2l0 29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3L44.3 416C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1L64 192c0-83 63.1-151.2 144-159.2L208 16zm16 48C153.3 64 96 121.3 96 192l0 29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3l359.4 0c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2l0-29.1c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8z"]};var faChevronDown={prefix:'fal',iconName:'chevron-down',icon:[512,512,[],"f078","M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z"]};

var _excluded$l = ["content", "videoUrl", "inlineOnMobile", "fullWidthVideo", "simpleForm", "profile", "charLimit"];
var Content$7 = function Content(_ref) {
  var content = _ref.content,
    videoUrl = _ref.videoUrl,
    inlineOnMobile = _ref.inlineOnMobile,
    fullWidthVideo = _ref.fullWidthVideo,
    simpleForm = _ref.simpleForm,
    profile = _ref.profile,
    charLimit = _ref.charLimit,
    rest = _objectWithoutProperties$1(_ref, _excluded$l);
  var _useState = useState(charLimit && content ? content.length <= charLimit : true),
    _useState2 = _slicedToArray(_useState, 2),
    showAllContent = _useState2[0],
    setShowAllContent = _useState2[1];
  useEffect(function () {
    if (!content) return;
    if (!charLimit) {
      setShowAllContent(true);
    } else {
      setShowAllContent((content === null || content === void 0 ? void 0 : content.length) <= charLimit);
    }
  }, [content]);
  var truncateContent = function truncateContent(content) {
    return truncateNearestWord(content, charLimit) + "...";
  };
  var seeMoreLink = /*#__PURE__*/React__default.createElement(SeeMoreLink, {
    onClick: function onClick() {
      return setShowAllContent(!showAllContent);
    }
  }, showAllContent ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, "See less"), /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faChevronUp,
    size: "1x"
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, "See more"), /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faChevronDown,
    size: "1x"
  })));
  var contentContainer = /*#__PURE__*/React__default.createElement(ContentContainer, _extends({
    inlineOnMobile: inlineOnMobile
  }, rest), /*#__PURE__*/React__default.createElement(Markdown, {
    componentStyles: {
      h1: {
        variant: "primary"
      }
    }
  }, content));
  var videoContent = function videoContent() {
    return videoUrl && validVideoUrl(videoUrl) ? /*#__PURE__*/React__default.createElement(VideoContainer$2, {
      simpleForm: simpleForm,
      fullWidthVideo: fullWidthVideo
    }, /*#__PURE__*/React__default.createElement(VideoWrapper$2, null, /*#__PURE__*/React__default.createElement(Video$1, {
      title: "Video",
      width: "560",
      height: "349",
      src: "".concat(videoUrl, "?color=white&rel=0"),
      frameBorder: "0",
      allowFullScreen: true
    }))) : null;
  };
  var simpleFormContentContainer = /*#__PURE__*/React__default.createElement(SimpleFormContentContainer, _extends({
    fullWidthVideo: fullWidthVideo,
    simpleForm: simpleForm
  }, rest), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Markdown, {
    componentStyles: {
      h1: {
        variant: "contentv2Heading",
        size: "smallv2"
      },
      h2: {
        variant: "contentv2PlainHeading",
        size: "smallv2"
      },
      h3: {
        variant: "contentv2PlainHeading",
        size: "smallv2"
      },
      img: {
        variant: "contentv2"
      },
      table: {
        variant: "contentv2"
      },
      details: {
        variant: "contentv2PlainHeading",
        size: "smallv2"
      },
      p: {
        variant: "contentv2",
        size: "smallv2"
      },
      li: {
        variant: "contentv2",
        size: "smallv2"
      }
    }
  }, showAllContent ? content : truncateContent(content)), charLimit && (content === null || content === void 0 ? void 0 : content.length) > charLimit && seeMoreLink), videoContent());
  var mobileContentContainer = /*#__PURE__*/React__default.createElement(MobileContentContainer, {
    inlineOnMobile: inlineOnMobile
  }, /*#__PURE__*/React__default.createElement(Markdown, {
    componentStyles: {
      generic: {
        variant: "default"
      }
    }
  }, content));
  var profileContentContainer = /*#__PURE__*/React__default.createElement(ProfileContentContainer, _extends({
    inlineOnMobile: inlineOnMobile
  }, rest), /*#__PURE__*/React__default.createElement(Markdown, {
    componentStyles: {
      h2: {
        variant: "primary",
        size: "profile"
      },
      h3: {
        variant: "secondary",
        size: "profile"
      },
      p: {
        variant: "content",
        size: "profile"
      },
      li: {
        variant: "content",
        size: "profile"
      }
    }
  }, content));
  if (content && simpleForm) {
    return /*#__PURE__*/React__default.createElement(Container$x, _extends({
      simpleForm: true
    }, rest), simpleFormContentContainer);
  } else if (content && profile) {
    return /*#__PURE__*/React__default.createElement(Container$x, rest, profileContentContainer, videoContent && videoContent());
  } else {
    return /*#__PURE__*/React__default.createElement(Container$x, _extends({
      fullWidthVideo: fullWidthVideo
    }, rest), content && contentContainer, content && !!inlineOnMobile && mobileContentContainer, videoContent && videoContent());
  }
};
Content$7.propTypes = {
  content: PropTypes.string,
  videoUrl: PropTypes.string,
  gridArea: PropTypes.string,
  inlineOnMobile: PropTypes.bool,
  marginless: PropTypes.bool
};
Content$7.defaultProps = {
  gridArea: undefined,
  inlineOnMobile: false,
  marginless: false
};

var Fieldset$2 = function Fieldset(_ref) {
  var children = _ref.children,
    legendText = _ref.legendText,
    content = _ref.content,
    showVideoHint = _ref.showVideoHint,
    videoUrl = _ref.videoUrl,
    simpleForm = _ref.simpleForm,
    last = _ref.last;
  var cardVariant = simpleForm ? "white" : "primary";
  var legendVariant = simpleForm ? "primary" : "body";
  var legendSize = simpleForm ? "simpleForm" : "large";
  var markdownVariant = simpleForm ? "simpleForm" : "default";
  return /*#__PURE__*/React__default.createElement(StyledFieldset, {
    simpleForm: simpleForm,
    last: last
  }, /*#__PURE__*/React__default.createElement(Card$1, {
    variant: cardVariant,
    paddingless: !!simpleForm,
    simpleForm: true
  }, /*#__PURE__*/React__default.createElement(Legend, {
    size: legendSize,
    variant: legendVariant
  }, legendText), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: simpleForm ? "1.5rem" : "1rem"
  }, !videoUrl && /*#__PURE__*/React__default.createElement(Markdown, {
    componentStyles: {
      h1: {
        variant: markdownVariant
      },
      h2: {
        variant: markdownVariant
      },
      h3: {
        variant: markdownVariant
      },
      p: {
        variant: markdownVariant
      },
      li: {
        variant: markdownVariant
      },
      a: {
        variant: markdownVariant
      }
    }
  }, content), videoUrl && /*#__PURE__*/React__default.createElement(Content$7, {
    content: content,
    videoUrl: videoUrl,
    inlineOnMobile: true
  }), children, showVideoHint && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(VideoHintHeading, {
    simpleForm: simpleForm
  }, "Tips for Video URLs"), /*#__PURE__*/React__default.createElement(VideoHintP, {
    simpleForm: simpleForm
  }, "From YouTube or Vimeo, find your video and click ", /*#__PURE__*/React__default.createElement("b", null, "Share"), " then ", /*#__PURE__*/React__default.createElement("b", null, "Embed"), " and copy just the URL and paste below."), /*#__PURE__*/React__default.createElement(VideoHintP, {
    simpleForm: simpleForm
  }, "It will look like this with your video ID at the end"), /*#__PURE__*/React__default.createElement(VideoHintList, {
    simpleForm: simpleForm
  }, /*#__PURE__*/React__default.createElement("li", null, "https://www.youtube.com/embed/videoID OR"), /*#__PURE__*/React__default.createElement("li", null, "https://player.vimeo.com/video/videoID"))))));
};
Fieldset$2.propTypes = {
  children: PropTypes.node,
  legend: PropTypes.string,
  content: PropTypes.string,
  videoUrl: PropTypes.string
};
Fieldset$2.defaultProps = {
  content: "",
  videoUrl: ""
};

var _templateObject$1t;
var StyledField$6 = styled.input(_templateObject$1t || (_templateObject$1t = _taggedTemplateLiteral(["\n  display: none;\n"])));

var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB in bytes

var FileField = function FileField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    name = _ref.name,
    text = _ref.text,
    noneText = _ref.noneText,
    accept = _ref.accept,
    required = _ref.required,
    multiple = _ref.multiple,
    alert = _ref.alert;
  var _useState = useState(noneText),
    _useState2 = _slicedToArray(_useState, 2),
    selectedText = _useState2[0],
    setSelectedText = _useState2[1];
  var onChange = function onChange(event) {
    var files = event.target.files;
    !!multiple ? handleMultipleFiles(files) : handleSingleFile(files[0]);
  };
  var handleMultipleFiles = function handleMultipleFiles(files) {
    var fileArray = Array.from(files);
    setSelectedText("".concat(fileArray.length, " ").concat(fileArray.length === 1 ? "file" : "files", " selected"));

    // Is this needed?
    // fileArray.forEach(file => {
    //   let reader = new FileReader()
    //   if (file instanceof Blob) reader.readAsDataURL(file)
    // })

    if (handleInputChange !== undefined) handleInputChange(name, fileArray);
  };
  var handleSingleFile = function handleSingleFile(file) {
    if ((file === null || file === void 0 ? void 0 : file.size) >= MAX_FILE_SIZE && alert !== undefined) {
      handleInputChange(name, null);
      alert.error("Chosen file is above file limit");
      return;
    }
    var reader = new FileReader();
    reader.onload = function () {
      var text = document.getElementById("".concat(name, "SelectedText"));
      setSelectedText(file.name);
      text.setAttribute("data-reader-result", reader.result);
      if (handleInputChange !== undefined) handleInputChange(name, file);
    };
    if (file instanceof Blob) reader.readAsDataURL(file);
  };
  var triggerFileUpload = function triggerFileUpload(event) {
    event.preventDefault();
    document.getElementById("".concat(name, "FileField")).click();
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1rem",
    grid: "auto / auto-flow",
    placeItems: "center",
    placeContent: "start"
  }, /*#__PURE__*/React__default.createElement(Button$5, {
    variant: "secondary",
    onClick: triggerFileUpload
  }, text), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    id: "".concat(name, "SelectedText")
  }, selectedText)), /*#__PURE__*/React__default.createElement(StyledField$6, {
    type: "file",
    name: name,
    accept: accept,
    required: required,
    multiple: multiple,
    onChange: onChange,
    id: "".concat(name, "FileField")
  }));
};
FileField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  text: PropTypes.string,
  noneText: PropTypes.string,
  accept: PropTypes.string,
  required: PropTypes.bool,
  multiple: PropTypes.bool
};
FileField.defaultProps = {
  handleInputChange: undefined,
  name: "",
  text: "Choose file",
  noneText: "No file selected",
  accept: "application/pdf",
  required: false,
  multiple: false
};

var _templateObject$1s, _templateObject2$1g;
var StyledForm = styled.form(_templateObject$1s || (_templateObject$1s = _taggedTemplateLiteral(["\n  margin: 0;\n\n  ", "\n"])), function (_ref) {
  var simpleForm = _ref.simpleForm;
  return !simpleForm && css(_templateObject2$1g || (_templateObject2$1g = _taggedTemplateLiteral(["\n      display: grid;\n      gap: 2rem;\n    "])));
});

var Form$1 = function Form(_ref) {
  var children = _ref.children,
    simpleForm = _ref.simpleForm;
  return /*#__PURE__*/React__default.createElement(StyledForm, {
    simpleForm: simpleForm
  }, children);
};
Form$1.propTypes = {
  children: PropTypes.node
};

var _templateObject$1r, _templateObject2$1f;
var P$3 = styled.p(_templateObject$1r || (_templateObject$1r = _taggedTemplateLiteral(["\n  font-family: ", ", sans-serif;\n  color: ", ";\n  font-size: 0.85rem;\n  margin: 0.5rem 0 0 0;\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.body.family;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.body;
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.simpleForm) && css(_templateObject2$1f || (_templateObject2$1f = _taggedTemplateLiteral(["\n      color: #000;\n    "])));
});

var HelpText = function HelpText(_ref) {
  var children = _ref.children,
    simpleForm = _ref.simpleForm;
  return /*#__PURE__*/React__default.createElement(P$3, {
    size: "small",
    simpleForm: simpleForm
  }, children);
};
HelpText.propTypes = {
  children: PropTypes.node
};

var _templateObject$1q, _templateObject2$1e, _templateObject3$10;
var StyledLabel$1 = styled.label(_templateObject$1q || (_templateObject$1q = _taggedTemplateLiteral(["\n  font-family: ", ", sans-serif;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.body.family;
}, function (_ref2) {
  var simpleForm = _ref2.simpleForm,
    theme = _ref2.theme;
  return !!simpleForm && css(_templateObject2$1e || (_templateObject2$1e = _taggedTemplateLiteral(["\n      margin: 0 0 16px;\n      color: ", ";\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 150%;\n    "])), theme.colors.fields.label);
}, function (_ref3) {
  var simpleForm = _ref3.simpleForm;
  return !simpleForm && css(_templateObject3$10 || (_templateObject3$10 = _taggedTemplateLiteral(["\n      margin: 0.5rem 0;\n      display: flex;\n      justify-content: space-between;\n      color: ", ";\n      font-size: 1rem;\n      font-weight: bold;\n    "])), function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.body;
  });
});

var Label$1 = function Label(_ref) {
  var children = _ref.children,
    invalid = _ref.invalid,
    simpleForm = _ref.simpleForm;
  return /*#__PURE__*/React__default.createElement(StyledLabel$1, {
    invalid: invalid,
    simpleForm: simpleForm
  }, children);
};
Label$1.propTypes = {
  children: PropTypes.node.isRequired,
  invalid: PropTypes.bool
};
Label$1.defaultProps = {
  invalid: false
};

var _templateObject$1p, _templateObject2$1d, _templateObject3$$, _templateObject4$S;
var sharedStyles$1 = css(_templateObject$1p || (_templateObject$1p = _taggedTemplateLiteral(["\n  ", "\n  font: inherit;\n  line-height: 22px;\n\n  grid-area: 1 / 1 / 2 / 2;\n"])), fieldStyles);
var TextAreaWrapper$1 = styled.div(_templateObject2$1d || (_templateObject2$1d = _taggedTemplateLiteral(["\n  display: grid;\n  overflow-x: auto;\n\n  &:after {\n    content: attr(data-replicated-value) \" \";\n    white-space: pre-wrap;\n    visibility: hidden;\n    ", "\n  }\n"])), sharedStyles$1);
var TextArea$3 = styled.textarea(_templateObject3$$ || (_templateObject3$$ = _taggedTemplateLiteral(["\n  resize: none;\n  overflow: hidden;\n  ", "\n  height: auto;\n  word-wrap: break-word; /* Ensures words wrap inside the textarea */\n  overflow-wrap: break-word; /* Handles long strings without spaces */\n\n  ", "\n\n  ", "\n"])), sharedStyles$1, function (_ref) {
  var large = _ref.large;
  return large && "\n    min-height: 20rem;\n  ";
}, function (_ref2) {
  var simpleForm = _ref2.simpleForm;
  return !!simpleForm && css(_templateObject4$S || (_templateObject4$S = _taggedTemplateLiteral(["\n      padding: 16px;\n    "])));
});

var _excluded$k = ["value", "handleInputChange", "expanding", "characterLimit"];
var TextArea$2 = function TextArea(_ref) {
  var value = _ref.value,
    handleInputChange = _ref.handleInputChange,
    expanding = _ref.expanding,
    characterLimit = _ref.characterLimit,
    rest = _objectWithoutProperties$1(_ref, _excluded$k);
  useEffect(function () {
    calculateCharactersRemaining(value === null || value === void 0 ? void 0 : value.length);
  }, [value]);
  var onChange = function onChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    calculateCharactersRemaining(value.length);
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  var showCharacterLimit = function showCharacterLimit() {
    if (isNaN(parseInt(characterLimit))) return false;
    if (parseInt(characterLimit) < 1) return false;
    return true;
  };
  var _useState = useState(characterLimit - (value === null || value === void 0 ? void 0 : value.length)),
    _useState2 = _slicedToArray(_useState, 2),
    charactersRemaining = _useState2[0],
    setCharactersRemaining = _useState2[1];
  var calculateCharactersRemaining = function calculateCharactersRemaining(characterCount) {
    return setCharactersRemaining(characterLimit - characterCount);
  };
  return /*#__PURE__*/React__default.createElement(TextAreaWrapper$1, {
    "data-replicated-value": expanding ? value : ""
  }, /*#__PURE__*/React__default.createElement(TextArea$3, _extends({
    value: value,
    onChange: onChange,
    maxLength: characterLimit
  }, rest)), showCharacterLimit() && !!value && /*#__PURE__*/React__default.createElement(P$4, {
    align: "right",
    size: "small",
    marginless: true
  }, "".concat(charactersRemaining, " characters remaining")));
};
TextArea$2.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  value: PropTypes.string,
  expanding: PropTypes.bool,
  rows: PropTypes.number,
  invalid: PropTypes.bool,
  characterLimit: PropTypes.number
};
TextArea$2.defaultProps = {
  handleInputChange: undefined,
  showValidation: false,
  value: "",
  expanding: true,
  rows: 4,
  invalid: false,
  characterLimit: undefined
};

var LargeTextArea = function LargeTextArea(props) {
  return /*#__PURE__*/React__default.createElement(TextArea$2, _extends({}, props, {
    large: true,
    rows: "15"
  }));
};

var _templateObject$1o, _templateObject2$1c, _templateObject3$_;
var StyledField$5 = styled.input(_templateObject$1o || (_templateObject$1o = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n"])), fieldStyles, function (_ref) {
  var disabled = _ref.disabled;
  return !!disabled && css(_templateObject2$1c || (_templateObject2$1c = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "])));
});
var Hint = styled.p(_templateObject3$_ || (_templateObject3$_ = _taggedTemplateLiteral(["\n  font-weight: 400;\n  margin: 6px 0 0 5px;\n  font-size: 0.9rem;\n\n  p {\n    font-size: 0.9rem;\n  }\n"])));

var _excluded$j = ["handleInputChange", "hint"];
var TextField = function TextField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    hint = _ref.hint,
    rest = _objectWithoutProperties$1(_ref, _excluded$j);
  var onChange = function onChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledField$5, _extends({
    type: "text",
    onChange: onChange
  }, rest)), hint && /*#__PURE__*/React__default.createElement(Hint, null, /*#__PURE__*/React__default.createElement(Markdown, {
    componentStyles: {
      p: {
        variant: rest.hintVariant || "default"
      },
      li: {
        variant: rest.hintVariant || "default"
      },
      a: {
        variant: rest.hintVariant || "default"
      }
    }
  }, hint)));
};
TextField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool
};
TextField.defaultProps = {
  handleInputChange: undefined,
  showValidation: false,
  invalid: false
};

var MultiTextField = function MultiTextField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    name = _ref.name,
    value = _ref.value,
    options = _ref.options,
    simpleForm = _ref.simpleForm;
  var onChange = function onChange(eName, eValue) {
    var valueHash = {};
    if (_typeof$1(value) === "object") valueHash = value;
    valueHash[eName] = eValue;
    if (handleInputChange !== undefined) handleInputChange(name, valueHash);
  };
  var getValue = function getValue(name) {
    if (_typeof$1(value) === "object") return value[name];else return "";
  };
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1rem",
    style: {
      marginBottom: "1rem"
    }
  }, options.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "0",
      key: "".concat(option[0], "_").concat(index)
    }, /*#__PURE__*/React__default.createElement(Label$1, {
      marginless: true,
      simpleForm: simpleForm
    }, option[1]), /*#__PURE__*/React__default.createElement(TextField, {
      handleInputChange: onChange,
      id: "".concat(option[0], "_").concat(index),
      value: getValue(option[0]),
      name: option[0],
      simpleForm: simpleForm
    }));
  }));
};
MultiTextField.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  value: PropTypes.object,
  handleInputChange: PropTypes.func.isRequired
};
MultiTextField.defaultProps = {
  name: "",
  options: [],
  value: {},
  handleInputChange: undefined
};

var _templateObject$1n, _templateObject2$1b, _templateObject3$Z, _templateObject4$R;
var StyledField$4 = styled.input(_templateObject$1n || (_templateObject$1n = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n"])), fieldStyles);
var EyeIcon = styled.div(_templateObject2$1b || (_templateObject2$1b = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  padding-right: 1rem;\n  color: #ccc;\n  cursor: pointer;\n  transition: color 0.3s;\n  &:hover {\n    color: ", ";\n  }\n\n  ", "\n\n  svg {\n    width: 1rem;\n    height: 1rem;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.brand;
}, function (_ref2) {
  var showPassword = _ref2.showPassword;
  return !!showPassword && css(_templateObject3$Z || (_templateObject3$Z = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.brand;
  });
});
var PasswordWrapper = styled.div(_templateObject4$R || (_templateObject4$R = _taggedTemplateLiteral(["\n  position: relative;\n"])));

var _excluded$i = ["handleInputChange"];
var PasswordField = function PasswordField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    rest = _objectWithoutProperties$1(_ref, _excluded$i);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var onChange = function onChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  return /*#__PURE__*/React__default.createElement(PasswordWrapper, null, /*#__PURE__*/React__default.createElement(StyledField$4, _extends({
    type: !!showPassword ? "text" : "password",
    onChange: onChange
  }, rest)), /*#__PURE__*/React__default.createElement(EyeIcon, {
    showPassword: showPassword
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faEye,
    onClick: function onClick() {
      setShowPassword(!showPassword);
    }
  })));
};
PasswordField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool
};
PasswordField.defaultProps = {
  handleInputChange: undefined,
  showValidation: false,
  invalid: false
};

var _templateObject$1m, _templateObject2$1a, _templateObject3$Y, _templateObject4$Q, _templateObject5$C, _templateObject6$y, _templateObject7$v, _templateObject8$p, _templateObject9$n, _templateObject0$m, _templateObject1$j, _templateObject10$i, _templateObject11$i;
var Container$w = styled.div(_templateObject$1m || (_templateObject$1m = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n    ", "\n"])), function (_ref) {
  var invalid = _ref.invalid,
    theme = _ref.theme;
  return !!invalid && css(_templateObject2$1a || (_templateObject2$1a = _taggedTemplateLiteral(["\n      border-radius: 1rem;\n      padding: 0.75rem 1.25rem;\n      border: 2px solid ", ";\n      background-color: ", ";\n    "])), darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger), mix(0.8, "#fff", theme.colors.danger));
}, function (_ref2) {
  var invalid = _ref2.invalid,
    simpleForm = _ref2.simpleForm,
    theme = _ref2.theme;
  return !!invalid && !simpleForm && css(_templateObject3$Y || (_templateObject3$Y = _taggedTemplateLiteral(["\n      border: 2px solid ", ";\n      background-color: ", ";\n\n      & > :not(:last-child) {\n        margin-bottom: 0.5rem;\n      }\n    "])), theme.colors.danger, mix(0.95, "#fff", theme.colors.danger));
}, function (_ref3) {
  var simpleForm = _ref3.simpleForm;
  return !!simpleForm && css(_templateObject4$Q || (_templateObject4$Q = _taggedTemplateLiteral(["\n      margin: 2px 0 8px;\n      padding-right: 4px;\n    "])));
});
var Label = styled.label(_templateObject5$C || (_templateObject5$C = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ", sans-serif;\n  cursor: pointer;\n  margin: 0;\n  line-height: 0;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.body;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fonts.body.family;
}, function (_ref6) {
  var textColor = _ref6.textColor;
  return textColor && css(_templateObject6$y || (_templateObject6$y = _taggedTemplateLiteral(["\n      color: ", " !important;\n    "])), textColor);
}, function (_ref7) {
  var invalid = _ref7.invalid,
    theme = _ref7.theme;
  return !!invalid && css(_templateObject7$v || (_templateObject7$v = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger));
}, function (_ref8) {
  var simpleForm = _ref8.simpleForm,
    theme = _ref8.theme;
  return !!simpleForm && css(_templateObject8$p || (_templateObject8$p = _taggedTemplateLiteral(["\n      color: ", ";\n      left: 18px;\n      font-size: 16px;\n      font-weight: 400;\n      position: relative;\n      top: -2px;\n    "])), theme.colors.fields.text);
});
var RadioContainer = styled.label(_templateObject9$n || (_templateObject9$n = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), function (_ref9) {
  var simpleForm = _ref9.simpleForm;
  return !!simpleForm && css(_templateObject0$m || (_templateObject0$m = _taggedTemplateLiteral(["\n      display: block;\n      position: relative;\n      padding-left: 24px;\n      margin: 3px 0;\n      cursor: pointer;\n      font-size: 22px;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n\n      &:not(:last-child) {\n        margin-bottom: 16px;\n      }\n\n      & > input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        height: 0;\n        width: 0;\n      }\n\n      &:hover input + span {\n        border-color: ", ";\n      }\n\n      & > input:checked + span {\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      & > input:checked + span:after {\n        display: block;\n      }\n\n      & > span:after {\n        top: 6px;\n        left: 6px;\n        width: 12px;\n        height: 12px;\n        border-radius: 50%;\n        background: white;\n      }\n    "])), function (_ref0) {
    var theme = _ref0.theme;
    return theme.colors.primary;
  }, function (_ref1) {
    var theme = _ref1.theme;
    return theme.colors.primary;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.primary;
  });
}, function (_ref11) {
  var simpleForm = _ref11.simpleForm;
  return !simpleForm && css(_templateObject1$j || (_templateObject1$j = _taggedTemplateLiteral(["\n      margin-right: 20px;\n      margin-bottom: 0.5rem;\n      display: block;\n    "])));
});
var RadioButton = styled.input(_templateObject10$i || (_templateObject10$i = _taggedTemplateLiteral(["\n  cursor: pointer;\n  margin: 0;\n  margin-right: 0.6rem;\n  width: 15px;\n  height: 15px;\n  position: relative;\n  top: 2px;\n"])));
var Checkmark = styled.span(_templateObject11$i || (_templateObject11$i = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 24px;\n  width: 24px;\n  background-color: transparent;\n  border-radius: 50%;\n  border: 1px solid ", ";\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n  }\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.fields.border;
});

var RadioButtons = function RadioButtons(_ref) {
  var name = _ref.name,
    value = _ref.value,
    options = _ref.options,
    handleInputChange = _ref.handleInputChange;
    _ref.required;
    var invalid = _ref.invalid,
    textColor = _ref.textColor,
    simpleForm = _ref.simpleForm,
    disabled = _ref.disabled,
    disabledMessage = _ref.disabledMessage;
  var onChange = function onChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  return /*#__PURE__*/React__default.createElement(Container$w, {
    simpleForm: simpleForm
  }, options.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement(RadioContainer, {
      simpleForm: simpleForm,
      key: "".concat(name, "_").concat(index)
    }, /*#__PURE__*/React__default.createElement(RadioButton, {
      type: "radio",
      id: "".concat(name, "_").concat(index),
      name: name,
      value: option[0],
      onChange: onChange,
      checked: value === option[0],
      disabled: disabled
    }), simpleForm && /*#__PURE__*/React__default.createElement(Checkmark, null), /*#__PURE__*/React__default.createElement(Label, {
      invalid: invalid,
      htmlFor: "".concat(name, "_").concat(index),
      textColor: textColor,
      simpleForm: simpleForm
    }, option[1]));
  }), disabled && disabledMessage && /*#__PURE__*/React__default.createElement(Card$1, {
    variant: "warning",
    fixed: false,
    style: {
      padding: "0.5rem"
    }
  }, /*#__PURE__*/React__default.createElement(P$4, {
    size: "small",
    variant: "content"
  }, disabledMessage)));
};
RadioButtons.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  options: PropTypes.array.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string
};
RadioButtons.defaultProps = {
  options: [],
  handleInputChange: undefined,
  required: false
};

var _templateObject$1l, _templateObject2$19, _templateObject3$X, _templateObject4$P;
var Select = styled.select(_templateObject$1l || (_templateObject$1l = _taggedTemplateLiteral(["\n  ", "\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3Ctitle%3Edown-arrow%3C%2Ftitle%3E%3Cg%20fill%3D%22%23000000%22%3E%3Cpath%20d%3D%22M10.293%2C3.293%2C6%2C7.586%2C1.707%2C3.293A1%2C1%2C0%2C0%2C0%2C.293%2C4.707l5%2C5a1%2C1%2C0%2C0%2C0%2C1.414%2C0l5-5a1%2C1%2C0%2C1%2C0-1.414-1.414Z%22%20fill%3D%22%23000000%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n  background-size: 0.6em;\n  background-position: calc(100% - 1.3em) center;\n  background-repeat: no-repeat;\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), fieldStyles, function (_ref) {
  var tableRow = _ref.tableRow,
    theme = _ref.theme;
  return !!tableRow && css(_templateObject2$19 || (_templateObject2$19 = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n      min-width: 14em;\n    "])), theme.colors.darkGrey);
}, function (_ref2) {
  var tableRow = _ref2.tableRow,
    numberOfOptions = _ref2.numberOfOptions;
  return !!tableRow && numberOfOptions === 0 && css(_templateObject3$X || (_templateObject3$X = _taggedTemplateLiteral(["\n      opacity: 0;\n      visibility: hidden;\n      pointer-events: none;\n    "])));
}, function (_ref3) {
  var maxMobileWidth = _ref3.maxMobileWidth;
  return !!maxMobileWidth && "max-width: ".concat(maxMobileWidth, ";");
}, breakpoint("tablet")(_templateObject4$P || (_templateObject4$P = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref4) {
  var maxWidth = _ref4.maxWidth;
  return !!maxWidth && "max-width: ".concat(maxWidth, ";");
}));

var _excluded$h = ["handleInputChange", "options", "blank"];
var SelectField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var handleInputChange = _ref.handleInputChange,
    options = _ref.options,
    blank = _ref.blank,
    rest = _objectWithoutProperties$1(_ref, _excluded$h);
  var onChange = function onChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  return /*#__PURE__*/React__default.createElement(Select, _extends({
    onChange: onChange,
    numberOfOptions: (options === null || options === void 0 ? void 0 : options.length) || 0,
    ref: ref
  }, rest), blank && /*#__PURE__*/React__default.createElement("option", {
    value: ""
  }, blank), options.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: option[0] + index,
      value: option[0]
    }, option[1]);
  }));
});
SelectField.propTypes = {
  handleInputChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  blank: PropTypes.string,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool
};
SelectField.defaultProps = {
  handleInputChange: undefined,
  options: [],
  showValidation: false,
  blank: "Please select",
  invalid: false
};

var _templateObject$1k, _templateObject2$18, _templateObject3$W, _templateObject4$O, _templateObject5$B;
var Container$v = styled.div(_templateObject$1k || (_templateObject$1k = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var simpleForm = _ref.simpleForm;
  return !simpleForm && css(_templateObject2$18 || (_templateObject2$18 = _taggedTemplateLiteral(["\n      flex-direction: column;\n      background-color: ", ";\n      bottom: 0;\n      left: 0;\n      z-index: 10;\n      width: 100vw;\n      padding: 1rem;\n      border-radius: 1rem 1rem 0 0;\n      box-sizing: border-box;\n      justify-content: space-evenly;\n      position: fixed;\n\n      > :not(.additional-text) {\n        width: 100%;\n      }\n\n      > .additional-text {\n        padding: 0.5rem 0;\n      }\n\n      ", "\n\n      > :not(:last-child) {\n        margin: 0 0 0.5rem 0;\n\n        ", "\n      }\n    "])), function (props) {
    return props.theme.colors.secondary;
  }, breakpoint("tablet")(_templateObject3$W || (_templateObject3$W = _taggedTemplateLiteral(["\n        width: auto;\n        right: 5vw;\n        left: auto;\n        flex-direction: row;\n\n        > :not(.additional-text) {\n          width: auto;\n          min-width: 10rem;\n        }\n\n        > .additional-text {\n          padding: 0 0.5rem;\n        }\n      "]))), breakpoint("tablet")(_templateObject4$O || (_templateObject4$O = _taggedTemplateLiteral(["\n      margin: 0 1rem 0 0;\n    "]))));
}, function (_ref2) {
  var simpleForm = _ref2.simpleForm;
  return !!simpleForm && css(_templateObject5$B || (_templateObject5$B = _taggedTemplateLiteral(["\n      gap: 16px;\n    "])));
});

var _excluded$g = ["text", "additionalText", "backButton", "backButtonOnly", "backButtonText", "simpleForm"];
var SubmitButton = function SubmitButton(_ref) {
  var text = _ref.text,
    additionalText = _ref.additionalText,
    backButton = _ref.backButton,
    backButtonOnly = _ref.backButtonOnly,
    backButtonText = _ref.backButtonText,
    simpleForm = _ref.simpleForm,
    rest = _objectWithoutProperties$1(_ref, _excluded$g);
  var propsForButton = {
    type: rest.type,
    disabled: rest.disabled,
    onClick: rest.handleClick,
    to: rest.to,
    href: rest.href,
    variant: simpleForm ? "simpleForm" : rest.variant
  };
  var propsForBackButton = _objectSpread2(_objectSpread2({}, backButton), {}, {
    onClick: backButton === null || backButton === void 0 ? void 0 : backButton.handleClick,
    disabled: rest.disabled && !rest.ignoreDisabledForBackButton
  });
  return /*#__PURE__*/React__default.createElement(Container$v, {
    simpleForm: simpleForm
  }, additionalText && /*#__PURE__*/React__default.createElement(P$4, {
    variant: simpleForm ? "content" : "secondaryReadable",
    marginless: true,
    bold: true,
    align: "center",
    className: "additional-text"
  }, additionalText), backButton && /*#__PURE__*/React__default.createElement(Button$5, _extends({
    variant: simpleForm ? "simpleFormBack" : "white",
    outlined: true
  }, propsForBackButton), backButtonText), !backButtonOnly && /*#__PURE__*/React__default.createElement(Button$5, _extends({}, propsForButton, {
    actionButton: (additionalText === null || additionalText === void 0 ? void 0 : additionalText.length) > 0 ? false : true
  }), text));
};
SubmitButton.propTypes = {
  type: PropTypes.oneOf(["button", "submit"]),
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  handleClick: PropTypes.func,
  to: PropTypes.string,
  href: PropTypes.string,
  simpleForm: PropTypes.bool,
  additionalText: PropTypes.string,
  variant: PropTypes.oneOf(["default", "primary", "secondary", "white", "success", "danger"]),
  backButton: PropTypes.shape({
    handleClick: PropTypes.func,
    to: PropTypes.string,
    href: PropTypes.string
  }),
  backButtonText: PropTypes.string,
  backButtonOnly: PropTypes.bool.isRequired,
  ignoreDisabledForBackButton: PropTypes.bool
};
SubmitButton.defaultProps = {
  type: "submit",
  text: "Save",
  disabled: false,
  handleClick: undefined,
  to: null,
  href: null,
  additionalText: null,
  variant: "success",
  backButton: null,
  backButtonOnly: false,
  backButtonText: "Back",
  ignoreDisabledForBackButton: false
};

var _templateObject$1j;
var StyledField$3 = styled.input(_templateObject$1j || (_templateObject$1j = _taggedTemplateLiteral(["\n  ", "\n"])), fieldStyles);

var _excluded$f = ["handleInputChange"];
var NumberField = function NumberField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    rest = _objectWithoutProperties$1(_ref, _excluded$f);
  var name = rest.name,
    value = rest.value;
    rest.simpleForm;
  var onChange = function onChange(value) {
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  return /*#__PURE__*/React__default.createElement(StyledField$3, _extends({
    type: "number",
    onWheel: function onWheel(event) {
      return event.target.blur();
    },
    onInput: function onInput(number) {
      return onChange(number.target.value);
    },
    defaultValue: value
  }, rest));
};
NumberField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  invalid: PropTypes.bool
};
NumberField.defaultProps = {
  handleInputChange: undefined,
  invalid: false
};

var _templateObject$1i;
var Container$u = styled.div(_templateObject$1i || (_templateObject$1i = _taggedTemplateLiteral(["\n  display: flex;\n  box-sizing: border-box;\n\n  & > :first-child {\n    flex: 0 0 6rem;\n    margin-right: 1rem;\n  }\n"])));

var PhoneSelect = function PhoneSelect(_ref) {
  var name = _ref.name,
    placeholder = _ref.placeholder,
    selectValue = _ref.selectValue,
    textValue = _ref.textValue,
    handleInputChange = _ref.handleInputChange,
    phoneCodes = _ref.phoneCodes,
    simpleForm = _ref.simpleForm;
  var onChange = function onChange(name, value) {
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  return /*#__PURE__*/React__default.createElement(Container$u, null, /*#__PURE__*/React__default.createElement(SelectField, {
    name: "".concat(name, "_country_id"),
    options: phoneCodes,
    value: selectValue,
    handleInputChange: onChange,
    blank: "-",
    simpleForm: simpleForm
  }), /*#__PURE__*/React__default.createElement(TextField, {
    name: name,
    placeholder: placeholder,
    value: textValue,
    handleInputChange: onChange,
    simpleForm: simpleForm
  }));
};
PhoneSelect.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  selectValue: PropTypes.number,
  textValue: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
  phoneCodes: PropTypes.array.isRequired
};
PhoneSelect.defaultProps = {
  placeholder: "Enter phone number",
  handleInputChange: undefined,
  phoneCodes: []
};

var _templateObject$1h, _templateObject2$17, _templateObject3$V, _templateObject4$N, _templateObject5$A, _templateObject6$x;
var StyledDiv$1 = styled.div(_templateObject$1h || (_templateObject$1h = _taggedTemplateLiteral(["\n  font-family: ", ", sans-serif;\n\n  .rmsc .dropdown-container {\n    border-width: 2px;\n    border-radius: 10px;\n    border-color: transparent;\n    color: #000;\n\n    .dropdown-heading {\n      height: unset;\n      padding: 4px 10px 4px 2px;\n      border-radius: 8px;\n    }\n\n    .dropdown-heading-value {\n      padding: 5px 8px;\n\n      & > span > span.text {\n        padding: calc(0.75rem - 9px) calc(1.25rem - 10px);\n      }\n\n      & > span {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: flex;\n        flex-wrap: wrap;\n        gap: 8px;\n      }\n    }\n\n    .dropdown-content,\n    .rmsc .options {\n      color: #000;\n    }\n\n    .select-item {\n      box-sizing: border-box;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: start;\n      padding: 12px 16px;\n      outline-offset: 0;\n    }\n\n    .select-item:hover {\n      background: #f2f2f2;\n    }\n  }\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.fonts.body.family;
}, function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$17 || (_templateObject2$17 = _taggedTemplateLiteral(["\n    .rmsc.invalid .dropdown-container {\n      border-color: ", ";\n      background-color: ", ";\n      color: ", ";\n    }\n\n    .rmsc.invalid .dropdown-container .gray {\n      color: ", ";\n    }\n  "])), darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger), mix(0.95, "#fff", theme.colors.danger), darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger), darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger));
}, function (_ref2) {
  var simpleForm = _ref2.simpleForm;
  return !!simpleForm && css(_templateObject3$V || (_templateObject3$V = _taggedTemplateLiteral(["\n      .rmsc .dropdown-container {\n        .dropdown-heading {\n          padding: 12px 10px 12px 16px;\n          border: 1px solid #e6e6e6;\n        }\n\n        .dropdown-heading-value {\n          padding: 0 10px 0 0;\n\n          & > span > span.text {\n            padding: 0;\n          }\n        }\n      }\n    "])));
});
var Item$1 = styled.div(_templateObject4$N || (_templateObject4$N = _taggedTemplateLiteral([""])));
var Token = styled.span(_templateObject5$A || (_templateObject5$A = _taggedTemplateLiteral(["\n  background: #f2f2f2;\n  color: #333333;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 6px 14px;\n  border-radius: 6px;\n  line-height: 150%;\n"])));
var ClearSelected = styled.span(_templateObject6$x || (_templateObject6$x = _taggedTemplateLiteral(["\n  cursor: pointer;\n  padding-right: 5px;\n  color: ", ";\n"])), function (props) {
  return props.theme.colors.primary;
});

var _excluded$e = ["handleInputChange", "simpleForm"];
var MultiSelectField = function MultiSelectField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    simpleForm = _ref.simpleForm,
    rest = _objectWithoutProperties$1(_ref, _excluded$e);
  var options = rest.options,
    value = rest.value,
    multiSelect = rest.multiSelect,
    name = rest.name,
    invalid = rest.invalid;
  var maxValueLength = 150;
  var onChange = function onChange(value) {
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  var ValueRenderer = function ValueRenderer(selected, _options) {
    if (selected.length) {
      var textLength = selected.map(function (_ref2) {
        var label = _ref2.label;
        return label;
      }).join(", ").length;
      if (textLength > maxValueLength) {
        return /*#__PURE__*/React__default.createElement("span", {
          className: "text"
        }, "".concat(selected.length, " Items Selected"));
      } else {
        return selected.map(function (_ref3) {
          var label = _ref3.label;
          return /*#__PURE__*/React__default.createElement(Token, null, label);
        });
      }
    } else {
      return /*#__PURE__*/React__default.createElement("span", {
        className: "text"
      }, "No Items Selected");
    }
  };
  var SimpleFormItemRenderer = function SimpleFormItemRenderer(_ref4) {
    var checked = _ref4.checked,
      option = _ref4.option,
      onClick = _ref4.onClick,
      disabled = _ref4.disabled;
    return /*#__PURE__*/React__default.createElement(Item$1, {
      className: "item-renderer ".concat(disabled ? "disabled" : "")
    }, /*#__PURE__*/React__default.createElement(Checkboxes, {
      name: option.value,
      value: checked ? option.value : 0,
      options: [[option.value, option.label]],
      handleInputChange: onClick,
      multiple: false,
      disabled: disabled,
      simpleForm: true,
      marginless: true
    }));
  };
  var multiSelectProps = {
    options: options,
    value: value || [],
    onChange: multiSelect ? onChange : handleInputChange,
    labelledBy: "Select",
    className: "".concat(value && value.length && "items", " ").concat(invalid && "invalid"),
    name: name
  };
  multiSelectProps["valueRenderer"] = ValueRenderer;
  if (simpleForm) {
    multiSelectProps["ItemRenderer"] = SimpleFormItemRenderer;
    multiSelectProps["ClearSelectedIcon"] = /*#__PURE__*/React__default.createElement(ClearSelected, null, "Clear");
  }
  return /*#__PURE__*/React__default.createElement(StyledDiv$1, {
    simpleForm: simpleForm
  }, /*#__PURE__*/React__default.createElement(MultiSelect, multiSelectProps));
};
MultiSelectField.propTypes = {
  name: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  blank: PropTypes.string,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool,
  multiSelect: PropTypes.bool
};
MultiSelectField.defaultProps = {
  name: "",
  handleInputChange: function handleInputChange() {},
  options: [],
  blank: "",
  showValidation: false,
  invalid: false,
  multiSelect: false
};

var _templateObject$1g, _templateObject2$16;
var StyledField$2 = styled.input.attrs({
  maxLength: function maxLength(props) {
    return props.maxlength;
  }
})(_templateObject$1g || (_templateObject$1g = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n"])), fieldStyles, function (_ref) {
  var disabled = _ref.disabled;
  return !!disabled && css(_templateObject2$16 || (_templateObject2$16 = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "])));
});
// export const DisabledStyledField = styled.input`
//   ${fieldStyles};
//   background-color: ${({ theme }) => theme.colors.brand};
// `

var _excluded$d = ["handleInputChange"];
var FLIGHT_NUMBER_REGEX = /^[1-9][0-9]*$/;
var FlightNumberField = function FlightNumberField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    rest = _objectWithoutProperties$1(_ref, _excluded$d);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    invalid = _useState2[0],
    setInvalid = _useState2[1];
  var onChange = function onChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    if (value === "") setInvalid(false);else setInvalid(!FLIGHT_NUMBER_REGEX.test(value));
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  return /*#__PURE__*/React__default.createElement(StyledField$2, _extends({
    type: "text",
    onChange: onChange
  }, rest, {
    invalid: invalid
  }));
};
FlightNumberField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool
};
FlightNumberField.defaultProps = {
  handleInputChange: undefined,
  showValidation: false,
  invalid: false
};

var _templateObject$1f, _templateObject2$15;
var StyledField$1 = styled.input.attrs({
  maxLength: function maxLength(props) {
    return props.maxlength;
  }
})(_templateObject$1f || (_templateObject$1f = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n"])), fieldStyles, function (_ref) {
  var disabled = _ref.disabled;
  return !!disabled && css(_templateObject2$15 || (_templateObject2$15 = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "])));
});
// export const DisabledStyledField = styled.input`
//   ${fieldStyles};
//   background-color: ${({ theme }) => theme.colors.brand};
// `

var _excluded$c = ["handleInputChange"];
var TIME_REGEX = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
var TimeField = function TimeField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    rest = _objectWithoutProperties$1(_ref, _excluded$c);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    invalid = _useState2[0],
    setInvalid = _useState2[1];
  var onChange = function onChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    if (value === "") setInvalid(false);else setInvalid(!TIME_REGEX.test(value));
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  return /*#__PURE__*/React__default.createElement(StyledField$1, _extends({
    type: "text",
    onChange: onChange
  }, rest, {
    invalid: invalid,
    placeholder: "HH:MM"
  }));
};
TimeField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool
};
TimeField.defaultProps = {
  handleInputChange: undefined,
  showValidation: false,
  invalid: false
};

var _templateObject$1e, _templateObject2$14, _templateObject3$U, _templateObject4$M;
var SwitchBox = styled.label(_templateObject$1e || (_templateObject$1e = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 27px;\n"])));
var SwitchInput = styled.input(_templateObject2$14 || (_templateObject2$14 = _taggedTemplateLiteral(["\n  opacity: 0;\n  width: 0;\n  height: 0;\n\n  &:checked + span {\n    background-color: ", ";\n  }\n\n  &:focus + span {\n    box-shadow: 0 0 1px #2196f3;\n  }\n\n  &:checked + span:before {\n    -webkit-transform: translateX(18px);\n    -ms-transform: translateX(18px);\n    transform: translateX(18px);\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
var SwitchSlider = styled.span(_templateObject3$U || (_templateObject3$U = _taggedTemplateLiteral(["\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n\n  &:before {\n    position: absolute;\n    content: \"\";\n    height: 18px;\n    width: 18px;\n    left: 5px;\n    bottom: 5px;\n    background-color: white;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n  }\n\n  ", "\n"])), function (_ref2) {
  var rounded = _ref2.rounded;
  return !!rounded && css(_templateObject4$M || (_templateObject4$M = _taggedTemplateLiteral(["\n      border-radius: 27px;\n\n      &:before {\n        border-radius: 50%;\n      }\n    "])));
});

var SwitchField = function SwitchField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    rounded = _ref.rounded,
    name = _ref.name,
    checked = _ref.checked;
  var _onChange = function onChange(isChecked) {
    if (handleInputChange !== undefined) handleInputChange(name, isChecked);
  };
  return /*#__PURE__*/React__default.createElement(SwitchBox, {
    "class": "switch"
  }, /*#__PURE__*/React__default.createElement(SwitchInput, {
    type: "checkbox",
    onChange: function onChange(event) {
      return _onChange(event.target.checked);
    },
    checked: checked
  }), /*#__PURE__*/React__default.createElement(SwitchSlider, {
    rounded: rounded
  }));
};
SwitchField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  rounded: PropTypes.bool,
  name: PropTypes.string
};
SwitchField.defaultProps = {
  handleInputChange: undefined,
  rounded: true
};

var _templateObject$1d, _templateObject2$13, _templateObject3$T;
var StyledSpacer = styled.hr(_templateObject$1d || (_templateObject$1d = _taggedTemplateLiteral(["\n  margin: 32px 0;\n  border: none;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var transparent = _ref.transparent;
  return !transparent && css(_templateObject2$13 || (_templateObject2$13 = _taggedTemplateLiteral(["\n      border-top: 1px solid ", ";\n    "])), function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.fields.spacer;
  });
}, function (_ref3) {
  var transparent = _ref3.transparent;
  return transparent && css(_templateObject3$T || (_templateObject3$T = _taggedTemplateLiteral(["\n      border-top: none;\n    "])));
});

var Spacer = function Spacer(_ref) {
  var transparent = _ref.transparent;
  return /*#__PURE__*/React__default.createElement(StyledSpacer, {
    transparent: transparent
  });
};

var _templateObject$1c, _templateObject2$12, _templateObject3$S, _templateObject4$L, _templateObject5$z, _templateObject6$w, _templateObject7$u, _templateObject8$o, _templateObject9$m, _templateObject0$l, _templateObject1$i, _templateObject10$h, _templateObject11$h, _templateObject12$g, _templateObject13$e, _templateObject14$d, _templateObject15$d, _templateObject16$c, _templateObject17$a, _templateObject18$9, _templateObject19$8, _templateObject20$7, _templateObject21$5, _templateObject22$5, _templateObject23$5;
var TickIcon$1 = styled(FontAwesomeIcon)(_templateObject$1c || (_templateObject$1c = _taggedTemplateLiteral(["\n  color: ", ";\n  height: 1rem;\n  width: 1rem;\n  margin-left: 0.5rem;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.success;
});
var StyledTabbedForm = styled.div(_templateObject2$12 || (_templateObject2$12 = _taggedTemplateLiteral([""])));
var Nav$1 = styled.nav(_templateObject3$S || (_templateObject3$S = _taggedTemplateLiteral(["\n  gap: 32px;\n  display: none;\n  ", "\n"])), breakpoint("tablet")(_templateObject4$L || (_templateObject4$L = _taggedTemplateLiteral(["\n    display: flex;\n  "]))));
var NavItem = styled.div(_templateObject5$z || (_templateObject5$z = _taggedTemplateLiteral([""])));
var NavButton = styled.button(_templateObject6$w || (_templateObject6$w = _taggedTemplateLiteral(["\n  color: #666666;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: 500;\n  background: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  ", "\n\n  ", "\n"])), function (_ref2) {
  var selected = _ref2.selected;
  return !!selected && css(_templateObject7$u || (_templateObject7$u = _taggedTemplateLiteral(["\n      color: #333333;\n    "])));
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return !!disabled && css(_templateObject8$o || (_templateObject8$o = _taggedTemplateLiteral(["\n      color: #999999;\n    "])));
});
var NavItemSelected = styled.div(_templateObject9$m || (_templateObject9$m = _taggedTemplateLiteral(["\n  height: 4px;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 99px;\n  margin: 10px 0 0;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var TabSection = styled.div(_templateObject0$l || (_templateObject0$l = _taggedTemplateLiteral(["\n  color: black;\n"])));
var TabSections = styled.div(_templateObject1$i || (_templateObject1$i = _taggedTemplateLiteral(["\n  color: black;\n"])));

// Mobile dropdown styles
styled.div(_templateObject10$h || (_templateObject10$h = _taggedTemplateLiteral(["\n  display: none;\n  position: relative;\n\n  ", "\n"])), breakpoint("tablet", "max")(_templateObject11$h || (_templateObject11$h = _taggedTemplateLiteral(["\n    display: block;\n    margin-bottom: 16px;\n  "]))));
styled.div(_templateObject12$g || (_templateObject12$g = _taggedTemplateLiteral(["\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 12px 16px;\n  font-size: 18px;\n  font-weight: 500;\n  color: #333;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n"])));
styled.div(_templateObject13$e || (_templateObject13$e = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 110%;\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  z-index: 10;\n  max-height: 240px;\n  overflow-y: auto;\n"])));
styled.div(_templateObject14$d || (_templateObject14$d = _taggedTemplateLiteral(["\n  padding: 12px 16px;\n  font-size: 18px;\n  color: #333;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  &:hover {\n    background: #f0f8ff;\n  }\n  &.selected {\n    background: #e6f4fa;\n    font-weight: 600;\n  }\n"])));

// Show mobile dropdown only on mobile
styled.div(_templateObject15$d || (_templateObject15$d = _taggedTemplateLiteral(["\n  display: none;\n  ", "\n"])), breakpoint("tablet", "max")(_templateObject16$c || (_templateObject16$c = _taggedTemplateLiteral(["\n    display: block;\n  "]))));

// Mobile native select styles
styled.div(_templateObject17$a || (_templateObject17$a = _taggedTemplateLiteral(["\n  display: none;\n  ", "\n"])), breakpoint("tablet", "max")(_templateObject18$9 || (_templateObject18$9 = _taggedTemplateLiteral(["\n    display: block;\n    width: 100%;\n    margin-bottom: 16px;\n    position: relative;\n  "]))));
styled.select(_templateObject19$8 || (_templateObject19$8 = _taggedTemplateLiteral(["\n  width: 100%;\n  font-size: 2rem;\n  font-weight: 600;\n  color: #333;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  outline: none;\n  padding: 0 0 8px 0;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n  box-shadow: none;\n  ", "\n\n  /* Hide default arrow in some browsers */\n  &::-ms-expand {\n    display: none;\n  }\n"])), breakpoint("desktop")(_templateObject20$7 || (_templateObject20$7 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
styled.div(_templateObject21$5 || (_templateObject21$5 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 4px;\n  background: ", ";\n  border-radius: 99px;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  z-index: 1;\n  ", "\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
}, breakpoint("desktop")(_templateObject22$5 || (_templateObject22$5 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var Count = styled.div(_templateObject23$5 || (_templateObject23$5 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  border-radius: 99px;\n  padding: 4px 8px;\n  font-size: 14px;\n  font-weight: 600;\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return lighten(0.8, theme.colors.primary);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
});

var _templateObject$1b, _templateObject2$11, _templateObject3$R;
var sharedStyles = css(_templateObject$1b || (_templateObject$1b = _taggedTemplateLiteral(["\n  ", "\n  line-height: 22px;\n\n  background-color: ", ";\n  border-color: ", ";\n  margin: 0;\n\n  min-height: 3.125rem;\n  max-height: 8rem;\n\n  grid-area: 1 / 1 / 2 / 2;\n"])), fieldStyles, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.lightGrey;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.lightGrey;
});
var TextAreaWrapper = styled.div(_templateObject2$11 || (_templateObject2$11 = _taggedTemplateLiteral(["\n  display: grid;\n\n  &:after {\n    content: attr(data-replicated-value) \" \";\n    white-space: pre-wrap;\n    visibility: hidden;\n    ", "\n  }\n"])), sharedStyles);
var TextArea$1 = styled.textarea(_templateObject3$R || (_templateObject3$R = _taggedTemplateLiteral(["\n  resize: none;\n  overflow: hidden;\n  overflow-y: auto;\n  ", "\n\n  &::-webkit-scrollbar {\n    width: 0.25rem;\n    overflow: hidden;\n  }\n\n  &::-webkit-scrollbar-track {\n    margin: 0.5rem;\n    background-color: ", ";\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #d8d8d8;\n    border-radius: 0.125rem;\n  }\n"])), sharedStyles, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.lightGrey;
});

var _excluded$b = ["value", "handleInputChange"];
var TextArea = function TextArea(_ref) {
  var value = _ref.value,
    handleInputChange = _ref.handleInputChange,
    rest = _objectWithoutProperties$1(_ref, _excluded$b);
  var ref = useRef();
  var onChange = function onChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  useEffect(function () {
    ref.current.scrollTop = ref.current.scrollHeight;
  }, [value]);
  return /*#__PURE__*/React__default.createElement(TextAreaWrapper, {
    "data-replicated-value": value
  }, /*#__PURE__*/React__default.createElement(TextArea$1, _extends({
    ref: ref,
    value: value,
    onChange: onChange
  }, rest)));
};
TextArea.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  value: PropTypes.string,
  rows: PropTypes.number,
  invalid: PropTypes.bool
};
TextArea.defaultProps = {
  handleInputChange: undefined,
  showValidation: false,
  value: "",
  rows: 1,
  invalid: false
};

var _templateObject$1a, _templateObject2$10, _templateObject3$Q, _templateObject4$K, _templateObject5$y, _templateObject6$v, _templateObject7$t, _templateObject8$n, _templateObject9$l, _templateObject0$k, _templateObject1$h, _templateObject10$g, _templateObject11$g, _templateObject12$f, _templateObject13$d, _templateObject14$c, _templateObject15$c, _templateObject16$b, _templateObject17$9, _templateObject18$8, _templateObject19$7, _templateObject20$6, _templateObject21$4, _templateObject22$4, _templateObject23$4, _templateObject24$4, _templateObject25$4, _templateObject26$4, _templateObject27$4, _templateObject28$3, _templateObject29$2, _templateObject30$1, _templateObject31$1, _templateObject32$1, _templateObject33$1, _templateObject34$1, _templateObject35$1, _templateObject36$1, _templateObject37$1, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60;
var StyledDeleteButton = styled(Button$5)(_templateObject$1a || (_templateObject$1a = _taggedTemplateLiteral(["\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  color: #999 !important;\n  font-size: 14px;\n"])));
var Counter$5 = styled.span(_templateObject2$10 || (_templateObject2$10 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: white;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1rem;\n  min-height: 1rem;\n  padding: 0.25rem;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
var StyledButton$1 = styled(Button$5)(_templateObject3$Q || (_templateObject3$Q = _taggedTemplateLiteral(["\n  background-color: ", " !important;\n  fill: #fff;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #fff !important;\n  padding: 16px;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});
var H1 = styled.h1(_templateObject4$K || (_templateObject4$K = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 0.5rem;\n  font-size: 20px;\n  font-weight: 700;\n  color: ", ";\n  margin: 0;\n  letter-spacing: -1px;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});
var ActivityLogContainer = styled.div(_templateObject5$y || (_templateObject5$y = _taggedTemplateLiteral(["\n  display: flex;\n  height: calc(100vh - 14rem);\n  padding: 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  background: #f7f7f7;\n  margin-left: -1.5rem;\n  width: 100%;\n  position: relative;\n  padding-bottom: 6rem;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject6$v || (_templateObject6$v = _taggedTemplateLiteral(["\n    margin-left: 2rem;\n    border-radius: 16px;\n    padding-bottom: 24px;\n    width: 260px;\n  "]))));
var MoreOptions = styled.div(_templateObject7$t || (_templateObject7$t = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  padding: 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 8px;\n  border: 1px solid #999;\n  background: #fff;\n  color: #666;\n  font-size: 24px;\n"])));
var SidebarActions = styled.div(_templateObject8$n || (_templateObject8$n = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  justify-content: space-between;\n"])));
var Buttons = styled.div(_templateObject9$l || (_templateObject9$l = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  button {\n    white-space: normal;\n    word-break: break-word;\n  }\n"])));
var Sidebar = styled.div(_templateObject0$k || (_templateObject0$k = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject1$h || (_templateObject1$h = _taggedTemplateLiteral(["\n    gap: 24px;\n  "]))));
var Main$1 = styled.main(_templateObject10$g || (_templateObject10$g = _taggedTemplateLiteral(["\n  padding: 24px 6% 5rem;\n  padding: 24px 6vw 5rem;\n  height: 100%;\n  overflow-y: visible;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject11$g || (_templateObject11$g = _taggedTemplateLiteral(["\n    padding: 24px 24px 5rem;\n    flex: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: start;\n    gap: 0;\n    padding: 0 0 32px 26px;\n    width: calc(100% - 26px);\n    display: flex;\n\n    ", "\n  "])), function (_ref4) {
  var participantMode = _ref4.participantMode;
  return participantMode && css(_templateObject12$f || (_templateObject12$f = _taggedTemplateLiteral(["\n        margin-top: 12px;\n        padding: 0 32px 32px 26px;\n        width: calc(100% - 58px);\n      "])));
}));
var Aside = styled.aside(_templateObject13$d || (_templateObject13$d = _taggedTemplateLiteral(["\n  background-color: ", ";\n  overflow-y: auto;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
}, function (_ref6) {
  var profile = _ref6.profile;
  return !!profile && css(_templateObject14$c || (_templateObject14$c = _taggedTemplateLiteral(["\n      background-color: transparent;\n      display: none;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject15$c || (_templateObject15$c = _taggedTemplateLiteral(["\n        display: block;\n      "]))));
}, breakpoint("tablet")(_templateObject16$b || (_templateObject16$b = _taggedTemplateLiteral(["\n    width: 225px;\n    max-height: calc(100vh - ", " - 48px);\n  "])), function (_ref7) {
  var contentHeightOffset = _ref7.contentHeightOffset;
  return css(_templateObject17$9 || (_templateObject17$9 = _taggedTemplateLiteral(["\n      ", "px\n    "])), contentHeightOffset);
}), function (_ref8) {
  var participantMode = _ref8.participantMode;
  return !participantMode && css(_templateObject18$8 || (_templateObject18$8 = _taggedTemplateLiteral(["\n      padding-top: 32px;\n    "])));
});
var Content$6 = styled.div(_templateObject19$7 || (_templateObject19$7 = _taggedTemplateLiteral(["\n  user-select: text;\n  flex: 1;\n  position: relative;\n  padding-top: 8px;\n  padding-bottom: 50px;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject20$6 || (_templateObject20$6 = _taggedTemplateLiteral(["\n    overflow-y: auto;\n    padding: 0px 32px 0px 64px;\n    max-height: calc(100vh - ", " - 12px);\n  "])), function (_ref9) {
  var contentHeightOffset = _ref9.contentHeightOffset;
  return css(_templateObject21$4 || (_templateObject21$4 = _taggedTemplateLiteral(["\n      ", "px\n    "])), contentHeightOffset);
}));
var CurrentSectionTitle = styled.div(_templateObject22$4 || (_templateObject22$4 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  position: relative;\n  margin-bottom: 1rem;\n  padding: 24px 0px 0;\n  background: white;\n  z-index: 10;\n  color: ", ";\n  font-size: 22px;\n  border-bottom: 1px solid #dddddd;\n\n  ", "\n\n  ", "\n"])), function (_ref0) {
  var theme = _ref0.theme;
  return theme.colors.secondary;
}, function (_ref1) {
  var fixed = _ref1.fixed;
  return !!fixed && css(_templateObject23$4 || (_templateObject23$4 = _taggedTemplateLiteral(["\n      position: fixed;\n      top: 0;\n      left: 0;\n      padding-left: 1rem;\n    "])));
}, breakpoint("tablet")(_templateObject24$4 || (_templateObject24$4 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var CurrentSectionHighlight = styled.div(_templateObject25$4 || (_templateObject25$4 = _taggedTemplateLiteral(["\n  width: fit-content;\n  display: flex;\n  gap: 8px;\n  flex-direction: column;\n  align-items: space-between;\n"])));
var CurrentSectionHighlightText = styled.button(_templateObject26$4 || (_templateObject26$4 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  border: none;\n  background: none;\n  padding-left: 0;\n  padding-right: 0;\n"])));
var CurrentSectionChevron = styled.span(_templateObject27$4 || (_templateObject27$4 = _taggedTemplateLiteral(["\n  transition: transform 0.3s ease-in-out;\n  transform: rotate(", ");\n"])), function (_ref10) {
  var direction = _ref10.direction;
  return direction === "up" ? "180deg" : "0deg";
});
var JumpNav = styled.div(_templateObject28$3 || (_templateObject28$3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px 16px;\n  background: white;\n  border: 1px solid #e8e8e8;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 8;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n"])));
var JumpNavButton = styled.button(_templateObject29$2 || (_templateObject29$2 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  text-align: left;\n  color: ", ";\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primary;
});
var CurrentSectionHighlightBorder = styled.div(_templateObject30$1 || (_templateObject30$1 = _taggedTemplateLiteral(["\n  border: 2px solid ", ";\n  border-radius: 4px;\n  position: relative;\n  top: 2px;\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.primary;
});
var CurrentSectionHeading = styled.h2(_templateObject31$1 || (_templateObject31$1 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 20px;\n  margin: 0;\n"])));
var ContentWrapper = styled.div(_templateObject32$1 || (_templateObject32$1 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid #dddddd;\n  width: 90vw;\n  padding-bottom: 2rem;\n\n  ", "\n\n  &:not(:first-child) {\n    padding: 32px 0;\n  }\n  ", "\n\n  ", "\n"])), function (_ref13) {
  var participantMode = _ref13.participantMode;
  return !participantMode && css(_templateObject33$1 || (_templateObject33$1 = _taggedTemplateLiteral(["\n      padding: 32px 0;\n    "])));
}, breakpoint("tablet")(_templateObject34$1 || (_templateObject34$1 = _taggedTemplateLiteral(["\n    width: unset;\n  "]))), function (_ref14) {
  var skipBorder = _ref14.skipBorder;
  return !!skipBorder && css(_templateObject35$1 || (_templateObject35$1 = _taggedTemplateLiteral(["\n      border-bottom: none;\n    "])));
});
var ContentMessage = styled.div(_templateObject36$1 || (_templateObject36$1 = _taggedTemplateLiteral(["\n  line-height: 1.4;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px !important;\n  padding: 16px 18px;\n  margin-bottom: 2rem;\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return transparentize(0.9, theme.colors.primary);
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.primary;
});
var ContentSection = styled.section(_templateObject37$1 || (_templateObject37$1 = _taggedTemplateLiteral([""])));
var CloseButton$2 = styled(CloseIcon$1)(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 16px;\n  right: 32px;\n"])));
var ActivityLogs = styled.div(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  position: relative;\n  flex: 1 1 auto;\n  overflow-y: auto;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-height: 0;\n  height: 100%;\n  margin-bottom: 4rem;\n  padding-right: 1rem;\n"])));
var ActivityLog = styled.div(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n"])));
var ActivityLogAvatar = styled.img(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n"])));
var ActivityLogContent = styled.div(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  flex: 1;\n  user-select: text;\n"])));
var ActivityLogUserAction = styled.div(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  color: #333333;\n"])));
var ActivityLogTimestamp = styled.div(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  color: #888;\n  font-size: 14px;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"])));
styled.div(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  color: #222;\n  font-size: 15px;\n  margin: 8px 0;\n  line-height: 1.5;\n"])));
var ActivityLogInputContainer = styled.div(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n  flex-direction: row;\n  align-items: flex-end;\n  width: 100%;\n  max-width: 100%;\n  position: absolute;\n  border-top: 1px solid #eee;\n  padding: 16px 24px 24px 24px;\n  background: #f7f7f7;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  border-bottom-left-radius: 16px;\n  border-bottom-right-radius: 16px;\n\n  & > div:first-child {\n    width: 100%;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref17) {
  var mobileOnly = _ref17.mobileOnly;
  return mobileOnly && css(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n      display: flex;\n      position: relative;\n      padding: 0;\n      border-top: none;\n      width: 100%;\n      align-items: flex-end;\n    "])));
}, function (_ref18) {
  var desktopOnly = _ref18.desktopOnly;
  return desktopOnly && css(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n      display: none;\n    "])));
}, breakpoint("tablet")(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n    max-width: 260px;\n\n    & > div:first-child {\n      max-width: 204px !important;\n    }\n    ", "\n    ", "\n  "])), function (_ref19) {
  var mobileOnly = _ref19.mobileOnly;
  return mobileOnly && css(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n        display: none !important;\n      "])));
}, function (_ref20) {
  var desktopOnly = _ref20.desktopOnly;
  return desktopOnly && css(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n        display: flex !important;\n        align-items: flex-end;\n        max-width: 260px;\n      "])));
}));
var DropdownMenu = styled.div(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n  left: 0;\n  bottom: 110%;\n  position: absolute;\n  background: #fff;\n  border: 1px solid #e8e8e8;\n  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  min-width: 150px;\n  z-index: 9999;\n  padding: 8px 0;\n  max-height: 50vh;\n  overflow-y: auto;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n    top: 110%;\n    right: 0;\n    left: auto;\n    bottom: auto;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    max-height: none;\n    overflow-y: visible;\n  "]))));
var DropdownItem = styled.button(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n  padding: 8px 16px;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  font-weight: ", ";\n  opacity: ", ";\n  pointer-events: ", ";\n  font-size: 1rem;\n  &:hover {\n    background: #f5f5f5;\n  }\n"])), function (_ref21) {
  var variant = _ref21.variant;
  return variant === "danger" ? "bold" : "normal";
}, function (_ref22) {
  var disabled = _ref22.disabled;
  return disabled ? 0.5 : 1;
}, function (_ref23) {
  var disabled = _ref23.disabled;
  return disabled ? "none" : "auto";
});
var MoreOptionsIcon = styled.span(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var StickyMobileFooter = styled.div(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100vw;\n  background: #fff;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.07);\n  z-index: 100;\n  padding: 12px 16px;\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n"])));
var StickyFooterButton = styled(Button$5)(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n  flex: 1;\n  margin-right: 2rem;\n  padding: 12px 18px;\n"])));
var ActivityLogEmptyState = styled.div(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #bdbdbd;\n  font-size: 16px;\n  width: 100%;\n  min-height: 0;\n"])));
var WhiteBgActivityLogTextArea = styled(TextArea)(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n  background: #fff;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  flex: 1 1 0;\n  box-sizing: border-box;\n  word-break: break-all;\n  overflow-wrap: break-word;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n    max-width: 204px;\n  "]))));

var TabbedForm = function TabbedForm(_ref) {
  var _tabs$;
  var children = _ref.children,
    tabs = _ref.tabs,
    selectedTab = _ref.selectedTab,
    onTabClick = _ref.onTabClick,
    disabled = _ref.disabled;
  var _useState = useState(selectedTab || ((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key)),
    _useState2 = _slicedToArray(_useState, 2),
    currentTabKey = _useState2[0],
    setCurrentTabKey = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dropdownOpen = _useState4[0],
    setDropdownOpen = _useState4[1];
  var arrayChildren = Children.toArray(children);
  useEffect(function () {
    if (selectedTab !== undefined && selectedTab !== currentTabKey) {
      setCurrentTabKey(selectedTab);
    }
  }, [selectedTab]);
  var currentTab = tabs.find(function (tab) {
    return tab.key === currentTabKey;
  });
  var handleTabChange = function handleTabChange(tab) {
    setDropdownOpen(false);
    if (tab.onClick) {
      tab.onClick();
    } else if (onTabClick) {
      onTabClick(tab.key);
    } else {
      setCurrentTabKey(tab.key);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledTabbedForm, null, /*#__PURE__*/React__default.createElement(Nav$1, null, tabs.map(function (tab, index) {
    return /*#__PURE__*/React__default.createElement(NavItem, {
      key: "tab_nav_item_".concat(index)
    }, /*#__PURE__*/React__default.createElement(NavButton, {
      disabled: disabled,
      selected: tab.key == currentTabKey,
      onClick: function onClick() {
        return handleTabChange(tab);
      }
    }, tab.label, tab.success && /*#__PURE__*/React__default.createElement(TickIcon$1, {
      icon: faCircleCheck
    }), !!tab.count && parseInt(tab.count) > 0 && /*#__PURE__*/React__default.createElement(Count, null, tab.count)), tab.key == currentTabKey && /*#__PURE__*/React__default.createElement(NavItemSelected, null));
  })), /*#__PURE__*/React__default.createElement(CurrentSectionTitle, {
    style: {
      padding: "0"
    }
  }, /*#__PURE__*/React__default.createElement(CurrentSectionHighlight, null, /*#__PURE__*/React__default.createElement(CurrentSectionHighlightText, {
    onClick: function onClick() {
      return setDropdownOpen(!dropdownOpen);
    }
  }, /*#__PURE__*/React__default.createElement(CurrentSectionHeading, null, currentTab === null || currentTab === void 0 ? void 0 : currentTab.label), /*#__PURE__*/React__default.createElement(CurrentSectionChevron, {
    direction: dropdownOpen ? "up" : "down"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faChevronDown$2
  }))), /*#__PURE__*/React__default.createElement(CurrentSectionHighlightBorder, null), dropdownOpen && /*#__PURE__*/React__default.createElement(JumpNav, null, tabs.map(function (tab, index) {
    return /*#__PURE__*/React__default.createElement(JumpNavButton, {
      key: tab.key,
      onClick: function onClick() {
        return handleTabChange(tab);
      },
      disabled: disabled
    }, tab.label, tab.success && /*#__PURE__*/React__default.createElement(TickIcon$1, {
      icon: faCircleCheck
    }));
  })))), /*#__PURE__*/React__default.createElement(TabSections, null, arrayChildren.map(function (child, index) {
    if (!child.props.tabKey) {
      throw new Error("TabbedForm child no. ".concat(index + 1, " should be passed a 'tabKey' prop"));
    }
    return currentTabKey === child.props.tabKey && /*#__PURE__*/React__default.createElement(TabSection, {
      key: "tab_section_".concat(index)
    }, /*#__PURE__*/cloneElement(child));
  })));
};
TabbedForm.propTypes = {
  children: PropTypes.node
};

var _templateObject$19, _templateObject2$$, _templateObject3$P, _templateObject4$J, _templateObject5$x, _templateObject6$u, _templateObject7$s, _templateObject8$m, _templateObject9$k, _templateObject0$j, _templateObject1$g, _templateObject10$f, _templateObject11$f, _templateObject12$e, _templateObject13$c, _templateObject14$b, _templateObject15$b;
var A$4 = styled.a(_templateObject$19 || (_templateObject$19 = _taggedTemplateLiteral(["\n  color: ", ";\n  display: block;\n  text-decoration: none;\n  margin-top: 1rem;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
styled.div(_templateObject2$$ || (_templateObject2$$ = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n"])));
styled.span(_templateObject3$P || (_templateObject3$P = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 3rem;\n  color: #fff;\n  cursor: pointer;\n"])));
var Wrapper = styled.div(_templateObject4$J || (_templateObject4$J = _taggedTemplateLiteral(["\n  border-radius: 1rem;\n  background: ", ";\n  width: 100%;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.content.background;
});
var Div$6 = styled.div(_templateObject5$x || (_templateObject5$x = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  border-radius: 1rem;\n  margin-top: 1.5rem;\n\n  ", ";\n"])), breakpoint("tablet")(_templateObject6$u || (_templateObject6$u = _taggedTemplateLiteral(["\n    margin-top: 0;\n    flex-wrap: nowrap;\n    width: 100%;\n  "]))));
var StyledButton = styled.button(_templateObject7$s || (_templateObject7$s = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border-radius: 8px;\n  border: 1px solid #505050;\n  cursor: pointer;\n  color: #505050;\n  font-size: 16px;\n  padding: 10px 20px;\n\n  &:hover {\n    background-color: #fff;\n  }\n\n  ", "\n"])), function (_ref3) {
  var danger = _ref3.danger;
  return danger && "\n    margin-top: 1rem;\n    background-color: ".concat(function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.danger;
  }, " !important;\n    color: #fff;\n  ");
});
var TwoThirds = styled.div(_templateObject8$m || (_templateObject8$m = _taggedTemplateLiteral(["\n  padding: 0;\n  width: 100%;\n  ", ";\n  ", ";\n"])), function (_ref5) {
  var increaseHeight = _ref5.increaseHeight;
  return increaseHeight && "height: 20rem";
}, breakpoint("tablet")(_templateObject9$k || (_templateObject9$k = _taggedTemplateLiteral(["\n    padding: 2rem 0 2rem 2rem;\n  "]))));
var OneThird = styled.div(_templateObject0$j || (_templateObject0$j = _taggedTemplateLiteral(["\n  width: 100%;\n  text-align: center;\n  padding: 2rem 0 2rem 0rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject1$g || (_templateObject1$g = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref6) {
  var padding = _ref6.padding;
  return padding ? "padding: 0rem 3rem 0rem 0rem;" : "padding: 0;";
}));
var P$2 = styled.p(_templateObject10$f || (_templateObject10$f = _taggedTemplateLiteral(["\n  margin-top: 1rem;\n  margin-bottom: 0;\n  font-size: 2rem;\n  color: ", ";\n  font-size: 10rem;\n  text-align: center;\n\n  &:hover {\n    cursor: pointer;\n  }\n  ", "\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
}, breakpoint("tablet")(_templateObject11$f || (_templateObject11$f = _taggedTemplateLiteral(["\n    margin: 0;\n  "]))));
var ProgressContainer = styled.div(_templateObject12$e || (_templateObject12$e = _taggedTemplateLiteral(["\n  width: 300px;\n  margin: auto auto 1rem auto;\n"])));
var ProgressBar = styled.div(_templateObject13$c || (_templateObject13$c = _taggedTemplateLiteral(["\n  height: 4px;\n  background-color: rgba(5, 114, 206, 0.2);\n  width: 100%;\n  overflow: hidden;\n"])));
var ProgressBarValue = styled.div(_templateObject14$b || (_templateObject14$b = _taggedTemplateLiteral(["\n  width: ", "%;\n  height: 100%;\n  background-color: rgb(5, 114, 206);\n  transition: width 0.2s ease;\n"])), function (_ref8) {
  var progress = _ref8.progress;
  return progress;
});
var ProgressText = styled.p(_templateObject15$b || (_templateObject15$b = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  color: ", ";\n  text-align: center;\n  height: 1rem;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.primary;
});

var _templateObject$18, _templateObject2$_, _templateObject3$O, _templateObject4$I, _templateObject5$w, _templateObject6$t;
var DimOverlay = styled.div(_templateObject$18 || (_templateObject$18 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* 50% black for dimming */\n  z-index: 1;\n  border-radius: 15px;\n"])));
var IntroduceLabel = styled.img(_templateObject2$_ || (_templateObject2$_ = _taggedTemplateLiteral(["\n  width: 90%;\n  position: absolute;\n  top: 58%;\n  left: 52%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n"])));
var VignetteOverlay = styled.div(_templateObject3$O || (_templateObject3$O = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none; /* Allow interactions to pass through */\n  background: radial-gradient(\n    circle,\n    rgba(0, 0, 0, 0) 20%,\n    /* Transparent center */ rgba(0, 0, 0, 0) 80%,\n    /* Slightly dark mid-point */ rgba(0, 0, 0, 0.8) 100% /* Dark edges */\n  );\n  z-index: 2;\n  border-radius: 15px;\n"])));
var Icon$4 = styled.div(_templateObject4$I || (_templateObject4$I = _taggedTemplateLiteral(["\n  font-size: 4rem;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  z-index: 9999;\n  display: none;\n\n  &.play-button {\n    display: flex;\n  }\n\n  &:hover {\n    display: flex;\n  }\n"])));
var VideoContainer$1 = styled.div(_templateObject5$w || (_templateObject5$w = _taggedTemplateLiteral(["\n  position: relative;\n  width: 225px;\n  height: 400px;\n  ", "\n\n  width: ", "px;\n  height: ", "px;\n\n  iframe {\n    border: 0;\n    border-radius: 15px;\n    height: 100%;\n    width: 100%;\n  }\n"])), function (_ref) {
  var fullSize = _ref.fullSize;
  return fullSize && "height: 100%; width: 100%;";
}, function (_ref2) {
  var width = _ref2.width;
  return width;
}, function (_ref3) {
  var height = _ref3.height;
  return height;
});
var VideoWrapper$1 = styled.div(_templateObject6$t || (_templateObject6$t = _taggedTemplateLiteral(["\n  position: relative;\n  height: 400px;\n  width: 225px;\n  margin: auto;\n  cursor: pointer;\n  ", "\n\n  iframe {\n    border-radius: 15px;\n    pointer-events: none;\n  }\n\n  &:hover ", " {\n    display: flex !important;\n  }\n"])), function (_ref4) {
  var fullSize = _ref4.fullSize;
  return fullSize && "height: 100%; width: 100%;";
}, Icon$4);

var VideoPlayer = function VideoPlayer(_ref) {
  var videoId = _ref.videoId,
    onPlay = _ref.onPlay,
    displayLabel = _ref.displayLabel,
    displayEmployerLabel = _ref.displayEmployerLabel,
    fullSize = _ref.fullSize,
    videoHeight = _ref.videoHeight,
    videoWidth = _ref.videoWidth;
  var videoRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    player = _useState2[0],
    setPlayer = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isPlaying = _useState4[0],
    setIsPlaying = _useState4[1];
  var isMounted = useRef(true); // Track if the component is mounted

  var initializePlayer = useCallback(function () {
    var actualVideoId = videoId.startsWith("encoding-") ? videoId.slice(9) : videoId;
    if (actualVideoId && videoRef.current) {
      // Destroy previous player instance if it exists
      if (player) {
        player.destroy();
      }
      var newPlayer = new PlayerSdk(videoRef.current, {
        id: actualVideoId,
        hideTitle: true,
        hideControls: true
      });

      // Set initial volume to 50%
      newPlayer.setVolume(0.5);

      // Use local functions for event handlers
      var handlePlay = function handlePlay() {
        if (isMounted.current) setIsPlaying(true);
      };
      var handlePause = function handlePause() {
        if (isMounted.current) setIsPlaying(false);
      };
      newPlayer.addEventListener("play", handlePlay);
      newPlayer.addEventListener("pause", handlePause);

      // Store these handlers on the player instance for later removal
      newPlayer.customHandlers = {
        handlePlay: handlePlay,
        handlePause: handlePause
      };
      setPlayer(newPlayer);
    }
  }, [videoId]);
  useEffect(function () {
    isMounted.current = true;
    initializePlayer();

    // Cleanup when the component unmounts
    return function () {
      isMounted.current = false;
      if (player) {
        // Pause the video before destroying the player
        player.pause();
        player.destroy();
      }
    };
  }, [initializePlayer]);
  var handleClick = function handleClick() {
    if (player) {
      if (isPlaying) {
        player.pause();
      } else {
        player.play();
        if (onPlay) onPlay();
      }
    }
  };
  return /*#__PURE__*/React__default.createElement(VideoWrapper$1, {
    fullSize: fullSize,
    onClick: handleClick
  }, !isPlaying && /*#__PURE__*/React__default.createElement(DimOverlay, null), /*#__PURE__*/React__default.createElement(VideoContainer$1, {
    ref: videoRef,
    fullSize: fullSize,
    width: videoWidth,
    height: videoHeight
  }), !videoId.includes("encoding-") && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isPlaying && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icon$4, {
    className: "play-button"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCirclePlay
  })), displayLabel && /*#__PURE__*/React__default.createElement(IntroduceLabel, {
    src: "/assets/introduce.png"
  }), displayEmployerLabel && /*#__PURE__*/React__default.createElement(IntroduceLabel, {
    src: "/assets/introduce-employer.png"
  })), isPlaying && /*#__PURE__*/React__default.createElement(Icon$4, {
    className: "pause-button"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCirclePause
  }))), /*#__PURE__*/React__default.createElement(VignetteOverlay, null));
};
VideoPlayer.propTypes = {
  videoId: PropTypes.string.isRequired,
  onPlay: PropTypes.func,
  displayLabel: PropTypes.bool,
  displayEmployerLabel: PropTypes.bool,
  fullSize: PropTypes.bool
};
VideoPlayer.defaultProps = {
  onPlay: undefined,
  displayLabel: false,
  displayEmployerLabel: false,
  fullSize: false
};

var _excluded$a = ["handleInputChange", "handleRemoveVideo"],
  _excluded2$2 = ["value", "loaded"];
var ExternalVideo = function ExternalVideo(_ref) {
  var handleInputChange = _ref.handleInputChange,
    handleRemoveVideo = _ref.handleRemoveVideo,
    rest = _objectWithoutProperties$1(_ref, _excluded$a);
  var value = rest.value,
    loaded = rest.loaded,
    filteredRest = _objectWithoutProperties$1(rest, _excluded2$2);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    uploading = _useState2[0],
    setUploading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    removing = _useState4[0],
    setRemoving = _useState4[1];
  var fileInputRef = useRef(null);
  var onChange = function onChange(event) {
    event.preventDefault();
    var _event$target = event.target,
      name = _event$target.name,
      files = _event$target.files;
    if (handleInputChange !== undefined && files.length > 0) {
      setUploading(true);
      handleInputChange(name, files[0], "external_video");
    }
  };
  var handleButtonClick = function handleButtonClick() {
    fileInputRef.current.click();
  };
  var removeVideo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var name;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            name = rest.name;
            event.preventDefault();
            if (!window.confirm("Are you sure you wish to delete this video?")) {
              _context.next = 14;
              break;
            }
            _context.prev = 3;
            setRemoving(true);
            _context.next = 7;
            return handleRemoveVideo(name, value);
          case 7:
            handleInputChange(name, null, "external_video");
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            console.error(_context.t0);
          case 13:
            setRemoving(false);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10]]);
    }));
    return function removeVideo(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(Div$6, null, /*#__PURE__*/React__default.createElement(TwoThirds, null, !!value ? /*#__PURE__*/React__default.createElement(VideoPlayer, {
    videoId: value
  }) : /*#__PURE__*/React__default.createElement(P$2, {
    onClick: handleButtonClick
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCirclePlay
  }))), /*#__PURE__*/React__default.createElement(OneThird, {
    padding: !value
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    type: "file",
    ref: fileInputRef,
    onChange: onChange
  }, filteredRest, {
    accept: "video/*",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React__default.createElement(StyledButton, {
    type: "button",
    onClick: handleButtonClick
  }, "Upload Video"), !!value && /*#__PURE__*/React__default.createElement(A$4, {
    href: "#",
    onClick: removeVideo,
    disabled: removing
  }, "Remove video"))), uploading && loaded !== true && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ProgressContainer, null, /*#__PURE__*/React__default.createElement(ProgressBar, null, /*#__PURE__*/React__default.createElement(ProgressBarValue, {
    progress: loaded
  }))), /*#__PURE__*/React__default.createElement(ProgressText, null, loaded >= 100 && /*#__PURE__*/React__default.createElement("span", null, "Saving, please wait..."))), removing && /*#__PURE__*/React__default.createElement(ProgressText, {
    style: {
      margin: "0 0 20px 0"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "Removing, please wait...")));
};
ExternalVideo.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool
};
ExternalVideo.defaultProps = {
  handleInputChange: undefined,
  handleRemove: function handleRemove() {},
  showValidation: false,
  invalid: false
};

var _templateObject$17;
var AddWrapper = styled.span(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteral(["\n  color: #000;\n  display: block;\n  font-size: 1rem;\n  font-weight: 500;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  padding: 16px 24px;\n  cursor: pointer;\n\n  svg {\n    color: ", ";\n    margin-right: 0.5rem;\n    font-size: 1rem;\n  }\n\n  span {\n    width: fit-content;\n    display: flex;\n    align-items: center;\n    color: #333333;\n    font-weight: 400;\n  }\n"])), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});

var AddButton = function AddButton(_ref) {
  var onClick = _ref.onClick,
    text = _ref.text;
  return /*#__PURE__*/React__default.createElement(AddWrapper, {
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faPlus
  }), text));
};

var _templateObject$16, _templateObject2$Z, _templateObject3$N;
var StyledCurrencyWrapper = styled.div(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n"])));
var StyledCurrencySymbol = styled.span(_templateObject2$Z || (_templateObject2$Z = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  color: #333;\n  margin-left: 1rem;\n  user-select: none;\n"])));
var StyledCurrencyInput = styled.input(_templateObject3$N || (_templateObject3$N = _taggedTemplateLiteral(["\n  ", "\n  flex: 1;\n  min-width: 0;\n  padding: 12px 16px 12px 8px;\n"])), fieldStyles);

var _excluded$9 = ["symbol", "handleInputChange"];
var CurrencyField = function CurrencyField(_ref) {
  var symbol = _ref.symbol,
    handleInputChange = _ref.handleInputChange,
    rest = _objectWithoutProperties$1(_ref, _excluded$9);
  var name = rest.name,
    value = rest.value;
  var onChange = function onChange(event) {
    if (handleInputChange !== undefined) handleInputChange(name, event.target.value);
  };
  return /*#__PURE__*/React__default.createElement(StyledCurrencyWrapper, null, /*#__PURE__*/React__default.createElement(StyledCurrencySymbol, null, symbol), /*#__PURE__*/React__default.createElement(StyledCurrencyInput, _extends({
    type: "number",
    onWheel: function onWheel(event) {
      return event.target.blur();
    },
    onInput: onChange,
    defaultValue: value
  }, rest)));
};
CurrencyField.propTypes = {
  symbol: PropTypes.string.isRequired,
  handleInputChange: PropTypes.func,
  invalid: PropTypes.bool
};
CurrencyField.defaultProps = {
  handleInputChange: undefined,
  invalid: false
};

var _templateObject$15, _templateObject2$Y, _templateObject3$M;
var StyledDiv = styled.div(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteral(["\n  font-family: ", ", sans-serif;\n\n  .react-select__control {\n    border-width: 2px;\n    border-radius: 8px;\n    border-color: transparent;\n    color: #000;\n    min-height: unset;\n    box-shadow: none;\n    background: #fff;\n    padding: 4px 10px 4px 2px;\n  }\n\n  .react-select__single-value,\n  .react-select__multi-value__label {\n    color: #333;\n    font-size: 1rem;\n  }\n\n  .react-select__indicator-separator {\n    display: none;\n  }\n\n  .react-select__dropdown-indicator {\n    color: #000;\n    padding-right: 5px;\n  }\n\n  .react-select__menu {\n    z-index: 10;\n  }\n\n  .react-select__option {\n    font-size: 1rem;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    padding: 12px 16px;\n    outline-offset: 0;\n  }\n\n  .react-select__option:hover {\n    background: #f2f2f2;\n    color: #000;\n  }\n\n  .react-select__placeholder {\n    color: #000;\n  }\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.fonts.body.family;
}, function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$Y || (_templateObject2$Y = _taggedTemplateLiteral(["\n    .react-select__control.react-select__control--is-invalid {\n      border-color: ", ";\n      background-color: ", ";\n      color: ", ";\n    }\n    .react-select__single-value.react-select__single-value--is-invalid {\n      color: ", ";\n    }\n  "])), darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger), mix(0.95, "#fff", theme.colors.danger), darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger), darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger));
}, function (_ref2) {
  var simpleForm = _ref2.simpleForm;
  return !!simpleForm && css(_templateObject3$M || (_templateObject3$M = _taggedTemplateLiteral(["\n      .react-select__control {\n        padding: 5px 10px 5px 16px;\n        border: 1px solid #e6e6e6;\n      }\n      .react-select__value-container {\n        padding: 0 10px 0 0;\n      }\n    "])));
});

var _excluded$8 = ["handleInputChange", "options", "simpleForm", "searchOptions", "invalid", "value"];
var SearchSelect = function SearchSelect(_ref) {
  var handleInputChange = _ref.handleInputChange;
    _ref.options;
    var simpleForm = _ref.simpleForm,
    searchOptions = _ref.searchOptions,
    invalid = _ref.invalid,
    value = _ref.value,
    rest = _objectWithoutProperties$1(_ref, _excluded$8);
  var onChange = function onChange(selectedOption) {
    handleInputChange(rest.name, selectedOption.value);
  };
  return /*#__PURE__*/React__default.createElement(StyledDiv, {
    simpleForm: simpleForm,
    invalid: invalid
  }, /*#__PURE__*/React__default.createElement(ReactSelect, {
    options: searchOptions,
    onChange: onChange,
    classNamePrefix: "react-select",
    value: searchOptions.find(function (option) {
      return option.value === value || option.label === value;
    }) || null
  }));
};
SearchSelect.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  simpleForm: PropTypes.bool,
  invalid: PropTypes.bool
};

var _templateObject$14, _templateObject2$X;
var fieldTypes$1 = {
  text: TextField,
  textarea: TextArea$2,
  radio: RadioButtons,
  select: SelectField,
  date: DateField,
  default_date: DefaultDateField,
  checkbox: Checkboxes,
  large_textarea: LargeTextArea,
  multi_text: MultiTextField,
  url: TextField,
  multi_select: MultiSelectField,
  number: NumberField,
  external_video: ExternalVideo,
  password: PasswordField
};
var maxLength = 99999;
var retrieveFieldType = function retrieveFieldType(fieldType, customComponents) {
  if (Object.keys(customComponents).includes(fieldType)) return customComponents[fieldType];else if (Object.keys(fieldTypes$1).includes(fieldType)) return fieldTypes$1[fieldType];else return fieldTypes$1["text"];
};
var CharP = styled(P$4)(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteral(["\n  margin-top: 0.25rem;\n\n  ", "\n"])), function (_ref) {
  var simpleForm = _ref.simpleForm;
  return !!simpleForm && css(_templateObject2$X || (_templateObject2$X = _taggedTemplateLiteral(["\n      font-weight: 400;\n      font-size: 0.9rem;\n      color: ", ";\n      margin-top: 0.5rem;\n    "])), function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.fields.hint;
  });
});
var Field = function Field(_ref3) {
  var name = _ref3.name,
    label = _ref3.label,
    required = _ref3.required,
    invalid = _ref3.invalid,
    field_options = _ref3.field_options,
    field_type = _ref3.field_type,
    character_limit = _ref3.character_limit,
    dependent_on = _ref3.dependent_on,
    dependent_value = _ref3.dependent_value,
    stateValue = _ref3.stateValue,
    handleInputChange = _ref3.handleInputChange,
    show = _ref3.show,
    fieldsetLegend = _ref3.fieldsetLegend,
    customFieldComponents = _ref3.customFieldComponents,
    hint = _ref3.hint,
    simpleForm = _ref3.simpleForm,
    loaded = _ref3.loaded,
    handleRemoveVideo = _ref3.handleRemoveVideo;
  var FieldType = retrieveFieldType(field_type, customFieldComponents);
  var _useState = useState(invalid),
    _useState2 = _slicedToArray(_useState, 2),
    invalidValue = _useState2[0],
    setInvalid = _useState2[1];
  var options = field_options.map(function (option) {
    return [option.name, option.name];
  });
  if (field_type === "multi_select") {
    options = field_options.map(function (option) {
      return {
        label: option.name,
        value: option.name
      };
    });
    stateValue = stateValue === "" ? [] : stateValue;
  } else {
    stateValue = !!stateValue ? stateValue : "";
  }
  var onInputChange = function onInputChange(fieldName, value) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (handleInputChange !== undefined) handleInputChange(fieldName, value, type);
    if (character_limit) calculateCharactersRemaining(value.length);
    if (invalidValue) setInvalid(false);
  };
  var _useState3 = useState(character_limit - stateValue.length),
    _useState4 = _slicedToArray(_useState3, 2),
    charactersRemaining = _useState4[0],
    setCharactersRemaining = _useState4[1];
  var calculateCharactersRemaining = function calculateCharactersRemaining(characterCount) {
    return setCharactersRemaining(character_limit - characterCount);
  };
  var showCharacterLimit = function showCharacterLimit() {
    if (!["text", "textarea", "large_textarea"].includes(field_type)) return false;
    if (parseInt(character_limit).isNaN) return false;
    if (parseInt(character_limit) < 1) return false;
    return true;
  };
  var showLabel = true;
  if (label === fieldsetLegend) showLabel = false;
  return /*#__PURE__*/React__default.createElement(FieldGroup, {
    show: show,
    "data-dependent-on": dependent_on,
    "data-dependent-value": dependent_value,
    simpleForm: simpleForm
  }, showLabel && /*#__PURE__*/React__default.createElement(Label$1, {
    invalid: invalidValue,
    simpleForm: simpleForm
  }, label, !!required && " *"), /*#__PURE__*/React__default.createElement(FieldType, {
    name: name,
    multiSelect: field_type === "multi_select",
    value: stateValue,
    placeholder: dependent_on ? label : null,
    required: dependent_on ? false : required,
    requiredField: required,
    options: options,
    maxLength: character_limit < 1 ? maxLength : character_limit,
    handleInputChange: onInputChange,
    invalid: invalidValue,
    hint: hint,
    simpleForm: simpleForm,
    loaded: loaded,
    handleRemoveVideo: handleRemoveVideo
  }), showCharacterLimit() && /*#__PURE__*/React__default.createElement(CharP, {
    simpleForm: simpleForm,
    align: "right",
    size: "small",
    marginless: true
  }, "".concat(charactersRemaining, " characters remaining")));
};
Field.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  invalid: PropTypes.bool,
  field_options: PropTypes.array,
  field_type: PropTypes.string,
  character_limit: PropTypes.number,
  dependent_on: PropTypes.string,
  dependent_value: PropTypes.string,
  stateValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  handleInputChange: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  customFieldComponents: PropTypes.object
};
Field.defaultProps = {
  name: "",
  label: "",
  required: false,
  invalid: false,
  field_options: [],
  field_type: "text",
  character_limit: 0,
  dependent_on: "",
  dependent_value: "Yes",
  stateValue: "",
  handleInputChange: undefined,
  show: false,
  customFieldComponents: {}
};

var Fieldset$1 = function Fieldset(_ref) {
  var name = _ref.name,
    legend = _ref.legend,
    content = _ref.content,
    showVideoHint = _ref.showVideoHint,
    videoUrl = _ref.videoUrl,
    fields = _ref.fields,
    formState = _ref.formState,
    handleInputChange = _ref.handleInputChange,
    customFieldComponents = _ref.customFieldComponents,
    simpleForm = _ref.simpleForm,
    last = _ref.last,
    handleRemoveVideo = _ref.handleRemoveVideo;
  var onInputChange = function onInputChange(fieldName, value) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (handleInputChange !== undefined) handleInputChange(name, fieldName, value, type);
  };
  var showField = function showField(_ref2) {
    var dependent_on = _ref2.dependent_on,
      dependent_value = _ref2.dependent_value;
    if (dependent_on === "") return true;else return formState[name][dependent_on] === dependent_value;
  };
  return /*#__PURE__*/React__default.createElement(Fieldset$2, {
    name: name,
    legendText: legend,
    content: content,
    showVideoHint: showVideoHint,
    videoUrl: videoUrl,
    simpleForm: simpleForm,
    last: last
  }, fields.map(function (field) {
    return /*#__PURE__*/React__default.createElement(Field, _extends({
      key: "".concat(name, "_").concat(field.name)
    }, field, {
      fieldsetLegend: legend,
      stateValue: formState[name][field.name],
      handleInputChange: onInputChange,
      show: showField(field),
      customFieldComponents: customFieldComponents,
      simpleForm: simpleForm,
      loaded: formState[name]["loaded"],
      handleRemoveVideo: handleRemoveVideo
    }));
  }));
};
Fieldset$1.propTypes = {
  name: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  content: PropTypes.string,
  videoUrl: PropTypes.string,
  fields: PropTypes.array,
  formState: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  customFieldComponents: PropTypes.object
};
Fieldset$1.defaultProps = {
  fields: [],
  formState: {},
  handleInputChange: undefined,
  customFieldComponents: {}
};

var ApplicationForm = function ApplicationForm(_ref) {
  _ref.id;
    var name = _ref.name,
    fieldsets = _ref.fieldsets,
    formState = _ref.formState,
    handleInputChange = _ref.handleInputChange,
    handleSubmit = _ref.handleSubmit,
    submitting = _ref.submitting,
    customFieldComponents = _ref.customFieldComponents,
    simpleForm = _ref.simpleForm,
    handleRemoveVideo = _ref.handleRemoveVideo;
  return /*#__PURE__*/React__default.createElement(Form$1, {
    simpleForm: simpleForm
  }, fieldsets.filter(function (fieldset) {
    return fieldset.fields.length > 0;
  }).map(function (fieldset, index) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Fieldset$1, _extends({
      key: "".concat(name, "_").concat(fieldset.name)
    }, fieldset, {
      formState: formState,
      handleInputChange: handleInputChange,
      customFieldComponents: customFieldComponents,
      simpleForm: simpleForm,
      last: index + 1 == fieldsets.length,
      handleRemoveVideo: handleRemoveVideo
    })), simpleForm && index + 1 < fieldsets.length && /*#__PURE__*/React__default.createElement(Spacer, null));
  }), /*#__PURE__*/React__default.createElement(SubmitButton, {
    handleClick: handleSubmit,
    disabled: submitting,
    simpleForm: simpleForm
  }));
};
ApplicationForm.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  fieldsets: PropTypes.array.isRequired,
  formState: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  customFieldComponents: PropTypes.object
};
ApplicationForm.defaultProps = {
  fieldsets: [],
  formState: {},
  handleInputChange: undefined,
  handleSubmit: undefined,
  customFieldComponents: {}
};

var _templateObject$13;
var getDegFromDirection = function getDegFromDirection(direction) {
  switch (direction) {
    case "up":
      return "270deg";
    case "down":
      return "90deg";
    case "left":
      return "180deg";
    default:
      return "0deg";
  }
};
var getSize$1 = function getSize(size) {
  switch (size) {
    case "small":
      return "1rem";
    case "medium":
      return "1.5rem";
    case "large":
      return "1.75rem";
    default:
      return "1.25rem";
  }
};
var getColor$1 = function getColor(color) {
  switch (color) {
    case "primary":
      return function (props) {
        return props.theme.colors.primary;
      };
    case "secondary":
      return function (props) {
        return props.theme.colors.secondary;
      };
    case "current":
      return "currentColor";
    default:
      return function (props) {
        return props.theme.colors.body;
      };
  }
};
var Icon$3 = styled.svg(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  transform: rotate(", ");\n  width: ", ";\n  height: ", ";\n  fill: ", ";\n  transition: transform 0.3s ease-in-out;\n"])), function (_ref) {
  var direction = _ref.direction;
  return getDegFromDirection(direction);
}, function (_ref2) {
  var size = _ref2.size;
  return getSize$1(size);
}, function (_ref3) {
  var size = _ref3.size;
  return getSize$1(size);
}, function (_ref4) {
  var color = _ref4.color;
  return getColor$1(color);
});

var Arrow = function Arrow(props) {
  return /*#__PURE__*/React__default.createElement(Icon$3, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 451.846 451.847",
    enableBackground: "new 0 0 451.846 451.847",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
    d: "M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744,L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284,c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"
  })), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};
Arrow.propTypes = {
  direction: PropTypes.oneOf(["up", "right", "down", "left"]),
  color: PropTypes.oneOf(["default", "primary", "secondary", "current"]),
  size: PropTypes.oneOf(["small", "default", "medium", "large"])
};
Arrow.defaultProps = {
  direction: "right",
  color: "default",
  size: "default"
};

var _templateObject$12, _templateObject2$W, _templateObject3$L, _templateObject4$H, _templateObject5$v, _templateObject6$s, _templateObject7$r, _templateObject8$l, _templateObject9$j, _templateObject0$i, _templateObject1$f, _templateObject10$e, _templateObject11$e, _templateObject12$d, _templateObject13$b;
var LeftArrow = styled(Arrow)(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteral(["\n  text-align: left;\n  font-weight: bold;\n  cursor: pointer;\n  display: inline-block;\n  width: 50%;\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.disabled && css(_templateObject2$W || (_templateObject2$W = _taggedTemplateLiteral(["\n      pointer-events: none;\n      opacity: 0.5;\n    "])));
}, breakpoint("tablet")(_templateObject3$L || (_templateObject3$L = _taggedTemplateLiteral(["\n    display: block;\n    width: unset;\n  "]))));
var RightArrow = styled(Arrow)(_templateObject4$H || (_templateObject4$H = _taggedTemplateLiteral(["\n  text-align: right;\n  font-weight: bold;\n  cursor: pointer;\n  display: inline-block;\n  width: 50%;\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.disabled && css(_templateObject5$v || (_templateObject5$v = _taggedTemplateLiteral(["\n      pointer-events: none;\n      opacity: 0.5;\n    "])));
}, breakpoint("tablet")(_templateObject6$s || (_templateObject6$s = _taggedTemplateLiteral(["\n    display: block;\n    width: unset;\n  "]))));
var Timeslot = styled.button(_templateObject7$r || (_templateObject7$r = _taggedTemplateLiteral(["\n  appearance: none;\n  padding: 0.5rem 1.75rem;\n  border-radius: 0.5rem;\n  border: ", ";\n  box-shadow: none;\n  font-size: 0.8rem;\n  font-weight: bold;\n  font-family: ", ", sans-serif;\n  color: #fff;\n  background-color: ", ";\n  margin: 0;\n  text-decoration: none;\n  text-align: center;\n  box-sizing: border-box;\n  cursor: pointer;\n  white-space: nowrap;\n  min-height: 38px;\n  min-width: 6rem;\n\n  background-color: ", ";\n  background-color: ", ";\n  opacity: ", ";\n  opacity: ", ";\n\n  color: ", ";\n  color: ", ";\n\n  &:not([disabled]):hover {\n    color: #000;\n    background-color: #fff;\n    opacity: 0.8;\n  }\n\n  &[disabled],\n  &:disabled {\n    pointer-events: none;\n  }\n"])), function (_ref) {
  var selected = _ref.selected;
  return !!selected ? "transparent" : "2px solid #fff";
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.body.family;
}, function (_ref3) {
  var selected = _ref3.selected,
    theme = _ref3.theme;
  return !!selected ? theme.colors.availability.booked : "transparent";
}, function (props) {
  return props.booked_slot ? function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.availability.booked + " !important";
  } : "";
}, function (props) {
  return props.selected_slot ? function (_ref5) {
    _ref5.theme;
    return "#fff";
  } : "";
}, function (props) {
  return props.restricted_slot || props.booked_elsewhere_slot ? 0.3 : "";
}, function (props) {
  return props.selected ? 1 + " !important" : "";
}, function (props) {
  return props.booked_slot ? "#fff !important" : "";
}, function (props) {
  return props.selected_slot ? function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.secondaryAlternative || theme.colors.secondary;
  } : "";
});
styled.div(_templateObject8$l || (_templateObject8$l = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  margin-left: 0;\n  margin-bottom: 2rem;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject9$j || (_templateObject9$j = _taggedTemplateLiteral(["\n    margin-left: 2rem;\n  "]))));
var Ul$1 = styled.ul(_templateObject0$i || (_templateObject0$i = _taggedTemplateLiteral(["\n  list-style-type: none;\n  padding: 0;\n"])));
var Li$1 = styled.li(_templateObject1$f || (_templateObject1$f = _taggedTemplateLiteral(["\n  color: #fff;\n  display: inline;\n  font-weight: 400;\n  font-family: ", ", sans-serif;\n  font-size: 0.8rem;\n  margin-right: 1rem;\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.fonts.body.family;
});
var BoxNotSelected = styled.span(_templateObject10$e || (_templateObject10$e = _taggedTemplateLiteral(["\n  border: 2px solid #fff;\n  border-radius: 4px;\n  background: transparent;\n  display: table-cell;\n  height: 12px;\n  width: 12px;\n"])));
var BoxSelected = styled.span(_templateObject11$e || (_templateObject11$e = _taggedTemplateLiteral(["\n  border-radius: 4px;\n  border: 2px solid #fff;\n  background: #fff;\n  display: table-cell;\n  height: 12px;\n  width: 12px;\n"])));
var BoxBooked = styled.span(_templateObject12$d || (_templateObject12$d = _taggedTemplateLiteral(["\n  border-radius: 5px;\n  border: 2px solid ", ";\n  background-color: ", ";\n  display: table-cell;\n  height: 12px;\n  width: 12px;\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.availability.booked;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.availability.booked;
});
var SpinnerContainer = styled.div(_templateObject13$b || (_templateObject13$b = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  font-size: 28px;\n  color: ", ";\n"])), function (_ref0) {
  var theme = _ref0.theme;
  return theme.colors.body;
});

var _templateObject$11, _templateObject2$V, _templateObject3$K;
function getColorFromVariant(variant, theme) {
  switch (variant) {
    case "primary":
      return theme.colors.primary;
    case "secondary":
      return theme.colors.secondary;
    default:
      return "white";
  }
}
var Container$t = styled.div(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  width: 80px;\n  height: 80px;\n"])));
var circleStyles = css(_templateObject2$V || (_templateObject2$V = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  animation: spin 1.2s linear infinite;\n  box-sizing: border-box;\n\n  @keyframes spin {\n    0%,\n    20%,\n    80%,\n    100% {\n      transform: scale(1);\n    }\n\n    50% {\n      transform: scale(1.5);\n    }\n  }\n\n  &:nth-child(1) {\n    animation-delay: 0s;\n    top: 37px;\n    left: 66px;\n  }\n\n  &:nth-child(2) {\n    animation-delay: -0.1s;\n    top: 22px;\n    left: 62px;\n  }\n\n  &:nth-child(3) {\n    animation-delay: -0.2s;\n    top: 11px;\n    left: 52px;\n  }\n\n  &:nth-child(4) {\n    animation-delay: -0.3s;\n    top: 7px;\n    left: 37px;\n  }\n\n  &:nth-child(5) {\n    animation-delay: -0.4s;\n    top: 11px;\n    left: 22px;\n  }\n\n  &:nth-child(6) {\n    animation-delay: -0.5s;\n    top: 22px;\n    left: 11px;\n  }\n\n  &:nth-child(7) {\n    animation-delay: -0.6s;\n    top: 37px;\n    left: 7px;\n  }\n\n  &:nth-child(8) {\n    animation-delay: -0.7s;\n    top: 52px;\n    left: 11px;\n  }\n\n  &:nth-child(9) {\n    animation-delay: -0.8s;\n    top: 62px;\n    left: 22px;\n  }\n\n  &:nth-child(10) {\n    animation-delay: -0.9s;\n    top: 66px;\n    left: 37px;\n  }\n\n  &:nth-child(11) {\n    animation-delay: -1s;\n    top: 62px;\n    left: 52px;\n  }\n\n  &:nth-child(12) {\n    animation-delay: -1.1s;\n    top: 52px;\n    left: 62px;\n  }\n"])));
var Circle$1 = styled.div(_templateObject3$K || (_templateObject3$K = _taggedTemplateLiteral(["\n  background-color: ", ";\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
    theme = _ref.theme;
  return getColorFromVariant(variant, theme);
}, circleStyles);

var LoadingSpinner = function LoadingSpinner(_ref) {
  var variant = _ref.variant;
  return /*#__PURE__*/React__default.createElement(Container$t, null, _toConsumableArray(Array(12).keys()).map(function (i) {
    return /*#__PURE__*/React__default.createElement(Circle$1, {
      variant: variant,
      key: "spinner_circle_".concat(i)
    });
  }));
};
LoadingSpinner.propTypes = {
  variant: PropTypes.oneOf(["default", "primary", "secondary"])
};
LoadingSpinner.defaultProps = {
  variant: "default"
};

var Moment = function Moment(_ref) {
  var value = _ref.value,
    blank = _ref.blank,
    format = _ref.format,
    tz = _ref.tz;
  if (value && tz) return moment$1(value).tz(tz).format(format);else if (value) return moment$1(value).format(format);else return blank;
};
Moment.propTypes = {
  value: PropTypes.string,
  blank: PropTypes.string,
  format: PropTypes.string,
  tz: PropTypes.string
};
Moment.defaultProps = {
  value: null,
  blank: null,
  format: "DD MMMM YYYY",
  tz: null
};

var AvailabilityGrid = function AvailabilityGrid(_ref) {
  var groupedTimeslots = _ref.groupedTimeslots,
    selected = _ref.selected,
    setSelected = _ref.setSelected,
    handlePreviousWeek = _ref.handlePreviousWeek,
    handleNextWeek = _ref.handleNextWeek,
    timezone = _ref.timezone,
    gridArea = _ref.gridArea,
    disable_timeslot = _ref.disable_timeslot,
    loaded = _ref.loaded,
    recurring = _ref.recurring,
    handleClearAvailability = _ref.handleClearAvailability,
    showRecurringButton = _ref.showRecurringButton,
    showClearButton = _ref.showClearButton,
    wc = _ref.wc,
    submitting = _ref.submitting;
  var _useState = useState({
      timestamp: null,
      group: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    lastSelected = _useState2[0],
    setLastSelected = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragging = _useState4[0],
    setDragging = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    adding = _useState6[0],
    setAdding = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    deleting = _useState8[0],
    setDeleting = _useState8[1];
  var findSlotAndGroup = function findSlotAndGroup(timestamp) {
    var _iterator = _createForOfIteratorHelper(groupedTimeslots),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var group = _step.value;
        var slot = group.timeslots.find(function (slot) {
          return slot.timestamp === timestamp;
        });
        if (slot) return {
          slot: slot,
          group: group
        };
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return {
      slot: null,
      group: null
    };
  };

  // Handle selection by Click+Drag
  var updateSelection = function updateSelection(startTimestamp, endTimestamp) {
    var _findSlotAndGroup = findSlotAndGroup(startTimestamp),
      startSlot = _findSlotAndGroup.slot,
      startGroup = _findSlotAndGroup.group;
    var _findSlotAndGroup2 = findSlotAndGroup(endTimestamp),
      endSlot = _findSlotAndGroup2.slot,
      endGroup = _findSlotAndGroup2.group;
    if (startSlot && endSlot) {
      var newSelected = new Set(selected);
      var startGroupIndex = groupedTimeslots.findIndex(function (g) {
        return g.date === startGroup.date;
      });
      var endGroupIndex = groupedTimeslots.findIndex(function (g) {
        return g.date === endGroup.date;
      });

      // If the start and end timeslots are in the same group
      if (startGroupIndex === endGroupIndex) {
        var group = groupedTimeslots[startGroupIndex];
        var startIndex = Math.min(group.timeslots.indexOf(startSlot), group.timeslots.indexOf(endSlot));
        var endIndex = Math.max(group.timeslots.indexOf(startSlot), group.timeslots.indexOf(endSlot));

        // This checks what the first timeslot clicked was
        if (Math.abs(startIndex - endIndex) === 1) {
          // If first timeslot clicked was just de-selected - add timeslots, otherwise, delete
          if (selected.includes(lastSelected.timestamp)) {
            setAdding(false);
            setDeleting(true);
            newSelected["delete"](lastSelected.timestamp);
          } else {
            setAdding(true);
            setDeleting(false);
            newSelected.add(lastSelected.timestamp);
          }
        }
        if (deleting) {
          for (var i = startIndex; i <= endIndex; i++) {
            var ts = group.timeslots[i].timestamp;
            // If the selected timeslots are all re-selected, deselect them
            newSelected["delete"](ts);

            // Ensure lastSelected is delselected if it is in the range
            if (newSelected.has(lastSelected.timestamp)) {
              newSelected["delete"](lastSelected.timestamp);
            }
          }
        } else if (adding) {
          for (var _i = startIndex; _i <= endIndex; _i++) {
            newSelected.add(group.timeslots[_i].timestamp);
          }
        }
      } else {
        // Handle selection across multiple groups
        if (!adding && selected.includes(lastSelected.timestamp)) {
          setDeleting(true);
          setAdding(false);
        } else if (!deleting) {
          setAdding(true);
        }
        for (var _i2 = startGroupIndex; _i2 <= endGroupIndex; _i2++) {
          var _group = groupedTimeslots[_i2];
          var _startIndex = _i2 === startGroupIndex ? _group.timeslots.findIndex(function (ts) {
            return ts.timestamp === lastSelected.timestamp;
          }) : 0;
          var _endIndex = _i2 === endGroupIndex ? _group.timeslots.findIndex(function (ts) {
            return ts.timestamp === endTimestamp;
          }) : _group.timeslots.length - 1;
          for (var j = _startIndex; j <= _endIndex; j++) {
            var _ts = _group.timeslots[j].timestamp;
            if (adding) {
              newSelected.add(_ts);
            } else {
              newSelected["delete"](_ts);
            }
          }
        }
      }
      setSelected(Array.from(newSelected));
    }
  };

  // Handle selection by Shift+Click or one-click
  var toggleTimeslot = function toggleTimeslot(event, timestamp) {
    event.preventDefault();
    var shiftKey = event.shiftKey;
    var _findSlotAndGroup3 = findSlotAndGroup(timestamp),
      slot = _findSlotAndGroup3.slot,
      group = _findSlotAndGroup3.group;
    if (shiftKey && lastSelected && lastSelected.timestamp !== null) {
      // If Shift is pressed, handle range selection
      var _findSlotAndGroup4 = findSlotAndGroup(lastSelected.timestamp),
        lastSlot = _findSlotAndGroup4.slot,
        lastGroup = _findSlotAndGroup4.group;
      if (lastSlot && slot) {
        var startGroupIndex = groupedTimeslots.findIndex(function (g) {
          return g.date === lastGroup.date;
        });
        var endGroupIndex = groupedTimeslots.findIndex(function (g) {
          return g.date === group.date;
        });
        var newSelected = new Set(selected);
        if (startGroupIndex === endGroupIndex) {
          // Both timeslots are in the same group
          var currentGroup = groupedTimeslots[startGroupIndex];
          var startIndex = Math.min(currentGroup.timeslots.indexOf(lastSlot), currentGroup.timeslots.indexOf(slot));
          var endIndex = Math.max(currentGroup.timeslots.indexOf(lastSlot), currentGroup.timeslots.indexOf(slot));

          // If the selected timeslots are all re-selected, deselect them
          var allSelected = currentGroup.timeslots.slice(startIndex, endIndex + 1).filter(function (ts) {
            return ts.timestamp !== lastSelected.timestamp;
          }).every(function (ts) {
            return newSelected.has(ts.timestamp);
          });
          for (var i = startIndex; i <= endIndex; i++) {
            var ts = currentGroup.timeslots[i].timestamp;
            if (allSelected) {
              newSelected["delete"](ts); // Deselect if already selected
            } else {
              newSelected.add(ts); // Select if not already selected
            }
          }
        } else {
          // Add timeslots if first selected was blank - delete timeslots if first and last was selected
          var endTimestampSelected = selected.includes(slot.timestamp);
          var _adding = selected.includes(lastSelected.timestamp) || !endTimestampSelected;
          // Handle selection across multiple groups
          for (var _i3 = startGroupIndex; _i3 <= endGroupIndex; _i3++) {
            var _group2 = groupedTimeslots[_i3];
            var _startIndex2 = _i3 === startGroupIndex ? _group2.timeslots.findIndex(function (ts) {
              return ts.timestamp === lastSelected.timestamp;
            }) : 0;
            var _endIndex2 = _i3 === endGroupIndex ? _group2.timeslots.findIndex(function (ts) {
              return ts.timestamp === timestamp;
            }) : _group2.timeslots.length - 1;
            for (var j = _startIndex2; j <= _endIndex2; j++) {
              var _ts2 = _group2.timeslots[j].timestamp;
              if (_adding) {
                newSelected.add(_ts2);
              } else {
                newSelected["delete"](_ts2);
              }
            }
          }
        }
        setSelected(Array.from(newSelected));
      }
    } else {
      // Handle single selection (without Shift)
      if (isSelected(timestamp)) {
        setSelected(selected.filter(function (x) {
          return x !== timestamp;
        }));
      } else {
        setSelected([].concat(_toConsumableArray(selected), [timestamp]));
      }
      setLastSelected({
        timestamp: timestamp,
        group: group
      });
    }
  };
  var handleMouseDown = function handleMouseDown(event, timestamp) {
    event.preventDefault();
    if (!event.shiftKey) {
      var _findSlotAndGroup5 = findSlotAndGroup(timestamp),
        group = _findSlotAndGroup5.group;
      setDragging(true);
      setLastSelected({
        timestamp: timestamp,
        group: group
      });
    }
  };
  var handleMouseUp = function handleMouseUp(event) {
    event.preventDefault();
    if (dragging) {
      setDeleting(false);
      setAdding(false);
      setDragging(false);
      setLastSelected(null); // Reset lastSelected after dragging is complete
    }
  };
  var handleMouseEnter = function handleMouseEnter(event, timestamp) {
    if (dragging) {
      event.preventDefault();
      updateSelection(lastSelected.timestamp, timestamp);
    }
  };
  var previousWeek = function previousWeek(event) {
    event.preventDefault();
    if (handlePreviousWeek !== undefined) handlePreviousWeek();
  };
  var nextWeek = function nextWeek(event) {
    event.preventDefault();
    if (handleNextWeek !== undefined) handleNextWeek();
  };
  var isSelected = function isSelected(timestamp) {
    return selected.includes(timestamp);
  };
  return /*#__PURE__*/React__default.createElement(Card$1, {
    variant: "primary",
    gridArea: gridArea,
    id: "availability_grid"
  }, submitting && /*#__PURE__*/React__default.createElement(SpinnerContainer, null, /*#__PURE__*/React__default.createElement(LoadingSpinner, {
    variant: "default"
  }), /*#__PURE__*/React__default.createElement("span", null, "Saving...")), !submitting && /*#__PURE__*/React__default.createElement(Grid$1, null, !!loaded && /*#__PURE__*/React__default.createElement(Grid$1, {
    template: "'left right' 1fr / 1fr",
    placeItems: "baseline"
  }, /*#__PURE__*/React__default.createElement(Ul$1, null, /*#__PURE__*/React__default.createElement(Li$1, null, /*#__PURE__*/React__default.createElement(BoxNotSelected, null), " Not selected"), /*#__PURE__*/React__default.createElement(Li$1, null, /*#__PURE__*/React__default.createElement(BoxSelected, null), " Selected"), !recurring && /*#__PURE__*/React__default.createElement(Li$1, null, /*#__PURE__*/React__default.createElement(BoxBooked, null), " Booked")), /*#__PURE__*/React__default.createElement(Grid$1, {
    template: "'left right' / 1fr auto",
    placeItems: "end",
    gap: showClearButton && showRecurringButton ? "inherit" : 0
  }, showRecurringButton && /*#__PURE__*/React__default.createElement(Button$5, {
    href: "/recurring-interview-availability",
    size: "small"
  }, "Manage Recurring Availability"), showClearButton && /*#__PURE__*/React__default.createElement(Button$5, {
    onClick: handleClearAvailability,
    size: "small",
    variant: "danger"
  }, "Clear All Availability"))), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1rem",
    grid: "auto / auto-flow",
    placeContent: "space-between"
  }, !recurring ? /*#__PURE__*/React__default.createElement(LeftArrow, {
    direction: "left",
    onClick: previousWeek,
    disabled: handlePreviousWeek === undefined || wc < 1
  }) : /*#__PURE__*/React__default.createElement("div", null), !!loaded && groupedTimeslots.map(function (_ref2) {
    var date = _ref2.date,
      timeslots = _ref2.timeslots;
    return /*#__PURE__*/React__default.createElement(Grid$1, {
      key: date,
      gap: "0.5rem",
      placeContent: "start center",
      placeItems: "start center"
    }, /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      bold: true,
      align: "center"
    }, recurring ? /*#__PURE__*/React__default.createElement(Moment, {
      value: date,
      format: "ddd"
    }) : /*#__PURE__*/React__default.createElement(Moment, {
      value: date,
      format: "ddd D MMM"
    })), /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "0.25rem"
    }, timeslots.map(function (_ref3) {
      var timestamp = _ref3.timestamp,
        restricted = _ref3.restricted,
        booked = _ref3.booked,
        booked_elsewhere = _ref3.booked_elsewhere;
      return /*#__PURE__*/React__default.createElement(Timeslot, {
        key: timestamp,
        disabled: restricted || booked || booked_elsewhere || disable_timeslot,
        selected: (!!isSelected(timestamp) || booked) && !restricted,
        onClick: function onClick(event) {
          return toggleTimeslot(event, timestamp);
        },
        booked_slot: !!booked && !restricted,
        booked_elsewhere_slot: !!booked_elsewhere && !restricted,
        restricted_slot: !!restricted,
        selected_slot: !!isSelected(timestamp) && !restricted,
        onMouseDown: function onMouseDown(event) {
          return handleMouseDown(event, timestamp);
        },
        onMouseUp: function onMouseUp(event) {
          return handleMouseUp(event);
        },
        onMouseEnter: function onMouseEnter(event) {
          return handleMouseEnter(event, timestamp);
        }
      }, /*#__PURE__*/React__default.createElement(Moment, {
        value: timestamp,
        format: "HH:mm",
        tz: timezone
      }));
    })));
  }), !recurring ? /*#__PURE__*/React__default.createElement(RightArrow, {
    direction: "right",
    onClick: nextWeek,
    disabled: handleNextWeek === undefined || wc >= 5
  }) : /*#__PURE__*/React__default.createElement("div", null)), !loaded && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem",
    placeContent: "start center",
    placeItems: "start center"
  }, /*#__PURE__*/React__default.createElement(SpinnerContainer, null, /*#__PURE__*/React__default.createElement(LoadingSpinner, {
    variant: "default"
  }), /*#__PURE__*/React__default.createElement("span", null, "Loading...")))));
};
AvailabilityGrid.propTypes = {
  groupedTimeslots: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string.isRequired,
    timeslots: PropTypes.arrayOf(PropTypes.shape({
      timestamp: PropTypes.string.isRequired,
      restricted: PropTypes.bool.isRequired,
      booked: PropTypes.bool.isRequired
    }))
  })),
  selected: PropTypes.array,
  setSelected: PropTypes.func.isRequired,
  handlePreviousWeek: PropTypes.func.isRequired,
  handleNextWeek: PropTypes.func.isRequired,
  timezone: PropTypes.string,
  gridArea: PropTypes.string,
  loaded: PropTypes.bool,
  recurring: PropTypes.bool,
  handleClearAvailability: PropTypes.func.isRequired,
  showRecurringButton: PropTypes.bool,
  showClearButton: PropTypes.bool,
  submitting: PropTypes.bool
};
AvailabilityGrid.defaultProps = {
  groupedTimeslots: [],
  selected: [],
  setSelected: undefined,
  handlePreviousWeek: undefined,
  handleNextWeek: undefined,
  timezone: null,
  gridArea: undefined,
  loaded: false,
  recurring: false,
  handleClearAvailability: undefined,
  showClearButton: true,
  showRecurringButton: false,
  submitting: false
};

var _templateObject$10, _templateObject2$U, _templateObject3$J, _templateObject4$G, _templateObject5$u, _templateObject6$r, _templateObject7$q, _templateObject8$k, _templateObject9$i, _templateObject0$h, _templateObject1$e, _templateObject10$d, _templateObject11$d, _templateObject12$c, _templateObject13$a, _templateObject14$a, _templateObject15$a, _templateObject16$a, _templateObject17$8, _templateObject18$7, _templateObject19$6, _templateObject20$5, _templateObject21$3, _templateObject22$3, _templateObject23$3, _templateObject24$3, _templateObject25$3, _templateObject26$3, _templateObject27$3, _templateObject28$2;
var getSize = function getSize(size) {
  switch (size) {
    case "small":
      return "3rem";
    case "standard":
      return "4rem";
    case "medium":
      return "7rem";
    case "large":
      return "9rem";
    default:
      return "140px";
  }
};
var getFontSize = function getFontSize(size) {
  switch (size) {
    case "small":
      return "1.35rem";
    case "medium":
      return "3.5rem";
    case "large":
      return "4.5rem";
    default:
      return "2.5rem";
  }
};
var sizes = css(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteral(["\n  min-width: ", ";\n  max-width: ", ";\n  min-height: ", ";\n  max-height: ", ";\n"])), function (_ref) {
  var size = _ref.size;
  return getSize(size);
}, function (_ref2) {
  var size = _ref2.size;
  return getSize(size);
}, function (_ref3) {
  var size = _ref3.size;
  return getSize(size);
}, function (_ref4) {
  var size = _ref4.size;
  return getSize(size);
});
var fontSizes = css(_templateObject2$U || (_templateObject2$U = _taggedTemplateLiteral(["\n  font-size: ", ";\n"])), function (_ref5) {
  var size = _ref5.size;
  return getFontSize(size);
});
var ImgWrapper$1 = styled.div(_templateObject3$J || (_templateObject3$J = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  border: 2px solid white;\n  border-radius: 50%;\n  overflow: hidden;\n  background-color: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n    ", "\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
}, function (_ref7) {
  var plain = _ref7.plain;
  return plain && css(_templateObject4$G || (_templateObject4$G = _taggedTemplateLiteral(["\n      border-color: transparent;\n    "])));
}, function (_ref8) {
  var smallOnMobile = _ref8.smallOnMobile;
  return smallOnMobile && css(_templateObject5$u || (_templateObject5$u = _taggedTemplateLiteral(["\n      width: 124px;\n      height: 124px;\n      border-width: 1px;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject6$r || (_templateObject6$r = _taggedTemplateLiteral(["\n      ", "\n      border-width: 2px;\n    "])), sizes));
}, function (_ref9) {
  var smallOnMobile = _ref9.smallOnMobile,
    size = _ref9.size;
  return !smallOnMobile && size !== "large" && css(_templateObject7$q || (_templateObject7$q = _taggedTemplateLiteral(["\n      ", "\n    "])), sizes);
}, function (_ref0) {
  var smallOnMobile = _ref0.smallOnMobile,
    size = _ref0.size;
  return !smallOnMobile && size == "large" && css(_templateObject8$k || (_templateObject8$k = _taggedTemplateLiteral(["\n      width: 5rem;\n      height: 5rem;\n\n      ", "\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject9$i || (_templateObject9$i = _taggedTemplateLiteral(["\n        width: 6rem;\n        height: 6rem;\n      "]))), breakpoint("desktop")(_templateObject0$h || (_templateObject0$h = _taggedTemplateLiteral(["\n          width: 9rem;\n          height: 9rem;\n      "]))));
});
var Img$7 = styled.img(_templateObject1$e || (_templateObject1$e = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  background-color: white;\n\n  ", "\n"])), function (_ref1) {
  var obfuscated = _ref1.obfuscated;
  return !!obfuscated && css(_templateObject10$d || (_templateObject10$d = _taggedTemplateLiteral(["\n      filter: blur(8px);\n      pointer-events: none;\n    "])));
});
var Div$5 = styled.div(_templateObject11$d || (_templateObject11$d = _taggedTemplateLiteral(["\n  border: 2px solid white;\n  border-radius: 50%;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  background-color: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n    ", "\n\n      ", "\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.secondary;
}, function (_ref11) {
  var profile = _ref11.profile;
  return !!profile && css(_templateObject12$c || (_templateObject12$c = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.profile.avatarBackground;
  });
}, function (_ref13) {
  var noBorder = _ref13.noBorder;
  return !!noBorder && css(_templateObject13$a || (_templateObject13$a = _taggedTemplateLiteral(["\n      border: none;\n    "])));
}, function (_ref14) {
  var plain = _ref14.plain;
  return plain && css(_templateObject14$a || (_templateObject14$a = _taggedTemplateLiteral(["\n      border-color: transparent;\n    "])));
}, function (_ref15) {
  var smallOnMobile = _ref15.smallOnMobile;
  return !!smallOnMobile && css(_templateObject15$a || (_templateObject15$a = _taggedTemplateLiteral(["\n      width: 124px;\n      height: 124px;\n      border-width: 1px;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject16$a || (_templateObject16$a = _taggedTemplateLiteral(["\n      ", "\n      border-width: 2px;\n    "])), sizes));
}, function (_ref16) {
  var smallOnMobile = _ref16.smallOnMobile,
    size = _ref16.size;
  return !smallOnMobile && size !== "large" && css(_templateObject17$8 || (_templateObject17$8 = _taggedTemplateLiteral(["\n      ", "\n    "])), sizes);
}, function (_ref17) {
  var smallOnMobile = _ref17.smallOnMobile,
    size = _ref17.size;
  return !smallOnMobile && size == "large" && css(_templateObject18$7 || (_templateObject18$7 = _taggedTemplateLiteral(["\n      width: 5rem;\n      height: 5rem;\n\n      ", "\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject19$6 || (_templateObject19$6 = _taggedTemplateLiteral(["\n          width: 6rem;\n          height: 6rem;\n        "]))), breakpoint("desktop")(_templateObject20$5 || (_templateObject20$5 = _taggedTemplateLiteral(["\n            width: 9rem;\n            height: 9rem;\n        "]))));
});
var P$1 = styled.p(_templateObject21$3 || (_templateObject21$3 = _taggedTemplateLiteral(["\n  font-family: Helvetica Neue;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  color: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n      ", "\n"])), function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.bodyAlternative || theme.colors.body;
}, function (_ref19) {
  var profile = _ref19.profile;
  return !!profile && css(_templateObject22$3 || (_templateObject22$3 = _taggedTemplateLiteral(["\n      color: white;\n    "])));
}, function (_ref20) {
  var smallOnMobile = _ref20.smallOnMobile;
  return !!smallOnMobile && css(_templateObject23$3 || (_templateObject23$3 = _taggedTemplateLiteral(["\n      font-size: ", ";\n\n      ", "\n    "])), function () {
    return getFontSize("small");
  }, breakpoint("tablet")(_templateObject24$3 || (_templateObject24$3 = _taggedTemplateLiteral(["\n        ", "\n      "])), fontSizes));
}, function (_ref21) {
  var smallOnMobile = _ref21.smallOnMobile,
    size = _ref21.size;
  return !smallOnMobile && size != "large" && css(_templateObject25$3 || (_templateObject25$3 = _taggedTemplateLiteral(["\n      ", "\n    "])), fontSizes);
}, function (_ref22) {
  var smallOnMobile = _ref22.smallOnMobile,
    size = _ref22.size;
  return !smallOnMobile && size == "large" && css(_templateObject26$3 || (_templateObject26$3 = _taggedTemplateLiteral(["\n      font-size: 1.25rem;\n\n      ", "\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject27$3 || (_templateObject27$3 = _taggedTemplateLiteral(["\n        font-size: 2rem;\n      "]))), breakpoint("desktop")(_templateObject28$2 || (_templateObject28$2 = _taggedTemplateLiteral(["\n        font-size: 4.5rem;\n      "]))));
});

var Avatar$1 = function Avatar(_ref) {
  var _firstName$charAt, _lastName$charAt;
  var src = _ref.src,
    alt = _ref.alt,
    size = _ref.size,
    smallOnMobile = _ref.smallOnMobile,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    avatarExists = _ref.avatarExists,
    plain = _ref.plain,
    obfuscated = _ref.obfuscated,
    noBorder = _ref.noBorder,
    profile = _ref.profile;
  var initials = (firstName === null || firstName === void 0 || (_firstName$charAt = firstName.charAt(0)) === null || _firstName$charAt === void 0 ? void 0 : _firstName$charAt.toUpperCase()) + (lastName === null || lastName === void 0 || (_lastName$charAt = lastName.charAt(0)) === null || _lastName$charAt === void 0 ? void 0 : _lastName$charAt.toUpperCase());
  var hideAvatar = !avatarExists || !!obfuscated;
  if (hideAvatar) {
    return /*#__PURE__*/React__default.createElement(Div$5, {
      alt: alt,
      size: size,
      smallOnMobile: smallOnMobile,
      plain: plain,
      noBorder: noBorder,
      profile: profile
    }, /*#__PURE__*/React__default.createElement(P$1, {
      size: size,
      smallOnMobile: smallOnMobile,
      profile: profile
    }, initials));
  } else {
    return /*#__PURE__*/React__default.createElement(ImgWrapper$1, {
      size: size,
      smallOnMobile: smallOnMobile
    }, /*#__PURE__*/React__default.createElement(Img$7, {
      src: src,
      alt: alt
    }));
  }
};
Avatar$1.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf(["small", "default", "medium", "large"]),
  smallOnMobile: PropTypes.bool,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  avatarExists: PropTypes.bool,
  plain: PropTypes.bool,
  obfuscated: PropTypes.bool,
  noBorder: PropTypes.bool
};
Avatar$1.defaultProps = {
  alt: "",
  size: "default",
  smallOnMobile: false,
  firstName: "",
  lastName: "",
  avatarExists: false,
  obfuscated: false,
  noBorder: false
};

var _templateObject$$, _templateObject2$T, _templateObject3$I, _templateObject4$F, _templateObject5$t;
var Container$s = styled.span(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 4px;\n  color: ", ";\n  padding: 0.25rem;\n  text-align: center;\n  min-width: 1rem;\n  min-height: 1rem;\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n  font-size: 0.875rem;\n  font-weight: 700;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.colors.notifications.badge.background;
}, function (props) {
  return props.theme.colors.notifications.badge.text;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.body.family;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.body.weight;
}, function (props) {
  return props.size == "small" && css(_templateObject2$T || (_templateObject2$T = _taggedTemplateLiteral(["\n      font-size: 0.9em;\n      padding: 0.01rem 0.2rem;\n      line-height: 1.8em;\n      min-height: unset;\n    "])));
}, function (props) {
  return props.color && css(_templateObject3$I || (_templateObject3$I = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n    "])), props.color, readableColor(props.color));
}, function (props) {
  return props.fontWeight && css(_templateObject4$F || (_templateObject4$F = _taggedTemplateLiteral(["\n      font-weight: ", ";\n    "])), props.fontWeight);
}, function (props) {
  return !!props.useTheme && css(_templateObject5$t || (_templateObject5$t = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), props.theme.colors.primaryContrastedDarker);
});

var Badge$2 = function Badge(_ref) {
  var children = _ref.children,
    size = _ref.size,
    color = _ref.color,
    fontWeight = _ref.fontWeight,
    useTheme = _ref.useTheme;
  return /*#__PURE__*/React__default.createElement(Container$s, {
    size: size,
    color: color,
    fontWeight: fontWeight,
    useTheme: useTheme
  }, children);
};
Badge$2.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
  fontWeight: PropTypes.string
};

var _templateObject$_, _templateObject2$S;
var P = styled.p(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 0.8rem;\n  margin: 0;\n  padding: 0;\n  font-weight: 700;\n"])), function (props) {
  return props.theme.colors.content.text;
});
var A$3 = styled.a(_templateObject2$S || (_templateObject2$S = _taggedTemplateLiteral(["\n  font-family: ", ", sans-serif;\n  color: ", ";\n  text-decoration: none;\n"])), function (props) {
  return props.theme.fonts.body.family;
}, function (props) {
  return props.theme.colors.content.text;
});

var Breadcrumb = function Breadcrumb(_ref) {
  var pages = _ref.pages;
  return /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      padding: "1rem",
      marginBottom: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(P, null, pages.map(function (page) {
    return /*#__PURE__*/React__default.createElement(A$3, {
      href: page.url
    }, " ", page.name, " ");
  }).reduce(function (val, x) {
    return val === null ? [x] : [val, "/", x];
  }, null)));
};
Breadcrumb.propTypes = {
  pages: PropTypes.array.isRequired
};
Breadcrumb.defaultProps = {
  pages: []
};

var _templateObject$Z, _templateObject2$R, _templateObject3$H;
var Container$r = styled.div(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteral(["\n  color: ", ";\n  padding: 18px;\n  border-radius: 8px;\n  font-size: 16px;\n\n  background-color: ", ";\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.banner.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.body;
}, breakpoint("tablet")(_templateObject2$R || (_templateObject2$R = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.banner.background;
}));
var Heading$1 = styled.p(_templateObject3$H || (_templateObject3$H = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0 0 10px 0;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.banner.text;
});

var _excluded$7 = ["heading", "content", "inlineOnMobile"];
var BannerContent = function BannerContent(_ref) {
  var heading = _ref.heading,
    content = _ref.content,
    inlineOnMobile = _ref.inlineOnMobile,
    rest = _objectWithoutProperties$1(_ref, _excluded$7);
  return /*#__PURE__*/React__default.createElement(Container$r, _extends({
    inlineOnMobile: inlineOnMobile,
    className: "ho-banner"
  }, rest), heading && /*#__PURE__*/React__default.createElement(H2$1, {
    marginless: true
  }, /*#__PURE__*/React__default.createElement(Heading$1, null, heading)), /*#__PURE__*/React__default.createElement(Markdown, {
    componentStyles: {
      h1: {
        variant: "primary"
      }
    }
  }, content));
};
BannerContent.propTypes = {
  content: PropTypes.string.isRequired,
  heading: PropTypes.string
};
BannerContent.defaultProps = {
  inlineOnMobile: false
};

var _templateObject$Y, _templateObject2$Q, _templateObject3$G, _templateObject4$E, _templateObject5$s, _templateObject6$q;
var getFontSizeFromSize = function getFontSizeFromSize(size, theme) {
  switch (size) {
    case "small":
      return "0.75rem";
    default:
      return "1rem";
  }
};
var getPaddingFromSize$1 = function getPaddingFromSize(size, theme) {
  switch (size) {
    case "small":
      return "0.5rem 1rem";
    default:
      return "0.75rem 1.5rem";
  }
};
var getMinWidthFromSize = function getMinWidthFromSize(size, theme) {
  switch (size) {
    case "small":
      return "8rem";
    default:
      return "10rem";
  }
};
var Container$q = styled.div(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteral(["\n  ", "\n  border-radius: 0.5rem 0.5rem 0 0;\n  display: inline-block;\n  position: relative;\n  min-width: ", ";\n"])), function (props) {
  return props.show && css(_templateObject2$Q || (_templateObject2$Q = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (props) {
    return props.theme.colors.secondary;
  });
}, function (_ref) {
  var size = _ref.size;
    _ref.theme;
  return getMinWidthFromSize(size);
});
var Title$5 = styled.div(_templateObject3$G || (_templateObject3$G = _taggedTemplateLiteral(["\n  background-color: white;\n  color: ", ";\n  border: 2px solid ", ";\n  font-family: ", ", sans-serif;\n  font-weight: bold;\n  font-size: ", ";\n  padding: ", ";\n  border-radius: 0.5rem;\n  cursor: pointer;\n  user-select: none;\n  text-align: center;\n"])), function (props) {
  return props.theme.colors.secondaryAlternative || props.theme.secondary;
}, function (props) {
  return props.theme.colors.secondary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.body.family;
}, function (_ref3) {
  var size = _ref3.size;
    _ref3.theme;
  return getFontSizeFromSize(size);
}, function (_ref4) {
  var size = _ref4.size;
    _ref4.theme;
  return getPaddingFromSize$1(size);
});
var Content$5 = styled.div(_templateObject4$E || (_templateObject4$E = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: none;\n  padding: 5px 10px 8px 10px;\n  border-radius: 0 0 0.5rem 0.5rem;\n  width: 100%;\n  box-sizing: border-box;\n\n  ", "\n\n  position: absolute;\n  z-index: 5;\n"])), function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.show && css(_templateObject5$s || (_templateObject5$s = _taggedTemplateLiteral(["\n      display: block;\n    "])));
});
var Option = styled(P$4).attrs({
  marginless: true,
  bold: true,
  variant: "secondaryReadable"
})(_templateObject6$q || (_templateObject6$q = _taggedTemplateLiteral(["\n  padding: 0.5rem 1.25rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  position: relative;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return darken(0.05, theme.colors.secondary);
});

var ButtonSelect = function ButtonSelect(_ref) {
  var title = _ref.title,
    options = _ref.options,
    clickHandler = _ref.clickHandler,
    size = _ref.size;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var handleClick = function handleClick(event, option) {
    setShow(false);
    if (clickHandler !== undefined) clickHandler(event, option);
  };
  return /*#__PURE__*/React__default.createElement(Container$q, {
    show: show
  }, /*#__PURE__*/React__default.createElement(Title$5, {
    size: size,
    onClick: function onClick() {
      return setShow(!show);
    }
  }, title, "\xA0\xA0", /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faChevronDown$1
  })), /*#__PURE__*/React__default.createElement(Content$5, {
    show: show
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0"
  }, options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(Option, {
      size: size,
      key: option,
      onClick: function onClick(event) {
        return handleClick(event, option);
      }
    }, option);
  }))));
};
ButtonSelect.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  clickHandler: PropTypes.func,
  size: PropTypes.oneOf(["default", "small"])
};
ButtonSelect.defaultProps = {
  title: "Please select",
  options: [],
  clickHandler: undefined,
  size: "default"
};

var _templateObject$X, _templateObject2$P, _templateObject3$F;
var Button$4 = styled.a(_templateObject$X || (_templateObject$X = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: transparent;\n  border: none;\n  font-size: 1.2rem;\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  text-align: center;\n  font-weight: normal;\n  appearance: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.colors.body;
}, function (props) {
  return props.small && css(_templateObject2$P || (_templateObject2$P = _taggedTemplateLiteral(["\n      width: 2rem;\n      height: 2rem;\n      font-size: 1rem;\n    "])));
}, function (props) {
  return props.mobileOnly && breakpoint("widescreen")(_templateObject3$F || (_templateObject3$F = _taggedTemplateLiteral(["\n    display: none;\n  "])));
});

var _excluded$6 = ["onClick", "mobileOnly", "small"];
var CloseButton$1 = function CloseButton(_ref) {
  var onClick = _ref.onClick,
    mobileOnly = _ref.mobileOnly;
    _ref.small;
    var rest = _objectWithoutProperties$1(_ref, _excluded$6);
  return /*#__PURE__*/React__default.createElement(Button$4, _extends({
    href: "",
    onClick: onClick,
    mobileOnly: mobileOnly
  }, rest), /*#__PURE__*/React__default.createElement(CloseIcon$1, _extends({
    size: "extralarge"
  }, rest)));
};
PropTypes.propTypes = {
  onClick: PropTypes.func.isRequired,
  mobileOnly: PropTypes.bool.isRequired,
  small: PropTypes.bool.isRequired
};
CloseButton$1.defaultProps = {
  mobileOnly: false,
  small: false
};

var _templateObject$W, _templateObject2$O, _templateObject3$E, _templateObject4$D, _templateObject5$r, _templateObject6$p, _templateObject7$p, _templateObject8$j, _templateObject9$h, _templateObject0$g, _templateObject1$d, _templateObject10$c, _templateObject11$c, _templateObject12$b, _templateObject13$9, _templateObject14$9, _templateObject15$9, _templateObject16$9, _templateObject17$7, _templateObject18$6, _templateObject19$5, _templateObject20$4, _templateObject21$2, _templateObject22$2, _templateObject23$2, _templateObject24$2, _templateObject25$2, _templateObject26$2, _templateObject27$2;
var Banner$2 = styled.div(_templateObject$W || (_templateObject$W = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: 1rem;\n  border-radius: 0.5rem;\n  height: fit-content;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.conversations.activeChat;
});
var BannerText = styled(P$4)(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteral(["\n  color: #333;\n  margin: 0;\n"])));
var Container$p = styled.div(_templateObject3$E || (_templateObject3$E = _taggedTemplateLiteral(["\n  background-color: white;\n  z-index: 10;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject4$D || (_templateObject4$D = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 33% 1fr;\n    height: 700px;\n    border: 1px solid #D8D8D8;\n  "]))));
var List$2 = styled.div(_templateObject5$r || (_templateObject5$r = _taggedTemplateLiteral(["\n  background-color: white;\n  overflow-y: auto;\n  display: none;\n  border: 1px solid #d8d8d8;\n\n  &::-webkit-scrollbar {\n    width: 0.5rem;\n    overflow: hidden;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: ", ";\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #d8d8d8;\n  }\n\n  ", "\n\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.lightGrey;
}, function (_ref3) {
  var show = _ref3.show;
  return !!show && css(_templateObject6$p || (_templateObject6$p = _taggedTemplateLiteral(["\n      display: block;\n    "])));
}, breakpoint("tablet")(_templateObject7$p || (_templateObject7$p = _taggedTemplateLiteral(["\n    display: block;\n    border: none;\n  "]))));
var ListItem$2 = styled.div(_templateObject8$j || (_templateObject8$j = _taggedTemplateLiteral(["\n  background-color: white;\n\n  &:not(:first-child) {\n    border-top: 1px solid #d8d8d8;\n  }\n\n  cursor: pointer;\n  transition: 0.3s;\n  padding: 1.25rem;\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n\n  &:last-child {\n    ", "\n  }\n\n  ", "\n"])), breakpoint("tablet")(_templateObject9$h || (_templateObject9$h = _taggedTemplateLiteral(["\n      border-bottom: 1px solid #D8D8D8;\n    "]))), breakpoint("tablet") && css(_templateObject0$g || (_templateObject0$g = _taggedTemplateLiteral(["\n    ", "\n\n    &:hover, &:active {\n      background-color: ", ";\n    }\n  "])), function (_ref4) {
  var selected = _ref4.selected;
  return !!selected && css(_templateObject1$d || (_templateObject1$d = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.conversations.activeChat;
  });
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.conversations.activeChat;
}));
var MessagesArea$1 = styled.div(_templateObject10$c || (_templateObject10$c = _taggedTemplateLiteral(["\n  background-color: white;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  height: -webkit-fill-available;\n  width: 100vw;\n  display: none;\n  padding: 1rem;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref7) {
  var show = _ref7.show;
  return !!show && css(_templateObject11$c || (_templateObject11$c = _taggedTemplateLiteral(["\n      display: grid;\n    "])));
}, breakpoint("tablet")(_templateObject12$b || (_templateObject12$b = _taggedTemplateLiteral(["\n    position: unset;\n    top: unset;\n    left: unset;\n    height: unset;\n    width: unset;\n    display: grid;\n    padding: 1.25rem;\n    border-left: 1px solid #D8D8D8;\n  "]))), function (_ref8) {
  var selected = _ref8.selected;
  return !!selected && css(_templateObject13$9 || (_templateObject13$9 = _taggedTemplateLiteral(["\n      gap: 1rem;\n      place-content: start stretch;\n      /* justify-content: space-between; */\n      grid-template-rows: auto 1fr auto;\n      overflow: hidden;\n      box-sizing: border-box;\n    "])));
}, function (_ref9) {
  var selected = _ref9.selected;
  return !selected && css(_templateObject14$9 || (_templateObject14$9 = _taggedTemplateLiteral(["\n      place-content: center;\n    "])));
});
var Links = styled.div(_templateObject15$9 || (_templateObject15$9 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-flow: column;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: center;\n  margin-bottom: 1rem;\n\n  > :last-child {\n    display: grid;\n    grid-auto-flow: column;\n    justify-items: end;\n    gap: 1rem;\n  }\n\n  ", "\n"])), function (_ref0) {
  var rescheduleInterviewEnabled = _ref0.rescheduleInterviewEnabled;
  return !!rescheduleInterviewEnabled && css(_templateObject16$9 || (_templateObject16$9 = _taggedTemplateLiteral(["\n      margin-bottom: 0;\n    "])));
});
var Link$1 = styled.a(_templateObject17$7 || (_templateObject17$7 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: bold;\n  font-family: ", ", sans-serif;\n  text-decoration: underline;\n  line-height: 1.4;\n  cursor: pointer;\n  display: block;\n\n  &.back-to-messages {\n    ", "\n  }\n"])), function (_ref1) {
  var theme = _ref1.theme;
  return theme.colors.primary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fonts.body.family;
}, breakpoint("tablet")(_templateObject18$6 || (_templateObject18$6 = _taggedTemplateLiteral(["\n        display: none;\n      }\n    "]))));
var Messages = styled.div(_templateObject19$5 || (_templateObject19$5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding-right: 0.5rem;\n  margin-right: -1rem;\n  overflow-y: auto;\n\n  // hide whilst loading and scrolling\n  visibility: hidden;\n\n  &::-webkit-scrollbar {\n    width: 0.5rem;\n    overflow: hidden;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: ", ";\n    border-radius: 0.25rem;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #d8d8d8;\n    border-radius: 0.25rem;\n  }\n\n  ", "\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.lightGrey;
}, breakpoint("tablet")(_templateObject20$4 || (_templateObject20$4 = _taggedTemplateLiteral(["\n    height: unset;\n  "]))));
var Message$1 = styled.div(_templateObject21$2 || (_templateObject21$2 = _taggedTemplateLiteral(["\n  display: grid;\n  gap: 0.25rem;\n  max-width: 60%;\n  place-self: flex-", ";\n  margin-bottom: 1rem;\n  white-space: pre-line;\n  overflow-wrap: anywhere;\n  justify-items: ", ";\n"])), function (_ref12) {
  var align = _ref12.align;
  return align;
}, function (_ref13) {
  var align = _ref13.align;
  return align === "start" ? "start" : "end";
});
var Bubble = styled(Card$1)(_templateObject22$2 || (_templateObject22$2 = _taggedTemplateLiteral(["\n  padding: 0.75rem 1.25rem;\n  margin: 0;\n"])));
var InputArea = styled.div(_templateObject23$2 || (_templateObject23$2 = _taggedTemplateLiteral(["\n  grid-template-columns: 1fr 25%;\n  display: grid;\n  align-items: end;\n  gap: 0.5rem;\n\n  button {\n    height: 3rem;\n    font-weight: 600;\n  }\n\n  ", "\n"])), breakpoint("tablet")(_templateObject24$2 || (_templateObject24$2 = _taggedTemplateLiteral(["\n    grid-template-columns: 1fr 20%;\n  "]))));
var MessageArea = styled.div(_templateObject25$2 || (_templateObject25$2 = _taggedTemplateLiteral(["\n  position: relative;\n\n  p {\n    position: absolute;\n    right: 0;\n    top: calc(100% + 1px);\n  }\n"])));
var Counter$4 = styled.span(_templateObject26$2 || (_templateObject26$2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: white;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.5rem;\n  min-height: 1.5rem;\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n  font-size: 1rem;\n  border-radius: 0.75rem;\n"])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.primary;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fonts.body.family;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fonts.body.weight;
});
var Error$1 = styled.span(_templateObject27$2 || (_templateObject27$2 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-align: center;\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n"])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.danger;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fonts.body.family;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fonts.body.weight;
});

var Conversations = function Conversations(_ref) {
  var _selected$employer_in, _selected$employer_in2;
  var timezone = _ref.timezone,
    conversations = _ref.conversations,
    selected = _ref.selected,
    selectedHandler = _ref.selectedHandler,
    profileHandler = _ref.profileHandler,
    shouldShowProfileHandler = _ref.shouldShowProfileHandler,
    submitHandler = _ref.submitHandler,
    endChatHandler = _ref.endChatHandler,
    currentUserType = _ref.currentUserType,
    openRescheduleModal = _ref.openRescheduleModal,
    actionsSelect = _ref.actionsSelect;
  var messagesContainer = useRef();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    message = _useState2[0],
    setMessage = _useState2[1];
  var id = selected === null || selected === void 0 ? void 0 : selected.id;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    typing = _useState6[0],
    setTyping = _useState6[1];
  useEffect(function () {
    if (id && messagesContainer.current) {
      messagesContainer.current.scrollTop = messagesContainer.current.scrollHeight;
      messagesContainer.current.style.visibility = "visible";
    }
  }, [id]);
  var selectConversation = function selectConversation(event, conversation) {
    event.preventDefault();
    if (selectedHandler !== undefined) selectedHandler(conversation);
    setMessage("");
    setTyping(false);
  };
  var sendMessage = function sendMessage(event) {
    var cleanedMessage = cleanMessage(message);
    var contentPresent = validateMessage(cleanMessage(message));
    if (!contentPresent) {
      alert("Please enter a message");
      return;
    }
    if (event) event.preventDefault();
    if (submitHandler !== undefined) {
      setSubmitting(true);
      Promise.resolve(submitHandler(selected, cleanedMessage)).then(function (result) {
        if (result && result.error) {
          setSubmitting(false);
          return;
        }
        setMessage("");
        setTyping(false);
        if (messagesContainer.current) messagesContainer.current.scrollTop = messagesContainer.current.scrollHeight;
        setSubmitting(false);
      });
    } else {
      alert("Please enter a message");
      setMessage("");
      setTyping(false);
    }
  };
  var validateMessage = function validateMessage(messageToValidate) {
    return messageToValidate.length > 0;
  };
  var cleanMessage = function cleanMessage(messageToClean) {
    return messageToClean.trim().replace(/\n{3,}/g, "\n");
  };
  var handleMessageChange = function handleMessageChange(event) {
    setMessage(event.target.value);
    displayMessagePrompt(event.target.value);
  };
  var displayMessagePrompt = function displayMessagePrompt(value) {
    setTyping(value.length > 0);
  };
  var checkSubmit = function checkSubmit(event) {
    var enterPressed = event.key === "Enter";
    var shiftPressed = event.shiftKey;
    var contentPresent = validateMessage(cleanMessage(message));
    var goodToGo = enterPressed && !shiftPressed && contentPresent;
    var submittingEmptyMessage = enterPressed && !shiftPressed && !contentPresent;
    if (goodToGo) {
      sendMessage();
    } else if (submittingEmptyMessage) {
      event.preventDefault();
      alert("Please enter a message");
      setMessage("");
      setTyping(false);
    }
  };
  var viewProfile = function viewProfile(event) {
    event.preventDefault();
    if (profileHandler !== undefined) profileHandler(selected);
  };
  var endChat = function endChat(event) {
    event.preventDefault();
    if (endChatHandler !== undefined) endChatHandler(selected);
    setMessage("");
    setTyping(false);
  };
  var archivedMessage = function archivedMessage(selected) {
    var msg = "";
    if (selected.archived_by_name) {
      msg = "".concat(selected.archived_by_name, " ended the conversation.");
    } else {
      msg = "Conversation ended by placement status update.";
    }
    if (selected.archived_by_current_user && selected.conversation_enabled) {
      msg = "".concat(msg, " Send a message to reopen the conversation.");
    }
    return msg;
  };
  var backToMessages = function backToMessages(event) {
    event.preventDefault();
    if (selectedHandler !== undefined) selectedHandler(null);
    setMessage("");
    setTyping(false);
  };
  var rescheduleInterviewEnabled = (selected === null || selected === void 0 || (_selected$employer_in = selected.employer_interview) === null || _selected$employer_in === void 0 ? void 0 : _selected$employer_in.reschedule_interview_enabled) && !!(selected !== null && selected !== void 0 && (_selected$employer_in2 = selected.employer_interview) !== null && _selected$employer_in2 !== void 0 && _selected$employer_in2.interview_start_date) && openRescheduleModal !== undefined;
  return /*#__PURE__*/React__default.createElement(Container$p, null, /*#__PURE__*/React__default.createElement(List$2, {
    show: !selected
  }, conversations.map(function (conversation) {
    return /*#__PURE__*/React__default.createElement(ListItem$2, {
      key: conversation.id,
      selected: conversation.id === (selected === null || selected === void 0 ? void 0 : selected.id),
      onClick: function onClick(event) {
        return selectConversation(event, conversation);
      }
    }, /*#__PURE__*/React__default.createElement(Grid$1, {
      grid: "auto / auto-flow",
      gap: "1rem",
      placeItems: "center",
      mobile: true
    }, /*#__PURE__*/React__default.createElement(Avatar$1, {
      avatarExists: conversation.avatar_exists,
      src: conversation.avatar,
      size: "small",
      firstName: conversation.first_name,
      lastName: conversation.last_name
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        maxWidth: "100%",
        overflow: "hidden"
      }
    }, /*#__PURE__*/React__default.createElement(P$4, {
      variant: "secondary",
      marginless: true,
      bold: true,
      style: {
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    }, conversation.title), /*#__PURE__*/React__default.createElement(P$4, {
      variant: "secondary",
      marginless: true,
      style: {
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    }, conversation.last_message_snippet || "New conversation"))), /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "0.25rem",
      placeItems: "center end",
      mobile: true
    }, /*#__PURE__*/React__default.createElement(P$4, {
      variant: "secondary",
      marginless: true,
      nowrap: true
    }, conversation.last_message_time), /*#__PURE__*/React__default.createElement("div", null, (selected === null || selected === void 0 ? void 0 : selected.id) !== conversation.id && conversation.new_messages_counter > 0 && /*#__PURE__*/React__default.createElement(Counter$4, null, conversation.new_messages_counter))));
  })), /*#__PURE__*/React__default.createElement(MessagesArea$1, {
    show: selected,
    selected: selected
  }, selected ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Links, {
    rescheduleInterviewEnabled: rescheduleInterviewEnabled
  }, /*#__PURE__*/React__default.createElement("div", null, selectedHandler !== undefined && /*#__PURE__*/React__default.createElement(Link$1, {
    onClick: backToMessages,
    className: "back-to-messages"
  }, "Back to Messages")), /*#__PURE__*/React__default.createElement("div", null, !!actionsSelect ? actionsSelect : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, profileHandler !== undefined && (shouldShowProfileHandler ? shouldShowProfileHandler(selected) : false) && /*#__PURE__*/React__default.createElement(Link$1, {
    onClick: viewProfile
  }, "View ", currentUserType == "employer" ? selected.participant_name : selected.employer_name, "'s Profile"), endChatHandler !== undefined && !selected.archived && id !== "new" && /*#__PURE__*/React__default.createElement(Link$1, {
    onClick: endChat
  }, "End Chat")))), rescheduleInterviewEnabled && /*#__PURE__*/React__default.createElement(Banner$2, null, /*#__PURE__*/React__default.createElement(BannerText, null, "You have an upcoming interview with ", selected.participant_name, " taking place on", " ", /*#__PURE__*/React__default.createElement("strong", null, /*#__PURE__*/React__default.createElement(Moment, {
    value: selected.employer_interview.interview_start_date,
    format: "D MMMM YYYY [at] HH:mm",
    tz: timezone
  })), " ", "-", " ", /*#__PURE__*/React__default.createElement(Link$1, {
    onClick: function onClick() {
      return openRescheduleModal(selected);
    },
    style: {
      width: "fit-content",
      display: "inline-block"
    }
  }, "Need to Reschedule?"))), /*#__PURE__*/React__default.createElement(Messages, {
    key: selected === null || selected === void 0 ? void 0 : selected.id,
    ref: messagesContainer
  }, selected.conversation_messages.length > 0 && selected.conversation_messages.map(function (message) {
    return !!message.me ? /*#__PURE__*/React__default.createElement(Message$1, {
      key: message.id,
      align: "end"
    }, /*#__PURE__*/React__default.createElement(Bubble, {
      variant: "primary"
    }, /*#__PURE__*/React__default.createElement(P$4, {
      variant: "white",
      marginless: true,
      bold: true
    }, message.fromUserName), /*#__PURE__*/React__default.createElement(P$4, {
      variant: "white",
      marginless: true
    }, message.text)), /*#__PURE__*/React__default.createElement(P$4, {
      variant: "secondary",
      size: "small",
      marginless: true,
      align: "right"
    }, !!message.sender_name && "".concat(message.sender_name, " \xB7"), " ", /*#__PURE__*/React__default.createElement(Moment, {
      value: message.created_at,
      format: "MMM DD \xB7 HH:mm",
      tz: timezone
    }))) : /*#__PURE__*/React__default.createElement(Message$1, {
      key: message.id,
      align: "start"
    }, /*#__PURE__*/React__default.createElement(Bubble, null, /*#__PURE__*/React__default.createElement(P$4, {
      variant: "secondary",
      marginless: true,
      bold: true
    }, message.fromUserName), /*#__PURE__*/React__default.createElement(P$4, {
      variant: "secondary",
      marginless: true
    }, message.text)), /*#__PURE__*/React__default.createElement(P$4, {
      variant: "secondary",
      size: "small",
      marginless: true,
      align: "left"
    }, !!message.sender_name && "".concat(message.sender_name, " \xB7"), " ", /*#__PURE__*/React__default.createElement(Moment, {
      value: message.created_at,
      format: "MMM DD \xB7 HH:mm",
      tz: timezone
    })));
  })), /*#__PURE__*/React__default.createElement(InputArea, null, /*#__PURE__*/React__default.createElement(MessageArea, null, /*#__PURE__*/React__default.createElement(TextArea, {
    name: "message",
    placeholder: "Type a message",
    value: message,
    onChange: handleMessageChange,
    onKeyPress: checkSubmit,
    rows: 1,
    disabled: selected.archived && (!selected.archived_by_current_user || !selected.conversation_enabled) || submitting
  }), /*#__PURE__*/React__default.createElement(P$4, {
    style: {
      visibility: typing ? "visible" : "hidden"
    },
    variant: "secondary",
    size: "small",
    marginless: true,
    align: "right"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Shift + Return"), " to add a new line")), /*#__PURE__*/React__default.createElement(Button$5, {
    style: {
      height: "51px"
    },
    variant: "success",
    onClick: sendMessage,
    disabled: message.length === 0 || submitting
  }, "Send")), selected.archived && /*#__PURE__*/React__default.createElement(Error$1, null, archivedMessage(selected))) : /*#__PURE__*/React__default.createElement(P$4, {
    variant: "secondary",
    size: "large",
    marginless: true
  }, "Select a conversation")));
};
Conversations.propTypes = {
  timezone: PropTypes.string,
  conversations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    avatar: PropTypes.string,
    avatarExists: PropTypes.bool,
    last_message_time: PropTypes.string,
    last_message_snippet: PropTypes.string,
    new_messages_counter: PropTypes.number,
    conversation_messages: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      created_at: PropTypes.string
    }))
  })),
  selectedHandler: PropTypes.func,
  shouldShowProfileHandler: PropTypes.func,
  profileHandler: PropTypes.func,
  submitHandler: PropTypes.func,
  endChatHandler: PropTypes.func,
  currentUserType: PropTypes.string.isRequired
};
Conversations.defaultProps = {
  conversations: [],
  selectedHandler: undefined,
  shouldShowProfileHandler: undefined,
  profileHandler: undefined,
  submitHandler: undefined,
  endChatHandler: undefined,
  currentUserType: "participant"
};

var _templateObject$V, _templateObject2$N, _templateObject3$D, _templateObject4$C, _templateObject5$q, _templateObject6$o, _templateObject7$o;
var StyledLink$3 = styled(Link$2)(_templateObject$V || (_templateObject$V = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  padding: 2rem;\n  text-decoration: none;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteral(["\n    align-content: center;\n    flex-direction: row;\n  "]))));
var Datum$1 = styled.div(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteral(["\n  margin-bottom: 1rem;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject4$C || (_templateObject4$C = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n    flex: 0 0 25%;\n\n    ", "\n  "])), function (props) {
  return props.large && "\n      flex: 0 0 40%;\n    ";
}));
var Title$4 = styled.span(_templateObject5$q || (_templateObject5$q = _taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 1rem;\n  font-family: ", ", sans-serif;\n  color: ", ";\n"])), function (props) {
  return props.theme.fonts.body.family;
}, function (props) {
  return props.theme.colors.tables.headings;
});
var Content$4 = styled.span(_templateObject6$o || (_templateObject6$o = _taggedTemplateLiteral(["\n  display: flex;\n  font-size: 1.2rem;\n  font-family: ", ", sans-serif;\n  color: ", ";\n"])), function (props) {
  return props.theme.fonts.body.family;
}, function (props) {
  return readableColor(props.theme.colors.secondary, props.theme.colors.buttons.darkColor, props.theme.colors.buttons.lightColor, false);
});
var ArrowContainer = styled.div(_templateObject7$o || (_templateObject7$o = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"])));

var _templateObject$U;
var Container$o = styled.div(_templateObject$U || (_templateObject$U = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (props) {
  return props.color;
});

var CompleteIcon = function CompleteIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$o, {
    color: color
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleCheck,
    size: size
  }));
};
CompleteIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
CompleteIcon.defaultProps = {
  color: "#ffffff",
  size: "sm"
};

var ExpiredIcon = function ExpiredIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$o, {
    color: color
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleExclamation,
    size: size
  }));
};
ExpiredIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
ExpiredIcon.defaultProps = {
  color: "#ffffff",
  size: "sm"
};

var IncompleteIcon = function IncompleteIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$o, {
    color: color
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleExclamation,
    size: size
  }));
};
IncompleteIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
IncompleteIcon.defaultProps = {
  color: "#ffffff",
  size: "sm"
};

var LockedIcon = function LockedIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$o, {
    color: color
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faLock,
    size: size
  }));
};
LockedIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
LockedIcon.defaultProps = {
  color: "#ffffff",
  size: "sm"
};

var NotStartedIcon = function NotStartedIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$o, {
    color: color
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircle,
    size: size
  }));
};
NotStartedIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
NotStartedIcon.defaultProps = {
  color: "#ffffff",
  size: "sm"
};

var RejectedIcon = function RejectedIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$o, {
    color: color
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleXmark,
    size: size
  }));
};
RejectedIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
RejectedIcon.defaultProps = {
  color: "#ffffff",
  size: "sm"
};

var PendingApprovalIcon = function PendingApprovalIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$o, {
    color: color
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleEllipsis,
    size: size
  }));
};
PendingApprovalIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
PendingApprovalIcon.defaultProps = {
  color: "#ffffff",
  size: "sm"
};

var StartedIcon = function StartedIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$o, {
    color: color
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleThreeQuartersStroke,
    size: size
  }));
};
StartedIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
StartedIcon.defaultProps = {
  color: "#ffffff",
  size: "sm"
};

var VerifiedIcon = function VerifiedIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$o, {
    color: color
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faBadgeCheck,
    size: size
  }));
};
VerifiedIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
VerifiedIcon.defaultProps = {
  color: "#ffffff",
  size: "sm"
};

var icons = {
  expired: ExpiredIcon,
  rejected: RejectedIcon,
  not_started: NotStartedIcon,
  verified: VerifiedIcon,
  pending_approval: PendingApprovalIcon,
  complete: CompleteIcon,
  started: StartedIcon,
  incomplete: IncompleteIcon,
  locked: LockedIcon
};
var StatusIconWrapper = function StatusIconWrapper(_ref) {
  var status = _ref.status,
    size = _ref.size,
    color = _ref.color;
  var Icon = icons[status];
  return /*#__PURE__*/React__default.createElement(Icon, {
    size: size,
    color: color
  });
};
StatusIconWrapper.propTypes = {
  status: PropTypes.oneOf(Object.keys(icons)).isRequired,
  size: PropTypes.string,
  color: PropTypes.string
};
StatusIconWrapper.defaultProps = {
  status: "not_started",
  size: "1x",
  color: "#ffffff"
};

var Document = function Document(_ref) {
  var id = _ref.id,
    name = _ref.name,
    status = _ref.status,
    rejectedReason = _ref.rejectedReason;
  return /*#__PURE__*/React__default.createElement(Card$1, {
    variant: "secondary",
    paddingless: true
  }, /*#__PURE__*/React__default.createElement(StyledLink$3, {
    to: "/documents/".concat(id)
  }, /*#__PURE__*/React__default.createElement(Datum$1, null, /*#__PURE__*/React__default.createElement(Title$4, null, "Name"), /*#__PURE__*/React__default.createElement(Content$4, null, name)), /*#__PURE__*/React__default.createElement(Datum$1, null, /*#__PURE__*/React__default.createElement(Title$4, null, "Status"), /*#__PURE__*/React__default.createElement(Content$4, null, status, "\xA0", /*#__PURE__*/React__default.createElement(StatusIconWrapper, {
    status: parameterize(status, "_")
  }))), status === "Rejected" && /*#__PURE__*/React__default.createElement(Datum$1, {
    large: true
  }, /*#__PURE__*/React__default.createElement(Title$4, null, "Rejection Reason"), /*#__PURE__*/React__default.createElement(Content$4, null, rejectedReason)), /*#__PURE__*/React__default.createElement(ArrowContainer, null, /*#__PURE__*/React__default.createElement(Arrow, null))));
};
Document.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  rejectedReason: PropTypes.string
};

var DocumentList = function DocumentList(_ref) {
  var title = _ref.title,
    documents = _ref.documents,
    noneText = _ref.noneText;
  return /*#__PURE__*/React__default.createElement(Card$1, {
    variant: "primary"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1rem"
  }, /*#__PURE__*/React__default.createElement(H2$1, {
    marginless: true
  }, title), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, documents.length > 0 ? documents.map(function (document) {
    return /*#__PURE__*/React__default.createElement(Document, _extends({
      key: document.id
    }, document));
  }) : /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true
  }, noneText))));
};
DocumentList.propTypes = {
  title: PropTypes.string.isRequired,
  documents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    rejectedReason: PropTypes.string
  }))
};
DocumentList.defaultProps = {
  title: "Documents",
  documents: [],
  noneText: "No documents."
};

var _templateObject$T, _templateObject2$M, _templateObject3$C, _templateObject4$B, _templateObject5$p, _templateObject6$n, _templateObject7$n, _templateObject8$i, _templateObject9$g, _templateObject0$f, _templateObject1$c, _templateObject10$b, _templateObject11$b, _templateObject12$a, _templateObject13$8, _templateObject14$8, _templateObject15$8, _templateObject16$8;
var Container$n = styled.div(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral(["\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n  margin-bottom: 1rem;\n  ", "\n\n  ", "\n"])), function (_ref) {
  var pointer = _ref.pointer;
  return pointer && css(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteral(["\n      cursor: pointer;\n    "])));
}, breakpoint("tablet")(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n  "]))));
var Skills$2 = styled.div(_templateObject4$B || (_templateObject4$B = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n"])));
var Skill$2 = styled.div(_templateObject5$p || (_templateObject5$p = _taggedTemplateLiteral(["\n  padding: 0.25rem 1rem;\n  border: 1px solid ", ";\n  color: ", ";\n  border-radius: 2rem;\n  font-size: 0.8rem;\n  margin-right: 0.2rem;\n  margin-bottom: 0.2rem;\n"])), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});
var Media$1 = styled.div(_templateObject6$n || (_templateObject6$n = _taggedTemplateLiteral(["\n  overflow: hidden;\n  height: 15rem;\n  position: relative;\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n\n  ", "\n"])), breakpoint("desktop")(_templateObject7$n || (_templateObject7$n = _taggedTemplateLiteral(["\n    border-radius: 1rem;\n  "]))));
var Img$6 = styled.img(_templateObject8$i || (_templateObject8$i = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n  object-fit: cover;\n  object-position: 50% 50%;\n  margin: 0;\n\n  ", "\n"])), breakpoint("desktop")(_templateObject9$g || (_templateObject9$g = _taggedTemplateLiteral(["\n    border-radius: 1rem;\n  "]))));
var Logo$1 = styled.img(_templateObject0$f || (_templateObject0$f = _taggedTemplateLiteral(["\n  position: absolute;\n  border-radius: 50%;\n  width: 4.25rem;\n  height: 4.25rem;\n  object-fit: cover;\n  bottom: 0.75rem;\n  left: 0.75rem;\n  margin: 0;\n"])));
var Text$3 = styled.div(_templateObject1$c || (_templateObject1$c = _taggedTemplateLiteral(["\n  background-color: white;\n  border-bottom-left-radius: 1rem;\n  border-bottom-right-radius: 1rem;\n  padding: 0.75rem;\n\n  ", "\n\n  > * {\n    margin: 0;\n    margin-top: 0.4rem;\n  }\n"])), breakpoint("desktop")(_templateObject10$b || (_templateObject10$b = _taggedTemplateLiteral(["\n    padding: 0;\n  "]))));
var PlayButton$1 = styled.svg(_templateObject11$b || (_templateObject11$b = _taggedTemplateLiteral(["\n  width: 1.5rem;\n  height: 1.5rem;\n  fill: white;\n"])));
var InterviewButton = styled.svg(_templateObject12$a || (_templateObject12$a = _taggedTemplateLiteral(["\n  width: 1.5rem;\n  height: 1.5rem;\n  fill: none;\n"])));
var Banner$1 = styled.span(_templateObject13$8 || (_templateObject13$8 = _taggedTemplateLiteral(["\n  color: white;\n  padding: 0.75rem 5px;\n  font-weight: bold;\n  text-align: center;\n  background-color: hsla(0, 1%, 30%, 0.7);\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 0;\n  box-sizing: border-box;\n"])));
var StyledH3 = styled(H3)(_templateObject14$8 || (_templateObject14$8 = _taggedTemplateLiteral(["\n  font-size: 1rem;\n"])));
var Div$4 = styled.div(_templateObject15$8 || (_templateObject15$8 = _taggedTemplateLiteral(["\n  display: flex;\n  right: 1rem;\n  flex-direction: row;\n  align-content: center;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  align-items: center;\n"])));
var SvgDiv = styled.div(_templateObject16$8 || (_templateObject16$8 = _taggedTemplateLiteral(["\n  position: relative;\n  bottom: 2.5rem;\n  padding-right: 0.5rem;\n"])));

var Employer = /*#__PURE__*/function (_Component) {
  function Employer() {
    _classCallCheck$1(this, Employer);
    return _callSuper(this, Employer, arguments);
  }
  _inherits$1(Employer, _Component);
  return _createClass$1(Employer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        employer = _this$props.employer,
        toggleProfile = _this$props.toggleProfile;
      var skills = [];
      var skillsFromEmployer = employer.skills || [];
      skillsFromEmployer.forEach(function (skill) {
        var i = skills.findIndex(function (x) {
          return x.name === skill.name;
        });
        if (i <= -1) skills.push(skill);
      });
      var skillsToDisplay = skills.slice(0, 5);
      var remainingSkills = skills.slice(5);
      return /*#__PURE__*/React__default.createElement(Container$n, {
        onClick: function onClick(event) {
          return toggleProfile && toggleProfile(event, employer.id);
        },
        pointer: !!toggleProfile
      }, /*#__PURE__*/React__default.createElement(Media$1, null, employer.interviews_available && /*#__PURE__*/React__default.createElement(Banner$1, null, "Online interviews available"), employer.interviews_available_via_event && /*#__PURE__*/React__default.createElement(Banner$1, null, "Interviews available at hiring fair"), /*#__PURE__*/React__default.createElement(Img$6, {
        src: employer.header_image_url,
        alt: employer.name
      }), /*#__PURE__*/React__default.createElement(Logo$1, {
        src: employer.logo_url,
        alt: employer.name
      }), /*#__PURE__*/React__default.createElement(Div$4, null, /*#__PURE__*/React__default.createElement(SvgDiv, null, employer.interviews_available && toggleProfile && /*#__PURE__*/React__default.createElement(InterviewButton, {
        width: "42",
        height: "42",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: function onClick(event) {
          return toggleProfile(event, employer.id, "roles");
        }
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M7 4C7.41563 4 7.75 4.33437 7.75 4.75V6H12.25V4.75C12.25 4.33437 12.5844 4 13 4C13.4156 4 13.75 4.33437 13.75 4.75V6H15C16.1031 6 17 6.89688 17 8V8.5V10H16.5H15.5H12H4.5V18C4.5 18.275 4.725 18.5 5 18.5H11.8906C12.275 19.0875 12.7656 19.5969 13.3375 20H5C3.89688 20 3 19.1031 3 18V10V8.5V8C3 6.89688 3.89688 6 5 6H6.25V4.75C6.25 4.33437 6.58437 4 7 4ZM12 15.5C12 14.3065 12.4741 13.1619 13.318 12.318C14.1619 11.4741 15.3065 11 16.5 11C17.6935 11 18.8381 11.4741 19.682 12.318C20.5259 13.1619 21 14.3065 21 15.5C21 16.6935 20.5259 17.8381 19.682 18.682C18.8381 19.5259 17.6935 20 16.5 20C15.3065 20 14.1619 19.5259 13.318 18.682C12.4741 17.8381 12 16.6935 12 15.5ZM16.5 13C16.225 13 16 13.225 16 13.5V15.5C16 15.775 16.225 16 16.5 16H18C18.275 16 18.5 15.775 18.5 15.5C18.5 15.225 18.275 15 18 15H17V13.5C17 13.225 16.775 13 16.5 13Z",
        fill: "white"
      }))), /*#__PURE__*/React__default.createElement(SvgDiv, null, employer.video_url && toggleProfile && /*#__PURE__*/React__default.createElement(PlayButton$1, {
        width: "42",
        height: "42",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: function onClick(event) {
          return toggleProfile(event, employer.id, "photos_and_videos");
        }
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M10 5.5C9.725 5.5 9.5 5.725 9.5 6V13C9.5 13.2719 9.71563 13.4937 9.9875 13.5L12.1469 10.5563C12.2875 10.3625 12.5125 10.25 12.7531 10.25C12.9938 10.25 13.2156 10.3625 13.3594 10.5563L13.875 11.2625L15.625 8.5875C15.7625 8.375 16 8.24687 16.2531 8.24687C16.5063 8.24687 16.7438 8.375 16.8813 8.5875L20.0844 13.4937C20.3219 13.4531 20.5 13.2469 20.5 13V6C20.5 5.725 20.275 5.5 20 5.5H10ZM8 6C8 4.89688 8.89688 4 10 4H20C21.1031 4 22 4.89688 22 6V13C22 14.1031 21.1031 15 20 15H10C8.89688 15 8 14.1031 8 13V6ZM6.25 8H7V9.5V12.25V15.75V16V18.5H13V16H14.5V18.5H16C16.275 18.5 16.5 18.275 16.5 18V16H18V18C18 19.1031 17.1031 20 16 20H14.5H13.75H13H7H6.25H5.5H4C2.89688 20 2 19.1031 2 18V10C2 8.89688 2.89688 8 4 8H5.5H6.25ZM5.5 9.5H4C3.725 9.5 3.5 9.725 3.5 10V11.5H5.5V9.5ZM5.5 18.5V16.5H3.5V18C3.5 18.275 3.725 18.5 4 18.5H5.5ZM3.5 15H5.5V13H3.5V15ZM11.5 6.5C11.7652 6.5 12.0196 6.60536 12.2071 6.79289C12.3946 6.98043 12.5 7.23478 12.5 7.5C12.5 7.76522 12.3946 8.01957 12.2071 8.20711C12.0196 8.39464 11.7652 8.5 11.5 8.5C11.2348 8.5 10.9804 8.39464 10.7929 8.20711C10.6054 8.01957 10.5 7.76522 10.5 7.5C10.5 7.23478 10.6054 6.98043 10.7929 6.79289C10.9804 6.60536 11.2348 6.5 11.5 6.5Z",
        fill: "white"
      }))))), /*#__PURE__*/React__default.createElement(Text$3, null, /*#__PURE__*/React__default.createElement(P$4, {
        variant: "primary",
        size: "small"
      }, employer.location && "".concat(employer.location, " \xB7 "), employer.employer_type), /*#__PURE__*/React__default.createElement(StyledH3, {
        variant: "content"
      }, employer.name), /*#__PURE__*/React__default.createElement(P$4, {
        variant: "contentv2"
      }, !!employer.camp_counselors && "Camp Counselors \xB7 ", !!employer.support_staff && "Support Staff \xB7 ", !!employer.staff_gender && "".concat(employer.staff_gender, " \xB7 "), !!employer.staff_minimum_age && "".concat(employer.staff_minimum_age, "+"), !!employer.number_of_campers && " \xB7 ".concat(employer.number_of_campers, " campers")), skillsToDisplay.length > 0 && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(P$4, {
        variant: "primary",
        marginless: true,
        size: "small"
      }, "Roles available:"), /*#__PURE__*/React__default.createElement(Skills$2, null, skillsToDisplay.map(function (skill) {
        return /*#__PURE__*/React__default.createElement(Skill$2, {
          key: "employer_".concat(employer.id, "_skill_").concat(skill.id)
        }, skill.name);
      }), remainingSkills.length > 0 && /*#__PURE__*/React__default.createElement(Skill$2, {
        key: "employer_".concat(employer.id, "_skills_remaining")
      }, "+ ".concat(remainingSkills.length, " more"))))));
    }
  }]);
}(Component$1);
Employer.propTypes = {
  employer: PropTypes.object.isRequired,
  toggleProfile: PropTypes.func.isRequired,
  skipLinks: PropTypes.bool
};
Employer.defaultProps = {
  skipLinks: false
};

var _templateObject$S, _templateObject2$L, _templateObject3$B, _templateObject4$A, _templateObject5$o, _templateObject6$m, _templateObject7$m, _templateObject8$h, _templateObject9$f, _templateObject0$e;
var getColor = function getColor(variant, lightened) {
  switch (variant) {
    case "primary":
      return function (_ref) {
        var theme = _ref.theme;
        return !!lightened ? lighten(0.025, theme.colors.primary) : theme.colors.primary;
      };
    case "secondary":
      return function (_ref2) {
        var theme = _ref2.theme;
        return !!lightened ? lighten(0.025, theme.colors.secondary) : theme.colors.secondary;
      };
    case "secondaryReadable":
      return function (props) {
        return readableColor(props.theme.colors.secondary, props.theme.colors.buttons.darkColor, props.theme.colors.buttons.lightColor, false);
      };
    default:
      return function (_ref3) {
        var theme = _ref3.theme;
        return !!lightened ? lighten(0.025, theme.colors.body) : theme.colors.body;
      };
  }
};
var getHeightFromSize = function getHeightFromSize(size) {
  switch (size) {
    case "small":
      return "1px";
    default:
      return "2px";
  }
};
var getMargin = function getMargin(margin) {
  switch (margin) {
    case "small":
      return "0.5rem 0";
    default:
      return "1rem 0";
  }
};
var StyledHr = styled.hr(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral(["\n  display: block;\n  height: ", ";\n  color: ", ";\n  background-color: ", ";\n  border: none;\n  margin: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref4) {
  var size = _ref4.size;
  return getHeightFromSize(size);
}, function (_ref5) {
  var variant = _ref5.variant,
    lightened = _ref5.lightened;
  return getColor(variant, lightened);
}, function (_ref6) {
  var variant = _ref6.variant,
    lightened = _ref6.lightened;
  return getColor(variant, lightened);
}, function (_ref7) {
  var margin = _ref7.margin;
  return getMargin(margin);
}, function (props) {
  return !!props.mobileOnly && !props.simpleForm && breakpoint("tablet")(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteral(["\n    display: none;\n  "])));
}, function (props) {
  return props.light && css(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "])), props.theme.colors.primary);
}, function (props) {
  return props.shadow && css(_templateObject4$A || (_templateObject4$A = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "])), setLightness(0.4, props.theme.colors.primaryContrastedDarker));
}, function (props) {
  return props.body && css(_templateObject5$o || (_templateObject5$o = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "])), props.theme.colors.body);
}, function (props) {
  return props.halfMargin && css(_templateObject6$m || (_templateObject6$m = _taggedTemplateLiteral(["\n      margin: 1.5rem 2rem;\n    "])));
}, function (props) {
  return props.halfMargin && breakpoint("desktop")(_templateObject7$m || (_templateObject7$m = _taggedTemplateLiteral(["\n      margin: 0.5rem 1rem;\n  "])));
}, function (props) {
  return props.marginless && breakpoint("tablet")(_templateObject8$h || (_templateObject8$h = _taggedTemplateLiteral(["\n      margin: 0;\n    "])));
}, function (props) {
  return props.navbar && css(_templateObject9$f || (_templateObject9$f = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), setLightness(0.4, props.theme.colors.primaryContrastedDarker));
}, function (props) {
  return props.simpleForm && css(_templateObject0$e || (_templateObject0$e = _taggedTemplateLiteral(["\n      display: block;\n      background-color: #e6e6e6;\n      margin: 1rem 0;\n      height: 1px;\n    "])));
});

var Separator$1 = function Separator(props) {
  return /*#__PURE__*/React__default.createElement(StyledHr, props);
};
Separator$1.propTypes = {
  variant: PropTypes.oneOf(["default", "primary", "secondary"]),
  size: PropTypes.oneOf(["small", "default"]),
  margin: PropTypes.oneOf(["small", "default"]),
  mobileOnly: PropTypes.bool,
  lightened: PropTypes.bool,
  simpleForm: PropTypes.bool
};
Separator$1.defaultProps = {
  variant: "default",
  size: "default",
  margin: "default",
  mobileOnly: true,
  lightened: false,
  simpleForm: false
};

var _templateObject$R, _templateObject2$K, _templateObject3$A, _templateObject4$z, _templateObject5$n, _templateObject6$l, _templateObject7$l;
var Data = styled.div(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral(["\n  display: grid;\n  gap: 2rem;\n  grid-auto-flow: column;\n  justify-content: start;\n"])));
var Datum = styled.div(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteral([""])));
var Key = styled(P$4).attrs({
  marginless: true,
  size: "small",
  color: "primary"
})(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteral(["\n  margin-bottom: 0.25rem;\n"])));
var Value = styled(P$4).attrs({
  marginless: true,
  bold: true
})(_templateObject4$z || (_templateObject4$z = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
  return !!props.negative && css(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteral(["\n      background-color: ", ";\n      padding-left: 0.5rem;\n      padding-right: 0.5rem;\n      border-radius: 0.5rem;\n    "])), props.theme.colors.danger);
}, function (props) {
  return !!props.altNegative && css(_templateObject6$l || (_templateObject6$l = _taggedTemplateLiteral(["\n      background-color: ", ";\n      padding-left: 0.5rem;\n      padding-right: 0.5rem;\n      border-radius: 0.5rem;\n    "])), lighten(0.15, props.theme.colors.danger));
}, function (props) {
  return !!props.positive && css(_templateObject7$l || (_templateObject7$l = _taggedTemplateLiteral(["\n      background-color: ", ";\n      padding-left: 0.5rem;\n      padding-right: 0.5rem;\n      border-radius: 0.5rem;\n    "])), props.theme.colors.success);
});

var BalanceBadge = function BalanceBadge(_ref) {
  var balance = _ref.balance,
    _ref$useAltNegative = _ref.useAltNegative,
    useAltNegative = _ref$useAltNegative === void 0 ? false : _ref$useAltNegative;
  if (balance.toString() === "$0.00") {
    return /*#__PURE__*/React__default.createElement(Value, {
      variant: "secondaryReadable"
    }, balance);
  } else {
    if (balance.toString().includes("-")) {
      return /*#__PURE__*/React__default.createElement(Value, {
        variant: "secondaryReadable",
        positive: balance.toString()
      }, balance);
    } else if (useAltNegative) {
      return /*#__PURE__*/React__default.createElement(Value, {
        variant: "secondaryReadable",
        altNegative: balance.toString()
      }, balance);
    } else {
      return /*#__PURE__*/React__default.createElement(Value, {
        variant: "secondaryReadable",
        negative: balance.toString()
      }, balance);
    }
  }
};
var EmployerFinancialOverview = function EmployerFinancialOverview(_ref2) {
  var employerName = _ref2.employerName,
    totalCosts = _ref2.totalCosts,
    totalDiscounted = _ref2.totalDiscounted,
    totalPaid = _ref2.totalPaid,
    balance = _ref2.balance,
    invoicedBalance = _ref2.invoicedBalance;
  return /*#__PURE__*/React__default.createElement(Card$1, {
    variant: "secondary"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    size: "small",
    marginless: true,
    variant: "secondaryReadable"
  }, employerName), /*#__PURE__*/React__default.createElement(H2$1, {
    size: "large",
    marginless: true,
    variant: "secondaryReadable"
  }, "Account Overview"), /*#__PURE__*/React__default.createElement(Separator$1, {
    size: "small",
    mobileOnly: false,
    variant: "secondaryReadable"
  }), /*#__PURE__*/React__default.createElement(Data, null, /*#__PURE__*/React__default.createElement(Datum, null, /*#__PURE__*/React__default.createElement(Key, {
    variant: "secondaryReadable"
  }, "Total Costs"), /*#__PURE__*/React__default.createElement(Value, {
    variant: "secondaryReadable"
  }, totalCosts)), /*#__PURE__*/React__default.createElement(Datum, null, /*#__PURE__*/React__default.createElement(Key, {
    variant: "secondaryReadable"
  }, "Total Discounted"), /*#__PURE__*/React__default.createElement(Value, {
    variant: "secondaryReadable"
  }, totalDiscounted)), /*#__PURE__*/React__default.createElement(Datum, null, /*#__PURE__*/React__default.createElement(Key, {
    variant: "secondaryReadable"
  }, "Total Paid"), /*#__PURE__*/React__default.createElement(Value, {
    variant: "secondaryReadable"
  }, totalPaid)), /*#__PURE__*/React__default.createElement(Datum, null, /*#__PURE__*/React__default.createElement(Key, {
    variant: "secondaryReadable"
  }, "Total Balance Due"), /*#__PURE__*/React__default.createElement(BalanceBadge, {
    balance: balance
  })), /*#__PURE__*/React__default.createElement(Datum, null, /*#__PURE__*/React__default.createElement(Key, {
    variant: "secondaryReadable"
  }, "Invoiced Balance"), /*#__PURE__*/React__default.createElement(BalanceBadge, {
    balance: invoicedBalance,
    useAltNegative: true
  }))));
};
EmployerFinancialOverview.propTypes = {
  employerName: PropTypes.string.isRequired,
  totalCosts: PropTypes.string.isRequired,
  totalDiscounted: PropTypes.string.isRequired,
  totalPaid: PropTypes.string.isRequired,
  balance: PropTypes.string.isRequired,
  invoicedBalance: PropTypes.string.isRequired
};
EmployerFinancialOverview.defaultProps = {
  employerName: "",
  totalCosts: "",
  totalDiscounted: "",
  totalPaid: "",
  balance: "",
  invoicedBalance: ""
};

var _templateObject$Q, _templateObject2$J;
var Container$m = styled.div(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  padding: 18px;\n  border-radius: 8px;\n  font-size: 16px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.feature.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.feature.text;
});
var Heading = styled.p(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0 0 10px 0;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.feature.text;
});

var _excluded$5 = ["heading", "content", "inlineOnMobile"];
var FeatureContent = function FeatureContent(_ref) {
  var heading = _ref.heading,
    content = _ref.content,
    inlineOnMobile = _ref.inlineOnMobile,
    rest = _objectWithoutProperties$1(_ref, _excluded$5);
  if (!heading && !content) return null;
  if (heading && heading.length == 0 && content && content.length == 0) return null;
  return /*#__PURE__*/React__default.createElement(Container$m, _extends({
    inlineOnMobile: inlineOnMobile,
    className: "ho-feature"
  }, rest), heading && /*#__PURE__*/React__default.createElement(H2$1, {
    marginless: true
  }, /*#__PURE__*/React__default.createElement(Heading, null, heading)), /*#__PURE__*/React__default.createElement(Markdown, {
    componentStyles: {
      h1: {
        variant: "primary"
      }
    }
  }, content));
};
FeatureContent.propTypes = {
  content: PropTypes.string.isRequired,
  heading: PropTypes.string
};
FeatureContent.defaultProps = {
  inlineOnMobile: false
};

var _templateObject$P, _templateObject2$I, _templateObject3$z, _templateObject4$y;
var Icon$2 = styled(CloseIcon$1)(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  right: 3px;\n  top: 3px;\n  border-radius: 100%;\n  color: #fff;\n\n  ", "\n"])), function (props) {
  return css(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), props.theme.colors.primary);
});
var Image = styled.img(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n"])));
var ImageWrapper$1 = styled.div(_templateObject4$y || (_templateObject4$y = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n"])));

var GalleryImage = function GalleryImage(_ref) {
  var image = _ref.image,
    closeAlert = _ref.closeAlert;
  return /*#__PURE__*/React__default.createElement(ImageWrapper$1, null, /*#__PURE__*/React__default.createElement(Icon$2, {
    onClick: closeAlert
  }), /*#__PURE__*/React__default.createElement(Image, {
    key: image.toString(),
    src: image.url,
    alt: image.alt
  }));
};
GalleryImage.propTypes = {
  image: PropTypes.object.isRequired,
  closeAlert: PropTypes.func.isRequired
};
GalleryImage.defaultProps = {
  image: {},
  closeAlert: undefined
};

var _templateObject$O, _templateObject2$H, _templateObject3$y, _templateObject4$x, _templateObject5$m, _templateObject6$k, _templateObject7$k, _templateObject8$g, _templateObject9$e, _templateObject0$d;
var Container$l = styled.div(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral(["\n  margin-bottom: 0rem;\n  ", "\n  ", "\n"])), function (_ref) {
  var gridArea = _ref.gridArea;
  return gridArea !== undefined && css(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteral(["\n      grid-area: ", ";\n    "])), gridArea));
}, breakpoint("tablet")(_templateObject4$x || (_templateObject4$x = _taggedTemplateLiteral(["\n    margin-bottom: 2rem;\n  "]))));
styled.div(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteral(["\n  text-align: right;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject6$k || (_templateObject6$k = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
styled.div(_templateObject7$k || (_templateObject7$k = _taggedTemplateLiteral(["\n  ", "\n"])), breakpoint("tablet")(_templateObject8$g || (_templateObject8$g = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var StyledHeading = styled.h1(_templateObject9$e || (_templateObject9$e = _taggedTemplateLiteral(["\n  margin: 0;\n  letter-spacing: -1px;\n  color: ", ";\n  margin-bottom: 32px;\n\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.fields.text;
}, breakpoint("desktop")(_templateObject0$d || (_templateObject0$d = _taggedTemplateLiteral(["\n    font-size: 32px;    \n  "]))));

var Header$4 = function Header(_ref) {
  var title = _ref.title,
    gridArea = _ref.gridArea,
    image = _ref.image,
    simpleFormLayout = _ref.simpleFormLayout,
    homePage = _ref.homePage;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !!simpleFormLayout ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledHeading, null, title)) : /*#__PURE__*/React__default.createElement(Container$l, {
    gridArea: gridArea,
    className: "ho-header"
  }, !!image ? /*#__PURE__*/React__default.createElement(Card$1, {
    variant: "primary",
    image: image,
    roundedOnMobile: false
  }, /*#__PURE__*/React__default.createElement(H1$1, {
    size: "3xlarge",
    marginless: true
  }, title)) : /*#__PURE__*/React__default.createElement(Card$1, {
    variant: "primary",
    gradient: true,
    pageMargin: true,
    desktopOnly: homePage
  }, /*#__PURE__*/React__default.createElement(H1$1, {
    size: "large",
    marginless: true
  }, title))));
};
Header$4.propTypes = {
  title: PropTypes.string.isRequired,
  gridArea: PropTypes.string,
  image: PropTypes.string
};
Header$4.defaultProps = {
  gridArea: undefined,
  image: undefined
};

var _templateObject$N, _templateObject2$G, _templateObject3$x, _templateObject4$w, _templateObject5$l, _templateObject6$j, _templateObject7$j, _templateObject8$f, _templateObject9$d;
var Card = styled.a(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral(["\n  background-color: white;\n  border: 1px solid ", ";\n  border-radius: 1rem;\n  overflow: hidden;\n  box-sizing: border-box;\n  margin-bottom: 1rem;\n  margin-top: 1.2rem;\n  display: flex;\n\n  background-color: #f6f6f6;\n  text-decoration: none;\n  cursor: default;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
}, function (_ref2) {
  var alert = _ref2.alert;
  return !!alert && "\n    border-color: #ffb20f;\n    background-color: rgba(255, 178, 15, 0.2);\n    ";
}, function (_ref3) {
  var href = _ref3.href;
  return !!href && href.length > 1 && "\n    cursor: pointer;\n\n    &:hover {\n      a {\n        text-decoration: underline;\n      }\n    }\n  ";
}, breakpoint("tablet")(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteral(["\n    margin-top: 0;\n    margin-bottom: 2rem;\n  "]))), function (_ref4) {
  var mobileOnly = _ref4.mobileOnly;
  return !!mobileOnly && breakpoint("tablet")(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteral(["\n    display: none;\n  "])));
}, function (_ref5) {
  var desktopOnly = _ref5.desktopOnly;
  return !!desktopOnly && css(_templateObject4$w || (_templateObject4$w = _taggedTemplateLiteral(["\n      display: none;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteral(["\n      display: grid;\n    "]))));
});
var Img$5 = styled.img(_templateObject6$j || (_templateObject6$j = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 33%;\n  object-fit: cover;\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
});
var Content$3 = styled.div(_templateObject7$j || (_templateObject7$j = _taggedTemplateLiteral(["\n  flex: 1;\n\n  color: ", ";\n  font-family: ", ", sans-serif;\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.body;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fonts.body.family;
});
var StyledContent = styled(Markdown)(_templateObject8$f || (_templateObject8$f = _taggedTemplateLiteral(["\n  display: block;\n  padding: 0;\n  margin: 1rem;\n\n  a {\n    color: ", ";\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.primary;
});
var StyledLink$2 = styled.a(_templateObject9$d || (_templateObject9$d = _taggedTemplateLiteral(["\n  display: block;\n  margin: 0 1rem 1rem;\n\n  color: ", ";\n  text-decoration: none;\n\n  svg {\n    font-size: 0.8rem;\n  }\n  span {\n    margin-right: 0.25rem;\n  }\n"])), function (_ref0) {
  var theme = _ref0.theme;
  return theme.colors.primary;
});

var Highlight = function Highlight(_ref) {
  var data = _ref.data,
    mobileOnly = _ref.mobileOnly,
    desktopOnly = _ref.desktopOnly;
  if (!data) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Card, {
    alert: !!data.alert,
    href: data.url,
    target: data.url_in_new_window ? "_blank" : "",
    mobileOnly: mobileOnly,
    desktopOnly: desktopOnly
  }, data.thumbnail && /*#__PURE__*/React__default.createElement(Img$5, {
    src: data.thumbnail
  }), /*#__PURE__*/React__default.createElement(Content$3, null, /*#__PURE__*/React__default.createElement(StyledContent, {
    componentStyles: {
      generic: {
        variant: "content"
      }
    }
  }, data.content), !!data.url && /*#__PURE__*/React__default.createElement(StyledLink$2, null, /*#__PURE__*/React__default.createElement("span", null, "Learn more"), /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faChevronRight,
    size: "1x"
  }))));
};

var _templateObject$M, _templateObject2$F, _templateObject3$w, _templateObject4$v;
var flexStyles = css(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var Container$k = styled.div(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var mobile = _ref.mobile;
  return !mobile && css(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteral(["\n      display: grid;\n      gap: 0.5rem;\n    "])));
}, function (_ref2) {
  var mobile = _ref2.mobile;
  return !!mobile && flexStyles;
}, breakpoint("tablet")(_templateObject4$v || (_templateObject4$v = _taggedTemplateLiteral(["\n    ", "\n  "])), flexStyles));

var Level = function Level(_ref) {
  var children = _ref.children,
    mobile = _ref.mobile;
  return /*#__PURE__*/React__default.createElement(Container$k, {
    mobile: mobile
  }, children);
};
Level.propTypes = {
  children: PropTypes.node.isRequired,
  mobile: PropTypes.bool
};
Level.defaultProps = {
  mobile: true
};

var _templateObject$L, _templateObject2$E, _templateObject3$v, _templateObject4$u, _templateObject5$k, _templateObject6$i, _templateObject7$i;
var Container$j = styled.div(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral(["\n  width: 60%;\n  position: relative;\n  top: 2px;\n  display: flex;\n  align-items: center;\n  max-width: 50%;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.small && css(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteral(["\n      width: 30%;\n    "])));
}, function (props) {
  return props.mobileOnly && breakpoint("tablet")(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteral(["\n    display: none;\n  "])));
}, function (props) {
  return props.tabletOnly && breakpoint("desktop")(_templateObject4$u || (_templateObject4$u = _taggedTemplateLiteral(["\n    display: none;\n  "])));
}, breakpoint("tablet")(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteral(["\n    top: 0;\n    max-width: 300px;\n  "]))));
var Img$4 = styled.img(_templateObject6$i || (_templateObject6$i = _taggedTemplateLiteral(["\n  width: 100%;\n  max-height: 70px;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject7$i || (_templateObject7$i = _taggedTemplateLiteral(["\n    max-height: initial\n  "]))));

var Logo = function Logo(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    mobileOnly = _ref.mobileOnly,
    tabletOnly = _ref.tabletOnly;
  return /*#__PURE__*/React__default.createElement(Container$j, {
    mobileOnly: mobileOnly,
    tabletOnly: tabletOnly
  }, /*#__PURE__*/React__default.createElement(Img$4, {
    src: src,
    alt: alt
  }));
};

var LogoutButton = function LogoutButton() {
  return /*#__PURE__*/React__default.createElement(Button$5, {
    to: "/logout",
    variant: "special",
    outlined: true
  }, "Log out");
};

var _templateObject$K, _templateObject2$D, _templateObject3$u, _templateObject4$t, _templateObject5$j, _templateObject6$h, _templateObject7$h, _templateObject8$e, _templateObject9$c, _templateObject0$c, _templateObject1$b, _templateObject10$a, _templateObject11$a, _templateObject12$9, _templateObject13$7, _templateObject14$7, _templateObject15$7, _templateObject16$7, _templateObject17$6, _templateObject18$5, _templateObject19$4, _templateObject20$3, _templateObject21$1, _templateObject22$1, _templateObject23$1, _templateObject24$1, _templateObject25$1, _templateObject26$1, _templateObject27$1, _templateObject28$1, _templateObject29$1, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37;
var getBackgroundColor = function getBackgroundColor(variant) {
  switch (variant) {
    case "primary":
      return function (props) {
        return props.theme.colors.primary;
      };
    case "secondary":
      return function (props) {
        return props.theme.colors.secondaryAlternative || props.theme.colors.secondary;
      };
    case "white":
      return "white";
    default:
      return function (props) {
        return props.theme.colors.lightGrey;
      };
  }
};
var StyledCard = styled.div(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral(["\n  ", "\n\n  color: ", ";\n  background-color: ", ";\n  border-radius: 1rem;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var forceMobile = _ref.forceMobile;
  return !forceMobile && css(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteral(["\n        display: grid;\n        grid: auto / 10rem 1fr;\n        min-height: 10rem;\n\n    ", "\n      "])), function (_ref2) {
    var fullWidth = _ref2.fullWidth;
    return !!fullWidth ? css(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteral(["\n            width: 100% !important;\n          "]))) : css(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteral(["\n            width: auto !important;\n          "])));
  }));
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.body;
}, function (_ref4) {
  var variant = _ref4.variant;
  return getBackgroundColor(variant);
}, function (_ref5) {
  var gridArea = _ref5.gridArea,
    forceMobile = _ref5.forceMobile;
  return gridArea !== undefined && !forceMobile && css(_templateObject6$h || (_templateObject6$h = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject7$h || (_templateObject7$h = _taggedTemplateLiteral(["\n      grid-area: ", ";\n    "])), gridArea));
}, function (_ref6) {
  var simpleForm = _ref6.simpleForm;
  return !!simpleForm && css(_templateObject8$e || (_templateObject8$e = _taggedTemplateLiteral(["\n      display: flex !important;\n      background-color: #fff;\n      border: 1px solid #e6e6e6;\n      padding: 24px;\n      width: auto !important;\n      flex-direction: column;\n      min-height: 8rem !important;\n      gap: 24px;\n\n      ", "\n\n      ", "\n    "])), function (_ref7) {
    var featured = _ref7.featured;
    return featured && css(_templateObject9$c || (_templateObject9$c = _taggedTemplateLiteral(["\n          border-radius: 16px;\n          border-top: 8px solid ", ";\n          border-right: 1px solid ", ";\n          border-bottom: 1px solid ", ";\n          border-left: 1px solid ", ";\n          background: ", ";\n        "])), function (_ref8) {
      var theme = _ref8.theme;
      return theme.colors.primary;
    }, function (_ref9) {
      var theme = _ref9.theme;
      return theme.colors.primary;
    }, function (_ref0) {
      var theme = _ref0.theme;
      return theme.colors.primary;
    }, function (_ref1) {
      var theme = _ref1.theme;
      return theme.colors.primary;
    }, function (_ref10) {
      var theme = _ref10.theme;
      return theme.colors.rgbaBrandLightened;
    });
  }, function (_ref11) {
    var forceMobile = _ref11.forceMobile;
    return !forceMobile && css(_templateObject0$c || (_templateObject0$c = _taggedTemplateLiteral(["\n          ", "\n        "])), breakpoint("tablet")(_templateObject1$b || (_templateObject1$b = _taggedTemplateLiteral(["\n            flex-direction: row;\n            align-items: center;\n            align-self: stretch;\n          "]))));
  });
});
var ImgContainer = styled.div(_templateObject10$a || (_templateObject10$a = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n\n  ", "\n"])), function (_ref12) {
  var simpleForm = _ref12.simpleForm;
  return !!simpleForm && css(_templateObject11$a || (_templateObject11$a = _taggedTemplateLiteral(["\n      height: 294px;\n      width: auto;\n\n      ", "\n    "])), function (_ref13) {
    var forceMobile = _ref13.forceMobile;
    return !forceMobile && css(_templateObject12$9 || (_templateObject12$9 = _taggedTemplateLiteral(["\n          ", "\n        "])), breakpoint("tablet")(_templateObject13$7 || (_templateObject13$7 = _taggedTemplateLiteral(["\n            min-width: 144px;\n            min-height: 144px;\n            width: 144px;\n            height: 144px;\n          "]))));
  });
});
var Img$3 = styled.img(_templateObject14$7 || (_templateObject14$7 = _taggedTemplateLiteral(["\n  display: block;\n  z-index: 2;\n  border-radius: 1rem 1rem 0 0;\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  object-position: 50% 50%;\n  margin: 0;\n  padding: 0;\n  background-color: #cccccc;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref14) {
  var forceMobile = _ref14.forceMobile;
  return !forceMobile && css(_templateObject15$7 || (_templateObject15$7 = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject16$7 || (_templateObject16$7 = _taggedTemplateLiteral(["\n        border-radius: 1rem 0 0 1rem;\n      "]))));
}, function (_ref15) {
  var completed = _ref15.completed;
  return !!completed && css(_templateObject17$6 || (_templateObject17$6 = _taggedTemplateLiteral(["\n      opacity: 0.9;\n    "])));
}, function (_ref16) {
  var simpleForm = _ref16.simpleForm;
  return !!simpleForm && css(_templateObject18$5 || (_templateObject18$5 = _taggedTemplateLiteral(["\n      border-radius: 8px !important;\n    "])));
});
var ImgWrapper = styled.div(_templateObject19$4 || (_templateObject19$4 = _taggedTemplateLiteral(["\n  width: inherit;\n  height: inherit;\n  border-radius: 8px;\n  ", "\n"])), function (_ref17) {
  var completed = _ref17.completed;
  return !!completed && css(_templateObject20$3 || (_templateObject20$3 = _taggedTemplateLiteral(["\n      background:\n        linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),\n        url(<path-to-image>) lightgray 50% / cover no-repeat;\n    "])));
});
var Content$2 = styled.div(_templateObject21$1 || (_templateObject21$1 = _taggedTemplateLiteral(["\n  padding: 1rem 1rem 2rem 1rem;\n  display: grid;\n  place-content: center stretch;\n  gap: 1rem;\n\n  ", "\n\n  ", "\n"])), function (_ref18) {
  var forceMobile = _ref18.forceMobile;
  return !forceMobile && css(_templateObject22$1 || (_templateObject22$1 = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject23$1 || (_templateObject23$1 = _taggedTemplateLiteral(["\n        padding: 1rem;\n      "]))));
}, function (_ref19) {
  var simpleForm = _ref19.simpleForm;
  return !!simpleForm && css(_templateObject24$1 || (_templateObject24$1 = _taggedTemplateLiteral(["\n      display: flex;\n      flex-direction: column;\n      flex: 1 0 0;\n      padding: 0 !important;\n      gap: 8px;\n    "])));
});
var Icon$1 = styled(FontAwesomeIcon)(_templateObject25$1 || (_templateObject25$1 = _taggedTemplateLiteral(["\n  z-index: 3;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 4rem;\n\n  ", "\n"])), function (_ref20) {
  var forceMobile = _ref20.forceMobile;
  return !forceMobile && css(_templateObject26$1 || (_templateObject26$1 = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject27$1 || (_templateObject27$1 = _taggedTemplateLiteral(["\n        font-size: 2rem;\n      "]))));
});
var ReferralContainer = styled.div(_templateObject28$1 || (_templateObject28$1 = _taggedTemplateLiteral(["\n  border-radius: 8px;\n  border: 1px dashed ", ";\n  background: ", ";\n  display: flex;\n  padding: 12px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n\n  ", "\n"])), function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.primary;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.rgbaBrandLightened;
}, function (_ref23) {
  var clickable = _ref23.clickable;
  return clickable && css(_templateObject29$1 || (_templateObject29$1 = _taggedTemplateLiteral(["\n      &:hover {\n        cursor: pointer;\n      }\n    "])));
});
var ReferralCode = styled.p(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #333;\n  text-align: center;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 0;\n\n  svg {\n    color: ", ";\n  }\n"])), function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.primary;
});
var Url = styled.a(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid #999;\n  background: #fff;\n  padding: 12px 24px;\n  width: -webkit-fill-available;\n  min-width: max-content;\n  text-decoration: none;\n  color: #333;\n  line-height: 24px;\n"])));
var Actions$1 = styled.div(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  border-top: 1px solid #e6e6e6;\n  padding-top: 24px;\n  padding-left: 0;\n  width: 100%;\n\n  ", "\n"])), function (_ref25) {
  var forceMobile = _ref25.forceMobile;
  return !forceMobile && css(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n        border-top: 0;\n        border-left: 1px solid #E6E6E6;\n        padding-left: 24px;\n        padding-top: 0;\n        width: 240px;\n      "]))));
});
var UrlWrapper = styled.a(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  text-decoration: none;\n  color: ", ";\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.body;
});
var H2 = styled.h2(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  font-family: ", ", sans-serif;\n  margin: 0;\n\n  ", "\n"])), function (props) {
  return props.theme.fonts.body.family;
}, function (_ref27) {
  var simpleForm = _ref27.simpleForm;
  return !!simpleForm && css(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n      color: #333;\n      font-size: 20px;\n    "])));
});

var Component = {};

var toggleSelection = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;
  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }
  switch (active.tagName.toUpperCase()) {
    // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;
    default:
      active = null;
      break;
  }
  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' && selection.removeAllRanges();
    if (!selection.rangeCount) {
      ranges.forEach(function (range) {
        selection.addRange(range);
      });
    }
    active && active.focus();
  };
};

var deselectCurrent = toggleSelection;
var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
};
var defaultMessage = "Copy to clipboard: #{key}, Enter";
function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}
function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();
    range = document.createRange();
    selection = document.getSelection();
    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true";
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function (e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") {
          // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
          window.clipboardData.setData(format, text);
        } else {
          // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });
    document.body.appendChild(mark);
    range.selectNodeContents(mark);
    selection.addRange(range);
    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }
    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }
  return success;
}
var copyToClipboard = copy;

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(Component, "__esModule", {
  value: true
});
Component.CopyToClipboard = void 0;
var _react = _interopRequireDefault(React__default);
var _copyToClipboard = _interopRequireDefault(copyToClipboard);
var _excluded$4 = ["text", "onCopy", "options", "children"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var CopyToClipboard$1 = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);
  var _super = _createSuper(CopyToClipboard);
  function CopyToClipboard() {
    var _this;
    _classCallCheck(this, CopyToClipboard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
        text = _this$props.text,
        onCopy = _this$props.onCopy,
        children = _this$props.children,
        options = _this$props.options;
      var elem = _react["default"].Children.only(children);
      var result = (0, _copyToClipboard["default"])(text, options);
      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present

      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });
    return _this;
  }
  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props;
        _this$props2.text;
        _this$props2.onCopy;
        _this$props2.options;
        var children = _this$props2.children,
        props = _objectWithoutProperties(_this$props2, _excluded$4);
      var elem = _react["default"].Children.only(children);
      return /*#__PURE__*/_react["default"].cloneElement(elem, _objectSpread(_objectSpread({}, props), {}, {
        onClick: this.onClick
      }));
    }
  }]);
  return CopyToClipboard;
}(_react["default"].PureComponent);
Component.CopyToClipboard = CopyToClipboard$1;
_defineProperty(CopyToClipboard$1, "defaultProps", {
  onCopy: undefined,
  options: undefined
});

var _require = Component,
  CopyToClipboard = _require.CopyToClipboard;
CopyToClipboard.CopyToClipboard = CopyToClipboard;
var lib = CopyToClipboard;

var _excluded$3 = ["children", "image", "completed", "referralCode", "url", "title", "locked", "simpleForm", "forceMobile", "alert", "buttonLabel"];
var showUrl = function showUrl(url, locked) {
  return !!url && !locked;
};
var MediaCard = function MediaCard(_ref) {
  var children = _ref.children,
    image = _ref.image,
    completed = _ref.completed,
    referralCode = _ref.referralCode,
    url = _ref.url,
    title = _ref.title,
    locked = _ref.locked,
    simpleForm = _ref.simpleForm,
    forceMobile = _ref.forceMobile,
    alert = _ref.alert,
    buttonLabel = _ref.buttonLabel,
    rest = _objectWithoutProperties$1(_ref, _excluded$3);
  return /*#__PURE__*/React__default.createElement(StyledCard, _extends({
    simpleForm: simpleForm,
    forceMobile: forceMobile
  }, rest), /*#__PURE__*/React__default.createElement(ImgContainer, {
    simpleForm: simpleForm,
    forceMobile: forceMobile
  }, showUrl(url, locked) ? /*#__PURE__*/React__default.createElement(UrlWrapper, {
    href: url,
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(Img$3, {
    src: image,
    completed: completed,
    simpleForm: simpleForm,
    forceMobile: forceMobile
  })) : /*#__PURE__*/React__default.createElement(ImgWrapper, {
    completed: completed
  }, /*#__PURE__*/React__default.createElement(Img$3, {
    src: image,
    completed: completed,
    simpleForm: simpleForm,
    forceMobile: forceMobile
  })), !!completed && !locked && /*#__PURE__*/React__default.createElement(Icon$1, {
    icon: faCheck
  }), !!locked && !completed && /*#__PURE__*/React__default.createElement(Icon$1, {
    icon: faLock$1
  })), /*#__PURE__*/React__default.createElement(Content$2, {
    simpleForm: simpleForm,
    forceMobile: forceMobile
  }, !!title && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showUrl(url, locked) ? /*#__PURE__*/React__default.createElement(UrlWrapper, {
    href: url,
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(H2, {
    simpleForm: simpleForm,
    forceMobile: forceMobile
  }, title)) : /*#__PURE__*/React__default.createElement(H2, {
    simpleForm: simpleForm,
    forceMobile: forceMobile
  }, title)), children), referralCode !== undefined && /*#__PURE__*/React__default.createElement(Actions$1, {
    forceMobile: forceMobile
  }, referralCode === false ? /*#__PURE__*/React__default.createElement(ReferralContainer, {
    clickable: false
  }, /*#__PURE__*/React__default.createElement(ReferralCode, null, "NO CODE REQUIRED")) : !!referralCode && /*#__PURE__*/React__default.createElement(lib.CopyToClipboard, {
    text: referralCode,
    onCopy: function onCopy() {
      alert.success("Referral code copied to clipboard");
    }
  }, /*#__PURE__*/React__default.createElement(ReferralContainer, {
    clickable: true
  }, /*#__PURE__*/React__default.createElement(ReferralCode, null, referralCode, " ", /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCopy
  })))), !!url && showUrl(url, locked) && /*#__PURE__*/React__default.createElement(Url, {
    href: url,
    target: "_blank"
  }, buttonLabel || "Visit website")));
};
MediaCard.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["default", "primary", "secondary", "white"]),
  gridArea: PropTypes.string,
  image: PropTypes.string.isRequired,
  completed: PropTypes.bool,
  locked: PropTypes.bool,
  url: PropTypes.string,
  forceMobile: PropTypes.bool
};
MediaCard.defaultProps = {
  variant: "default",
  gridArea: undefined,
  completed: false,
  locked: false,
  url: undefined,
  forceMobile: false
};

var NewMessageForm = /*#__PURE__*/function (_React$Component) {
  function NewMessageForm(props) {
    var _this;
    _classCallCheck$1(this, NewMessageForm);
    _this = _callSuper(this, NewMessageForm, [props]);
    _defineProperty$1(_this, "handleChange", function (e) {
      _this.setState({
        text: e.target.value
      });
    });
    _defineProperty$1(_this, "submitHandler", function (e) {
      e.preventDefault();
      _this.props.submitHandler(_this.state.text).then(function () {
        _this.setState({
          text: ""
        });
      });
    });
    _defineProperty$1(_this, "render", function () {
      var _this2 = _this,
        submitHandler = _this2.submitHandler,
        handleChange = _this2.handleChange;
      var text = _this.state.text;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "newMessageForm"
      }, /*#__PURE__*/React__default.createElement("form", {
        onSubmit: submitHandler
      }, /*#__PURE__*/React__default.createElement("label", null, "New Message:"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("input", {
        type: "text",
        value: text,
        onChange: handleChange
      }), /*#__PURE__*/React__default.createElement("input", {
        type: "submit"
      })));
    });
    _this.state = {
      text: ""
    };
    return _this;
  }
  _inherits$1(NewMessageForm, _React$Component);
  return _createClass$1(NewMessageForm);
}(React__default.Component);
NewMessageForm.propTypes = {
  submitHandler: PropTypes.func.isRequired
};

var MessagesArea = /*#__PURE__*/function (_React$Component) {
  function MessagesArea(props) {
    var _this;
    _classCallCheck$1(this, MessagesArea);
    _this = _callSuper(this, MessagesArea, [props]);
    _this.state = {
      conversationTitle: props.conversationTitle,
      conversationMessages: props.conversationMessages
    };
    return _this;
  }
  _inherits$1(MessagesArea, _React$Component);
  return _createClass$1(MessagesArea, [{
    key: "mapMessages",
    value: function mapMessages(conversationMessages) {
      return conversationMessages.map(function (message) {
        return /*#__PURE__*/React__default.createElement("li", {
          key: message.id
        }, message.text, " - from ", message.fromUserName, " at ", message.created_at.toString());
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.conversationMessages !== this.props.conversationMessages) {
        this.setState({
          conversationMessages: this.props.conversationMessages
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var mapMessages = this.mapMessages;
      var _this$state = this.state,
        conversationTitle = _this$state.conversationTitle,
        conversationMessages = _this$state.conversationMessages;
      console.log(conversationMessages);
      return /*#__PURE__*/React__default.createElement(Card$1, {
        variant: "primary"
      }, conversationMessages.constructor === Array && conversationMessages.length > 0 && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("h1", null, conversationTitle), /*#__PURE__*/React__default.createElement("ul", null, mapMessages(conversationMessages))), /*#__PURE__*/React__default.createElement(NewMessageForm, {
        submitHandler: this.props.submitHandler
      }));
    }
  }]);
}(React__default.Component);
MessagesArea.propTypes = {
  conversationTitle: PropTypes.string.isRequired,
  conversationMessages: PropTypes.array.isRequired,
  submitHandler: PropTypes.func.isRequired
};
MessagesArea.defaultProps = {
  conversationTitle: "Conversation",
  conversationMessages: []
};

var _templateObject$J, _templateObject2$C, _templateObject3$t, _templateObject4$s, _templateObject5$i, _templateObject6$g, _templateObject7$g, _templateObject8$d;
var Dialog = styled.dialog(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral(["\n  width: 100%;\n  border: none;\n  border-radius: 8px;\n  padding: 0;\n  background-color: #fff;\n  color: ", ";\n  z-index: 1000; // Ensures the modal is on top of other elements\n\n  &::backdrop {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.colors.content.text;
}, breakpoint("desktop")(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteral(["\n    width: 90%;\n    max-width: 30%;\n  "]))), function (_ref) {
  var narrow = _ref.narrow;
  return narrow && css(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteral(["\n      width: 360px;\n      max-width: unset;\n\n      ", "\n    "])), breakpoint("desktop")(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteral(["\n        width: 410px;\n      "]))));
});
var HeaderBar = styled.div(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: row;\n  padding: 20px;\n\n  ", "\n"])), function (_ref2) {
  var _short = _ref2["short"];
  return _short && css(_templateObject6$g || (_templateObject6$g = _taggedTemplateLiteral(["\n      padding: 10px 20px;\n    "])));
});
var Content$1 = styled.div(_templateObject7$g || (_templateObject7$g = _taggedTemplateLiteral(["\n  padding: 0 20px 20px;\n\n  ", "\n"])), function (_ref3) {
  var clear = _ref3.clear;
  return clear && css(_templateObject8$d || (_templateObject8$d = _taggedTemplateLiteral(["\n      background: white;\n    "])));
});

var Modal = function Modal(_ref) {
  var isOpen = _ref.isOpen,
    hasCloseBtn = _ref.hasCloseBtn,
    onClose = _ref.onClose,
    children = _ref.children,
    header = _ref.header,
    employerTile = _ref.employerTile;
  var dialogRef = useRef(null);
  useEffect(function () {
    if (isOpen) {
      dialogRef.current.showModal(); // Opens the dialog as a modal
    } else {
      dialogRef.current.close(); // Closes the dialog
    }
  }, [isOpen]);
  var handleCloseModal = function handleCloseModal() {
    if (onClose) onClose();
    dialogRef.current.close(); // Ensure the dialog is closed
    return true;
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === "Escape") handleCloseModal();
  };
  var isClickInsideDialog = function isClickInsideDialog(e, element) {
    var r = element.getBoundingClientRect();
    var isInside = e.clientX > r.left && e.clientX < r.right && e.clientY > r.top && e.clientY < r.bottom; // Are we clicking inside the dialog?

    return isInside;
  };
  var dialogClickHandler = function dialogClickHandler(e) {
    if (e.target.classList.contains("close-icon") || e.target.closest(".close-icon")) return;
    if (!dialogRef.current) return;
    if (isClickInsideDialog(e, dialogRef.current)) return;
    handleCloseModal();
  };
  var closeButtonClickHandler = function closeButtonClickHandler() {
    if (!dialogRef.current) return;
    handleCloseModal();
  };
  return /*#__PURE__*/React__default.createElement(Dialog, {
    onKeyDown: handleKeyDown,
    className: "modal",
    ref: dialogRef,
    onClick: dialogClickHandler,
    narrow: employerTile
  }, /*#__PURE__*/React__default.createElement(HeaderBar, {
    "short": employerTile
  }, /*#__PURE__*/React__default.createElement(H1$1, {
    variant: "primary",
    size: employerTile ? "small" : "default",
    marginless: true
  }, header), hasCloseBtn && /*#__PURE__*/React__default.createElement(CloseIcon$1, {
    variant: "content",
    size: "large",
    style: {
      marginRight: "-0.75rem"
    },
    onClick: closeButtonClickHandler
  })), /*#__PURE__*/React__default.createElement(Content$1, {
    clear: employerTile
  }, isOpen && children));
};
Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  hasCloseBtn: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  header: PropTypes.string.isRequired,
  employerTile: PropTypes.bool
};
Modal.defaultProps = {
  hasCloseBtn: true,
  narrow: false
};

var _templateObject$I, _templateObject2$B, _templateObject3$s, _templateObject4$r;
var Container$i = styled.nav(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  overflow-x: auto;\n  overflow-y: auto;\n  margin: 0;\n  padding: 0;\n\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var compact = _ref.compact;
  return !!compact && css(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteral(["\n      gap: 1rem;\n    "])));
}, function (_ref2) {
  var profile = _ref2.profile;
  return !!profile && css(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteral(["\n      display: none;\n      flex-direction: column;\n      align-items: start;\n      gap: 27px;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteral(["\n        display: flex;\n        padding-bottom: 24px;\n      "]))));
});

var _templateObject$H, _templateObject2$A, _templateObject3$r, _templateObject4$q, _templateObject5$h, _templateObject6$f, _templateObject7$f, _templateObject8$c, _templateObject9$b, _templateObject0$b, _templateObject1$a, _templateObject10$9, _templateObject11$9, _templateObject12$8, _templateObject13$6, _templateObject14$6, _templateObject15$6, _templateObject16$6, _templateObject17$5, _templateObject18$4, _templateObject19$3, _templateObject20$2, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29;
var selectedStyle = css(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral(["\n  display: block;\n  height: 100%;\n  border-radius: 5px;\n  background-color: ", ";\n  position: relative;\n  overflow: hidden;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
var Selected = styled.span(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteral(["\n  display: none;\n\n  ", "\n"])), function (_ref2) {
  var selected = _ref2.selected;
  return selected && selectedStyle;
});
var Container$h = styled.div(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteral(["\n  cursor: pointer;\n  width: 100%;\n\n  &:hover {\n    ", " {\n      ", "\n    }\n  }\n\n  ", "\n"])), Selected, selectedStyle, function (_ref3) {
  var compact = _ref3.compact;
  return css(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteral(["\n    ", "\n  "])), compact && css(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteral(["\n      width: auto;\n    "]))));
});
var Content = styled.div(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  text-align: center;\n\n  ", "\n\n  ", "\n"])), function (_ref4) {
  var compact = _ref4.compact;
  return css(_templateObject7$f || (_templateObject7$f = _taggedTemplateLiteral(["\n    ", "\n  "])), compact && css(_templateObject8$c || (_templateObject8$c = _taggedTemplateLiteral(["\n      padding: 0.5rem;\n    "]))));
}, function (_ref5) {
  var profile = _ref5.profile;
  return !!profile && css(_templateObject9$b || (_templateObject9$b = _taggedTemplateLiteral(["\n      text-align: left;\n      justify-content: start;\n      padding: 0;\n      gap: 16px;\n      align-items: stretch;\n    "])));
});
var Icon = styled(FontAwesomeIcon)(_templateObject0$b || (_templateObject0$b = _taggedTemplateLiteral(["\n  color: ", ";\n\n  ", "\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
}, function (_ref7) {
  var compact = _ref7.compact,
    selected = _ref7.selected;
  return css(_templateObject1$a || (_templateObject1$a = _taggedTemplateLiteral(["\n    ", "\n\n    ", "\n  "])), compact && css(_templateObject10$9 || (_templateObject10$9 = _taggedTemplateLiteral(["\n      color: #dddddd;\n    "]))), compact && selected && css(_templateObject11$9 || (_templateObject11$9 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.primary;
  }));
});
var Name$1 = styled.div(_templateObject12$8 || (_templateObject12$8 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n  white-space: nowrap;\n  font-family: ", ", sans-serif;\n\n  ", "\n\n  ", "\n\n    ", "\n"])), function (_ref9) {
  var _theme$colors$nav;
  var theme = _ref9.theme;
  return ((_theme$colors$nav = theme.colors.nav) === null || _theme$colors$nav === void 0 ? void 0 : _theme$colors$nav.name) || theme.colors.secondary;
}, function (_ref0) {
  var theme = _ref0.theme;
  return theme.fonts.body.family;
}, function (_ref1) {
  var compact = _ref1.compact,
    selected = _ref1.selected;
  return css(_templateObject13$6 || (_templateObject13$6 = _taggedTemplateLiteral(["\n    ", "\n\n    ", "\n  "])), compact && css(_templateObject14$6 || (_templateObject14$6 = _taggedTemplateLiteral(["\n      font-size: 1.25rem;\n      color: #aaaaaa;\n    "]))), compact && selected && css(_templateObject15$6 || (_templateObject15$6 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), function (_ref10) {
    var _theme$colors$nav2;
    var theme = _ref10.theme;
    return ((_theme$colors$nav2 = theme.colors.nav) === null || _theme$colors$nav2 === void 0 ? void 0 : _theme$colors$nav2.name) || theme.colors.secondary;
  }));
}, function (_ref11) {
  var profile = _ref11.profile;
  return !!profile && css(_templateObject16$6 || (_templateObject16$6 = _taggedTemplateLiteral(["\n      font-weight: 500;\n      white-space: pre-line;\n      line-height: 1.45em;\n      font-size: 18px;\n      color: #777777;\n      max-width: 190px;\n\n      &:hover {\n        color: ", ";\n      }\n    "])), function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.secondaryAlternative || theme.colors.secondary;
  });
}, function (_ref13) {
  var profile = _ref13.profile,
    selected = _ref13.selected;
  return !!profile && !!selected && css(_templateObject17$5 || (_templateObject17$5 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), function (_ref14) {
    var theme = _ref14.theme;
    return theme.colors.secondaryAlternative || theme.colors.secondary;
  });
});
var Badge$1 = styled.div(_templateObject18$4 || (_templateObject18$4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  color: white;\n  font-family: ", ", sans-serif;\n  font-size: 0.75rem;\n  font-weight: bold;\n  padding: 0.15rem 0.5rem;\n  border-radius: 5px;\n\n  ", "\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.primary;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fonts.body.family;
}, function (_ref17) {
  var compact = _ref17.compact;
  return css(_templateObject19$3 || (_templateObject19$3 = _taggedTemplateLiteral(["\n    ", "\n  "])), compact && css(_templateObject20$2 || (_templateObject20$2 = _taggedTemplateLiteral(["\n      padding: 0.25rem 0.5rem;\n    "]))));
});
var Bar = styled.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 0.5rem;\n  background-color: ", ";\n  position: relative;\n\n  ", "\n\n  ", "\n"])), function (_ref18) {
  var theme = _ref18.theme;
  return transparentize(0.6, theme.colors.primary);
}, function (_ref19) {
  var transparent = _ref19.transparent;
  return css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    ", "\n  "])), transparent && css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n      background-color: transparent;\n      height: 4px;\n    "]))));
}, function (_ref20) {
  var first = _ref20.first,
    last = _ref20.last;
  return css(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n    ", "\n\n    ", "\n  "])), first && css(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n    "]))), last && css(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n    "]))));
});
var ProfileSelected = styled.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), function (_ref21) {
  var selected = _ref21.selected;
  return !!selected && css(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n      border: 2px solid ", ";\n      border-radius: 4px;\n    "])), function (_ref22) {
    var theme = _ref22.theme;
    return theme.colors.primary;
  });
}, function (_ref23) {
  var selected = _ref23.selected;
  return !selected && css(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n      width: 4px;\n    "])));
});

var Item = function Item(_ref) {
  var name = _ref.name,
    label = _ref.label,
    icon = _ref.icon,
    badge = _ref.badge,
    clickHandler = _ref.clickHandler,
    isSelected = _ref.isSelected,
    setSelected = _ref.setSelected,
    first = _ref.first,
    last = _ref.last,
    compact = _ref.compact,
    transparent = _ref.transparent,
    profile = _ref.profile;
  var sharedProps = {
    selected: !!isSelected,
    compact: !!compact,
    transparent: !!transparent,
    profile: !!profile
  };
  var handleClick = function handleClick(event) {
    if (setSelected !== undefined) setSelected(name);
    if (clickHandler !== undefined) clickHandler(event);
  };
  return /*#__PURE__*/React__default.createElement(Container$h, _extends({
    onClick: handleClick
  }, sharedProps), /*#__PURE__*/React__default.createElement(Content, sharedProps, icon && /*#__PURE__*/React__default.createElement(Icon, _extends({}, sharedProps, {
    size: "1x",
    icon: icon
  })), profile && /*#__PURE__*/React__default.createElement(ProfileSelected, sharedProps), /*#__PURE__*/React__default.createElement(Name$1, sharedProps, label), badge && /*#__PURE__*/React__default.createElement(Badge$1, sharedProps, badge)), !profile && /*#__PURE__*/React__default.createElement(Bar, _extends({
    first: !!first,
    last: !!last
  }, sharedProps), /*#__PURE__*/React__default.createElement(Selected, sharedProps)));
};
Item.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  badge: PropTypes.number,
  icon: PropTypes.object,
  clickHandler: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  setSelected: PropTypes.func.isRequired,
  first: PropTypes.bool.isRequired,
  last: PropTypes.bool.isRequired,
  compact: PropTypes.bool.isRequired,
  transparent: PropTypes.bool.isRequired
};
Item.defaultProps = {
  name: "",
  label: "",
  clickHandler: undefined,
  isSelected: false,
  setSelected: undefined,
  first: false,
  last: false,
  compact: false,
  transparent: false
};

var Nav = function Nav(_ref) {
  var items = _ref.items,
    selected = _ref.selected,
    setSelected = _ref.setSelected,
    transparent = _ref.transparent,
    compact = _ref.compact,
    profile = _ref.profile;
  return /*#__PURE__*/React__default.createElement(Container$i, {
    compact: !!compact,
    profile: profile
  }, items.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(Item, _extends({
      key: item.name
    }, item, {
      isSelected: selected === item.name,
      setSelected: setSelected,
      first: index === 0,
      last: items.length === index + 1,
      transparent: transparent,
      compact: compact,
      profile: profile
    }));
  }));
};
Nav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    clickHandler: PropTypes.func.isRequired
  })).isRequired,
  selected: PropTypes.string.isRequired,
  setSelected: PropTypes.func.isRequired,
  transparent: PropTypes.bool.isRequired,
  compact: PropTypes.bool.isRequired
};
Nav.defaultProps = {
  items: [],
  selected: "",
  setSelected: undefined,
  transparent: false,
  compact: false
};

var _templateObject$G, _templateObject2$z, _templateObject3$q, _templateObject4$p, _templateObject5$g, _templateObject6$e, _templateObject7$e, _templateObject8$b, _templateObject9$a, _templateObject0$a, _templateObject1$9, _templateObject10$8, _templateObject11$8, _templateObject12$7, _templateObject13$5, _templateObject14$5, _templateObject15$5, _templateObject16$5, _templateObject17$4, _templateObject18$3;
styled.p(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n  margin: 0;\n  color: ", ";\n"])), function (props) {
  return props.theme.colors.body;
});
styled.span(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteral(["\n  font-size: 0.8rem;\n  color: ", ";\n"])), function (props) {
  return props.theme.colors.notifications.meta;
});
var Main = styled.div(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
var Side = styled.div(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding-left: 2rem;\n"])));
var Top = styled.div(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteral(["\n  > :not(:last-child) {\n    margin-bottom: 0.5rem;\n  }\n"])));
var Bottom = styled.div(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var contentContainerStyles = css(_templateObject7$e || (_templateObject7$e = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  padding: 2rem;\n  display: flex;\n  box-sizing: border-box;\n  text-decoration: none;\n  position: relative;\n"])));
var StyledLink$1 = styled.a(_templateObject8$b || (_templateObject8$b = _taggedTemplateLiteral(["\n  ", "\n"])), contentContainerStyles);
var Div$3 = styled.div(_templateObject9$a || (_templateObject9$a = _taggedTemplateLiteral(["\n  ", "\n"])), contentContainerStyles);
styled.div(_templateObject0$a || (_templateObject0$a = _taggedTemplateLiteral(["\n  display: none;\n\n  &.slide-out {\n    animation: slide-out 0.5s forwards;\n  }\n\n  @keyframes slide-out {\n    0% {\n      transform: translateX(0%);\n    }\n    100% {\n      transform: translateX(-120%);\n    }\n  }\n\n  ", "\n"])), breakpoint("tablet")(_templateObject1$9 || (_templateObject1$9 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
var Container$g = styled.div(_templateObject10$8 || (_templateObject10$8 = _taggedTemplateLiteral(["\n  &.slide-out {\n    animation: slide-out 0.5s forwards;\n  }\n\n  @keyframes slide-out {\n    0% {\n      transform: translateX(0%);\n    }\n    100% {\n      transform: translateX(-120%);\n    }\n  }\n"])));
styled.div(_templateObject11$8 || (_templateObject11$8 = _taggedTemplateLiteral(["\n  ", "\n"])), breakpoint("tablet")(_templateObject12$7 || (_templateObject12$7 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var Hover = styled.div(_templateObject13$5 || (_templateObject13$5 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
var Obj = styled.object(_templateObject14$5 || (_templateObject14$5 = _taggedTemplateLiteral(["\n  right: 15px;\n  display: block;\n  color: ", ";\n  font-size: 2rem;\n  position: absolute;\n  top: 5px;\n  cursor: pointer;\n\n  ", "\n"])), function (props) {
  return props.theme.colors.body;
}, breakpoint("tablet")(_templateObject15$5 || (_templateObject15$5 = _taggedTemplateLiteral(["\n    right: 20px;\n    top: 10px;\n  "]))));
var StyledArrow = styled(Arrow)(_templateObject16$5 || (_templateObject16$5 = _taggedTemplateLiteral(["\n  right: 15px;\n  bottom: 15px;\n  position: absolute;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject17$4 || (_templateObject17$4 = _taggedTemplateLiteral(["\n    right: 20px;\n    bottom: 25px;\n  "]))));
var Meta = styled(P$4).attrs({
  marginless: true,
  size: "small"
})(_templateObject18$3 || (_templateObject18$3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var _theme$colors$notific;
  var theme = _ref.theme;
  return ((_theme$colors$notific = theme.colors.notifications) === null || _theme$colors$notific === void 0 ? void 0 : _theme$colors$notific.meta) || theme.colors.primary;
});

var _excluded$2 = ["notification", "close", "actionHandler"];
var Notification = function Notification(_ref) {
  var notification = _ref.notification,
    close = _ref.close,
    actionHandler = _ref.actionHandler,
    rest = _objectWithoutProperties$1(_ref, _excluded$2);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fade = _useState2[0],
    setFade = _useState2[1];
  var dismiss = function dismiss(event) {
    event.preventDefault();
    setFade(true);
    setTimeout(function () {
      return close(notification.id);
    }, 500);
  };
  var cardContent = /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Main, null, /*#__PURE__*/React__default.createElement(Top, null, notification.title && /*#__PURE__*/React__default.createElement(H3, {
    marginless: true,
    variant: "secondaryReadable"
  }, notification.title), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    variant: "secondaryReadable"
  }, notification.content)), (notification.created_at || notification.created_by_name) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Separator$1, {
    mobileOnly: false
  }), /*#__PURE__*/React__default.createElement(Bottom, null, /*#__PURE__*/React__default.createElement(Meta, null, notification.created_at), /*#__PURE__*/React__default.createElement(Meta, null, notification.created_by_name)))), (close || notification.link) && /*#__PURE__*/React__default.createElement(Side, null, close && /*#__PURE__*/React__default.createElement(Obj, {
    onClick: dismiss
  }, "\xD7"), (notification.link || notification.view_participant_profile_id) && /*#__PURE__*/React__default.createElement(StyledArrow, null)));
  var card = /*#__PURE__*/React__default.createElement(Card$1, {
    variant: "secondary",
    paddingless: true,
    marginless: rest.marginless
  }, notification.link ? /*#__PURE__*/React__default.createElement(StyledLink$1, {
    href: notification.link
  }, cardContent) : notification.view_participant_profile_id ? /*#__PURE__*/React__default.createElement(Hover, null, /*#__PURE__*/React__default.createElement(StyledLink$1, {
    onClick: function onClick() {
      return actionHandler(notification.view_participant_profile_id);
    }
  }, cardContent)) : /*#__PURE__*/React__default.createElement(Div$3, null, cardContent));
  return /*#__PURE__*/React__default.createElement(Container$g, {
    className: fade ? "slide-out" : ""
  }, card);
};
Notification.propTypes = {
  notification: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string.isRequired,
    created_at: PropTypes.string,
    created_by_name: PropTypes.string,
    link: PropTypes.string
  }),
  close: PropTypes.func
};

var _templateObject$F, _templateObject2$y, _templateObject3$p, _templateObject4$o, _templateObject5$f, _templateObject6$d, _templateObject7$d;
var ButtonContainer = styled.div(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 100%;\n  gap: 15px;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteral(["\n    gap: 5px;\n    flex-direction: row; /* Default: Horizontal layout */\n    align-items: center;\n  "]))));
var Button$3 = styled.button(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteral(["\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  color: ", ";\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  width: 100%;\n  padding: 10px 0;\n\n  background-color: ", ";\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.text;
}, function (_ref2) {
  var num = _ref2.num;
  if (num <= 6) return "#ffd9d8"; // Red-300
  if (num <= 8) return "#ffe8d1"; // Yellow-200
  return "#d1f0d4"; // Green-200
}, breakpoint("tablet")(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteral(["\n    max-width: 50px; /* Prevents huge buttons on large screens */\n    font-size: clamp(0.8rem, 2vw, 1rem); /* Responsive text size */\n    aspect-ratio: 1 / 1;\n    padding: 0;\n    &:hover {\n      filter: brightness(0.9);\n    }\n\n    width: ", "; /* Makes all buttons equal width */\n  "])), function (_ref3) {
  var length = _ref3.length;
  return "calc(100% / ".concat(length, ")");
}), function (_ref4) {
  var selected = _ref4.selected;
  return selected && css(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteral(["\n      outline: 1px solid #000;\n    "])));
});
var Helpers = styled.div(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteral(["\n  display: none;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n  "]))));

var NpsScale = function NpsScale(_ref) {
  var onClick = _ref.onClick,
    selected = _ref.selected;
  var numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  var handleClick = function handleClick(num) {
    onClick(num);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ButtonContainer, null, numbers.map(function (num) {
    return /*#__PURE__*/React__default.createElement(Button$3, {
      key: num,
      num: num,
      onClick: function onClick() {
        return handleClick(num);
      },
      type: "button",
      length: numbers.length,
      selected: selected === num
    }, num);
  })), /*#__PURE__*/React__default.createElement(Helpers, null, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    size: "small"
  }, "Not great"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    size: "small"
  }, "Great")));
};

var _templateObject$E, _templateObject2$x, _templateObject3$o, _templateObject4$n;
var Button$2 = styled(Link$2)(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n  background-color: transparent;\n  /* border: 2px solid ", "; */\n  /* border-radius: 50%; */\n  border: none;\n  width: 2.5rem;\n  height: 2.5rem;\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  text-align: center;\n  font-weight: bold;\n  appearance: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  font-size: 22px;\n  height: 40px;\n  width: 40px;\n\n  ", "\n"])), function (props) {
  return props.theme.colors.body;
}, function (props) {
  return props.theme.colors.primary;
}, breakpoint("desktop")(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteral(["\n    font-size: 24px;\n  "]))));
var Counter$3 = styled.span(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  bottom: 20px;\n  left: 13px;\n  background-color: ", ";\n  border-radius: 50%;\n  color: ", ";\n  padding: 0.2rem;\n  margin-left: 0.5rem;\n  text-align: center;\n  font-size: 12px;\n  min-width: 14px;\n  min-height: 14px;\n\n  ", "\n"])), function (props) {
  return props.theme.colors.notifications.badge.background;
}, function (props) {
  return props.theme.colors.notifications.badge.text;
}, breakpoint("desktop")(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteral(["\n  min-width: 0.9rem;\n  min-height: 0.9rem;\n"]))));

var OpenMessagesButton = function OpenMessagesButton(_ref) {
  var messageCount = _ref.messageCount;
  return /*#__PURE__*/React__default.createElement(Button$2, {
    to: "/conversations"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faMessage,
    size: "1x"
  }), messageCount > 0 && /*#__PURE__*/React__default.createElement(Counter$3, null, messageCount));
};
OpenMessagesButton.propTypes = {
  messageCount: PropTypes.number
};

var _templateObject$D, _templateObject2$w, _templateObject3$n, _templateObject4$m;
var Button$1 = styled(Link$2)(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: none;\n  width: 2.5rem;\n  height: 2.5rem;\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  text-align: center;\n  font-weight: bold;\n  appearance: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  font-size: 22px;\n  height: 40px;\n  width: 40px;\n\n  ", "\n"])), function (props) {
  return props.theme.colors.primary;
}, breakpoint("desktop")(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteral(["\n    font-size: 24px;\n  "]))));
var Counter$2 = styled.span(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  bottom: 20px;\n  left: 13px;\n  background-color: ", ";\n  border-radius: 50%;\n  color: ", ";\n  padding: 0.2rem;\n  margin-left: 0.5rem;\n  text-align: center;\n  font-size: 12px;\n  min-width: 14px;\n  min-height: 14px;\n\n  ", "\n"])), function (props) {
  return props.theme.colors.notifications.badge.background;
}, function (props) {
  return props.theme.colors.notifications.badge.text;
}, breakpoint("desktop")(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteral(["\n    min-width: 0.9rem;\n    min-height: 0.9rem;\n  "]))));

var OpenNotificationsButton = function OpenNotificationsButton(_ref) {
  var notificationCount = _ref.notificationCount;
  return /*#__PURE__*/React__default.createElement(Button$1, {
    to: "/notifications"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faBell,
    size: "1x"
  }), notificationCount > 0 && /*#__PURE__*/React__default.createElement(Counter$2, null, notificationCount));
};
OpenNotificationsButton.propTypes = {
  notificationCount: PropTypes.number
};

var _templateObject$C, _templateObject2$v;
var Button = styled.button(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: transparent;\n  border: none;\n  width: 2rem;\n  height: 2rem;\n  font-size: 22px;\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  text-align: center;\n  font-weight: bold;\n  appearance: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  height: 40px;\n  width: 40px;\n\n  ", "\n"])), function (props) {
  return props.theme.colors.primary;
}, breakpoint("widescreen")(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral(["\n    font-size: 35px;\n    width: 2.5rem;\n    height: 2.5rem;\n  "]))));

var OpenMenuButton = function OpenMenuButton(_ref) {
  var toggleMenu = _ref.toggleMenu;
  return /*#__PURE__*/React__default.createElement(Button, {
    onClick: toggleMenu
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faBars,
    size: "1x"
  }));
};
OpenMenuButton.propTypes = {
  toggleMenu: PropTypes.func.isRequired
};

var _templateObject$B;
var Container$f = styled.div(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n  padding: 0;\n"])));

var PageContent = function PageContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(Container$f, {
    className: "ho-page"
  }, children);
};
PageContent.propTypes = {
  children: PropTypes.node
};
PageContent.defaultProps = {
  children: null
};

var _templateObject$A, _templateObject2$u, _templateObject3$m, _templateObject4$l, _templateObject5$e, _templateObject6$c, _templateObject7$c, _templateObject8$a, _templateObject9$9, _templateObject0$9, _templateObject1$8;
var Avatar = styled.img(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n  height: 75px;\n  width: 75px;\n  border-radius: 50%;\n  float: right;\n"])));
var Div$2 = styled.div(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  object-position: 50% 50%;\n  margin: 0;\n  z-index: 1;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryAlternative || theme.colors.secondary;
});
var Para = styled.p(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral(["\n  font-size: 6rem;\n  font-family: Helvetica Neue;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  color: white;\n"])));
var Skills$1 = styled.div(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  flex-wrap: wrap;\n"])));
var Skill$1 = styled.div(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteral(["\n  padding: 0.2rem 0.5rem;\n  border: 1px solid ", ";\n  color: ", ";\n  border-radius: 2rem;\n  font-size: 0.8rem;\n  font-family: ", ", sans-serif;\n  margin-right: 0.2rem;\n  margin-bottom: 0.2rem;\n  display: flex;\n  align-items: center;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.body.family;
});
var Media = styled.div(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteral(["\n  overflow: hidden;\n  position: relative;\n  border-radius: 1rem;\n  width: 100%;\n  padding-bottom: 100%;\n"])));
var Img$2 = styled.img(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  border-radius: 1rem;\n  object-fit: cover;\n  object-position: 50% 50%;\n  margin: 0;\n  z-index: 1;\n\n  ", "\n"])), function (_ref5) {
  var obfuscated = _ref5.obfuscated;
  return !!obfuscated && css(_templateObject8$a || (_templateObject8$a = _taggedTemplateLiteral(["\n      filter: blur(30px);\n      pointer-events: none;\n    "])));
});
var Text$2 = styled.div(_templateObject9$9 || (_templateObject9$9 = _taggedTemplateLiteral([""])));
var PlayButton = styled.svg(_templateObject0$9 || (_templateObject0$9 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 1rem;\n  right: 1rem;\n  z-index: 2;\n"])));
var CloudButton = styled.svg(_templateObject1$8 || (_templateObject1$8 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 1rem;\n  left: 1rem;\n  z-index: 2;\n"])));

var _templateObject$z;
var getBackgroundColorFromVariant = function getBackgroundColorFromVariant(variant, theme) {
  switch (variant) {
    case "danger":
      return theme.colors.danger;
    case "warning":
      return theme.colors.warning;
    case "success":
      return theme.colors.success;
    default:
      return "hsla(0, 0%, 0%, 0.2)";
  }
};
var getTextColorFromVariant = function getTextColorFromVariant(variant, theme) {
  var backgroundColor = getBackgroundColorFromVariant(variant, theme);
  return readableColor(backgroundColor, theme.colors.buttons.darkColor, theme.colors.buttons.lightColor);
};
var Container$e = styled.div(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n  padding: 0.5rem 5px;\n  font-weight: bold;\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 0;\n  box-sizing: border-box;\n  z-index: 2;\n"])), function (_ref) {
  var variant = _ref.variant,
    theme = _ref.theme;
  return getTextColorFromVariant(variant, theme);
}, function (_ref2) {
  var variant = _ref2.variant,
    theme = _ref2.theme;
  return getBackgroundColorFromVariant(variant, theme);
});

var Banner = function Banner(_ref) {
  var variant = _ref.variant,
    text = _ref.text;
  return /*#__PURE__*/React__default.createElement(Container$e, {
    variant: variant
  }, /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    align: "center",
    size: "small",
    bold: true
  }, text));
};
Banner.propTypes = {
  variant: PropTypes.oneOf(["default", "danger", "warning", "success"]).isRequired,
  text: PropTypes.string.isRequired
};
Banner.defaultProps = {
  variant: "default",
  text: ""
};

var ParticipantTile = function ParticipantTile(_ref) {
  var id = _ref.id,
    avatar_exists = _ref.avatar_exists,
    avatar_path = _ref.avatar_path,
    obfuscated = _ref.obfuscated;
    _ref.video_path;
    var banner = _ref.banner,
    programme_name = _ref.programme_name,
    age = _ref.age,
    gender = _ref.gender,
    country_code = _ref.country_code,
    display_name = _ref.display_name,
    first_name = _ref.first_name,
    last_name = _ref.last_name,
    availability_from = _ref.availability_from,
    availability_until = _ref.availability_until,
    student_status = _ref.student_status,
    has_visa = _ref.has_visa,
    skills = _ref.skills,
    skill_count = _ref.skill_count,
    buttons = _ref.buttons,
    clickHandler = _ref.clickHandler,
    playVideoHandler = _ref.playVideoHandler,
    downloadPdfHandler = _ref.downloadPdfHandler,
    placed_section = _ref.placed_section,
    arrival_date = _ref.arrival_date,
    starts_on = _ref.starts_on,
    ends_on = _ref.ends_on,
    placement_position = _ref.placement_position,
    status = _ref.status,
    inline_avatar = _ref.inline_avatar,
    showSkillRating = _ref.showSkillRating;
  var remainingSkillCount = skill_count - skills.length;
  var summary = "".concat(programme_name, " \xB7 ").concat(age, " \xB7 ").concat(gender, " \xB7 ").concat(country_code);
  if (has_visa && !placed_section) {
    summary += " \xB7 Visa \u2714";
  }
  var hideAvatar = !avatar_exists || !!obfuscated;
  var card = /*#__PURE__*/React__default.createElement(Card$1, {
    variant: "white",
    paddingless: true
  }, !!inline_avatar && avatar_exists && /*#__PURE__*/React__default.createElement(Avatar, {
    src: avatar_path,
    alt: display_name
  }), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem"
  }, inline_avatar != true && /*#__PURE__*/React__default.createElement(Media, null, banner !== undefined && /*#__PURE__*/React__default.createElement(Banner, banner), hideAvatar ? /*#__PURE__*/React__default.createElement(Div$2, null, /*#__PURE__*/React__default.createElement(Para, null, "".concat(first_name[0]).concat(last_name[0]))) : /*#__PURE__*/React__default.createElement(Img$2, {
    src: avatar_path,
    alt: display_name
  }), playVideoHandler !== undefined && /*#__PURE__*/React__default.createElement(PlayButton, {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: playVideoHandler
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M16 10.0001L7 15.1963L7 4.80397L16 10.0001Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9",
    stroke: "white",
    "stroke-width": "2"
  })), downloadPdfHandler !== undefined && /*#__PURE__*/React__default.createElement(CloudButton, {
    width: "24",
    height: "16",
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: downloadPdfHandler
  }, /*#__PURE__*/React__default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M19.35 6.04C18.67 2.59 15.64 0 12 0C9.11 0 6.6 1.64 5.35 4.04C2.34 4.36 0 6.91 0 10C0 13.31 2.69 16 6 16H19C21.76 16 24 13.76 24 11C24 8.36 21.95 6.22 19.35 6.04ZM19 14H6C3.79 14 2 12.21 2 10C2 7.95 3.53 6.24 5.56 6.03L6.63 5.92L7.13 4.97C8.08 3.14 9.94 2 12 2C14.62 2 16.88 3.86 17.39 6.43L17.69 7.93L19.22 8.04C20.78 8.14 22 9.45 22 11C22 12.65 20.65 14 19 14ZM10.55 6H13.45V9H16L12 13L8 9H10.55V6Z",
    fill: "white"
  }))), /*#__PURE__*/React__default.createElement(Text$2, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.75rem"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.25rem"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    variant: "primary",
    size: "small"
  }, summary), /*#__PURE__*/React__default.createElement(H3, {
    marginless: true,
    variant: "secondary"
  }, display_name), status !== "did_not_start" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, placed_section === true ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    variant: "primary",
    bold: true
  }, placement_position), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    variant: "secondary"
  }, "Arriving ", /*#__PURE__*/React__default.createElement(Moment, {
    value: arrival_date,
    format: "DD MMM YYYY"
  })), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    variant: "secondary"
  }, /*#__PURE__*/React__default.createElement(Moment, {
    value: starts_on,
    format: "DD MMM YYYY"
  }), " -", " ", /*#__PURE__*/React__default.createElement(Moment, {
    value: ends_on,
    format: "DD MMM YYYY"
  }))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    variant: "secondary"
  }, /*#__PURE__*/React__default.createElement(Moment, {
    value: availability_from,
    format: "DD MMM YYYY"
  }), " -", " ", /*#__PURE__*/React__default.createElement(Moment, {
    value: availability_until,
    format: "DD MMM YYYY"
  })), student_status && /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    variant: "secondary",
    size: "small"
  }, student_status)))), !placed_section && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.25rem"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    variant: "primary",
    size: "small"
  }, "Skills"), /*#__PURE__*/React__default.createElement(Skills$1, null, skills.map(function (skill) {
    return /*#__PURE__*/React__default.createElement(Skill$1, {
      key: "review_".concat(id, "_skill_").concat(skill.name)
    }, skill.name, " ", showSkillRating && skill.star_rating > 0 && _toConsumableArray(Array(skill.star_rating)).map(function () {
      return "★";
    }), showSkillRating && 4 - skill.star_rating > 0 && _toConsumableArray(Array(4 - skill.star_rating)).map(function () {
      return "☆";
    }));
  }), remainingSkillCount > 0 && /*#__PURE__*/React__default.createElement(Skill$1, {
    key: "review_".concat(id, "_skills_remaining")
  }, "+ ".concat(remainingSkillCount, " more")))), buttons !== undefined && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem"
  }, buttons)))));
  if (clickHandler === undefined) return card;else return /*#__PURE__*/React__default.createElement("div", {
    onClick: clickHandler,
    style: {
      cursor: "pointer"
    }
  }, card);
};
ParticipantTile.propTypes = {
  id: PropTypes.number.isRequired,
  avatarExists: PropTypes.bool,
  avatar_path: PropTypes.string.isRequired,
  obfuscated: PropTypes.bool,
  video_path: PropTypes.string,
  programme_name: PropTypes.string.isRequired,
  age: PropTypes.string.isRequired,
  gender: PropTypes.string.isRequired,
  country_code: PropTypes.string.isRequired,
  display_name: PropTypes.string.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  availability_from: PropTypes.string.isRequired,
  availability_until: PropTypes.string.isRequired,
  skills: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    star_rating: PropTypes.number.isRequired
  })).isRequired,
  skill_count: PropTypes.number.isRequired,
  banner: PropTypes.shape({
    variant: PropTypes.oneOf(["default", "danger", "warning", "success"]),
    text: PropTypes.string
  }),
  buttons: PropTypes.node,
  clickHandler: PropTypes.func,
  playVideoHandler: PropTypes.func,
  downloadPdfHandler: PropTypes.func,
  showSkillRating: PropTypes.bool
};
ParticipantTile.defaultProps = {
  skills: [],
  banner: undefined,
  buttons: undefined,
  clickHandler: undefined,
  playVideoHandler: undefined,
  downloadPdfHandler: undefined,
  avatarExists: true,
  obfuscated: false,
  showSkillRating: true
};

var _templateObject$y, _templateObject2$t, _templateObject3$l, _templateObject4$k;
var Container$d = styled.div(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  > * {\n    width: 100%;\n    margin-bottom: 0.5rem;\n  }\n\n  ", "\n"])), breakpoint("tablet")(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral(["\n    display: inline-flex;\n    flex-wrap: wrap;\n    align-items: center;\n\n    > * {\n      width: unset;\n    }\n\n    > :not(:last-child) {\n      margin-right: 0.5rem;\n    }\n  "]))));
var StyledLabel = styled.label(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: 1rem;\n  font-family: ", ", sans-serif;\n  font-weight: bold;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.body.family;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.body;
});
var StyledFieldGroup = styled(FieldGroup)(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteral(["\n  gap: 0.5rem;\n"])));

var Filters = function Filters(_ref) {
  var filters = _ref.filters,
    filterHandler = _ref.filterHandler,
    q = _ref.q,
    clearFilterHandler = _ref.clearFilterHandler,
    clearAllFiltersHandler = _ref.clearAllFiltersHandler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showFilter = _useState2[0],
    setShowFilter = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedFilter = _useState4[0],
    setSelectedFilter = _useState4[1];
  var _useState5 = useState({
      value: "",
      name: ""
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    dateHolder = _useState6[0],
    setDateHolder = _useState6[1];
  var _useState7 = useState({
      value: "",
      name: ""
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    numberHolder = _useState8[0],
    setNumberHolder = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    multiValue = _useState0[0],
    setMultiValue = _useState0[1];
  var handleFilterChange = function handleFilterChange(name, value) {
    if (filterHandler !== undefined) filterHandler(name, value);
    setShowFilter(false);
    setSelectedFilter({});
  };
  var clearAllFilters = function clearAllFilters() {
    if (clearAllFiltersHandler !== undefined) clearAllFiltersHandler();
  };
  var handleClearFilter = function handleClearFilter(name) {
    if (clearFilterHandler !== undefined) clearFilterHandler(name);
    setShowFilter(false);
    setSelectedFilter({});
    setDateHolder({
      value: "",
      name: ""
    });
    setNumberHolder({
      value: "",
      name: ""
    });
    setNumberHolder({
      value: "",
      name: ""
    });
    setMultiValue([]);
  };
  var toggleFilter = function toggleFilter(event, filter) {
    if (filter.type === "boolean") {
      if (filterHandler === undefined) filterHandler(event, filter.param, !checkSelected(filter));
    } else if (filter.param === selectedFilter.param) {
      setShowFilter(false);
      setSelectedFilter({});
    } else {
      setSelectedFilter(filter);
      setShowFilter(true);
    }
  };
  var handleDateFieldChange = function handleDateFieldChange(name, value) {
    setDateHolder({
      value: value,
      name: name
    });
  };
  var handleNumberFieldChange = function handleNumberFieldChange(name, value) {
    setNumberHolder({
      value: value,
      name: name
    });
  };
  var saveDateChange = function saveDateChange(name) {
    if (filterHandler !== undefined) filterHandler(name, dateHolder.value);
    setShowFilter(false);
    setSelectedFilter({});
    setDateHolder({
      name: "",
      value: ""
    });
  };
  var saveNumberChange = function saveNumberChange(name) {
    if (filterHandler !== undefined) filterHandler(name, numberHolder.value);
    setShowFilter(false);
    setSelectedFilter({});
    setNumberHolder({
      name: "",
      value: ""
    });
  };
  var handleMultiSelectChange = function handleMultiSelectChange(value) {
    setMultiValue(value);
  };
  var saveMultiSelectChange = function saveMultiSelectChange(name) {
    if (filterHandler !== undefined) filterHandler(name, multiValue);
    setShowFilter(false);
    setSelectedFilter({});
    setMultiValue([]);
  };
  var isDateSupported = function isDateSupported() {
    var i = document.createElement("input");
    i.setAttribute("type", "date");
    return i.type !== "text";
  };
  var options;
  if (selectedFilter.type === "multi_select") {
    options = selectedFilter.options.map(function (option) {
      return {
        label: option[1],
        value: option[0]
      };
    });
  }
  useEffect(function () {
    if (selectedFilter.type === "multi_select") {
      var values_array = q[selectedFilter.param] || [];
      if (values_array.length > 0 && values_array[0].value === undefined) {
        values_array = values_array.map(function (value) {
          var option = selectedFilter.options.find(function (option) {
            return option[0] === value;
          });
          return {
            value: value,
            label: option[1] || value
          };
        });
      }
      setMultiValue(values_array);
    }
  }, [selectedFilter]);
  var filterComponent = function filterComponent() {
    if (selectedFilter.type === "date") {
      return /*#__PURE__*/React__default.createElement(DefaultDateField, {
        key: selectedFilter.param,
        name: selectedFilter.param,
        value: q[selectedFilter.param],
        placeholder: selectedFilter.name,
        handleInputChange: handleDateFieldChange
      });
    } else if (selectedFilter.type === "select") {
      return /*#__PURE__*/React__default.createElement(SelectField, {
        key: selectedFilter.param,
        name: selectedFilter.param,
        value: q[selectedFilter.param],
        options: selectedFilter.options,
        placeholder: selectedFilter.name,
        handleInputChange: handleFilterChange,
        blank: selectedFilter.blank
      });
    } else if (selectedFilter.type === "number") {
      return /*#__PURE__*/React__default.createElement(NumberField, {
        key: selectedFilter.param,
        name: selectedFilter.param,
        value: q[selectedFilter.param],
        handleInputChange: handleNumberFieldChange
      });
    } else if (selectedFilter.type === "multi_select") {
      return /*#__PURE__*/React__default.createElement(MultiSelectField, {
        key: selectedFilter.param,
        name: selectedFilter.param,
        value: multiValue,
        options: options,
        handleInputChange: handleMultiSelectChange
      });
    }
  };
  var checkSelected = function checkSelected(_ref2) {
    var param = _ref2.param;
      _ref2.type;
    var query = Object.entries(q).find(function (entry) {
      return entry[0] === param;
    });
    return query && query[1];
  };
  var anyFiltersSelected = function anyFiltersSelected() {
    var filterNames = filters.map(function (filter) {
      return filter.param;
    });
    return Object.keys(q).some(function (param) {
      return filterNames.includes(param);
    });
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, filters.length > 0 && /*#__PURE__*/React__default.createElement(Container$d, null, /*#__PURE__*/React__default.createElement(P$4, {
    bold: true,
    variant: "secondary",
    marginless: true
  }, "Filters:"), filters.map(function (filter) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "secondary",
      outlined: !checkSelected(filter),
      onClick: function onClick(event) {
        return toggleFilter(event, filter);
      }
    }, filter.name);
  }), clearAllFiltersHandler !== undefined && anyFiltersSelected() && /*#__PURE__*/React__default.createElement(Button$5, {
    onClick: function onClick() {
      clearAllFilters();
    }
  }, "Clear Filters")), !!showFilter && /*#__PURE__*/React__default.createElement(Grid$1, {
    template: "auto / 1fr 1fr"
  }, /*#__PURE__*/React__default.createElement(Card$1, {
    variant: "secondary",
    useAlternativeVariant: true
  }, /*#__PURE__*/React__default.createElement(StyledFieldGroup, null, /*#__PURE__*/React__default.createElement(StyledLabel, null, selectedFilter.name, " ", clearFilterHandler !== undefined && /*#__PURE__*/React__default.createElement(CloseIcon$1, {
    onClick: function onClick(event) {
      return handleClearFilter(selectedFilter.param);
    }
  })), filterComponent(), isDateSupported() && selectedFilter.type === "date" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$5, {
    onClick: function onClick() {
      return saveDateChange(selectedFilter.param);
    }
  }, "Save")), selectedFilter.type === "number" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$5, {
    onClick: function onClick() {
      return saveNumberChange(selectedFilter.param);
    }
  }, "Search")), selectedFilter.type === "multi_select" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$5, {
    onClick: function onClick() {
      return saveMultiSelectChange(selectedFilter.param);
    }
  }, "Search"))))));
};
Filters.propTypes = {
  filters: PropTypes.array,
  filterHandler: PropTypes.func,
  clearFilterHandler: PropTypes.func,
  clearAllFiltersHandler: PropTypes.func,
  q: PropTypes.object
};
Filters.defaultProps = {
  filters: [],
  filterHandler: undefined,
  clearFilterHandler: undefined,
  clearAllFiltersHandler: undefined,
  q: {}
};

var _templateObject$x;
var StyledCSVLink = styled(CSVLink)(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n  ", "\n"])), styles$1);

var Actions = function Actions(_ref) {
  var actions = _ref.actions,
    actionHandler = _ref.actionHandler,
    csvData = _ref.csvData;
  var actionButtons = actions.filter(function (a) {
    return a.type === "button";
  });
  var actionOptions = actions.filter(function (a) {
    return a.type === "option";
  });
  var handleClick = function handleClick(_ref2) {
    var param = _ref2.param,
      type = _ref2.type;
    if (actionHandler !== undefined) actionHandler(param, type);
  };
  var handleActionOption = function handleActionOption(event, option) {
    event.preventDefault();
    var opt = actionOptions.find(function (o) {
      return o.name === option;
    });
    if (opt) handleClick(opt);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, actions.length > 0 && /*#__PURE__*/React__default.createElement(Container$A, null, actionButtons.map(function (action) {
    if (action.param === "export") return /*#__PURE__*/React__default.createElement(StyledCSVLink, {
      filename: "export.csv",
      target: "_blank",
      data: csvData,
      size: "small",
      variant: "secondary"
    }, action.name);else return /*#__PURE__*/React__default.createElement(Button$5, {
      onClick: function onClick() {
        return handleClick(action);
      },
      size: "small",
      variant: "secondary"
    }, action.name);
  }), actionOptions.length > 0 && /*#__PURE__*/React__default.createElement(ButtonSelect, {
    size: "small",
    title: "Actions",
    options: actionOptions.map(function (a) {
      return a.name;
    }),
    clickHandler: handleActionOption
  })));
};
Actions.propTypes = {
  actions: PropTypes.array,
  actionHandler: PropTypes.func,
  csvData: PropTypes.array
};
Actions.defaultProps = {
  actions: [],
  actionHandler: undefined,
  csvData: []
};

var _templateObject$w, _templateObject2$s, _templateObject3$k, _templateObject4$j;
var Container$c = styled.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n  display: grid;\n  grid-gap: 2rem;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), breakpoint("tablet")(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral(["\n    grid-template-columns: 1fr 1fr;\n  "]))), breakpoint("desktop")(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral(["\n    grid-template-columns: 1fr 1fr 1fr;\n  "]))), breakpoint("mahoosive")(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteral(["\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n  "]))));

var Tiles = function Tiles(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(Container$c, null, children);
};
Tiles.propTypes = {
  children: PropTypes.node
};

var _templateObject$v, _templateObject2$r;
var getPaddingFromSize = function getPaddingFromSize(size, theme) {
  switch (size) {
    case "small":
      return "0.5rem 1rem 0.5rem 2.25rem";
    case "medium":
      return "1rem 2rem 1rem 3.25rem";
    case "large":
      return "1.25rem 2.5rem 1.25rem 3.75rem";
    default:
      return "0.75rem 1.5rem 0.75rem 2.75rem";
  }
};
var StyledField = styled.input(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  line-height: 1.4;\n  padding: ", ";\n  border: 1px solid #d8d8d8;\n  color: ", ";\n  width: unset;\n  font-weight: bold;\n  background-color: #f4f4f4;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 6.5C13 7.9375 12.5312 9.28125 11.75 10.3438L15.6875 14.3125C16.0938 14.6875 16.0938 15.3438 15.6875 15.7188C15.3125 16.125 14.6562 16.125 14.2812 15.7188L10.3125 11.75C9.25 12.5625 7.90625 13 6.5 13C2.90625 13 0 10.0938 0 6.5C0 2.9375 2.90625 0 6.5 0C10.0625 0 13 2.9375 13 6.5ZM6.5 11C8.09375 11 9.5625 10.1562 10.375 8.75C11.1875 7.375 11.1875 5.65625 10.375 4.25C9.5625 2.875 8.09375 2 6.5 2C4.875 2 3.40625 2.875 2.59375 4.25C1.78125 5.65625 1.78125 7.375 2.59375 8.75C3.40625 10.1562 4.875 11 6.5 11Z' fill='%23AAAAAA'/%3E%3C/svg%3E%0A\");\n  background-repeat: no-repeat;\n  background-position: 17px center;\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:focus,\n  &:active {\n    outline: 2px solid ", ";\n  }\n\n  ", "\n"])), function (_ref) {
  var size = _ref.size;
    _ref.theme;
  return getPaddingFromSize(size);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondaryAlternative || theme.colors.secondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return transparentize(0.6, theme.colors.secondaryAlternative || theme.colors.secondary);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return !!disabled && css(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "])));
});

var _excluded$1 = ["handleInputChange"];
var SearchBox$2 = function SearchBox(_ref) {
  var handleInputChange = _ref.handleInputChange,
    rest = _objectWithoutProperties$1(_ref, _excluded$1);
  var onChange = function onChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    if (handleInputChange !== undefined) handleInputChange(name, value);
  };
  return /*#__PURE__*/React__default.createElement(StyledField, _extends({
    type: "search",
    onChange: onChange
  }, rest));
};
SearchBox$2.propTypes = {
  handleInputChange: PropTypes.func.isRequired
};
SearchBox$2.defaultProps = {
  handleInputChange: undefined
};

var _templateObject$u, _templateObject2$q;
var AdjustedSearchBox = styled(SearchBox$2)(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n  line-height: 1;\n  color: ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryAlternative || theme.colors.secondary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return transparentize(0.6, theme.colors.secondaryAlternative || theme.colors.secondary);
});
var LoadMoreButton = styled(Button$5)(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral(["\n  padding: 0.75rem 2rem;\n  font-size: 1.25rem;\n"])));

var ParticipantTiles = function ParticipantTiles(_ref) {
  var loading = _ref.loading,
    filters = _ref.filters,
    actions = _ref.actions,
    participants = _ref.participants,
    gridArea = _ref.gridArea,
    noneText = _ref.noneText,
    actionHandler = _ref.actionHandler,
    filterHandler = _ref.filterHandler,
    searchHandler = _ref.searchHandler,
    q = _ref.q,
    totalEntries = _ref.totalEntries,
    loadMoreHandler = _ref.loadMoreHandler,
    clearFilterHandler = _ref.clearFilterHandler,
    clearAllFiltersHandler = _ref.clearAllFiltersHandler;
  var _useState = useState((q === null || q === void 0 ? void 0 : q.search_string_i_cont) || (q === null || q === void 0 ? void 0 : q.application_container_search_string_i_cont) || ""),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var loadMore = function loadMore(event) {
    event.preventDefault();
    if (loadMoreHandler !== undefined) loadMoreHandler();
  };
  var handleSearchBox = function handleSearchBox(event) {
    var value = event.target.value;
    setSearchValue(value);
  };
  var handleFilter = function handleFilter(name, value) {
    setSearchValue("");
    if (filterHandler !== undefined) filterHandler(name, value);
  };
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1rem",
    gridArea: gridArea
  }, /*#__PURE__*/React__default.createElement(Filters, {
    filters: filters,
    filterHandler: handleFilter,
    q: q,
    clearFilterHandler: clearFilterHandler,
    clearAllFiltersHandler: clearAllFiltersHandler
  }), /*#__PURE__*/React__default.createElement(Level, {
    mobile: false
  }, /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement(AdjustedSearchBox, {
    name: "text_search",
    value: searchValue,
    placeholder: "Search",
    onChange: handleSearchBox,
    onKeyUp: searchHandler
  })), /*#__PURE__*/React__default.createElement(Actions, {
    actions: actions,
    actionHandler: actionHandler
  }), loading && /*#__PURE__*/React__default.createElement(Grid$1, {
    placeContent: "center",
    mobile: true
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner, {
    variant: "primary"
  })), !loading && (participants.length > 0 ? /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "2rem"
  }, /*#__PURE__*/React__default.createElement(Tiles, null, participants.map(function (participant) {
    return /*#__PURE__*/React__default.createElement(ParticipantTile, _extends({}, participant, {
      key: participant.id
    }));
  })), participants.length < totalEntries && /*#__PURE__*/React__default.createElement(Grid$1, {
    placeContent: "center"
  }, /*#__PURE__*/React__default.createElement(LoadMoreButton, {
    variant: "secondary",
    onClick: loadMore
  }, "Load more")), /*#__PURE__*/React__default.createElement(P$4, {
    bold: true,
    variant: "content",
    align: "center"
  }, "Showing ", participants.length, " of ", totalEntries)) : /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true
  }, noneText)));
};
ParticipantTiles.propTypes = {
  loading: PropTypes.bool,
  participants: PropTypes.arrayOf(PropTypes.object),
  filters: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.arrayOf(PropTypes.object),
  gridArea: PropTypes.string,
  noneText: PropTypes.string,
  actionHandler: PropTypes.func,
  filterHandler: PropTypes.func,
  searchHandler: PropTypes.func,
  q: PropTypes.object,
  totalEntries: PropTypes.number,
  loadMoreHandler: PropTypes.func,
  clearFilterHandler: PropTypes.func,
  clearAllFiltersHandler: PropTypes.func
};
ParticipantTiles.defaultProps = {
  loading: false,
  participants: [],
  filters: [],
  actions: [],
  gridArea: undefined,
  noneText: "No records.",
  actionHandler: undefined,
  filterHandler: undefined,
  searchHandler: undefined,
  q: {},
  totalEntries: 0,
  loadMoreHandler: undefined,
  clearFilterHandler: undefined,
  clearAllFiltersHandler: undefined
};

var _templateObject$t, _templateObject2$p, _templateObject3$j, _templateObject4$i;
var StyledPlacementOffer = styled.div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n  display: grid;\n  border-radius: 1rem;\n  background-color: #fff;\n  padding: 1rem;\n  gap: 3rem;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral(["\n    padding: 46px 63px;\n  "]))));
var Img$1 = styled.img(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral(["\n  height: 100px;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteral(["\n    height: 150px;\n  "]))));

var PlacementOffer = /*#__PURE__*/function (_React$Component) {
  function PlacementOffer() {
    _classCallCheck$1(this, PlacementOffer);
    return _callSuper(this, PlacementOffer, arguments);
  }
  _inherits$1(PlacementOffer, _React$Component);
  return _createClass$1(PlacementOffer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        employer = _this$props.employer,
        participant = _this$props.participant,
        placement = _this$props.placement,
        header_1 = _this$props.header_1,
        content_1 = _this$props.content_1,
        header_2 = _this$props.header_2,
        content_2 = _this$props.content_2;
      var employerDetails = /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "1rem"
      }, /*#__PURE__*/React__default.createElement(H2$1, {
        variant: "primary",
        marginless: true
      }, employer.host_word, " Details"), /*#__PURE__*/React__default.createElement(Grid$1, {
        grid: "auto / auto-flow",
        placeItems: "start",
        placeContent: "start"
      }, /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, employer.host_word, " Name"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        wrap: true,
        variant: "content"
      }, employer.name)), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Address"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        wrap: true,
        variant: "content"
      }, employer.address && Object.keys(employer.address).length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, employer.address.address_1, /*#__PURE__*/React__default.createElement("br", null), employer.address.address_2 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, employer.address.address_2, /*#__PURE__*/React__default.createElement("br", null)), employer.address.town, /*#__PURE__*/React__default.createElement("br", null), employer.address.county && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, employer.address.county, /*#__PURE__*/React__default.createElement("br", null)), employer.address.country))), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Phone"), employer.address && Object.keys(employer.address).length > 0 && /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        wrap: true,
        variant: "content"
      }, employer.address.phone)), !!employer.website && /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Website"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        wrap: true,
        variant: "content"
      }, employer.website))));
      var participantDetails = /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "1rem"
      }, /*#__PURE__*/React__default.createElement(H2$1, {
        variant: "primary",
        marginless: true
      }, "Participant Details"), /*#__PURE__*/React__default.createElement(Grid$1, {
        grid: "auto / auto-flow",
        placeItems: "start",
        placeContent: "start"
      }, /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Name"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        variant: "content"
      }, participant.full_name)), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Date of Birth"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        variant: "content"
      }, /*#__PURE__*/React__default.createElement(Moment, {
        value: participant.dob
      }))), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Address"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        wrap: true,
        variant: "content"
      }, participant.address.address_1, /*#__PURE__*/React__default.createElement("br", null), participant.address.address_2 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, participant.address.address_2, /*#__PURE__*/React__default.createElement("br", null)), participant.address.town, /*#__PURE__*/React__default.createElement("br", null), participant.address.county && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, participant.address.county, /*#__PURE__*/React__default.createElement("br", null)), participant.address.country)), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Phone"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        wrap: true,
        variant: "content"
      }, participant.address.phone)), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Email"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        wrap: true,
        variant: "content"
      }, participant.email))));
      var placementDetails = /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "1rem"
      }, /*#__PURE__*/React__default.createElement(H2$1, {
        variant: "primary",
        marginless: true
      }, "Placement Information"), /*#__PURE__*/React__default.createElement(Grid$1, {
        grid: "auto / auto-flow",
        placeItems: "start",
        placeContent: "start"
      }, /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Position"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        variant: "content"
      }, placement.position)), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Program"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        variant: "content"
      }, placement.programme_name)), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Arrival Date"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        variant: "content"
      }, /*#__PURE__*/React__default.createElement(Moment, {
        value: placement.starts_on
      }))), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Start Date"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        variant: "content"
      }, /*#__PURE__*/React__default.createElement(Moment, {
        value: placement.contract_starts_on
      }))), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "End Date"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        variant: "content"
      }, /*#__PURE__*/React__default.createElement(Moment, {
        value: placement.ends_on
      }))), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "No. of Days"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        variant: "content"
      }, placement.number_of_days))), /*#__PURE__*/React__default.createElement(Grid$1, {
        grid: "auto / auto-flow",
        placeItems: "start",
        placeContent: "start"
      }, /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, "Placement Offer - Issue Date"), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        variant: "content"
      }, /*#__PURE__*/React__default.createElement(Moment, {
        value: placement.offer_date
      }))), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H3, {
        variant: "primary",
        marginless: true
      }, placement.pay_label), /*#__PURE__*/React__default.createElement(P$4, {
        marginless: true,
        variant: "content"
      }, placement.pay_value))));
      return /*#__PURE__*/React__default.createElement(StyledPlacementOffer, null, !!employer.host_word && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Grid$1, {
        placeItems: "center",
        placeContent: "center",
        gap: "1rem",
        mobile: true
      }, /*#__PURE__*/React__default.createElement(Img$1, {
        src: employer.avatar,
        alt: "Placement Offer"
      }), /*#__PURE__*/React__default.createElement(H1$1, {
        variant: "primary"
      }, employer.name, " Placement Offer")), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "3rem"
      }, employerDetails, participantDetails, placementDetails, /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H2$1, {
        variant: "primary",
        marginless: true
      }, header_1), /*#__PURE__*/React__default.createElement(P$4, {
        variant: "content",
        wrap: true,
        marginless: true
      }, content_1)), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "0.5rem"
      }, /*#__PURE__*/React__default.createElement(H2$1, {
        variant: "primary",
        marginless: true
      }, header_2), /*#__PURE__*/React__default.createElement(P$4, {
        variant: "content",
        wrap: true,
        marginless: true
      }, content_2)))));
    }
  }]);
}(React__default.Component);
PlacementOffer.propTypes = {
  employer: PropTypes.object.isRequired,
  participant: PropTypes.object.isRequired,
  placement: PropTypes.object.isRequired,
  header_1: PropTypes.string.isRequired,
  header_2: PropTypes.string.isRequired,
  content_1: PropTypes.string.isRequired,
  content_2: PropTypes.string.isRequired
};
PlacementOffer.defaultProps = {
  employer: {
    address: {}
  },
  participant: {
    address: {}
  },
  placement: {},
  header_1: "",
  header_2: "",
  content_1: "",
  content_2: ""
};

var Availability = function Availability(_ref) {
  var earliest_departure_date = _ref.earliest_departure_date,
    latest_date_you_can_work = _ref.latest_date_you_can_work;
  return /*#__PURE__*/React__default.createElement(Card$1, {
    marginless: true,
    variant: "primary"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1rem"
  }, /*#__PURE__*/React__default.createElement(H2$1, {
    marginless: true
  }, "Availability"), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.25rem"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    bold: true
  }, "Available from:"), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true
  }, earliest_departure_date)), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.25rem"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    bold: true
  }, "Available until:"), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true
  }, latest_date_you_can_work))));
};
Availability.propTypes = {
  earliest_departure_date: PropTypes.string,
  latest_date_you_can_work: PropTypes.string
};
Availability.defaultProps = {
  earliest_departure_date: "-",
  latest_date_you_can_work: "-"
};

var Events = function Events(_ref) {
  var events = _ref.events;
  return /*#__PURE__*/React__default.createElement(Card$1, {
    marginless: true,
    variant: "primary"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1rem"
  }, /*#__PURE__*/React__default.createElement(H2$1, {
    marginless: true
  }, "Events"), events.length > 0 ? /*#__PURE__*/React__default.createElement(Grid$1, null, events.map(function (event, index) {
    return /*#__PURE__*/React__default.createElement(Card$1, {
      key: "event_".concat(index),
      variant: "secondary"
    }, /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "0.5rem"
    }, /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      bold: true,
      size: "medium",
      variant: "secondaryReadable"
    }, event.name), /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      variant: "secondaryReadable"
    }, event.event_type)));
  })) : /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true
  }, "Not attending any events.")));
};
Events.propTypes = {
  events: PropTypes.array.isRequired
};
Events.defaultProps = {
  events: []
};

var Date$1 = function Date(_ref) {
  var label = _ref.label,
    answer = _ref.answer;
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, label && label.length > 0 && /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, label), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, /*#__PURE__*/React__default.createElement(Moment, {
    value: answer,
    blank: "-"
  })));
};

var _templateObject$s, _templateObject2$o, _templateObject3$i, _templateObject4$h;
var Ul = styled.ul(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n  margin: 0;\n\n  ", "\n"])), function (_ref) {
  var profileData = _ref.profileData;
  return profileData && css(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral(["\n      padding-left: 16px;\n      padding-top: 4px;\n    "])));
});
var Li = styled.li(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ", sans-serif;\n  font-weight: ", ";\n  margin-bottom: 0.25rem;\n\n  ", "\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.content.text;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.body.family;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.body.weight;
}, function (_ref5) {
  var profileData = _ref5.profileData;
  return profileData && css(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteral(["\n      color: #333333;\n      font-weight: 500;\n      font-size: 16px;\n      font-weight: normal;\n    "])));
});

var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
    answer = _ref.answer;
  var values = Array.isArray(answer) ? answer : answer.toString().split(",").filter(function (n) {
    return n;
  });
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, label && label.length > 0 && /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, label), values && values.length > 0 ? /*#__PURE__*/React__default.createElement(Ul, {
    profileData: true
  }, values.map(function (value) {
    return /*#__PURE__*/React__default.createElement(Li, {
      profileData: true
    }, " ", value, " ");
  })) : /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, "-"));
};

var _templateObject$r, _templateObject2$n;
var List$1 = styled.ul(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  padding-left: 18px;\n"])));
var ListItem$1 = styled.li(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral(["\n  color: ", ";\n  line-height: 1.55em;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.darkGrey;
});

var MultiText = function MultiText(_ref) {
  var label = _ref.label,
    answer = _ref.answer;
  var values = Object.values(answer).filter(function (value) {
    return value !== null && value !== "";
  });
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, label && label.length > 0 && /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    size: "medium",
    marginless: true,
    profileLabel: true
  }, label), values.length > 0 ? /*#__PURE__*/React__default.createElement(List$1, null, values.map(function (value) {
    return /*#__PURE__*/React__default.createElement(ListItem$1, null, capitalize(value));
  })) : /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, "Not set"));
};

var Text$1 = function Text(_ref) {
  var label = _ref.label,
    answer = _ref.answer;
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, label && label.length > 0 && /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, label), answer && /*#__PURE__*/React__default.createElement(Markdown, null, answer), !answer && /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    profileData: true
  }, "-"));
};

var Number$1 = function Number(_ref) {
  var label = _ref.label,
    answer = _ref.answer;
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, label && label.length > 0 && /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, label), answer && /*#__PURE__*/React__default.createElement(Markdown, null, answer), !answer && /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    profileData: true
  }, "-"));
};

var _templateObject$q, _templateObject2$m, _templateObject3$h, _templateObject4$g, _templateObject5$d, _templateObject6$b, _templateObject7$b, _templateObject8$9, _templateObject9$8, _templateObject0$8, _templateObject1$7, _templateObject10$7, _templateObject11$7, _templateObject12$6;
var Container$b = styled.div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  position: relative;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.content.text;
});
var StyledLink = styled(Link$2)(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral(["\n  font-weight: 500;\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.body;
});
var Header$3 = styled.div(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var Title$3 = styled(P$4)(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteral(["\n  font-size: 1.25rem;\n  font-weight: 500;\n"])));
var Subtitle = styled.div(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n\n  ", "\n"])), function (_ref3) {
  var showSeparator = _ref3.showSeparator;
  return !!showSeparator && css(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteral(["\n      &:before {\n        content: \"\";\n        border-left: 1px solid #dddddd;\n        margin: 2px 0;\n        align-self: stretch;\n      }\n    "])));
});
var StartDate = styled(P$4)(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteral(["\n  order: -1;\n\n  @media only screen and (max-width: 764px) {\n    font-size: 0.8rem;\n  }\n"])));
var Interviews$1 = styled(P$4)(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteral(["\n  margin: 0;\n  color: #aaaaaa;\n\n  @media only screen and (max-width: 764px) {\n    font-size: 0.8rem;\n  }\n\n  ", "\n"])), function (_ref4) {
  var positive = _ref4.positive;
  return !!positive && css(_templateObject9$8 || (_templateObject9$8 = _taggedTemplateLiteral(["\n      color: #629f00;\n    "])));
});
var Separator = styled.div(_templateObject0$8 || (_templateObject0$8 = _taggedTemplateLiteral(["\n  border-top: 1px solid #dddddd;\n"])));
var SearchBox$1 = styled(TextField)(_templateObject1$7 || (_templateObject1$7 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  padding: 0.5rem 1rem;\n  background-color: #fff;\n  border: 1px solid #d8d8d8;\n  color: ", ";\n  width: unset;\n  font-weight: bold;\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  ", "\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.secondaryAlternative || theme.colors.secondary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return transparentize(0.6, theme.colors.secondaryAlternative || theme.colors.secondary);
}, breakpoint("tablet")(_templateObject10$7 || (_templateObject10$7 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: -2.5rem;\n    right: 0;\n  "]))));
var RoleCard = styled(Card$1)(_templateObject11$7 || (_templateObject11$7 = _taggedTemplateLiteral(["\n  padding: 1.5rem;\n  margin-top: 0.75rem;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject12$6 || (_templateObject12$6 = _taggedTemplateLiteral(["\n    padding: 2rem;\n    margin-top: 0.5rem;\n  "]))));

var Roles = function Roles(_ref) {
  var _employer$host_word;
  var label = _ref.label,
    skills = _ref.skills,
    employer = _ref.employer,
    onRequestInterview = _ref.onRequestInterview,
    onInterview = _ref.onInterview,
    bookInterviewSelectedSkill = _ref.bookInterviewSelectedSkill,
    bookInterviewSection = _ref.bookInterviewSection,
    initialSection = _ref.initialSection;
  var _useState = useState(skills),
    _useState2 = _slicedToArray(_useState, 2),
    filteredSkills = _useState2[0],
    setFilteredSkills = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    openSkills = _useState4[0],
    setOpenSkills = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    searchValue = _useState6[0],
    setSearchValue = _useState6[1];
  var toggle = function toggle(skill) {
    if (isOpen(skill)) setOpenSkills(openSkills.filter(function (x) {
      return x.id !== skill.id;
    }));else setOpenSkills([].concat(_toConsumableArray(openSkills), [skill]));
  };
  var handleSearchBox = function handleSearchBox(event) {
    var value = event.target.value;
    setSearchValue(value);
    var filteredSkills = skills.filter(function (skill) {
      return skill.name.toLowerCase().includes(value.toLowerCase()) || skill.notes.toLowerCase().includes(value.toLowerCase());
    });
    setFilteredSkills(filteredSkills);
  };
  var isOpen = function isOpen(skill) {
    return openSkills.includes(skill);
  };
  var hasInterviews = function hasInterviews(skill) {
    var _employer$interviews_;
    return (employer === null || employer === void 0 ? void 0 : employer.interviews_available) && (employer === null || employer === void 0 || (_employer$interviews_ = employer.interviews_available_role_ids) === null || _employer$interviews_ === void 0 ? void 0 : _employer$interviews_.includes(skill.id));
  };
  useEffect(function () {
    if (initialSection && initialSection == "roles") {
      setOpenSkills(skills.filter(function (skill) {
        return hasInterviews(skill);
      }));
    }
  }, [initialSection]);
  useEffect(function () {
    if (employer !== null && employer !== void 0 && employer.available_role_ids_for_programme) {
      var _filteredSkills = skills.filter(function (skill) {
        return employer.available_role_ids_for_programme.includes(skill.id);
      });
      setFilteredSkills(_filteredSkills);
    }
  }, [employer === null || employer === void 0 ? void 0 : employer.available_role_ids_for_programme]);
  var panelContent = function panelContent(skill) {
    var contents = [];
    if (employer !== null && employer !== void 0 && employer.additional_role_fields_enabled && (skill.hourly_wage || skill.experience_required || skill.certifications_required || skill.full_job_description)) {
      contents.push(/*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: "fields"
      }, /*#__PURE__*/React__default.createElement(P$4, {
        variant: "content",
        marginless: true
      }, skill.hourly_wage && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Wage: ", employer.employer_currency, skill.hourly_wage, " p/h", " ", skill.tips_available !== undefined && skill.tips_available === true && "- Tipped Position", /*#__PURE__*/React__default.createElement("br", null)), skill.experience_required && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Experience required: ", skill.experience_required, /*#__PURE__*/React__default.createElement("br", null)), skill.certifications_required && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Certifications required: ", skill.certifications_required, /*#__PURE__*/React__default.createElement("br", null))), /*#__PURE__*/React__default.createElement(P$4, {
        variant: "content",
        marginless: true,
        style: {
          marginTop: "-5px",
          whiteSpace: "pre-wrap"
        }
      }, skill.full_job_description)));
    }
    if (skill.notes) {
      contents.push(/*#__PURE__*/React__default.createElement(P$4, {
        key: "notes",
        variant: "content",
        marginless: true,
        style: {
          marginTop: "-5px",
          whiteSpace: "pre-wrap"
        }
      }, skill.notes));
    }
    if (!(employer !== null && employer !== void 0 && employer.hide_interview_availability)) {
      if (bookInterviewSelectedSkill && bookInterviewSelectedSkill.id === skill.id && bookInterviewSection) {
        contents.push(/*#__PURE__*/React__default.createElement(React__default.Fragment, {
          key: "custom-section"
        }, bookInterviewSection()));
      } else if (hasInterviews(skill)) {
        contents.push(/*#__PURE__*/React__default.createElement(Grid$1, {
          key: "book",
          placeItems: "start"
        }, /*#__PURE__*/React__default.createElement(Button$5, {
          variant: "primary",
          onClick: function onClick() {
            onInterview(skill);
          }
        }, "Book Interview")));
      } else if (employer !== null && employer !== void 0 && employer.participantCanInvokeInterviews && !hasInterviews(skill)) {
        contents.push(/*#__PURE__*/React__default.createElement(React__default.Fragment, {
          key: "request"
        }, !employer.shown_interest && /*#__PURE__*/React__default.createElement(P$4, {
          variant: "content",
          marginless: true,
          style: {
            marginTop: "-5px"
          }
        }, "Sorry, no interview times are currently available for this role. You can still request an interview. We'll email the ", employer.host_word.toLowerCase(), " to let them know you're interested and you'll get a notification once they've added some times."), employer.shown_interest && /*#__PURE__*/React__default.createElement(P$4, {
          variant: "content",
          marginless: true,
          style: {
            marginTop: "-5px"
          }
        }, "You have successfully requested an interview with this ", employer.host_word.toLowerCase(), ". Once they add more interview times, you'll get a notification."), /*#__PURE__*/React__default.createElement(Grid$1, {
          placeItems: "start"
        }, /*#__PURE__*/React__default.createElement(Button$5, {
          disabled: employer.shown_interest,
          variant: "primary",
          onClick: function onClick(e) {
            e.preventDefault();
            onRequestInterview(skill);
          }
        }, "Request Interview"))));
      }
    }
    if (contents.length === 0) return null;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, contents);
  };
  return /*#__PURE__*/React__default.createElement(Container$b, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(SearchBox$1, {
    value: searchValue,
    placeholder: "Search",
    onChange: handleSearchBox
  }), label && label.length > 0 && /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true
  }, label), !!(employer !== null && employer !== void 0 && employer.interviews_available_via_event) && /*#__PURE__*/React__default.createElement(RoleCard, {
    marginless: true,
    variant: "primary"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true
  }, "This ", (employer === null || employer === void 0 || (_employer$host_word = employer.host_word) === null || _employer$host_word === void 0 ? void 0 : _employer$host_word.toLowerCase()) || "employer", " is currently open to interviews via an online hiring fair."), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true
  }, "Check ", /*#__PURE__*/React__default.createElement(StyledLink, {
    to: "/events"
  }, "your events"), " to register for a hiring fair and access interview availability.")), filteredSkills.length == 0 && /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true
  }, (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "No roles matching ", /*#__PURE__*/React__default.createElement("strong", null, searchValue), " were found.") : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "No roles are currently available.")), filteredSkills.map(function (skill) {
    var content = panelContent(skill);
    var hasContent = !!content;
    return /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "16px",
      key: skill.id
    }, /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement(Header$3, hasContent ? {
      onClick: function onClick() {
        return toggle(skill);
      },
      style: {
        cursor: "pointer"
      }
    } : {}, /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "4px"
    }, /*#__PURE__*/React__default.createElement(Title$3, {
      variant: "content",
      marginless: true
    }, skill.name), /*#__PURE__*/React__default.createElement(Subtitle, {
      showSeparator: !(employer !== null && employer !== void 0 && employer.hide_interview_availability)
    }, /*#__PURE__*/React__default.createElement(StartDate, {
      variant: "content",
      marginless: true
    }, "Start date: ", skill.start_dates_string), !(employer !== null && employer !== void 0 && employer.hide_interview_availability) && /*#__PURE__*/React__default.createElement(Interviews$1, {
      positive: hasInterviews(skill)
    }, hasInterviews(skill) ? "Interviews available" : "Interviews unavailable"))), hasContent && /*#__PURE__*/React__default.createElement(Arrow, {
      direction: isOpen(skill) ? "up" : "down",
      color: "current",
      size: "small"
    })), hasContent && isOpen(skill) && content, filteredSkills.indexOf(skill) < filteredSkills.length - 1 && /*#__PURE__*/React__default.createElement(Separator, {
      variant: "secondaryReadable"
    }));
  })));
};
Roles.defaultProps = {
  skills: []
};

var VideoFrame = function VideoFrame(_ref) {
  var label = _ref.label,
    answer = _ref.answer;
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem"
  }, label && label.length > 0 && /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    size: "medium",
    marginless: true,
    bold: true
  }, label), /*#__PURE__*/React__default.createElement(VideoContainer$2, null, /*#__PURE__*/React__default.createElement(VideoWrapper$2, null, /*#__PURE__*/React__default.createElement(Video$1, {
    title: label,
    width: "560",
    height: "349",
    src: answer,
    frameBorder: "0",
    allowFullScreen: true
  }))));
};

var _templateObject$p, _templateObject2$l, _templateObject3$g, _templateObject4$f, _templateObject5$c, _templateObject6$a, _templateObject7$a, _templateObject8$8, _templateObject9$7, _templateObject0$7, _templateObject1$6, _templateObject10$6, _templateObject11$6, _templateObject12$5;
var Fieldset = styled.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  border-bottom: 1px solid #dddddd;\n  padding-bottom: 2rem;\n\n  &:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n\n  ", "\n"])), function (_ref) {
  var video = _ref.video;
  return video && css(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral(["\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 2rem;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral(["\n        flex-direction: row;\n      "]))));
});
var CustomFlex = styled.div(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var header = _ref2.header;
  return header && css(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteral(["\n      ", "\n\n      display: flex;\n      justify-content: space-between;\n      gap: 2rem;\n      flex-direction: column-reverse;\n    "])), breakpoint("tablet")(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteral(["\n        flex-direction: row;\n      "]))));
});
var VideoContainer = styled.div(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  overflow: hidden;\n  margin: 0 auto;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteral(["\n    margin: 0;\n  "]))));
var Div$1 = styled.div(_templateObject9$7 || (_templateObject9$7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n\n  ", "\n  ", "\n"])), function (_ref3) {
  var profileLayout = _ref3.profileLayout;
  return profileLayout === "split" && css(_templateObject0$7 || (_templateObject0$7 = _taggedTemplateLiteral(["\n      flex: 1;\n      box-sizing: border-box;\n    "])));
}, function (_ref4) {
  var profileLayout = _ref4.profileLayout;
  return profileLayout === "horizontal" && css(_templateObject1$6 || (_templateObject1$6 = _taggedTemplateLiteral(["\n      display: grid;\n      align-items: start;\n      gap: 1.5rem;\n      grid-template: auto / 1fr;\n\n      ", "\n      ", "\n    "])), breakpoint("tablet")(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteral(["\n        grid-template: auto / 1fr 1fr;\n      "]))), breakpoint("desktop")(_templateObject11$6 || (_templateObject11$6 = _taggedTemplateLiteral(["\n        grid-template: auto / 1fr 1fr 1fr 1fr;\n      "]))));
});
styled.img(_templateObject12$5 || (_templateObject12$5 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n"])));

var _templateObject$o, _templateObject2$k, _templateObject3$f, _templateObject4$e;
var Img = styled.img(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  margin: 0;\n  width: 100%;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n    cursor: pointer;\n  "]))));
var VideoWrapper = styled.div(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral(["\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 0%;\n  overflow: hidden;\n  z-index: 1;\n"])));
var Video = styled.iframe(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n"])));

var fieldTypes = {
  text: Text$1,
  textarea: Text$1,
  number: Number$1,
  radio: Text$1,
  select: Text$1,
  date: Date$1,
  default_date: Date$1,
  university: Text$1,
  checkbox: Checkbox,
  large_textarea: Text$1,
  multi_text: MultiText,
  url: Text$1,
  roles: Roles
};
var isEmbedVideoUrl = function isEmbedVideoUrl(field) {
  return field.field_type == "url" && validVideoUrl(field.answer);
};
var defaultMaxWidth = 250;
var dynamicHeight = function dynamicHeight(videoWidth, videoHeight) {
  var aspectRatio = videoHeight / videoWidth;
  var dynamicHeight = defaultMaxWidth * aspectRatio;
  return dynamicHeight;
};
var Form = function Form(_ref) {
  var fieldsets = _ref.fieldsets,
    employer = _ref.employer,
    onRequestInterview = _ref.onRequestInterview,
    onInterview = _ref.onInterview,
    bookInterviewSelectedSkill = _ref.bookInterviewSelectedSkill,
    bookInterviewSection = _ref.bookInterviewSection,
    initialSection = _ref.initialSection;
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "32px"
  }, fieldsets && fieldsets.filter(function (fieldset) {
    return fieldset.fields.length > 0 && fieldset.fields.some(function (field) {
      return field.answer || field.field_type === "roles";
    });
  }).map(function (fieldset, index) {
    return /*#__PURE__*/React__default.createElement(Fieldset, {
      className: "fieldset_".concat(fieldset.name),
      key: "fieldset_".concat(index),
      last: fieldsets.length === index + 1,
      video: !!fieldset.intro_video_id,
      marginless: true
    }, /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "1.5rem"
    }, /*#__PURE__*/React__default.createElement(H2$1, {
      variant: "primary",
      marginless: true,
      profile: true
    }, fieldset.legend), /*#__PURE__*/React__default.createElement(CustomFlex, {
      header: !!fieldset.header_photo
    }, /*#__PURE__*/React__default.createElement(Div$1, {
      profileLayout: fieldset.profile_layout
    }, fieldset.fields.map(function (field, index2) {
      var FieldType;
      if (isEmbedVideoUrl(field)) {
        FieldType = VideoFrame;
      } else {
        FieldType = fieldTypes[field.field_type];
      }

      // skip the title if it's the same as the fieldset
      field.label = fieldset.legend == field.label ? "" : field.label;
      return FieldType ? /*#__PURE__*/React__default.createElement(FieldType, _extends({
        key: "fieldset_".concat(index, "_field_").concat(index2)
      }, field, {
        employer: employer,
        onRequestInterview: onRequestInterview,
        onInterview: onInterview,
        bookInterviewSelectedSkill: bookInterviewSelectedSkill,
        bookInterviewSection: bookInterviewSection,
        initialSection: initialSection
      })) : /*#__PURE__*/React__default.createElement(P$4, {
        variant: "content"
      }, "error");
    })), !!!fieldset.intro_video_id && !!fieldset.header_photo && /*#__PURE__*/React__default.createElement(Div$1, {
      profileLayout: fieldset.profile_layout,
      style: {
        maxHeight: "320px",
        overflow: "hidden"
      }
    }, /*#__PURE__*/React__default.createElement(Img, {
      src: fieldset.header_photo,
      alt: fieldset.legend,
      style: {
        cursor: "default",
        objectFit: "cover",
        width: "100%",
        height: "100%"
      }
    })))), !!fieldset.intro_video_id && /*#__PURE__*/React__default.createElement(VideoContainer, {
      style: {
        width: defaultMaxWidth,
        height: dynamicHeight(fieldset.intro_video_width, fieldset.intro_video_height)
      }
    }, /*#__PURE__*/React__default.createElement(VideoPlayer, {
      videoId: fieldset.intro_video_id,
      displayEmployerLabel: true,
      fullSize: true,
      width: defaultMaxWidth,
      height: dynamicHeight(fieldset.intro_video_width, fieldset.intro_video_height)
    })));
  }));
};

var Interviews = function Interviews(_ref) {
  var interview_summary = _ref.interview_summary,
    english_rating = _ref.english_rating;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(H2$1, {
    variant: "primary",
    profile: true
  }, "Interview summary"), /*#__PURE__*/React__default.createElement(Grid$1, {
    marginless: true,
    gap: "24px"
  }, interview_summary.length > 0 ? interview_summary.map(function (paragraph) {
    return /*#__PURE__*/React__default.createElement(P$4, {
      variant: "content",
      marginless: true,
      profileData: true
    }, paragraph);
  }) : /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, "No summary available."), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    profileLabel: true
  }, "English rating:"), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    profileData: true
  }, english_rating))));
};
Interviews.propTypes = {
  interview_summary: PropTypes.array.isRequired,
  english_rating: PropTypes.string
};
Interviews.defaultProps = {
  interview_summary: [],
  english_rating: "-"
};

var Languages = function Languages(_ref) {
  var languages = _ref.languages;
  return /*#__PURE__*/React__default.createElement(Card$1, {
    marginless: true,
    variant: "primary"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1rem"
  }, /*#__PURE__*/React__default.createElement(H2$1, {
    marginless: true
  }, "Languages"), languages.length > 0 ? /*#__PURE__*/React__default.createElement(Grid$1, null, languages.map(function (language, index) {
    return /*#__PURE__*/React__default.createElement(Card$1, {
      key: "language_".concat(index),
      variant: "secondary"
    }, /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "0.5rem"
    }, /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      bold: true,
      size: "medium",
      variant: "secondaryReadable"
    }, language.name), /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      variant: "secondaryReadable"
    }, language.level)));
  })) : /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true
  }, "-")));
};
Languages.propTypes = {
  languages: PropTypes.array.isRequired
};
Languages.defaultProps = {
  languages: []
};

var _templateObject$n, _templateObject2$j, _templateObject3$e, _templateObject4$d, _templateObject5$b, _templateObject6$9, _templateObject7$9;
var OverviewContainer = styled.div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  ", "\n"])), breakpoint("tablet")(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n    display: flex;\n    gap: 32px;\n  "]))));
var IntroVideoContainer = styled.div(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral(["\n  padding: 32px 0;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteral(["\n    flex: 0 0 25%;\n    display: flex;\n    justify-content: end;\n    padding-right: 0;\n    padding-top: 0;\n  "]))));
var IntroVideo = styled.div(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #333;\n  border-radius: 16px;\n  color: #fff;\n  font-size: 1.5rem;\n  text-align: center;\n  line-height: 1.7em;\n  aspect-ratio: 9/19;\n  width: 50vw;\n  margin: 0 auto;\n\n  width: ", "px;\n  height: ", "px;\n\n  ", "\n"])), function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var height = _ref2.height;
  return height;
}, breakpoint("tablet")(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    max-height: 500px;\n    margin: 0;\n  "])), function (_ref3) {
  var width = _ref3.width;
  return width ? "width: ".concat(width, "px") : "width: unset;";
}, function (_ref4) {
  var height = _ref4.height;
  return height ? "height: ".concat(height, "px") : "height: 50%; height: 50vh;";
}));
styled.p(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteral(["\n  position: absolute;\n  margin-top: 7rem;\n  font-size: 1rem;\n"])));

var Overview = function Overview(_ref) {
  var preferred_name = _ref.preferred_name,
    dob = _ref.dob,
    programme_age = _ref.programme_age,
    availability_from = _ref.availability_from,
    availability_until = _ref.availability_until,
    course_studied = _ref.course_studied,
    home_number = _ref.home_number,
    mobile_number = _ref.mobile_number,
    email = _ref.email,
    address = _ref.address,
    show_contact_info = _ref.show_contact_info,
    availability_plugin_enabled = _ref.availability_plugin_enabled,
    video_id = _ref.video_id,
    video_height = _ref.video_height,
    video_width = _ref.video_width,
    student_status = _ref.student_status;
  var aspectRatio = video_height / video_width;
  var defaultMaxWidth = 250;
  var videoWidth = Math.min(defaultMaxWidth, video_width);
  var dynamicHeight = videoWidth * aspectRatio;
  return /*#__PURE__*/React__default.createElement(OverviewContainer, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "64px",
    fill: true
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(H2$1, {
    variant: "primary",
    profile: true
  }, "Basic Information"), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1.5rem",
    overview: true,
    videoGrid: !!video_id
  }, preferred_name && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, "Preferred name"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, preferred_name)), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, "Date of birth"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, /*#__PURE__*/React__default.createElement(Moment, {
    value: dob,
    blank: "-"
  }))), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, "Age on program"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, programme_age || "-")), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, "Course studying/studied"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, course_studied || "-")), availability_plugin_enabled && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, "Availability"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, availability_from && availability_until ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Moment, {
    value: availability_from,
    blank: "-"
  }), "\xA0to\xA0", /*#__PURE__*/React__default.createElement(Moment, {
    value: availability_until,
    blank: "-"
  })) : "-")), student_status && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, "Student status"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, student_status)))), !!show_contact_info && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(H2$1, {
    variant: "primary",
    profile: true
  }, "Contact information"), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1.5rem",
    overview: true,
    videoGrid: true,
    template: "auto / 1fr 1fr 1fr"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, "Home tel"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, home_number)), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, "Mobile/cell"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, mobile_number)), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, "Email"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, email)), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileLabel: true
  }, "Address"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, address))))), !!video_id && /*#__PURE__*/React__default.createElement(IntroVideoContainer, null, /*#__PURE__*/React__default.createElement(IntroVideo, {
    width: videoWidth,
    height: dynamicHeight
  }, /*#__PURE__*/React__default.createElement(VideoPlayer, {
    videoId: video_id,
    displayLabel: true,
    fullSize: true,
    width: videoWidth,
    height: dynamicHeight
  }))));
};
Overview.propTypes = {
  dob: PropTypes.string,
  programme_age: PropTypes.string,
  availability_from: PropTypes.string,
  availability_until: PropTypes.string,
  course_studied: PropTypes.string,
  home_number: PropTypes.string,
  mobile_number: PropTypes.string,
  email: PropTypes.string,
  address: PropTypes.string,
  show_contact_info: PropTypes.bool,
  availability_plugin_enabled: PropTypes.bool
};
Overview.defaultProps = {
  dob: "-",
  programme_age: "-",
  availability_from: "-",
  availability_until: "-",
  course_studied: "-",
  home_number: "-",
  mobile_number: "-",
  email: "-",
  address: "-",
  show_contact_info: false,
  availability_plugin_enabled: false
};

var _templateObject$m, _templateObject2$i, _templateObject3$d, _templateObject4$c, _templateObject5$a, _templateObject6$8, _templateObject7$8, _templateObject8$7;
var Container$a = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  background: #f7f7f7;\n  border: 1px solid #e6e6e6;\n  border-radius: 0.75rem;\n  padding: 1.5rem;\n\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 1rem;\n\n  ", "\n\n  margin-bottom: 2rem;\n"])), breakpoint("desktop")(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n    flex-direction: row;\n    gap: 1.5rem;\n  "]))));
var ImageWrapper = styled.div(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 0;\n\n  img {\n    width: 50%;\n    max-height: 120px;\n    min-height: 40px;\n    margin: 0;\n\n    border-radius: 0.25rem;\n  }\n\n  span {\n    font-size: 1rem;\n    font-weight: 500;\n    color: ", ";\n  }\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.brand;
}, function (_ref2) {
  var background = _ref2.background;
  return background && css(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteral(["\n      img {\n        background: #fff;\n        margin: 0;\n        padding: 0.5rem;\n      }\n    "])));
}, breakpoint("desktop")(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteral(["\n    align-items: center;\n    gap: 0.5rem;\n\n    img {\n      width: 120px;\n      margin: 0 1rem;\n    }\n  "]))));
var TextWrapper = styled.div(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n"])));
var NoteTitle = styled.h3(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteral(["\n  color: #333333;\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0;\n"])));
var NoteText = styled.p(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteral(["\n  color: #333333;\n  font-size: 1rem;\n  line-height: 1.5;\n  margin: 0;\n  white-space: pre-line;\n"])));

var Note = function Note(_ref) {
  var image = _ref.image,
    image_note = _ref.image_note,
    image_background = _ref.image_background,
    title = _ref.title,
    notes = _ref.notes;
  return /*#__PURE__*/React__default.createElement(Container$a, null, image && /*#__PURE__*/React__default.createElement(ImageWrapper, {
    background: image_background
  }, /*#__PURE__*/React__default.createElement("img", {
    src: image
  }), image_note && /*#__PURE__*/React__default.createElement("span", null, image_note)), /*#__PURE__*/React__default.createElement(TextWrapper, null, title && /*#__PURE__*/React__default.createElement(NoteTitle, null, title), /*#__PURE__*/React__default.createElement(NoteText, null, notes)));
};

var Preferences = function Preferences(_ref) {
  var preferences = _ref.preferences;
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0"
  }, /*#__PURE__*/React__default.createElement(H2$1, {
    variant: "primary",
    profile: true
  }, "Preferences"), preferences.length > 0 ? /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "8px"
  }, preferences.map(function (preference, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: "preference_".concat(index)
    }, /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      variant: "content",
      profileData: true
    }, "- ", preference.name));
  })) : /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    profileData: true
  }, "No preferences set."));
};
Preferences.propTypes = {
  preferences: PropTypes.array.isRequired
};
Preferences.defaultProps = {
  preferences: []
};

var _templateObject$l, _templateObject2$h;
var Span$1 = styled.span(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  float: right;\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var Reference = styled.div(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n  border: 1px solid #e6e6e6;\n  padding: 24px;\n  border-radius: 12px;\n"])));

var References = function References(_ref) {
  var references = _ref.references,
    rft_references = _ref.rft_references,
    channel_host_word = _ref.channel_host_word,
    openReference = _ref.openReference;
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0"
  }, /*#__PURE__*/React__default.createElement(H2$1, {
    variant: "primary",
    profile: true
  }, "References"), references && references.length > 0 || rft_references && rft_references.length > 0 ? /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "24px"
  }, [rft_references, references].map(function (referenceList) {
    return referenceList && referenceList.length > 0 && /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "24px",
      key: referenceList === references ? "personal" : "previous"
    }, referenceList.map(function (reference, index) {
      return /*#__PURE__*/React__default.createElement(Reference, {
        key: reference.id
      }, openReference && /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Button$5, {
        onClick: function onClick() {
          return openReference(reference.id);
        },
        size: "small",
        variant: "primary",
        outlined: true
      }, "Download PDF")), /*#__PURE__*/React__default.createElement(Grid$1, {
        gap: "12px"
      }, /*#__PURE__*/React__default.createElement(H3, {
        marginless: true,
        variant: "content",
        profile: true
      }, referenceList === references ? "Personal Reference ".concat(index + 1) : "".concat(channel_host_word, " Reference")), /*#__PURE__*/React__default.createElement(Grid$1, {
        template: "auto / 1fr",
        gap: "24px"
      }, reference.fieldsets.map(function (fieldset) {
        return fieldset.fields.map(function (field, index) {
          return /*#__PURE__*/React__default.createElement(Grid$1, {
            gap: "4px",
            key: index
          }, /*#__PURE__*/React__default.createElement(P$4, {
            marginless: true,
            variant: "content",
            profileLabel: true
          }, field.label), /*#__PURE__*/React__default.createElement(P$4, {
            marginless: true,
            variant: "content",
            profileData: true
          }, field.answer));
        });
      }))));
    }));
  })) : /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    profileData: true
  }, "No references."));
};
References.propTypes = {
  references: PropTypes.array.isRequired,
  openReference: PropTypes.func
};
References.defaultProps = {
  references: [],
  openReference: undefined
};

var _templateObject$k, _templateObject2$g, _templateObject3$c, _templateObject4$b, _templateObject5$9, _templateObject6$7, _templateObject7$7;
var Skill = styled.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  border: 1px solid #e6e6e6;\n  padding: 24px;\n  border-radius: 12px;\n"])));
var TopSkill = styled.span(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n  padding: 4px 8px;\n  border-radius: 6px;\n  margin-left: 8px;\n  margin-top: 0;\n  font-size: 13px;\n  font-weight: bold;\n  font-family: ", ", sans-serif;\n  text-align: center;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.body.family;
}, function (props) {
  return css(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "])), props.theme.colors.primary, props.theme.colors.body);
}, breakpoint("tablet")(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral(["\n    margin-top: 0;\n    margin-left: 10px;\n  "]))));
var SkillName = styled.div(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var SkillQualifications = styled.div(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteral(["\n  margin-top: 1rem;\n"])));
var SkillLevel = styled.span(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteral(["\n  font-size: 0.7em;\n  font-weight: normal;\n  letter-spacing: 0.1px;\n"])));

var AutoLink = function AutoLink(_ref) {
  var text = _ref.text,
    target = _ref.target;
  var delimiter = /((?:https?:\/\/)?(?:(?:[a-z0-9]?(?:[a-z0-9\-]{1,61}[a-z0-9])?\.[^\.|\s])+[a-z\.]*[a-z]+|(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3})(?::\d{1,5})*[a-z0-9.,_\/~#&=;%+?\-\\(\\)]*)/gi;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, text.split(delimiter).map(function (word) {
    var match = word.match(delimiter);
    if (match) {
      var url = match[0];
      return /*#__PURE__*/React__default.createElement("a", {
        href: url.startsWith("http") ? url : "https://".concat(url),
        target: target
      }, url);
    }
    return word;
  }));
};
AutoLink.propTypes = {
  text: PropTypes.string.isRequired,
  target: PropTypes.string
};
AutoLink.defaultProps = {
  target: "_blank"
};

var Qualifications = function Qualifications(skill) {
  var _skill$qualifications;
  return /*#__PURE__*/React__default.createElement(SkillQualifications, null, (_skill$qualifications = skill.qualifications) === null || _skill$qualifications === void 0 ? void 0 : _skill$qualifications.map(function (qualification, index) {
    var qualification_name = qualification.qualification_name,
      certificate_body_name = qualification.certificate_body_name,
      year_awarded = qualification.year_awarded;
    var qualificationDetails = [qualification_name, certificate_body_name, year_awarded].filter(Boolean).join(", ");
    return /*#__PURE__*/React__default.createElement(P$4, {
      key: index,
      profileData: true,
      marginless: true
    }, qualificationDetails);
  }));
};
var Skills = function Skills(_ref) {
  var top_skills = _ref.top_skills,
    other_skills = _ref.other_skills,
    portalType = _ref.portalType;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(H2$1, {
    variant: "primary",
    profile: true
  }, "Skills"), top_skills.length > 0 || other_skills.length > 0 ? /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "24px"
  }, top_skills.map(function (skill, _index) {
    var _skill$level, _skill$qualifications2;
    return /*#__PURE__*/React__default.createElement(Skill, {
      key: skill.id
    }, /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "16px"
    }, /*#__PURE__*/React__default.createElement(SkillName, null, /*#__PURE__*/React__default.createElement(H2$1, {
      marginless: true,
      variant: "secondary",
      profile: true
    }, skill.name, portalType === "employer" && ((_skill$level = skill.level) === null || _skill$level === void 0 ? void 0 : _skill$level.length) > 0 && /*#__PURE__*/React__default.createElement(SkillLevel, null, " - ", skill.level)), /*#__PURE__*/React__default.createElement(TopSkill, null, "Top skill")), portalType !== "employer" && /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "4px"
    }, /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileLabel: true
    }, "Level"), /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileData: true
    }, skill.level || "-")), ((_skill$qualifications2 = skill.qualifications) === null || _skill$qualifications2 === void 0 ? void 0 : _skill$qualifications2.length) > 0 && /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "4px"
    }, /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileLabel: true
    }, "Qualification Acquired"), /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileData: true,
      variant: "contentv2",
      overflow: true
    }, Qualifications(skill))), /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      variant: "contentv2",
      multiline: true,
      overflow: true
    }, /*#__PURE__*/React__default.createElement(AutoLink, {
      text: skill.description || "-"
    }))));
  }), other_skills.map(function (skill, index) {
    var _skill$level2, _skill$qualifications3;
    return /*#__PURE__*/React__default.createElement(Skill, {
      key: skill.id
    }, /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "16px"
    }, /*#__PURE__*/React__default.createElement(H2$1, {
      marginless: true,
      variant: "secondary",
      profile: true
    }, skill.name, portalType === "employer" && ((_skill$level2 = skill.level) === null || _skill$level2 === void 0 ? void 0 : _skill$level2.length) > 0 && /*#__PURE__*/React__default.createElement(SkillLevel, null, " - ", skill.level)), portalType !== "employer" && /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "4px"
    }, /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileLabel: true
    }, "Level"), /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileData: true
    }, skill.level || "-")), ((_skill$qualifications3 = skill.qualifications) === null || _skill$qualifications3 === void 0 ? void 0 : _skill$qualifications3.length) > 0 && /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "4px"
    }, /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileLabel: true
    }, "Qualification Acquired"), /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileData: true
    }, Qualifications(skill))), /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      variant: "contentv2",
      multiline: true,
      overflow: true
    }, /*#__PURE__*/React__default.createElement(AutoLink, {
      text: skill.description || "-"
    }))));
  })) : /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    profileData: true
  }, "No skills set."));
};
Skills.propTypes = {
  top_skills: PropTypes.array.isRequired,
  other_skills: PropTypes.array.isRequired
};
Skills.defaultProps = {
  top_skills: [],
  other_skills: []
};

var TravelAndFlights = function TravelAndFlights() {
  return null;
};

var _templateObject$j;
var Experience = styled.div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  border: 1px solid #e6e6e6;\n  padding: 24px;\n  border-radius: 12px;\n"])));

var WorkExperience = function WorkExperience(_ref) {
  var work_experiences = _ref.work_experiences;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(H2$1, {
    variant: "primary",
    profile: true
  }, "Work Experience"), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "24px"
  }, work_experiences.length > 0 ? /*#__PURE__*/React__default.createElement(Grid$1, null, work_experiences.map(function (work_experience) {
    return /*#__PURE__*/React__default.createElement(Experience, {
      key: work_experience.id
    }, /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "16px"
    }, /*#__PURE__*/React__default.createElement(H3, {
      marginless: true,
      profile: true,
      variant: "content"
    }, work_experience.job_title), /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "16px",
      template: "auto / 1fr 1fr"
    }, /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "4px"
    }, /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileLabel: true
    }, "Name"), /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileData: true
    }, work_experience.employer_name)), /*#__PURE__*/React__default.createElement(Grid$1, {
      gap: "4px"
    }, /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileLabel: true
    }, "Period"), /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      profileData: true
    }, work_experience.dates))), /*#__PURE__*/React__default.createElement(P$4, {
      marginless: true,
      variant: "content",
      profileData: true
    }, work_experience.job_description)));
  })) : /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    profileData: true
  }, "No work experience.")));
};
WorkExperience.propTypes = {
  work_experiences: PropTypes.array.isRequired
};
WorkExperience.defaultProps = {
  work_experiences: []
};

var WorkPermit = function WorkPermit() {
  return null;
};

var MODULE_CAROUSEL = "carousel";
var MODULE_CONTROLLER = "controller";
var MODULE_NAVIGATION = "navigation";
var MODULE_NO_SCROLL = "no-scroll";
var MODULE_PORTAL = "portal";
var MODULE_ROOT = "root";
var MODULE_TOOLBAR = "toolbar";
var PLUGIN_COUNTER = "counter";
var SLIDE_STATUS_LOADING = "loading";
var SLIDE_STATUS_ERROR = "error";
var SLIDE_STATUS_COMPLETE = "complete";
var SLIDE_STATUS_PLACEHOLDER = "placeholder";
var activeSlideStatus = function activeSlideStatus(status) {
  return "active-slide-".concat(status);
};
var CLASS_FLEX_CENTER = "flex_center";
var CLASS_NO_SCROLL = "no_scroll";
var CLASS_NO_SCROLL_PADDING = "no_scroll_padding";
var CLASS_SLIDE_WRAPPER = "slide_wrapper";
var ACTION_PREV = "prev";
var ACTION_NEXT = "next";
var ACTION_SWIPE = "swipe";
var ACTION_CLOSE = "close";
var EVENT_ON_POINTER_DOWN = "onPointerDown";
var EVENT_ON_POINTER_MOVE = "onPointerMove";
var EVENT_ON_POINTER_UP = "onPointerUp";
var EVENT_ON_POINTER_LEAVE = "onPointerLeave";
var EVENT_ON_POINTER_CANCEL = "onPointerCancel";
var EVENT_ON_KEY_DOWN = "onKeyDown";
var EVENT_ON_KEY_UP = "onKeyUp";
var EVENT_ON_WHEEL = "onWheel";
var VK_ESCAPE = "Escape";
var VK_ARROW_LEFT = "ArrowLeft";
var VK_ARROW_RIGHT = "ArrowRight";
var ELEMENT_BUTTON = "button";
var ELEMENT_ICON = "icon";
var IMAGE_FIT_CONTAIN = "contain";
var IMAGE_FIT_COVER = "cover";
var UNKNOWN_ACTION_TYPE = "Unknown action type";

var _excluded2$1 = ["children"],
  _excluded3$1 = ["label", "className", "icon", "renderIcon", "onClick", "style"],
  _excluded4 = ["style", "className"],
  _excluded5 = ["className", "children"],
  _excluded6 = ["children"],
  _excluded7 = ["easing"],
  _excluded8 = ["easing"],
  _excluded9 = ["carousel", "animation", "render", "toolbar", "controller", "noScroll", "on", "plugins", "slides", "index"],
  _excluded0 = ["animation", "carousel", "render", "toolbar", "controller", "noScroll", "on", "slides", "index", "plugins"];
var cssPrefix$3 = "yarl__";
function clsx() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }
  return [].concat(classes).filter(Boolean).join(" ");
}
function cssClass(name) {
  return "".concat(cssPrefix$3).concat(name);
}
function cssVar(name) {
  return "--".concat(cssPrefix$3).concat(name);
}
function composePrefix(base, prefix) {
  return "".concat(base).concat(prefix ? "_".concat(prefix) : "");
}
function makeComposePrefix(base) {
  return function (prefix) {
    return composePrefix(base, prefix);
  };
}
function label(labels, defaultLabel) {
  var _a;
  return (_a = labels === null || labels === void 0 ? void 0 : labels[defaultLabel]) !== null && _a !== void 0 ? _a : defaultLabel;
}
function cleanup() {
  for (var _len2 = arguments.length, cleaners = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    cleaners[_key2] = arguments[_key2];
  }
  return function () {
    cleaners.forEach(function (cleaner) {
      cleaner();
    });
  };
}
function makeUseContext(name, contextName, context) {
  return function () {
    var ctx = React.useContext(context);
    if (!ctx) {
      throw new Error("".concat(name, " must be used within a ").concat(contextName, ".Provider"));
    }
    return ctx;
  };
}
function hasWindow() {
  return typeof window !== "undefined";
}
function round(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var factor = Math.pow(10, decimals);
  return Math.round((value + Number.EPSILON) * factor) / factor;
}
function isImageSlide(slide) {
  return slide.type === undefined || slide.type === "image";
}
function isImageFitCover(image, imageFit) {
  return image.imageFit === IMAGE_FIT_COVER || image.imageFit !== IMAGE_FIT_CONTAIN && imageFit === IMAGE_FIT_COVER;
}
function parseInt$1(value) {
  return typeof value === "string" ? Number.parseInt(value, 10) : value;
}
function parseLengthPercentage(input) {
  if (typeof input === "number") {
    return {
      pixel: input
    };
  }
  if (typeof input === "string") {
    var value = parseInt$1(input);
    return input.endsWith("%") ? {
      percent: value
    } : {
      pixel: value
    };
  }
  return {
    pixel: 0
  };
}
function computeSlideRect(containerRect, padding) {
  var paddingValue = parseLengthPercentage(padding);
  var paddingPixels = paddingValue.percent !== undefined ? containerRect.width / 100 * paddingValue.percent : paddingValue.pixel;
  return {
    width: Math.max(containerRect.width - 2 * paddingPixels, 0),
    height: Math.max(containerRect.height - 2 * paddingPixels, 0)
  };
}
function getSlideIndex(index, slidesCount) {
  return slidesCount > 0 ? (index % slidesCount + slidesCount) % slidesCount : 0;
}
function hasSlides(slides) {
  return slides.length > 0;
}
function getSlide(slides, index) {
  return slides[getSlideIndex(index, slides.length)];
}
function getSlideIfPresent(slides, index) {
  return hasSlides(slides) ? getSlide(slides, index) : undefined;
}
function getSlideKey(slide) {
  return isImageSlide(slide) ? slide.src : undefined;
}
function calculatePreload(carousel, slides) {
  var minimum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return Math.min(carousel.preload, Math.max(carousel.finite ? slides.length - 1 : Math.floor(slides.length / 2), minimum));
}
var isReact19 = Number(React.version.split(".")[0]) >= 19;
function makeInertWhen(condition) {
  var legacyValue = condition ? "" : undefined;
  return {
    inert: isReact19 ? condition : legacyValue
  };
}
function reflow(node) {
  node.scrollTop;
}
var LightboxDefaultProps = {
  open: false,
  close: function close() {},
  index: 0,
  slides: [],
  render: {},
  plugins: [],
  toolbar: {
    buttons: [ACTION_CLOSE]
  },
  labels: {},
  animation: {
    fade: 250,
    swipe: 500,
    easing: {
      fade: "ease",
      swipe: "ease-out",
      navigation: "ease-in-out"
    }
  },
  carousel: {
    finite: false,
    preload: 2,
    padding: "16px",
    spacing: "30%",
    imageFit: IMAGE_FIT_CONTAIN,
    imageProps: {}
  },
  controller: {
    ref: null,
    focus: true,
    aria: false,
    touchAction: "none",
    closeOnPullUp: false,
    closeOnPullDown: false,
    closeOnBackdropClick: false,
    preventDefaultWheelX: true,
    preventDefaultWheelY: false,
    disableSwipeNavigation: false
  },
  portal: {},
  noScroll: {
    disabled: false
  },
  on: {},
  styles: {},
  className: ""
};
function createModule(name, component) {
  return {
    name: name,
    component: component
  };
}
function createNode(module, children) {
  return {
    module: module,
    children: children
  };
}
function traverseNode(node, target, apply) {
  if (node.module.name === target) {
    return apply(node);
  }
  if (node.children) {
    return [createNode(node.module, node.children.flatMap(function (n) {
      var _a;
      return (_a = traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : [];
    }))];
  }
  return [node];
}
function traverse(nodes, target, apply) {
  return nodes.flatMap(function (node) {
    var _a;
    return (_a = traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : [];
  });
}
function withPlugins(root) {
  var plugins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var augmentations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var config = root;
  var contains = function contains(target) {
    var nodes = _toConsumableArray(config);
    while (nodes.length > 0) {
      var node = nodes.pop();
      if ((node === null || node === void 0 ? void 0 : node.module.name) === target) return true;
      if (node === null || node === void 0 ? void 0 : node.children) nodes.push.apply(nodes, _toConsumableArray(node.children));
    }
    return false;
  };
  var addParent = function addParent(target, module) {
    if (target === "") {
      config = [createNode(module, config)];
      return;
    }
    config = traverse(config, target, function (node) {
      return [createNode(module, [node])];
    });
  };
  var append = function append(target, module) {
    config = traverse(config, target, function (node) {
      return [createNode(node.module, [createNode(module, node.children)])];
    });
  };
  var addChild = function addChild(target, module, precede) {
    config = traverse(config, target, function (node) {
      var _a;
      return [createNode(node.module, [].concat(_toConsumableArray(precede ? [createNode(module)] : []), _toConsumableArray((_a = node.children) !== null && _a !== void 0 ? _a : []), _toConsumableArray(!precede ? [createNode(module)] : [])))];
    });
  };
  var addSibling = function addSibling(target, module, precede) {
    config = traverse(config, target, function (node) {
      return [].concat(_toConsumableArray(precede ? [createNode(module)] : []), [node], _toConsumableArray(!precede ? [createNode(module)] : []));
    });
  };
  var addModule = function addModule(module) {
    append(MODULE_CONTROLLER, module);
  };
  var replace = function replace(target, module) {
    config = traverse(config, target, function (node) {
      return [createNode(module, node.children)];
    });
  };
  var remove = function remove(target) {
    config = traverse(config, target, function (node) {
      return node.children;
    });
  };
  var augment = function augment(augmentation) {
    augmentations.push(augmentation);
  };
  plugins.forEach(function (plugin) {
    plugin({
      contains: contains,
      addParent: addParent,
      append: append,
      addChild: addChild,
      addSibling: addSibling,
      addModule: addModule,
      replace: replace,
      remove: remove,
      augment: augment
    });
  });
  return {
    config: config,
    augmentation: function augmentation(props) {
      return augmentations.reduce(function (acc, augmentation) {
        return augmentation(acc);
      }, props);
    }
  };
}
var DocumentContext = /*#__PURE__*/React.createContext(null);
var useDocumentContext = makeUseContext("useDocument", "DocumentContext", DocumentContext);
function DocumentContextProvider(_ref) {
  var nodeRef = _ref.nodeRef,
    children = _ref.children;
  var context = React.useMemo(function () {
    var getOwnerDocument = function getOwnerDocument(node) {
      var _a;
      return ((_a = node || nodeRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) || document;
    };
    var getOwnerWindow = function getOwnerWindow(node) {
      var _a;
      return ((_a = getOwnerDocument(node)) === null || _a === void 0 ? void 0 : _a.defaultView) || window;
    };
    return {
      getOwnerDocument: getOwnerDocument,
      getOwnerWindow: getOwnerWindow
    };
  }, [nodeRef]);
  return /*#__PURE__*/React.createElement(DocumentContext.Provider, {
    value: context
  }, children);
}
var EventsContext = /*#__PURE__*/React.createContext(null);
var useEvents = makeUseContext("useEvents", "EventsContext", EventsContext);
function EventsProvider(_ref2) {
  var children = _ref2.children;
  var _React$useState = React.useState({}),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    subscriptions = _React$useState2[0];
  React.useEffect(function () {
    return function () {
      Object.keys(subscriptions).forEach(function (topic) {
        return delete subscriptions[topic];
      });
    };
  }, [subscriptions]);
  var context = React.useMemo(function () {
    var unsubscribe = function unsubscribe(topic, callback) {
      var _a2;
      var _a;
      (_a = subscriptions[topic]) === null || _a === void 0 ? void 0 : (_a2 = _a).splice.apply(_a2, [0, subscriptions[topic].length].concat(_toConsumableArray(subscriptions[topic].filter(function (cb) {
        return cb !== callback;
      }))));
    };
    var subscribe = function subscribe(topic, callback) {
      if (!subscriptions[topic]) {
        subscriptions[topic] = [];
      }
      subscriptions[topic].push(callback);
      return function () {
        return unsubscribe(topic, callback);
      };
    };
    var publish = function publish() {
      for (var _len3 = arguments.length, _ref3 = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        _ref3[_key3] = arguments[_key3];
      }
      var topic = _ref3[0],
        event = _ref3[1];
      var _a;
      (_a = subscriptions[topic]) === null || _a === void 0 ? void 0 : _a.forEach(function (callback) {
        return callback(event);
      });
    };
    return {
      publish: publish,
      subscribe: subscribe,
      unsubscribe: unsubscribe
    };
  }, [subscriptions]);
  return /*#__PURE__*/React.createElement(EventsContext.Provider, {
    value: context
  }, children);
}
var LightboxPropsContext = /*#__PURE__*/React.createContext(null);
var useLightboxProps = makeUseContext("useLightboxProps", "LightboxPropsContext", LightboxPropsContext);
function LightboxPropsProvider(_ref4) {
  var children = _ref4.children,
    props = _objectWithoutProperties$1(_ref4, _excluded2$1);
  return /*#__PURE__*/React.createElement(LightboxPropsContext.Provider, {
    value: props
  }, children);
}
var LightboxStateContext = /*#__PURE__*/React.createContext(null);
var useLightboxState = makeUseContext("useLightboxState", "LightboxStateContext", LightboxStateContext);
var LightboxDispatchContext = /*#__PURE__*/React.createContext(null);
var useLightboxDispatch = makeUseContext("useLightboxDispatch", "LightboxDispatchContext", LightboxDispatchContext);
function reducer(state, action) {
  switch (action.type) {
    case "swipe":
      {
        var slides = state.slides;
        var increment = (action === null || action === void 0 ? void 0 : action.increment) || 0;
        var globalIndex = state.globalIndex + increment;
        var currentIndex = getSlideIndex(globalIndex, slides.length);
        var currentSlide = getSlideIfPresent(slides, currentIndex);
        var animation = increment || action.duration !== undefined ? {
          increment: increment,
          duration: action.duration,
          easing: action.easing
        } : undefined;
        return {
          slides: slides,
          currentIndex: currentIndex,
          globalIndex: globalIndex,
          currentSlide: currentSlide,
          animation: animation
        };
      }
    case "update":
      if (action.slides !== state.slides || action.index !== state.currentIndex) {
        return {
          slides: action.slides,
          currentIndex: action.index,
          globalIndex: action.index,
          currentSlide: getSlideIfPresent(action.slides, action.index)
        };
      }
      return state;
    default:
      throw new Error(UNKNOWN_ACTION_TYPE);
  }
}
function LightboxStateProvider(_ref5) {
  var slides = _ref5.slides,
    index = _ref5.index,
    children = _ref5.children;
  var _React$useReducer = React.useReducer(reducer, {
      slides: slides,
      currentIndex: index,
      globalIndex: index,
      currentSlide: getSlideIfPresent(slides, index)
    }),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    state = _React$useReducer2[0],
    dispatch = _React$useReducer2[1];
  React.useEffect(function () {
    dispatch({
      type: "update",
      slides: slides,
      index: index
    });
  }, [slides, index]);
  var context = React.useMemo(function () {
    return _objectSpread2(_objectSpread2({}, state), {}, {
      state: state,
      dispatch: dispatch
    });
  }, [state, dispatch]);
  return /*#__PURE__*/React.createElement(LightboxDispatchContext.Provider, {
    value: dispatch
  }, /*#__PURE__*/React.createElement(LightboxStateContext.Provider, {
    value: context
  }, children));
}
var TimeoutsContext = /*#__PURE__*/React.createContext(null);
var useTimeouts = makeUseContext("useTimeouts", "TimeoutsContext", TimeoutsContext);
function TimeoutsProvider(_ref6) {
  var children = _ref6.children;
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 1),
    timeouts = _React$useState4[0];
  React.useEffect(function () {
    return function () {
      timeouts.forEach(function (tid) {
        return window.clearTimeout(tid);
      });
      timeouts.splice(0, timeouts.length);
    };
  }, [timeouts]);
  var context = React.useMemo(function () {
    var removeTimeout = function removeTimeout(id) {
      timeouts.splice.apply(timeouts, [0, timeouts.length].concat(_toConsumableArray(timeouts.filter(function (tid) {
        return tid !== id;
      }))));
    };
    var setTimeout = function setTimeout(fn, delay) {
      var id = window.setTimeout(function () {
        removeTimeout(id);
        fn();
      }, delay);
      timeouts.push(id);
      return id;
    };
    var clearTimeout = function clearTimeout(id) {
      if (id !== undefined) {
        removeTimeout(id);
        window.clearTimeout(id);
      }
    };
    return {
      setTimeout: setTimeout,
      clearTimeout: clearTimeout
    };
  }, [timeouts]);
  return /*#__PURE__*/React.createElement(TimeoutsContext.Provider, {
    value: context
  }, children);
}
var IconButton = /*#__PURE__*/React.forwardRef(function IconButton(_ref7, ref) {
  var label$1 = _ref7.label,
    className = _ref7.className,
    Icon = _ref7.icon,
    renderIcon = _ref7.renderIcon,
    onClick = _ref7.onClick,
    style = _ref7.style,
    rest = _objectWithoutProperties$1(_ref7, _excluded3$1);
  var _useLightboxProps = useLightboxProps(),
    styles = _useLightboxProps.styles,
    labels = _useLightboxProps.labels;
  var buttonLabel = label(labels, label$1);
  return /*#__PURE__*/React.createElement("button", _objectSpread2({
    ref: ref,
    type: "button",
    title: buttonLabel,
    "aria-label": buttonLabel,
    className: clsx(cssClass(ELEMENT_BUTTON), className),
    onClick: onClick,
    style: _objectSpread2(_objectSpread2({}, style), styles.button)
  }, rest), renderIcon ? renderIcon() : /*#__PURE__*/React.createElement(Icon, {
    className: cssClass(ELEMENT_ICON),
    style: styles.icon
  }));
});
function svgIcon(name, children) {
  var icon = function icon(props) {
    return /*#__PURE__*/React.createElement("svg", _objectSpread2({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24",
      "aria-hidden": "true",
      focusable: "false"
    }, props), children);
  };
  icon.displayName = name;
  return icon;
}
function createIcon(name, glyph) {
  return svgIcon(name, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), glyph));
}
var CloseIcon = createIcon("Close", /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));
var PreviousIcon = createIcon("Previous", /*#__PURE__*/React.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}));
var NextIcon = createIcon("Next", /*#__PURE__*/React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}));
var LoadingIcon = createIcon("Loading", /*#__PURE__*/React.createElement(React.Fragment, null, Array.from({
  length: 8
}).map(function (_, index, array) {
  return /*#__PURE__*/React.createElement("line", {
    key: index,
    x1: "12",
    y1: "6.5",
    x2: "12",
    y2: "1.8",
    strokeLinecap: "round",
    strokeWidth: "2.6",
    stroke: "currentColor",
    strokeOpacity: 1 / array.length * (index + 1),
    transform: "rotate(".concat(360 / array.length * index, ", 12, 12)")
  });
})));
var ErrorIcon = createIcon("Error", /*#__PURE__*/React.createElement("path", {
  d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z"
}));
var useLayoutEffect = hasWindow() ? React.useLayoutEffect : React.useEffect;
function useMotionPreference() {
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    reduceMotion = _React$useState6[0],
    setReduceMotion = _React$useState6[1];
  React.useEffect(function () {
    var _a, _b;
    var mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
    setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);
    var listener = function listener(event) {
      return setReduceMotion(event.matches);
    };
    (_b = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) === null || _b === void 0 ? void 0 : _b.call(mediaQuery, "change", listener);
    return function () {
      var _a;
      return (_a = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(mediaQuery, "change", listener);
    };
  }, []);
  return reduceMotion;
}
function currentTransformation(node) {
  var x = 0;
  var y = 0;
  var z = 0;
  var matrix = window.getComputedStyle(node).transform;
  var matcher = matrix.match(/matrix.*\((.+)\)/);
  if (matcher) {
    var values = matcher[1].split(",").map(parseInt$1);
    if (values.length === 6) {
      x = values[4];
      y = values[5];
    } else if (values.length === 16) {
      x = values[12];
      y = values[13];
      z = values[14];
    }
  }
  return {
    x: x,
    y: y,
    z: z
  };
}
function useAnimation(nodeRef, computeAnimation) {
  var snapshot = React.useRef(undefined);
  var animation = React.useRef(undefined);
  var reduceMotion = useMotionPreference();
  useLayoutEffect(function () {
    var _a, _b, _c;
    if (nodeRef.current && snapshot.current !== undefined && !reduceMotion) {
      var _ref8 = computeAnimation(snapshot.current, nodeRef.current.getBoundingClientRect(), currentTransformation(nodeRef.current)) || {},
        keyframes = _ref8.keyframes,
        duration = _ref8.duration,
        easing = _ref8.easing,
        onfinish = _ref8.onfinish;
      if (keyframes && duration) {
        (_a = animation.current) === null || _a === void 0 ? void 0 : _a.cancel();
        animation.current = undefined;
        try {
          animation.current = (_c = (_b = nodeRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, keyframes, {
            duration: duration,
            easing: easing
          });
        } catch (err) {
          console.error(err);
        }
        if (animation.current) {
          animation.current.onfinish = function () {
            animation.current = undefined;
            onfinish === null || onfinish === void 0 ? void 0 : onfinish();
          };
        }
      }
    }
    snapshot.current = undefined;
  });
  return {
    prepareAnimation: function prepareAnimation(currentSnapshot) {
      snapshot.current = currentSnapshot;
    },
    isAnimationPlaying: function isAnimationPlaying() {
      var _a;
      return ((_a = animation.current) === null || _a === void 0 ? void 0 : _a.playState) === "running";
    }
  };
}
function useContainerRect() {
  var containerRef = React.useRef(null);
  var observerRef = React.useRef(undefined);
  var _React$useState7 = React.useState(),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    containerRect = _React$useState8[0],
    setContainerRect = _React$useState8[1];
  var setContainerRef = React.useCallback(function (node) {
    containerRef.current = node;
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = undefined;
    }
    var updateContainerRect = function updateContainerRect() {
      if (node) {
        var styles = window.getComputedStyle(node);
        var parse = function parse(value) {
          return parseFloat(value) || 0;
        };
        setContainerRect({
          width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
          height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom))
        });
      } else {
        setContainerRect(undefined);
      }
    };
    updateContainerRect();
    if (node && typeof ResizeObserver !== "undefined") {
      observerRef.current = new ResizeObserver(updateContainerRect);
      observerRef.current.observe(node);
    }
  }, []);
  return {
    setContainerRef: setContainerRef,
    containerRef: containerRef,
    containerRect: containerRect
  };
}
function useDelay() {
  var timeoutId = React.useRef(undefined);
  var _useTimeouts = useTimeouts(),
    setTimeout = _useTimeouts.setTimeout,
    clearTimeout = _useTimeouts.clearTimeout;
  return React.useCallback(function (callback, delay) {
    clearTimeout(timeoutId.current);
    timeoutId.current = setTimeout(callback, delay > 0 ? delay : 0);
  }, [setTimeout, clearTimeout]);
}
function useEventCallback(fn) {
  var ref = React.useRef(fn);
  useLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    var _a3;
    var _a;
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return (_a = ref.current) === null || _a === void 0 ? void 0 : (_a3 = _a).call.apply(_a3, [ref].concat(args));
  }, []);
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
function useForkRef(refA, refB) {
  return React.useMemo(function () {
    return refA == null && refB == null ? null : function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}
function useLoseFocus(focus) {
  var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var focused = React.useRef(false);
  useLayoutEffect(function () {
    if (disabled && focused.current) {
      focused.current = false;
      focus();
    }
  }, [disabled, focus]);
  var onFocus = React.useCallback(function () {
    focused.current = true;
  }, []);
  var onBlur = React.useCallback(function () {
    focused.current = false;
  }, []);
  return {
    onFocus: onFocus,
    onBlur: onBlur
  };
}
function useRTL() {
  var _React$useState9 = React.useState(false),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    isRTL = _React$useState0[0],
    setIsRTL = _React$useState0[1];
  useLayoutEffect(function () {
    setIsRTL(window.getComputedStyle(window.document.documentElement).direction === "rtl");
  }, []);
  return isRTL;
}
function useSensors() {
  var _React$useState1 = React.useState({}),
    _React$useState10 = _slicedToArray(_React$useState1, 1),
    subscribers = _React$useState10[0];
  var notifySubscribers = React.useCallback(function (type, event) {
    var _a;
    (_a = subscribers[type]) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) {
      if (!event.isPropagationStopped()) listener(event);
    });
  }, [subscribers]);
  var registerSensors = React.useMemo(function () {
    return {
      onPointerDown: function onPointerDown(event) {
        return notifySubscribers(EVENT_ON_POINTER_DOWN, event);
      },
      onPointerMove: function onPointerMove(event) {
        return notifySubscribers(EVENT_ON_POINTER_MOVE, event);
      },
      onPointerUp: function onPointerUp(event) {
        return notifySubscribers(EVENT_ON_POINTER_UP, event);
      },
      onPointerLeave: function onPointerLeave(event) {
        return notifySubscribers(EVENT_ON_POINTER_LEAVE, event);
      },
      onPointerCancel: function onPointerCancel(event) {
        return notifySubscribers(EVENT_ON_POINTER_CANCEL, event);
      },
      onKeyDown: function onKeyDown(event) {
        return notifySubscribers(EVENT_ON_KEY_DOWN, event);
      },
      onKeyUp: function onKeyUp(event) {
        return notifySubscribers(EVENT_ON_KEY_UP, event);
      },
      onWheel: function onWheel(event) {
        return notifySubscribers(EVENT_ON_WHEEL, event);
      }
    };
  }, [notifySubscribers]);
  var subscribeSensors = React.useCallback(function (type, callback) {
    if (!subscribers[type]) {
      subscribers[type] = [];
    }
    subscribers[type].unshift(callback);
    return function () {
      var listeners = subscribers[type];
      if (listeners) {
        listeners.splice.apply(listeners, [0, listeners.length].concat(_toConsumableArray(listeners.filter(function (el) {
          return el !== callback;
        }))));
      }
    };
  }, [subscribers]);
  return {
    registerSensors: registerSensors,
    subscribeSensors: subscribeSensors
  };
}
function useThrottle(callback, delay) {
  var lastCallbackTime = React.useRef(0);
  var delayCallback = useDelay();
  var executeCallback = useEventCallback(function () {
    lastCallbackTime.current = Date.now();
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    callback(args);
  });
  return React.useCallback(function () {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }
    delayCallback(function () {
      executeCallback(args);
    }, delay - (Date.now() - lastCallbackTime.current));
  }, [delay, executeCallback, delayCallback]);
}
var slidePrefix = makeComposePrefix("slide");
var slideImagePrefix = makeComposePrefix("slide_image");
function ImageSlide(_ref9) {
  var image = _ref9.slide,
    offset = _ref9.offset,
    render = _ref9.render,
    rect = _ref9.rect,
    imageFit = _ref9.imageFit,
    imageProps = _ref9.imageProps,
    onClick = _ref9.onClick,
    onLoad = _ref9.onLoad,
    onError = _ref9.onError,
    style = _ref9.style;
  var _a, _b, _c, _d, _e, _f, _g;
  var _React$useState11 = React.useState(SLIDE_STATUS_LOADING),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    status = _React$useState12[0],
    setStatus = _React$useState12[1];
  var _useEvents = useEvents(),
    publish = _useEvents.publish;
  var _useTimeouts2 = useTimeouts(),
    setTimeout = _useTimeouts2.setTimeout;
  var imageRef = React.useRef(null);
  React.useEffect(function () {
    if (offset === 0) {
      publish(activeSlideStatus(status));
    }
  }, [offset, status, publish]);
  var handleLoading = useEventCallback(function (img) {
    ("decode" in img ? img.decode() : Promise.resolve())["catch"](function () {}).then(function () {
      if (!img.parentNode) {
        return;
      }
      setStatus(SLIDE_STATUS_COMPLETE);
      setTimeout(function () {
        onLoad === null || onLoad === void 0 ? void 0 : onLoad(img);
      }, 0);
    });
  });
  var setImageRef = React.useCallback(function (img) {
    imageRef.current = img;
    if (img === null || img === void 0 ? void 0 : img.complete) {
      handleLoading(img);
    }
  }, [handleLoading]);
  var handleOnLoad = React.useCallback(function (event) {
    handleLoading(event.currentTarget);
  }, [handleLoading]);
  var handleOnError = useEventCallback(function () {
    setStatus(SLIDE_STATUS_ERROR);
    onError === null || onError === void 0 ? void 0 : onError();
  });
  var cover = isImageFitCover(image, imageFit);
  var nonInfinite = function nonInfinite(value, fallback) {
    return Number.isFinite(value) ? value : fallback;
  };
  var maxWidth = nonInfinite(Math.max.apply(Math, _toConsumableArray(((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map(function (x) {
    return x.width;
  })) !== null && _b !== void 0 ? _b : []).concat(image.width ? [image.width] : []).filter(Boolean))), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
  var maxHeight = nonInfinite(Math.max.apply(Math, _toConsumableArray(((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map(function (x) {
    return x.height;
  })) !== null && _e !== void 0 ? _e : []).concat(image.height ? [image.height] : []).filter(Boolean))), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
  var defaultStyle = maxWidth && maxHeight ? {
    maxWidth: "min(".concat(maxWidth, "px, 100%)"),
    maxHeight: "min(".concat(maxHeight, "px, 100%)")
  } : {
    maxWidth: "100%",
    maxHeight: "100%"
  };
  var srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.sort(function (a, b) {
    return a.width - b.width;
  }).map(function (item) {
    return "".concat(item.src, " ").concat(item.width, "w");
  }).join(", ");
  var estimateActualWidth = function estimateActualWidth() {
    return rect && !cover && image.width && image.height ? rect.height / image.height * image.width : Number.MAX_VALUE;
  };
  var sizes = srcSet && rect && hasWindow() ? "".concat(Math.round(Math.min(estimateActualWidth(), rect.width)), "px") : undefined;
  var _ref0 = imageProps || {},
    imagePropsStyle = _ref0.style,
    imagePropsClassName = _ref0.className,
    restImageProps = _objectWithoutProperties$1(_ref0, _excluded4);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", _objectSpread2(_objectSpread2({
    ref: setImageRef,
    onLoad: handleOnLoad,
    onError: handleOnError,
    onClick: onClick,
    draggable: false,
    className: clsx(cssClass(slideImagePrefix()), cover && cssClass(slideImagePrefix("cover")), status !== SLIDE_STATUS_COMPLETE && cssClass(slideImagePrefix("loading")), imagePropsClassName),
    style: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultStyle), style), imagePropsStyle)
  }, restImageProps), {}, {
    alt: image.alt,
    sizes: sizes,
    srcSet: srcSet,
    src: image.src
  })), status !== SLIDE_STATUS_COMPLETE && (/*#__PURE__*/React.createElement("div", {
    className: cssClass(slidePrefix(SLIDE_STATUS_PLACEHOLDER))
  }, status === SLIDE_STATUS_LOADING && ((render === null || render === void 0 ? void 0 : render.iconLoading) ? render.iconLoading() : (/*#__PURE__*/React.createElement(LoadingIcon, {
    className: clsx(cssClass(ELEMENT_ICON), cssClass(slidePrefix(SLIDE_STATUS_LOADING)))
  }))), status === SLIDE_STATUS_ERROR && ((render === null || render === void 0 ? void 0 : render.iconError) ? render.iconError() : (/*#__PURE__*/React.createElement(ErrorIcon, {
    className: clsx(cssClass(ELEMENT_ICON), cssClass(slidePrefix(SLIDE_STATUS_ERROR)))
  }))))));
}
var LightboxRoot = /*#__PURE__*/React.forwardRef(function LightboxRoot(_ref1, ref) {
  var className = _ref1.className,
    children = _ref1.children,
    rest = _objectWithoutProperties$1(_ref1, _excluded5);
  var nodeRef = React.useRef(null);
  return /*#__PURE__*/React.createElement(DocumentContextProvider, {
    nodeRef: nodeRef
  }, /*#__PURE__*/React.createElement("div", _objectSpread2({
    ref: useForkRef(ref, nodeRef),
    className: clsx(cssClass("root"), className)
  }, rest), children));
});
var SwipeState;
(function (SwipeState) {
  SwipeState[SwipeState["NONE"] = 0] = "NONE";
  SwipeState[SwipeState["SWIPE"] = 1] = "SWIPE";
  SwipeState[SwipeState["PULL"] = 2] = "PULL";
  SwipeState[SwipeState["ANIMATION"] = 3] = "ANIMATION";
})(SwipeState || (SwipeState = {}));
function usePointerEvents(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled) {
  React.useEffect(function () {
    return !disabled ? cleanup(subscribeSensors(EVENT_ON_POINTER_DOWN, onPointerDown), subscribeSensors(EVENT_ON_POINTER_MOVE, onPointerMove), subscribeSensors(EVENT_ON_POINTER_UP, onPointerUp), subscribeSensors(EVENT_ON_POINTER_LEAVE, onPointerUp), subscribeSensors(EVENT_ON_POINTER_CANCEL, onPointerUp)) : function () {};
  }, [subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled]);
}
var Gesture;
(function (Gesture) {
  Gesture[Gesture["NONE"] = 0] = "NONE";
  Gesture[Gesture["SWIPE"] = 1] = "SWIPE";
  Gesture[Gesture["PULL"] = 2] = "PULL";
})(Gesture || (Gesture = {}));
var SWIPE_THRESHOLD = 30;
function usePointerSwipe(_ref10, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel, pullUpEnabled, pullDownEnabled, onPullStart, onPullProgress, onPullFinish, onPullCancel) {
  var disableSwipeNavigation = _ref10.disableSwipeNavigation;
  var offset = React.useRef(0);
  var pointers = React.useRef([]);
  var activePointer = React.useRef(undefined);
  var startTime = React.useRef(0);
  var gesture = React.useRef(Gesture.NONE);
  var clearPointer = React.useCallback(function (event) {
    if (activePointer.current === event.pointerId) {
      activePointer.current = undefined;
      gesture.current = Gesture.NONE;
    }
    var currentPointers = pointers.current;
    currentPointers.splice.apply(currentPointers, [0, currentPointers.length].concat(_toConsumableArray(currentPointers.filter(function (p) {
      return p.pointerId !== event.pointerId;
    }))));
  }, []);
  var addPointer = React.useCallback(function (event) {
    clearPointer(event);
    event.persist();
    pointers.current.push(event);
  }, [clearPointer]);
  var onPointerDown = useEventCallback(function (event) {
    addPointer(event);
  });
  var exceedsPullThreshold = function exceedsPullThreshold(value, threshold) {
    return pullDownEnabled && value > threshold || pullUpEnabled && value < -threshold;
  };
  var onPointerUp = useEventCallback(function (event) {
    if (pointers.current.find(function (x) {
      return x.pointerId === event.pointerId;
    }) && activePointer.current === event.pointerId) {
      var duration = Date.now() - startTime.current;
      var currentOffset = offset.current;
      if (gesture.current === Gesture.SWIPE) {
        if (Math.abs(currentOffset) > 0.3 * containerWidth || Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration) {
          onSwipeFinish(currentOffset, duration);
        } else {
          onSwipeCancel(currentOffset);
        }
      } else if (gesture.current === Gesture.PULL) {
        if (exceedsPullThreshold(currentOffset, 2 * SWIPE_THRESHOLD)) {
          onPullFinish(currentOffset, duration);
        } else {
          onPullCancel(currentOffset);
        }
      }
      offset.current = 0;
      gesture.current = Gesture.NONE;
    }
    clearPointer(event);
  });
  var onPointerMove = useEventCallback(function (event) {
    var pointer = pointers.current.find(function (p) {
      return p.pointerId === event.pointerId;
    });
    if (pointer) {
      var isCurrentPointer = activePointer.current === event.pointerId;
      if (event.buttons === 0) {
        if (isCurrentPointer && offset.current !== 0) {
          onPointerUp(event);
        } else {
          clearPointer(pointer);
        }
        return;
      }
      var deltaX = event.clientX - pointer.clientX;
      var deltaY = event.clientY - pointer.clientY;
      if (activePointer.current === undefined) {
        var startGesture = function startGesture(newGesture) {
          addPointer(event);
          activePointer.current = event.pointerId;
          startTime.current = Date.now();
          gesture.current = newGesture;
        };
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > SWIPE_THRESHOLD && isSwipeValid(deltaX)) {
          if (!disableSwipeNavigation) {
            startGesture(Gesture.SWIPE);
            onSwipeStart();
          }
        } else if (Math.abs(deltaY) > Math.abs(deltaX) && exceedsPullThreshold(deltaY, SWIPE_THRESHOLD)) {
          startGesture(Gesture.PULL);
          onPullStart();
        }
      } else if (isCurrentPointer) {
        if (gesture.current === Gesture.SWIPE) {
          offset.current = deltaX;
          onSwipeProgress(deltaX);
        } else if (gesture.current === Gesture.PULL) {
          offset.current = deltaY;
          onPullProgress(deltaY);
        }
      }
    }
  });
  usePointerEvents(subscribeSensors, onPointerDown, onPointerMove, onPointerUp);
}
function usePreventWheelDefaults(_ref11) {
  var preventDefaultWheelX = _ref11.preventDefaultWheelX,
    preventDefaultWheelY = _ref11.preventDefaultWheelY;
  var ref = React.useRef(null);
  var listener = useEventCallback(function (event) {
    var horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
    if (horizontal && preventDefaultWheelX || !horizontal && preventDefaultWheelY || event.ctrlKey) {
      event.preventDefault();
    }
  });
  return React.useCallback(function (node) {
    var _a;
    if (node) {
      node.addEventListener("wheel", listener, {
        passive: false
      });
    } else {
      (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("wheel", listener);
    }
    ref.current = node;
  }, [listener]);
}
function useWheelSwipe(swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
  var offset = React.useRef(0);
  var intent = React.useRef(0);
  var intentCleanup = React.useRef(undefined);
  var resetCleanup = React.useRef(undefined);
  var wheelInertia = React.useRef(0);
  var wheelInertiaCleanup = React.useRef(undefined);
  var startTime = React.useRef(0);
  var _useTimeouts3 = useTimeouts(),
    setTimeout = _useTimeouts3.setTimeout,
    clearTimeout = _useTimeouts3.clearTimeout;
  var cancelSwipeIntentCleanup = React.useCallback(function () {
    if (intentCleanup.current) {
      clearTimeout(intentCleanup.current);
      intentCleanup.current = undefined;
    }
  }, [clearTimeout]);
  var cancelSwipeResetCleanup = React.useCallback(function () {
    if (resetCleanup.current) {
      clearTimeout(resetCleanup.current);
      resetCleanup.current = undefined;
    }
  }, [clearTimeout]);
  var handleCleanup = useEventCallback(function () {
    if (swipeState !== SwipeState.SWIPE) {
      offset.current = 0;
      startTime.current = 0;
      cancelSwipeIntentCleanup();
      cancelSwipeResetCleanup();
    }
  });
  React.useEffect(handleCleanup, [swipeState, handleCleanup]);
  var handleCancelSwipe = useEventCallback(function (currentSwipeOffset) {
    resetCleanup.current = undefined;
    if (offset.current === currentSwipeOffset) {
      onSwipeCancel(offset.current);
    }
  });
  var onWheel = useEventCallback(function (event) {
    if (event.ctrlKey) {
      return;
    }
    if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
      return;
    }
    var setWheelInertia = function setWheelInertia(inertia) {
      wheelInertia.current = inertia;
      clearTimeout(wheelInertiaCleanup.current);
      wheelInertiaCleanup.current = inertia > 0 ? setTimeout(function () {
        wheelInertia.current = 0;
        wheelInertiaCleanup.current = undefined;
      }, 300) : undefined;
    };
    if (swipeState === SwipeState.NONE) {
      if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelInertia.current)) {
        setWheelInertia(event.deltaX);
        return;
      }
      if (!isSwipeValid(-event.deltaX)) {
        return;
      }
      intent.current += event.deltaX;
      cancelSwipeIntentCleanup();
      if (Math.abs(intent.current) > 30) {
        intent.current = 0;
        setWheelInertia(0);
        startTime.current = Date.now();
        onSwipeStart();
      } else {
        var currentSwipeIntent = intent.current;
        intentCleanup.current = setTimeout(function () {
          intentCleanup.current = undefined;
          if (currentSwipeIntent === intent.current) {
            intent.current = 0;
          }
        }, swipeAnimationDuration);
      }
    } else if (swipeState === SwipeState.SWIPE) {
      var newSwipeOffset = offset.current - event.deltaX;
      newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
      offset.current = newSwipeOffset;
      onSwipeProgress(newSwipeOffset);
      cancelSwipeResetCleanup();
      if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
        setWheelInertia(event.deltaX);
        onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
        return;
      }
      resetCleanup.current = setTimeout(function () {
        return handleCancelSwipe(newSwipeOffset);
      }, 2 * swipeAnimationDuration);
    } else {
      setWheelInertia(event.deltaX);
    }
  });
  React.useEffect(function () {
    return subscribeSensors(EVENT_ON_WHEEL, onWheel);
  }, [subscribeSensors, onWheel]);
}
var cssContainerPrefix = makeComposePrefix("container");
var ControllerContext = /*#__PURE__*/React.createContext(null);
var useController = makeUseContext("useController", "ControllerContext", ControllerContext);
function Controller(_ref12) {
  var children = _ref12.children,
    props = _objectWithoutProperties$1(_ref12, _excluded6);
  var _a;
  var carousel = props.carousel,
    animation = props.animation,
    controller = props.controller,
    on = props.on,
    styles = props.styles,
    render = props.render;
  var closeOnPullUp = controller.closeOnPullUp,
    closeOnPullDown = controller.closeOnPullDown,
    preventDefaultWheelX = controller.preventDefaultWheelX,
    preventDefaultWheelY = controller.preventDefaultWheelY;
  var _React$useState13 = React.useState(),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    toolbarWidth = _React$useState14[0],
    setToolbarWidth = _React$useState14[1];
  var state = useLightboxState();
  var dispatch = useLightboxDispatch();
  var _React$useState15 = React.useState(SwipeState.NONE),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    swipeState = _React$useState16[0],
    setSwipeState = _React$useState16[1];
  var swipeOffset = React.useRef(0);
  var pullOffset = React.useRef(0);
  var pullOpacity = React.useRef(1);
  var _useSensors = useSensors(),
    registerSensors = _useSensors.registerSensors,
    subscribeSensors = _useSensors.subscribeSensors;
  var _useEvents2 = useEvents(),
    subscribe = _useEvents2.subscribe,
    publish = _useEvents2.publish;
  var cleanupAnimationIncrement = useDelay();
  var cleanupSwipeOffset = useDelay();
  var cleanupPullOffset = useDelay();
  var _useContainerRect = useContainerRect(),
    containerRef = _useContainerRect.containerRef,
    setContainerRef = _useContainerRect.setContainerRef,
    containerRect = _useContainerRect.containerRect;
  var handleContainerRef = useForkRef(usePreventWheelDefaults({
    preventDefaultWheelX: preventDefaultWheelX,
    preventDefaultWheelY: preventDefaultWheelY
  }), setContainerRef);
  var carouselRef = React.useRef(null);
  var setCarouselRef = useForkRef(carouselRef, undefined);
  var _useDocumentContext = useDocumentContext(),
    getOwnerDocument = _useDocumentContext.getOwnerDocument;
  var isRTL = useRTL();
  var rtl = function rtl(value) {
    return (isRTL ? -1 : 1) * (typeof value === "number" ? value : 1);
  };
  var focus = useEventCallback(function () {
    var _a;
    return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  });
  var getLightboxProps = useEventCallback(function () {
    return props;
  });
  var getLightboxState = useEventCallback(function () {
    return state;
  });
  var prev = React.useCallback(function (params) {
    return publish(ACTION_PREV, params);
  }, [publish]);
  var next = React.useCallback(function (params) {
    return publish(ACTION_NEXT, params);
  }, [publish]);
  var close = React.useCallback(function () {
    return publish(ACTION_CLOSE);
  }, [publish]);
  var isSwipeValid = function isSwipeValid(offset) {
    return !(carousel.finite && (rtl(offset) > 0 && state.currentIndex === 0 || rtl(offset) < 0 && state.currentIndex === state.slides.length - 1));
  };
  var setSwipeOffset = function setSwipeOffset(offset) {
    var _a;
    swipeOffset.current = offset;
    (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty(cssVar("swipe_offset"), "".concat(Math.round(offset), "px"));
  };
  var setPullOffset = function setPullOffset(offset) {
    var _a, _b;
    pullOffset.current = offset;
    pullOpacity.current = function () {
      var threshold = 60;
      var minOpacity = 0.5;
      var offsetValue = function () {
        if (closeOnPullDown && offset > 0) return offset;
        if (closeOnPullUp && offset < 0) return -offset;
        return 0;
      }();
      return Math.min(Math.max(round(1 - offsetValue / threshold * (1 - minOpacity), 2), minOpacity), 1);
    }();
    (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty(cssVar("pull_offset"), "".concat(Math.round(offset), "px"));
    (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.style.setProperty(cssVar("pull_opacity"), "".concat(pullOpacity.current));
  };
  var _useAnimation = useAnimation(carouselRef, function (snapshot, rect, translate) {
      if (carouselRef.current && containerRect) {
        return {
          keyframes: [{
            transform: "translate(0, ".concat(snapshot.rect.y - rect.y + translate.y, "px)"),
            opacity: snapshot.opacity
          }, {
            transform: "translate(0, 0)",
            opacity: 1
          }],
          duration: snapshot.duration,
          easing: animation.easing.fade
        };
      }
      return undefined;
    }),
    preparePullAnimation = _useAnimation.prepareAnimation;
  var pull = function pull(offset, cancel) {
    if (closeOnPullUp || closeOnPullDown) {
      setPullOffset(offset);
      var duration = 0;
      if (carouselRef.current) {
        duration = animation.fade * (cancel ? 2 : 1);
        preparePullAnimation({
          rect: carouselRef.current.getBoundingClientRect(),
          opacity: pullOpacity.current,
          duration: duration
        });
      }
      cleanupPullOffset(function () {
        setPullOffset(0);
        setSwipeState(SwipeState.NONE);
      }, duration);
      setSwipeState(SwipeState.ANIMATION);
      if (!cancel) {
        close();
      }
    }
  };
  var _useAnimation2 = useAnimation(carouselRef, function (snapshot, rect, translate) {
      var _a;
      if (carouselRef.current && containerRect && ((_a = state.animation) === null || _a === void 0 ? void 0 : _a.duration)) {
        var parsedSpacing = parseLengthPercentage(carousel.spacing);
        var spacingValue = (parsedSpacing.percent ? parsedSpacing.percent * containerRect.width / 100 : parsedSpacing.pixel) || 0;
        return {
          keyframes: [{
            transform: "translate(".concat(rtl(state.globalIndex - snapshot.index) * (containerRect.width + spacingValue) + snapshot.rect.x - rect.x + translate.x, "px, 0)")
          }, {
            transform: "translate(0, 0)"
          }],
          duration: state.animation.duration,
          easing: state.animation.easing
        };
      }
      return undefined;
    }),
    prepareAnimation = _useAnimation2.prepareAnimation,
    isAnimationPlaying = _useAnimation2.isAnimationPlaying;
  var swipe = useEventCallback(function (action) {
    var _a, _b;
    var currentSwipeOffset = action.offset || 0;
    var swipeDuration = !currentSwipeOffset ? (_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe : animation.swipe;
    var swipeEasing = !currentSwipeOffset && !isAnimationPlaying() ? animation.easing.navigation : animation.easing.swipe;
    var direction = action.direction;
    var count = (_b = action.count) !== null && _b !== void 0 ? _b : 1;
    var newSwipeState = SwipeState.ANIMATION;
    var newSwipeAnimationDuration = swipeDuration * count;
    if (!direction) {
      var containerWidth = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width;
      var elapsedTime = action.duration || 0;
      var expectedTime = containerWidth ? swipeDuration / containerWidth * Math.abs(currentSwipeOffset) : swipeDuration;
      if (count !== 0) {
        if (elapsedTime < expectedTime) {
          newSwipeAnimationDuration = newSwipeAnimationDuration / expectedTime * Math.max(elapsedTime, expectedTime / 5);
        } else if (containerWidth) {
          newSwipeAnimationDuration = swipeDuration / containerWidth * (containerWidth - Math.abs(currentSwipeOffset));
        }
        direction = rtl(currentSwipeOffset) > 0 ? ACTION_PREV : ACTION_NEXT;
      } else {
        newSwipeAnimationDuration = swipeDuration / 2;
      }
    }
    var increment = 0;
    if (direction === ACTION_PREV) {
      if (isSwipeValid(rtl(1))) {
        increment = -count;
      } else {
        newSwipeState = SwipeState.NONE;
        newSwipeAnimationDuration = swipeDuration;
      }
    } else if (direction === ACTION_NEXT) {
      if (isSwipeValid(rtl(-1))) {
        increment = count;
      } else {
        newSwipeState = SwipeState.NONE;
        newSwipeAnimationDuration = swipeDuration;
      }
    }
    newSwipeAnimationDuration = Math.round(newSwipeAnimationDuration);
    cleanupSwipeOffset(function () {
      setSwipeOffset(0);
      setSwipeState(SwipeState.NONE);
    }, newSwipeAnimationDuration);
    if (carouselRef.current) {
      prepareAnimation({
        rect: carouselRef.current.getBoundingClientRect(),
        index: state.globalIndex
      });
    }
    setSwipeState(newSwipeState);
    publish(ACTION_SWIPE, {
      type: "swipe",
      increment: increment,
      duration: newSwipeAnimationDuration,
      easing: swipeEasing
    });
  });
  React.useEffect(function () {
    var _a, _b;
    if (((_a = state.animation) === null || _a === void 0 ? void 0 : _a.increment) && ((_b = state.animation) === null || _b === void 0 ? void 0 : _b.duration)) {
      cleanupAnimationIncrement(function () {
        return dispatch({
          type: "swipe",
          increment: 0
        });
      }, state.animation.duration);
    }
  }, [state.animation, dispatch, cleanupAnimationIncrement]);
  var swipeParams = [subscribeSensors, isSwipeValid, (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) || 0, animation.swipe, function () {
    return setSwipeState(SwipeState.SWIPE);
  }, function (offset) {
    return setSwipeOffset(offset);
  }, function (offset, duration) {
    return swipe({
      offset: offset,
      duration: duration,
      count: 1
    });
  }, function (offset) {
    return swipe({
      offset: offset,
      count: 0
    });
  }];
  var pullParams = [function () {
    if (closeOnPullDown) {
      setSwipeState(SwipeState.PULL);
    }
  }, function (offset) {
    return setPullOffset(offset);
  }, function (offset) {
    return pull(offset);
  }, function (offset) {
    return pull(offset, true);
  }];
  usePointerSwipe.apply(void 0, [controller].concat(swipeParams, [closeOnPullUp, closeOnPullDown], pullParams));
  useWheelSwipe.apply(void 0, [swipeState].concat(swipeParams));
  var focusOnMount = useEventCallback(function () {
    if (controller.focus && getOwnerDocument().querySelector(".".concat(cssClass(MODULE_PORTAL), " .").concat(cssClass(cssContainerPrefix())))) {
      focus();
    }
  });
  React.useEffect(focusOnMount, [focusOnMount]);
  var onViewCallback = useEventCallback(function () {
    var _a;
    (_a = on.view) === null || _a === void 0 ? void 0 : _a.call(on, {
      index: state.currentIndex
    });
  });
  React.useEffect(onViewCallback, [state.globalIndex, onViewCallback]);
  React.useEffect(function () {
    return cleanup(subscribe(ACTION_PREV, function (action) {
      return swipe(_objectSpread2({
        direction: ACTION_PREV
      }, action));
    }), subscribe(ACTION_NEXT, function (action) {
      return swipe(_objectSpread2({
        direction: ACTION_NEXT
      }, action));
    }), subscribe(ACTION_SWIPE, function (action) {
      return dispatch(action);
    }));
  }, [subscribe, swipe, dispatch]);
  var context = React.useMemo(function () {
    return {
      prev: prev,
      next: next,
      close: close,
      focus: focus,
      slideRect: containerRect ? computeSlideRect(containerRect, carousel.padding) : {
        width: 0,
        height: 0
      },
      containerRect: containerRect || {
        width: 0,
        height: 0
      },
      subscribeSensors: subscribeSensors,
      containerRef: containerRef,
      setCarouselRef: setCarouselRef,
      toolbarWidth: toolbarWidth,
      setToolbarWidth: setToolbarWidth
    };
  }, [prev, next, close, focus, subscribeSensors, containerRect, containerRef, setCarouselRef, toolbarWidth, setToolbarWidth, carousel.padding]);
  React.useImperativeHandle(controller.ref, function () {
    return {
      prev: prev,
      next: next,
      close: close,
      focus: focus,
      getLightboxProps: getLightboxProps,
      getLightboxState: getLightboxState
    };
  }, [prev, next, close, focus, getLightboxProps, getLightboxState]);
  return /*#__PURE__*/React.createElement("div", _objectSpread2(_objectSpread2({
    ref: handleContainerRef,
    className: clsx(cssClass(cssContainerPrefix()), cssClass(CLASS_FLEX_CENTER)),
    style: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, swipeState === SwipeState.SWIPE ? _defineProperty$1({}, cssVar("swipe_offset"), "".concat(Math.round(swipeOffset.current), "px")) : null), swipeState === SwipeState.PULL ? _defineProperty$1(_defineProperty$1({}, cssVar("pull_offset"), "".concat(Math.round(pullOffset.current), "px")), cssVar("pull_opacity"), "".concat(pullOpacity.current)) : null), controller.touchAction !== "none" ? _defineProperty$1({}, cssVar("controller_touch_action"), controller.touchAction) : null), styles.container)
  }, controller.aria ? {
    role: "region",
    "aria-live": "polite",
    "aria-roledescription": "carousel"
  } : null), {}, {
    tabIndex: -1
  }, registerSensors), containerRect && (/*#__PURE__*/React.createElement(ControllerContext.Provider, {
    value: context
  }, children, (_a = render.controls) === null || _a === void 0 ? void 0 : _a.call(render))));
}
var ControllerModule = createModule(MODULE_CONTROLLER, Controller);
function cssPrefix$2(value) {
  return composePrefix(MODULE_CAROUSEL, value);
}
function cssSlidePrefix(value) {
  return composePrefix("slide", value);
}
function CarouselSlide(_ref16) {
  var slide = _ref16.slide,
    offset = _ref16.offset;
  var containerRef = React.useRef(null);
  var _useLightboxState = useLightboxState(),
    currentIndex = _useLightboxState.currentIndex;
  var _useController = useController(),
    slideRect = _useController.slideRect,
    close = _useController.close,
    focus = _useController.focus;
  var _useLightboxProps2 = useLightboxProps(),
    render = _useLightboxProps2.render,
    _useLightboxProps2$ca = _useLightboxProps2.carousel,
    imageFit = _useLightboxProps2$ca.imageFit,
    imageProps = _useLightboxProps2$ca.imageProps,
    onClick = _useLightboxProps2.on.click,
    closeOnBackdropClick = _useLightboxProps2.controller.closeOnBackdropClick,
    style = _useLightboxProps2.styles.slide;
  var _useDocumentContext2 = useDocumentContext(),
    getOwnerDocument = _useDocumentContext2.getOwnerDocument;
  var offscreen = offset !== 0;
  React.useEffect(function () {
    var _a;
    if (offscreen && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(getOwnerDocument().activeElement))) {
      focus();
    }
  }, [offscreen, focus, getOwnerDocument]);
  var renderSlide = function renderSlide() {
    var _a, _b, _c, _d;
    var rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, {
      slide: slide,
      offset: offset,
      rect: slideRect
    });
    if (!rendered && isImageSlide(slide)) {
      rendered = /*#__PURE__*/React.createElement(ImageSlide, {
        slide: slide,
        offset: offset,
        render: render,
        rect: slideRect,
        imageFit: imageFit,
        imageProps: imageProps,
        onClick: !offscreen ? function () {
          return onClick === null || onClick === void 0 ? void 0 : onClick({
            index: currentIndex
          });
        } : undefined
      });
    }
    return rendered ? (/*#__PURE__*/React.createElement(React.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 : _b.call(render, {
      slide: slide
    }), ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : function (_ref17) {
      var children = _ref17.children;
      return children;
    })({
      slide: slide,
      children: rendered
    }), (_d = render.slideFooter) === null || _d === void 0 ? void 0 : _d.call(render, {
      slide: slide
    }))) : null;
  };
  var handleBackdropClick = function handleBackdropClick(event) {
    var container = containerRef.current;
    var target = event.target instanceof HTMLElement ? event.target : undefined;
    if (closeOnBackdropClick && target && container && (target === container || Array.from(container.children).find(function (x) {
      return x === target;
    }) && target.classList.contains(cssClass(CLASS_SLIDE_WRAPPER)))) {
      close();
    }
  };
  return /*#__PURE__*/React.createElement("div", _objectSpread2(_objectSpread2({
    ref: containerRef,
    className: clsx(cssClass(cssSlidePrefix()), !offscreen && cssClass(cssSlidePrefix("current")), cssClass(CLASS_FLEX_CENTER))
  }, makeInertWhen(offscreen)), {}, {
    onClick: handleBackdropClick,
    style: style,
    role: "region",
    "aria-roledescription": "slide"
  }), renderSlide());
}
function Placeholder() {
  var style = useLightboxProps().styles.slide;
  return /*#__PURE__*/React.createElement("div", {
    className: cssClass("slide"),
    style: style
  });
}
function Carousel(_ref18) {
  var carousel = _ref18.carousel;
  var _useLightboxState2 = useLightboxState(),
    slides = _useLightboxState2.slides,
    currentIndex = _useLightboxState2.currentIndex,
    globalIndex = _useLightboxState2.globalIndex;
  var _useController2 = useController(),
    setCarouselRef = _useController2.setCarouselRef;
  var spacingValue = parseLengthPercentage(carousel.spacing);
  var paddingValue = parseLengthPercentage(carousel.padding);
  var preload = calculatePreload(carousel, slides, 1);
  var items = [];
  if (hasSlides(slides)) {
    for (var index = currentIndex - preload; index <= currentIndex + preload; index += 1) {
      var slide = getSlide(slides, index);
      var key = globalIndex - currentIndex + index;
      var placeholder = carousel.finite && (index < 0 || index > slides.length - 1);
      items.push(!placeholder ? {
        key: ["".concat(key), getSlideKey(slide)].filter(Boolean).join("|"),
        offset: index - currentIndex,
        slide: slide
      } : {
        key: key
      });
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    ref: setCarouselRef,
    className: clsx(cssClass(cssPrefix$2()), items.length > 0 && cssClass(cssPrefix$2("with_slides"))),
    style: _defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1({}, "".concat(cssVar(cssPrefix$2("slides_count"))), items.length), "".concat(cssVar(cssPrefix$2("spacing_px"))), spacingValue.pixel || 0), "".concat(cssVar(cssPrefix$2("spacing_percent"))), spacingValue.percent || 0), "".concat(cssVar(cssPrefix$2("padding_px"))), paddingValue.pixel || 0), "".concat(cssVar(cssPrefix$2("padding_percent"))), paddingValue.percent || 0)
  }, items.map(function (_ref19) {
    var key = _ref19.key,
      slide = _ref19.slide,
      offset = _ref19.offset;
    return slide ? /*#__PURE__*/React.createElement(CarouselSlide, {
      key: key,
      slide: slide,
      offset: offset
    }) : /*#__PURE__*/React.createElement(Placeholder, {
      key: key
    });
  }));
}
var CarouselModule = createModule(MODULE_CAROUSEL, Carousel);
function useNavigationState() {
  var _useLightboxProps3 = useLightboxProps(),
    carousel = _useLightboxProps3.carousel;
  var _useLightboxState3 = useLightboxState(),
    slides = _useLightboxState3.slides,
    currentIndex = _useLightboxState3.currentIndex;
  var prevDisabled = slides.length === 0 || carousel.finite && currentIndex === 0;
  var nextDisabled = slides.length === 0 || carousel.finite && currentIndex === slides.length - 1;
  return {
    prevDisabled: prevDisabled,
    nextDisabled: nextDisabled
  };
}
function useKeyboardNavigation(subscribeSensors) {
  var _a;
  var isRTL = useRTL();
  var _useEvents3 = useEvents(),
    publish = _useEvents3.publish;
  var _useLightboxProps4 = useLightboxProps(),
    animation = _useLightboxProps4.animation;
  var _useNavigationState = useNavigationState(),
    prevDisabled = _useNavigationState.prevDisabled,
    nextDisabled = _useNavigationState.nextDisabled;
  var throttle = ((_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe) / 2;
  var prev = useThrottle(function () {
    return publish(ACTION_PREV);
  }, throttle);
  var next = useThrottle(function () {
    return publish(ACTION_NEXT);
  }, throttle);
  var handleKeyDown = useEventCallback(function (event) {
    switch (event.key) {
      case VK_ESCAPE:
        publish(ACTION_CLOSE);
        break;
      case VK_ARROW_LEFT:
        if (!(isRTL ? nextDisabled : prevDisabled)) (isRTL ? next : prev)();
        break;
      case VK_ARROW_RIGHT:
        if (!(isRTL ? prevDisabled : nextDisabled)) (isRTL ? prev : next)();
        break;
    }
  });
  React.useEffect(function () {
    return subscribeSensors(EVENT_ON_KEY_DOWN, handleKeyDown);
  }, [subscribeSensors, handleKeyDown]);
}
function NavigationButton(_ref20) {
  var label = _ref20.label,
    icon = _ref20.icon,
    renderIcon = _ref20.renderIcon,
    action = _ref20.action,
    onClick = _ref20.onClick,
    disabled = _ref20.disabled,
    style = _ref20.style;
  return /*#__PURE__*/React.createElement(IconButton, _objectSpread2({
    label: label,
    icon: icon,
    renderIcon: renderIcon,
    className: cssClass("navigation_".concat(action)),
    disabled: disabled,
    onClick: onClick,
    style: style
  }, useLoseFocus(useController().focus, disabled)));
}
function Navigation(_ref21) {
  var _ref21$render = _ref21.render,
    buttonPrev = _ref21$render.buttonPrev,
    buttonNext = _ref21$render.buttonNext,
    iconPrev = _ref21$render.iconPrev,
    iconNext = _ref21$render.iconNext,
    styles = _ref21.styles;
  var _useController3 = useController(),
    prev = _useController3.prev,
    next = _useController3.next,
    subscribeSensors = _useController3.subscribeSensors;
  var _useNavigationState2 = useNavigationState(),
    prevDisabled = _useNavigationState2.prevDisabled,
    nextDisabled = _useNavigationState2.nextDisabled;
  useKeyboardNavigation(subscribeSensors);
  return /*#__PURE__*/React.createElement(React.Fragment, null, buttonPrev ? buttonPrev() : (/*#__PURE__*/React.createElement(NavigationButton, {
    label: "Previous",
    action: ACTION_PREV,
    icon: PreviousIcon,
    renderIcon: iconPrev,
    style: styles.navigationPrev,
    disabled: prevDisabled,
    onClick: prev
  })), buttonNext ? buttonNext() : (/*#__PURE__*/React.createElement(NavigationButton, {
    label: "Next",
    action: ACTION_NEXT,
    icon: NextIcon,
    renderIcon: iconNext,
    style: styles.navigationNext,
    disabled: nextDisabled,
    onClick: next
  })));
}
var NavigationModule = createModule(MODULE_NAVIGATION, Navigation);
var noScroll = cssClass(CLASS_NO_SCROLL);
var noScrollPadding = cssClass(CLASS_NO_SCROLL_PADDING);
function isHTMLElement(element) {
  return "style" in element;
}
function padScrollbar(element, padding, rtl) {
  var styles = window.getComputedStyle(element);
  var property = rtl ? "padding-left" : "padding-right";
  var computedValue = rtl ? styles.paddingLeft : styles.paddingRight;
  var originalValue = element.style.getPropertyValue(property);
  element.style.setProperty(property, "".concat((parseInt$1(computedValue) || 0) + padding, "px"));
  return function () {
    if (originalValue) {
      element.style.setProperty(property, originalValue);
    } else {
      element.style.removeProperty(property);
    }
  };
}
function NoScroll(_ref22) {
  var disabled = _ref22.noScroll.disabled,
    children = _ref22.children;
  var rtl = useRTL();
  var _useDocumentContext3 = useDocumentContext(),
    getOwnerDocument = _useDocumentContext3.getOwnerDocument,
    getOwnerWindow = _useDocumentContext3.getOwnerWindow;
  React.useEffect(function () {
    if (disabled) return function () {};
    var cleanup = [];
    var ownerWindow = getOwnerWindow();
    var _getOwnerDocument = getOwnerDocument(),
      body = _getOwnerDocument.body,
      documentElement = _getOwnerDocument.documentElement;
    var scrollbar = Math.round(ownerWindow.innerWidth - documentElement.clientWidth);
    if (scrollbar > 0) {
      cleanup.push(padScrollbar(body, scrollbar, rtl));
      var elements = body.getElementsByTagName("*");
      for (var i = 0; i < elements.length; i += 1) {
        var element = elements[i];
        if (isHTMLElement(element) && ownerWindow.getComputedStyle(element).getPropertyValue("position") === "fixed" && !element.classList.contains(noScrollPadding)) {
          cleanup.push(padScrollbar(element, scrollbar, rtl));
        }
      }
    }
    body.classList.add(noScroll);
    return function () {
      body.classList.remove(noScroll);
      cleanup.forEach(function (clean) {
        return clean();
      });
    };
  }, [rtl, disabled, getOwnerDocument, getOwnerWindow]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
var NoScrollModule = createModule(MODULE_NO_SCROLL, NoScroll);
function cssPrefix$1(value) {
  return composePrefix(MODULE_PORTAL, value);
}
function setAttribute(element, attribute, value) {
  var previousValue = element.getAttribute(attribute);
  element.setAttribute(attribute, value);
  return function () {
    if (previousValue) {
      element.setAttribute(attribute, previousValue);
    } else {
      element.removeAttribute(attribute);
    }
  };
}
function Portal(_ref23) {
  var children = _ref23.children,
    animation = _ref23.animation,
    styles = _ref23.styles,
    className = _ref23.className,
    on = _ref23.on,
    portal = _ref23.portal,
    close = _ref23.close;
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    mounted = _React$useState18[0],
    setMounted = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    visible = _React$useState20[0],
    setVisible = _React$useState20[1];
  var cleanup = React.useRef([]);
  var restoreFocus = React.useRef(null);
  var _useTimeouts4 = useTimeouts(),
    setTimeout = _useTimeouts4.setTimeout;
  var _useEvents4 = useEvents(),
    subscribe = _useEvents4.subscribe;
  var reduceMotion = useMotionPreference();
  var animationDuration = !reduceMotion ? animation.fade : 0;
  React.useEffect(function () {
    setMounted(true);
    return function () {
      setMounted(false);
      setVisible(false);
    };
  }, []);
  var handleCleanup = useEventCallback(function () {
    cleanup.current.forEach(function (clean) {
      return clean();
    });
    cleanup.current = [];
  });
  var handleClose = useEventCallback(function () {
    var _a;
    setVisible(false);
    handleCleanup();
    (_a = on.exiting) === null || _a === void 0 ? void 0 : _a.call(on);
    setTimeout(function () {
      var _a;
      (_a = on.exited) === null || _a === void 0 ? void 0 : _a.call(on);
      close();
    }, animationDuration);
  });
  React.useEffect(function () {
    return subscribe(ACTION_CLOSE, handleClose);
  }, [subscribe, handleClose]);
  var handleEnter = useEventCallback(function (node) {
    var _a, _b, _c;
    reflow(node);
    setVisible(true);
    (_a = on.entering) === null || _a === void 0 ? void 0 : _a.call(on);
    var elements = (_c = (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
    for (var i = 0; i < elements.length; i += 1) {
      var element = elements[i];
      if (["TEMPLATE", "SCRIPT", "STYLE"].indexOf(element.tagName) === -1 && element !== node) {
        cleanup.current.push(setAttribute(element, "inert", ""));
        cleanup.current.push(setAttribute(element, "aria-hidden", "true"));
      }
    }
    cleanup.current.push(function () {
      var _a, _b;
      (_b = (_a = restoreFocus.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    });
    setTimeout(function () {
      var _a;
      (_a = on.entered) === null || _a === void 0 ? void 0 : _a.call(on);
    }, animationDuration);
  });
  var handleRef = React.useCallback(function (node) {
    if (node) {
      handleEnter(node);
    } else {
      handleCleanup();
    }
  }, [handleEnter, handleCleanup]);
  return mounted ? /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(LightboxRoot, {
    ref: handleRef,
    className: clsx(className, cssClass(cssPrefix$1()), cssClass(CLASS_NO_SCROLL_PADDING), visible && cssClass(cssPrefix$1("open"))),
    "aria-modal": true,
    role: "dialog",
    "aria-live": "polite",
    "aria-roledescription": "lightbox",
    style: _objectSpread2(_objectSpread2(_objectSpread2({}, animation.fade !== LightboxDefaultProps.animation.fade ? _defineProperty$1({}, cssVar("fade_animation_duration"), "".concat(animationDuration, "ms")) : null), animation.easing.fade !== LightboxDefaultProps.animation.easing.fade ? _defineProperty$1({}, cssVar("fade_animation_timing_function"), animation.easing.fade) : null), styles.root),
    onFocus: function onFocus(event) {
      if (!restoreFocus.current) {
        restoreFocus.current = event.relatedTarget;
      }
    }
  }, children), portal.root || document.body) : null;
}
var PortalModule = createModule(MODULE_PORTAL, Portal);
function Root(_ref26) {
  var children = _ref26.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
var RootModule = createModule(MODULE_ROOT, Root);
function cssPrefix(value) {
  return composePrefix(MODULE_TOOLBAR, value);
}
function Toolbar(_ref27) {
  var buttons = _ref27.toolbar.buttons,
    _ref27$render = _ref27.render,
    buttonClose = _ref27$render.buttonClose,
    iconClose = _ref27$render.iconClose,
    styles = _ref27.styles;
  var _useController4 = useController(),
    close = _useController4.close,
    setToolbarWidth = _useController4.setToolbarWidth;
  var _useContainerRect2 = useContainerRect(),
    setContainerRef = _useContainerRect2.setContainerRef,
    containerRect = _useContainerRect2.containerRect;
  useLayoutEffect(function () {
    setToolbarWidth(containerRect === null || containerRect === void 0 ? void 0 : containerRect.width);
  }, [setToolbarWidth, containerRect === null || containerRect === void 0 ? void 0 : containerRect.width]);
  var renderCloseButton = function renderCloseButton() {
    if (buttonClose) return buttonClose();
    return /*#__PURE__*/React.createElement(IconButton, {
      key: ACTION_CLOSE,
      label: "Close",
      icon: CloseIcon,
      renderIcon: iconClose,
      onClick: close
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: setContainerRef,
    style: styles.toolbar,
    className: cssClass(cssPrefix())
  }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (button) {
    return button === ACTION_CLOSE ? renderCloseButton() : button;
  }));
}
var ToolbarModule = createModule(MODULE_TOOLBAR, Toolbar);
function renderNode(node, props) {
  var _a;
  return /*#__PURE__*/React.createElement(node.module.component, _objectSpread2({
    key: node.module.name
  }, props), (_a = node.children) === null || _a === void 0 ? void 0 : _a.map(function (child) {
    return renderNode(child, props);
  }));
}
function mergeAnimation(defaultAnimation) {
  var animation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultAnimationEasing = defaultAnimation.easing,
    restDefaultAnimation = _objectWithoutProperties$1(defaultAnimation, _excluded7);
  var easing = animation.easing,
    restAnimation = _objectWithoutProperties$1(animation, _excluded8);
  return _objectSpread2(_objectSpread2({
    easing: _objectSpread2(_objectSpread2({}, defaultAnimationEasing), easing)
  }, restDefaultAnimation), restAnimation);
}
function Lightbox(_ref28) {
  var carousel = _ref28.carousel,
    animation = _ref28.animation,
    render = _ref28.render,
    toolbar = _ref28.toolbar,
    controller = _ref28.controller,
    noScroll = _ref28.noScroll,
    on = _ref28.on,
    plugins = _ref28.plugins,
    slides = _ref28.slides,
    index = _ref28.index,
    restProps = _objectWithoutProperties$1(_ref28, _excluded9);
  var defaultAnimation = LightboxDefaultProps.animation,
    defaultCarousel = LightboxDefaultProps.carousel,
    defaultRender = LightboxDefaultProps.render,
    defaultToolbar = LightboxDefaultProps.toolbar,
    defaultController = LightboxDefaultProps.controller,
    defaultNoScroll = LightboxDefaultProps.noScroll,
    defaultOn = LightboxDefaultProps.on,
    defaultSlides = LightboxDefaultProps.slides,
    defaultIndex = LightboxDefaultProps.index,
    defaultPlugins = LightboxDefaultProps.plugins,
    restDefaultProps = _objectWithoutProperties$1(LightboxDefaultProps, _excluded0);
  var _withPlugins = withPlugins([createNode(PortalModule, [createNode(NoScrollModule, [createNode(ControllerModule, [createNode(CarouselModule), createNode(ToolbarModule), createNode(NavigationModule)])])])], plugins || defaultPlugins),
    config = _withPlugins.config,
    augmentation = _withPlugins.augmentation;
  var props = augmentation(_objectSpread2(_objectSpread2({
    animation: mergeAnimation(defaultAnimation, animation),
    carousel: _objectSpread2(_objectSpread2({}, defaultCarousel), carousel),
    render: _objectSpread2(_objectSpread2({}, defaultRender), render),
    toolbar: _objectSpread2(_objectSpread2({}, defaultToolbar), toolbar),
    controller: _objectSpread2(_objectSpread2({}, defaultController), controller),
    noScroll: _objectSpread2(_objectSpread2({}, defaultNoScroll), noScroll),
    on: _objectSpread2(_objectSpread2({}, defaultOn), on)
  }, restDefaultProps), restProps));
  if (!props.open) return null;
  return /*#__PURE__*/React.createElement(LightboxPropsProvider, _objectSpread2({}, props), /*#__PURE__*/React.createElement(LightboxStateProvider, {
    slides: slides || defaultSlides,
    index: parseInt$1(index || defaultIndex)
  }, /*#__PURE__*/React.createElement(TimeoutsProvider, null, /*#__PURE__*/React.createElement(EventsProvider, null, renderNode(createNode(RootModule, config), props)))));
}

var _excluded = ["className"],
  _excluded2 = ["separator", "container", "className"],
  _excluded3 = ["counter"];
var defaultCounterProps = {
  separator: "/",
  container: {}
};
var resolveCounterProps = function resolveCounterProps(counter) {
  return _objectSpread2(_objectSpread2({}, defaultCounterProps), counter);
};
function CounterComponent(_ref) {
  var counter = _ref.counter;
  var _useLightboxState = useLightboxState(),
    slides = _useLightboxState.slides,
    currentIndex = _useLightboxState.currentIndex;
  var _resolveCounterProps = resolveCounterProps(counter),
    separator = _resolveCounterProps.separator,
    _resolveCounterProps$ = _resolveCounterProps.container,
    className = _resolveCounterProps$.className,
    rest = _objectWithoutProperties$1(_resolveCounterProps$, _excluded),
    legacyClassName = _resolveCounterProps.className,
    legacyRest = _objectWithoutProperties$1(_resolveCounterProps, _excluded2);
  if (slides.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", _objectSpread2(_objectSpread2({
    className: clsx(cssClass("counter"), className || legacyClassName)
  }, legacyRest), rest), currentIndex + 1, " ", separator, " ", slides.length);
}
function Counter$1(_ref2) {
  var augment = _ref2.augment,
    addChild = _ref2.addChild;
  augment(function (_ref3) {
    var counter = _ref3.counter,
      restProps = _objectWithoutProperties$1(_ref3, _excluded3);
    return _objectSpread2({
      counter: resolveCounterProps(counter)
    }, restProps);
  });
  addChild(MODULE_CONTROLLER, createModule(PLUGIN_COUNTER, CounterComponent));
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".yarl__fullsize{height:100%;width:100%}.yarl__relative{position:relative}.yarl__portal{bottom:0;left:0;opacity:0;overflow:hidden;position:fixed;right:0;top:0;transition:opacity var(--yarl__fade_animation_duration,.25s) var(--yarl__fade_animation_timing_function,ease);z-index:var(--yarl__portal_zindex,9999)}.yarl__portal_open{opacity:1}.yarl__container{background-color:var(--yarl__container_background_color,var(--yarl__color_backdrop,#000));bottom:0;left:0;outline:none;overflow:hidden;overscroll-behavior:var(--yarl__controller_overscroll_behavior,contain);position:absolute;right:0;top:0;touch-action:var(--yarl__controller_touch_action,none);-webkit-user-select:none;-moz-user-select:none;user-select:none}.yarl__carousel{align-content:center;align-items:stretch;display:flex;flex:0 0 auto;height:100%;justify-content:center;opacity:var(--yarl__pull_opacity,1);transform:translate(var(--yarl__swipe_offset,0),var(--yarl__pull_offset,0));width:calc(100% + (var(--yarl__carousel_slides_count) - 1)*(100% + var(--yarl__carousel_spacing_px, 0)*1px + var(--yarl__carousel_spacing_percent, 0)*1%))}.yarl__carousel_with_slides{-moz-column-gap:calc(var(--yarl__carousel_spacing_px, 0)*1px + 100/(var(--yarl__carousel_slides_count)*100 + (var(--yarl__carousel_slides_count) - 1)*var(--yarl__carousel_spacing_percent, 0))*var(--yarl__carousel_spacing_percent, 0)*1%);column-gap:calc(var(--yarl__carousel_spacing_px, 0)*1px + 100/(var(--yarl__carousel_slides_count)*100 + (var(--yarl__carousel_slides_count) - 1)*var(--yarl__carousel_spacing_percent, 0))*var(--yarl__carousel_spacing_percent, 0)*1%)}.yarl__flex_center{align-content:center;align-items:center;display:flex;justify-content:center}.yarl__slide{flex:1;overflow:hidden;padding:calc(var(--yarl__carousel_padding_px, 0)*1px + 100/(var(--yarl__carousel_slides_count)*100 + (var(--yarl__carousel_slides_count) - 1)*var(--yarl__carousel_spacing_percent, 0))*var(--yarl__carousel_padding_percent, 0)*1%);position:relative}[dir=rtl] .yarl__slide{--yarl__direction:-1}.yarl__slide_image{max-height:100%;max-width:100%;-o-object-fit:contain;object-fit:contain;touch-action:var(--yarl__controller_touch_action,none);-moz-user-select:none;user-select:none;-webkit-user-select:none;-webkit-touch-callout:none}.yarl__slide_image_cover{height:100%;-o-object-fit:cover;object-fit:cover;width:100%}.yarl__slide_image_loading{opacity:0}@media screen and (min-width:800px){.yarl__slide_wrapper:not(.yarl__slide_wrapper_interactive) .yarl__slide_image{-webkit-backface-visibility:hidden;-webkit-transform:translateZ(0);-webkit-transform-style:preserve-3d}}.yarl__slide_placeholder{left:50%;line-height:0;position:absolute;top:50%;transform:translateX(-50%) translateY(-50%)}.yarl__slide_loading{animation:yarl__delayed_fadein 1s linear;color:var(--yarl__slide_icon_loading_color,var(--yarl__color_button,hsla(0,0%,100%,.8)))}.yarl__slide_loading line{animation:yarl__stroke_opacity 1s linear infinite}.yarl__slide_loading line:first-of-type{animation-delay:-1.875s}.yarl__slide_loading line:nth-of-type(2){animation-delay:-1.75s}.yarl__slide_loading line:nth-of-type(3){animation-delay:-1.625s}.yarl__slide_loading line:nth-of-type(4){animation-delay:-1.5s}.yarl__slide_loading line:nth-of-type(5){animation-delay:-1.375s}.yarl__slide_loading line:nth-of-type(6){animation-delay:-1.25s}.yarl__slide_loading line:nth-of-type(7){animation-delay:-1.125s}.yarl__slide_loading line:nth-of-type(8){animation-delay:-1s}.yarl__slide_error{color:var(--yarl__slide_icon_error_color,red);height:var(--yarl__slide_icon_error_size,48px);width:var(--yarl__slide_icon_error_size,48px)}@media (prefers-reduced-motion){.yarl__portal,.yarl__slide{transition:unset}.yarl__slide_loading,.yarl__slide_loading line{animation:unset}}.yarl__toolbar{bottom:auto;display:flex;justify-content:flex-end;left:auto;padding:var(--yarl__toolbar_padding,8px);position:absolute;right:0;top:0}[dir=rtl] .yarl__toolbar{bottom:auto;left:0;right:auto;top:0}.yarl__icon{height:var(--yarl__icon_size,32px);width:var(--yarl__icon_size,32px)}.yarl__button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--yarl__button_background_color,transparent);border:var(--yarl__button_border,0);color:var(--yarl__color_button,hsla(0,0%,100%,.8));cursor:pointer;filter:var(--yarl__button_filter,drop-shadow(2px 2px 2px rgba(0,0,0,.8)));line-height:0;margin:var(--yarl__button_margin,0);outline:none;padding:var(--yarl__button_padding,8px);-webkit-tap-highlight-color:transparent}.yarl__button:focus{color:var(--yarl__color_button_active,#fff)}.yarl__button:focus:not(:focus-visible){color:var(--yarl__color_button,hsla(0,0%,100%,.8))}.yarl__button:focus-visible{color:var(--yarl__color_button_active,#fff)}@media (hover:hover){.yarl__button:focus-visible:hover,.yarl__button:focus:hover,.yarl__button:hover{color:var(--yarl__color_button_active,#fff)}}.yarl__button:disabled{color:var(--yarl__color_button_disabled,hsla(0,0%,100%,.4));cursor:default}.yarl__navigation_next,.yarl__navigation_prev{padding:var(--yarl__navigation_button_padding,24px 16px);position:absolute;top:50%;transform:translateY(-50%)}.yarl__navigation_prev{left:0}[dir=rtl] .yarl__navigation_prev{left:unset;right:0;transform:translateY(-50%) rotate(180deg)}.yarl__navigation_next{right:0}[dir=rtl] .yarl__navigation_next{left:0;right:unset;transform:translateY(-50%) rotate(180deg)}.yarl__no_scroll{height:100%;overflow:hidden;overscroll-behavior:none}@keyframes yarl__delayed_fadein{0%{opacity:0}80%{opacity:0}to{opacity:1}}@keyframes yarl__stroke_opacity{0%{stroke-opacity:1}to{stroke-opacity:.125}}";
styleInject(css_248z$1);

var css_248z = ".yarl__counter{bottom:var(--yarl__counter_bottom,unset);color:var(--yarl__counter_color,var(--yarl__color_button,hsla(0,0%,100%,.8)));filter:var(--yarl__counter_filter,drop-shadow(2px 2px 2px rgba(0,0,0,.8)));left:var(--yarl__counter_left,0);line-height:var(--yarl__counter_line_height,var(--yarl__icon_size,32px));margin:var(--yarl__counter_margin,var(--yarl__toolbar_padding,8px));padding:var(--yarl__counter_padding,var(--yarl__button_padding,8px));position:var(--yarl__counter_position,absolute);right:var(--yarl__counter_right,unset);top:var(--yarl__counter_top,0);-webkit-user-select:var(--yarl__counter_user_select,none);-moz-user-select:var(--yarl__counter_user_select,none);user-select:var(--yarl__counter_user_select,none)}";
styleInject(css_248z);

var PhotosAndVideos = function PhotosAndVideos(_ref) {
  var photos = _ref.photos,
    video_url = _ref.video_url;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPhotoIndex = _useState4[0],
    setCurrentPhotoIndex = _useState4[1];
  var _useState5 = useState(window.innerWidth > 768),
    _useState6 = _slicedToArray(_useState5, 2),
    isDesktop = _useState6[0],
    setIsDesktop = _useState6[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      setIsDesktop(window.innerWidth > 768);
    };
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  var handleOpen = function handleOpen(index) {
    if (isDesktop) {
      setOpen(true);
      setCurrentPhotoIndex(index);
    }
  };
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "32px"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "24px"
  }, /*#__PURE__*/React__default.createElement(H2$1, {
    variant: "primary",
    size: "profile",
    marginless: true
  }, "Videos"), video_url ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px",
    template: "auto / 1fr 1fr"
  }, /*#__PURE__*/React__default.createElement(VideoWrapper, null, /*#__PURE__*/React__default.createElement(Video, {
    title: "Video",
    width: "560",
    height: "349",
    src: "".concat(video_url, "?color=white&rel=0"),
    allowFullScreen: true,
    frameBorder: "0"
  })))) : /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, "No videos available.")), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "24px"
  }, /*#__PURE__*/React__default.createElement(H2$1, {
    variant: "primary",
    size: "profile",
    marginless: true
  }, "Photos"), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "12px"
  }, photos.length > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px",
    template: "auto / 1fr 1fr 1fr"
  }, photos.map(function (image, index) {
    return /*#__PURE__*/React__default.createElement(Img, {
      key: index,
      src: image.url,
      alt: image.alt,
      onClick: function onClick() {
        return handleOpen(index);
      }
    });
  }))) : /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, "No photos available."))), /*#__PURE__*/React__default.createElement(Lightbox, {
    open: open,
    close: function close() {
      return setOpen(false);
    },
    slides: photos.map(function (photo) {
      return {
        src: photo.url
      };
    }),
    index: currentPhotoIndex,
    styles: {
      container: {
        backgroundColor: "rgba(0, 0, 0, .8)"
      }
    },
    plugins: [Counter$1]
  }));
};
PhotosAndVideos.propTypes = {
  photos: PropTypes.array.isRequired,
  video_url: PropTypes.string
};
PhotosAndVideos.defaultProps = {
  photos: [],
  video_url: ""
};

var Location = function Location(_ref) {
  var content = _ref.content,
    maps_api_key = _ref.maps_api_key,
    lat = _ref.lat,
    lng = _ref.lng;
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "32px"
  }, /*#__PURE__*/React__default.createElement(Markdown, {
    componentStyles: {
      h1: {
        variant: "primary"
      },
      h2: {
        variant: "primary"
      },
      h3: {
        variant: "primary"
      },
      p: {
        variant: "content"
      },
      li: {
        variant: "content"
      },
      a: {
        variant: "content"
      }
    }
  }, content), lat && lng && /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "400px",
      width: "100%",
      borderRadius: "10px",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React__default.createElement("iframe", {
    src: "https://www.google.com/maps/embed/v1/place?key=".concat(maps_api_key, "&q=").concat(lat, ",").concat(lng),
    width: "100%",
    height: "100%",
    frameBorder: "0",
    style: {
      border: 0,
      outline: "none"
    },
    allowFullScreen: "",
    "aria-hidden": "false",
    tabIndex: "0"
  })));
};

var _templateObject$i, _templateObject2$f;
var Container$9 = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  height: auto;\n  min-height: 100%;\n  box-sizing: border-box;\n  padding: 2rem;\n  display: grid;\n  gap: 2rem;\n  place-content: space-between stretch;\n  user-select: text;\n"])));
var A$2 = styled.a(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n  text-decoration: none;\n  color: #fff;\n"])));

var ParticipantSidebar = function ParticipantSidebar(_ref) {
  _ref.avatar_exists;
    _ref.avatar_path;
    _ref.display_name;
    _ref.first_name;
    _ref.last_name;
    _ref.age;
    _ref.gender;
    var gender_info = _ref.gender_info;
    _ref.country_code;
    var placement_or_interview_status = _ref.placement_or_interview_status,
    english_rating = _ref.english_rating,
    availability_from = _ref.availability_from,
    availability_until = _ref.availability_until,
    email = _ref.email,
    mobile_number = _ref.mobile_number,
    buttons = _ref.buttons,
    interview_plugin_enabled = _ref.interview_plugin_enabled,
    availability_plugin_enabled = _ref.availability_plugin_enabled,
    student_status = _ref.student_status,
    has_visa = _ref.has_visa;
  return /*#__PURE__*/React__default.createElement(Container$9, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1rem"
  }, placement_or_interview_status && placement_or_interview_status.length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Separator$1, {
    variant: "secondary",
    size: "small",
    margin: "small",
    mobileOnly: false
  }), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    size: "medium",
    marginless: true,
    bold: true,
    align: "center"
  }, "Status:"), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    align: "center"
  }, placement_or_interview_status))), /*#__PURE__*/React__default.createElement(Separator$1, {
    variant: "secondary",
    size: "small",
    margin: "small",
    mobileOnly: false
  }), has_visa && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    size: "medium",
    marginless: true,
    bold: true,
    align: "center"
  }, "Visa received:"), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    align: "center"
  }, "Yes")), interview_plugin_enabled && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    size: "medium",
    marginless: true,
    bold: true,
    align: "center"
  }, "English rating:"), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    align: "center"
  }, english_rating || "-")), student_status && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    size: "medium",
    marginless: true,
    bold: true,
    align: "center"
  }, "Student status:"), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    align: "center"
  }, student_status)), availability_plugin_enabled && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    size: "medium",
    marginless: true,
    bold: true,
    align: "center"
  }, "Availability:"), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    align: "center"
  }, availability_from && availability_until ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Moment, {
    value: availability_from,
    blank: "-"
  }), "\xA0to\xA0", /*#__PURE__*/React__default.createElement(Moment, {
    value: availability_until,
    blank: "-"
  })) : "-")), gender_info && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    size: "medium",
    marginless: true,
    bold: true,
    align: "center"
  }, "I describe myself as:"), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    align: "center"
  }, gender_info)), (email || mobile_number) && /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem"
  }, /*#__PURE__*/React__default.createElement(P$4, {
    size: "medium",
    marginless: true,
    bold: true,
    align: "center"
  }, "Contact:"), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    align: "center"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faEnvelope$1
  }), " ", /*#__PURE__*/React__default.createElement(A$2, {
    href: "mailto:".concat(email)
  }, email), /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faPhone
  }), " ", mobile_number)))), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0.5rem"
  }, buttons !== undefined && buttons));
};
ParticipantSidebar.propTypes = {
  avatar_exists: PropTypes.bool,
  avatar_path: PropTypes.string,
  display_name: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  age: PropTypes.string,
  gender: PropTypes.string,
  gender_info: PropTypes.string,
  country_code: PropTypes.string,
  english_rating: PropTypes.string,
  availability_from: PropTypes.string,
  availability_until: PropTypes.string,
  email: PropTypes.string,
  mobile_number: PropTypes.string,
  buttons: PropTypes.node
};
ParticipantSidebar.defaultProps = {
  avatar_exists: true,
  avatar_path: "",
  display_name: "",
  first_name: "",
  last_name: "",
  age: "",
  gender: "",
  gender_info: "",
  country_code: "",
  english_rating: "",
  availability_from: "",
  availability_until: "",
  email: "",
  mobile_number: "",
  buttons: undefined
};

var _templateObject$h, _templateObject2$e, _templateObject3$b, _templateObject4$a;
var Span = styled.span(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  ", "\n\n  > button {\n    margin-bottom: 2rem;\n    width: 100%;\n    font-size: 1rem;\n    padding: 1rem;\n\n    ", "\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"])), breakpoint("tablet")(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n    float: right;\n    margin-left: 2rem;\n  "]))), breakpoint("tablet")(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n      margin-bottom: 0;\n      width: auto;\n      font-size: 0.75rem;\n      padding: 0.5rem 1rem;\n    "]))));
var A$1 = styled.a(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n  cursor: pointer;\n"])), function (props) {
  return props.theme.colors.primary;
});

var LinkedApplication = function LinkedApplication(_ref) {
  var _linked_application$l, _linked_application$l2, _linked_application$l3, _linked_application$l4, _linked_application$l5, _linked_application$l6, _linked_application$l7, _linked_application$l8, _linked_application$l9;
  var linked_application = _ref.linked_application,
    toggleProfile = _ref.toggleProfile;
  var name = linked_application === null || linked_application === void 0 || (_linked_application$l = linked_application.linked_person) === null || _linked_application$l === void 0 ? void 0 : _linked_application$l.name;
  var otherName = linked_application === null || linked_application === void 0 || (_linked_application$l2 = linked_application.linked_person) === null || _linked_application$l2 === void 0 ? void 0 : _linked_application$l2.linked_name;
  if (!name || !otherName) return null;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(H2$1, {
    variant: "primary",
    profile: true
  }, "Linked Application"), linked_application !== null && linked_application !== void 0 && linked_application.show_link && toggleProfile !== undefined ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Span, null, /*#__PURE__*/React__default.createElement(Button$5, {
    onClick: function onClick(event) {
      return toggleProfile(event, linked_application === null || linked_application === void 0 ? void 0 : linked_application.linked_person);
    },
    variant: "primary",
    size: "small",
    outlined: true
  }, "Open ", linked_application === null || linked_application === void 0 || (_linked_application$l3 = linked_application.linked_person) === null || _linked_application$l3 === void 0 ? void 0 : _linked_application$l3.name, " profile")), /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    variant: "content",
    profileData: true
  }, linked_application !== null && linked_application !== void 0 && linked_application.show_link && toggleProfile !== undefined ? /*#__PURE__*/React__default.createElement(A$1, {
    onClick: function onClick(event) {
      return toggleProfile(event, linked_application === null || linked_application === void 0 ? void 0 : linked_application.linked_person);
    }
  }, linked_application === null || linked_application === void 0 || (_linked_application$l4 = linked_application.linked_person) === null || _linked_application$l4 === void 0 ? void 0 : _linked_application$l4.name, " ") : "".concat(linked_application === null || linked_application === void 0 || (_linked_application$l5 = linked_application.linked_person) === null || _linked_application$l5 === void 0 ? void 0 : _linked_application$l5.name, " "), "and ", linked_application === null || linked_application === void 0 || (_linked_application$l6 = linked_application.linked_person) === null || _linked_application$l6 === void 0 ? void 0 : _linked_application$l6.linked_name, " have linked their applications as they would like to participate on the program together.")) : /*#__PURE__*/React__default.createElement(P$4, {
    marginless: true,
    variant: "content",
    profileData: true
  }, linked_application === null || linked_application === void 0 || (_linked_application$l7 = linked_application.linked_person) === null || _linked_application$l7 === void 0 ? void 0 : _linked_application$l7.name, " and ", linked_application === null || linked_application === void 0 || (_linked_application$l8 = linked_application.linked_person) === null || _linked_application$l8 === void 0 ? void 0 : _linked_application$l8.linked_name, " have linked their applications, but ", linked_application === null || linked_application === void 0 || (_linked_application$l9 = linked_application.linked_person) === null || _linked_application$l9 === void 0 ? void 0 : _linked_application$l9.name, "'s profile is currently unavailable."));
};
LinkedApplication.propTypes = {
  linked_application: PropTypes.object.isRequired,
  toggleProfile: PropTypes.func
};
LinkedApplication.defaultProps = {
  linked_application: {},
  toggleProfile: undefined
};

var RpInterviewSummary = function RpInterviewSummary() {
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(H2$1, {
    variant: "primary",
    profile: true
  }, "Interview Summary"), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, "This participant had frequent communication with a member of Camp Leaders' staff and has been given guidance on the returnee application process."), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, "Having been interviewed and successfully completed a past season at camp the participant has already fulfilled all the criteria required to be an excellent staff member at camp."), /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    marginless: true,
    profileData: true
  }, "Reference, camp contact, police check and full documentation are provided. Please contact Camp Leaders directly for these if necessary."));
};

var _templateObject$g, _templateObject2$d;
var Header$2 = styled.header(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  font-family: ", ", sans-serif;\n  gap: 32px;\n  align-items: center;\n  background-size: cover;\n  padding: 0;\n  display: block;\n  justify-content: start;\n  display: flex;\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.body.family;
}, breakpoint("tablet")(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n    justify-content: start;\n    padding: 24px 32px 12px 32px;\n  "]))));

var _templateObject$f, _templateObject2$c, _templateObject3$a, _templateObject4$9, _templateObject5$8, _templateObject6$6, _templateObject7$6, _templateObject8$6, _templateObject9$6, _templateObject0$6, _templateObject1$5, _templateObject10$5, _templateObject11$5, _templateObject12$4, _templateObject13$4, _templateObject14$4, _templateObject15$4, _templateObject16$4, _templateObject17$3, _templateObject18$2, _templateObject19$2, _templateObject20$1;
var TopBanner = styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"])));
var DisplayName = styled.p(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 140%;\n  margin: 0;\n"])));
var PlacementOrInterviewStatus = styled.p(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 4px 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 4px;\n  background-color: #e5f7fc;\n  margin: 0;\n"])));
var Container$8 = styled.div(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteral(["\n    ", "\n    align-items: flex-start;\n  "])), function (_ref) {
  var hasEmployer = _ref.hasEmployer;
  return hasEmployer ? css(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteral(["\n            flex-direction: row;\n          "]))) : css(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteral(["\n            flex-direction: column;\n          "])));
}));
var Badge = styled.div(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%;\n  font-family: ", ", sans-serif;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 4px;\n  display: flex;\n  padding: 4px 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  text-wrap: nowrap;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.body.family;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.profile.badge.background;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.profile.badge.text;
});
styled.div(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteral(["\n  display: none;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject0$6 || (_templateObject0$6 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n  margin-top: 8px;\n"]))));
var InfoBox = styled.div(_templateObject1$5 || (_templateObject1$5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  color: white;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject10$5 || (_templateObject10$5 = _taggedTemplateLiteral(["\n    margin-left: 48px;\n  "]))));
var NameAndStatus = styled.div(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  margin-top: 32px;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteral(["\n    flex-direction: row;\n    margin-top: 12px;\n    margin-bottom: 6px;\n  "]))));
var Name = styled.h3(_templateObject13$4 || (_templateObject13$4 = _taggedTemplateLiteral(["\n  font-family: \"Helvetica Neue\";\n  font-style: normal;\n  font-weight: 700;\n  line-height: 110%;\n  letter-spacing: -1px;\n  margin: 0 8px 0 0;\n  display: block;\n  text-align: center;\n  width: 100%;\n  font-size: 28px;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject14$4 || (_templateObject14$4 = _taggedTemplateLiteral(["\n    display: inline;\n    text-align: left;\n    width: unset;\n    font-size: 32px;\n    margin: 0 4px 0 0;\n  "]))));
var OtherInfo = styled.div(_templateObject15$4 || (_templateObject15$4 = _taggedTemplateLiteral(["\n  display: flex;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  gap: 8px;\n  margin-bottom: 4px;\n  font-size: 18px;\n  justify-content: center;\n\n  ", "\n\n  ", "\n"])), function (_ref5) {
  var employer = _ref5.employer;
  return employer && css(_templateObject16$4 || (_templateObject16$4 = _taggedTemplateLiteral(["\n      text-align: center;\n      display: block;\n    "])));
}, breakpoint("tablet")(_templateObject17$3 || (_templateObject17$3 = _taggedTemplateLiteral(["\n    font-size: 16px;\n    justify-content: left;\n\n      ", "\n\n  "])), function (_ref6) {
  var employer = _ref6.employer;
  return employer && css(_templateObject18$2 || (_templateObject18$2 = _taggedTemplateLiteral(["\n          text-align: left;\n          display: flex;\n        "])));
}));
var DesktopOnly = styled.div(_templateObject19$2 || (_templateObject19$2 = _taggedTemplateLiteral(["\n  display: none;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject20$1 || (_templateObject20$1 = _taggedTemplateLiteral(["\n    display: inline-block;\n  "]))));

var ProfileInfo = function ProfileInfo(_ref) {
  _ref.age;
    var avatarExists = _ref.avatarExists,
    avatarUrl = _ref.avatarUrl,
    obfuscated = _ref.obfuscated,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    smallOnMobile = _ref.smallOnMobile,
    displayName = _ref.displayName,
    placementOrInterviewStatus = _ref.placementOrInterviewStatus,
    employerName = _ref.employerName,
    employerHighlyRated = _ref.employerHighlyRated,
    employerLocation = _ref.employerLocation,
    employerType = _ref.employerType,
    hasCoverImage = _ref.hasCoverImage;
  return /*#__PURE__*/React__default.createElement(Container$8, {
    smallOnMobile: smallOnMobile,
    hasEmployer: !!employerName
  }, !!employerName ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, avatarUrl !== undefined && /*#__PURE__*/React__default.createElement(Avatar$1, {
    avatarExists: avatarExists,
    src: avatarUrl,
    obfuscated: obfuscated,
    alt: employerName ? employerName : "".concat(firstName, " ").concat(lastName),
    smallOnMobile: smallOnMobile,
    firstName: firstName,
    lastName: lastName,
    noBorder: true,
    profile: true
  }), /*#__PURE__*/React__default.createElement(InfoBox, {
    hasCoverImage: hasCoverImage
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NameAndStatus, null, /*#__PURE__*/React__default.createElement(Name, null, employerName), employerHighlyRated && /*#__PURE__*/React__default.createElement(Badge, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faStar
  }), " Rated Highly By Former Staff")), /*#__PURE__*/React__default.createElement(OtherInfo, {
    employer: true
  }, employerLocation && /*#__PURE__*/React__default.createElement("div", null, employerLocation), employerType && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DesktopOnly, null, "\xB7"), /*#__PURE__*/React__default.createElement("div", null, employerType)))))) : /*#__PURE__*/React__default.createElement(TopBanner, null, /*#__PURE__*/React__default.createElement(DisplayName, null, displayName), placementOrInterviewStatus && /*#__PURE__*/React__default.createElement(PlacementOrInterviewStatus, null, placementOrInterviewStatus)));
};
ProfileInfo.propTypes = {
  avatarExists: PropTypes.bool,
  avatarUrl: PropTypes.string,
  obfuscated: PropTypes.bool,
  name: PropTypes.string,
  subtext: PropTypes.string,
  placeItems: PropTypes.string,
  avatarSize: PropTypes.string,
  smallOnMobile: PropTypes.bool,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  handleDownloadBtn: PropTypes.func,
  handleMessagingBtn: PropTypes.func,
  employerHighlyRated: PropTypes.bool
};
ProfileInfo.defaultProps = {
  avatarExists: true,
  avatarUrl: undefined,
  obfuscated: false,
  name: "",
  subtext: "",
  placeItems: undefined,
  avatarSize: "default",
  smallOnMobile: false,
  firstName: "",
  lastName: "",
  employerHighlyRated: false
};

var ParticipantHeader = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var avatar_exists = _ref.avatar_exists,
    avatar_path = _ref.avatar_path,
    obfuscated = _ref.obfuscated,
    display_name = _ref.display_name,
    first_name = _ref.first_name,
    last_name = _ref.last_name,
    age = _ref.age,
    gender_string = _ref.gender_string,
    pronouns_string = _ref.pronouns_string,
    country_name = _ref.country_name,
    placement_or_interview_status = _ref.placement_or_interview_status,
    buttons = _ref.buttons,
    has_visa = _ref.has_visa,
    hasCoverImage = _ref.hasCoverImage;
  return /*#__PURE__*/React__default.createElement(Header$2, {
    ref: ref
  }, /*#__PURE__*/React__default.createElement(ProfileInfo, {
    avatarExists: avatar_exists,
    avatarUrl: avatar_path,
    obfuscated: obfuscated,
    displayName: display_name,
    firstName: first_name,
    lastName: last_name,
    buttons: buttons,
    country: country_name,
    gender: gender_string,
    pronouns: pronouns_string,
    age: age,
    smallOnMobile: true,
    hasVisa: has_visa,
    placementOrInterviewStatus: placement_or_interview_status,
    hasCoverImage: hasCoverImage
  }));
});
ParticipantHeader.propTypes = {
  avatar_exists: PropTypes.bool,
  avatar_path: PropTypes.string,
  obfuscated: PropTypes.bool,
  display_name: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  age: PropTypes.number,
  gender_string: PropTypes.string,
  pronouns_string: PropTypes.string,
  country_name: PropTypes.string,
  placement_or_interview_status: PropTypes.string
};
ParticipantHeader.defaultProps = {
  avatar_exists: true,
  avatar_path: "",
  obfuscated: false,
  display_name: "",
  first_name: "",
  last_name: "",
  age: 0,
  gender_string: "",
  pronouns_string: "",
  country_name: "",
  placement_or_interview_status: ""
};

var _templateObject$e, _templateObject2$b, _templateObject3$9, _templateObject4$8;
var Header$1 = styled.header(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  font-family: ", ", sans-serif;\n  gap: 32px;\n  align-items: center;\n  background-color: ", ";\n  background-size: cover;\n  padding: 88px 24px 32px;\n  display: block;\n  justify-content: center;\n  display: flex;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.body.family;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, breakpoint("tablet")(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n    justify-content: start;\n    padding-left: 60px;\n    padding-right: 60px;\n    ", ";\n  "])), function (_ref3) {
  var theme = _ref3.theme,
    headerHeight = _ref3.headerHeight,
    headerTopPadding = _ref3.headerTopPadding,
    headerBottomPadding = _ref3.headerBottomPadding;
  return css(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n      height: ", "px;\n      padding-top: ", "px;\n      padding-bottom: ", "px;\n      background-color: ", ";\n    "])), headerHeight, headerTopPadding, headerBottomPadding, theme.colors.profile.headerBg);
}), function (props) {
  return props.coverImage && css(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["\n      background-image: url(", ");\n    "])), function (props) {
    return props.coverImage;
  });
});

var EmployerHeader = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var header_image_url = _ref.header_image_url,
    avatar_exists = _ref.avatar_exists,
    avatar_path = _ref.avatar_path,
    name = _ref.name,
    buttons = _ref.buttons,
    location = _ref.location,
    employer_type = _ref.employer_type,
    highly_rated = _ref.highly_rated,
    hasCoverImage = _ref.hasCoverImage,
    headerHeight = _ref.headerHeight,
    headerTopPadding = _ref.headerTopPadding,
    headerBottomPadding = _ref.headerBottomPadding;
  return /*#__PURE__*/React__default.createElement(Header$1, {
    coverImage: hasCoverImage ? header_image_url : null,
    ref: ref,
    headerHeight: headerHeight,
    headerTopPadding: headerTopPadding,
    headerBottomPadding: headerBottomPadding
  }, /*#__PURE__*/React__default.createElement(ProfileInfo, {
    avatarExists: avatar_exists,
    avatarUrl: avatar_path,
    buttons: buttons,
    smallOnMobile: true,
    employerName: name,
    employerLocation: location,
    employerType: employer_type,
    employerHighlyRated: highly_rated,
    hasCoverImage: hasCoverImage,
    displayName: name
  }));
});
EmployerHeader.propTypes = {
  headerHeight: PropTypes.number,
  headerTopPadding: PropTypes.number,
  headerBottomPadding: PropTypes.number,
  avatar_exists: PropTypes.bool,
  avatar_path: PropTypes.string,
  obfuscated: PropTypes.bool,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  age: PropTypes.number,
  gender_string: PropTypes.string,
  country_name: PropTypes.string,
  placement_or_interview_status: PropTypes.string
};
EmployerHeader.defaultProps = {
  headerHeight: 144,
  headerTopPadding: 32,
  headerBottomPadding: 22,
  avatar_exists: true,
  avatar_path: "",
  obfuscated: false,
  first_name: "",
  last_name: "",
  age: 0,
  gender_string: "",
  country_name: "",
  placement_or_interview_status: ""
};

var sections = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Availability: Availability,
  EmployerHeader: EmployerHeader,
  Events: Events,
  Form: Form,
  Interviews: Interviews,
  Languages: Languages,
  LinkedApplication: LinkedApplication,
  Location: Location,
  Note: Note,
  Overview: Overview,
  ParticipantHeader: ParticipantHeader,
  ParticipantSidebar: ParticipantSidebar,
  PhotosAndVideos: PhotosAndVideos,
  Preferences: Preferences,
  References: References,
  RpInterviewSummary: RpInterviewSummary,
  Skills: Skills,
  TravelAndFlights: TravelAndFlights,
  WorkExperience: WorkExperience,
  WorkPermit: WorkPermit
});

var _templateObject$d, _templateObject2$a, _templateObject3$8, _templateObject4$7, _templateObject5$7, _templateObject6$5, _templateObject7$5, _templateObject8$5, _templateObject9$5, _templateObject0$5, _templateObject1$4, _templateObject10$4, _templateObject11$4, _templateObject12$3, _templateObject13$3, _templateObject14$3, _templateObject15$3, _templateObject16$3, _templateObject17$2, _templateObject18$1, _templateObject19$1;
var Container$7 = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  font-family: ", ", sans-serif;\n  position: fixed;\n  z-index: 51;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgb(0, 0, 0);\n  background-color: rgb(0, 0, 0, 0.4);\n  box-sizing: border-box;\n  user-select: none;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  overflow: hidden;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.body.family;
}, breakpoint("desktop")(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n    padding: ", "\n  "])), function (_ref2) {
  var maskVerticalOffset = _ref2.maskVerticalOffset;
  return css(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n      ", "px;\n    "])), maskVerticalOffset);
}), function (props) {
  return !props.show && css(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n      display: none;\n    "])));
}, function (props) {
  return props.show && css(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral(["\n      display: flex;\n    "])));
});
var Box = styled.div(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral(["\n  z-index: 3;\n  cursor: default;\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref3) {
  var smallSize = _ref3.smallSize;
  return smallSize ? css(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteral(["\n          max-width: 960px;\n        "]))) : css(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteral(["\n          max-width: 1240px;\n        "])));
}, function (_ref4) {
  var fullSize = _ref4.fullSize;
  return fullSize && css(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteral(["\n      max-width: 1400px;\n    "])));
}, breakpoint("tablet")(_templateObject0$5 || (_templateObject0$5 = _taggedTemplateLiteral(["\n    border-radius: 1rem;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  "]))));
styled.aside(_templateObject1$4 || (_templateObject1$4 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  overflow-y: auto;\n\n  ", "\n\n  ", "\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
}, function (_ref6) {
  var profile = _ref6.profile;
  return !!profile && css(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteral(["\n      background-color: transparent;\n      display: none;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteral(["\n        display: block;\n      "]))));
}, breakpoint("tablet")(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteral(["\n    width: 224px;\n  "]))));
styled.div(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteral(["\n  overflow-y: auto;\n  user-select: text;\n  flex: 1;\n"])));
var CloseButton = styled(CloseIcon$1)(_templateObject14$3 || (_templateObject14$3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  fill: #fff;\n  z-index: 9999;\n\n  ", "\n"])), function (_ref7) {
  var participantMode = _ref7.participantMode;
  return participantMode && css(_templateObject15$3 || (_templateObject15$3 = _taggedTemplateLiteral(["\n      fill: #999;\n      top: 0.75rem;\n      right: 0.75rem;\n    "])));
});
var MobileOnly = styled.div(_templateObject16$3 || (_templateObject16$3 = _taggedTemplateLiteral(["\n  display: block;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject17$2 || (_templateObject17$2 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var LoadingContainer = styled.div(_templateObject18$1 || (_templateObject18$1 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject19$1 || (_templateObject19$1 = _taggedTemplateLiteral(["\n    > :first-child {\n      margin-right: 0rem;\n    }\n  "]))));

var _this = window;
var scrollTimeout = null;
var SpaContentNav = function SpaContentNav(_ref) {
  var sections = _ref.sections,
    sectionsMap = _ref.sectionsMap,
    disclaimer = _ref.disclaimer,
    noteInfo = _ref.noteInfo,
    employer = _ref.employer,
    openReference = _ref.openReference,
    toggleProfile = _ref.toggleProfile,
    mobileScrollingBoxRef = _ref.mobileScrollingBoxRef,
    mobileHeaderRef = _ref.mobileHeaderRef,
    close = _ref.close,
    portalType = _ref.portalType,
    onRequestInterview = _ref.onRequestInterview,
    onInterview = _ref.onInterview,
    bookInterviewSelectedSkill = _ref.bookInterviewSelectedSkill,
    bookInterviewSection = _ref.bookInterviewSection,
    setSelectedOuter = _ref.setSelectedOuter,
    initialSection = _ref.initialSection,
    avatarUrl = _ref.avatarUrl,
    avatarExists = _ref.avatarExists,
    obfuscated = _ref.obfuscated,
    employerName = _ref.employerName,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    buttonValues = _ref.buttonValues,
    activityLogs = _ref.activityLogs,
    applicationContainerId = _ref.applicationContainerId,
    addComment = _ref.addComment,
    removeComment = _ref.removeComment,
    headerComponent = _ref.headerComponent;
  var contentHeightOffset = applicationContainerId ? 132 : 252;
  var sidebarHeightOffset = applicationContainerId ? 350 : 252;
  var _useState = useState(sections[0].item_name),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = useState(sections[0].item_friendly_name),
    _useState4 = _slicedToArray(_useState3, 2),
    currentSectionTitle = _useState4[0],
    setCurrentSectionTitle = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    sectionTitleFixed = _useState6[0],
    setSectionTitleFixed = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    navItemClicked = _useState8[0],
    setNavItemClicked = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    jumpNavOpen = _useState0[0],
    setJumpNavOpen = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    moreOptionsOpen = _useState10[0],
    setMoreOptionsOpen = _useState10[1];
  var contentBoxRef = useRef();
  var itemsRef = useRef(null);
  var scrollingOffset = 10;
  var mobileScrollingOffset = 320;
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    comment = _useState12[0],
    setComment = _useState12[1];

  // Ref for MoreOptions (applies to both desktop and mobile)
  var moreOptionsRef = useRef(null);
  // Ref for DropdownMenu (applies to both desktop and mobile)
  var dropdownMenuRef = useRef(null);
  var activityLogRef = useRef(null);
  var scrollToItem = function scrollToItem(itemName) {
    var mobileScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var map = getMap();
    var node = map.get(itemName);
    if (!node && itemName == "roles") {
      node = document.querySelector(".fieldset_employer_camp_roles_available_profile_fs, .fieldset_employer_resort_roles_available_profile_fs");
    }
    if (!node) return;
    var top;
    var specialOffset = itemName == "roles" ? 36 : 0;
    if (mobileScroll) {
      top = node.offsetTop + mobileScrollingOffset - specialOffset;
      mobileScrollingBoxRef.current.scrollTo({
        top: top,
        behavior: "smooth"
      });
    } else {
      top = node.offsetTop + scrollingOffset - specialOffset;
      contentBoxRef.current.scrollTo({
        top: top,
        behavior: "smooth"
      });
    }
  };
  var setSelectedContent = function setSelectedContent(itemName) {
    var clicked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var callOuterCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var mobileScroll = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (clicked) {
      setNavItemClicked(true);
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        setNavItemClicked(false);
      }, 1000);
      scrollToItem(itemName, mobileScroll);
    } else {
      setSelected(itemName);
      if (callOuterCallback) setSelectedOuter(itemName);
      setCurrentSectionTitle(sections.find(function (x) {
        return x.item_name === itemName;
      }).item_friendly_name);
    }
  };
  var getMap = function getMap() {
    if (!itemsRef.current) itemsRef.current = new Map();
    return itemsRef.current;
  };
  useEffect(function () {
    var _mobileScrollingBoxRe2;
    if (!(mobileScrollingBoxRef !== null && mobileScrollingBoxRef !== void 0 && mobileScrollingBoxRef.current)) return;
    var watchScroll = function watchScroll() {
      var _mobileHeaderRef$curr, _mobileScrollingBoxRe;
      var headerHeight = (_mobileHeaderRef$curr = mobileHeaderRef.current) === null || _mobileHeaderRef$curr === void 0 ? void 0 : _mobileHeaderRef$curr.clientHeight;
      var top = (_mobileScrollingBoxRe = mobileScrollingBoxRef.current) === null || _mobileScrollingBoxRe === void 0 ? void 0 : _mobileScrollingBoxRe.scrollTop;
      setSectionTitleFixed(top > headerHeight);
    };
    (_mobileScrollingBoxRe2 = mobileScrollingBoxRef.current) === null || _mobileScrollingBoxRe2 === void 0 || _mobileScrollingBoxRe2.addEventListener("scroll", watchScroll);
    return function () {
      var _mobileScrollingBoxRe3;
      return (_mobileScrollingBoxRe3 = mobileScrollingBoxRef.current) === null || _mobileScrollingBoxRe3 === void 0 ? void 0 : _mobileScrollingBoxRe3.removeEventListener("scroll", watchScroll);
    };
  }, [mobileScrollingBoxRef, mobileHeaderRef]);
  useEffect(function () {
    if (initialSection) setSelectedContent(initialSection);
  }, [initialSection]);
  useEffect(function () {
    var _contentBoxRef$curren, _mobileScrollingBoxRe4;
    var handleScroll = function handleScroll(ref) {
      if (!ref) return;
      if (navItemClicked) return;
      var isVisible = function isVisible(ele, container) {
        var eleTop = ele.offsetTop;
        var eleBottom = eleTop + ele.clientHeight;
        var containerTop = (container === null || container === void 0 ? void 0 : container.scrollTop) || 0;
        var containerBottom = containerTop + ((container === null || container === void 0 ? void 0 : container.clientHeight) || 0);

        // The element is fully visible in the container
        return eleTop >= containerTop && eleBottom <= containerBottom ||
        // Some part of the element is visible in the container
        eleTop < containerTop && containerTop < eleBottom || eleTop < containerBottom && containerBottom < eleBottom;
      };
      var isContained = function isContained(ele, container) {
        var eleTop = ele.offsetTop - 90; // Adjust threshold as needed
        var eleBottom = eleTop + ele.clientHeight;
        var scrollPosition = (container === null || container === void 0 ? void 0 : container.scrollTop) || 0;
        return scrollPosition >= eleTop && scrollPosition < eleBottom;
      };
      var reversedSections = sections.slice().reverse();
      var foundSection = false;
      var _iterator = _createForOfIteratorHelper(reversedSections),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var section = _step.value;
          var sectionElement = document.getElementById("section_".concat(section.item_name));
          if (sectionElement) {
            // If last section, check for any intersection
            var isLastSection = reversedSections[0] === section;
            if (isLastSection && isVisible(sectionElement, ref.current)) {
              setSelectedContent(section.item_name, false, true, false);
              foundSection = true;
              break;
            } else if (isContained(sectionElement, ref.current)) {
              setSelectedContent(section.item_name, false, true, false);
              foundSection = true;
              break;
            }
          }
        }

        // Check if Activity Log is in view if not found in sections
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!foundSection && activityLogRef.current && isVisible(activityLogRef.current, ref.current)) {
        setSelected("activity_log");
        setCurrentSectionTitle("Activity Log");
        setSelectedOuter("activity_log");
      }
    };
    (_contentBoxRef$curren = contentBoxRef.current) === null || _contentBoxRef$curren === void 0 || _contentBoxRef$curren.addEventListener("scroll", handleScroll.bind(_this, contentBoxRef));
    (_mobileScrollingBoxRe4 = mobileScrollingBoxRef.current) === null || _mobileScrollingBoxRe4 === void 0 || _mobileScrollingBoxRe4.addEventListener("scroll", handleScroll.bind(_this, mobileScrollingBoxRef));
    return function () {
      var _contentBoxRef$curren2, _mobileScrollingBoxRe5;
      (_contentBoxRef$curren2 = contentBoxRef.current) === null || _contentBoxRef$curren2 === void 0 || _contentBoxRef$curren2.removeEventListener("scroll", handleScroll.bind(_this, contentBoxRef));
      (_mobileScrollingBoxRe5 = mobileScrollingBoxRef.current) === null || _mobileScrollingBoxRe5 === void 0 || _mobileScrollingBoxRe5.removeEventListener("scroll", handleScroll.bind(_this, mobileScrollingBoxRef));
    };
  }, [sections, contentBoxRef, navItemClicked, mobileScrollingBoxRef]);
  useEffect(function () {
    if (!moreOptionsOpen) return;
    function handleClickOutside(event) {
      if (moreOptionsRef.current && !moreOptionsRef.current.contains(event.target) && (!dropdownMenuRef.current || !dropdownMenuRef.current.contains(event.target))) {
        setMoreOptionsOpen(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return function () {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [moreOptionsOpen]);

  // Helper to select the main button and the rest for MoreOptions
  var getMainAndMoreOptionsButtons = function getMainAndMoreOptionsButtons(buttonValues) {
    if (!buttonValues || buttonValues.length === 0) return {
      mainButton: null,
      moreOptionsButtons: []
    };
    var mainButton = null;
    if (!buttonValues[0].disabled) {
      mainButton = buttonValues[0];
    } else {
      // If the first button is disabled, search for an enabled button whose label contains 'download' (case-insensitive)
      mainButton = buttonValues.find(function (btn) {
        return typeof btn.label === "string" && btn.label.toLowerCase().includes("download") && !btn.disabled;
      });
      // Otherwise use message button
      if (!mainButton) {
        mainButton = buttonValues.find(function (btn) {
          return typeof btn.label === "string" && btn.label.toLowerCase().includes("message") && !btn.disabled;
        });
      }
      // Otherwise use the next enabled button
      if (!mainButton) {
        mainButton = buttonValues.slice(1).find(function (btn) {
          return !btn.disabled;
        });
      }
    }
    if (!mainButton) return {
      mainButton: null,
      moreOptionsButtons: []
    };
    var moreOptionsButtons = buttonValues.filter(function (btn) {
      return btn !== mainButton;
    });
    return {
      mainButton: mainButton,
      moreOptionsButtons: moreOptionsButtons
    };
  };

  // Handling activity log on mobile nav
  var isMobile = function isMobile() {
    return window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
  };
  var navSections = isMobile() ? [].concat(_toConsumableArray(sections.map(function (x) {
    return {
      name: x.item_name,
      label: x.item_friendly_name
    };
  })), _toConsumableArray(addComment !== undefined ? [{
    name: "activity_log",
    label: "Activity Log"
  }] : [])) : sections.map(function (x) {
    return {
      name: x.item_name,
      label: x.item_friendly_name
    };
  });
  var jumpNavSections = isMobile() ? [].concat(_toConsumableArray(sections.map(function (x) {
    return {
      name: x.item_name,
      label: x.item_friendly_name
    };
  })), _toConsumableArray(addComment !== undefined ? [{
    name: "activity_log",
    label: "Activity Log"
  }] : [])) : sections.map(function (x) {
    return {
      name: x.item_name,
      label: x.item_friendly_name
    };
  });
  var handleNavSelect = function handleNavSelect(itemName) {
    if (itemName === "activity_log") {
      if (activityLogRef.current) {
        activityLogRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
      setSelected(itemName);
      setCurrentSectionTitle("Activity Log");
      setSelectedOuter(itemName);
      return;
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    setSelectedContent.apply(void 0, [itemName].concat(args));
  };
  return /*#__PURE__*/React__default.createElement(Main$1, {
    participantMode: !!applicationContainerId
  }, applicationContainerId ? /*#__PURE__*/React__default.createElement(Sidebar, null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, avatarUrl !== undefined && /*#__PURE__*/React__default.createElement(Avatar$1, {
    avatarExists: avatarExists,
    src: avatarUrl,
    obfuscated: obfuscated,
    alt: employerName ? employerName : "".concat(firstName, " ").concat(lastName),
    smallOnMobile: true,
    firstName: firstName,
    lastName: lastName,
    noBorder: true,
    profile: true
  })), headerComponent && /*#__PURE__*/React__default.createElement(MobileOnly, null, headerComponent), /*#__PURE__*/React__default.createElement(DesktopOnly, null, /*#__PURE__*/React__default.createElement(SidebarActions, null, /*#__PURE__*/React__default.createElement(Buttons, null, function () {
    var _getMainAndMoreOption = getMainAndMoreOptionsButtons(buttonValues),
      mainButton = _getMainAndMoreOption.mainButton;
    if (!mainButton) return null;
    return /*#__PURE__*/React__default.createElement(Button$5, {
      onClick: mainButton.onClick,
      disabled: mainButton.disabled,
      variant: "primary",
      size: mainButton.size,
      outlined: mainButton.outlined,
      fullwidth: true,
      fullHeight: true
    }, mainButton.label);
  }()), function () {
    var _getMainAndMoreOption2 = getMainAndMoreOptionsButtons(buttonValues),
      moreOptionsButtons = _getMainAndMoreOption2.moreOptionsButtons;
    if (moreOptionsButtons.length === 0) return null;
    return /*#__PURE__*/React__default.createElement(MoreOptions, {
      ref: moreOptionsRef,
      onClick: function onClick(e) {
        e.stopPropagation();
        setMoreOptionsOpen(function (open) {
          return !open;
        });
      }
    }, /*#__PURE__*/React__default.createElement(MoreOptionsIcon, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faEllipsis
    })), moreOptionsOpen && /*#__PURE__*/React__default.createElement(DropdownMenu, {
      ref: dropdownMenuRef,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, moreOptionsButtons.map(function (btn, idx) {
      return /*#__PURE__*/React__default.createElement(DropdownItem, {
        key: idx,
        type: "button",
        onClick: function onClick(e) {
          btn.onClick(e);
          setMoreOptionsOpen(false);
        },
        disabled: btn.disabled,
        variant: btn.variant
      }, btn.label);
    })));
  }())), /*#__PURE__*/React__default.createElement(Aside, {
    profile: true,
    contentHeightOffset: sidebarHeightOffset,
    participantMode: true
  }, /*#__PURE__*/React__default.createElement(Nav, {
    profile: true,
    items: navSections,
    selected: selected,
    setSelected: handleNavSelect
  }))) : /*#__PURE__*/React__default.createElement(Aside, {
    profile: true,
    contentHeightOffset: contentHeightOffset
  }, /*#__PURE__*/React__default.createElement(Nav, {
    profile: true,
    items: navSections,
    selected: selected,
    setSelected: handleNavSelect
  })), currentSectionTitle && /*#__PURE__*/React__default.createElement(CurrentSectionTitle, {
    fixed: sectionTitleFixed
  }, /*#__PURE__*/React__default.createElement(CurrentSectionHighlight, null, /*#__PURE__*/React__default.createElement(CurrentSectionHighlightText, {
    onClick: function onClick() {
      return setJumpNavOpen(!jumpNavOpen);
    }
  }, /*#__PURE__*/React__default.createElement(CurrentSectionHeading, null, currentSectionTitle), /*#__PURE__*/React__default.createElement(CurrentSectionChevron, {
    direction: jumpNavOpen ? "up" : "down"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faChevronDown$2
  }))), /*#__PURE__*/React__default.createElement(CurrentSectionHighlightBorder, null), jumpNavOpen && /*#__PURE__*/React__default.createElement(JumpNav, null, jumpNavSections.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(JumpNavButton, {
      key: index,
      selected: selected === item.name,
      onClick: function onClick() {
        if (item.name === "activity_log") {
          if (activityLogRef.current) {
            activityLogRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
          setSelected(item.name);
          setCurrentSectionTitle("Activity Log");
          setSelectedOuter(item.name);
          setJumpNavOpen(false);
          return;
        }
        setSelectedContent(item.name, true, false, true);
        setJumpNavOpen(false);
      }
    }, item.label);
  }))), sectionTitleFixed && /*#__PURE__*/React__default.createElement(CloseButton$2, {
    size: "large",
    variant: "content",
    onClick: close,
    participantMode: !!applicationContainerId
  })), /*#__PURE__*/React__default.createElement(Content$6, {
    ref: contentBoxRef,
    contentHeightOffset: contentHeightOffset
  }, disclaimer && /*#__PURE__*/React__default.createElement(Card$1, {
    variant: "warning",
    marginless: true,
    style: {
      marginTop: "2rem"
    }
  }, disclaimer), /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "0",
    style: {
      justifyContent: "center"
    }
  }, sections && sections.map(function (section, i) {
    var key = section.item_type.toLowerCase().includes("form") ? "form" : section.item_name;
    var Section;
    if (key == "form" && !section.fieldsets) {
      Section = null;
    } else {
      Section = sectionsMap[key];
    }
    var skipBorder = i === sections.length - 1;
    var sectionRef = /*#__PURE__*/React__default.createRef();
    return Section !== null ? /*#__PURE__*/React__default.createElement(ContentWrapper, {
      key: "content_wrapper_".concat(section.item_name),
      skipBorder: skipBorder,
      id: "section_".concat(section.item_name),
      ref: function ref(node) {
        var mapper = getMap();
        if (node) {
          mapper.set(section.item_name, node);
        } else {
          mapper["delete"](section.item_name);
        }
      },
      participantMode: !!applicationContainerId
    }, /*#__PURE__*/React__default.createElement(ContentSection, {
      ref: sectionRef
    }, i === 0 && noteInfo && noteInfo.notes && /*#__PURE__*/React__default.createElement(Note, noteInfo), section.item_introduction && section.item_introduction.length && /*#__PURE__*/React__default.createElement(ContentMessage, null, section.item_introduction), /*#__PURE__*/React__default.createElement(Section, _extends({
      portalType: portalType,
      employer: employer
    }, section, {
      openReference: openReference,
      toggleProfile: toggleProfile,
      onRequestInterview: onRequestInterview,
      onInterview: onInterview,
      bookInterviewSelectedSkill: bookInterviewSelectedSkill,
      bookInterviewSection: bookInterviewSection,
      initialSection: initialSection
    })))) : null;
  }))), addComment && /*#__PURE__*/React__default.createElement(ActivityLogContainer, {
    ref: activityLogRef
  }, /*#__PURE__*/React__default.createElement(H1, null, "Activity Log ", activityLogs && activityLogs.length > 0 ? /*#__PURE__*/React__default.createElement(Counter$5, null, activityLogs.length) : ""), /*#__PURE__*/React__default.createElement(ActivityLogInputContainer, {
    mobileOnly: true
  }, /*#__PURE__*/React__default.createElement(WhiteBgActivityLogTextArea, {
    name: "comment",
    value: comment,
    placeholder: "Add a comment",
    handleInputChange: function handleInputChange(name, value) {
      return setComment(value);
    },
    showValidation: false,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" && !e.shiftKey && comment.trim()) {
        e.preventDefault();
        addComment(comment, applicationContainerId);
        setComment("");
      }
    },
    rows: 1
  }), /*#__PURE__*/React__default.createElement(StyledButton$1, {
    onClick: function onClick() {
      addComment(comment, applicationContainerId);
      setComment("");
    },
    disabled: !comment.trim()
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faPaperPlaneTop
  }))), /*#__PURE__*/React__default.createElement(ActivityLogs, null, activityLogs && activityLogs.length > 0 ? activityLogs.map(function (log, idx) {
    return /*#__PURE__*/React__default.createElement(ActivityLog, {
      key: idx
    }, /*#__PURE__*/React__default.createElement(ActivityLogAvatar, {
      src: log.logged_by_user_avatar,
      alt: "avatar"
    }), /*#__PURE__*/React__default.createElement(ActivityLogContent, null, /*#__PURE__*/React__default.createElement(ActivityLogUserAction, null, log.content), /*#__PURE__*/React__default.createElement(ActivityLogTimestamp, null, log.created_at, " ", removeComment && log.content.includes("commented:") && /*#__PURE__*/React__default.createElement(StyledDeleteButton, {
      onClick: function onClick() {
        return removeComment(log, idx);
      },
      title: "Delete comment"
    }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faTrash
    })))));
  }) : /*#__PURE__*/React__default.createElement(ActivityLogEmptyState, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faList,
    style: {
      fontSize: "32px",
      marginBottom: "12px",
      color: "#d3d3d3"
    }
  }), /*#__PURE__*/React__default.createElement("div", null, "No activity yet"))), /*#__PURE__*/React__default.createElement(ActivityLogInputContainer, {
    desktopOnly: true
  }, /*#__PURE__*/React__default.createElement(WhiteBgActivityLogTextArea, {
    name: "comment",
    value: comment,
    placeholder: "Add a comment",
    handleInputChange: function handleInputChange(name, value) {
      return setComment(value);
    },
    showValidation: false,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" && !e.shiftKey && comment.trim()) {
        e.preventDefault();
        addComment(comment, applicationContainerId);
        setComment("");
      }
    },
    rows: 1
  }), /*#__PURE__*/React__default.createElement(StyledButton$1, {
    onClick: function onClick() {
      addComment(comment, applicationContainerId);
      setComment("");
    },
    disabled: !comment.trim()
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faPaperPlaneTop
  })))), function () {
    var _getMainAndMoreOption3 = getMainAndMoreOptionsButtons(buttonValues),
      mainButton = _getMainAndMoreOption3.mainButton,
      moreOptionsButtons = _getMainAndMoreOption3.moreOptionsButtons;
    if (!mainButton) return null;
    return /*#__PURE__*/React__default.createElement(MobileOnly, null, /*#__PURE__*/React__default.createElement(StickyMobileFooter, null, moreOptionsButtons.length > 0 && /*#__PURE__*/React__default.createElement(MoreOptions, {
      ref: moreOptionsRef,
      onClick: function onClick(e) {
        e.stopPropagation();
        setMoreOptionsOpen(function (open) {
          return !open;
        });
      }
    }, /*#__PURE__*/React__default.createElement(MoreOptionsIcon, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faEllipsis
    })), moreOptionsOpen && /*#__PURE__*/React__default.createElement(DropdownMenu, {
      ref: dropdownMenuRef,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, moreOptionsButtons.map(function (btn, idx) {
      return /*#__PURE__*/React__default.createElement(DropdownItem, {
        key: idx,
        type: "button",
        onClick: function onClick(e) {
          btn.onClick(e);
          setMoreOptionsOpen(false);
        },
        disabled: btn.disabled,
        variant: btn.variant
      }, btn.label);
    }))), /*#__PURE__*/React__default.createElement(StickyFooterButton, {
      onClick: mainButton.onClick,
      disabled: mainButton.disabled,
      variant: "primary",
      size: mainButton.size,
      outlined: mainButton.outlined,
      fullwidth: true
    }, mainButton.label)));
  }());
};
SpaContentNav.propTypes = {
  sections: PropTypes.array.isRequired,
  sectionsMap: PropTypes.object.isRequired,
  portalType: PropTypes.string.isRequired,
  disclaimer: PropTypes.string,
  employer: PropTypes.object,
  openReference: PropTypes.func,
  toggleProfile: PropTypes.func,
  mobileScrollingBoxRef: PropTypes.object,
  mobileHeaderRef: PropTypes.object,
  close: PropTypes.func,
  bookInterviewSelectedSkill: PropTypes.string,
  bookInterviewSection: PropTypes.element,
  setSelectedOuter: PropTypes.func,
  contentHeightOffset: PropTypes.number,
  headerComponent: PropTypes.node,
  removeComment: PropTypes.func
};
SpaContentNav.defaultProps = {
  sections: [],
  sectionsMap: {},
  portalType: "",
  disclaimer: "",
  employer: {},
  openReference: null,
  toggleProfile: function toggleProfile() {},
  mobileScrollingBoxRef: {},
  mobileHeaderRef: {},
  close: function close() {},
  bookInterviewSelectedSkill: null,
  bookInterviewSection: null,
  setSelectedOuter: function setSelectedOuter() {},
  contentHeightOffset: 252,
  headerComponent: null,
  removeComment: null
};

var sectionsMap = {
  form: Form,
  interviews: Interviews,
  overview: Overview,
  preferences: Preferences,
  references: References,
  skill: Skills,
  flight: TravelAndFlights,
  work_experience: WorkExperience,
  work_permit: WorkPermit,
  photos_and_videos: PhotosAndVideos,
  location: Location,
  rp_interview_summary: RpInterviewSummary,
  linked_application: LinkedApplication
};
var headerMap = {
  participant: ParticipantHeader,
  employer: EmployerHeader
};
var Profile = function Profile(_ref) {
  var show = _ref.show,
    loading = _ref.loading,
    disclaimer = _ref.disclaimer,
    noteInfo = _ref.noteInfo,
    employer = _ref.employer,
    sections = _ref.sections,
    toggle = _ref.toggle,
    profileData = _ref.profileData,
    openReference = _ref.openReference,
    toggleProfile = _ref.toggleProfile,
    onRequestInterview = _ref.onRequestInterview,
    onInterview = _ref.onInterview,
    bookInterviewSelectedSkill = _ref.bookInterviewSelectedSkill,
    bookInterviewSection = _ref.bookInterviewSection,
    setSelected = _ref.setSelected,
    initialSection = _ref.initialSection,
    addComment = _ref.addComment,
    removeComment = _ref.removeComment,
    activityLogs = _ref.activityLogs;
  var displaySmallSize = addComment === undefined && profileData.key === "participant";
  var displayFullSize = addComment !== undefined;
  var maskVerticalOffset = 27;
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Container$7, {
      show: true,
      maskVerticalOffset: maskVerticalOffset
    }, /*#__PURE__*/React__default.createElement(Box, {
      fullSize: displayFullSize,
      smallSize: displaySmallSize
    }, Header && /*#__PURE__*/React__default.createElement(Header, null), /*#__PURE__*/React__default.createElement(LoadingContainer, null, /*#__PURE__*/React__default.createElement(LoadingSpinner, {
      variant: "primary"
    }))));
  }
  var Header = headerMap[profileData.key];
  var headerRef = /*#__PURE__*/React__default.createRef();
  var boxRef = /*#__PURE__*/React__default.createRef();
  var hasCoverImage = false;
  var participantMode = profileData.data.application_container_id !== undefined;
  return /*#__PURE__*/React__default.createElement(Container$7, {
    show: show,
    onClick: toggle,
    maskVerticalOffset: maskVerticalOffset
  }, /*#__PURE__*/React__default.createElement(Box, {
    ref: boxRef,
    scrollable: true,
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    fullSize: displayFullSize,
    smallSize: displaySmallSize
  }, /*#__PURE__*/React__default.createElement(DesktopOnly, null, /*#__PURE__*/React__default.createElement(Header, _extends({}, profileData.data, {
    hasCoverImage: hasCoverImage,
    ref: headerRef
  }))), /*#__PURE__*/React__default.createElement(SpaContentNav, {
    sections: sections,
    sectionsMap: sectionsMap,
    disclaimer: disclaimer,
    noteInfo: noteInfo,
    employer: employer,
    openReference: openReference,
    toggleProfile: toggleProfile,
    mobileScrollingBoxRef: boxRef,
    mobileHeaderRef: headerRef,
    close: toggle,
    portalType: profileData.portalType,
    onRequestInterview: onRequestInterview,
    onInterview: onInterview,
    bookInterviewSelectedSkill: bookInterviewSelectedSkill,
    bookInterviewSection: bookInterviewSection,
    initialSection: initialSection,
    setSelectedOuter: setSelected,
    avatarUrl: profileData.data.avatar_path,
    avatarExists: profileData.data.avatar_exists,
    obfuscated: profileData.data.obfuscated,
    employerName: profileData.data.employer_name,
    firstName: profileData.data.first_name,
    lastName: profileData.data.last_name,
    buttonValues: profileData.data.buttonValues,
    applicationContainerId: profileData.data.application_container_id,
    addComment: addComment,
    removeComment: removeComment,
    activityLogs: activityLogs,
    headerComponent: /*#__PURE__*/React__default.createElement(Header, _extends({}, profileData.data, {
      hasCoverImage: hasCoverImage,
      ref: headerRef
    }))
  }), /*#__PURE__*/React__default.createElement(CloseButton, {
    size: "large",
    body: hasCoverImage,
    onClick: toggle,
    participantMode: participantMode
  })));
};
Profile.propTypes = {
  show: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  disclaimer: PropTypes.node,
  noteInfo: PropTypes.object,
  toggle: PropTypes.func.isRequired,
  openReference: PropTypes.func,
  sections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    content: PropTypes.node.isRequired
  })).isRequired,
  profileData: PropTypes.shape({
    key: PropTypes.oneOf(["participant", "employer"]).isRequired,
    data: PropTypes.object.isRequired
  }).isRequired,
  employer: PropTypes.object,
  bookInterviewSelectedSkill: PropTypes.string,
  bookInterviewSection: PropTypes.element,
  onRequestInterview: PropTypes.func,
  onInterview: PropTypes.func,
  setSelected: PropTypes.func,
  initialSection: PropTypes.string
};
Profile.defaultProps = {
  show: false,
  loading: false,
  toggle: undefined,
  openReference: undefined,
  toggleProfile: undefined,
  sections: [],
  sidebar: {
    key: "",
    data: {}
  },
  employer: {},
  bookInterviewSection: null,
  onRequestInterview: function onRequestInterview() {},
  onInterview: function onInterview() {},
  setSelected: function setSelected() {},
  bookInterviewSelectedSkill: "",
  initialSection: ""
};

var _templateObject$c, _templateObject2$9, _templateObject3$7, _templateObject4$6, _templateObject5$6;
var Container$6 = styled.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  display: flex;\n  width: 120px;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n"])));
var Metric = styled.div(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: baseline;\n  gap: 8px;\n"])));
var Title$2 = styled.div(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral([""])));
var StyledP = styled(P$4)(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n  font-size: 14px;\n"])));
var StatLink = styled(Link$2)(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});

var RatingStat = function RatingStat(_ref) {
  var rating = _ref.rating,
    outOf = _ref.outOf,
    title = _ref.title,
    link = _ref.link;
  return /*#__PURE__*/React__default.createElement(Container$6, null, /*#__PURE__*/React__default.createElement(Metric, null, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "secondary",
    marginless: true,
    bold: true,
    size: "large"
  }, !link && rating, link && /*#__PURE__*/React__default.createElement(StatLink, {
    to: link
  }, rating)), outOf && /*#__PURE__*/React__default.createElement(P$4, {
    variant: "secondary",
    marginless: true
  }, "/", outOf)), /*#__PURE__*/React__default.createElement(Title$2, null, title && /*#__PURE__*/React__default.createElement(StyledP, {
    variant: "secondary",
    marginless: true,
    align: "center",
    size: "large"
  }, title)));
};
RatingStat.propTypes = {
  rating: PropTypes.number.isRequired,
  outOf: PropTypes.number.isRequired,
  title: PropTypes.string
};
RatingStat.defaultProps = {
  rating: 0,
  outOf: 10,
  title: null
};

var _templateObject$b, _templateObject2$8, _templateObject3$6;
var GroupContainer = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 12px 26px;\n  align-items: flex-end;\n  gap: 50px;\n  background-color: #f6f6f6;\n  border-radius: 1rem;\n  width: fit-content;\n  margin-top: 16px;\n\n  ", "\n\n  > div {\n    position: relative;\n\n    &:before {\n      position: absolute;\n      left: -25px;\n      top: 0;\n      bottom: 0;\n      height: 100%;\n      content: \"\";\n      width: 1px;\n      background-color: #ddd;\n\n      ", "\n    }\n\n    &:first-child {\n      &:before {\n        display: none;\n      }\n    }\n  }\n"])), breakpoint("tablet")(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n      gap: 72px;\n      padding: 16px 36px;\n    "]))), breakpoint("tablet")(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n          left: -36px;\n        "]))));

var RatingStatGroup = function RatingStatGroup(_ref) {
  var ratings = _ref.ratings;
  return /*#__PURE__*/React__default.createElement(GroupContainer, {
    ratings: ratings.length
  }, ratings.map(function (rating) {
    return /*#__PURE__*/React__default.createElement(RatingStat, rating);
  }));
};
RatingStatGroup.propTypes = {
  ratings: PropTypes.arrayOf(PropTypes.shape({
    rating: PropTypes.number.isRequired,
    outOf: PropTypes.number.isRequired,
    title: PropTypes.string
  }))
};
RatingStatGroup.defaultProps = {
  ratings: [{
    rating: 0,
    outOf: 10,
    title: null
  }, {
    rating: 0,
    outOf: 10,
    title: null
  }]
};

var _templateObject$a, _templateObject2$7;
var SignatureWrapper = styled.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.simpleForm) && css(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n      border: 1px solid #e6e6e6;\n      border-radius: 8px;\n    "])));
});

var SignatureField = function SignatureField(_ref) {
  var handleInputChange = _ref.handleInputChange,
    name = _ref.name,
    initialSignature = _ref.initialSignature,
    disabled = _ref.disabled,
    simpleForm = _ref.simpleForm;
  var signatureFieldRef = useRef(null);
  var resetSignature = function resetSignature(event) {
    var _signatureFieldRef$cu;
    event.preventDefault();
    signatureFieldRef === null || signatureFieldRef === void 0 || (_signatureFieldRef$cu = signatureFieldRef.current) === null || _signatureFieldRef$cu === void 0 || _signatureFieldRef$cu.signaturePad.clear();
    if (handleInputChange !== undefined) handleInputChange(name, "");
  };
  useEffect(function () {
    var _signatureFieldRef$cu2, _signatureFieldRef$cu4;
    var onEndStroke = function onEndStroke() {
      if (handleInputChange !== undefined) handleInputChange(name, signatureFieldRef.current.signaturePad.toDataURL());
    };
    if (signatureFieldRef !== null && initialSignature !== null && initialSignature.length > 0 && !!(signatureFieldRef !== null && signatureFieldRef !== void 0 && (_signatureFieldRef$cu2 = signatureFieldRef.current) !== null && _signatureFieldRef$cu2 !== void 0 && _signatureFieldRef$cu2.signaturePad)) {
      var _signatureFieldRef$cu3;
      signatureFieldRef === null || signatureFieldRef === void 0 || (_signatureFieldRef$cu3 = signatureFieldRef.current) === null || _signatureFieldRef$cu3 === void 0 || _signatureFieldRef$cu3.signaturePad.fromDataURL(initialSignature);
    }
    if (disabled) signatureFieldRef === null || signatureFieldRef === void 0 || (_signatureFieldRef$cu4 = signatureFieldRef.current) === null || _signatureFieldRef$cu4 === void 0 || _signatureFieldRef$cu4.signaturePad.off();
    if (!!signatureFieldRef.current && !!signatureFieldRef.current.signaturePad) {
      var current = signatureFieldRef.current;
      current.signaturePad.addEventListener("endStroke", onEndStroke, false);
      return function cleanup() {
        current.signaturePad.removeEventListener("endStroke", onEndStroke);
      };
    }
  }, [signatureFieldRef, initialSignature, disabled, handleInputChange, name]);
  var options = {
    backgroundColor: "white",
    borderColor: "grey"
  };
  var canvasProps = {
    style: {
      borderRadius: "0.5rem"
    }
  };
  var button = /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button$5, {
    variant: "secondary",
    onClick: resetSignature
  }, "Reset"));
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1rem"
  }, /*#__PURE__*/React__default.createElement(SignatureWrapper, {
    simpleForm: simpleForm
  }, /*#__PURE__*/React__default.createElement(SignaturePad, {
    ref: signatureFieldRef,
    options: options,
    height: "100",
    redrawOnResize: true,
    canvasProps: canvasProps
  })), !disabled && button);
};
SignatureField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  initialSignature: PropTypes.string
};
SignatureField.defaultProps = {
  handleInputChange: undefined,
  name: "",
  initialSignature: "",
  disabled: false
};

var _templateObject$9, _templateObject2$6, _templateObject3$5, _templateObject4$5, _templateObject5$5, _templateObject6$4, _templateObject7$4, _templateObject8$4, _templateObject9$4, _templateObject0$4, _templateObject1$3, _templateObject10$3, _templateObject11$3, _templateObject12$2, _templateObject13$2, _templateObject14$2, _templateObject15$2, _templateObject16$2;
var GridContainer = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  display: none;\n  text-align: center;\n  align-items: center;\n  gap: 18px;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
  return !props.homePage && css(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n      opacity: 0.4;\n      transition: opacity 0.2s ease-in-out;\n\n      a {\n        color: #aaaaaa;\n      }\n\n      &:hover {\n        opacity: 1;\n\n        a {\n          color: ", ";\n        }\n      }\n    "])), function (props) {
    return props.theme.colors.primary;
  });
}, function (props) {
  return !!props.mobileOnly && css(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n      display: flex;\n      justify-content: center;\n    "])));
}, breakpoint("desktop")(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n    gap: 0;\n    grid-template-columns: repeat(6, 105px);\n    width: 100%;\n\n    ", "\n    ", "\n  "])), function (props) {
  return !!props.mobileOnly && css(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n        display: none;\n      "])));
}, function (props) {
  return !!props.desktopOnly && css(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["\n        display: grid;\n      "])));
}));
var Grid = styled.div(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral(["\n  position: relative;\n\n  &:nth-child(n + 2)::after {\n    ", "\n  }\n\n  &:nth-child(1)::after {\n    ", "\n  }\n\n  ", "\n\n  ", "\n"])), breakpoint("desktop")(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral(["\n      content: \"\";\n      height: 1.75rem;\n      width: 1px;\n\n      position: absolute;\n      left: 0;\n      top: 0.5rem;\n\n      background-color: #dddddd;\n  "]))), breakpoint("desktop")(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteral(["\n      display: none;\n    "]))), function (props) {
  return props.desktopOnly && css(_templateObject0$4 || (_templateObject0$4 = _taggedTemplateLiteral(["\n      display: none;\n    "])));
}, function (props) {
  return props.desktopOnly && breakpoint("desktop")(_templateObject1$3 || (_templateObject1$3 = _taggedTemplateLiteral(["\n    display: block;\n  "])));
});
var CounterLink = styled(Link$2)(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 500;\n  font-size: 1rem;\n  margin: 0 0 5px 0;\n  text-decoration: none;\n\n  ", "\n"])), function (props) {
  return props.theme.colors.primary;
}, breakpoint("desktop")(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteral(["\n    font-size: 1.125rem;\n    "]))));
var Counter = styled.span(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 500;\n  font-size: 1rem;\n  margin: 0 0 5px 0;\n  text-decoration: none;\n\n  ", "\n"])), function (props) {
  return props.theme.colors.primary;
}, breakpoint("desktop")(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteral(["\n    font-size: 1.125rem;\n    "]))));
var State = styled.p(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteral(["\n  color: #aaaaaa;\n  font-weight: 500;\n  font-size: 0.6rem;\n  margin: 0;\n  text-align: center;\n\n  ", "\n"])), breakpoint("desktop")(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteral(["\n    font-size: 0.75rem;\n    "]))));
var Header = styled.p(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteral(["\n  color: #aaaaaa;\n  font-size: 1.125rem;\n  font-weight: 400;\n"])));

var StaffStats = function StaffStats(_ref) {
  var desktopOnly = _ref.desktopOnly,
    mobileOnly = _ref.mobileOnly,
    staffCounts = _ref.staffCounts,
    homePage = _ref.homePage;
  return /*#__PURE__*/React__default.createElement(GridContainer, {
    desktopOnly: desktopOnly,
    mobileOnly: mobileOnly,
    homePage: homePage,
    className: "hide-on-print"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    desktopOnly: true
  }, /*#__PURE__*/React__default.createElement(Header, null, "My Staff")), /*#__PURE__*/React__default.createElement(Grid, null, /*#__PURE__*/React__default.createElement(CounterLink, {
    to: "/placements/watchlist"
  }, /*#__PURE__*/React__default.createElement(Counter, null, (staffCounts === null || staffCounts === void 0 ? void 0 : staffCounts.watchlist_count) || 0), /*#__PURE__*/React__default.createElement(State, null, "WATCHLIST"))), /*#__PURE__*/React__default.createElement(Grid, null, /*#__PURE__*/React__default.createElement(CounterLink, {
    to: "/placements/on_review"
  }, /*#__PURE__*/React__default.createElement(Counter, null, (staffCounts === null || staffCounts === void 0 ? void 0 : staffCounts.on_review_count) || 0), /*#__PURE__*/React__default.createElement(State, null, "ON REVIEW"))), /*#__PURE__*/React__default.createElement(Grid, null, /*#__PURE__*/React__default.createElement(CounterLink, {
    to: "/placements/interviews"
  }, /*#__PURE__*/React__default.createElement(Counter, null, (staffCounts === null || staffCounts === void 0 ? void 0 : staffCounts.interviews_count) || 0), /*#__PURE__*/React__default.createElement(State, null, "INTERVIEWS"))), /*#__PURE__*/React__default.createElement(Grid, null, /*#__PURE__*/React__default.createElement(CounterLink, {
    to: "/placements/placement_offered"
  }, /*#__PURE__*/React__default.createElement(Counter, null, (staffCounts === null || staffCounts === void 0 ? void 0 : staffCounts.offered_count) || 0), /*#__PURE__*/React__default.createElement(State, null, "OFFERED"))), /*#__PURE__*/React__default.createElement(Grid, null, /*#__PURE__*/React__default.createElement(CounterLink, {
    to: "/placements/placed"
  }, /*#__PURE__*/React__default.createElement(Counter, null, (staffCounts === null || staffCounts === void 0 ? void 0 : staffCounts.hired_count) || 0), /*#__PURE__*/React__default.createElement(State, null, "HIRED"))));
};

var index$1 = {
  CompleteIcon: CompleteIcon,
  ExpiredIcon: ExpiredIcon,
  IncompleteIcon: IncompleteIcon,
  LockedIcon: LockedIcon,
  NotStartedIcon: NotStartedIcon,
  PendingApprovalIcon: PendingApprovalIcon,
  RejectedIcon: RejectedIcon,
  StartedIcon: StartedIcon,
  VerifiedIcon: VerifiedIcon
};

var _templateObject$8, _templateObject2$5, _templateObject3$4, _templateObject4$4, _templateObject5$4, _templateObject6$3, _templateObject7$3, _templateObject8$3, _templateObject9$3, _templateObject0$3, _templateObject1$2, _templateObject10$2, _templateObject11$2, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15$1, _templateObject16$1, _templateObject17$1, _templateObject18, _templateObject19, _templateObject20;
var Container$5 = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  overflow: auto;\n  overflow-y: hidden;\n  max-width: 100%;\n  overflow-x: auto;\n\n  ", "\n"])), function (_ref) {
  var gridArea = _ref.gridArea;
  return gridArea !== undefined && css(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n      grid-area: ", ";\n    "])), gridArea));
});
var Table$1 = styled.table(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n  background-color: white;\n  width: 100%;\n  border-radius: 1rem;\n  border-collapse: collapse;\n  font-family: ", ", sans-serif;\n\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.body.family;
}, function (_ref3) {
  var simpleForm = _ref3.simpleForm;
  return !!simpleForm && css(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n      border-radius: 0;\n    "])));
});
var Th = styled.th(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n  text-align: left;\n  color: white;\n  padding: 0.75rem 1rem;\n  white-space: nowrap;\n\n  ", "\n"])), function (_ref4) {
  var simpleForm = _ref4.simpleForm;
  return !!simpleForm && css(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n      color: ", ";\n      font-weight: 400;\n      border-top: 1px solid #ececec;\n      border-bottom: 1px solid #ececec;\n      padding: 1.3rem 1rem;\n      background-color: #f7f7f7;\n      border-radius: 0 !important;\n      height: 40px;\n    "])), function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.content.text;
  });
});
var ThWrap = styled.th(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral(["\n  text-align: left;\n  color: white;\n  padding: 0.75rem 1rem;\n  white-space: normal;\n"])));
var Tr = styled.tr(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral([""])));
var Td = styled.td(_templateObject0$3 || (_templateObject0$3 = _taggedTemplateLiteral(["\n  text-align: left;\n  padding: 0.75rem 1rem;\n  color: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.content.text;
}, function (_ref7) {
  var centered = _ref7.centered;
  return !!centered && css(_templateObject1$2 || (_templateObject1$2 = _taggedTemplateLiteral(["\n      text-align: center;\n    "])));
}, function (_ref8) {
  var simpleForm = _ref8.simpleForm;
  return !!simpleForm && css(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral(["\n      border-bottom: 1px solid #ececec;\n      padding: 1.3rem 1rem;\n      height: 40px;\n      color: ", " !important;\n    "])), function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.content.text;
  });
}, function (_ref0) {
  var type = _ref0.type;
  return type === "date" && css(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), function (_ref1) {
    var theme = _ref1.theme;
    return theme.colors.content.text;
  });
});
var Thead = styled.thead(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n\n  ", ":first-child {\n    ", ":first-child {\n      border-top-left-radius: 1rem;\n    }\n\n    ", ":last-child {\n      border-top-right-radius: 1rem;\n    }\n  }\n\n  ", "\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primary;
}, Tr, Th, Th, function (_ref11) {
  var simpleForm = _ref11.simpleForm;
  return !!simpleForm && css(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral(["\n      background-color: transparent;\n    "])));
});
var Tbody = styled.tbody(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n  ", ":nth-child(odd) {\n    background-color: #fafafa;\n  }\n\n  ", ":nth-child(even) {\n    background-color: #f1f1f1;\n  }\n\n  ", ":last-child {\n    ", ":first-child {\n      border-bottom-left-radius: 1rem;\n    }\n\n    ", ":last-child {\n      border-bottom-right-radius: 1rem;\n    }\n  }\n\n  ", "\n"])), Tr, Tr, Tr, Td, Td, function (_ref12) {
  var simpleForm = _ref12.simpleForm;
  return !!simpleForm && css(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral(["\n      ", ":nth-child(odd) {\n        background-color: transparent !important;\n      }\n\n      ", ":nth-child(even) {\n        background-color: transparent !important;\n      }\n    "])), Tr, Tr);
});
styled.div(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteral(["\n  white-space: nowrap;\n\n  > * {\n    width: 100%;\n  }\n\n  > :not(:last-child) {\n    margin-bottom: 0.25rem;\n  }\n\n  ", "\n"])), breakpoint("tablet")(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteral(["\n    > * {\n      width: unset;\n    }\n\n    > :not(:last-child) {\n      margin: 0;\n      margin-right: 0.25rem;\n    }\n  "]))));
var SearchBox = styled(TextField)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  padding: 0.5rem 1rem;\n  background-color: #f4f4f4;\n  border: 1px solid #d8d8d8;\n  color: ", ";\n  width: unset;\n  font-weight: bold;\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.secondaryAlternative || theme.colors.secondary;
}, function (_ref14) {
  var theme = _ref14.theme;
  return transparentize(0.6, theme.colors.secondaryAlternative || theme.colors.secondary);
});
var MyInterviewsToggle = styled.label(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 0.6rem;\n  margin: 15px 0 15px 3px;\n  cursor: pointer;\n"])));
var MyInterviewsToggleText = styled.span(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  font-weight: bold;\n"])));

var _templateObject$7;
var Container$4 = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n\n  > * {\n    margin-bottom: 0.5rem;\n  }\n\n  > :not(:last-child) {\n    margin-right: 0.5rem;\n  }\n"])));

var Columnsets = function Columnsets(_ref) {
  var columnsets = _ref.columnsets,
    selected = _ref.selected,
    setSelected = _ref.setSelected;
  var handleClick = function handleClick(event, _ref2) {
    var name = _ref2.name;
    event.preventDefault();
    if (setSelected !== undefined) setSelected(name);
  };
  var checkSelected = function checkSelected(_ref3) {
    var name = _ref3.name;
    return name === selected;
  };
  return /*#__PURE__*/React__default.createElement(Container$4, null, columnsets.length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(P$4, {
    variant: "secondary",
    bold: true,
    marginless: true
  }, "View:"), columnsets.map(function (columnset) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      size: "small",
      variant: !!checkSelected(columnset) ? "primary" : "secondary",
      onClick: function onClick(event) {
        return handleClick(event, columnset);
      }
    }, columnset.title);
  })));
};
Columnsets.propTypes = {
  columnsets: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string
  })),
  selected: PropTypes.string,
  setSelected: PropTypes.func
};
Columnsets.defaultProps = {
  columnsets: [],
  selected: "",
  setSelected: undefined
};

var _templateObject$6, _templateObject2$4, _templateObject3$3, _templateObject4$3, _templateObject5$3, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$2, _templateObject0$2;
var ActionsContainer = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  > * {\n    width: 100%;\n  }\n\n  > :not(:last-child) {\n    margin-bottom: 0.25rem;\n  }\n\n  ", "\n\n  ", "\n"])), breakpoint("tablet")(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n    white-space: nowrap;\n\n    > * {\n      width: unset;\n    }\n\n    > :not(:last-child) {\n      margin: 0;\n      margin-right: 0.25rem;\n    }\n  "]))), function (_ref) {
  var simpleForm = _ref.simpleForm;
  return simpleForm && css(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n      display: flex;\n      justify-content: start;\n      gap: 0.7rem;\n    "])));
});
var IconsContainer = styled.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n"])));
var StyledSelectField = styled(SelectField)(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n  border-radius: 0.5rem;\n  border-width: 2px;\n  border-color: ", ";\n  color: ", ";\n  padding: 0px 6px 0px 0px;\n  margin: 0;\n  font-weight: bold;\n  width: 6rem;\n  height: 2.25rem;\n  font-size: 0.75rem;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  cursor: pointer;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondaryAlternative || theme.colors.secondary;
});
var NameWithIcon = styled.div(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n\n  svg {\n    color: ", ";\n  }\n\n  p {\n    margin: 0;\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var StyledCurrencyValue = styled.span(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n\n  ", "\n"])), function (_ref5) {
  var $color = _ref5.$color;
  return $color || "inherit";
}, function (_ref6) {
  var positive = _ref6.positive;
  return positive ? css(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n          color: #333;\n        "]))) : css(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n          color: #497929;\n        "])));
});
var StyledStatusText = styled.span(_templateObject0$2 || (_templateObject0$2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref7) {
  var isDanger = _ref7.isDanger,
    theme = _ref7.theme;
  return isDanger ? theme.colors.alerts.danger : "inherit";
});

var ActionsCell = function ActionsCell(_ref) {
  var actionCellHandler = _ref.actionCellHandler,
    simpleForm = _ref.simpleForm,
    value = _ref.value,
    id = _ref.row.original.id;
  var ViewAction = function ViewAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "primary",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "view");
      }
    }, "View");
  };
  var UploadAction = function UploadAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "success",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "view");
      }
    }, "Upload");
  };
  var SignAction = function SignAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "success",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "sign");
      }
    }, "Sign");
  };
  var EditAction = function EditAction(id, simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: simpleForm ? "simpleForm" : "secondary",
      outlined: true,
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "edit");
      }
    }, "Edit");
  };
  var DeleteAction = function DeleteAction(id, simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: simpleForm ? "simpleFormDanger" : "danger",
      outlined: !!simpleForm,
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "delete");
      }
    }, "Delete");
  };
  var RemoveAction = function RemoveAction(id, simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: simpleForm ? "simpleFormDanger" : "danger",
      outlined: !!simpleForm,
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "remove");
      }
    }, "Remove");
  };
  var AcceptInterviewAction = function AcceptInterviewAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "success",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "accept_interview");
      }
    }, "Accept");
  };
  var RescheduleInterviewAction = function RescheduleInterviewAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "secondary",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "reschedule_interview");
      }
    }, "Reschedule");
  };
  var DeclineInterviewAction = function DeclineInterviewAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "danger",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "decline_interview");
      }
    }, "Decline");
  };
  var CancelInterviewAction = function CancelInterviewAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "danger",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "cancel_interview");
      }
    }, "Cancel");
  };
  var OfferPlacementAction = function OfferPlacementAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "success",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "offer_placement");
      }
    }, "Make Offer");
  };
  var DeclinePlacementAction = function DeclinePlacementAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "danger",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "decline_placement");
      }
    }, "Decline");
  };
  var AmmendOfferAction = function AmmendOfferAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "success",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "ammend");
      }
    }, "Amend Offer");
  };
  var CancelOfferAction = function CancelOfferAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "danger",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "cancel_offer");
      }
    }, "Cancel Offer");
  };
  var PdfAction = function PdfAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "secondary",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "pdf");
      }
    }, "PDF");
  };
  var CsvAction = function CsvAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "secondary",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "csv");
      }
    }, "CSV");
  };
  var SubmitAction = function SubmitAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "success",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "submit");
      }
    }, "Submit");
  };
  var FilledAction = function FilledAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "success",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "filled");
      }
    }, "Mark as Filled");
  };
  var UnfulfilledAction = function UnfulfilledAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "secondary",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "unfulfilled");
      }
    }, "Filled");
  };
  var SearchAction = function SearchAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "secondary",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "search");
      }
    }, "Search");
  };
  var ReinviteAction = function ReinviteAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "success",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "reinvite");
      }
    }, "Re-Invite");
  };
  var ContinueAction = function ContinueAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "success",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "continue");
      }
    }, "Continue");
  };
  var ConfirmAction = function ConfirmAction(id, _simpleForm) {
    return /*#__PURE__*/React__default.createElement(Button$5, {
      variant: "success",
      size: "small",
      onClick: function onClick(event) {
        return actionCellHandler(event, id, "confirm");
      }
    }, "Confirm");
  };
  var actionTypes = {
    view: ViewAction,
    upload: UploadAction,
    sign: SignAction,
    edit: EditAction,
    "delete": DeleteAction,
    remove: RemoveAction,
    accept_interview: AcceptInterviewAction,
    decline_interview: DeclineInterviewAction,
    reschedule_interview: RescheduleInterviewAction,
    cancel_interview: CancelInterviewAction,
    offer_placement: OfferPlacementAction,
    decline_placement: DeclinePlacementAction,
    ammend: AmmendOfferAction,
    cancel_offer: CancelOfferAction,
    pdf: PdfAction,
    csv: CsvAction,
    submit: SubmitAction,
    filled: FilledAction,
    unfulfilled: UnfulfilledAction,
    search: SearchAction,
    reinvite: ReinviteAction,
    "continue": ContinueAction,
    confirm: ConfirmAction
  };
  if (Array.isArray(value) && id !== undefined && actionCellHandler !== undefined) {
    return /*#__PURE__*/React__default.createElement(ActionsContainer, {
      simpleForm: simpleForm
    }, value.map(function (action) {
      var Action = actionTypes[action];
      return Action ? Action(id, simpleForm) : null;
    }));
  } else {
    return "";
  }
};

var BooleanCell = function BooleanCell(_ref) {
  var value = _ref.value;
  var yesIcon = /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCheckCircle,
    color: "green"
  });
  var noIcon = /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faDotCircle,
    color: "red"
  });
  return !!toBool(value) ? yesIcon : noIcon;
};

var DateCell = function DateCell(_ref) {
  var value = _ref.value;
  return value && value.length > 1 ? /*#__PURE__*/React__default.createElement(Moment, {
    value: value
  }) : "-";
};

var DateRangeCell = function DateRangeCell(_ref) {
  var value = _ref.value;
  if (value && value.length > 1) {
    return /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Moment, {
      value: value[0]
    }), " - ", /*#__PURE__*/React__default.createElement(Moment, {
      value: value[1]
    }));
  } else if (value && value[0] && value[0].length > 0) {
    return /*#__PURE__*/React__default.createElement(Moment, {
      value: value[0]
    });
  } else {
    return null;
  }
};

var DateTimeCell = function DateTimeCell(_ref) {
  var value = _ref.value;
  return value && value.length > 1 ? /*#__PURE__*/React__default.createElement(Moment, {
    value: value,
    format: "DD MMM YYYY HH:mm"
  }) : "-";
};

var DocumentCell = function DocumentCell(_ref) {
  var value = _ref.value,
    documentHandler = _ref.documentHandler,
    id = _ref.row.original.id;
  var handleClick = function handleClick(event) {
    event.preventDefault();
    if (documentHandler !== undefined) documentHandler(id, value);
  };
  return value ? /*#__PURE__*/React__default.createElement(Button$5, {
    onClick: handleClick,
    size: "small",
    variant: "secondary",
    outlined: true
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faFilePdf
  })) : null;
};
DocumentCell.propTypes = {
  value: PropTypes.string,
  documentHandler: PropTypes.func
};
DocumentCell.defaultProps = {
  value: "",
  documentHandler: undefined
};

var DropdownActionsCell = function DropdownActionsCell(_ref) {
  var actionCellHandler = _ref.actionCellHandler,
    value = _ref.value,
    id = _ref.row.original.id;
  var ref = useRef(null);
  var onChange = function onChange(event) {
    var action = event.target.value;
    actionCellHandler(event, id, action);
    if (ref.current) {
      ref.current.value = "";
    }
  };
  var actionTexts = {
    view: "View",
    upload: "Upload",
    sign: "Sign",
    edit: "Edit",
    "delete": "Delete",
    accept_interview: "Accept Interview",
    decline_interview: "Decline Interview",
    reschedule_interview: "Reschedule Interview",
    cancel_interview: "Cancel Interview",
    offer_placement: "Make Offer",
    decline_placement: "Decline",
    ammend: "Amend Offer",
    cancel_offer: "Cancel Offer",
    pdf: "PDF",
    csv: "CSV",
    submit: "Submit",
    filled: "Mark as Filled",
    unfulfilled: "Filled",
    search: "Search",
    reinvite: "Re-Invite",
    "continue": "Continue",
    confirm: "Confirm",
    add_placement_midpoint_pay: "Add Placement Midpoint Net Pay",
    add_placement_end_date_pay: "Add Placement End Date Net Pay",
    edit_placement_midpoint_pay: "Edit Placement Midpoint Net Pay",
    edit_placement_end_date_pay: "Edit Placement End Date Net Pay"
  };
  var options = value.map(function (action) {
    return [action, actionTexts[action]];
  });
  return /*#__PURE__*/React__default.createElement(SelectField, {
    onChange: onChange,
    ref: ref,
    options: options,
    blank: "- Choose action -",
    tableRow: true
  });
};

var ExternalLinkCell = function ExternalLinkCell(_ref) {
  var value = _ref.value;
  return value && value.length > 1 ? /*#__PURE__*/React__default.createElement(Button$5, {
    href: value,
    size: "small",
    variant: "secondary",
    outlined: true,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faLink
  })) : null;
};
ExternalLinkCell.propTypes = {
  value: PropTypes.string
};
ExternalLinkCell.defaultProps = {
  value: ""
};

var ImageCell = function ImageCell(_ref) {
  var value = _ref.value,
    _ref$row$original = _ref.row.original,
    avatar_exists = _ref$row$original.avatar_exists,
    first_name = _ref$row$original.first_name,
    last_name = _ref$row$original.last_name;
  return value ? /*#__PURE__*/React__default.createElement(Avatar$1, {
    avatarExists: avatar_exists,
    src: value,
    size: "small",
    firstName: first_name,
    lastName: last_name
  }) : "";
};

var TernaryCell = function TernaryCell(_ref) {
  var value = _ref.value,
    icon = _ref.icon;
  return value === null || value === undefined ? !!icon ? /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faMinusCircle,
    color: "gray"
  }) : "-" : /*#__PURE__*/React__default.createElement(BooleanCell, {
    value: value
  });
};
TernaryCell.propTypes = {
  icon: PropTypes.bool
};
TernaryCell.defaultProps = {
  icon: true
};

var InvoiceStatusCell = function InvoiceStatusCell(_ref) {
  var value = _ref.value,
    due_date = _ref.row.original.due_date;
  if (value == false && !!due_date) {
    var dueDateStr = moment$1(due_date).format("DD MMMM YYYY");
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      title: "Payment due: ".concat(dueDateStr)
    }, /*#__PURE__*/React__default.createElement(IconsContainer, null, /*#__PURE__*/React__default.createElement(TernaryCell, {
      value: value
    }), /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faCalendar,
      size: "sm"
    })));
  } else {
    return /*#__PURE__*/React__default.createElement(TernaryCell, {
      value: value
    });
  }
};

var PlainCell = function PlainCell(_ref) {
  var value = _ref.value,
    type = _ref.type,
    column = _ref.column,
    simpleForm = _ref.simpleForm;
  var truncate = false;
  if (type === "currency" && simpleForm) {
    var num = parseFloat((value || "").replace(/[^0-9.-]+/g, ""));
    return /*#__PURE__*/React__default.createElement(StyledCurrencyValue, {
      positive: isNaN(num) ? false : num >= 0
    }, value);
  } else {
    truncate = (column === null || column === void 0 ? void 0 : column.truncate) && (value === null || value === void 0 ? void 0 : value.length) > column.truncate;
  }
  return truncate ? /*#__PURE__*/React__default.createElement("span", {
    title: value
  }, value.slice(0, column.truncate), "...") : value;
};
PlainCell.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
  column: PropTypes.shape({
    truncate: PropTypes.number
  }),
  simpleForm: PropTypes.bool
};
PlainCell.defaultProps = {
  value: "",
  type: undefined,
  column: {},
  simpleForm: false
};

var RatingBoolFieldCell = function RatingBoolFieldCell(_ref) {
  var value = _ref.value,
    id = _ref.column.id,
    locked = _ref.row.original.locked;
  return (value === null || value === undefined) && !toBool(locked) ? /*#__PURE__*/React__default.createElement(StyledSelectField, {
    name: id,
    options: [["true", "Yes"], ["false", "No"]],
    blank: "Select"
  }) : /*#__PURE__*/React__default.createElement(TernaryCell, {
    value: value,
    icon: false
  });
};

var RatingFieldCell = function RatingFieldCell(_ref) {
  var value = _ref.value,
    id = _ref.column.id,
    locked = _ref.row.original.locked;
  return (value === null || value === undefined) && !toBool(locked) ? /*#__PURE__*/React__default.createElement(StyledSelectField, {
    name: id,
    options: _toConsumableArray(Array(11).keys()).map(function (o) {
      return [o, o];
    }),
    blank: "Select"
  }) : /*#__PURE__*/React__default.createElement(PlainCell, {
    value: value || "-"
  });
};

var SelectionCell = function SelectionCell(_ref) {
  var selectionHandler = _ref.selectionHandler,
    selectedRows = _ref.selectedRows,
    id = _ref.row.original.id;
  var handleSelection = function handleSelection(event) {
    event.stopPropagation();
    var checked = event.target.checked;
    if (selectionHandler !== undefined) selectionHandler(id, checked);
  };
  return /*#__PURE__*/React__default.createElement("input", {
    type: "checkbox",
    checked: selectedRows.includes(id),
    onChange: handleSelection
  });
};

var ViewProfileFieldCell = function ViewProfileFieldCell(_ref) {
  var value = _ref.value,
    viewProfileCellHandler = _ref.viewProfileCellHandler,
    id = _ref.row.original.id;
  // viewProfileCellHandler is a function that returns a React component
  return viewProfileCellHandler ? viewProfileCellHandler(id, value) : value;
};

var EmployerUserNameCell = function EmployerUserNameCell(_ref) {
  var value = _ref.value,
    can_manage_users = _ref.row.original.can_manage_users;
  return /*#__PURE__*/React__default.createElement(NameWithIcon, null, /*#__PURE__*/React__default.createElement("span", null, value), toBool(can_manage_users) && /*#__PURE__*/React__default.createElement(Tooltip, {
    title: "Can manage users"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faUserGroup,
    size: "sm"
  })));
};

// Array of statuses that should be colored
var WARNING_STATUSES = ["Failed"];
var StatusCell = function StatusCell(_ref) {
  var value = _ref.value,
    _ref$warningStatuses = _ref.warningStatuses,
    warningStatuses = _ref$warningStatuses === void 0 ? WARNING_STATUSES : _ref$warningStatuses;
  var isDanger = value && warningStatuses.includes(value);
  return /*#__PURE__*/React__default.createElement(StyledStatusText, {
    isDanger: isDanger
  }, value || "-");
};
StatusCell.propTypes = {
  value: PropTypes.string,
  warningStatuses: PropTypes.arrayOf(PropTypes.string)
};
StatusCell.defaultProps = {
  value: "",
  warningStatuses: WARNING_STATUSES
};

var FILTERABLE_COLUMN_TYPES = ["plain", "view_profile", "date", "datetime"];
var cellTypes = {
  plain: PlainCell,
  currency: PlainCell,
  "boolean": BooleanCell,
  image: ImageCell,
  date: DateCell,
  datetime: DateTimeCell,
  date_range: DateRangeCell,
  external_link: ExternalLinkCell,
  document: DocumentCell,
  actions: ActionsCell,
  dropdown_actions: DropdownActionsCell,
  selection: SelectionCell,
  ternary: TernaryCell,
  rating_field: RatingFieldCell,
  bool_field: RatingBoolFieldCell,
  view_profile: ViewProfileFieldCell,
  invoice_status: InvoiceStatusCell,
  employer_user_name: EmployerUserNameCell,
  status: StatusCell,
  reference: DocumentCell
};
var Table = function Table(_ref) {
  var columns = _ref.columns,
    filters = _ref.filters,
    actions = _ref.actions,
    data = _ref.data,
    gridArea = _ref.gridArea,
    noneText = _ref.noneText,
    actionHandler = _ref.actionHandler,
    filterHandler = _ref.filterHandler,
    actionCellHandler = _ref.actionCellHandler,
    viewProfileCellHandler = _ref.viewProfileCellHandler,
    q = _ref.q,
    columnsets = _ref.columnsets,
    selectedColumnset = _ref.selectedColumnset,
    setColumnset = _ref.setColumnset,
    documentHandler = _ref.documentHandler,
    csvData = _ref.csvData;
    _ref.csvHeaders;
    var selectionHandler = _ref.selectionHandler,
    selectedRows = _ref.selectedRows,
    clearFilterHandler = _ref.clearFilterHandler,
    clearAllFiltersHandler = _ref.clearAllFiltersHandler,
    showSearchBox = _ref.showSearchBox,
    showMyInterviewsToggle = _ref.showMyInterviewsToggle,
    handleMyInterviewsToggle = _ref.handleMyInterviewsToggle,
    myInterviewsCount = _ref.myInterviewsCount,
    myInterviewsOnly = _ref.myInterviewsOnly,
    showCountsummary = _ref.showCountsummary,
    simpleForm = _ref.simpleForm;
  var _useState = useState(data),
    _useState2 = _slicedToArray(_useState, 2),
    filteredData = _useState2[0],
    setFilteredData = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    searchValue = _useState4[0],
    setSearchValue = _useState4[1];
  if (selectionHandler !== undefined && !columns.some(function (c) {
    return c.type === "selection";
  })) {
    columns.unshift({
      accessor: "selection",
      type: "selection"
    });
  }
  var selectAll = function selectAll(event) {
    event.stopPropagation();
    var checked = event.target.checked;
    if (selectionHandler !== undefined) selectionHandler("all", checked);
  };
  columns.forEach(function (column) {
    if (!column.type) column.type = "plain";
    column.Cell = cellTypes[column.type];
    if (column.type == "boolean" || column.type == "ternary" || column.type == "invoice_status") {
      column.sortType = "basic";
    } else if (column.type === "currency") {
      column.sortType = function (a, b) {
        var valueA = parseFloat(a.values[column.accessor].replace(/[^0-9.-]+/g, ""));
        var valueB = parseFloat(b.values[column.accessor].replace(/[^0-9.-]+/g, ""));
        if (valueA < valueB) return -1;else if (valueB < valueA) return 1;else return 0;
      };
    } else if (column.type === "date" || column.type === "datetime") {
      column.sortType = function (a, b) {
        var dateA = moment$1(a.values[column.accessor]);
        var dateB = moment$1(b.values[column.accessor]);
        if (!dateA.isValid() || dateA.isBefore(dateB)) return -1;else if (dateB.isBefore(dateA)) return 1;else return 0;
      };
    } else if (column.type === "date_range") {
      column.sortType = function (a, b) {
        var dateA = moment$1(a.values[column.accessor][0]);
        var dateB = moment$1(b.values[column.accessor][0]);
        if (!dateA.isValid() || dateA.isBefore(dateB)) return -1;else if (dateB.isBefore(dateA)) return 1;else return 0;
      };
    } else if (["actions", "selection"].includes(column.type)) {
      column.disableSortBy = true;
    }
    if (column.type === "selection") {
      column.Header = /*#__PURE__*/React__default.createElement("input", {
        type: "checkbox",
        onChange: selectAll
      });
    }
  });
  var tableInstance = useTable({
    columns: columns,
    data: filteredData
  }, useSortBy);
  var getTableProps = tableInstance.getTableProps,
    getTableBodyProps = tableInstance.getTableBodyProps,
    headerGroups = tableInstance.headerGroups,
    rows = tableInstance.rows,
    prepareRow = tableInstance.prepareRow;
  var prepareValueForSearch = function prepareValueForSearch(type, value) {
    if (type === "date") return moment$1(value).format("DD MMMM YYYY").toLowerCase();else if (type === "datetime") return moment$1(value).format("DD MMMM YYYY HH:mm").toLowerCase();else return value.toString().toLowerCase();
  };
  var filterableColumns = columns.filter(function (column) {
    return FILTERABLE_COLUMN_TYPES.includes(column.type);
  });
  var handleSearchBox = function handleSearchBox(event) {
    var value = event.target.value;
    setSearchValue(value);
    if (!Array.isArray(data)) return;
    var filteredData = [];
    filteredData = data.filter(function (row) {
      return filterableColumns.some(function (column) {
        var datum = row[column.accessor];
        if (datum === undefined || datum === null) return false;
        return prepareValueForSearch(column.type, datum).includes(value.toString().toLowerCase());
      });
    });
    setFilteredData(filteredData);
  };
  var handleFilter = function handleFilter(name, value) {
    setSearchValue("");
    setFilteredData(data);
    if (filterHandler !== undefined) filterHandler(name, value);
  };
  var renderSortIcon = function renderSortIcon(_ref2) {
    var disableSortBy = _ref2.disableSortBy,
      isSorted = _ref2.isSorted,
      isSortedDesc = _ref2.isSortedDesc;
    if (!!disableSortBy) return null;else if (!isSorted) return /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faSort,
      size: "sm"
    });else if (!!isSortedDesc) return /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faSortDown,
      size: "sm"
    });else return /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faSortUp,
      size: "sm"
    });
  };
  return /*#__PURE__*/React__default.createElement(Grid$1, {
    gap: "1rem",
    gridArea: gridArea
  }, /*#__PURE__*/React__default.createElement(Filters, {
    filters: filters,
    filterHandler: handleFilter,
    q: q,
    clearFilterHandler: clearFilterHandler,
    clearAllFiltersHandler: clearAllFiltersHandler
  }), (columnsets && columnsets.length > 0 || actions && actions.length > 0 || showSearchBox || showMyInterviewsToggle) && /*#__PURE__*/React__default.createElement(Level, {
    mobile: false
  }, showMyInterviewsToggle && myInterviewsCount > 0 && /*#__PURE__*/React__default.createElement(MyInterviewsToggle, null, /*#__PURE__*/React__default.createElement(SwitchField, {
    name: "showMyInterviews",
    handleInputChange: handleMyInterviewsToggle,
    checked: myInterviewsOnly
  }), /*#__PURE__*/React__default.createElement(MyInterviewsToggleText, null, "Only show my interviews (", myInterviewsCount, ")")), /*#__PURE__*/React__default.createElement(Columnsets, {
    columnsets: columnsets,
    selected: selectedColumnset,
    setSelected: setColumnset
  }), /*#__PURE__*/React__default.createElement(Grid$1, {
    template: "auto / 2fr 1fr",
    placeItems: "start end"
  }, /*#__PURE__*/React__default.createElement(Actions, {
    actions: actions,
    actionHandler: actionHandler,
    csvData: csvData
  }), !!showSearchBox && /*#__PURE__*/React__default.createElement(SearchBox, {
    name: "text_search",
    value: searchValue,
    placeholder: "Search",
    onChange: handleSearchBox
  }))), /*#__PURE__*/React__default.createElement(Container$5, null, /*#__PURE__*/React__default.createElement(Table$1, _extends({}, getTableProps(), {
    simpleForm: simpleForm
  }), /*#__PURE__*/React__default.createElement(Thead, {
    simpleForm: simpleForm
  }, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/React__default.createElement(Tr, headerGroup.getHeaderGroupProps(), headerGroup.headers.map(function (column) {
      return column.wrap_column ? /*#__PURE__*/React__default.createElement(ThWrap, column.getHeaderProps(column.getSortByToggleProps()), column.render("Header"), " ", renderSortIcon(column)) : /*#__PURE__*/React__default.createElement(Th, _extends({}, column.getHeaderProps(column.getSortByToggleProps()), {
        simpleForm: simpleForm
      }), column.render("Header"), " ", renderSortIcon(column));
    }));
  })), /*#__PURE__*/React__default.createElement(Tbody, _extends({}, getTableBodyProps(), {
    simpleForm: simpleForm
  }), rows.length > 0 ? rows.map(function (row) {
    prepareRow(row);
    return /*#__PURE__*/React__default.createElement(Tr, row.getRowProps(), row.cells.map(function (cell) {
      return /*#__PURE__*/React__default.createElement(Td, _extends({}, cell.getCellProps(), {
        simpleForm: simpleForm,
        type: cell.column.type
      }), cell.render("Cell", {
        actionCellHandler: actionCellHandler,
        viewProfileCellHandler: viewProfileCellHandler,
        documentHandler: documentHandler,
        selectionHandler: selectionHandler,
        selectedRows: selectedRows,
        simpleForm: simpleForm,
        type: cell.column.type
      }));
    }));
  }) : columns.length > 0 && /*#__PURE__*/React__default.createElement(Tr, null, /*#__PURE__*/React__default.createElement(Td, {
    colSpan: columns.length,
    centered: true,
    simpleForm: simpleForm
  }, noneText))))), !!showCountsummary && /*#__PURE__*/React__default.createElement(P$4, {
    variant: "content",
    align: "center"
  }, "Showing ", filteredData.length, " of ", data.length));
};
Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    Header: PropTypes.string.isRequired,
    accessor: PropTypes.string.isRequired
  })).isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
  filters: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.arrayOf(PropTypes.object),
  gridArea: PropTypes.string,
  noneText: PropTypes.string,
  actionHandler: PropTypes.func,
  filterHandler: PropTypes.func,
  actionCellHandler: PropTypes.func,
  viewProfileCellHandler: PropTypes.func,
  q: PropTypes.object,
  columnsets: PropTypes.array,
  selectedColumnset: PropTypes.string,
  setColumnset: PropTypes.func,
  documentHandler: PropTypes.func,
  selectionHandler: PropTypes.func,
  selectedRows: PropTypes.array,
  clearFilterHandler: PropTypes.func,
  clearAllFiltersHandler: PropTypes.func,
  showSearchBox: PropTypes.bool,
  showCountsummary: PropTypes.bool
};
Table.defaultProps = {
  columns: [],
  data: [],
  filters: [],
  actions: [],
  gridArea: undefined,
  noneText: "No records.",
  actionHandler: undefined,
  filterHandler: undefined,
  actionCellHandler: undefined,
  viewProfileCellHandler: undefined,
  q: {},
  columnsets: [],
  selectedColumnset: "",
  setColumnset: undefined,
  documentHandler: undefined,
  selectionHandler: undefined,
  selectedRows: [],
  clearFilterHandler: undefined,
  clearAllFiltersHandler: undefined,
  showSearchBox: false,
  showCountsummary: true
};

var _templateObject$5;
var Ribbon = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  width: 12.1em;\n  height: 12.1em;\n  position: fixed;\n  overflow: hidden;\n  top: 0;\n  right: 0;\n  z-index: 9999;\n  pointer-events: none;\n  font-size: 13px;\n  text-decoration: none;\n  text-indent: -999999px;\n  cursor: pointer;\n\n  &:before,\n  &:after {\n    /* The right and left classes determine the side we attach our banner to */\n    position: absolute;\n    display: block;\n    width: 15.38em;\n    height: 1.54em;\n\n    top: 3.23em;\n    right: -3.23em;\n\n    -webkit-box-sizing: content-box;\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n\n  &:before {\n    content: \"\";\n\n    /* Add a bit of padding to give some substance outside the \"stitching\" */\n    padding: 0.38em 0;\n\n    /* Set the base colour */\n    background-color: #e74c3c;\n\n    pointer-events: auto;\n  }\n\n  &:after {\n    /* Set the text from the data-ribbon attribute */\n    content: attr(data-ribbon);\n\n    /* Set the text properties */\n    color: #fff;\n    font:\n      700 1em \"Helvetica Neue\",\n      sans-serif;\n    line-height: 1.54em;\n    text-decoration: none;\n    text-align: center;\n    text-indent: 0;\n\n    /* Set the layout properties */\n    padding: 0.15em 0;\n    margin: 0.15em 0;\n  }\n\n  &:hover,\n  &:active {\n    opacity: 0.5;\n  }\n"])));

var EnvironmentRibbon = function EnvironmentRibbon(_ref) {
  var environment = _ref.environment;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var handleClick = function handleClick(event) {
    event.preventDefault();
    setVisible(false);
  };
  if (!visible) return null;
  return /*#__PURE__*/React__default.createElement(Ribbon, {
    "data-ribbon": environment,
    onClick: handleClick
  });
};
EnvironmentRibbon.propTypes = {
  environment: PropTypes.string.isRequired
};
EnvironmentRibbon.defaultProps = {
  environment: ""
};

var _templateObject$4;
var Container$3 = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  color: ", ";\n  width: 1.5em;\n  height: 1.5em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});

var HomeIcon = function HomeIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faHouse,
    size: size
  }));
};
HomeIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
HomeIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var ProfileIcon = function ProfileIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faUser,
    size: size
  }));
};
ProfileIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
ProfileIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var VisaIcon = function VisaIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faPassport,
    size: size
  }));
};
VisaIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
VisaIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var FlightIcon = function FlightIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faPlane,
    size: size
  }));
};
FlightIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
FlightIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var DocumentsIcon = function DocumentsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faFolderOpen,
    size: size
  }));
};
DocumentsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
DocumentsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var InsuranceIcon = function InsuranceIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faShieldHalved,
    size: size
  }));
};
InsuranceIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
InsuranceIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var EventsIcon = function EventsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCalendar,
    size: size
  }));
};
EventsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
EventsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var PaymentsIcon = function PaymentsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faMoneyBills,
    size: size
  }));
};
PaymentsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
PaymentsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var NotificationsIcon = function NotificationsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faBell$1,
    size: size
  }));
};
NotificationsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
NotificationsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var MessagesIcon = function MessagesIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faMessage$1,
    size: size
  }));
};
MessagesIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
MessagesIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var HelpIcon = function HelpIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleInfo$1,
    size: size
  }));
};
HelpIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
HelpIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var SettingsIcon = function SettingsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faGear,
    size: size
  }));
};
SettingsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
SettingsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var SwitchIcon = function SwitchIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faRepeat,
    size: size
  }));
};
SwitchIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
SwitchIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var LogoutIcon = function LogoutIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faArrowRightFromBracket,
    size: size
  }));
};
LogoutIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
LogoutIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var PerksIcon = function PerksIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCakeCandles,
    size: size
  }));
};
PerksIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
PerksIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var ReferralsIcon = function ReferralsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCoins,
    size: size
  }));
};
ReferralsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
ReferralsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var WorkPermitsIcon = function WorkPermitsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faUserHelmetSafety,
    size: size
  }));
};
WorkPermitsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
WorkPermitsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var CoursesIcon = function CoursesIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faUserGraduate,
    size: size
  }));
};
CoursesIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
CoursesIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var ParticipantMonitoringIcon = function ParticipantMonitoringIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faStopwatch,
    size: size
  }));
};
ParticipantMonitoringIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
ParticipantMonitoringIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var JobAdsIcon = function JobAdsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faBriefcase,
    size: size
  }));
};
JobAdsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
JobAdsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var EllipsisIcon = function EllipsisIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faEllipsis,
    size: size
  }));
};
EllipsisIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
EllipsisIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var CampsIcon = function CampsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCampground,
    size: size
  }));
};
CampsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
CampsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var ResortsIcon = function ResortsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faHotel,
    size: size
  }));
};
ResortsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
ResortsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var LinkedApplicationIcon = function LinkedApplicationIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faLink$1,
    size: size
  }));
};
LinkedApplicationIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
LinkedApplicationIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var SearchIcon = function SearchIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faSearch,
    size: size
  }));
};
SearchIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
SearchIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var NeedsIcon = function NeedsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faNote,
    size: size
  }));
};
NeedsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
NeedsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var PlacementsIcon = function PlacementsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faClipboardUser,
    size: size
  }));
};
PlacementsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
PlacementsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var FinancialsIcon = function FinancialsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCoins,
    size: size
  }));
};
FinancialsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
FinancialsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var PublicProfileIcon = function PublicProfileIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCabin,
    size: size
  }));
};
PublicProfileIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
PublicProfileIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var FeedbackIcon = function FeedbackIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faStar,
    size: size
  }));
};
FeedbackIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
FeedbackIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var ArrivalsIcon = function ArrivalsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faPlaneArrival,
    size: size
  }));
};
ArrivalsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
ArrivalsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var DirectHireIcon = function DirectHireIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faPaperPlaneTop$1,
    size: size
  }));
};
DirectHireIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
DirectHireIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var InformationIcon = function InformationIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faMemoCircleInfo,
    size: size
  }));
};
InformationIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
InformationIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var InterviewsIcon = function InterviewsIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faClipboardQuestion,
    size: size
  }));
};
InterviewsIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
InterviewsIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var PoliceCheckIcon = function PoliceCheckIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faFileMagnifyingGlass,
    size: size
  }));
};
PoliceCheckIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
PoliceCheckIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var FeeSheetIcon = function FeeSheetIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faFileInvoiceDollar,
    size: size
  }));
};
FeeSheetIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
FeeSheetIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var CommunityIcon = function CommunityIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faGlobe,
    size: size
  }));
};
CommunityIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
CommunityIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var LiveChatIcon = function LiveChatIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faComments,
    size: size
  }));
};
LiveChatIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
LiveChatIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var ManageUsersIcon = function ManageUsersIcon(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement(Container$3, {
    color: color,
    size: size
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faUserGroup,
    size: size
  }));
};
ManageUsersIcon.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string
};
ManageUsersIcon.defaultProps = {
  color: "#ffffff",
  size: "lg"
};

var NavIcons = {
  ArrivalsIcon: ArrivalsIcon,
  CampsIcon: CampsIcon,
  CommunityIcon: CommunityIcon,
  CoursesIcon: CoursesIcon,
  DirectHireIcon: DirectHireIcon,
  DocumentsIcon: DocumentsIcon,
  EllipsisIcon: EllipsisIcon,
  EventsIcon: EventsIcon,
  FeedbackIcon: FeedbackIcon,
  FeeSheetIcon: FeeSheetIcon,
  FinancialsIcon: FinancialsIcon,
  FlightIcon: FlightIcon,
  HelpIcon: HelpIcon,
  HomeIcon: HomeIcon,
  InformationIcon: InformationIcon,
  InsuranceIcon: InsuranceIcon,
  InterviewsIcon: InterviewsIcon,
  JobAdsIcon: JobAdsIcon,
  LinkedApplicationIcon: LinkedApplicationIcon,
  LiveChatIcon: LiveChatIcon,
  LogoutIcon: LogoutIcon,
  MessagesIcon: MessagesIcon,
  NeedsIcon: NeedsIcon,
  NotificationsIcon: NotificationsIcon,
  ParticipantMonitoringIcon: ParticipantMonitoringIcon,
  PaymentsIcon: PaymentsIcon,
  PerksIcon: PerksIcon,
  PlacementsIcon: PlacementsIcon,
  PoliceCheckIcon: PoliceCheckIcon,
  ProfileIcon: ProfileIcon,
  PublicProfileIcon: PublicProfileIcon,
  ReferralsIcon: ReferralsIcon,
  ResortsIcon: ResortsIcon,
  SearchIcon: SearchIcon,
  SettingsIcon: SettingsIcon,
  SwitchIcon: SwitchIcon,
  VisaIcon: VisaIcon,
  WorkPermitsIcon: WorkPermitsIcon,
  ManageUsersIcon: ManageUsersIcon
};

var _templateObject$3, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$2;
var Container$2 = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  background: white;\n  border-radius: 1rem;\n  padding: 0.1rem;\n  width: 100%;\n  font-size: 1rem;\n  color: ", ";\n  border: 1px solid #ececec;\n"])), function (props) {
  return props.theme.colors.darkGrey;
});
var List = styled.ul(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n"])));
var ListItem = styled.li(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  list-style: none;\n  font-weight: 500;\n  padding: 2px;\n"])));
var Link = styled.a(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  padding: 0.75rem 1rem;\n  border-radius: 0.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  text-decoration: none;\n  color: ", ";\n\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%; /* 1.5rem */\n\n  &:hover {\n    background: ", ";\n  }\n"])), function (props) {
  return props.theme.colors.content.text;
}, function (props) {
  return darken(0.04, props.theme.colors.lightGrey);
});
var LinkText = styled.span(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 0.5rem;\n"])));

var OptionsPopup = function OptionsPopup(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React__default.createElement(Container$2, {
    className: className
  }, children);
};
OptionsPopup.PropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

var OptionsPopupList = function OptionsPopupList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(List, null, children);
};
OptionsPopupList.PropTypes = {
  children: PropTypes.node.isRequired
};

var OptionsPopupListItem = function OptionsPopupListItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(ListItem, null, children);
};
OptionsPopupListItem.PropTypes = {
  children: PropTypes.node.isRequired
};

var OptionsPopupLink = function OptionsPopupLink(_ref) {
  var children = _ref.children,
    id = _ref.id,
    onClick = _ref.onClick,
    brand = _ref.brand,
    href = _ref.href;
  return /*#__PURE__*/React__default.createElement(Link, {
    onClick: onClick,
    href: href,
    key: id,
    "data-id": id,
    "data-brand": brand
  }, children);
};
OptionsPopupLink.PropTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  id: PropTypes.string,
  brand: PropTypes.string
};

var OptionsPopupLinkText = function OptionsPopupLinkText(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(LinkText, null, children);
};
OptionsPopupLinkText.PropTypes = {
  children: PropTypes.node.isRequired
};

var index = {
  Box: OptionsPopup,
  List: OptionsPopupList,
  ListItem: OptionsPopupListItem,
  Link: OptionsPopupLink,
  LinkText: OptionsPopupLinkText
};

var _templateObject$2, _templateObject2$2;
var Container$1 = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  color: #ff2230;\n  border-radius: 8px;\n  display: flex;\n"])));
var Message = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  margin-left: 10px;\n"])));

var ErrorNotice = function ErrorNotice(_ref) {
  var error_message = _ref.error_message;
  return /*#__PURE__*/React__default.createElement(Container$1, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faExclamationCircle,
    style: {
      fontSize: "16px"
    }
  })), /*#__PURE__*/React__default.createElement(Message, null, error_message));
};

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject0$1, _templateObject1$1, _templateObject10$1, _templateObject11$1, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;
var Container = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  padding: 1rem 0.4rem;\n  color: ", ";\n  border-radius: 1rem;\n  box-sizing: border-box;\n\n  ", "\n"])), function (props) {
  return props.theme.colors.contactInfo.title;
}, breakpoint("tablet")(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    padding: 1em 0 0 1em;\n\n    ", "\n  "])), function (_ref) {
  var paddingLess = _ref.paddingLess;
  return paddingLess && css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n        padding: 0;\n      "])));
}));
var Split = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  width: 100%;\n\n  ", "\n\n  ", "\n"])), function (_ref2) {
  var withBottomMargin = _ref2.withBottomMargin;
  return withBottomMargin && css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n      margin-bottom: 2rem;\n\n      ", "\n    "])), breakpoint("tablet")(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n        margin-bottom: 3.1rem;\n      "]))));
}, function (_ref3) {
  var withBottomMargin = _ref3.withBottomMargin;
  return !withBottomMargin && css(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpoint("tablet")(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n        margin-bottom: 1rem;\n      "]))));
});
var A = styled.a(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n"])), function (props) {
  return props.theme.colors.primary;
});
var Title$1 = styled.span(_templateObject0$1 || (_templateObject0$1 = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 10px;\n"])));
var Text = styled.div(_templateObject1$1 || (_templateObject1$1 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 0.6rem;\n  margin: 0.5em 0 0.8em;\n  max-width: 1200px;\n\n  > svg {\n    width: 1.2rem;\n    color: #aaa;\n  }\n\n  ", "\n\n  ", "\n"])), function (_ref4) {
  var spacer = _ref4.spacer;
  return !!spacer && css(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n      margin-bottom: 1.2em;\n    "])));
}, function (_ref5) {
  var bio = _ref5.bio;
  return !!bio && css(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n      margin: 0;\n    "])));
});
var Info = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", "\n"])), breakpoint("tablet")(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    max-width: unset;\n  "]))));
var BioWrapper = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 1rem;\n  margin-top: 1.2rem;\n  width: 100%;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    flex-direction: row;\n    margin-top: 0;\n  "]))));
var Photo = styled.img(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  width: 76px;\n  height: 76px;\n  border-radius: 20rem;\n\n  ", "\n"])), breakpoint("tablet")(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    width: 132px;\n    height: 132px;\n    margin-right: 8px;\n  "]))));

var CentreInfo = function CentreInfo(_ref) {
  var email = _ref.email,
    phone = _ref.phone,
    bio = _ref.bio,
    photoUrl = _ref.photoUrl,
    paddingLess = _ref.paddingLess;
  var hasContactDetails = email || phone;
  return hasContactDetails ? /*#__PURE__*/React__default.createElement(Container, {
    paddingLess: paddingLess
  }, /*#__PURE__*/React__default.createElement(Split, null, /*#__PURE__*/React__default.createElement(Info, null, /*#__PURE__*/React__default.createElement(Title$1, null, "Have a question? We're here to help"), /*#__PURE__*/React__default.createElement(Text, {
    spacer: true
  }, "If you need any assistance, please don't hesitate to contact us using your preferred method below."), /*#__PURE__*/React__default.createElement(Text, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faPhoneAlt,
    size: "1x"
  }), /*#__PURE__*/React__default.createElement(A, {
    href: "tel:".concat(phone)
  }, phone)), /*#__PURE__*/React__default.createElement(Text, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faEnvelope,
    size: "1x"
  }), /*#__PURE__*/React__default.createElement(A, {
    href: "mailto:".concat(email)
  }, email)))), (photoUrl || bio) && /*#__PURE__*/React__default.createElement(Split, null, /*#__PURE__*/React__default.createElement(BioWrapper, null, photoUrl && /*#__PURE__*/React__default.createElement(Photo, {
    src: photoUrl,
    alt: "Get in touch"
  }), bio && /*#__PURE__*/React__default.createElement(Text, {
    bio: true
  }, /*#__PURE__*/React__default.createElement(Markdown, {
    componentStyles: {
      p: {
        variant: "content"
      }
    }
  }, bio))))) : null;
};
CentreInfo.propTypes = {
  email: PropTypes.string,
  phone: PropTypes.string,
  gridArea: PropTypes.string
};
CentreInfo.defaultProps = {
  gridArea: undefined
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11;
var TickIcon = styled(FontAwesomeIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  height: 1rem;\n  width: 1rem;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.success;
});
var TimelineContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  max-width: 360px;\n"])));
var TimelineItem = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 16px;\n  position: relative;\n  padding-bottom: 32px;\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n"])));
var Title = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: ", ";\n  font-weight: ", ";\n  line-height: 24px;\n"])), function (_ref2) {
  var isActive = _ref2.isActive,
    theme = _ref2.theme;
  return isActive ? theme.colors.primary : "#333";
}, function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? "700" : "500";
});
var DateText = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: #666;\n  line-height: 24px;\n"])));
var CountdownWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n  margin-top: 1rem;\n"])));
var Countdown = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 8px;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n  background-color: #f7f7f7;\n  border-radius: 8px;\n"])));
var Circle = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 4px;\n  height: 4px;\n  padding: 10px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  background-color: ", ";\n  border-radius: 30px;\n  border: 1px solid\n    ", ";\n"])), function (_ref4) {
  var isActive = _ref4.isActive,
    theme = _ref4.theme;
  return isActive ? theme.colors.primary : "#fff";
}, function (_ref5) {
  var isActive = _ref5.isActive,
    isCompleted = _ref5.isCompleted,
    theme = _ref5.theme;
  return isActive ? "transparent" : isCompleted ? theme.colors.success : "#cccccc";
});
var ItemNumber = styled.p(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: ", ";\n  font-weight: 300;\n"])), function (_ref6) {
  var isActive = _ref6.isActive;
  return isActive ? "#fff" : "#333";
});
var Line = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 11px;\n  top: 20px;\n  width: 1px;\n  height: 100%;\n  background-color: #cccccc;\n  z-index: -1;\n"])));
var ItemDayText = styled.p(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  color: #333;\n  text-align: center;\n  font-size: 16px;\n  line-height: 150%;\n  margin: 0;\n  margin-bottom: 4px;\n  font-weight: bold;\n"])));
var ItemUnitText = styled.p(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  color: #666;\n  text-align: center;\n  font-size: 16px;\n  margin: 0;\n"])));
var Div = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));

var Timeline = function Timeline(_ref) {
  var items = _ref.items,
    time_zone = _ref.time_zone;
  var _useState = useState(new Date()),
    _useState2 = _slicedToArray(_useState, 2),
    currentTime = _useState2[0],
    setCurrentTime = _useState2[1];
  useEffect(function () {
    var interval = setInterval(function () {
      setCurrentTime(new Date());
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, []);
  var calculateTimeDifference = function calculateTimeDifference(date) {
    var localDate = new Date(date);
    var diff = localDate - currentTime;
    if (diff <= 1000) {
      // Refresh a second after the countdown ends to give enough time for data to be fetched
      setTimeout(function () {
        window.location.reload();
      }, 1000);
    }
    if (diff <= 0) {
      return null;
    }
    var duration = moment$1.duration(diff);
    var days = Math.floor(duration.asDays());
    var hours = duration.hours();
    var minutes = duration.minutes();
    var seconds = duration.seconds();
    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  };
  var lastActiveIndex = items.findLastIndex(function (item) {
    return moment$1.tz(currentTime, time_zone).isSameOrAfter(moment$1.tz(item.starts_at, time_zone));
  });
  var hasActiveItems = lastActiveIndex !== -1;
  return hasActiveItems && lastActiveIndex < items.length - 1 ? /*#__PURE__*/React__default.createElement(TimelineContainer, null, items.map(function (item, index) {
    var itemDate = moment$1.tz(item.starts_at, time_zone).toDate();
    var isActive = lastActiveIndex === index && moment$1.tz(itemDate, time_zone).isBefore(moment$1.tz(currentTime, time_zone));
    var countdown = lastActiveIndex + 1 === index ? calculateTimeDifference(item.starts_at) : null;
    var isCompleted = index < lastActiveIndex;
    return /*#__PURE__*/React__default.createElement(TimelineItem, {
      key: index,
      isActive: isActive
    }, /*#__PURE__*/React__default.createElement(Circle, {
      isActive: isActive,
      isCompleted: isCompleted
    }, isCompleted ? /*#__PURE__*/React__default.createElement(TickIcon, {
      icon: faCheck$1
    }) : /*#__PURE__*/React__default.createElement(ItemNumber, {
      isActive: isActive
    }, index + 1)), index < items.length - 1 && /*#__PURE__*/React__default.createElement(Line, null), /*#__PURE__*/React__default.createElement(Div, null, /*#__PURE__*/React__default.createElement(Title, {
      isActive: isActive
    }, item.name), /*#__PURE__*/React__default.createElement(DateText, null, /*#__PURE__*/React__default.createElement(Moment, {
      value: item.starts_at,
      format: "D MMMM YYYY [at] HH:mm",
      tz: time_zone
    })), countdown && /*#__PURE__*/React__default.createElement(CountdownWrapper, null, /*#__PURE__*/React__default.createElement(Countdown, null, /*#__PURE__*/React__default.createElement(ItemDayText, null, String(countdown.days).padStart(2, "0")), /*#__PURE__*/React__default.createElement(ItemUnitText, null, "Days")), /*#__PURE__*/React__default.createElement(Countdown, null, /*#__PURE__*/React__default.createElement(ItemDayText, null, String(countdown.hours).padStart(2, "0")), /*#__PURE__*/React__default.createElement(ItemUnitText, null, "Hrs")), /*#__PURE__*/React__default.createElement(Countdown, null, /*#__PURE__*/React__default.createElement(ItemDayText, null, String(countdown.minutes).padStart(2, "0")), /*#__PURE__*/React__default.createElement(ItemUnitText, null, "Mins")), /*#__PURE__*/React__default.createElement(Countdown, null, /*#__PURE__*/React__default.createElement(ItemDayText, null, String(countdown.seconds).padStart(2, "0")), /*#__PURE__*/React__default.createElement(ItemUnitText, null, "Secs")))));
  })) : null;
};

export { AccordionContent, AddButton, Alert, ApplicationForm, Arrow, AvailabilityGrid, Avatar$1 as Avatar, Badge$2 as Badge, BannerContent, Breadcrumb, Button$5 as Button, ButtonGroup, ButtonSelect, Card$1 as Card, CentreInfo, Checkboxes, CloseButton$1 as CloseButton, CloseIcon$1 as CloseIcon, Content$7 as Content, Conversations, CurrencyField, DateField, DefaultDateField, DefaultDateTimeField, Document, DocumentList, EmployerFinancialOverview, Employer as EmployerTile, EnvironmentRibbon, ErrorNotice, FeatureContent, FieldGroup, Fieldset$2 as Fieldset, FileField, Filters, FlightNumberField, Form$1 as Form, GalleryImage, Grid$1 as Grid, H1$1 as H1, H2$1 as H2, H3, Header$4 as Header, HelpText, Highlight, Label$1 as Label, LargeTextArea, Level, LoadingSpinner, Logo, LogoutButton, Markdown, MediaCard, MessagesArea, Modal, Moment, MultiSelectField, MultiTextField, Nav, NavIcons, NewMessageForm, Notification, NpsScale, NumberField, OpenMenuButton, OpenMessagesButton, OpenNotificationsButton, index as OptionsPopup, P$4 as P, PageContent, ParticipantTile, ParticipantTiles, PasswordField, PhoneSelect, PlacementOffer, PlainDateField, PostcardThemeProvider, Profile, sections as ProfileSections, RadioButtons, RatingStat, RatingStatGroup, SearchBox$2 as SearchBox, SearchSelect, SelectField, Separator$1 as Separator, SignatureField, SimpleAlert, Spacer, StaffStats, index$1 as StatusIcons, SubmitButton, SwitchField, TabbedForm, Table, TextArea$2 as TextArea, TextField, Tiles, TimeField, Timeline, themes };
//# sourceMappingURL=index.esm.js.map
